function Q_(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const o in r)
        if (o !== "default" && !(o in e)) {
          const i = Object.getOwnPropertyDescriptor(r, o);
          i && Object.defineProperty(e, o, i.get ? i : {
            enumerable: !0,
            get: () => r[o]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function ju(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ij = { exports: {} }, Cc = {}, aj = { exports: {} }, st = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hx;
function ek() {
  if (Hx)
    return st;
  Hx = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), p = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), m = Symbol.iterator;
  function v(L) {
    return L === null || typeof L != "object" ? null : (L = m && L[m] || L["@@iterator"], typeof L == "function" ? L : null);
  }
  var b = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, x = Object.assign, w = {};
  function j(L, W, ie) {
    this.props = L, this.context = W, this.refs = w, this.updater = ie || b;
  }
  j.prototype.isReactComponent = {}, j.prototype.setState = function(L, W) {
    if (typeof L != "object" && typeof L != "function" && L != null)
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, L, W, "setState");
  }, j.prototype.forceUpdate = function(L) {
    this.updater.enqueueForceUpdate(this, L, "forceUpdate");
  };
  function C() {
  }
  C.prototype = j.prototype;
  function E(L, W, ie) {
    this.props = L, this.context = W, this.refs = w, this.updater = ie || b;
  }
  var P = E.prototype = new C();
  P.constructor = E, x(P, j.prototype), P.isPureReactComponent = !0;
  var k = Array.isArray, T = Object.prototype.hasOwnProperty, O = { current: null }, A = { key: !0, ref: !0, __self: !0, __source: !0 };
  function $(L, W, ie) {
    var re, le = {}, me = null, oe = null;
    if (W != null)
      for (re in W.ref !== void 0 && (oe = W.ref), W.key !== void 0 && (me = "" + W.key), W)
        T.call(W, re) && !A.hasOwnProperty(re) && (le[re] = W[re]);
    var se = arguments.length - 2;
    if (se === 1)
      le.children = ie;
    else if (1 < se) {
      for (var de = Array(se), we = 0; we < se; we++)
        de[we] = arguments[we + 2];
      le.children = de;
    }
    if (L && L.defaultProps)
      for (re in se = L.defaultProps, se)
        le[re] === void 0 && (le[re] = se[re]);
    return { $$typeof: e, type: L, key: me, ref: oe, props: le, _owner: O.current };
  }
  function N(L, W) {
    return { $$typeof: e, type: L.type, key: W, ref: L.ref, props: L.props, _owner: L._owner };
  }
  function R(L) {
    return typeof L == "object" && L !== null && L.$$typeof === e;
  }
  function z(L) {
    var W = { "=": "=0", ":": "=2" };
    return "$" + L.replace(/[=:]/g, function(ie) {
      return W[ie];
    });
  }
  var D = /\/+/g;
  function Z(L, W) {
    return typeof L == "object" && L !== null && L.key != null ? z("" + L.key) : W.toString(36);
  }
  function K(L, W, ie, re, le) {
    var me = typeof L;
    (me === "undefined" || me === "boolean") && (L = null);
    var oe = !1;
    if (L === null)
      oe = !0;
    else
      switch (me) {
        case "string":
        case "number":
          oe = !0;
          break;
        case "object":
          switch (L.$$typeof) {
            case e:
            case t:
              oe = !0;
          }
      }
    if (oe)
      return oe = L, le = le(oe), L = re === "" ? "." + Z(oe, 0) : re, k(le) ? (ie = "", L != null && (ie = L.replace(D, "$&/") + "/"), K(le, W, ie, "", function(we) {
        return we;
      })) : le != null && (R(le) && (le = N(le, ie + (!le.key || oe && oe.key === le.key ? "" : ("" + le.key).replace(D, "$&/") + "/") + L)), W.push(le)), 1;
    if (oe = 0, re = re === "" ? "." : re + ":", k(L))
      for (var se = 0; se < L.length; se++) {
        me = L[se];
        var de = re + Z(me, se);
        oe += K(me, W, ie, de, le);
      }
    else if (de = v(L), typeof de == "function")
      for (L = de.call(L), se = 0; !(me = L.next()).done; )
        me = me.value, de = re + Z(me, se++), oe += K(me, W, ie, de, le);
    else if (me === "object")
      throw W = String(L), Error("Objects are not valid as a React child (found: " + (W === "[object Object]" ? "object with keys {" + Object.keys(L).join(", ") + "}" : W) + "). If you meant to render a collection of children, use an array instead.");
    return oe;
  }
  function H(L, W, ie) {
    if (L == null)
      return L;
    var re = [], le = 0;
    return K(L, re, "", "", function(me) {
      return W.call(ie, me, le++);
    }), re;
  }
  function q(L) {
    if (L._status === -1) {
      var W = L._result;
      W = W(), W.then(function(ie) {
        (L._status === 0 || L._status === -1) && (L._status = 1, L._result = ie);
      }, function(ie) {
        (L._status === 0 || L._status === -1) && (L._status = 2, L._result = ie);
      }), L._status === -1 && (L._status = 0, L._result = W);
    }
    if (L._status === 1)
      return L._result.default;
    throw L._result;
  }
  var te = { current: null }, I = { transition: null }, F = { ReactCurrentDispatcher: te, ReactCurrentBatchConfig: I, ReactCurrentOwner: O };
  function V() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return st.Children = { map: H, forEach: function(L, W, ie) {
    H(L, function() {
      W.apply(this, arguments);
    }, ie);
  }, count: function(L) {
    var W = 0;
    return H(L, function() {
      W++;
    }), W;
  }, toArray: function(L) {
    return H(L, function(W) {
      return W;
    }) || [];
  }, only: function(L) {
    if (!R(L))
      throw Error("React.Children.only expected to receive a single React element child.");
    return L;
  } }, st.Component = j, st.Fragment = n, st.Profiler = o, st.PureComponent = E, st.StrictMode = r, st.Suspense = d, st.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = F, st.act = V, st.cloneElement = function(L, W, ie) {
    if (L == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + L + ".");
    var re = x({}, L.props), le = L.key, me = L.ref, oe = L._owner;
    if (W != null) {
      if (W.ref !== void 0 && (me = W.ref, oe = O.current), W.key !== void 0 && (le = "" + W.key), L.type && L.type.defaultProps)
        var se = L.type.defaultProps;
      for (de in W)
        T.call(W, de) && !A.hasOwnProperty(de) && (re[de] = W[de] === void 0 && se !== void 0 ? se[de] : W[de]);
    }
    var de = arguments.length - 2;
    if (de === 1)
      re.children = ie;
    else if (1 < de) {
      se = Array(de);
      for (var we = 0; we < de; we++)
        se[we] = arguments[we + 2];
      re.children = se;
    }
    return { $$typeof: e, type: L.type, key: le, ref: me, props: re, _owner: oe };
  }, st.createContext = function(L) {
    return L = { $$typeof: l, _currentValue: L, _currentValue2: L, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, L.Provider = { $$typeof: i, _context: L }, L.Consumer = L;
  }, st.createElement = $, st.createFactory = function(L) {
    var W = $.bind(null, L);
    return W.type = L, W;
  }, st.createRef = function() {
    return { current: null };
  }, st.forwardRef = function(L) {
    return { $$typeof: c, render: L };
  }, st.isValidElement = R, st.lazy = function(L) {
    return { $$typeof: g, _payload: { _status: -1, _result: L }, _init: q };
  }, st.memo = function(L, W) {
    return { $$typeof: p, type: L, compare: W === void 0 ? null : W };
  }, st.startTransition = function(L) {
    var W = I.transition;
    I.transition = {};
    try {
      L();
    } finally {
      I.transition = W;
    }
  }, st.unstable_act = V, st.useCallback = function(L, W) {
    return te.current.useCallback(L, W);
  }, st.useContext = function(L) {
    return te.current.useContext(L);
  }, st.useDebugValue = function() {
  }, st.useDeferredValue = function(L) {
    return te.current.useDeferredValue(L);
  }, st.useEffect = function(L, W) {
    return te.current.useEffect(L, W);
  }, st.useId = function() {
    return te.current.useId();
  }, st.useImperativeHandle = function(L, W, ie) {
    return te.current.useImperativeHandle(L, W, ie);
  }, st.useInsertionEffect = function(L, W) {
    return te.current.useInsertionEffect(L, W);
  }, st.useLayoutEffect = function(L, W) {
    return te.current.useLayoutEffect(L, W);
  }, st.useMemo = function(L, W) {
    return te.current.useMemo(L, W);
  }, st.useReducer = function(L, W, ie) {
    return te.current.useReducer(L, W, ie);
  }, st.useRef = function(L) {
    return te.current.useRef(L);
  }, st.useState = function(L) {
    return te.current.useState(L);
  }, st.useSyncExternalStore = function(L, W, ie) {
    return te.current.useSyncExternalStore(L, W, ie);
  }, st.useTransition = function() {
    return te.current.useTransition();
  }, st.version = "18.3.1", st;
}
aj.exports = ek();
var y = aj.exports;
const Q = /* @__PURE__ */ ju(y), ru = /* @__PURE__ */ Q_({
  __proto__: null,
  default: Q
}, [y]);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fx;
function tk() {
  if (Fx)
    return Cc;
  Fx = 1;
  var e = y, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(c, d, p) {
    var g, m = {}, v = null, b = null;
    p !== void 0 && (v = "" + p), d.key !== void 0 && (v = "" + d.key), d.ref !== void 0 && (b = d.ref);
    for (g in d)
      r.call(d, g) && !i.hasOwnProperty(g) && (m[g] = d[g]);
    if (c && c.defaultProps)
      for (g in d = c.defaultProps, d)
        m[g] === void 0 && (m[g] = d[g]);
    return { $$typeof: t, type: c, key: v, ref: b, props: m, _owner: o.current };
  }
  return Cc.Fragment = n, Cc.jsx = l, Cc.jsxs = l, Cc;
}
ij.exports = tk();
var u = ij.exports, lj = { exports: {} }, sr = {}, nm = { exports: {} }, rm = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zx;
function nk() {
  return zx || (zx = 1, function(e) {
    function t(I, F) {
      var V = I.length;
      I.push(F);
      e:
        for (; 0 < V; ) {
          var L = V - 1 >>> 1, W = I[L];
          if (0 < o(W, F))
            I[L] = F, I[V] = W, V = L;
          else
            break e;
        }
    }
    function n(I) {
      return I.length === 0 ? null : I[0];
    }
    function r(I) {
      if (I.length === 0)
        return null;
      var F = I[0], V = I.pop();
      if (V !== F) {
        I[0] = V;
        e:
          for (var L = 0, W = I.length, ie = W >>> 1; L < ie; ) {
            var re = 2 * (L + 1) - 1, le = I[re], me = re + 1, oe = I[me];
            if (0 > o(le, V))
              me < W && 0 > o(oe, le) ? (I[L] = oe, I[me] = V, L = me) : (I[L] = le, I[re] = V, L = re);
            else if (me < W && 0 > o(oe, V))
              I[L] = oe, I[me] = V, L = me;
            else
              break e;
          }
      }
      return F;
    }
    function o(I, F) {
      var V = I.sortIndex - F.sortIndex;
      return V !== 0 ? V : I.id - F.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var i = performance;
      e.unstable_now = function() {
        return i.now();
      };
    } else {
      var l = Date, c = l.now();
      e.unstable_now = function() {
        return l.now() - c;
      };
    }
    var d = [], p = [], g = 1, m = null, v = 3, b = !1, x = !1, w = !1, j = typeof setTimeout == "function" ? setTimeout : null, C = typeof clearTimeout == "function" ? clearTimeout : null, E = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function P(I) {
      for (var F = n(p); F !== null; ) {
        if (F.callback === null)
          r(p);
        else if (F.startTime <= I)
          r(p), F.sortIndex = F.expirationTime, t(d, F);
        else
          break;
        F = n(p);
      }
    }
    function k(I) {
      if (w = !1, P(I), !x)
        if (n(d) !== null)
          x = !0, q(T);
        else {
          var F = n(p);
          F !== null && te(k, F.startTime - I);
        }
    }
    function T(I, F) {
      x = !1, w && (w = !1, C($), $ = -1), b = !0;
      var V = v;
      try {
        for (P(F), m = n(d); m !== null && (!(m.expirationTime > F) || I && !z()); ) {
          var L = m.callback;
          if (typeof L == "function") {
            m.callback = null, v = m.priorityLevel;
            var W = L(m.expirationTime <= F);
            F = e.unstable_now(), typeof W == "function" ? m.callback = W : m === n(d) && r(d), P(F);
          } else
            r(d);
          m = n(d);
        }
        if (m !== null)
          var ie = !0;
        else {
          var re = n(p);
          re !== null && te(k, re.startTime - F), ie = !1;
        }
        return ie;
      } finally {
        m = null, v = V, b = !1;
      }
    }
    var O = !1, A = null, $ = -1, N = 5, R = -1;
    function z() {
      return !(e.unstable_now() - R < N);
    }
    function D() {
      if (A !== null) {
        var I = e.unstable_now();
        R = I;
        var F = !0;
        try {
          F = A(!0, I);
        } finally {
          F ? Z() : (O = !1, A = null);
        }
      } else
        O = !1;
    }
    var Z;
    if (typeof E == "function")
      Z = function() {
        E(D);
      };
    else if (typeof MessageChannel < "u") {
      var K = new MessageChannel(), H = K.port2;
      K.port1.onmessage = D, Z = function() {
        H.postMessage(null);
      };
    } else
      Z = function() {
        j(D, 0);
      };
    function q(I) {
      A = I, O || (O = !0, Z());
    }
    function te(I, F) {
      $ = j(function() {
        I(e.unstable_now());
      }, F);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(I) {
      I.callback = null;
    }, e.unstable_continueExecution = function() {
      x || b || (x = !0, q(T));
    }, e.unstable_forceFrameRate = function(I) {
      0 > I || 125 < I ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : N = 0 < I ? Math.floor(1e3 / I) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return v;
    }, e.unstable_getFirstCallbackNode = function() {
      return n(d);
    }, e.unstable_next = function(I) {
      switch (v) {
        case 1:
        case 2:
        case 3:
          var F = 3;
          break;
        default:
          F = v;
      }
      var V = v;
      v = F;
      try {
        return I();
      } finally {
        v = V;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(I, F) {
      switch (I) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          I = 3;
      }
      var V = v;
      v = I;
      try {
        return F();
      } finally {
        v = V;
      }
    }, e.unstable_scheduleCallback = function(I, F, V) {
      var L = e.unstable_now();
      switch (typeof V == "object" && V !== null ? (V = V.delay, V = typeof V == "number" && 0 < V ? L + V : L) : V = L, I) {
        case 1:
          var W = -1;
          break;
        case 2:
          W = 250;
          break;
        case 5:
          W = 1073741823;
          break;
        case 4:
          W = 1e4;
          break;
        default:
          W = 5e3;
      }
      return W = V + W, I = { id: g++, callback: F, priorityLevel: I, startTime: V, expirationTime: W, sortIndex: -1 }, V > L ? (I.sortIndex = V, t(p, I), n(d) === null && I === n(p) && (w ? (C($), $ = -1) : w = !0, te(k, V - L))) : (I.sortIndex = W, t(d, I), x || b || (x = !0, q(T))), I;
    }, e.unstable_shouldYield = z, e.unstable_wrapCallback = function(I) {
      var F = v;
      return function() {
        var V = v;
        v = F;
        try {
          return I.apply(this, arguments);
        } finally {
          v = V;
        }
      };
    };
  }(rm)), rm;
}
var Bx;
function rk() {
  return Bx || (Bx = 1, nm.exports = nk()), nm.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ux;
function ok() {
  if (Ux)
    return sr;
  Ux = 1;
  var e = y, t = rk();
  function n(s) {
    for (var a = "https://reactjs.org/docs/error-decoder.html?invariant=" + s, f = 1; f < arguments.length; f++)
      a += "&args[]=" + encodeURIComponent(arguments[f]);
    return "Minified React error #" + s + "; visit " + a + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = /* @__PURE__ */ new Set(), o = {};
  function i(s, a) {
    l(s, a), l(s + "Capture", a);
  }
  function l(s, a) {
    for (o[s] = a, s = 0; s < a.length; s++)
      r.add(a[s]);
  }
  var c = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), d = Object.prototype.hasOwnProperty, p = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, g = {}, m = {};
  function v(s) {
    return d.call(m, s) ? !0 : d.call(g, s) ? !1 : p.test(s) ? m[s] = !0 : (g[s] = !0, !1);
  }
  function b(s, a, f, h) {
    if (f !== null && f.type === 0)
      return !1;
    switch (typeof a) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return h ? !1 : f !== null ? !f.acceptsBooleans : (s = s.toLowerCase().slice(0, 5), s !== "data-" && s !== "aria-");
      default:
        return !1;
    }
  }
  function x(s, a, f, h) {
    if (a === null || typeof a > "u" || b(s, a, f, h))
      return !0;
    if (h)
      return !1;
    if (f !== null)
      switch (f.type) {
        case 3:
          return !a;
        case 4:
          return a === !1;
        case 5:
          return isNaN(a);
        case 6:
          return isNaN(a) || 1 > a;
      }
    return !1;
  }
  function w(s, a, f, h, S, _, M) {
    this.acceptsBooleans = a === 2 || a === 3 || a === 4, this.attributeName = h, this.attributeNamespace = S, this.mustUseProperty = f, this.propertyName = s, this.type = a, this.sanitizeURL = _, this.removeEmptyString = M;
  }
  var j = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(s) {
    j[s] = new w(s, 0, !1, s, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(s) {
    var a = s[0];
    j[a] = new w(a, 1, !1, s[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(s) {
    j[s] = new w(s, 2, !1, s.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(s) {
    j[s] = new w(s, 2, !1, s, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(s) {
    j[s] = new w(s, 3, !1, s.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(s) {
    j[s] = new w(s, 3, !0, s, null, !1, !1);
  }), ["capture", "download"].forEach(function(s) {
    j[s] = new w(s, 4, !1, s, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(s) {
    j[s] = new w(s, 6, !1, s, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(s) {
    j[s] = new w(s, 5, !1, s.toLowerCase(), null, !1, !1);
  });
  var C = /[\-:]([a-z])/g;
  function E(s) {
    return s[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(s) {
    var a = s.replace(
      C,
      E
    );
    j[a] = new w(a, 1, !1, s, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(s) {
    var a = s.replace(C, E);
    j[a] = new w(a, 1, !1, s, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(s) {
    var a = s.replace(C, E);
    j[a] = new w(a, 1, !1, s, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(s) {
    j[s] = new w(s, 1, !1, s.toLowerCase(), null, !1, !1);
  }), j.xlinkHref = new w("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(s) {
    j[s] = new w(s, 1, !1, s.toLowerCase(), null, !0, !0);
  });
  function P(s, a, f, h) {
    var S = j.hasOwnProperty(a) ? j[a] : null;
    (S !== null ? S.type !== 0 : h || !(2 < a.length) || a[0] !== "o" && a[0] !== "O" || a[1] !== "n" && a[1] !== "N") && (x(a, f, S, h) && (f = null), h || S === null ? v(a) && (f === null ? s.removeAttribute(a) : s.setAttribute(a, "" + f)) : S.mustUseProperty ? s[S.propertyName] = f === null ? S.type === 3 ? !1 : "" : f : (a = S.attributeName, h = S.attributeNamespace, f === null ? s.removeAttribute(a) : (S = S.type, f = S === 3 || S === 4 && f === !0 ? "" : "" + f, h ? s.setAttributeNS(h, a, f) : s.setAttribute(a, f))));
  }
  var k = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, T = Symbol.for("react.element"), O = Symbol.for("react.portal"), A = Symbol.for("react.fragment"), $ = Symbol.for("react.strict_mode"), N = Symbol.for("react.profiler"), R = Symbol.for("react.provider"), z = Symbol.for("react.context"), D = Symbol.for("react.forward_ref"), Z = Symbol.for("react.suspense"), K = Symbol.for("react.suspense_list"), H = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), te = Symbol.for("react.offscreen"), I = Symbol.iterator;
  function F(s) {
    return s === null || typeof s != "object" ? null : (s = I && s[I] || s["@@iterator"], typeof s == "function" ? s : null);
  }
  var V = Object.assign, L;
  function W(s) {
    if (L === void 0)
      try {
        throw Error();
      } catch (f) {
        var a = f.stack.trim().match(/\n( *(at )?)/);
        L = a && a[1] || "";
      }
    return `
` + L + s;
  }
  var ie = !1;
  function re(s, a) {
    if (!s || ie)
      return "";
    ie = !0;
    var f = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (a)
        if (a = function() {
          throw Error();
        }, Object.defineProperty(a.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(a, []);
          } catch (ue) {
            var h = ue;
          }
          Reflect.construct(s, [], a);
        } else {
          try {
            a.call();
          } catch (ue) {
            h = ue;
          }
          s.call(a.prototype);
        }
      else {
        try {
          throw Error();
        } catch (ue) {
          h = ue;
        }
        s();
      }
    } catch (ue) {
      if (ue && h && typeof ue.stack == "string") {
        for (var S = ue.stack.split(`
`), _ = h.stack.split(`
`), M = S.length - 1, U = _.length - 1; 1 <= M && 0 <= U && S[M] !== _[U]; )
          U--;
        for (; 1 <= M && 0 <= U; M--, U--)
          if (S[M] !== _[U]) {
            if (M !== 1 || U !== 1)
              do
                if (M--, U--, 0 > U || S[M] !== _[U]) {
                  var X = `
` + S[M].replace(" at new ", " at ");
                  return s.displayName && X.includes("<anonymous>") && (X = X.replace("<anonymous>", s.displayName)), X;
                }
              while (1 <= M && 0 <= U);
            break;
          }
      }
    } finally {
      ie = !1, Error.prepareStackTrace = f;
    }
    return (s = s ? s.displayName || s.name : "") ? W(s) : "";
  }
  function le(s) {
    switch (s.tag) {
      case 5:
        return W(s.type);
      case 16:
        return W("Lazy");
      case 13:
        return W("Suspense");
      case 19:
        return W("SuspenseList");
      case 0:
      case 2:
      case 15:
        return s = re(s.type, !1), s;
      case 11:
        return s = re(s.type.render, !1), s;
      case 1:
        return s = re(s.type, !0), s;
      default:
        return "";
    }
  }
  function me(s) {
    if (s == null)
      return null;
    if (typeof s == "function")
      return s.displayName || s.name || null;
    if (typeof s == "string")
      return s;
    switch (s) {
      case A:
        return "Fragment";
      case O:
        return "Portal";
      case N:
        return "Profiler";
      case $:
        return "StrictMode";
      case Z:
        return "Suspense";
      case K:
        return "SuspenseList";
    }
    if (typeof s == "object")
      switch (s.$$typeof) {
        case z:
          return (s.displayName || "Context") + ".Consumer";
        case R:
          return (s._context.displayName || "Context") + ".Provider";
        case D:
          var a = s.render;
          return s = s.displayName, s || (s = a.displayName || a.name || "", s = s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef"), s;
        case H:
          return a = s.displayName || null, a !== null ? a : me(s.type) || "Memo";
        case q:
          a = s._payload, s = s._init;
          try {
            return me(s(a));
          } catch {
          }
      }
    return null;
  }
  function oe(s) {
    var a = s.type;
    switch (s.tag) {
      case 24:
        return "Cache";
      case 9:
        return (a.displayName || "Context") + ".Consumer";
      case 10:
        return (a._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return s = a.render, s = s.displayName || s.name || "", a.displayName || (s !== "" ? "ForwardRef(" + s + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return a;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return me(a);
      case 8:
        return a === $ ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof a == "function")
          return a.displayName || a.name || null;
        if (typeof a == "string")
          return a;
    }
    return null;
  }
  function se(s) {
    switch (typeof s) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return s;
      case "object":
        return s;
      default:
        return "";
    }
  }
  function de(s) {
    var a = s.type;
    return (s = s.nodeName) && s.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
  }
  function we(s) {
    var a = de(s) ? "checked" : "value", f = Object.getOwnPropertyDescriptor(s.constructor.prototype, a), h = "" + s[a];
    if (!s.hasOwnProperty(a) && typeof f < "u" && typeof f.get == "function" && typeof f.set == "function") {
      var S = f.get, _ = f.set;
      return Object.defineProperty(s, a, { configurable: !0, get: function() {
        return S.call(this);
      }, set: function(M) {
        h = "" + M, _.call(this, M);
      } }), Object.defineProperty(s, a, { enumerable: f.enumerable }), { getValue: function() {
        return h;
      }, setValue: function(M) {
        h = "" + M;
      }, stopTracking: function() {
        s._valueTracker = null, delete s[a];
      } };
    }
  }
  function je(s) {
    s._valueTracker || (s._valueTracker = we(s));
  }
  function He(s) {
    if (!s)
      return !1;
    var a = s._valueTracker;
    if (!a)
      return !0;
    var f = a.getValue(), h = "";
    return s && (h = de(s) ? s.checked ? "true" : "false" : s.value), s = h, s !== f ? (a.setValue(s), !0) : !1;
  }
  function Le(s) {
    if (s = s || (typeof document < "u" ? document : void 0), typeof s > "u")
      return null;
    try {
      return s.activeElement || s.body;
    } catch {
      return s.body;
    }
  }
  function ot(s, a) {
    var f = a.checked;
    return V({}, a, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: f ?? s._wrapperState.initialChecked });
  }
  function vt(s, a) {
    var f = a.defaultValue == null ? "" : a.defaultValue, h = a.checked != null ? a.checked : a.defaultChecked;
    f = se(a.value != null ? a.value : f), s._wrapperState = { initialChecked: h, initialValue: f, controlled: a.type === "checkbox" || a.type === "radio" ? a.checked != null : a.value != null };
  }
  function zt(s, a) {
    a = a.checked, a != null && P(s, "checked", a, !1);
  }
  function Ot(s, a) {
    zt(s, a);
    var f = se(a.value), h = a.type;
    if (f != null)
      h === "number" ? (f === 0 && s.value === "" || s.value != f) && (s.value = "" + f) : s.value !== "" + f && (s.value = "" + f);
    else if (h === "submit" || h === "reset") {
      s.removeAttribute("value");
      return;
    }
    a.hasOwnProperty("value") ? vn(s, a.type, f) : a.hasOwnProperty("defaultValue") && vn(s, a.type, se(a.defaultValue)), a.checked == null && a.defaultChecked != null && (s.defaultChecked = !!a.defaultChecked);
  }
  function ct(s, a, f) {
    if (a.hasOwnProperty("value") || a.hasOwnProperty("defaultValue")) {
      var h = a.type;
      if (!(h !== "submit" && h !== "reset" || a.value !== void 0 && a.value !== null))
        return;
      a = "" + s._wrapperState.initialValue, f || a === s.value || (s.value = a), s.defaultValue = a;
    }
    f = s.name, f !== "" && (s.name = ""), s.defaultChecked = !!s._wrapperState.initialChecked, f !== "" && (s.name = f);
  }
  function vn(s, a, f) {
    (a !== "number" || Le(s.ownerDocument) !== s) && (f == null ? s.defaultValue = "" + s._wrapperState.initialValue : s.defaultValue !== "" + f && (s.defaultValue = "" + f));
  }
  var St = Array.isArray;
  function At(s, a, f, h) {
    if (s = s.options, a) {
      a = {};
      for (var S = 0; S < f.length; S++)
        a["$" + f[S]] = !0;
      for (f = 0; f < s.length; f++)
        S = a.hasOwnProperty("$" + s[f].value), s[f].selected !== S && (s[f].selected = S), S && h && (s[f].defaultSelected = !0);
    } else {
      for (f = "" + se(f), a = null, S = 0; S < s.length; S++) {
        if (s[S].value === f) {
          s[S].selected = !0, h && (s[S].defaultSelected = !0);
          return;
        }
        a !== null || s[S].disabled || (a = s[S]);
      }
      a !== null && (a.selected = !0);
    }
  }
  function en(s, a) {
    if (a.dangerouslySetInnerHTML != null)
      throw Error(n(91));
    return V({}, a, { value: void 0, defaultValue: void 0, children: "" + s._wrapperState.initialValue });
  }
  function Bt(s, a) {
    var f = a.value;
    if (f == null) {
      if (f = a.children, a = a.defaultValue, f != null) {
        if (a != null)
          throw Error(n(92));
        if (St(f)) {
          if (1 < f.length)
            throw Error(n(93));
          f = f[0];
        }
        a = f;
      }
      a == null && (a = ""), f = a;
    }
    s._wrapperState = { initialValue: se(f) };
  }
  function Et(s, a) {
    var f = se(a.value), h = se(a.defaultValue);
    f != null && (f = "" + f, f !== s.value && (s.value = f), a.defaultValue == null && s.defaultValue !== f && (s.defaultValue = f)), h != null && (s.defaultValue = "" + h);
  }
  function it(s) {
    var a = s.textContent;
    a === s._wrapperState.initialValue && a !== "" && a !== null && (s.value = a);
  }
  function Lt(s) {
    switch (s) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function Ut(s, a) {
    return s == null || s === "http://www.w3.org/1999/xhtml" ? Lt(a) : s === "http://www.w3.org/2000/svg" && a === "foreignObject" ? "http://www.w3.org/1999/xhtml" : s;
  }
  var yn, Bn = function(s) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(a, f, h, S) {
      MSApp.execUnsafeLocalFunction(function() {
        return s(a, f, h, S);
      });
    } : s;
  }(function(s, a) {
    if (s.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in s)
      s.innerHTML = a;
    else {
      for (yn = yn || document.createElement("div"), yn.innerHTML = "<svg>" + a.valueOf().toString() + "</svg>", a = yn.firstChild; s.firstChild; )
        s.removeChild(s.firstChild);
      for (; a.firstChild; )
        s.appendChild(a.firstChild);
    }
  });
  function Zn(s, a) {
    if (a) {
      var f = s.firstChild;
      if (f && f === s.lastChild && f.nodeType === 3) {
        f.nodeValue = a;
        return;
      }
    }
    s.textContent = a;
  }
  var Jn = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, oo = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Jn).forEach(function(s) {
    oo.forEach(function(a) {
      a = a + s.charAt(0).toUpperCase() + s.substring(1), Jn[a] = Jn[s];
    });
  });
  function as(s, a, f) {
    return a == null || typeof a == "boolean" || a === "" ? "" : f || typeof a != "number" || a === 0 || Jn.hasOwnProperty(s) && Jn[s] ? ("" + a).trim() : a + "px";
  }
  function Ni(s, a) {
    s = s.style;
    for (var f in a)
      if (a.hasOwnProperty(f)) {
        var h = f.indexOf("--") === 0, S = as(f, a[f], h);
        f === "float" && (f = "cssFloat"), h ? s.setProperty(f, S) : s[f] = S;
      }
  }
  var nn = V({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function It(s, a) {
    if (a) {
      if (nn[s] && (a.children != null || a.dangerouslySetInnerHTML != null))
        throw Error(n(137, s));
      if (a.dangerouslySetInnerHTML != null) {
        if (a.children != null)
          throw Error(n(60));
        if (typeof a.dangerouslySetInnerHTML != "object" || !("__html" in a.dangerouslySetInnerHTML))
          throw Error(n(61));
      }
      if (a.style != null && typeof a.style != "object")
        throw Error(n(62));
    }
  }
  function Mt(s, a) {
    if (s.indexOf("-") === -1)
      return typeof a.is == "string";
    switch (s) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var at = null;
  function bn(s) {
    return s = s.target || s.srcElement || window, s.correspondingUseElement && (s = s.correspondingUseElement), s.nodeType === 3 ? s.parentNode : s;
  }
  var $n = null, rn = null, Qn = null;
  function ls(s) {
    if (s = cc(s)) {
      if (typeof $n != "function")
        throw Error(n(280));
      var a = s.stateNode;
      a && (a = Sd(a), $n(s.stateNode, s.type, a));
    }
  }
  function ko(s) {
    rn ? Qn ? Qn.push(s) : Qn = [s] : rn = s;
  }
  function hr() {
    if (rn) {
      var s = rn, a = Qn;
      if (Qn = rn = null, ls(s), a)
        for (s = 0; s < a.length; s++)
          ls(a[s]);
    }
  }
  function Nr(s, a) {
    return s(a);
  }
  function cs() {
  }
  var pe = !1;
  function _e(s, a, f) {
    if (pe)
      return s(a, f);
    pe = !0;
    try {
      return Nr(s, a, f);
    } finally {
      pe = !1, (rn !== null || Qn !== null) && (cs(), hr());
    }
  }
  function Oe(s, a) {
    var f = s.stateNode;
    if (f === null)
      return null;
    var h = Sd(f);
    if (h === null)
      return null;
    f = h[a];
    e:
      switch (a) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (h = !h.disabled) || (s = s.type, h = !(s === "button" || s === "input" || s === "select" || s === "textarea")), s = !h;
          break e;
        default:
          s = !1;
      }
    if (s)
      return null;
    if (f && typeof f != "function")
      throw Error(n(231, a, typeof f));
    return f;
  }
  var Ye = !1;
  if (c)
    try {
      var fn = {};
      Object.defineProperty(fn, "passive", { get: function() {
        Ye = !0;
      } }), window.addEventListener("test", fn, fn), window.removeEventListener("test", fn, fn);
    } catch {
      Ye = !1;
    }
  function ln(s, a, f, h, S, _, M, U, X) {
    var ue = Array.prototype.slice.call(arguments, 3);
    try {
      a.apply(f, ue);
    } catch (Se) {
      this.onError(Se);
    }
  }
  var xn = !1, $r = null, wn = !1, $i = null, i3 = { onError: function(s) {
    xn = !0, $r = s;
  } };
  function a3(s, a, f, h, S, _, M, U, X) {
    xn = !1, $r = null, ln.apply(i3, arguments);
  }
  function l3(s, a, f, h, S, _, M, U, X) {
    if (a3.apply(this, arguments), xn) {
      if (xn) {
        var ue = $r;
        xn = !1, $r = null;
      } else
        throw Error(n(198));
      wn || (wn = !0, $i = ue);
    }
  }
  function Di(s) {
    var a = s, f = s;
    if (s.alternate)
      for (; a.return; )
        a = a.return;
    else {
      s = a;
      do
        a = s, a.flags & 4098 && (f = a.return), s = a.return;
      while (s);
    }
    return a.tag === 3 ? f : null;
  }
  function cy(s) {
    if (s.tag === 13) {
      var a = s.memoizedState;
      if (a === null && (s = s.alternate, s !== null && (a = s.memoizedState)), a !== null)
        return a.dehydrated;
    }
    return null;
  }
  function uy(s) {
    if (Di(s) !== s)
      throw Error(n(188));
  }
  function c3(s) {
    var a = s.alternate;
    if (!a) {
      if (a = Di(s), a === null)
        throw Error(n(188));
      return a !== s ? null : s;
    }
    for (var f = s, h = a; ; ) {
      var S = f.return;
      if (S === null)
        break;
      var _ = S.alternate;
      if (_ === null) {
        if (h = S.return, h !== null) {
          f = h;
          continue;
        }
        break;
      }
      if (S.child === _.child) {
        for (_ = S.child; _; ) {
          if (_ === f)
            return uy(S), s;
          if (_ === h)
            return uy(S), a;
          _ = _.sibling;
        }
        throw Error(n(188));
      }
      if (f.return !== h.return)
        f = S, h = _;
      else {
        for (var M = !1, U = S.child; U; ) {
          if (U === f) {
            M = !0, f = S, h = _;
            break;
          }
          if (U === h) {
            M = !0, h = S, f = _;
            break;
          }
          U = U.sibling;
        }
        if (!M) {
          for (U = _.child; U; ) {
            if (U === f) {
              M = !0, f = _, h = S;
              break;
            }
            if (U === h) {
              M = !0, h = _, f = S;
              break;
            }
            U = U.sibling;
          }
          if (!M)
            throw Error(n(189));
        }
      }
      if (f.alternate !== h)
        throw Error(n(190));
    }
    if (f.tag !== 3)
      throw Error(n(188));
    return f.stateNode.current === f ? s : a;
  }
  function dy(s) {
    return s = c3(s), s !== null ? fy(s) : null;
  }
  function fy(s) {
    if (s.tag === 5 || s.tag === 6)
      return s;
    for (s = s.child; s !== null; ) {
      var a = fy(s);
      if (a !== null)
        return a;
      s = s.sibling;
    }
    return null;
  }
  var py = t.unstable_scheduleCallback, gy = t.unstable_cancelCallback, u3 = t.unstable_shouldYield, d3 = t.unstable_requestPaint, on = t.unstable_now, f3 = t.unstable_getCurrentPriorityLevel, Sg = t.unstable_ImmediatePriority, hy = t.unstable_UserBlockingPriority, nd = t.unstable_NormalPriority, p3 = t.unstable_LowPriority, my = t.unstable_IdlePriority, rd = null, To = null;
  function g3(s) {
    if (To && typeof To.onCommitFiberRoot == "function")
      try {
        To.onCommitFiberRoot(rd, s, void 0, (s.current.flags & 128) === 128);
      } catch {
      }
  }
  var so = Math.clz32 ? Math.clz32 : v3, h3 = Math.log, m3 = Math.LN2;
  function v3(s) {
    return s >>>= 0, s === 0 ? 32 : 31 - (h3(s) / m3 | 0) | 0;
  }
  var od = 64, sd = 4194304;
  function Wl(s) {
    switch (s & -s) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return s & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return s & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return s;
    }
  }
  function id(s, a) {
    var f = s.pendingLanes;
    if (f === 0)
      return 0;
    var h = 0, S = s.suspendedLanes, _ = s.pingedLanes, M = f & 268435455;
    if (M !== 0) {
      var U = M & ~S;
      U !== 0 ? h = Wl(U) : (_ &= M, _ !== 0 && (h = Wl(_)));
    } else
      M = f & ~S, M !== 0 ? h = Wl(M) : _ !== 0 && (h = Wl(_));
    if (h === 0)
      return 0;
    if (a !== 0 && a !== h && !(a & S) && (S = h & -h, _ = a & -a, S >= _ || S === 16 && (_ & 4194240) !== 0))
      return a;
    if (h & 4 && (h |= f & 16), a = s.entangledLanes, a !== 0)
      for (s = s.entanglements, a &= h; 0 < a; )
        f = 31 - so(a), S = 1 << f, h |= s[f], a &= ~S;
    return h;
  }
  function y3(s, a) {
    switch (s) {
      case 1:
      case 2:
      case 4:
        return a + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function b3(s, a) {
    for (var f = s.suspendedLanes, h = s.pingedLanes, S = s.expirationTimes, _ = s.pendingLanes; 0 < _; ) {
      var M = 31 - so(_), U = 1 << M, X = S[M];
      X === -1 ? (!(U & f) || U & h) && (S[M] = y3(U, a)) : X <= a && (s.expiredLanes |= U), _ &= ~U;
    }
  }
  function jg(s) {
    return s = s.pendingLanes & -1073741825, s !== 0 ? s : s & 1073741824 ? 1073741824 : 0;
  }
  function vy() {
    var s = od;
    return od <<= 1, !(od & 4194240) && (od = 64), s;
  }
  function Cg(s) {
    for (var a = [], f = 0; 31 > f; f++)
      a.push(s);
    return a;
  }
  function Gl(s, a, f) {
    s.pendingLanes |= a, a !== 536870912 && (s.suspendedLanes = 0, s.pingedLanes = 0), s = s.eventTimes, a = 31 - so(a), s[a] = f;
  }
  function x3(s, a) {
    var f = s.pendingLanes & ~a;
    s.pendingLanes = a, s.suspendedLanes = 0, s.pingedLanes = 0, s.expiredLanes &= a, s.mutableReadLanes &= a, s.entangledLanes &= a, a = s.entanglements;
    var h = s.eventTimes;
    for (s = s.expirationTimes; 0 < f; ) {
      var S = 31 - so(f), _ = 1 << S;
      a[S] = 0, h[S] = -1, s[S] = -1, f &= ~_;
    }
  }
  function Eg(s, a) {
    var f = s.entangledLanes |= a;
    for (s = s.entanglements; f; ) {
      var h = 31 - so(f), S = 1 << h;
      S & a | s[h] & a && (s[h] |= a), f &= ~S;
    }
  }
  var Pt = 0;
  function yy(s) {
    return s &= -s, 1 < s ? 4 < s ? s & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var by, Pg, xy, wy, Sy, _g = !1, ad = [], Is = null, Vs = null, Hs = null, Kl = /* @__PURE__ */ new Map(), ql = /* @__PURE__ */ new Map(), Fs = [], w3 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function jy(s, a) {
    switch (s) {
      case "focusin":
      case "focusout":
        Is = null;
        break;
      case "dragenter":
      case "dragleave":
        Vs = null;
        break;
      case "mouseover":
      case "mouseout":
        Hs = null;
        break;
      case "pointerover":
      case "pointerout":
        Kl.delete(a.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        ql.delete(a.pointerId);
    }
  }
  function Yl(s, a, f, h, S, _) {
    return s === null || s.nativeEvent !== _ ? (s = { blockedOn: a, domEventName: f, eventSystemFlags: h, nativeEvent: _, targetContainers: [S] }, a !== null && (a = cc(a), a !== null && Pg(a)), s) : (s.eventSystemFlags |= h, a = s.targetContainers, S !== null && a.indexOf(S) === -1 && a.push(S), s);
  }
  function S3(s, a, f, h, S) {
    switch (a) {
      case "focusin":
        return Is = Yl(Is, s, a, f, h, S), !0;
      case "dragenter":
        return Vs = Yl(Vs, s, a, f, h, S), !0;
      case "mouseover":
        return Hs = Yl(Hs, s, a, f, h, S), !0;
      case "pointerover":
        var _ = S.pointerId;
        return Kl.set(_, Yl(Kl.get(_) || null, s, a, f, h, S)), !0;
      case "gotpointercapture":
        return _ = S.pointerId, ql.set(_, Yl(ql.get(_) || null, s, a, f, h, S)), !0;
    }
    return !1;
  }
  function Cy(s) {
    var a = Ii(s.target);
    if (a !== null) {
      var f = Di(a);
      if (f !== null) {
        if (a = f.tag, a === 13) {
          if (a = cy(f), a !== null) {
            s.blockedOn = a, Sy(s.priority, function() {
              xy(f);
            });
            return;
          }
        } else if (a === 3 && f.stateNode.current.memoizedState.isDehydrated) {
          s.blockedOn = f.tag === 3 ? f.stateNode.containerInfo : null;
          return;
        }
      }
    }
    s.blockedOn = null;
  }
  function ld(s) {
    if (s.blockedOn !== null)
      return !1;
    for (var a = s.targetContainers; 0 < a.length; ) {
      var f = Tg(s.domEventName, s.eventSystemFlags, a[0], s.nativeEvent);
      if (f === null) {
        f = s.nativeEvent;
        var h = new f.constructor(f.type, f);
        at = h, f.target.dispatchEvent(h), at = null;
      } else
        return a = cc(f), a !== null && Pg(a), s.blockedOn = f, !1;
      a.shift();
    }
    return !0;
  }
  function Ey(s, a, f) {
    ld(s) && f.delete(a);
  }
  function j3() {
    _g = !1, Is !== null && ld(Is) && (Is = null), Vs !== null && ld(Vs) && (Vs = null), Hs !== null && ld(Hs) && (Hs = null), Kl.forEach(Ey), ql.forEach(Ey);
  }
  function Xl(s, a) {
    s.blockedOn === a && (s.blockedOn = null, _g || (_g = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, j3)));
  }
  function Zl(s) {
    function a(S) {
      return Xl(S, s);
    }
    if (0 < ad.length) {
      Xl(ad[0], s);
      for (var f = 1; f < ad.length; f++) {
        var h = ad[f];
        h.blockedOn === s && (h.blockedOn = null);
      }
    }
    for (Is !== null && Xl(Is, s), Vs !== null && Xl(Vs, s), Hs !== null && Xl(Hs, s), Kl.forEach(a), ql.forEach(a), f = 0; f < Fs.length; f++)
      h = Fs[f], h.blockedOn === s && (h.blockedOn = null);
    for (; 0 < Fs.length && (f = Fs[0], f.blockedOn === null); )
      Cy(f), f.blockedOn === null && Fs.shift();
  }
  var Ea = k.ReactCurrentBatchConfig, cd = !0;
  function C3(s, a, f, h) {
    var S = Pt, _ = Ea.transition;
    Ea.transition = null;
    try {
      Pt = 1, kg(s, a, f, h);
    } finally {
      Pt = S, Ea.transition = _;
    }
  }
  function E3(s, a, f, h) {
    var S = Pt, _ = Ea.transition;
    Ea.transition = null;
    try {
      Pt = 4, kg(s, a, f, h);
    } finally {
      Pt = S, Ea.transition = _;
    }
  }
  function kg(s, a, f, h) {
    if (cd) {
      var S = Tg(s, a, f, h);
      if (S === null)
        Gg(s, a, h, ud, f), jy(s, h);
      else if (S3(S, s, a, f, h))
        h.stopPropagation();
      else if (jy(s, h), a & 4 && -1 < w3.indexOf(s)) {
        for (; S !== null; ) {
          var _ = cc(S);
          if (_ !== null && by(_), _ = Tg(s, a, f, h), _ === null && Gg(s, a, h, ud, f), _ === S)
            break;
          S = _;
        }
        S !== null && h.stopPropagation();
      } else
        Gg(s, a, h, null, f);
    }
  }
  var ud = null;
  function Tg(s, a, f, h) {
    if (ud = null, s = bn(h), s = Ii(s), s !== null)
      if (a = Di(s), a === null)
        s = null;
      else if (f = a.tag, f === 13) {
        if (s = cy(a), s !== null)
          return s;
        s = null;
      } else if (f === 3) {
        if (a.stateNode.current.memoizedState.isDehydrated)
          return a.tag === 3 ? a.stateNode.containerInfo : null;
        s = null;
      } else
        a !== s && (s = null);
    return ud = s, null;
  }
  function Py(s) {
    switch (s) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (f3()) {
          case Sg:
            return 1;
          case hy:
            return 4;
          case nd:
          case p3:
            return 16;
          case my:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var zs = null, Og = null, dd = null;
  function _y() {
    if (dd)
      return dd;
    var s, a = Og, f = a.length, h, S = "value" in zs ? zs.value : zs.textContent, _ = S.length;
    for (s = 0; s < f && a[s] === S[s]; s++)
      ;
    var M = f - s;
    for (h = 1; h <= M && a[f - h] === S[_ - h]; h++)
      ;
    return dd = S.slice(s, 1 < h ? 1 - h : void 0);
  }
  function fd(s) {
    var a = s.keyCode;
    return "charCode" in s ? (s = s.charCode, s === 0 && a === 13 && (s = 13)) : s = a, s === 10 && (s = 13), 32 <= s || s === 13 ? s : 0;
  }
  function pd() {
    return !0;
  }
  function ky() {
    return !1;
  }
  function mr(s) {
    function a(f, h, S, _, M) {
      this._reactName = f, this._targetInst = S, this.type = h, this.nativeEvent = _, this.target = M, this.currentTarget = null;
      for (var U in s)
        s.hasOwnProperty(U) && (f = s[U], this[U] = f ? f(_) : _[U]);
      return this.isDefaultPrevented = (_.defaultPrevented != null ? _.defaultPrevented : _.returnValue === !1) ? pd : ky, this.isPropagationStopped = ky, this;
    }
    return V(a.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var f = this.nativeEvent;
      f && (f.preventDefault ? f.preventDefault() : typeof f.returnValue != "unknown" && (f.returnValue = !1), this.isDefaultPrevented = pd);
    }, stopPropagation: function() {
      var f = this.nativeEvent;
      f && (f.stopPropagation ? f.stopPropagation() : typeof f.cancelBubble != "unknown" && (f.cancelBubble = !0), this.isPropagationStopped = pd);
    }, persist: function() {
    }, isPersistent: pd }), a;
  }
  var Pa = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(s) {
    return s.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Lg = mr(Pa), Jl = V({}, Pa, { view: 0, detail: 0 }), P3 = mr(Jl), Mg, Ag, Ql, gd = V({}, Jl, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Ng, button: 0, buttons: 0, relatedTarget: function(s) {
    return s.relatedTarget === void 0 ? s.fromElement === s.srcElement ? s.toElement : s.fromElement : s.relatedTarget;
  }, movementX: function(s) {
    return "movementX" in s ? s.movementX : (s !== Ql && (Ql && s.type === "mousemove" ? (Mg = s.screenX - Ql.screenX, Ag = s.screenY - Ql.screenY) : Ag = Mg = 0, Ql = s), Mg);
  }, movementY: function(s) {
    return "movementY" in s ? s.movementY : Ag;
  } }), Ty = mr(gd), _3 = V({}, gd, { dataTransfer: 0 }), k3 = mr(_3), T3 = V({}, Jl, { relatedTarget: 0 }), Rg = mr(T3), O3 = V({}, Pa, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), L3 = mr(O3), M3 = V({}, Pa, { clipboardData: function(s) {
    return "clipboardData" in s ? s.clipboardData : window.clipboardData;
  } }), A3 = mr(M3), R3 = V({}, Pa, { data: 0 }), Oy = mr(R3), N3 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, $3 = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, D3 = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function I3(s) {
    var a = this.nativeEvent;
    return a.getModifierState ? a.getModifierState(s) : (s = D3[s]) ? !!a[s] : !1;
  }
  function Ng() {
    return I3;
  }
  var V3 = V({}, Jl, { key: function(s) {
    if (s.key) {
      var a = N3[s.key] || s.key;
      if (a !== "Unidentified")
        return a;
    }
    return s.type === "keypress" ? (s = fd(s), s === 13 ? "Enter" : String.fromCharCode(s)) : s.type === "keydown" || s.type === "keyup" ? $3[s.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Ng, charCode: function(s) {
    return s.type === "keypress" ? fd(s) : 0;
  }, keyCode: function(s) {
    return s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
  }, which: function(s) {
    return s.type === "keypress" ? fd(s) : s.type === "keydown" || s.type === "keyup" ? s.keyCode : 0;
  } }), H3 = mr(V3), F3 = V({}, gd, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Ly = mr(F3), z3 = V({}, Jl, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Ng }), B3 = mr(z3), U3 = V({}, Pa, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), W3 = mr(U3), G3 = V({}, gd, {
    deltaX: function(s) {
      return "deltaX" in s ? s.deltaX : "wheelDeltaX" in s ? -s.wheelDeltaX : 0;
    },
    deltaY: function(s) {
      return "deltaY" in s ? s.deltaY : "wheelDeltaY" in s ? -s.wheelDeltaY : "wheelDelta" in s ? -s.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), K3 = mr(G3), q3 = [9, 13, 27, 32], $g = c && "CompositionEvent" in window, ec = null;
  c && "documentMode" in document && (ec = document.documentMode);
  var Y3 = c && "TextEvent" in window && !ec, My = c && (!$g || ec && 8 < ec && 11 >= ec), Ay = String.fromCharCode(32), Ry = !1;
  function Ny(s, a) {
    switch (s) {
      case "keyup":
        return q3.indexOf(a.keyCode) !== -1;
      case "keydown":
        return a.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function $y(s) {
    return s = s.detail, typeof s == "object" && "data" in s ? s.data : null;
  }
  var _a = !1;
  function X3(s, a) {
    switch (s) {
      case "compositionend":
        return $y(a);
      case "keypress":
        return a.which !== 32 ? null : (Ry = !0, Ay);
      case "textInput":
        return s = a.data, s === Ay && Ry ? null : s;
      default:
        return null;
    }
  }
  function Z3(s, a) {
    if (_a)
      return s === "compositionend" || !$g && Ny(s, a) ? (s = _y(), dd = Og = zs = null, _a = !1, s) : null;
    switch (s) {
      case "paste":
        return null;
      case "keypress":
        if (!(a.ctrlKey || a.altKey || a.metaKey) || a.ctrlKey && a.altKey) {
          if (a.char && 1 < a.char.length)
            return a.char;
          if (a.which)
            return String.fromCharCode(a.which);
        }
        return null;
      case "compositionend":
        return My && a.locale !== "ko" ? null : a.data;
      default:
        return null;
    }
  }
  var J3 = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Dy(s) {
    var a = s && s.nodeName && s.nodeName.toLowerCase();
    return a === "input" ? !!J3[s.type] : a === "textarea";
  }
  function Iy(s, a, f, h) {
    ko(h), a = bd(a, "onChange"), 0 < a.length && (f = new Lg("onChange", "change", null, f, h), s.push({ event: f, listeners: a }));
  }
  var tc = null, nc = null;
  function Q3(s) {
    nb(s, 0);
  }
  function hd(s) {
    var a = Ma(s);
    if (He(a))
      return s;
  }
  function e_(s, a) {
    if (s === "change")
      return a;
  }
  var Vy = !1;
  if (c) {
    var Dg;
    if (c) {
      var Ig = "oninput" in document;
      if (!Ig) {
        var Hy = document.createElement("div");
        Hy.setAttribute("oninput", "return;"), Ig = typeof Hy.oninput == "function";
      }
      Dg = Ig;
    } else
      Dg = !1;
    Vy = Dg && (!document.documentMode || 9 < document.documentMode);
  }
  function Fy() {
    tc && (tc.detachEvent("onpropertychange", zy), nc = tc = null);
  }
  function zy(s) {
    if (s.propertyName === "value" && hd(nc)) {
      var a = [];
      Iy(a, nc, s, bn(s)), _e(Q3, a);
    }
  }
  function t_(s, a, f) {
    s === "focusin" ? (Fy(), tc = a, nc = f, tc.attachEvent("onpropertychange", zy)) : s === "focusout" && Fy();
  }
  function n_(s) {
    if (s === "selectionchange" || s === "keyup" || s === "keydown")
      return hd(nc);
  }
  function r_(s, a) {
    if (s === "click")
      return hd(a);
  }
  function o_(s, a) {
    if (s === "input" || s === "change")
      return hd(a);
  }
  function s_(s, a) {
    return s === a && (s !== 0 || 1 / s === 1 / a) || s !== s && a !== a;
  }
  var io = typeof Object.is == "function" ? Object.is : s_;
  function rc(s, a) {
    if (io(s, a))
      return !0;
    if (typeof s != "object" || s === null || typeof a != "object" || a === null)
      return !1;
    var f = Object.keys(s), h = Object.keys(a);
    if (f.length !== h.length)
      return !1;
    for (h = 0; h < f.length; h++) {
      var S = f[h];
      if (!d.call(a, S) || !io(s[S], a[S]))
        return !1;
    }
    return !0;
  }
  function By(s) {
    for (; s && s.firstChild; )
      s = s.firstChild;
    return s;
  }
  function Uy(s, a) {
    var f = By(s);
    s = 0;
    for (var h; f; ) {
      if (f.nodeType === 3) {
        if (h = s + f.textContent.length, s <= a && h >= a)
          return { node: f, offset: a - s };
        s = h;
      }
      e: {
        for (; f; ) {
          if (f.nextSibling) {
            f = f.nextSibling;
            break e;
          }
          f = f.parentNode;
        }
        f = void 0;
      }
      f = By(f);
    }
  }
  function Wy(s, a) {
    return s && a ? s === a ? !0 : s && s.nodeType === 3 ? !1 : a && a.nodeType === 3 ? Wy(s, a.parentNode) : "contains" in s ? s.contains(a) : s.compareDocumentPosition ? !!(s.compareDocumentPosition(a) & 16) : !1 : !1;
  }
  function Gy() {
    for (var s = window, a = Le(); a instanceof s.HTMLIFrameElement; ) {
      try {
        var f = typeof a.contentWindow.location.href == "string";
      } catch {
        f = !1;
      }
      if (f)
        s = a.contentWindow;
      else
        break;
      a = Le(s.document);
    }
    return a;
  }
  function Vg(s) {
    var a = s && s.nodeName && s.nodeName.toLowerCase();
    return a && (a === "input" && (s.type === "text" || s.type === "search" || s.type === "tel" || s.type === "url" || s.type === "password") || a === "textarea" || s.contentEditable === "true");
  }
  function i_(s) {
    var a = Gy(), f = s.focusedElem, h = s.selectionRange;
    if (a !== f && f && f.ownerDocument && Wy(f.ownerDocument.documentElement, f)) {
      if (h !== null && Vg(f)) {
        if (a = h.start, s = h.end, s === void 0 && (s = a), "selectionStart" in f)
          f.selectionStart = a, f.selectionEnd = Math.min(s, f.value.length);
        else if (s = (a = f.ownerDocument || document) && a.defaultView || window, s.getSelection) {
          s = s.getSelection();
          var S = f.textContent.length, _ = Math.min(h.start, S);
          h = h.end === void 0 ? _ : Math.min(h.end, S), !s.extend && _ > h && (S = h, h = _, _ = S), S = Uy(f, _);
          var M = Uy(
            f,
            h
          );
          S && M && (s.rangeCount !== 1 || s.anchorNode !== S.node || s.anchorOffset !== S.offset || s.focusNode !== M.node || s.focusOffset !== M.offset) && (a = a.createRange(), a.setStart(S.node, S.offset), s.removeAllRanges(), _ > h ? (s.addRange(a), s.extend(M.node, M.offset)) : (a.setEnd(M.node, M.offset), s.addRange(a)));
        }
      }
      for (a = [], s = f; s = s.parentNode; )
        s.nodeType === 1 && a.push({ element: s, left: s.scrollLeft, top: s.scrollTop });
      for (typeof f.focus == "function" && f.focus(), f = 0; f < a.length; f++)
        s = a[f], s.element.scrollLeft = s.left, s.element.scrollTop = s.top;
    }
  }
  var a_ = c && "documentMode" in document && 11 >= document.documentMode, ka = null, Hg = null, oc = null, Fg = !1;
  function Ky(s, a, f) {
    var h = f.window === f ? f.document : f.nodeType === 9 ? f : f.ownerDocument;
    Fg || ka == null || ka !== Le(h) || (h = ka, "selectionStart" in h && Vg(h) ? h = { start: h.selectionStart, end: h.selectionEnd } : (h = (h.ownerDocument && h.ownerDocument.defaultView || window).getSelection(), h = { anchorNode: h.anchorNode, anchorOffset: h.anchorOffset, focusNode: h.focusNode, focusOffset: h.focusOffset }), oc && rc(oc, h) || (oc = h, h = bd(Hg, "onSelect"), 0 < h.length && (a = new Lg("onSelect", "select", null, a, f), s.push({ event: a, listeners: h }), a.target = ka)));
  }
  function md(s, a) {
    var f = {};
    return f[s.toLowerCase()] = a.toLowerCase(), f["Webkit" + s] = "webkit" + a, f["Moz" + s] = "moz" + a, f;
  }
  var Ta = { animationend: md("Animation", "AnimationEnd"), animationiteration: md("Animation", "AnimationIteration"), animationstart: md("Animation", "AnimationStart"), transitionend: md("Transition", "TransitionEnd") }, zg = {}, qy = {};
  c && (qy = document.createElement("div").style, "AnimationEvent" in window || (delete Ta.animationend.animation, delete Ta.animationiteration.animation, delete Ta.animationstart.animation), "TransitionEvent" in window || delete Ta.transitionend.transition);
  function vd(s) {
    if (zg[s])
      return zg[s];
    if (!Ta[s])
      return s;
    var a = Ta[s], f;
    for (f in a)
      if (a.hasOwnProperty(f) && f in qy)
        return zg[s] = a[f];
    return s;
  }
  var Yy = vd("animationend"), Xy = vd("animationiteration"), Zy = vd("animationstart"), Jy = vd("transitionend"), Qy = /* @__PURE__ */ new Map(), eb = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Bs(s, a) {
    Qy.set(s, a), i(a, [s]);
  }
  for (var Bg = 0; Bg < eb.length; Bg++) {
    var Ug = eb[Bg], l_ = Ug.toLowerCase(), c_ = Ug[0].toUpperCase() + Ug.slice(1);
    Bs(l_, "on" + c_);
  }
  Bs(Yy, "onAnimationEnd"), Bs(Xy, "onAnimationIteration"), Bs(Zy, "onAnimationStart"), Bs("dblclick", "onDoubleClick"), Bs("focusin", "onFocus"), Bs("focusout", "onBlur"), Bs(Jy, "onTransitionEnd"), l("onMouseEnter", ["mouseout", "mouseover"]), l("onMouseLeave", ["mouseout", "mouseover"]), l("onPointerEnter", ["pointerout", "pointerover"]), l("onPointerLeave", ["pointerout", "pointerover"]), i("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), i("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), i("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), i("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), i("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), i("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var sc = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), u_ = new Set("cancel close invalid load scroll toggle".split(" ").concat(sc));
  function tb(s, a, f) {
    var h = s.type || "unknown-event";
    s.currentTarget = f, l3(h, a, void 0, s), s.currentTarget = null;
  }
  function nb(s, a) {
    a = (a & 4) !== 0;
    for (var f = 0; f < s.length; f++) {
      var h = s[f], S = h.event;
      h = h.listeners;
      e: {
        var _ = void 0;
        if (a)
          for (var M = h.length - 1; 0 <= M; M--) {
            var U = h[M], X = U.instance, ue = U.currentTarget;
            if (U = U.listener, X !== _ && S.isPropagationStopped())
              break e;
            tb(S, U, ue), _ = X;
          }
        else
          for (M = 0; M < h.length; M++) {
            if (U = h[M], X = U.instance, ue = U.currentTarget, U = U.listener, X !== _ && S.isPropagationStopped())
              break e;
            tb(S, U, ue), _ = X;
          }
      }
    }
    if (wn)
      throw s = $i, wn = !1, $i = null, s;
  }
  function Wt(s, a) {
    var f = a[Jg];
    f === void 0 && (f = a[Jg] = /* @__PURE__ */ new Set());
    var h = s + "__bubble";
    f.has(h) || (rb(a, s, 2, !1), f.add(h));
  }
  function Wg(s, a, f) {
    var h = 0;
    a && (h |= 4), rb(f, s, h, a);
  }
  var yd = "_reactListening" + Math.random().toString(36).slice(2);
  function ic(s) {
    if (!s[yd]) {
      s[yd] = !0, r.forEach(function(f) {
        f !== "selectionchange" && (u_.has(f) || Wg(f, !1, s), Wg(f, !0, s));
      });
      var a = s.nodeType === 9 ? s : s.ownerDocument;
      a === null || a[yd] || (a[yd] = !0, Wg("selectionchange", !1, a));
    }
  }
  function rb(s, a, f, h) {
    switch (Py(a)) {
      case 1:
        var S = C3;
        break;
      case 4:
        S = E3;
        break;
      default:
        S = kg;
    }
    f = S.bind(null, a, f, s), S = void 0, !Ye || a !== "touchstart" && a !== "touchmove" && a !== "wheel" || (S = !0), h ? S !== void 0 ? s.addEventListener(a, f, { capture: !0, passive: S }) : s.addEventListener(a, f, !0) : S !== void 0 ? s.addEventListener(a, f, { passive: S }) : s.addEventListener(a, f, !1);
  }
  function Gg(s, a, f, h, S) {
    var _ = h;
    if (!(a & 1) && !(a & 2) && h !== null)
      e:
        for (; ; ) {
          if (h === null)
            return;
          var M = h.tag;
          if (M === 3 || M === 4) {
            var U = h.stateNode.containerInfo;
            if (U === S || U.nodeType === 8 && U.parentNode === S)
              break;
            if (M === 4)
              for (M = h.return; M !== null; ) {
                var X = M.tag;
                if ((X === 3 || X === 4) && (X = M.stateNode.containerInfo, X === S || X.nodeType === 8 && X.parentNode === S))
                  return;
                M = M.return;
              }
            for (; U !== null; ) {
              if (M = Ii(U), M === null)
                return;
              if (X = M.tag, X === 5 || X === 6) {
                h = _ = M;
                continue e;
              }
              U = U.parentNode;
            }
          }
          h = h.return;
        }
    _e(function() {
      var ue = _, Se = bn(f), Ce = [];
      e: {
        var be = Qy.get(s);
        if (be !== void 0) {
          var Me = Lg, Ne = s;
          switch (s) {
            case "keypress":
              if (fd(f) === 0)
                break e;
            case "keydown":
            case "keyup":
              Me = H3;
              break;
            case "focusin":
              Ne = "focus", Me = Rg;
              break;
            case "focusout":
              Ne = "blur", Me = Rg;
              break;
            case "beforeblur":
            case "afterblur":
              Me = Rg;
              break;
            case "click":
              if (f.button === 2)
                break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Me = Ty;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Me = k3;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Me = B3;
              break;
            case Yy:
            case Xy:
            case Zy:
              Me = L3;
              break;
            case Jy:
              Me = W3;
              break;
            case "scroll":
              Me = P3;
              break;
            case "wheel":
              Me = K3;
              break;
            case "copy":
            case "cut":
            case "paste":
              Me = A3;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Me = Ly;
          }
          var $e = (a & 4) !== 0, sn = !$e && s === "scroll", ne = $e ? be !== null ? be + "Capture" : null : be;
          $e = [];
          for (var J = ue, ae; J !== null; ) {
            ae = J;
            var Pe = ae.stateNode;
            if (ae.tag === 5 && Pe !== null && (ae = Pe, ne !== null && (Pe = Oe(J, ne), Pe != null && $e.push(ac(J, Pe, ae)))), sn)
              break;
            J = J.return;
          }
          0 < $e.length && (be = new Me(be, Ne, null, f, Se), Ce.push({ event: be, listeners: $e }));
        }
      }
      if (!(a & 7)) {
        e: {
          if (be = s === "mouseover" || s === "pointerover", Me = s === "mouseout" || s === "pointerout", be && f !== at && (Ne = f.relatedTarget || f.fromElement) && (Ii(Ne) || Ne[us]))
            break e;
          if ((Me || be) && (be = Se.window === Se ? Se : (be = Se.ownerDocument) ? be.defaultView || be.parentWindow : window, Me ? (Ne = f.relatedTarget || f.toElement, Me = ue, Ne = Ne ? Ii(Ne) : null, Ne !== null && (sn = Di(Ne), Ne !== sn || Ne.tag !== 5 && Ne.tag !== 6) && (Ne = null)) : (Me = null, Ne = ue), Me !== Ne)) {
            if ($e = Ty, Pe = "onMouseLeave", ne = "onMouseEnter", J = "mouse", (s === "pointerout" || s === "pointerover") && ($e = Ly, Pe = "onPointerLeave", ne = "onPointerEnter", J = "pointer"), sn = Me == null ? be : Ma(Me), ae = Ne == null ? be : Ma(Ne), be = new $e(Pe, J + "leave", Me, f, Se), be.target = sn, be.relatedTarget = ae, Pe = null, Ii(Se) === ue && ($e = new $e(ne, J + "enter", Ne, f, Se), $e.target = ae, $e.relatedTarget = sn, Pe = $e), sn = Pe, Me && Ne)
              t: {
                for ($e = Me, ne = Ne, J = 0, ae = $e; ae; ae = Oa(ae))
                  J++;
                for (ae = 0, Pe = ne; Pe; Pe = Oa(Pe))
                  ae++;
                for (; 0 < J - ae; )
                  $e = Oa($e), J--;
                for (; 0 < ae - J; )
                  ne = Oa(ne), ae--;
                for (; J--; ) {
                  if ($e === ne || ne !== null && $e === ne.alternate)
                    break t;
                  $e = Oa($e), ne = Oa(ne);
                }
                $e = null;
              }
            else
              $e = null;
            Me !== null && ob(Ce, be, Me, $e, !1), Ne !== null && sn !== null && ob(Ce, sn, Ne, $e, !0);
          }
        }
        e: {
          if (be = ue ? Ma(ue) : window, Me = be.nodeName && be.nodeName.toLowerCase(), Me === "select" || Me === "input" && be.type === "file")
            var Ie = e_;
          else if (Dy(be))
            if (Vy)
              Ie = o_;
            else {
              Ie = n_;
              var Fe = t_;
            }
          else
            (Me = be.nodeName) && Me.toLowerCase() === "input" && (be.type === "checkbox" || be.type === "radio") && (Ie = r_);
          if (Ie && (Ie = Ie(s, ue))) {
            Iy(Ce, Ie, f, Se);
            break e;
          }
          Fe && Fe(s, be, ue), s === "focusout" && (Fe = be._wrapperState) && Fe.controlled && be.type === "number" && vn(be, "number", be.value);
        }
        switch (Fe = ue ? Ma(ue) : window, s) {
          case "focusin":
            (Dy(Fe) || Fe.contentEditable === "true") && (ka = Fe, Hg = ue, oc = null);
            break;
          case "focusout":
            oc = Hg = ka = null;
            break;
          case "mousedown":
            Fg = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Fg = !1, Ky(Ce, f, Se);
            break;
          case "selectionchange":
            if (a_)
              break;
          case "keydown":
          case "keyup":
            Ky(Ce, f, Se);
        }
        var ze;
        if ($g)
          e: {
            switch (s) {
              case "compositionstart":
                var We = "onCompositionStart";
                break e;
              case "compositionend":
                We = "onCompositionEnd";
                break e;
              case "compositionupdate":
                We = "onCompositionUpdate";
                break e;
            }
            We = void 0;
          }
        else
          _a ? Ny(s, f) && (We = "onCompositionEnd") : s === "keydown" && f.keyCode === 229 && (We = "onCompositionStart");
        We && (My && f.locale !== "ko" && (_a || We !== "onCompositionStart" ? We === "onCompositionEnd" && _a && (ze = _y()) : (zs = Se, Og = "value" in zs ? zs.value : zs.textContent, _a = !0)), Fe = bd(ue, We), 0 < Fe.length && (We = new Oy(We, s, null, f, Se), Ce.push({ event: We, listeners: Fe }), ze ? We.data = ze : (ze = $y(f), ze !== null && (We.data = ze)))), (ze = Y3 ? X3(s, f) : Z3(s, f)) && (ue = bd(ue, "onBeforeInput"), 0 < ue.length && (Se = new Oy("onBeforeInput", "beforeinput", null, f, Se), Ce.push({ event: Se, listeners: ue }), Se.data = ze));
      }
      nb(Ce, a);
    });
  }
  function ac(s, a, f) {
    return { instance: s, listener: a, currentTarget: f };
  }
  function bd(s, a) {
    for (var f = a + "Capture", h = []; s !== null; ) {
      var S = s, _ = S.stateNode;
      S.tag === 5 && _ !== null && (S = _, _ = Oe(s, f), _ != null && h.unshift(ac(s, _, S)), _ = Oe(s, a), _ != null && h.push(ac(s, _, S))), s = s.return;
    }
    return h;
  }
  function Oa(s) {
    if (s === null)
      return null;
    do
      s = s.return;
    while (s && s.tag !== 5);
    return s || null;
  }
  function ob(s, a, f, h, S) {
    for (var _ = a._reactName, M = []; f !== null && f !== h; ) {
      var U = f, X = U.alternate, ue = U.stateNode;
      if (X !== null && X === h)
        break;
      U.tag === 5 && ue !== null && (U = ue, S ? (X = Oe(f, _), X != null && M.unshift(ac(f, X, U))) : S || (X = Oe(f, _), X != null && M.push(ac(f, X, U)))), f = f.return;
    }
    M.length !== 0 && s.push({ event: a, listeners: M });
  }
  var d_ = /\r\n?/g, f_ = /\u0000|\uFFFD/g;
  function sb(s) {
    return (typeof s == "string" ? s : "" + s).replace(d_, `
`).replace(f_, "");
  }
  function xd(s, a, f) {
    if (a = sb(a), sb(s) !== a && f)
      throw Error(n(425));
  }
  function wd() {
  }
  var Kg = null, qg = null;
  function Yg(s, a) {
    return s === "textarea" || s === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
  }
  var Xg = typeof setTimeout == "function" ? setTimeout : void 0, p_ = typeof clearTimeout == "function" ? clearTimeout : void 0, ib = typeof Promise == "function" ? Promise : void 0, g_ = typeof queueMicrotask == "function" ? queueMicrotask : typeof ib < "u" ? function(s) {
    return ib.resolve(null).then(s).catch(h_);
  } : Xg;
  function h_(s) {
    setTimeout(function() {
      throw s;
    });
  }
  function Zg(s, a) {
    var f = a, h = 0;
    do {
      var S = f.nextSibling;
      if (s.removeChild(f), S && S.nodeType === 8)
        if (f = S.data, f === "/$") {
          if (h === 0) {
            s.removeChild(S), Zl(a);
            return;
          }
          h--;
        } else
          f !== "$" && f !== "$?" && f !== "$!" || h++;
      f = S;
    } while (f);
    Zl(a);
  }
  function Us(s) {
    for (; s != null; s = s.nextSibling) {
      var a = s.nodeType;
      if (a === 1 || a === 3)
        break;
      if (a === 8) {
        if (a = s.data, a === "$" || a === "$!" || a === "$?")
          break;
        if (a === "/$")
          return null;
      }
    }
    return s;
  }
  function ab(s) {
    s = s.previousSibling;
    for (var a = 0; s; ) {
      if (s.nodeType === 8) {
        var f = s.data;
        if (f === "$" || f === "$!" || f === "$?") {
          if (a === 0)
            return s;
          a--;
        } else
          f === "/$" && a++;
      }
      s = s.previousSibling;
    }
    return null;
  }
  var La = Math.random().toString(36).slice(2), Oo = "__reactFiber$" + La, lc = "__reactProps$" + La, us = "__reactContainer$" + La, Jg = "__reactEvents$" + La, m_ = "__reactListeners$" + La, v_ = "__reactHandles$" + La;
  function Ii(s) {
    var a = s[Oo];
    if (a)
      return a;
    for (var f = s.parentNode; f; ) {
      if (a = f[us] || f[Oo]) {
        if (f = a.alternate, a.child !== null || f !== null && f.child !== null)
          for (s = ab(s); s !== null; ) {
            if (f = s[Oo])
              return f;
            s = ab(s);
          }
        return a;
      }
      s = f, f = s.parentNode;
    }
    return null;
  }
  function cc(s) {
    return s = s[Oo] || s[us], !s || s.tag !== 5 && s.tag !== 6 && s.tag !== 13 && s.tag !== 3 ? null : s;
  }
  function Ma(s) {
    if (s.tag === 5 || s.tag === 6)
      return s.stateNode;
    throw Error(n(33));
  }
  function Sd(s) {
    return s[lc] || null;
  }
  var Qg = [], Aa = -1;
  function Ws(s) {
    return { current: s };
  }
  function Gt(s) {
    0 > Aa || (s.current = Qg[Aa], Qg[Aa] = null, Aa--);
  }
  function Vt(s, a) {
    Aa++, Qg[Aa] = s.current, s.current = a;
  }
  var Gs = {}, Dn = Ws(Gs), er = Ws(!1), Vi = Gs;
  function Ra(s, a) {
    var f = s.type.contextTypes;
    if (!f)
      return Gs;
    var h = s.stateNode;
    if (h && h.__reactInternalMemoizedUnmaskedChildContext === a)
      return h.__reactInternalMemoizedMaskedChildContext;
    var S = {}, _;
    for (_ in f)
      S[_] = a[_];
    return h && (s = s.stateNode, s.__reactInternalMemoizedUnmaskedChildContext = a, s.__reactInternalMemoizedMaskedChildContext = S), S;
  }
  function tr(s) {
    return s = s.childContextTypes, s != null;
  }
  function jd() {
    Gt(er), Gt(Dn);
  }
  function lb(s, a, f) {
    if (Dn.current !== Gs)
      throw Error(n(168));
    Vt(Dn, a), Vt(er, f);
  }
  function cb(s, a, f) {
    var h = s.stateNode;
    if (a = a.childContextTypes, typeof h.getChildContext != "function")
      return f;
    h = h.getChildContext();
    for (var S in h)
      if (!(S in a))
        throw Error(n(108, oe(s) || "Unknown", S));
    return V({}, f, h);
  }
  function Cd(s) {
    return s = (s = s.stateNode) && s.__reactInternalMemoizedMergedChildContext || Gs, Vi = Dn.current, Vt(Dn, s), Vt(er, er.current), !0;
  }
  function ub(s, a, f) {
    var h = s.stateNode;
    if (!h)
      throw Error(n(169));
    f ? (s = cb(s, a, Vi), h.__reactInternalMemoizedMergedChildContext = s, Gt(er), Gt(Dn), Vt(Dn, s)) : Gt(er), Vt(er, f);
  }
  var ds = null, Ed = !1, eh = !1;
  function db(s) {
    ds === null ? ds = [s] : ds.push(s);
  }
  function y_(s) {
    Ed = !0, db(s);
  }
  function Ks() {
    if (!eh && ds !== null) {
      eh = !0;
      var s = 0, a = Pt;
      try {
        var f = ds;
        for (Pt = 1; s < f.length; s++) {
          var h = f[s];
          do
            h = h(!0);
          while (h !== null);
        }
        ds = null, Ed = !1;
      } catch (S) {
        throw ds !== null && (ds = ds.slice(s + 1)), py(Sg, Ks), S;
      } finally {
        Pt = a, eh = !1;
      }
    }
    return null;
  }
  var Na = [], $a = 0, Pd = null, _d = 0, Dr = [], Ir = 0, Hi = null, fs = 1, ps = "";
  function Fi(s, a) {
    Na[$a++] = _d, Na[$a++] = Pd, Pd = s, _d = a;
  }
  function fb(s, a, f) {
    Dr[Ir++] = fs, Dr[Ir++] = ps, Dr[Ir++] = Hi, Hi = s;
    var h = fs;
    s = ps;
    var S = 32 - so(h) - 1;
    h &= ~(1 << S), f += 1;
    var _ = 32 - so(a) + S;
    if (30 < _) {
      var M = S - S % 5;
      _ = (h & (1 << M) - 1).toString(32), h >>= M, S -= M, fs = 1 << 32 - so(a) + S | f << S | h, ps = _ + s;
    } else
      fs = 1 << _ | f << S | h, ps = s;
  }
  function th(s) {
    s.return !== null && (Fi(s, 1), fb(s, 1, 0));
  }
  function nh(s) {
    for (; s === Pd; )
      Pd = Na[--$a], Na[$a] = null, _d = Na[--$a], Na[$a] = null;
    for (; s === Hi; )
      Hi = Dr[--Ir], Dr[Ir] = null, ps = Dr[--Ir], Dr[Ir] = null, fs = Dr[--Ir], Dr[Ir] = null;
  }
  var vr = null, yr = null, Kt = !1, ao = null;
  function pb(s, a) {
    var f = zr(5, null, null, 0);
    f.elementType = "DELETED", f.stateNode = a, f.return = s, a = s.deletions, a === null ? (s.deletions = [f], s.flags |= 16) : a.push(f);
  }
  function gb(s, a) {
    switch (s.tag) {
      case 5:
        var f = s.type;
        return a = a.nodeType !== 1 || f.toLowerCase() !== a.nodeName.toLowerCase() ? null : a, a !== null ? (s.stateNode = a, vr = s, yr = Us(a.firstChild), !0) : !1;
      case 6:
        return a = s.pendingProps === "" || a.nodeType !== 3 ? null : a, a !== null ? (s.stateNode = a, vr = s, yr = null, !0) : !1;
      case 13:
        return a = a.nodeType !== 8 ? null : a, a !== null ? (f = Hi !== null ? { id: fs, overflow: ps } : null, s.memoizedState = { dehydrated: a, treeContext: f, retryLane: 1073741824 }, f = zr(18, null, null, 0), f.stateNode = a, f.return = s, s.child = f, vr = s, yr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function rh(s) {
    return (s.mode & 1) !== 0 && (s.flags & 128) === 0;
  }
  function oh(s) {
    if (Kt) {
      var a = yr;
      if (a) {
        var f = a;
        if (!gb(s, a)) {
          if (rh(s))
            throw Error(n(418));
          a = Us(f.nextSibling);
          var h = vr;
          a && gb(s, a) ? pb(h, f) : (s.flags = s.flags & -4097 | 2, Kt = !1, vr = s);
        }
      } else {
        if (rh(s))
          throw Error(n(418));
        s.flags = s.flags & -4097 | 2, Kt = !1, vr = s;
      }
    }
  }
  function hb(s) {
    for (s = s.return; s !== null && s.tag !== 5 && s.tag !== 3 && s.tag !== 13; )
      s = s.return;
    vr = s;
  }
  function kd(s) {
    if (s !== vr)
      return !1;
    if (!Kt)
      return hb(s), Kt = !0, !1;
    var a;
    if ((a = s.tag !== 3) && !(a = s.tag !== 5) && (a = s.type, a = a !== "head" && a !== "body" && !Yg(s.type, s.memoizedProps)), a && (a = yr)) {
      if (rh(s))
        throw mb(), Error(n(418));
      for (; a; )
        pb(s, a), a = Us(a.nextSibling);
    }
    if (hb(s), s.tag === 13) {
      if (s = s.memoizedState, s = s !== null ? s.dehydrated : null, !s)
        throw Error(n(317));
      e: {
        for (s = s.nextSibling, a = 0; s; ) {
          if (s.nodeType === 8) {
            var f = s.data;
            if (f === "/$") {
              if (a === 0) {
                yr = Us(s.nextSibling);
                break e;
              }
              a--;
            } else
              f !== "$" && f !== "$!" && f !== "$?" || a++;
          }
          s = s.nextSibling;
        }
        yr = null;
      }
    } else
      yr = vr ? Us(s.stateNode.nextSibling) : null;
    return !0;
  }
  function mb() {
    for (var s = yr; s; )
      s = Us(s.nextSibling);
  }
  function Da() {
    yr = vr = null, Kt = !1;
  }
  function sh(s) {
    ao === null ? ao = [s] : ao.push(s);
  }
  var b_ = k.ReactCurrentBatchConfig;
  function uc(s, a, f) {
    if (s = f.ref, s !== null && typeof s != "function" && typeof s != "object") {
      if (f._owner) {
        if (f = f._owner, f) {
          if (f.tag !== 1)
            throw Error(n(309));
          var h = f.stateNode;
        }
        if (!h)
          throw Error(n(147, s));
        var S = h, _ = "" + s;
        return a !== null && a.ref !== null && typeof a.ref == "function" && a.ref._stringRef === _ ? a.ref : (a = function(M) {
          var U = S.refs;
          M === null ? delete U[_] : U[_] = M;
        }, a._stringRef = _, a);
      }
      if (typeof s != "string")
        throw Error(n(284));
      if (!f._owner)
        throw Error(n(290, s));
    }
    return s;
  }
  function Td(s, a) {
    throw s = Object.prototype.toString.call(a), Error(n(31, s === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : s));
  }
  function vb(s) {
    var a = s._init;
    return a(s._payload);
  }
  function yb(s) {
    function a(ne, J) {
      if (s) {
        var ae = ne.deletions;
        ae === null ? (ne.deletions = [J], ne.flags |= 16) : ae.push(J);
      }
    }
    function f(ne, J) {
      if (!s)
        return null;
      for (; J !== null; )
        a(ne, J), J = J.sibling;
      return null;
    }
    function h(ne, J) {
      for (ne = /* @__PURE__ */ new Map(); J !== null; )
        J.key !== null ? ne.set(J.key, J) : ne.set(J.index, J), J = J.sibling;
      return ne;
    }
    function S(ne, J) {
      return ne = ti(ne, J), ne.index = 0, ne.sibling = null, ne;
    }
    function _(ne, J, ae) {
      return ne.index = ae, s ? (ae = ne.alternate, ae !== null ? (ae = ae.index, ae < J ? (ne.flags |= 2, J) : ae) : (ne.flags |= 2, J)) : (ne.flags |= 1048576, J);
    }
    function M(ne) {
      return s && ne.alternate === null && (ne.flags |= 2), ne;
    }
    function U(ne, J, ae, Pe) {
      return J === null || J.tag !== 6 ? (J = Xh(ae, ne.mode, Pe), J.return = ne, J) : (J = S(J, ae), J.return = ne, J);
    }
    function X(ne, J, ae, Pe) {
      var Ie = ae.type;
      return Ie === A ? Se(ne, J, ae.props.children, Pe, ae.key) : J !== null && (J.elementType === Ie || typeof Ie == "object" && Ie !== null && Ie.$$typeof === q && vb(Ie) === J.type) ? (Pe = S(J, ae.props), Pe.ref = uc(ne, J, ae), Pe.return = ne, Pe) : (Pe = Qd(ae.type, ae.key, ae.props, null, ne.mode, Pe), Pe.ref = uc(ne, J, ae), Pe.return = ne, Pe);
    }
    function ue(ne, J, ae, Pe) {
      return J === null || J.tag !== 4 || J.stateNode.containerInfo !== ae.containerInfo || J.stateNode.implementation !== ae.implementation ? (J = Zh(ae, ne.mode, Pe), J.return = ne, J) : (J = S(J, ae.children || []), J.return = ne, J);
    }
    function Se(ne, J, ae, Pe, Ie) {
      return J === null || J.tag !== 7 ? (J = Yi(ae, ne.mode, Pe, Ie), J.return = ne, J) : (J = S(J, ae), J.return = ne, J);
    }
    function Ce(ne, J, ae) {
      if (typeof J == "string" && J !== "" || typeof J == "number")
        return J = Xh("" + J, ne.mode, ae), J.return = ne, J;
      if (typeof J == "object" && J !== null) {
        switch (J.$$typeof) {
          case T:
            return ae = Qd(J.type, J.key, J.props, null, ne.mode, ae), ae.ref = uc(ne, null, J), ae.return = ne, ae;
          case O:
            return J = Zh(J, ne.mode, ae), J.return = ne, J;
          case q:
            var Pe = J._init;
            return Ce(ne, Pe(J._payload), ae);
        }
        if (St(J) || F(J))
          return J = Yi(J, ne.mode, ae, null), J.return = ne, J;
        Td(ne, J);
      }
      return null;
    }
    function be(ne, J, ae, Pe) {
      var Ie = J !== null ? J.key : null;
      if (typeof ae == "string" && ae !== "" || typeof ae == "number")
        return Ie !== null ? null : U(ne, J, "" + ae, Pe);
      if (typeof ae == "object" && ae !== null) {
        switch (ae.$$typeof) {
          case T:
            return ae.key === Ie ? X(ne, J, ae, Pe) : null;
          case O:
            return ae.key === Ie ? ue(ne, J, ae, Pe) : null;
          case q:
            return Ie = ae._init, be(
              ne,
              J,
              Ie(ae._payload),
              Pe
            );
        }
        if (St(ae) || F(ae))
          return Ie !== null ? null : Se(ne, J, ae, Pe, null);
        Td(ne, ae);
      }
      return null;
    }
    function Me(ne, J, ae, Pe, Ie) {
      if (typeof Pe == "string" && Pe !== "" || typeof Pe == "number")
        return ne = ne.get(ae) || null, U(J, ne, "" + Pe, Ie);
      if (typeof Pe == "object" && Pe !== null) {
        switch (Pe.$$typeof) {
          case T:
            return ne = ne.get(Pe.key === null ? ae : Pe.key) || null, X(J, ne, Pe, Ie);
          case O:
            return ne = ne.get(Pe.key === null ? ae : Pe.key) || null, ue(J, ne, Pe, Ie);
          case q:
            var Fe = Pe._init;
            return Me(ne, J, ae, Fe(Pe._payload), Ie);
        }
        if (St(Pe) || F(Pe))
          return ne = ne.get(ae) || null, Se(J, ne, Pe, Ie, null);
        Td(J, Pe);
      }
      return null;
    }
    function Ne(ne, J, ae, Pe) {
      for (var Ie = null, Fe = null, ze = J, We = J = 0, Cn = null; ze !== null && We < ae.length; We++) {
        ze.index > We ? (Cn = ze, ze = null) : Cn = ze.sibling;
        var yt = be(ne, ze, ae[We], Pe);
        if (yt === null) {
          ze === null && (ze = Cn);
          break;
        }
        s && ze && yt.alternate === null && a(ne, ze), J = _(yt, J, We), Fe === null ? Ie = yt : Fe.sibling = yt, Fe = yt, ze = Cn;
      }
      if (We === ae.length)
        return f(ne, ze), Kt && Fi(ne, We), Ie;
      if (ze === null) {
        for (; We < ae.length; We++)
          ze = Ce(ne, ae[We], Pe), ze !== null && (J = _(ze, J, We), Fe === null ? Ie = ze : Fe.sibling = ze, Fe = ze);
        return Kt && Fi(ne, We), Ie;
      }
      for (ze = h(ne, ze); We < ae.length; We++)
        Cn = Me(ze, ne, We, ae[We], Pe), Cn !== null && (s && Cn.alternate !== null && ze.delete(Cn.key === null ? We : Cn.key), J = _(Cn, J, We), Fe === null ? Ie = Cn : Fe.sibling = Cn, Fe = Cn);
      return s && ze.forEach(function(ni) {
        return a(ne, ni);
      }), Kt && Fi(ne, We), Ie;
    }
    function $e(ne, J, ae, Pe) {
      var Ie = F(ae);
      if (typeof Ie != "function")
        throw Error(n(150));
      if (ae = Ie.call(ae), ae == null)
        throw Error(n(151));
      for (var Fe = Ie = null, ze = J, We = J = 0, Cn = null, yt = ae.next(); ze !== null && !yt.done; We++, yt = ae.next()) {
        ze.index > We ? (Cn = ze, ze = null) : Cn = ze.sibling;
        var ni = be(ne, ze, yt.value, Pe);
        if (ni === null) {
          ze === null && (ze = Cn);
          break;
        }
        s && ze && ni.alternate === null && a(ne, ze), J = _(ni, J, We), Fe === null ? Ie = ni : Fe.sibling = ni, Fe = ni, ze = Cn;
      }
      if (yt.done)
        return f(
          ne,
          ze
        ), Kt && Fi(ne, We), Ie;
      if (ze === null) {
        for (; !yt.done; We++, yt = ae.next())
          yt = Ce(ne, yt.value, Pe), yt !== null && (J = _(yt, J, We), Fe === null ? Ie = yt : Fe.sibling = yt, Fe = yt);
        return Kt && Fi(ne, We), Ie;
      }
      for (ze = h(ne, ze); !yt.done; We++, yt = ae.next())
        yt = Me(ze, ne, We, yt.value, Pe), yt !== null && (s && yt.alternate !== null && ze.delete(yt.key === null ? We : yt.key), J = _(yt, J, We), Fe === null ? Ie = yt : Fe.sibling = yt, Fe = yt);
      return s && ze.forEach(function(J_) {
        return a(ne, J_);
      }), Kt && Fi(ne, We), Ie;
    }
    function sn(ne, J, ae, Pe) {
      if (typeof ae == "object" && ae !== null && ae.type === A && ae.key === null && (ae = ae.props.children), typeof ae == "object" && ae !== null) {
        switch (ae.$$typeof) {
          case T:
            e: {
              for (var Ie = ae.key, Fe = J; Fe !== null; ) {
                if (Fe.key === Ie) {
                  if (Ie = ae.type, Ie === A) {
                    if (Fe.tag === 7) {
                      f(ne, Fe.sibling), J = S(Fe, ae.props.children), J.return = ne, ne = J;
                      break e;
                    }
                  } else if (Fe.elementType === Ie || typeof Ie == "object" && Ie !== null && Ie.$$typeof === q && vb(Ie) === Fe.type) {
                    f(ne, Fe.sibling), J = S(Fe, ae.props), J.ref = uc(ne, Fe, ae), J.return = ne, ne = J;
                    break e;
                  }
                  f(ne, Fe);
                  break;
                } else
                  a(ne, Fe);
                Fe = Fe.sibling;
              }
              ae.type === A ? (J = Yi(ae.props.children, ne.mode, Pe, ae.key), J.return = ne, ne = J) : (Pe = Qd(ae.type, ae.key, ae.props, null, ne.mode, Pe), Pe.ref = uc(ne, J, ae), Pe.return = ne, ne = Pe);
            }
            return M(ne);
          case O:
            e: {
              for (Fe = ae.key; J !== null; ) {
                if (J.key === Fe)
                  if (J.tag === 4 && J.stateNode.containerInfo === ae.containerInfo && J.stateNode.implementation === ae.implementation) {
                    f(ne, J.sibling), J = S(J, ae.children || []), J.return = ne, ne = J;
                    break e;
                  } else {
                    f(ne, J);
                    break;
                  }
                else
                  a(ne, J);
                J = J.sibling;
              }
              J = Zh(ae, ne.mode, Pe), J.return = ne, ne = J;
            }
            return M(ne);
          case q:
            return Fe = ae._init, sn(ne, J, Fe(ae._payload), Pe);
        }
        if (St(ae))
          return Ne(ne, J, ae, Pe);
        if (F(ae))
          return $e(ne, J, ae, Pe);
        Td(ne, ae);
      }
      return typeof ae == "string" && ae !== "" || typeof ae == "number" ? (ae = "" + ae, J !== null && J.tag === 6 ? (f(ne, J.sibling), J = S(J, ae), J.return = ne, ne = J) : (f(ne, J), J = Xh(ae, ne.mode, Pe), J.return = ne, ne = J), M(ne)) : f(ne, J);
    }
    return sn;
  }
  var Ia = yb(!0), bb = yb(!1), Od = Ws(null), Ld = null, Va = null, ih = null;
  function ah() {
    ih = Va = Ld = null;
  }
  function lh(s) {
    var a = Od.current;
    Gt(Od), s._currentValue = a;
  }
  function ch(s, a, f) {
    for (; s !== null; ) {
      var h = s.alternate;
      if ((s.childLanes & a) !== a ? (s.childLanes |= a, h !== null && (h.childLanes |= a)) : h !== null && (h.childLanes & a) !== a && (h.childLanes |= a), s === f)
        break;
      s = s.return;
    }
  }
  function Ha(s, a) {
    Ld = s, ih = Va = null, s = s.dependencies, s !== null && s.firstContext !== null && (s.lanes & a && (nr = !0), s.firstContext = null);
  }
  function Vr(s) {
    var a = s._currentValue;
    if (ih !== s)
      if (s = { context: s, memoizedValue: a, next: null }, Va === null) {
        if (Ld === null)
          throw Error(n(308));
        Va = s, Ld.dependencies = { lanes: 0, firstContext: s };
      } else
        Va = Va.next = s;
    return a;
  }
  var zi = null;
  function uh(s) {
    zi === null ? zi = [s] : zi.push(s);
  }
  function xb(s, a, f, h) {
    var S = a.interleaved;
    return S === null ? (f.next = f, uh(a)) : (f.next = S.next, S.next = f), a.interleaved = f, gs(s, h);
  }
  function gs(s, a) {
    s.lanes |= a;
    var f = s.alternate;
    for (f !== null && (f.lanes |= a), f = s, s = s.return; s !== null; )
      s.childLanes |= a, f = s.alternate, f !== null && (f.childLanes |= a), f = s, s = s.return;
    return f.tag === 3 ? f.stateNode : null;
  }
  var qs = !1;
  function dh(s) {
    s.updateQueue = { baseState: s.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function wb(s, a) {
    s = s.updateQueue, a.updateQueue === s && (a.updateQueue = { baseState: s.baseState, firstBaseUpdate: s.firstBaseUpdate, lastBaseUpdate: s.lastBaseUpdate, shared: s.shared, effects: s.effects });
  }
  function hs(s, a) {
    return { eventTime: s, lane: a, tag: 0, payload: null, callback: null, next: null };
  }
  function Ys(s, a, f) {
    var h = s.updateQueue;
    if (h === null)
      return null;
    if (h = h.shared, ht & 2) {
      var S = h.pending;
      return S === null ? a.next = a : (a.next = S.next, S.next = a), h.pending = a, gs(s, f);
    }
    return S = h.interleaved, S === null ? (a.next = a, uh(h)) : (a.next = S.next, S.next = a), h.interleaved = a, gs(s, f);
  }
  function Md(s, a, f) {
    if (a = a.updateQueue, a !== null && (a = a.shared, (f & 4194240) !== 0)) {
      var h = a.lanes;
      h &= s.pendingLanes, f |= h, a.lanes = f, Eg(s, f);
    }
  }
  function Sb(s, a) {
    var f = s.updateQueue, h = s.alternate;
    if (h !== null && (h = h.updateQueue, f === h)) {
      var S = null, _ = null;
      if (f = f.firstBaseUpdate, f !== null) {
        do {
          var M = { eventTime: f.eventTime, lane: f.lane, tag: f.tag, payload: f.payload, callback: f.callback, next: null };
          _ === null ? S = _ = M : _ = _.next = M, f = f.next;
        } while (f !== null);
        _ === null ? S = _ = a : _ = _.next = a;
      } else
        S = _ = a;
      f = { baseState: h.baseState, firstBaseUpdate: S, lastBaseUpdate: _, shared: h.shared, effects: h.effects }, s.updateQueue = f;
      return;
    }
    s = f.lastBaseUpdate, s === null ? f.firstBaseUpdate = a : s.next = a, f.lastBaseUpdate = a;
  }
  function Ad(s, a, f, h) {
    var S = s.updateQueue;
    qs = !1;
    var _ = S.firstBaseUpdate, M = S.lastBaseUpdate, U = S.shared.pending;
    if (U !== null) {
      S.shared.pending = null;
      var X = U, ue = X.next;
      X.next = null, M === null ? _ = ue : M.next = ue, M = X;
      var Se = s.alternate;
      Se !== null && (Se = Se.updateQueue, U = Se.lastBaseUpdate, U !== M && (U === null ? Se.firstBaseUpdate = ue : U.next = ue, Se.lastBaseUpdate = X));
    }
    if (_ !== null) {
      var Ce = S.baseState;
      M = 0, Se = ue = X = null, U = _;
      do {
        var be = U.lane, Me = U.eventTime;
        if ((h & be) === be) {
          Se !== null && (Se = Se.next = {
            eventTime: Me,
            lane: 0,
            tag: U.tag,
            payload: U.payload,
            callback: U.callback,
            next: null
          });
          e: {
            var Ne = s, $e = U;
            switch (be = a, Me = f, $e.tag) {
              case 1:
                if (Ne = $e.payload, typeof Ne == "function") {
                  Ce = Ne.call(Me, Ce, be);
                  break e;
                }
                Ce = Ne;
                break e;
              case 3:
                Ne.flags = Ne.flags & -65537 | 128;
              case 0:
                if (Ne = $e.payload, be = typeof Ne == "function" ? Ne.call(Me, Ce, be) : Ne, be == null)
                  break e;
                Ce = V({}, Ce, be);
                break e;
              case 2:
                qs = !0;
            }
          }
          U.callback !== null && U.lane !== 0 && (s.flags |= 64, be = S.effects, be === null ? S.effects = [U] : be.push(U));
        } else
          Me = { eventTime: Me, lane: be, tag: U.tag, payload: U.payload, callback: U.callback, next: null }, Se === null ? (ue = Se = Me, X = Ce) : Se = Se.next = Me, M |= be;
        if (U = U.next, U === null) {
          if (U = S.shared.pending, U === null)
            break;
          be = U, U = be.next, be.next = null, S.lastBaseUpdate = be, S.shared.pending = null;
        }
      } while (1);
      if (Se === null && (X = Ce), S.baseState = X, S.firstBaseUpdate = ue, S.lastBaseUpdate = Se, a = S.shared.interleaved, a !== null) {
        S = a;
        do
          M |= S.lane, S = S.next;
        while (S !== a);
      } else
        _ === null && (S.shared.lanes = 0);
      Wi |= M, s.lanes = M, s.memoizedState = Ce;
    }
  }
  function jb(s, a, f) {
    if (s = a.effects, a.effects = null, s !== null)
      for (a = 0; a < s.length; a++) {
        var h = s[a], S = h.callback;
        if (S !== null) {
          if (h.callback = null, h = f, typeof S != "function")
            throw Error(n(191, S));
          S.call(h);
        }
      }
  }
  var dc = {}, Lo = Ws(dc), fc = Ws(dc), pc = Ws(dc);
  function Bi(s) {
    if (s === dc)
      throw Error(n(174));
    return s;
  }
  function fh(s, a) {
    switch (Vt(pc, a), Vt(fc, s), Vt(Lo, dc), s = a.nodeType, s) {
      case 9:
      case 11:
        a = (a = a.documentElement) ? a.namespaceURI : Ut(null, "");
        break;
      default:
        s = s === 8 ? a.parentNode : a, a = s.namespaceURI || null, s = s.tagName, a = Ut(a, s);
    }
    Gt(Lo), Vt(Lo, a);
  }
  function Fa() {
    Gt(Lo), Gt(fc), Gt(pc);
  }
  function Cb(s) {
    Bi(pc.current);
    var a = Bi(Lo.current), f = Ut(a, s.type);
    a !== f && (Vt(fc, s), Vt(Lo, f));
  }
  function ph(s) {
    fc.current === s && (Gt(Lo), Gt(fc));
  }
  var Yt = Ws(0);
  function Rd(s) {
    for (var a = s; a !== null; ) {
      if (a.tag === 13) {
        var f = a.memoizedState;
        if (f !== null && (f = f.dehydrated, f === null || f.data === "$?" || f.data === "$!"))
          return a;
      } else if (a.tag === 19 && a.memoizedProps.revealOrder !== void 0) {
        if (a.flags & 128)
          return a;
      } else if (a.child !== null) {
        a.child.return = a, a = a.child;
        continue;
      }
      if (a === s)
        break;
      for (; a.sibling === null; ) {
        if (a.return === null || a.return === s)
          return null;
        a = a.return;
      }
      a.sibling.return = a.return, a = a.sibling;
    }
    return null;
  }
  var gh = [];
  function hh() {
    for (var s = 0; s < gh.length; s++)
      gh[s]._workInProgressVersionPrimary = null;
    gh.length = 0;
  }
  var Nd = k.ReactCurrentDispatcher, mh = k.ReactCurrentBatchConfig, Ui = 0, Xt = null, pn = null, Sn = null, $d = !1, gc = !1, hc = 0, x_ = 0;
  function In() {
    throw Error(n(321));
  }
  function vh(s, a) {
    if (a === null)
      return !1;
    for (var f = 0; f < a.length && f < s.length; f++)
      if (!io(s[f], a[f]))
        return !1;
    return !0;
  }
  function yh(s, a, f, h, S, _) {
    if (Ui = _, Xt = a, a.memoizedState = null, a.updateQueue = null, a.lanes = 0, Nd.current = s === null || s.memoizedState === null ? C_ : E_, s = f(h, S), gc) {
      _ = 0;
      do {
        if (gc = !1, hc = 0, 25 <= _)
          throw Error(n(301));
        _ += 1, Sn = pn = null, a.updateQueue = null, Nd.current = P_, s = f(h, S);
      } while (gc);
    }
    if (Nd.current = Vd, a = pn !== null && pn.next !== null, Ui = 0, Sn = pn = Xt = null, $d = !1, a)
      throw Error(n(300));
    return s;
  }
  function bh() {
    var s = hc !== 0;
    return hc = 0, s;
  }
  function Mo() {
    var s = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Sn === null ? Xt.memoizedState = Sn = s : Sn = Sn.next = s, Sn;
  }
  function Hr() {
    if (pn === null) {
      var s = Xt.alternate;
      s = s !== null ? s.memoizedState : null;
    } else
      s = pn.next;
    var a = Sn === null ? Xt.memoizedState : Sn.next;
    if (a !== null)
      Sn = a, pn = s;
    else {
      if (s === null)
        throw Error(n(310));
      pn = s, s = { memoizedState: pn.memoizedState, baseState: pn.baseState, baseQueue: pn.baseQueue, queue: pn.queue, next: null }, Sn === null ? Xt.memoizedState = Sn = s : Sn = Sn.next = s;
    }
    return Sn;
  }
  function mc(s, a) {
    return typeof a == "function" ? a(s) : a;
  }
  function xh(s) {
    var a = Hr(), f = a.queue;
    if (f === null)
      throw Error(n(311));
    f.lastRenderedReducer = s;
    var h = pn, S = h.baseQueue, _ = f.pending;
    if (_ !== null) {
      if (S !== null) {
        var M = S.next;
        S.next = _.next, _.next = M;
      }
      h.baseQueue = S = _, f.pending = null;
    }
    if (S !== null) {
      _ = S.next, h = h.baseState;
      var U = M = null, X = null, ue = _;
      do {
        var Se = ue.lane;
        if ((Ui & Se) === Se)
          X !== null && (X = X.next = { lane: 0, action: ue.action, hasEagerState: ue.hasEagerState, eagerState: ue.eagerState, next: null }), h = ue.hasEagerState ? ue.eagerState : s(h, ue.action);
        else {
          var Ce = {
            lane: Se,
            action: ue.action,
            hasEagerState: ue.hasEagerState,
            eagerState: ue.eagerState,
            next: null
          };
          X === null ? (U = X = Ce, M = h) : X = X.next = Ce, Xt.lanes |= Se, Wi |= Se;
        }
        ue = ue.next;
      } while (ue !== null && ue !== _);
      X === null ? M = h : X.next = U, io(h, a.memoizedState) || (nr = !0), a.memoizedState = h, a.baseState = M, a.baseQueue = X, f.lastRenderedState = h;
    }
    if (s = f.interleaved, s !== null) {
      S = s;
      do
        _ = S.lane, Xt.lanes |= _, Wi |= _, S = S.next;
      while (S !== s);
    } else
      S === null && (f.lanes = 0);
    return [a.memoizedState, f.dispatch];
  }
  function wh(s) {
    var a = Hr(), f = a.queue;
    if (f === null)
      throw Error(n(311));
    f.lastRenderedReducer = s;
    var h = f.dispatch, S = f.pending, _ = a.memoizedState;
    if (S !== null) {
      f.pending = null;
      var M = S = S.next;
      do
        _ = s(_, M.action), M = M.next;
      while (M !== S);
      io(_, a.memoizedState) || (nr = !0), a.memoizedState = _, a.baseQueue === null && (a.baseState = _), f.lastRenderedState = _;
    }
    return [_, h];
  }
  function Eb() {
  }
  function Pb(s, a) {
    var f = Xt, h = Hr(), S = a(), _ = !io(h.memoizedState, S);
    if (_ && (h.memoizedState = S, nr = !0), h = h.queue, Sh(Tb.bind(null, f, h, s), [s]), h.getSnapshot !== a || _ || Sn !== null && Sn.memoizedState.tag & 1) {
      if (f.flags |= 2048, vc(9, kb.bind(null, f, h, S, a), void 0, null), jn === null)
        throw Error(n(349));
      Ui & 30 || _b(f, a, S);
    }
    return S;
  }
  function _b(s, a, f) {
    s.flags |= 16384, s = { getSnapshot: a, value: f }, a = Xt.updateQueue, a === null ? (a = { lastEffect: null, stores: null }, Xt.updateQueue = a, a.stores = [s]) : (f = a.stores, f === null ? a.stores = [s] : f.push(s));
  }
  function kb(s, a, f, h) {
    a.value = f, a.getSnapshot = h, Ob(a) && Lb(s);
  }
  function Tb(s, a, f) {
    return f(function() {
      Ob(a) && Lb(s);
    });
  }
  function Ob(s) {
    var a = s.getSnapshot;
    s = s.value;
    try {
      var f = a();
      return !io(s, f);
    } catch {
      return !0;
    }
  }
  function Lb(s) {
    var a = gs(s, 1);
    a !== null && fo(a, s, 1, -1);
  }
  function Mb(s) {
    var a = Mo();
    return typeof s == "function" && (s = s()), a.memoizedState = a.baseState = s, s = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: mc, lastRenderedState: s }, a.queue = s, s = s.dispatch = j_.bind(null, Xt, s), [a.memoizedState, s];
  }
  function vc(s, a, f, h) {
    return s = { tag: s, create: a, destroy: f, deps: h, next: null }, a = Xt.updateQueue, a === null ? (a = { lastEffect: null, stores: null }, Xt.updateQueue = a, a.lastEffect = s.next = s) : (f = a.lastEffect, f === null ? a.lastEffect = s.next = s : (h = f.next, f.next = s, s.next = h, a.lastEffect = s)), s;
  }
  function Ab() {
    return Hr().memoizedState;
  }
  function Dd(s, a, f, h) {
    var S = Mo();
    Xt.flags |= s, S.memoizedState = vc(1 | a, f, void 0, h === void 0 ? null : h);
  }
  function Id(s, a, f, h) {
    var S = Hr();
    h = h === void 0 ? null : h;
    var _ = void 0;
    if (pn !== null) {
      var M = pn.memoizedState;
      if (_ = M.destroy, h !== null && vh(h, M.deps)) {
        S.memoizedState = vc(a, f, _, h);
        return;
      }
    }
    Xt.flags |= s, S.memoizedState = vc(1 | a, f, _, h);
  }
  function Rb(s, a) {
    return Dd(8390656, 8, s, a);
  }
  function Sh(s, a) {
    return Id(2048, 8, s, a);
  }
  function Nb(s, a) {
    return Id(4, 2, s, a);
  }
  function $b(s, a) {
    return Id(4, 4, s, a);
  }
  function Db(s, a) {
    if (typeof a == "function")
      return s = s(), a(s), function() {
        a(null);
      };
    if (a != null)
      return s = s(), a.current = s, function() {
        a.current = null;
      };
  }
  function Ib(s, a, f) {
    return f = f != null ? f.concat([s]) : null, Id(4, 4, Db.bind(null, a, s), f);
  }
  function jh() {
  }
  function Vb(s, a) {
    var f = Hr();
    a = a === void 0 ? null : a;
    var h = f.memoizedState;
    return h !== null && a !== null && vh(a, h[1]) ? h[0] : (f.memoizedState = [s, a], s);
  }
  function Hb(s, a) {
    var f = Hr();
    a = a === void 0 ? null : a;
    var h = f.memoizedState;
    return h !== null && a !== null && vh(a, h[1]) ? h[0] : (s = s(), f.memoizedState = [s, a], s);
  }
  function Fb(s, a, f) {
    return Ui & 21 ? (io(f, a) || (f = vy(), Xt.lanes |= f, Wi |= f, s.baseState = !0), a) : (s.baseState && (s.baseState = !1, nr = !0), s.memoizedState = f);
  }
  function w_(s, a) {
    var f = Pt;
    Pt = f !== 0 && 4 > f ? f : 4, s(!0);
    var h = mh.transition;
    mh.transition = {};
    try {
      s(!1), a();
    } finally {
      Pt = f, mh.transition = h;
    }
  }
  function zb() {
    return Hr().memoizedState;
  }
  function S_(s, a, f) {
    var h = Qs(s);
    if (f = { lane: h, action: f, hasEagerState: !1, eagerState: null, next: null }, Bb(s))
      Ub(a, f);
    else if (f = xb(s, a, f, h), f !== null) {
      var S = Wn();
      fo(f, s, h, S), Wb(f, a, h);
    }
  }
  function j_(s, a, f) {
    var h = Qs(s), S = { lane: h, action: f, hasEagerState: !1, eagerState: null, next: null };
    if (Bb(s))
      Ub(a, S);
    else {
      var _ = s.alternate;
      if (s.lanes === 0 && (_ === null || _.lanes === 0) && (_ = a.lastRenderedReducer, _ !== null))
        try {
          var M = a.lastRenderedState, U = _(M, f);
          if (S.hasEagerState = !0, S.eagerState = U, io(U, M)) {
            var X = a.interleaved;
            X === null ? (S.next = S, uh(a)) : (S.next = X.next, X.next = S), a.interleaved = S;
            return;
          }
        } catch {
        } finally {
        }
      f = xb(s, a, S, h), f !== null && (S = Wn(), fo(f, s, h, S), Wb(f, a, h));
    }
  }
  function Bb(s) {
    var a = s.alternate;
    return s === Xt || a !== null && a === Xt;
  }
  function Ub(s, a) {
    gc = $d = !0;
    var f = s.pending;
    f === null ? a.next = a : (a.next = f.next, f.next = a), s.pending = a;
  }
  function Wb(s, a, f) {
    if (f & 4194240) {
      var h = a.lanes;
      h &= s.pendingLanes, f |= h, a.lanes = f, Eg(s, f);
    }
  }
  var Vd = { readContext: Vr, useCallback: In, useContext: In, useEffect: In, useImperativeHandle: In, useInsertionEffect: In, useLayoutEffect: In, useMemo: In, useReducer: In, useRef: In, useState: In, useDebugValue: In, useDeferredValue: In, useTransition: In, useMutableSource: In, useSyncExternalStore: In, useId: In, unstable_isNewReconciler: !1 }, C_ = { readContext: Vr, useCallback: function(s, a) {
    return Mo().memoizedState = [s, a === void 0 ? null : a], s;
  }, useContext: Vr, useEffect: Rb, useImperativeHandle: function(s, a, f) {
    return f = f != null ? f.concat([s]) : null, Dd(
      4194308,
      4,
      Db.bind(null, a, s),
      f
    );
  }, useLayoutEffect: function(s, a) {
    return Dd(4194308, 4, s, a);
  }, useInsertionEffect: function(s, a) {
    return Dd(4, 2, s, a);
  }, useMemo: function(s, a) {
    var f = Mo();
    return a = a === void 0 ? null : a, s = s(), f.memoizedState = [s, a], s;
  }, useReducer: function(s, a, f) {
    var h = Mo();
    return a = f !== void 0 ? f(a) : a, h.memoizedState = h.baseState = a, s = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: s, lastRenderedState: a }, h.queue = s, s = s.dispatch = S_.bind(null, Xt, s), [h.memoizedState, s];
  }, useRef: function(s) {
    var a = Mo();
    return s = { current: s }, a.memoizedState = s;
  }, useState: Mb, useDebugValue: jh, useDeferredValue: function(s) {
    return Mo().memoizedState = s;
  }, useTransition: function() {
    var s = Mb(!1), a = s[0];
    return s = w_.bind(null, s[1]), Mo().memoizedState = s, [a, s];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(s, a, f) {
    var h = Xt, S = Mo();
    if (Kt) {
      if (f === void 0)
        throw Error(n(407));
      f = f();
    } else {
      if (f = a(), jn === null)
        throw Error(n(349));
      Ui & 30 || _b(h, a, f);
    }
    S.memoizedState = f;
    var _ = { value: f, getSnapshot: a };
    return S.queue = _, Rb(Tb.bind(
      null,
      h,
      _,
      s
    ), [s]), h.flags |= 2048, vc(9, kb.bind(null, h, _, f, a), void 0, null), f;
  }, useId: function() {
    var s = Mo(), a = jn.identifierPrefix;
    if (Kt) {
      var f = ps, h = fs;
      f = (h & ~(1 << 32 - so(h) - 1)).toString(32) + f, a = ":" + a + "R" + f, f = hc++, 0 < f && (a += "H" + f.toString(32)), a += ":";
    } else
      f = x_++, a = ":" + a + "r" + f.toString(32) + ":";
    return s.memoizedState = a;
  }, unstable_isNewReconciler: !1 }, E_ = {
    readContext: Vr,
    useCallback: Vb,
    useContext: Vr,
    useEffect: Sh,
    useImperativeHandle: Ib,
    useInsertionEffect: Nb,
    useLayoutEffect: $b,
    useMemo: Hb,
    useReducer: xh,
    useRef: Ab,
    useState: function() {
      return xh(mc);
    },
    useDebugValue: jh,
    useDeferredValue: function(s) {
      var a = Hr();
      return Fb(a, pn.memoizedState, s);
    },
    useTransition: function() {
      var s = xh(mc)[0], a = Hr().memoizedState;
      return [s, a];
    },
    useMutableSource: Eb,
    useSyncExternalStore: Pb,
    useId: zb,
    unstable_isNewReconciler: !1
  }, P_ = { readContext: Vr, useCallback: Vb, useContext: Vr, useEffect: Sh, useImperativeHandle: Ib, useInsertionEffect: Nb, useLayoutEffect: $b, useMemo: Hb, useReducer: wh, useRef: Ab, useState: function() {
    return wh(mc);
  }, useDebugValue: jh, useDeferredValue: function(s) {
    var a = Hr();
    return pn === null ? a.memoizedState = s : Fb(a, pn.memoizedState, s);
  }, useTransition: function() {
    var s = wh(mc)[0], a = Hr().memoizedState;
    return [s, a];
  }, useMutableSource: Eb, useSyncExternalStore: Pb, useId: zb, unstable_isNewReconciler: !1 };
  function lo(s, a) {
    if (s && s.defaultProps) {
      a = V({}, a), s = s.defaultProps;
      for (var f in s)
        a[f] === void 0 && (a[f] = s[f]);
      return a;
    }
    return a;
  }
  function Ch(s, a, f, h) {
    a = s.memoizedState, f = f(h, a), f = f == null ? a : V({}, a, f), s.memoizedState = f, s.lanes === 0 && (s.updateQueue.baseState = f);
  }
  var Hd = { isMounted: function(s) {
    return (s = s._reactInternals) ? Di(s) === s : !1;
  }, enqueueSetState: function(s, a, f) {
    s = s._reactInternals;
    var h = Wn(), S = Qs(s), _ = hs(h, S);
    _.payload = a, f != null && (_.callback = f), a = Ys(s, _, S), a !== null && (fo(a, s, S, h), Md(a, s, S));
  }, enqueueReplaceState: function(s, a, f) {
    s = s._reactInternals;
    var h = Wn(), S = Qs(s), _ = hs(h, S);
    _.tag = 1, _.payload = a, f != null && (_.callback = f), a = Ys(s, _, S), a !== null && (fo(a, s, S, h), Md(a, s, S));
  }, enqueueForceUpdate: function(s, a) {
    s = s._reactInternals;
    var f = Wn(), h = Qs(s), S = hs(f, h);
    S.tag = 2, a != null && (S.callback = a), a = Ys(s, S, h), a !== null && (fo(a, s, h, f), Md(a, s, h));
  } };
  function Gb(s, a, f, h, S, _, M) {
    return s = s.stateNode, typeof s.shouldComponentUpdate == "function" ? s.shouldComponentUpdate(h, _, M) : a.prototype && a.prototype.isPureReactComponent ? !rc(f, h) || !rc(S, _) : !0;
  }
  function Kb(s, a, f) {
    var h = !1, S = Gs, _ = a.contextType;
    return typeof _ == "object" && _ !== null ? _ = Vr(_) : (S = tr(a) ? Vi : Dn.current, h = a.contextTypes, _ = (h = h != null) ? Ra(s, S) : Gs), a = new a(f, _), s.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Hd, s.stateNode = a, a._reactInternals = s, h && (s = s.stateNode, s.__reactInternalMemoizedUnmaskedChildContext = S, s.__reactInternalMemoizedMaskedChildContext = _), a;
  }
  function qb(s, a, f, h) {
    s = a.state, typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(f, h), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(f, h), a.state !== s && Hd.enqueueReplaceState(a, a.state, null);
  }
  function Eh(s, a, f, h) {
    var S = s.stateNode;
    S.props = f, S.state = s.memoizedState, S.refs = {}, dh(s);
    var _ = a.contextType;
    typeof _ == "object" && _ !== null ? S.context = Vr(_) : (_ = tr(a) ? Vi : Dn.current, S.context = Ra(s, _)), S.state = s.memoizedState, _ = a.getDerivedStateFromProps, typeof _ == "function" && (Ch(s, a, _, f), S.state = s.memoizedState), typeof a.getDerivedStateFromProps == "function" || typeof S.getSnapshotBeforeUpdate == "function" || typeof S.UNSAFE_componentWillMount != "function" && typeof S.componentWillMount != "function" || (a = S.state, typeof S.componentWillMount == "function" && S.componentWillMount(), typeof S.UNSAFE_componentWillMount == "function" && S.UNSAFE_componentWillMount(), a !== S.state && Hd.enqueueReplaceState(S, S.state, null), Ad(s, f, S, h), S.state = s.memoizedState), typeof S.componentDidMount == "function" && (s.flags |= 4194308);
  }
  function za(s, a) {
    try {
      var f = "", h = a;
      do
        f += le(h), h = h.return;
      while (h);
      var S = f;
    } catch (_) {
      S = `
Error generating stack: ` + _.message + `
` + _.stack;
    }
    return { value: s, source: a, stack: S, digest: null };
  }
  function Ph(s, a, f) {
    return { value: s, source: null, stack: f ?? null, digest: a ?? null };
  }
  function _h(s, a) {
    try {
      console.error(a.value);
    } catch (f) {
      setTimeout(function() {
        throw f;
      });
    }
  }
  var __ = typeof WeakMap == "function" ? WeakMap : Map;
  function Yb(s, a, f) {
    f = hs(-1, f), f.tag = 3, f.payload = { element: null };
    var h = a.value;
    return f.callback = function() {
      Kd || (Kd = !0, zh = h), _h(s, a);
    }, f;
  }
  function Xb(s, a, f) {
    f = hs(-1, f), f.tag = 3;
    var h = s.type.getDerivedStateFromError;
    if (typeof h == "function") {
      var S = a.value;
      f.payload = function() {
        return h(S);
      }, f.callback = function() {
        _h(s, a);
      };
    }
    var _ = s.stateNode;
    return _ !== null && typeof _.componentDidCatch == "function" && (f.callback = function() {
      _h(s, a), typeof h != "function" && (Zs === null ? Zs = /* @__PURE__ */ new Set([this]) : Zs.add(this));
      var M = a.stack;
      this.componentDidCatch(a.value, { componentStack: M !== null ? M : "" });
    }), f;
  }
  function Zb(s, a, f) {
    var h = s.pingCache;
    if (h === null) {
      h = s.pingCache = new __();
      var S = /* @__PURE__ */ new Set();
      h.set(a, S);
    } else
      S = h.get(a), S === void 0 && (S = /* @__PURE__ */ new Set(), h.set(a, S));
    S.has(f) || (S.add(f), s = F_.bind(null, s, a, f), a.then(s, s));
  }
  function Jb(s) {
    do {
      var a;
      if ((a = s.tag === 13) && (a = s.memoizedState, a = a !== null ? a.dehydrated !== null : !0), a)
        return s;
      s = s.return;
    } while (s !== null);
    return null;
  }
  function Qb(s, a, f, h, S) {
    return s.mode & 1 ? (s.flags |= 65536, s.lanes = S, s) : (s === a ? s.flags |= 65536 : (s.flags |= 128, f.flags |= 131072, f.flags &= -52805, f.tag === 1 && (f.alternate === null ? f.tag = 17 : (a = hs(-1, 1), a.tag = 2, Ys(f, a, 1))), f.lanes |= 1), s);
  }
  var k_ = k.ReactCurrentOwner, nr = !1;
  function Un(s, a, f, h) {
    a.child = s === null ? bb(a, null, f, h) : Ia(a, s.child, f, h);
  }
  function ex(s, a, f, h, S) {
    f = f.render;
    var _ = a.ref;
    return Ha(a, S), h = yh(s, a, f, h, _, S), f = bh(), s !== null && !nr ? (a.updateQueue = s.updateQueue, a.flags &= -2053, s.lanes &= ~S, ms(s, a, S)) : (Kt && f && th(a), a.flags |= 1, Un(s, a, h, S), a.child);
  }
  function tx(s, a, f, h, S) {
    if (s === null) {
      var _ = f.type;
      return typeof _ == "function" && !Yh(_) && _.defaultProps === void 0 && f.compare === null && f.defaultProps === void 0 ? (a.tag = 15, a.type = _, nx(s, a, _, h, S)) : (s = Qd(f.type, null, h, a, a.mode, S), s.ref = a.ref, s.return = a, a.child = s);
    }
    if (_ = s.child, !(s.lanes & S)) {
      var M = _.memoizedProps;
      if (f = f.compare, f = f !== null ? f : rc, f(M, h) && s.ref === a.ref)
        return ms(s, a, S);
    }
    return a.flags |= 1, s = ti(_, h), s.ref = a.ref, s.return = a, a.child = s;
  }
  function nx(s, a, f, h, S) {
    if (s !== null) {
      var _ = s.memoizedProps;
      if (rc(_, h) && s.ref === a.ref)
        if (nr = !1, a.pendingProps = h = _, (s.lanes & S) !== 0)
          s.flags & 131072 && (nr = !0);
        else
          return a.lanes = s.lanes, ms(s, a, S);
    }
    return kh(s, a, f, h, S);
  }
  function rx(s, a, f) {
    var h = a.pendingProps, S = h.children, _ = s !== null ? s.memoizedState : null;
    if (h.mode === "hidden")
      if (!(a.mode & 1))
        a.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, Vt(Ua, br), br |= f;
      else {
        if (!(f & 1073741824))
          return s = _ !== null ? _.baseLanes | f : f, a.lanes = a.childLanes = 1073741824, a.memoizedState = { baseLanes: s, cachePool: null, transitions: null }, a.updateQueue = null, Vt(Ua, br), br |= s, null;
        a.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, h = _ !== null ? _.baseLanes : f, Vt(Ua, br), br |= h;
      }
    else
      _ !== null ? (h = _.baseLanes | f, a.memoizedState = null) : h = f, Vt(Ua, br), br |= h;
    return Un(s, a, S, f), a.child;
  }
  function ox(s, a) {
    var f = a.ref;
    (s === null && f !== null || s !== null && s.ref !== f) && (a.flags |= 512, a.flags |= 2097152);
  }
  function kh(s, a, f, h, S) {
    var _ = tr(f) ? Vi : Dn.current;
    return _ = Ra(a, _), Ha(a, S), f = yh(s, a, f, h, _, S), h = bh(), s !== null && !nr ? (a.updateQueue = s.updateQueue, a.flags &= -2053, s.lanes &= ~S, ms(s, a, S)) : (Kt && h && th(a), a.flags |= 1, Un(s, a, f, S), a.child);
  }
  function sx(s, a, f, h, S) {
    if (tr(f)) {
      var _ = !0;
      Cd(a);
    } else
      _ = !1;
    if (Ha(a, S), a.stateNode === null)
      zd(s, a), Kb(a, f, h), Eh(a, f, h, S), h = !0;
    else if (s === null) {
      var M = a.stateNode, U = a.memoizedProps;
      M.props = U;
      var X = M.context, ue = f.contextType;
      typeof ue == "object" && ue !== null ? ue = Vr(ue) : (ue = tr(f) ? Vi : Dn.current, ue = Ra(a, ue));
      var Se = f.getDerivedStateFromProps, Ce = typeof Se == "function" || typeof M.getSnapshotBeforeUpdate == "function";
      Ce || typeof M.UNSAFE_componentWillReceiveProps != "function" && typeof M.componentWillReceiveProps != "function" || (U !== h || X !== ue) && qb(a, M, h, ue), qs = !1;
      var be = a.memoizedState;
      M.state = be, Ad(a, h, M, S), X = a.memoizedState, U !== h || be !== X || er.current || qs ? (typeof Se == "function" && (Ch(a, f, Se, h), X = a.memoizedState), (U = qs || Gb(a, f, U, h, be, X, ue)) ? (Ce || typeof M.UNSAFE_componentWillMount != "function" && typeof M.componentWillMount != "function" || (typeof M.componentWillMount == "function" && M.componentWillMount(), typeof M.UNSAFE_componentWillMount == "function" && M.UNSAFE_componentWillMount()), typeof M.componentDidMount == "function" && (a.flags |= 4194308)) : (typeof M.componentDidMount == "function" && (a.flags |= 4194308), a.memoizedProps = h, a.memoizedState = X), M.props = h, M.state = X, M.context = ue, h = U) : (typeof M.componentDidMount == "function" && (a.flags |= 4194308), h = !1);
    } else {
      M = a.stateNode, wb(s, a), U = a.memoizedProps, ue = a.type === a.elementType ? U : lo(a.type, U), M.props = ue, Ce = a.pendingProps, be = M.context, X = f.contextType, typeof X == "object" && X !== null ? X = Vr(X) : (X = tr(f) ? Vi : Dn.current, X = Ra(a, X));
      var Me = f.getDerivedStateFromProps;
      (Se = typeof Me == "function" || typeof M.getSnapshotBeforeUpdate == "function") || typeof M.UNSAFE_componentWillReceiveProps != "function" && typeof M.componentWillReceiveProps != "function" || (U !== Ce || be !== X) && qb(a, M, h, X), qs = !1, be = a.memoizedState, M.state = be, Ad(a, h, M, S);
      var Ne = a.memoizedState;
      U !== Ce || be !== Ne || er.current || qs ? (typeof Me == "function" && (Ch(a, f, Me, h), Ne = a.memoizedState), (ue = qs || Gb(a, f, ue, h, be, Ne, X) || !1) ? (Se || typeof M.UNSAFE_componentWillUpdate != "function" && typeof M.componentWillUpdate != "function" || (typeof M.componentWillUpdate == "function" && M.componentWillUpdate(h, Ne, X), typeof M.UNSAFE_componentWillUpdate == "function" && M.UNSAFE_componentWillUpdate(h, Ne, X)), typeof M.componentDidUpdate == "function" && (a.flags |= 4), typeof M.getSnapshotBeforeUpdate == "function" && (a.flags |= 1024)) : (typeof M.componentDidUpdate != "function" || U === s.memoizedProps && be === s.memoizedState || (a.flags |= 4), typeof M.getSnapshotBeforeUpdate != "function" || U === s.memoizedProps && be === s.memoizedState || (a.flags |= 1024), a.memoizedProps = h, a.memoizedState = Ne), M.props = h, M.state = Ne, M.context = X, h = ue) : (typeof M.componentDidUpdate != "function" || U === s.memoizedProps && be === s.memoizedState || (a.flags |= 4), typeof M.getSnapshotBeforeUpdate != "function" || U === s.memoizedProps && be === s.memoizedState || (a.flags |= 1024), h = !1);
    }
    return Th(s, a, f, h, _, S);
  }
  function Th(s, a, f, h, S, _) {
    ox(s, a);
    var M = (a.flags & 128) !== 0;
    if (!h && !M)
      return S && ub(a, f, !1), ms(s, a, _);
    h = a.stateNode, k_.current = a;
    var U = M && typeof f.getDerivedStateFromError != "function" ? null : h.render();
    return a.flags |= 1, s !== null && M ? (a.child = Ia(a, s.child, null, _), a.child = Ia(a, null, U, _)) : Un(s, a, U, _), a.memoizedState = h.state, S && ub(a, f, !0), a.child;
  }
  function ix(s) {
    var a = s.stateNode;
    a.pendingContext ? lb(s, a.pendingContext, a.pendingContext !== a.context) : a.context && lb(s, a.context, !1), fh(s, a.containerInfo);
  }
  function ax(s, a, f, h, S) {
    return Da(), sh(S), a.flags |= 256, Un(s, a, f, h), a.child;
  }
  var Oh = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Lh(s) {
    return { baseLanes: s, cachePool: null, transitions: null };
  }
  function lx(s, a, f) {
    var h = a.pendingProps, S = Yt.current, _ = !1, M = (a.flags & 128) !== 0, U;
    if ((U = M) || (U = s !== null && s.memoizedState === null ? !1 : (S & 2) !== 0), U ? (_ = !0, a.flags &= -129) : (s === null || s.memoizedState !== null) && (S |= 1), Vt(Yt, S & 1), s === null)
      return oh(a), s = a.memoizedState, s !== null && (s = s.dehydrated, s !== null) ? (a.mode & 1 ? s.data === "$!" ? a.lanes = 8 : a.lanes = 1073741824 : a.lanes = 1, null) : (M = h.children, s = h.fallback, _ ? (h = a.mode, _ = a.child, M = { mode: "hidden", children: M }, !(h & 1) && _ !== null ? (_.childLanes = 0, _.pendingProps = M) : _ = ef(M, h, 0, null), s = Yi(s, h, f, null), _.return = a, s.return = a, _.sibling = s, a.child = _, a.child.memoizedState = Lh(f), a.memoizedState = Oh, s) : Mh(a, M));
    if (S = s.memoizedState, S !== null && (U = S.dehydrated, U !== null))
      return T_(s, a, M, h, U, S, f);
    if (_) {
      _ = h.fallback, M = a.mode, S = s.child, U = S.sibling;
      var X = { mode: "hidden", children: h.children };
      return !(M & 1) && a.child !== S ? (h = a.child, h.childLanes = 0, h.pendingProps = X, a.deletions = null) : (h = ti(S, X), h.subtreeFlags = S.subtreeFlags & 14680064), U !== null ? _ = ti(U, _) : (_ = Yi(_, M, f, null), _.flags |= 2), _.return = a, h.return = a, h.sibling = _, a.child = h, h = _, _ = a.child, M = s.child.memoizedState, M = M === null ? Lh(f) : { baseLanes: M.baseLanes | f, cachePool: null, transitions: M.transitions }, _.memoizedState = M, _.childLanes = s.childLanes & ~f, a.memoizedState = Oh, h;
    }
    return _ = s.child, s = _.sibling, h = ti(_, { mode: "visible", children: h.children }), !(a.mode & 1) && (h.lanes = f), h.return = a, h.sibling = null, s !== null && (f = a.deletions, f === null ? (a.deletions = [s], a.flags |= 16) : f.push(s)), a.child = h, a.memoizedState = null, h;
  }
  function Mh(s, a) {
    return a = ef({ mode: "visible", children: a }, s.mode, 0, null), a.return = s, s.child = a;
  }
  function Fd(s, a, f, h) {
    return h !== null && sh(h), Ia(a, s.child, null, f), s = Mh(a, a.pendingProps.children), s.flags |= 2, a.memoizedState = null, s;
  }
  function T_(s, a, f, h, S, _, M) {
    if (f)
      return a.flags & 256 ? (a.flags &= -257, h = Ph(Error(n(422))), Fd(s, a, M, h)) : a.memoizedState !== null ? (a.child = s.child, a.flags |= 128, null) : (_ = h.fallback, S = a.mode, h = ef({ mode: "visible", children: h.children }, S, 0, null), _ = Yi(_, S, M, null), _.flags |= 2, h.return = a, _.return = a, h.sibling = _, a.child = h, a.mode & 1 && Ia(a, s.child, null, M), a.child.memoizedState = Lh(M), a.memoizedState = Oh, _);
    if (!(a.mode & 1))
      return Fd(s, a, M, null);
    if (S.data === "$!") {
      if (h = S.nextSibling && S.nextSibling.dataset, h)
        var U = h.dgst;
      return h = U, _ = Error(n(419)), h = Ph(_, h, void 0), Fd(s, a, M, h);
    }
    if (U = (M & s.childLanes) !== 0, nr || U) {
      if (h = jn, h !== null) {
        switch (M & -M) {
          case 4:
            S = 2;
            break;
          case 16:
            S = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            S = 32;
            break;
          case 536870912:
            S = 268435456;
            break;
          default:
            S = 0;
        }
        S = S & (h.suspendedLanes | M) ? 0 : S, S !== 0 && S !== _.retryLane && (_.retryLane = S, gs(s, S), fo(h, s, S, -1));
      }
      return qh(), h = Ph(Error(n(421))), Fd(s, a, M, h);
    }
    return S.data === "$?" ? (a.flags |= 128, a.child = s.child, a = z_.bind(null, s), S._reactRetry = a, null) : (s = _.treeContext, yr = Us(S.nextSibling), vr = a, Kt = !0, ao = null, s !== null && (Dr[Ir++] = fs, Dr[Ir++] = ps, Dr[Ir++] = Hi, fs = s.id, ps = s.overflow, Hi = a), a = Mh(a, h.children), a.flags |= 4096, a);
  }
  function cx(s, a, f) {
    s.lanes |= a;
    var h = s.alternate;
    h !== null && (h.lanes |= a), ch(s.return, a, f);
  }
  function Ah(s, a, f, h, S) {
    var _ = s.memoizedState;
    _ === null ? s.memoizedState = { isBackwards: a, rendering: null, renderingStartTime: 0, last: h, tail: f, tailMode: S } : (_.isBackwards = a, _.rendering = null, _.renderingStartTime = 0, _.last = h, _.tail = f, _.tailMode = S);
  }
  function ux(s, a, f) {
    var h = a.pendingProps, S = h.revealOrder, _ = h.tail;
    if (Un(s, a, h.children, f), h = Yt.current, h & 2)
      h = h & 1 | 2, a.flags |= 128;
    else {
      if (s !== null && s.flags & 128)
        e:
          for (s = a.child; s !== null; ) {
            if (s.tag === 13)
              s.memoizedState !== null && cx(s, f, a);
            else if (s.tag === 19)
              cx(s, f, a);
            else if (s.child !== null) {
              s.child.return = s, s = s.child;
              continue;
            }
            if (s === a)
              break e;
            for (; s.sibling === null; ) {
              if (s.return === null || s.return === a)
                break e;
              s = s.return;
            }
            s.sibling.return = s.return, s = s.sibling;
          }
      h &= 1;
    }
    if (Vt(Yt, h), !(a.mode & 1))
      a.memoizedState = null;
    else
      switch (S) {
        case "forwards":
          for (f = a.child, S = null; f !== null; )
            s = f.alternate, s !== null && Rd(s) === null && (S = f), f = f.sibling;
          f = S, f === null ? (S = a.child, a.child = null) : (S = f.sibling, f.sibling = null), Ah(a, !1, S, f, _);
          break;
        case "backwards":
          for (f = null, S = a.child, a.child = null; S !== null; ) {
            if (s = S.alternate, s !== null && Rd(s) === null) {
              a.child = S;
              break;
            }
            s = S.sibling, S.sibling = f, f = S, S = s;
          }
          Ah(a, !0, f, null, _);
          break;
        case "together":
          Ah(a, !1, null, null, void 0);
          break;
        default:
          a.memoizedState = null;
      }
    return a.child;
  }
  function zd(s, a) {
    !(a.mode & 1) && s !== null && (s.alternate = null, a.alternate = null, a.flags |= 2);
  }
  function ms(s, a, f) {
    if (s !== null && (a.dependencies = s.dependencies), Wi |= a.lanes, !(f & a.childLanes))
      return null;
    if (s !== null && a.child !== s.child)
      throw Error(n(153));
    if (a.child !== null) {
      for (s = a.child, f = ti(s, s.pendingProps), a.child = f, f.return = a; s.sibling !== null; )
        s = s.sibling, f = f.sibling = ti(s, s.pendingProps), f.return = a;
      f.sibling = null;
    }
    return a.child;
  }
  function O_(s, a, f) {
    switch (a.tag) {
      case 3:
        ix(a), Da();
        break;
      case 5:
        Cb(a);
        break;
      case 1:
        tr(a.type) && Cd(a);
        break;
      case 4:
        fh(a, a.stateNode.containerInfo);
        break;
      case 10:
        var h = a.type._context, S = a.memoizedProps.value;
        Vt(Od, h._currentValue), h._currentValue = S;
        break;
      case 13:
        if (h = a.memoizedState, h !== null)
          return h.dehydrated !== null ? (Vt(Yt, Yt.current & 1), a.flags |= 128, null) : f & a.child.childLanes ? lx(s, a, f) : (Vt(Yt, Yt.current & 1), s = ms(s, a, f), s !== null ? s.sibling : null);
        Vt(Yt, Yt.current & 1);
        break;
      case 19:
        if (h = (f & a.childLanes) !== 0, s.flags & 128) {
          if (h)
            return ux(s, a, f);
          a.flags |= 128;
        }
        if (S = a.memoizedState, S !== null && (S.rendering = null, S.tail = null, S.lastEffect = null), Vt(Yt, Yt.current), h)
          break;
        return null;
      case 22:
      case 23:
        return a.lanes = 0, rx(s, a, f);
    }
    return ms(s, a, f);
  }
  var dx, Rh, fx, px;
  dx = function(s, a) {
    for (var f = a.child; f !== null; ) {
      if (f.tag === 5 || f.tag === 6)
        s.appendChild(f.stateNode);
      else if (f.tag !== 4 && f.child !== null) {
        f.child.return = f, f = f.child;
        continue;
      }
      if (f === a)
        break;
      for (; f.sibling === null; ) {
        if (f.return === null || f.return === a)
          return;
        f = f.return;
      }
      f.sibling.return = f.return, f = f.sibling;
    }
  }, Rh = function() {
  }, fx = function(s, a, f, h) {
    var S = s.memoizedProps;
    if (S !== h) {
      s = a.stateNode, Bi(Lo.current);
      var _ = null;
      switch (f) {
        case "input":
          S = ot(s, S), h = ot(s, h), _ = [];
          break;
        case "select":
          S = V({}, S, { value: void 0 }), h = V({}, h, { value: void 0 }), _ = [];
          break;
        case "textarea":
          S = en(s, S), h = en(s, h), _ = [];
          break;
        default:
          typeof S.onClick != "function" && typeof h.onClick == "function" && (s.onclick = wd);
      }
      It(f, h);
      var M;
      f = null;
      for (ue in S)
        if (!h.hasOwnProperty(ue) && S.hasOwnProperty(ue) && S[ue] != null)
          if (ue === "style") {
            var U = S[ue];
            for (M in U)
              U.hasOwnProperty(M) && (f || (f = {}), f[M] = "");
          } else
            ue !== "dangerouslySetInnerHTML" && ue !== "children" && ue !== "suppressContentEditableWarning" && ue !== "suppressHydrationWarning" && ue !== "autoFocus" && (o.hasOwnProperty(ue) ? _ || (_ = []) : (_ = _ || []).push(ue, null));
      for (ue in h) {
        var X = h[ue];
        if (U = S != null ? S[ue] : void 0, h.hasOwnProperty(ue) && X !== U && (X != null || U != null))
          if (ue === "style")
            if (U) {
              for (M in U)
                !U.hasOwnProperty(M) || X && X.hasOwnProperty(M) || (f || (f = {}), f[M] = "");
              for (M in X)
                X.hasOwnProperty(M) && U[M] !== X[M] && (f || (f = {}), f[M] = X[M]);
            } else
              f || (_ || (_ = []), _.push(
                ue,
                f
              )), f = X;
          else
            ue === "dangerouslySetInnerHTML" ? (X = X ? X.__html : void 0, U = U ? U.__html : void 0, X != null && U !== X && (_ = _ || []).push(ue, X)) : ue === "children" ? typeof X != "string" && typeof X != "number" || (_ = _ || []).push(ue, "" + X) : ue !== "suppressContentEditableWarning" && ue !== "suppressHydrationWarning" && (o.hasOwnProperty(ue) ? (X != null && ue === "onScroll" && Wt("scroll", s), _ || U === X || (_ = [])) : (_ = _ || []).push(ue, X));
      }
      f && (_ = _ || []).push("style", f);
      var ue = _;
      (a.updateQueue = ue) && (a.flags |= 4);
    }
  }, px = function(s, a, f, h) {
    f !== h && (a.flags |= 4);
  };
  function yc(s, a) {
    if (!Kt)
      switch (s.tailMode) {
        case "hidden":
          a = s.tail;
          for (var f = null; a !== null; )
            a.alternate !== null && (f = a), a = a.sibling;
          f === null ? s.tail = null : f.sibling = null;
          break;
        case "collapsed":
          f = s.tail;
          for (var h = null; f !== null; )
            f.alternate !== null && (h = f), f = f.sibling;
          h === null ? a || s.tail === null ? s.tail = null : s.tail.sibling = null : h.sibling = null;
      }
  }
  function Vn(s) {
    var a = s.alternate !== null && s.alternate.child === s.child, f = 0, h = 0;
    if (a)
      for (var S = s.child; S !== null; )
        f |= S.lanes | S.childLanes, h |= S.subtreeFlags & 14680064, h |= S.flags & 14680064, S.return = s, S = S.sibling;
    else
      for (S = s.child; S !== null; )
        f |= S.lanes | S.childLanes, h |= S.subtreeFlags, h |= S.flags, S.return = s, S = S.sibling;
    return s.subtreeFlags |= h, s.childLanes = f, a;
  }
  function L_(s, a, f) {
    var h = a.pendingProps;
    switch (nh(a), a.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return Vn(a), null;
      case 1:
        return tr(a.type) && jd(), Vn(a), null;
      case 3:
        return h = a.stateNode, Fa(), Gt(er), Gt(Dn), hh(), h.pendingContext && (h.context = h.pendingContext, h.pendingContext = null), (s === null || s.child === null) && (kd(a) ? a.flags |= 4 : s === null || s.memoizedState.isDehydrated && !(a.flags & 256) || (a.flags |= 1024, ao !== null && (Wh(ao), ao = null))), Rh(s, a), Vn(a), null;
      case 5:
        ph(a);
        var S = Bi(pc.current);
        if (f = a.type, s !== null && a.stateNode != null)
          fx(s, a, f, h, S), s.ref !== a.ref && (a.flags |= 512, a.flags |= 2097152);
        else {
          if (!h) {
            if (a.stateNode === null)
              throw Error(n(166));
            return Vn(a), null;
          }
          if (s = Bi(Lo.current), kd(a)) {
            h = a.stateNode, f = a.type;
            var _ = a.memoizedProps;
            switch (h[Oo] = a, h[lc] = _, s = (a.mode & 1) !== 0, f) {
              case "dialog":
                Wt("cancel", h), Wt("close", h);
                break;
              case "iframe":
              case "object":
              case "embed":
                Wt("load", h);
                break;
              case "video":
              case "audio":
                for (S = 0; S < sc.length; S++)
                  Wt(sc[S], h);
                break;
              case "source":
                Wt("error", h);
                break;
              case "img":
              case "image":
              case "link":
                Wt(
                  "error",
                  h
                ), Wt("load", h);
                break;
              case "details":
                Wt("toggle", h);
                break;
              case "input":
                vt(h, _), Wt("invalid", h);
                break;
              case "select":
                h._wrapperState = { wasMultiple: !!_.multiple }, Wt("invalid", h);
                break;
              case "textarea":
                Bt(h, _), Wt("invalid", h);
            }
            It(f, _), S = null;
            for (var M in _)
              if (_.hasOwnProperty(M)) {
                var U = _[M];
                M === "children" ? typeof U == "string" ? h.textContent !== U && (_.suppressHydrationWarning !== !0 && xd(h.textContent, U, s), S = ["children", U]) : typeof U == "number" && h.textContent !== "" + U && (_.suppressHydrationWarning !== !0 && xd(
                  h.textContent,
                  U,
                  s
                ), S = ["children", "" + U]) : o.hasOwnProperty(M) && U != null && M === "onScroll" && Wt("scroll", h);
              }
            switch (f) {
              case "input":
                je(h), ct(h, _, !0);
                break;
              case "textarea":
                je(h), it(h);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof _.onClick == "function" && (h.onclick = wd);
            }
            h = S, a.updateQueue = h, h !== null && (a.flags |= 4);
          } else {
            M = S.nodeType === 9 ? S : S.ownerDocument, s === "http://www.w3.org/1999/xhtml" && (s = Lt(f)), s === "http://www.w3.org/1999/xhtml" ? f === "script" ? (s = M.createElement("div"), s.innerHTML = "<script><\/script>", s = s.removeChild(s.firstChild)) : typeof h.is == "string" ? s = M.createElement(f, { is: h.is }) : (s = M.createElement(f), f === "select" && (M = s, h.multiple ? M.multiple = !0 : h.size && (M.size = h.size))) : s = M.createElementNS(s, f), s[Oo] = a, s[lc] = h, dx(s, a, !1, !1), a.stateNode = s;
            e: {
              switch (M = Mt(f, h), f) {
                case "dialog":
                  Wt("cancel", s), Wt("close", s), S = h;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Wt("load", s), S = h;
                  break;
                case "video":
                case "audio":
                  for (S = 0; S < sc.length; S++)
                    Wt(sc[S], s);
                  S = h;
                  break;
                case "source":
                  Wt("error", s), S = h;
                  break;
                case "img":
                case "image":
                case "link":
                  Wt(
                    "error",
                    s
                  ), Wt("load", s), S = h;
                  break;
                case "details":
                  Wt("toggle", s), S = h;
                  break;
                case "input":
                  vt(s, h), S = ot(s, h), Wt("invalid", s);
                  break;
                case "option":
                  S = h;
                  break;
                case "select":
                  s._wrapperState = { wasMultiple: !!h.multiple }, S = V({}, h, { value: void 0 }), Wt("invalid", s);
                  break;
                case "textarea":
                  Bt(s, h), S = en(s, h), Wt("invalid", s);
                  break;
                default:
                  S = h;
              }
              It(f, S), U = S;
              for (_ in U)
                if (U.hasOwnProperty(_)) {
                  var X = U[_];
                  _ === "style" ? Ni(s, X) : _ === "dangerouslySetInnerHTML" ? (X = X ? X.__html : void 0, X != null && Bn(s, X)) : _ === "children" ? typeof X == "string" ? (f !== "textarea" || X !== "") && Zn(s, X) : typeof X == "number" && Zn(s, "" + X) : _ !== "suppressContentEditableWarning" && _ !== "suppressHydrationWarning" && _ !== "autoFocus" && (o.hasOwnProperty(_) ? X != null && _ === "onScroll" && Wt("scroll", s) : X != null && P(s, _, X, M));
                }
              switch (f) {
                case "input":
                  je(s), ct(s, h, !1);
                  break;
                case "textarea":
                  je(s), it(s);
                  break;
                case "option":
                  h.value != null && s.setAttribute("value", "" + se(h.value));
                  break;
                case "select":
                  s.multiple = !!h.multiple, _ = h.value, _ != null ? At(s, !!h.multiple, _, !1) : h.defaultValue != null && At(
                    s,
                    !!h.multiple,
                    h.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof S.onClick == "function" && (s.onclick = wd);
              }
              switch (f) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  h = !!h.autoFocus;
                  break e;
                case "img":
                  h = !0;
                  break e;
                default:
                  h = !1;
              }
            }
            h && (a.flags |= 4);
          }
          a.ref !== null && (a.flags |= 512, a.flags |= 2097152);
        }
        return Vn(a), null;
      case 6:
        if (s && a.stateNode != null)
          px(s, a, s.memoizedProps, h);
        else {
          if (typeof h != "string" && a.stateNode === null)
            throw Error(n(166));
          if (f = Bi(pc.current), Bi(Lo.current), kd(a)) {
            if (h = a.stateNode, f = a.memoizedProps, h[Oo] = a, (_ = h.nodeValue !== f) && (s = vr, s !== null))
              switch (s.tag) {
                case 3:
                  xd(h.nodeValue, f, (s.mode & 1) !== 0);
                  break;
                case 5:
                  s.memoizedProps.suppressHydrationWarning !== !0 && xd(h.nodeValue, f, (s.mode & 1) !== 0);
              }
            _ && (a.flags |= 4);
          } else
            h = (f.nodeType === 9 ? f : f.ownerDocument).createTextNode(h), h[Oo] = a, a.stateNode = h;
        }
        return Vn(a), null;
      case 13:
        if (Gt(Yt), h = a.memoizedState, s === null || s.memoizedState !== null && s.memoizedState.dehydrated !== null) {
          if (Kt && yr !== null && a.mode & 1 && !(a.flags & 128))
            mb(), Da(), a.flags |= 98560, _ = !1;
          else if (_ = kd(a), h !== null && h.dehydrated !== null) {
            if (s === null) {
              if (!_)
                throw Error(n(318));
              if (_ = a.memoizedState, _ = _ !== null ? _.dehydrated : null, !_)
                throw Error(n(317));
              _[Oo] = a;
            } else
              Da(), !(a.flags & 128) && (a.memoizedState = null), a.flags |= 4;
            Vn(a), _ = !1;
          } else
            ao !== null && (Wh(ao), ao = null), _ = !0;
          if (!_)
            return a.flags & 65536 ? a : null;
        }
        return a.flags & 128 ? (a.lanes = f, a) : (h = h !== null, h !== (s !== null && s.memoizedState !== null) && h && (a.child.flags |= 8192, a.mode & 1 && (s === null || Yt.current & 1 ? gn === 0 && (gn = 3) : qh())), a.updateQueue !== null && (a.flags |= 4), Vn(a), null);
      case 4:
        return Fa(), Rh(s, a), s === null && ic(a.stateNode.containerInfo), Vn(a), null;
      case 10:
        return lh(a.type._context), Vn(a), null;
      case 17:
        return tr(a.type) && jd(), Vn(a), null;
      case 19:
        if (Gt(Yt), _ = a.memoizedState, _ === null)
          return Vn(a), null;
        if (h = (a.flags & 128) !== 0, M = _.rendering, M === null)
          if (h)
            yc(_, !1);
          else {
            if (gn !== 0 || s !== null && s.flags & 128)
              for (s = a.child; s !== null; ) {
                if (M = Rd(s), M !== null) {
                  for (a.flags |= 128, yc(_, !1), h = M.updateQueue, h !== null && (a.updateQueue = h, a.flags |= 4), a.subtreeFlags = 0, h = f, f = a.child; f !== null; )
                    _ = f, s = h, _.flags &= 14680066, M = _.alternate, M === null ? (_.childLanes = 0, _.lanes = s, _.child = null, _.subtreeFlags = 0, _.memoizedProps = null, _.memoizedState = null, _.updateQueue = null, _.dependencies = null, _.stateNode = null) : (_.childLanes = M.childLanes, _.lanes = M.lanes, _.child = M.child, _.subtreeFlags = 0, _.deletions = null, _.memoizedProps = M.memoizedProps, _.memoizedState = M.memoizedState, _.updateQueue = M.updateQueue, _.type = M.type, s = M.dependencies, _.dependencies = s === null ? null : { lanes: s.lanes, firstContext: s.firstContext }), f = f.sibling;
                  return Vt(Yt, Yt.current & 1 | 2), a.child;
                }
                s = s.sibling;
              }
            _.tail !== null && on() > Wa && (a.flags |= 128, h = !0, yc(_, !1), a.lanes = 4194304);
          }
        else {
          if (!h)
            if (s = Rd(M), s !== null) {
              if (a.flags |= 128, h = !0, f = s.updateQueue, f !== null && (a.updateQueue = f, a.flags |= 4), yc(_, !0), _.tail === null && _.tailMode === "hidden" && !M.alternate && !Kt)
                return Vn(a), null;
            } else
              2 * on() - _.renderingStartTime > Wa && f !== 1073741824 && (a.flags |= 128, h = !0, yc(_, !1), a.lanes = 4194304);
          _.isBackwards ? (M.sibling = a.child, a.child = M) : (f = _.last, f !== null ? f.sibling = M : a.child = M, _.last = M);
        }
        return _.tail !== null ? (a = _.tail, _.rendering = a, _.tail = a.sibling, _.renderingStartTime = on(), a.sibling = null, f = Yt.current, Vt(Yt, h ? f & 1 | 2 : f & 1), a) : (Vn(a), null);
      case 22:
      case 23:
        return Kh(), h = a.memoizedState !== null, s !== null && s.memoizedState !== null !== h && (a.flags |= 8192), h && a.mode & 1 ? br & 1073741824 && (Vn(a), a.subtreeFlags & 6 && (a.flags |= 8192)) : Vn(a), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(n(156, a.tag));
  }
  function M_(s, a) {
    switch (nh(a), a.tag) {
      case 1:
        return tr(a.type) && jd(), s = a.flags, s & 65536 ? (a.flags = s & -65537 | 128, a) : null;
      case 3:
        return Fa(), Gt(er), Gt(Dn), hh(), s = a.flags, s & 65536 && !(s & 128) ? (a.flags = s & -65537 | 128, a) : null;
      case 5:
        return ph(a), null;
      case 13:
        if (Gt(Yt), s = a.memoizedState, s !== null && s.dehydrated !== null) {
          if (a.alternate === null)
            throw Error(n(340));
          Da();
        }
        return s = a.flags, s & 65536 ? (a.flags = s & -65537 | 128, a) : null;
      case 19:
        return Gt(Yt), null;
      case 4:
        return Fa(), null;
      case 10:
        return lh(a.type._context), null;
      case 22:
      case 23:
        return Kh(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var Bd = !1, Hn = !1, A_ = typeof WeakSet == "function" ? WeakSet : Set, Ae = null;
  function Ba(s, a) {
    var f = s.ref;
    if (f !== null)
      if (typeof f == "function")
        try {
          f(null);
        } catch (h) {
          tn(s, a, h);
        }
      else
        f.current = null;
  }
  function Nh(s, a, f) {
    try {
      f();
    } catch (h) {
      tn(s, a, h);
    }
  }
  var gx = !1;
  function R_(s, a) {
    if (Kg = cd, s = Gy(), Vg(s)) {
      if ("selectionStart" in s)
        var f = { start: s.selectionStart, end: s.selectionEnd };
      else
        e: {
          f = (f = s.ownerDocument) && f.defaultView || window;
          var h = f.getSelection && f.getSelection();
          if (h && h.rangeCount !== 0) {
            f = h.anchorNode;
            var S = h.anchorOffset, _ = h.focusNode;
            h = h.focusOffset;
            try {
              f.nodeType, _.nodeType;
            } catch {
              f = null;
              break e;
            }
            var M = 0, U = -1, X = -1, ue = 0, Se = 0, Ce = s, be = null;
            t:
              for (; ; ) {
                for (var Me; Ce !== f || S !== 0 && Ce.nodeType !== 3 || (U = M + S), Ce !== _ || h !== 0 && Ce.nodeType !== 3 || (X = M + h), Ce.nodeType === 3 && (M += Ce.nodeValue.length), (Me = Ce.firstChild) !== null; )
                  be = Ce, Ce = Me;
                for (; ; ) {
                  if (Ce === s)
                    break t;
                  if (be === f && ++ue === S && (U = M), be === _ && ++Se === h && (X = M), (Me = Ce.nextSibling) !== null)
                    break;
                  Ce = be, be = Ce.parentNode;
                }
                Ce = Me;
              }
            f = U === -1 || X === -1 ? null : { start: U, end: X };
          } else
            f = null;
        }
      f = f || { start: 0, end: 0 };
    } else
      f = null;
    for (qg = { focusedElem: s, selectionRange: f }, cd = !1, Ae = a; Ae !== null; )
      if (a = Ae, s = a.child, (a.subtreeFlags & 1028) !== 0 && s !== null)
        s.return = a, Ae = s;
      else
        for (; Ae !== null; ) {
          a = Ae;
          try {
            var Ne = a.alternate;
            if (a.flags & 1024)
              switch (a.tag) {
                case 0:
                case 11:
                case 15:
                  break;
                case 1:
                  if (Ne !== null) {
                    var $e = Ne.memoizedProps, sn = Ne.memoizedState, ne = a.stateNode, J = ne.getSnapshotBeforeUpdate(a.elementType === a.type ? $e : lo(a.type, $e), sn);
                    ne.__reactInternalSnapshotBeforeUpdate = J;
                  }
                  break;
                case 3:
                  var ae = a.stateNode.containerInfo;
                  ae.nodeType === 1 ? ae.textContent = "" : ae.nodeType === 9 && ae.documentElement && ae.removeChild(ae.documentElement);
                  break;
                case 5:
                case 6:
                case 4:
                case 17:
                  break;
                default:
                  throw Error(n(163));
              }
          } catch (Pe) {
            tn(a, a.return, Pe);
          }
          if (s = a.sibling, s !== null) {
            s.return = a.return, Ae = s;
            break;
          }
          Ae = a.return;
        }
    return Ne = gx, gx = !1, Ne;
  }
  function bc(s, a, f) {
    var h = a.updateQueue;
    if (h = h !== null ? h.lastEffect : null, h !== null) {
      var S = h = h.next;
      do {
        if ((S.tag & s) === s) {
          var _ = S.destroy;
          S.destroy = void 0, _ !== void 0 && Nh(a, f, _);
        }
        S = S.next;
      } while (S !== h);
    }
  }
  function Ud(s, a) {
    if (a = a.updateQueue, a = a !== null ? a.lastEffect : null, a !== null) {
      var f = a = a.next;
      do {
        if ((f.tag & s) === s) {
          var h = f.create;
          f.destroy = h();
        }
        f = f.next;
      } while (f !== a);
    }
  }
  function $h(s) {
    var a = s.ref;
    if (a !== null) {
      var f = s.stateNode;
      switch (s.tag) {
        case 5:
          s = f;
          break;
        default:
          s = f;
      }
      typeof a == "function" ? a(s) : a.current = s;
    }
  }
  function hx(s) {
    var a = s.alternate;
    a !== null && (s.alternate = null, hx(a)), s.child = null, s.deletions = null, s.sibling = null, s.tag === 5 && (a = s.stateNode, a !== null && (delete a[Oo], delete a[lc], delete a[Jg], delete a[m_], delete a[v_])), s.stateNode = null, s.return = null, s.dependencies = null, s.memoizedProps = null, s.memoizedState = null, s.pendingProps = null, s.stateNode = null, s.updateQueue = null;
  }
  function mx(s) {
    return s.tag === 5 || s.tag === 3 || s.tag === 4;
  }
  function vx(s) {
    e:
      for (; ; ) {
        for (; s.sibling === null; ) {
          if (s.return === null || mx(s.return))
            return null;
          s = s.return;
        }
        for (s.sibling.return = s.return, s = s.sibling; s.tag !== 5 && s.tag !== 6 && s.tag !== 18; ) {
          if (s.flags & 2 || s.child === null || s.tag === 4)
            continue e;
          s.child.return = s, s = s.child;
        }
        if (!(s.flags & 2))
          return s.stateNode;
      }
  }
  function Dh(s, a, f) {
    var h = s.tag;
    if (h === 5 || h === 6)
      s = s.stateNode, a ? f.nodeType === 8 ? f.parentNode.insertBefore(s, a) : f.insertBefore(s, a) : (f.nodeType === 8 ? (a = f.parentNode, a.insertBefore(s, f)) : (a = f, a.appendChild(s)), f = f._reactRootContainer, f != null || a.onclick !== null || (a.onclick = wd));
    else if (h !== 4 && (s = s.child, s !== null))
      for (Dh(s, a, f), s = s.sibling; s !== null; )
        Dh(s, a, f), s = s.sibling;
  }
  function Ih(s, a, f) {
    var h = s.tag;
    if (h === 5 || h === 6)
      s = s.stateNode, a ? f.insertBefore(s, a) : f.appendChild(s);
    else if (h !== 4 && (s = s.child, s !== null))
      for (Ih(s, a, f), s = s.sibling; s !== null; )
        Ih(s, a, f), s = s.sibling;
  }
  var Tn = null, co = !1;
  function Xs(s, a, f) {
    for (f = f.child; f !== null; )
      yx(s, a, f), f = f.sibling;
  }
  function yx(s, a, f) {
    if (To && typeof To.onCommitFiberUnmount == "function")
      try {
        To.onCommitFiberUnmount(rd, f);
      } catch {
      }
    switch (f.tag) {
      case 5:
        Hn || Ba(f, a);
      case 6:
        var h = Tn, S = co;
        Tn = null, Xs(s, a, f), Tn = h, co = S, Tn !== null && (co ? (s = Tn, f = f.stateNode, s.nodeType === 8 ? s.parentNode.removeChild(f) : s.removeChild(f)) : Tn.removeChild(f.stateNode));
        break;
      case 18:
        Tn !== null && (co ? (s = Tn, f = f.stateNode, s.nodeType === 8 ? Zg(s.parentNode, f) : s.nodeType === 1 && Zg(s, f), Zl(s)) : Zg(Tn, f.stateNode));
        break;
      case 4:
        h = Tn, S = co, Tn = f.stateNode.containerInfo, co = !0, Xs(s, a, f), Tn = h, co = S;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Hn && (h = f.updateQueue, h !== null && (h = h.lastEffect, h !== null))) {
          S = h = h.next;
          do {
            var _ = S, M = _.destroy;
            _ = _.tag, M !== void 0 && (_ & 2 || _ & 4) && Nh(f, a, M), S = S.next;
          } while (S !== h);
        }
        Xs(s, a, f);
        break;
      case 1:
        if (!Hn && (Ba(f, a), h = f.stateNode, typeof h.componentWillUnmount == "function"))
          try {
            h.props = f.memoizedProps, h.state = f.memoizedState, h.componentWillUnmount();
          } catch (U) {
            tn(f, a, U);
          }
        Xs(s, a, f);
        break;
      case 21:
        Xs(s, a, f);
        break;
      case 22:
        f.mode & 1 ? (Hn = (h = Hn) || f.memoizedState !== null, Xs(s, a, f), Hn = h) : Xs(s, a, f);
        break;
      default:
        Xs(s, a, f);
    }
  }
  function bx(s) {
    var a = s.updateQueue;
    if (a !== null) {
      s.updateQueue = null;
      var f = s.stateNode;
      f === null && (f = s.stateNode = new A_()), a.forEach(function(h) {
        var S = B_.bind(null, s, h);
        f.has(h) || (f.add(h), h.then(S, S));
      });
    }
  }
  function uo(s, a) {
    var f = a.deletions;
    if (f !== null)
      for (var h = 0; h < f.length; h++) {
        var S = f[h];
        try {
          var _ = s, M = a, U = M;
          e:
            for (; U !== null; ) {
              switch (U.tag) {
                case 5:
                  Tn = U.stateNode, co = !1;
                  break e;
                case 3:
                  Tn = U.stateNode.containerInfo, co = !0;
                  break e;
                case 4:
                  Tn = U.stateNode.containerInfo, co = !0;
                  break e;
              }
              U = U.return;
            }
          if (Tn === null)
            throw Error(n(160));
          yx(_, M, S), Tn = null, co = !1;
          var X = S.alternate;
          X !== null && (X.return = null), S.return = null;
        } catch (ue) {
          tn(S, a, ue);
        }
      }
    if (a.subtreeFlags & 12854)
      for (a = a.child; a !== null; )
        xx(a, s), a = a.sibling;
  }
  function xx(s, a) {
    var f = s.alternate, h = s.flags;
    switch (s.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (uo(a, s), Ao(s), h & 4) {
          try {
            bc(3, s, s.return), Ud(3, s);
          } catch ($e) {
            tn(s, s.return, $e);
          }
          try {
            bc(5, s, s.return);
          } catch ($e) {
            tn(s, s.return, $e);
          }
        }
        break;
      case 1:
        uo(a, s), Ao(s), h & 512 && f !== null && Ba(f, f.return);
        break;
      case 5:
        if (uo(a, s), Ao(s), h & 512 && f !== null && Ba(f, f.return), s.flags & 32) {
          var S = s.stateNode;
          try {
            Zn(S, "");
          } catch ($e) {
            tn(s, s.return, $e);
          }
        }
        if (h & 4 && (S = s.stateNode, S != null)) {
          var _ = s.memoizedProps, M = f !== null ? f.memoizedProps : _, U = s.type, X = s.updateQueue;
          if (s.updateQueue = null, X !== null)
            try {
              U === "input" && _.type === "radio" && _.name != null && zt(S, _), Mt(U, M);
              var ue = Mt(U, _);
              for (M = 0; M < X.length; M += 2) {
                var Se = X[M], Ce = X[M + 1];
                Se === "style" ? Ni(S, Ce) : Se === "dangerouslySetInnerHTML" ? Bn(S, Ce) : Se === "children" ? Zn(S, Ce) : P(S, Se, Ce, ue);
              }
              switch (U) {
                case "input":
                  Ot(S, _);
                  break;
                case "textarea":
                  Et(S, _);
                  break;
                case "select":
                  var be = S._wrapperState.wasMultiple;
                  S._wrapperState.wasMultiple = !!_.multiple;
                  var Me = _.value;
                  Me != null ? At(S, !!_.multiple, Me, !1) : be !== !!_.multiple && (_.defaultValue != null ? At(
                    S,
                    !!_.multiple,
                    _.defaultValue,
                    !0
                  ) : At(S, !!_.multiple, _.multiple ? [] : "", !1));
              }
              S[lc] = _;
            } catch ($e) {
              tn(s, s.return, $e);
            }
        }
        break;
      case 6:
        if (uo(a, s), Ao(s), h & 4) {
          if (s.stateNode === null)
            throw Error(n(162));
          S = s.stateNode, _ = s.memoizedProps;
          try {
            S.nodeValue = _;
          } catch ($e) {
            tn(s, s.return, $e);
          }
        }
        break;
      case 3:
        if (uo(a, s), Ao(s), h & 4 && f !== null && f.memoizedState.isDehydrated)
          try {
            Zl(a.containerInfo);
          } catch ($e) {
            tn(s, s.return, $e);
          }
        break;
      case 4:
        uo(a, s), Ao(s);
        break;
      case 13:
        uo(a, s), Ao(s), S = s.child, S.flags & 8192 && (_ = S.memoizedState !== null, S.stateNode.isHidden = _, !_ || S.alternate !== null && S.alternate.memoizedState !== null || (Fh = on())), h & 4 && bx(s);
        break;
      case 22:
        if (Se = f !== null && f.memoizedState !== null, s.mode & 1 ? (Hn = (ue = Hn) || Se, uo(a, s), Hn = ue) : uo(a, s), Ao(s), h & 8192) {
          if (ue = s.memoizedState !== null, (s.stateNode.isHidden = ue) && !Se && s.mode & 1)
            for (Ae = s, Se = s.child; Se !== null; ) {
              for (Ce = Ae = Se; Ae !== null; ) {
                switch (be = Ae, Me = be.child, be.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    bc(4, be, be.return);
                    break;
                  case 1:
                    Ba(be, be.return);
                    var Ne = be.stateNode;
                    if (typeof Ne.componentWillUnmount == "function") {
                      h = be, f = be.return;
                      try {
                        a = h, Ne.props = a.memoizedProps, Ne.state = a.memoizedState, Ne.componentWillUnmount();
                      } catch ($e) {
                        tn(h, f, $e);
                      }
                    }
                    break;
                  case 5:
                    Ba(be, be.return);
                    break;
                  case 22:
                    if (be.memoizedState !== null) {
                      jx(Ce);
                      continue;
                    }
                }
                Me !== null ? (Me.return = be, Ae = Me) : jx(Ce);
              }
              Se = Se.sibling;
            }
          e:
            for (Se = null, Ce = s; ; ) {
              if (Ce.tag === 5) {
                if (Se === null) {
                  Se = Ce;
                  try {
                    S = Ce.stateNode, ue ? (_ = S.style, typeof _.setProperty == "function" ? _.setProperty("display", "none", "important") : _.display = "none") : (U = Ce.stateNode, X = Ce.memoizedProps.style, M = X != null && X.hasOwnProperty("display") ? X.display : null, U.style.display = as("display", M));
                  } catch ($e) {
                    tn(s, s.return, $e);
                  }
                }
              } else if (Ce.tag === 6) {
                if (Se === null)
                  try {
                    Ce.stateNode.nodeValue = ue ? "" : Ce.memoizedProps;
                  } catch ($e) {
                    tn(s, s.return, $e);
                  }
              } else if ((Ce.tag !== 22 && Ce.tag !== 23 || Ce.memoizedState === null || Ce === s) && Ce.child !== null) {
                Ce.child.return = Ce, Ce = Ce.child;
                continue;
              }
              if (Ce === s)
                break e;
              for (; Ce.sibling === null; ) {
                if (Ce.return === null || Ce.return === s)
                  break e;
                Se === Ce && (Se = null), Ce = Ce.return;
              }
              Se === Ce && (Se = null), Ce.sibling.return = Ce.return, Ce = Ce.sibling;
            }
        }
        break;
      case 19:
        uo(a, s), Ao(s), h & 4 && bx(s);
        break;
      case 21:
        break;
      default:
        uo(
          a,
          s
        ), Ao(s);
    }
  }
  function Ao(s) {
    var a = s.flags;
    if (a & 2) {
      try {
        e: {
          for (var f = s.return; f !== null; ) {
            if (mx(f)) {
              var h = f;
              break e;
            }
            f = f.return;
          }
          throw Error(n(160));
        }
        switch (h.tag) {
          case 5:
            var S = h.stateNode;
            h.flags & 32 && (Zn(S, ""), h.flags &= -33);
            var _ = vx(s);
            Ih(s, _, S);
            break;
          case 3:
          case 4:
            var M = h.stateNode.containerInfo, U = vx(s);
            Dh(s, U, M);
            break;
          default:
            throw Error(n(161));
        }
      } catch (X) {
        tn(s, s.return, X);
      }
      s.flags &= -3;
    }
    a & 4096 && (s.flags &= -4097);
  }
  function N_(s, a, f) {
    Ae = s, wx(s);
  }
  function wx(s, a, f) {
    for (var h = (s.mode & 1) !== 0; Ae !== null; ) {
      var S = Ae, _ = S.child;
      if (S.tag === 22 && h) {
        var M = S.memoizedState !== null || Bd;
        if (!M) {
          var U = S.alternate, X = U !== null && U.memoizedState !== null || Hn;
          U = Bd;
          var ue = Hn;
          if (Bd = M, (Hn = X) && !ue)
            for (Ae = S; Ae !== null; )
              M = Ae, X = M.child, M.tag === 22 && M.memoizedState !== null ? Cx(S) : X !== null ? (X.return = M, Ae = X) : Cx(S);
          for (; _ !== null; )
            Ae = _, wx(_), _ = _.sibling;
          Ae = S, Bd = U, Hn = ue;
        }
        Sx(s);
      } else
        S.subtreeFlags & 8772 && _ !== null ? (_.return = S, Ae = _) : Sx(s);
    }
  }
  function Sx(s) {
    for (; Ae !== null; ) {
      var a = Ae;
      if (a.flags & 8772) {
        var f = a.alternate;
        try {
          if (a.flags & 8772)
            switch (a.tag) {
              case 0:
              case 11:
              case 15:
                Hn || Ud(5, a);
                break;
              case 1:
                var h = a.stateNode;
                if (a.flags & 4 && !Hn)
                  if (f === null)
                    h.componentDidMount();
                  else {
                    var S = a.elementType === a.type ? f.memoizedProps : lo(a.type, f.memoizedProps);
                    h.componentDidUpdate(S, f.memoizedState, h.__reactInternalSnapshotBeforeUpdate);
                  }
                var _ = a.updateQueue;
                _ !== null && jb(a, _, h);
                break;
              case 3:
                var M = a.updateQueue;
                if (M !== null) {
                  if (f = null, a.child !== null)
                    switch (a.child.tag) {
                      case 5:
                        f = a.child.stateNode;
                        break;
                      case 1:
                        f = a.child.stateNode;
                    }
                  jb(a, M, f);
                }
                break;
              case 5:
                var U = a.stateNode;
                if (f === null && a.flags & 4) {
                  f = U;
                  var X = a.memoizedProps;
                  switch (a.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      X.autoFocus && f.focus();
                      break;
                    case "img":
                      X.src && (f.src = X.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (a.memoizedState === null) {
                  var ue = a.alternate;
                  if (ue !== null) {
                    var Se = ue.memoizedState;
                    if (Se !== null) {
                      var Ce = Se.dehydrated;
                      Ce !== null && Zl(Ce);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(n(163));
            }
          Hn || a.flags & 512 && $h(a);
        } catch (be) {
          tn(a, a.return, be);
        }
      }
      if (a === s) {
        Ae = null;
        break;
      }
      if (f = a.sibling, f !== null) {
        f.return = a.return, Ae = f;
        break;
      }
      Ae = a.return;
    }
  }
  function jx(s) {
    for (; Ae !== null; ) {
      var a = Ae;
      if (a === s) {
        Ae = null;
        break;
      }
      var f = a.sibling;
      if (f !== null) {
        f.return = a.return, Ae = f;
        break;
      }
      Ae = a.return;
    }
  }
  function Cx(s) {
    for (; Ae !== null; ) {
      var a = Ae;
      try {
        switch (a.tag) {
          case 0:
          case 11:
          case 15:
            var f = a.return;
            try {
              Ud(4, a);
            } catch (X) {
              tn(a, f, X);
            }
            break;
          case 1:
            var h = a.stateNode;
            if (typeof h.componentDidMount == "function") {
              var S = a.return;
              try {
                h.componentDidMount();
              } catch (X) {
                tn(a, S, X);
              }
            }
            var _ = a.return;
            try {
              $h(a);
            } catch (X) {
              tn(a, _, X);
            }
            break;
          case 5:
            var M = a.return;
            try {
              $h(a);
            } catch (X) {
              tn(a, M, X);
            }
        }
      } catch (X) {
        tn(a, a.return, X);
      }
      if (a === s) {
        Ae = null;
        break;
      }
      var U = a.sibling;
      if (U !== null) {
        U.return = a.return, Ae = U;
        break;
      }
      Ae = a.return;
    }
  }
  var $_ = Math.ceil, Wd = k.ReactCurrentDispatcher, Vh = k.ReactCurrentOwner, Fr = k.ReactCurrentBatchConfig, ht = 0, jn = null, cn = null, On = 0, br = 0, Ua = Ws(0), gn = 0, xc = null, Wi = 0, Gd = 0, Hh = 0, wc = null, rr = null, Fh = 0, Wa = 1 / 0, vs = null, Kd = !1, zh = null, Zs = null, qd = !1, Js = null, Yd = 0, Sc = 0, Bh = null, Xd = -1, Zd = 0;
  function Wn() {
    return ht & 6 ? on() : Xd !== -1 ? Xd : Xd = on();
  }
  function Qs(s) {
    return s.mode & 1 ? ht & 2 && On !== 0 ? On & -On : b_.transition !== null ? (Zd === 0 && (Zd = vy()), Zd) : (s = Pt, s !== 0 || (s = window.event, s = s === void 0 ? 16 : Py(s.type)), s) : 1;
  }
  function fo(s, a, f, h) {
    if (50 < Sc)
      throw Sc = 0, Bh = null, Error(n(185));
    Gl(s, f, h), (!(ht & 2) || s !== jn) && (s === jn && (!(ht & 2) && (Gd |= f), gn === 4 && ei(s, On)), or(s, h), f === 1 && ht === 0 && !(a.mode & 1) && (Wa = on() + 500, Ed && Ks()));
  }
  function or(s, a) {
    var f = s.callbackNode;
    b3(s, a);
    var h = id(s, s === jn ? On : 0);
    if (h === 0)
      f !== null && gy(f), s.callbackNode = null, s.callbackPriority = 0;
    else if (a = h & -h, s.callbackPriority !== a) {
      if (f != null && gy(f), a === 1)
        s.tag === 0 ? y_(Px.bind(null, s)) : db(Px.bind(null, s)), g_(function() {
          !(ht & 6) && Ks();
        }), f = null;
      else {
        switch (yy(h)) {
          case 1:
            f = Sg;
            break;
          case 4:
            f = hy;
            break;
          case 16:
            f = nd;
            break;
          case 536870912:
            f = my;
            break;
          default:
            f = nd;
        }
        f = Rx(f, Ex.bind(null, s));
      }
      s.callbackPriority = a, s.callbackNode = f;
    }
  }
  function Ex(s, a) {
    if (Xd = -1, Zd = 0, ht & 6)
      throw Error(n(327));
    var f = s.callbackNode;
    if (Ga() && s.callbackNode !== f)
      return null;
    var h = id(s, s === jn ? On : 0);
    if (h === 0)
      return null;
    if (h & 30 || h & s.expiredLanes || a)
      a = Jd(s, h);
    else {
      a = h;
      var S = ht;
      ht |= 2;
      var _ = kx();
      (jn !== s || On !== a) && (vs = null, Wa = on() + 500, Ki(s, a));
      do
        try {
          V_();
          break;
        } catch (U) {
          _x(s, U);
        }
      while (1);
      ah(), Wd.current = _, ht = S, cn !== null ? a = 0 : (jn = null, On = 0, a = gn);
    }
    if (a !== 0) {
      if (a === 2 && (S = jg(s), S !== 0 && (h = S, a = Uh(s, S))), a === 1)
        throw f = xc, Ki(s, 0), ei(s, h), or(s, on()), f;
      if (a === 6)
        ei(s, h);
      else {
        if (S = s.current.alternate, !(h & 30) && !D_(S) && (a = Jd(s, h), a === 2 && (_ = jg(s), _ !== 0 && (h = _, a = Uh(s, _))), a === 1))
          throw f = xc, Ki(s, 0), ei(s, h), or(s, on()), f;
        switch (s.finishedWork = S, s.finishedLanes = h, a) {
          case 0:
          case 1:
            throw Error(n(345));
          case 2:
            qi(s, rr, vs);
            break;
          case 3:
            if (ei(s, h), (h & 130023424) === h && (a = Fh + 500 - on(), 10 < a)) {
              if (id(s, 0) !== 0)
                break;
              if (S = s.suspendedLanes, (S & h) !== h) {
                Wn(), s.pingedLanes |= s.suspendedLanes & S;
                break;
              }
              s.timeoutHandle = Xg(qi.bind(null, s, rr, vs), a);
              break;
            }
            qi(s, rr, vs);
            break;
          case 4:
            if (ei(s, h), (h & 4194240) === h)
              break;
            for (a = s.eventTimes, S = -1; 0 < h; ) {
              var M = 31 - so(h);
              _ = 1 << M, M = a[M], M > S && (S = M), h &= ~_;
            }
            if (h = S, h = on() - h, h = (120 > h ? 120 : 480 > h ? 480 : 1080 > h ? 1080 : 1920 > h ? 1920 : 3e3 > h ? 3e3 : 4320 > h ? 4320 : 1960 * $_(h / 1960)) - h, 10 < h) {
              s.timeoutHandle = Xg(qi.bind(null, s, rr, vs), h);
              break;
            }
            qi(s, rr, vs);
            break;
          case 5:
            qi(s, rr, vs);
            break;
          default:
            throw Error(n(329));
        }
      }
    }
    return or(s, on()), s.callbackNode === f ? Ex.bind(null, s) : null;
  }
  function Uh(s, a) {
    var f = wc;
    return s.current.memoizedState.isDehydrated && (Ki(s, a).flags |= 256), s = Jd(s, a), s !== 2 && (a = rr, rr = f, a !== null && Wh(a)), s;
  }
  function Wh(s) {
    rr === null ? rr = s : rr.push.apply(rr, s);
  }
  function D_(s) {
    for (var a = s; ; ) {
      if (a.flags & 16384) {
        var f = a.updateQueue;
        if (f !== null && (f = f.stores, f !== null))
          for (var h = 0; h < f.length; h++) {
            var S = f[h], _ = S.getSnapshot;
            S = S.value;
            try {
              if (!io(_(), S))
                return !1;
            } catch {
              return !1;
            }
          }
      }
      if (f = a.child, a.subtreeFlags & 16384 && f !== null)
        f.return = a, a = f;
      else {
        if (a === s)
          break;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === s)
            return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
    }
    return !0;
  }
  function ei(s, a) {
    for (a &= ~Hh, a &= ~Gd, s.suspendedLanes |= a, s.pingedLanes &= ~a, s = s.expirationTimes; 0 < a; ) {
      var f = 31 - so(a), h = 1 << f;
      s[f] = -1, a &= ~h;
    }
  }
  function Px(s) {
    if (ht & 6)
      throw Error(n(327));
    Ga();
    var a = id(s, 0);
    if (!(a & 1))
      return or(s, on()), null;
    var f = Jd(s, a);
    if (s.tag !== 0 && f === 2) {
      var h = jg(s);
      h !== 0 && (a = h, f = Uh(s, h));
    }
    if (f === 1)
      throw f = xc, Ki(s, 0), ei(s, a), or(s, on()), f;
    if (f === 6)
      throw Error(n(345));
    return s.finishedWork = s.current.alternate, s.finishedLanes = a, qi(s, rr, vs), or(s, on()), null;
  }
  function Gh(s, a) {
    var f = ht;
    ht |= 1;
    try {
      return s(a);
    } finally {
      ht = f, ht === 0 && (Wa = on() + 500, Ed && Ks());
    }
  }
  function Gi(s) {
    Js !== null && Js.tag === 0 && !(ht & 6) && Ga();
    var a = ht;
    ht |= 1;
    var f = Fr.transition, h = Pt;
    try {
      if (Fr.transition = null, Pt = 1, s)
        return s();
    } finally {
      Pt = h, Fr.transition = f, ht = a, !(ht & 6) && Ks();
    }
  }
  function Kh() {
    br = Ua.current, Gt(Ua);
  }
  function Ki(s, a) {
    s.finishedWork = null, s.finishedLanes = 0;
    var f = s.timeoutHandle;
    if (f !== -1 && (s.timeoutHandle = -1, p_(f)), cn !== null)
      for (f = cn.return; f !== null; ) {
        var h = f;
        switch (nh(h), h.tag) {
          case 1:
            h = h.type.childContextTypes, h != null && jd();
            break;
          case 3:
            Fa(), Gt(er), Gt(Dn), hh();
            break;
          case 5:
            ph(h);
            break;
          case 4:
            Fa();
            break;
          case 13:
            Gt(Yt);
            break;
          case 19:
            Gt(Yt);
            break;
          case 10:
            lh(h.type._context);
            break;
          case 22:
          case 23:
            Kh();
        }
        f = f.return;
      }
    if (jn = s, cn = s = ti(s.current, null), On = br = a, gn = 0, xc = null, Hh = Gd = Wi = 0, rr = wc = null, zi !== null) {
      for (a = 0; a < zi.length; a++)
        if (f = zi[a], h = f.interleaved, h !== null) {
          f.interleaved = null;
          var S = h.next, _ = f.pending;
          if (_ !== null) {
            var M = _.next;
            _.next = S, h.next = M;
          }
          f.pending = h;
        }
      zi = null;
    }
    return s;
  }
  function _x(s, a) {
    do {
      var f = cn;
      try {
        if (ah(), Nd.current = Vd, $d) {
          for (var h = Xt.memoizedState; h !== null; ) {
            var S = h.queue;
            S !== null && (S.pending = null), h = h.next;
          }
          $d = !1;
        }
        if (Ui = 0, Sn = pn = Xt = null, gc = !1, hc = 0, Vh.current = null, f === null || f.return === null) {
          gn = 1, xc = a, cn = null;
          break;
        }
        e: {
          var _ = s, M = f.return, U = f, X = a;
          if (a = On, U.flags |= 32768, X !== null && typeof X == "object" && typeof X.then == "function") {
            var ue = X, Se = U, Ce = Se.tag;
            if (!(Se.mode & 1) && (Ce === 0 || Ce === 11 || Ce === 15)) {
              var be = Se.alternate;
              be ? (Se.updateQueue = be.updateQueue, Se.memoizedState = be.memoizedState, Se.lanes = be.lanes) : (Se.updateQueue = null, Se.memoizedState = null);
            }
            var Me = Jb(M);
            if (Me !== null) {
              Me.flags &= -257, Qb(Me, M, U, _, a), Me.mode & 1 && Zb(_, ue, a), a = Me, X = ue;
              var Ne = a.updateQueue;
              if (Ne === null) {
                var $e = /* @__PURE__ */ new Set();
                $e.add(X), a.updateQueue = $e;
              } else
                Ne.add(X);
              break e;
            } else {
              if (!(a & 1)) {
                Zb(_, ue, a), qh();
                break e;
              }
              X = Error(n(426));
            }
          } else if (Kt && U.mode & 1) {
            var sn = Jb(M);
            if (sn !== null) {
              !(sn.flags & 65536) && (sn.flags |= 256), Qb(sn, M, U, _, a), sh(za(X, U));
              break e;
            }
          }
          _ = X = za(X, U), gn !== 4 && (gn = 2), wc === null ? wc = [_] : wc.push(_), _ = M;
          do {
            switch (_.tag) {
              case 3:
                _.flags |= 65536, a &= -a, _.lanes |= a;
                var ne = Yb(_, X, a);
                Sb(_, ne);
                break e;
              case 1:
                U = X;
                var J = _.type, ae = _.stateNode;
                if (!(_.flags & 128) && (typeof J.getDerivedStateFromError == "function" || ae !== null && typeof ae.componentDidCatch == "function" && (Zs === null || !Zs.has(ae)))) {
                  _.flags |= 65536, a &= -a, _.lanes |= a;
                  var Pe = Xb(_, U, a);
                  Sb(_, Pe);
                  break e;
                }
            }
            _ = _.return;
          } while (_ !== null);
        }
        Ox(f);
      } catch (Ie) {
        a = Ie, cn === f && f !== null && (cn = f = f.return);
        continue;
      }
      break;
    } while (1);
  }
  function kx() {
    var s = Wd.current;
    return Wd.current = Vd, s === null ? Vd : s;
  }
  function qh() {
    (gn === 0 || gn === 3 || gn === 2) && (gn = 4), jn === null || !(Wi & 268435455) && !(Gd & 268435455) || ei(jn, On);
  }
  function Jd(s, a) {
    var f = ht;
    ht |= 2;
    var h = kx();
    (jn !== s || On !== a) && (vs = null, Ki(s, a));
    do
      try {
        I_();
        break;
      } catch (S) {
        _x(s, S);
      }
    while (1);
    if (ah(), ht = f, Wd.current = h, cn !== null)
      throw Error(n(261));
    return jn = null, On = 0, gn;
  }
  function I_() {
    for (; cn !== null; )
      Tx(cn);
  }
  function V_() {
    for (; cn !== null && !u3(); )
      Tx(cn);
  }
  function Tx(s) {
    var a = Ax(s.alternate, s, br);
    s.memoizedProps = s.pendingProps, a === null ? Ox(s) : cn = a, Vh.current = null;
  }
  function Ox(s) {
    var a = s;
    do {
      var f = a.alternate;
      if (s = a.return, a.flags & 32768) {
        if (f = M_(f, a), f !== null) {
          f.flags &= 32767, cn = f;
          return;
        }
        if (s !== null)
          s.flags |= 32768, s.subtreeFlags = 0, s.deletions = null;
        else {
          gn = 6, cn = null;
          return;
        }
      } else if (f = L_(f, a, br), f !== null) {
        cn = f;
        return;
      }
      if (a = a.sibling, a !== null) {
        cn = a;
        return;
      }
      cn = a = s;
    } while (a !== null);
    gn === 0 && (gn = 5);
  }
  function qi(s, a, f) {
    var h = Pt, S = Fr.transition;
    try {
      Fr.transition = null, Pt = 1, H_(s, a, f, h);
    } finally {
      Fr.transition = S, Pt = h;
    }
    return null;
  }
  function H_(s, a, f, h) {
    do
      Ga();
    while (Js !== null);
    if (ht & 6)
      throw Error(n(327));
    f = s.finishedWork;
    var S = s.finishedLanes;
    if (f === null)
      return null;
    if (s.finishedWork = null, s.finishedLanes = 0, f === s.current)
      throw Error(n(177));
    s.callbackNode = null, s.callbackPriority = 0;
    var _ = f.lanes | f.childLanes;
    if (x3(s, _), s === jn && (cn = jn = null, On = 0), !(f.subtreeFlags & 2064) && !(f.flags & 2064) || qd || (qd = !0, Rx(nd, function() {
      return Ga(), null;
    })), _ = (f.flags & 15990) !== 0, f.subtreeFlags & 15990 || _) {
      _ = Fr.transition, Fr.transition = null;
      var M = Pt;
      Pt = 1;
      var U = ht;
      ht |= 4, Vh.current = null, R_(s, f), xx(f, s), i_(qg), cd = !!Kg, qg = Kg = null, s.current = f, N_(f), d3(), ht = U, Pt = M, Fr.transition = _;
    } else
      s.current = f;
    if (qd && (qd = !1, Js = s, Yd = S), _ = s.pendingLanes, _ === 0 && (Zs = null), g3(f.stateNode), or(s, on()), a !== null)
      for (h = s.onRecoverableError, f = 0; f < a.length; f++)
        S = a[f], h(S.value, { componentStack: S.stack, digest: S.digest });
    if (Kd)
      throw Kd = !1, s = zh, zh = null, s;
    return Yd & 1 && s.tag !== 0 && Ga(), _ = s.pendingLanes, _ & 1 ? s === Bh ? Sc++ : (Sc = 0, Bh = s) : Sc = 0, Ks(), null;
  }
  function Ga() {
    if (Js !== null) {
      var s = yy(Yd), a = Fr.transition, f = Pt;
      try {
        if (Fr.transition = null, Pt = 16 > s ? 16 : s, Js === null)
          var h = !1;
        else {
          if (s = Js, Js = null, Yd = 0, ht & 6)
            throw Error(n(331));
          var S = ht;
          for (ht |= 4, Ae = s.current; Ae !== null; ) {
            var _ = Ae, M = _.child;
            if (Ae.flags & 16) {
              var U = _.deletions;
              if (U !== null) {
                for (var X = 0; X < U.length; X++) {
                  var ue = U[X];
                  for (Ae = ue; Ae !== null; ) {
                    var Se = Ae;
                    switch (Se.tag) {
                      case 0:
                      case 11:
                      case 15:
                        bc(8, Se, _);
                    }
                    var Ce = Se.child;
                    if (Ce !== null)
                      Ce.return = Se, Ae = Ce;
                    else
                      for (; Ae !== null; ) {
                        Se = Ae;
                        var be = Se.sibling, Me = Se.return;
                        if (hx(Se), Se === ue) {
                          Ae = null;
                          break;
                        }
                        if (be !== null) {
                          be.return = Me, Ae = be;
                          break;
                        }
                        Ae = Me;
                      }
                  }
                }
                var Ne = _.alternate;
                if (Ne !== null) {
                  var $e = Ne.child;
                  if ($e !== null) {
                    Ne.child = null;
                    do {
                      var sn = $e.sibling;
                      $e.sibling = null, $e = sn;
                    } while ($e !== null);
                  }
                }
                Ae = _;
              }
            }
            if (_.subtreeFlags & 2064 && M !== null)
              M.return = _, Ae = M;
            else
              e:
                for (; Ae !== null; ) {
                  if (_ = Ae, _.flags & 2048)
                    switch (_.tag) {
                      case 0:
                      case 11:
                      case 15:
                        bc(9, _, _.return);
                    }
                  var ne = _.sibling;
                  if (ne !== null) {
                    ne.return = _.return, Ae = ne;
                    break e;
                  }
                  Ae = _.return;
                }
          }
          var J = s.current;
          for (Ae = J; Ae !== null; ) {
            M = Ae;
            var ae = M.child;
            if (M.subtreeFlags & 2064 && ae !== null)
              ae.return = M, Ae = ae;
            else
              e:
                for (M = J; Ae !== null; ) {
                  if (U = Ae, U.flags & 2048)
                    try {
                      switch (U.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Ud(9, U);
                      }
                    } catch (Ie) {
                      tn(U, U.return, Ie);
                    }
                  if (U === M) {
                    Ae = null;
                    break e;
                  }
                  var Pe = U.sibling;
                  if (Pe !== null) {
                    Pe.return = U.return, Ae = Pe;
                    break e;
                  }
                  Ae = U.return;
                }
          }
          if (ht = S, Ks(), To && typeof To.onPostCommitFiberRoot == "function")
            try {
              To.onPostCommitFiberRoot(rd, s);
            } catch {
            }
          h = !0;
        }
        return h;
      } finally {
        Pt = f, Fr.transition = a;
      }
    }
    return !1;
  }
  function Lx(s, a, f) {
    a = za(f, a), a = Yb(s, a, 1), s = Ys(s, a, 1), a = Wn(), s !== null && (Gl(s, 1, a), or(s, a));
  }
  function tn(s, a, f) {
    if (s.tag === 3)
      Lx(s, s, f);
    else
      for (; a !== null; ) {
        if (a.tag === 3) {
          Lx(a, s, f);
          break;
        } else if (a.tag === 1) {
          var h = a.stateNode;
          if (typeof a.type.getDerivedStateFromError == "function" || typeof h.componentDidCatch == "function" && (Zs === null || !Zs.has(h))) {
            s = za(f, s), s = Xb(a, s, 1), a = Ys(a, s, 1), s = Wn(), a !== null && (Gl(a, 1, s), or(a, s));
            break;
          }
        }
        a = a.return;
      }
  }
  function F_(s, a, f) {
    var h = s.pingCache;
    h !== null && h.delete(a), a = Wn(), s.pingedLanes |= s.suspendedLanes & f, jn === s && (On & f) === f && (gn === 4 || gn === 3 && (On & 130023424) === On && 500 > on() - Fh ? Ki(s, 0) : Hh |= f), or(s, a);
  }
  function Mx(s, a) {
    a === 0 && (s.mode & 1 ? (a = sd, sd <<= 1, !(sd & 130023424) && (sd = 4194304)) : a = 1);
    var f = Wn();
    s = gs(s, a), s !== null && (Gl(s, a, f), or(s, f));
  }
  function z_(s) {
    var a = s.memoizedState, f = 0;
    a !== null && (f = a.retryLane), Mx(s, f);
  }
  function B_(s, a) {
    var f = 0;
    switch (s.tag) {
      case 13:
        var h = s.stateNode, S = s.memoizedState;
        S !== null && (f = S.retryLane);
        break;
      case 19:
        h = s.stateNode;
        break;
      default:
        throw Error(n(314));
    }
    h !== null && h.delete(a), Mx(s, f);
  }
  var Ax;
  Ax = function(s, a, f) {
    if (s !== null)
      if (s.memoizedProps !== a.pendingProps || er.current)
        nr = !0;
      else {
        if (!(s.lanes & f) && !(a.flags & 128))
          return nr = !1, O_(s, a, f);
        nr = !!(s.flags & 131072);
      }
    else
      nr = !1, Kt && a.flags & 1048576 && fb(a, _d, a.index);
    switch (a.lanes = 0, a.tag) {
      case 2:
        var h = a.type;
        zd(s, a), s = a.pendingProps;
        var S = Ra(a, Dn.current);
        Ha(a, f), S = yh(null, a, h, s, S, f);
        var _ = bh();
        return a.flags |= 1, typeof S == "object" && S !== null && typeof S.render == "function" && S.$$typeof === void 0 ? (a.tag = 1, a.memoizedState = null, a.updateQueue = null, tr(h) ? (_ = !0, Cd(a)) : _ = !1, a.memoizedState = S.state !== null && S.state !== void 0 ? S.state : null, dh(a), S.updater = Hd, a.stateNode = S, S._reactInternals = a, Eh(a, h, s, f), a = Th(null, a, h, !0, _, f)) : (a.tag = 0, Kt && _ && th(a), Un(null, a, S, f), a = a.child), a;
      case 16:
        h = a.elementType;
        e: {
          switch (zd(s, a), s = a.pendingProps, S = h._init, h = S(h._payload), a.type = h, S = a.tag = W_(h), s = lo(h, s), S) {
            case 0:
              a = kh(null, a, h, s, f);
              break e;
            case 1:
              a = sx(null, a, h, s, f);
              break e;
            case 11:
              a = ex(null, a, h, s, f);
              break e;
            case 14:
              a = tx(null, a, h, lo(h.type, s), f);
              break e;
          }
          throw Error(n(
            306,
            h,
            ""
          ));
        }
        return a;
      case 0:
        return h = a.type, S = a.pendingProps, S = a.elementType === h ? S : lo(h, S), kh(s, a, h, S, f);
      case 1:
        return h = a.type, S = a.pendingProps, S = a.elementType === h ? S : lo(h, S), sx(s, a, h, S, f);
      case 3:
        e: {
          if (ix(a), s === null)
            throw Error(n(387));
          h = a.pendingProps, _ = a.memoizedState, S = _.element, wb(s, a), Ad(a, h, null, f);
          var M = a.memoizedState;
          if (h = M.element, _.isDehydrated)
            if (_ = { element: h, isDehydrated: !1, cache: M.cache, pendingSuspenseBoundaries: M.pendingSuspenseBoundaries, transitions: M.transitions }, a.updateQueue.baseState = _, a.memoizedState = _, a.flags & 256) {
              S = za(Error(n(423)), a), a = ax(s, a, h, f, S);
              break e;
            } else if (h !== S) {
              S = za(Error(n(424)), a), a = ax(s, a, h, f, S);
              break e;
            } else
              for (yr = Us(a.stateNode.containerInfo.firstChild), vr = a, Kt = !0, ao = null, f = bb(a, null, h, f), a.child = f; f; )
                f.flags = f.flags & -3 | 4096, f = f.sibling;
          else {
            if (Da(), h === S) {
              a = ms(s, a, f);
              break e;
            }
            Un(s, a, h, f);
          }
          a = a.child;
        }
        return a;
      case 5:
        return Cb(a), s === null && oh(a), h = a.type, S = a.pendingProps, _ = s !== null ? s.memoizedProps : null, M = S.children, Yg(h, S) ? M = null : _ !== null && Yg(h, _) && (a.flags |= 32), ox(s, a), Un(s, a, M, f), a.child;
      case 6:
        return s === null && oh(a), null;
      case 13:
        return lx(s, a, f);
      case 4:
        return fh(a, a.stateNode.containerInfo), h = a.pendingProps, s === null ? a.child = Ia(a, null, h, f) : Un(s, a, h, f), a.child;
      case 11:
        return h = a.type, S = a.pendingProps, S = a.elementType === h ? S : lo(h, S), ex(s, a, h, S, f);
      case 7:
        return Un(s, a, a.pendingProps, f), a.child;
      case 8:
        return Un(s, a, a.pendingProps.children, f), a.child;
      case 12:
        return Un(s, a, a.pendingProps.children, f), a.child;
      case 10:
        e: {
          if (h = a.type._context, S = a.pendingProps, _ = a.memoizedProps, M = S.value, Vt(Od, h._currentValue), h._currentValue = M, _ !== null)
            if (io(_.value, M)) {
              if (_.children === S.children && !er.current) {
                a = ms(s, a, f);
                break e;
              }
            } else
              for (_ = a.child, _ !== null && (_.return = a); _ !== null; ) {
                var U = _.dependencies;
                if (U !== null) {
                  M = _.child;
                  for (var X = U.firstContext; X !== null; ) {
                    if (X.context === h) {
                      if (_.tag === 1) {
                        X = hs(-1, f & -f), X.tag = 2;
                        var ue = _.updateQueue;
                        if (ue !== null) {
                          ue = ue.shared;
                          var Se = ue.pending;
                          Se === null ? X.next = X : (X.next = Se.next, Se.next = X), ue.pending = X;
                        }
                      }
                      _.lanes |= f, X = _.alternate, X !== null && (X.lanes |= f), ch(
                        _.return,
                        f,
                        a
                      ), U.lanes |= f;
                      break;
                    }
                    X = X.next;
                  }
                } else if (_.tag === 10)
                  M = _.type === a.type ? null : _.child;
                else if (_.tag === 18) {
                  if (M = _.return, M === null)
                    throw Error(n(341));
                  M.lanes |= f, U = M.alternate, U !== null && (U.lanes |= f), ch(M, f, a), M = _.sibling;
                } else
                  M = _.child;
                if (M !== null)
                  M.return = _;
                else
                  for (M = _; M !== null; ) {
                    if (M === a) {
                      M = null;
                      break;
                    }
                    if (_ = M.sibling, _ !== null) {
                      _.return = M.return, M = _;
                      break;
                    }
                    M = M.return;
                  }
                _ = M;
              }
          Un(s, a, S.children, f), a = a.child;
        }
        return a;
      case 9:
        return S = a.type, h = a.pendingProps.children, Ha(a, f), S = Vr(S), h = h(S), a.flags |= 1, Un(s, a, h, f), a.child;
      case 14:
        return h = a.type, S = lo(h, a.pendingProps), S = lo(h.type, S), tx(s, a, h, S, f);
      case 15:
        return nx(s, a, a.type, a.pendingProps, f);
      case 17:
        return h = a.type, S = a.pendingProps, S = a.elementType === h ? S : lo(h, S), zd(s, a), a.tag = 1, tr(h) ? (s = !0, Cd(a)) : s = !1, Ha(a, f), Kb(a, h, S), Eh(a, h, S, f), Th(null, a, h, !0, s, f);
      case 19:
        return ux(s, a, f);
      case 22:
        return rx(s, a, f);
    }
    throw Error(n(156, a.tag));
  };
  function Rx(s, a) {
    return py(s, a);
  }
  function U_(s, a, f, h) {
    this.tag = s, this.key = f, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = a, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = h, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function zr(s, a, f, h) {
    return new U_(s, a, f, h);
  }
  function Yh(s) {
    return s = s.prototype, !(!s || !s.isReactComponent);
  }
  function W_(s) {
    if (typeof s == "function")
      return Yh(s) ? 1 : 0;
    if (s != null) {
      if (s = s.$$typeof, s === D)
        return 11;
      if (s === H)
        return 14;
    }
    return 2;
  }
  function ti(s, a) {
    var f = s.alternate;
    return f === null ? (f = zr(s.tag, a, s.key, s.mode), f.elementType = s.elementType, f.type = s.type, f.stateNode = s.stateNode, f.alternate = s, s.alternate = f) : (f.pendingProps = a, f.type = s.type, f.flags = 0, f.subtreeFlags = 0, f.deletions = null), f.flags = s.flags & 14680064, f.childLanes = s.childLanes, f.lanes = s.lanes, f.child = s.child, f.memoizedProps = s.memoizedProps, f.memoizedState = s.memoizedState, f.updateQueue = s.updateQueue, a = s.dependencies, f.dependencies = a === null ? null : { lanes: a.lanes, firstContext: a.firstContext }, f.sibling = s.sibling, f.index = s.index, f.ref = s.ref, f;
  }
  function Qd(s, a, f, h, S, _) {
    var M = 2;
    if (h = s, typeof s == "function")
      Yh(s) && (M = 1);
    else if (typeof s == "string")
      M = 5;
    else
      e:
        switch (s) {
          case A:
            return Yi(f.children, S, _, a);
          case $:
            M = 8, S |= 8;
            break;
          case N:
            return s = zr(12, f, a, S | 2), s.elementType = N, s.lanes = _, s;
          case Z:
            return s = zr(13, f, a, S), s.elementType = Z, s.lanes = _, s;
          case K:
            return s = zr(19, f, a, S), s.elementType = K, s.lanes = _, s;
          case te:
            return ef(f, S, _, a);
          default:
            if (typeof s == "object" && s !== null)
              switch (s.$$typeof) {
                case R:
                  M = 10;
                  break e;
                case z:
                  M = 9;
                  break e;
                case D:
                  M = 11;
                  break e;
                case H:
                  M = 14;
                  break e;
                case q:
                  M = 16, h = null;
                  break e;
              }
            throw Error(n(130, s == null ? s : typeof s, ""));
        }
    return a = zr(M, f, a, S), a.elementType = s, a.type = h, a.lanes = _, a;
  }
  function Yi(s, a, f, h) {
    return s = zr(7, s, h, a), s.lanes = f, s;
  }
  function ef(s, a, f, h) {
    return s = zr(22, s, h, a), s.elementType = te, s.lanes = f, s.stateNode = { isHidden: !1 }, s;
  }
  function Xh(s, a, f) {
    return s = zr(6, s, null, a), s.lanes = f, s;
  }
  function Zh(s, a, f) {
    return a = zr(4, s.children !== null ? s.children : [], s.key, a), a.lanes = f, a.stateNode = { containerInfo: s.containerInfo, pendingChildren: null, implementation: s.implementation }, a;
  }
  function G_(s, a, f, h, S) {
    this.tag = a, this.containerInfo = s, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = Cg(0), this.expirationTimes = Cg(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Cg(0), this.identifierPrefix = h, this.onRecoverableError = S, this.mutableSourceEagerHydrationData = null;
  }
  function Jh(s, a, f, h, S, _, M, U, X) {
    return s = new G_(s, a, f, U, X), a === 1 ? (a = 1, _ === !0 && (a |= 8)) : a = 0, _ = zr(3, null, null, a), s.current = _, _.stateNode = s, _.memoizedState = { element: h, isDehydrated: f, cache: null, transitions: null, pendingSuspenseBoundaries: null }, dh(_), s;
  }
  function K_(s, a, f) {
    var h = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: O, key: h == null ? null : "" + h, children: s, containerInfo: a, implementation: f };
  }
  function Nx(s) {
    if (!s)
      return Gs;
    s = s._reactInternals;
    e: {
      if (Di(s) !== s || s.tag !== 1)
        throw Error(n(170));
      var a = s;
      do {
        switch (a.tag) {
          case 3:
            a = a.stateNode.context;
            break e;
          case 1:
            if (tr(a.type)) {
              a = a.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        a = a.return;
      } while (a !== null);
      throw Error(n(171));
    }
    if (s.tag === 1) {
      var f = s.type;
      if (tr(f))
        return cb(s, f, a);
    }
    return a;
  }
  function $x(s, a, f, h, S, _, M, U, X) {
    return s = Jh(f, h, !0, s, S, _, M, U, X), s.context = Nx(null), f = s.current, h = Wn(), S = Qs(f), _ = hs(h, S), _.callback = a ?? null, Ys(f, _, S), s.current.lanes = S, Gl(s, S, h), or(s, h), s;
  }
  function tf(s, a, f, h) {
    var S = a.current, _ = Wn(), M = Qs(S);
    return f = Nx(f), a.context === null ? a.context = f : a.pendingContext = f, a = hs(_, M), a.payload = { element: s }, h = h === void 0 ? null : h, h !== null && (a.callback = h), s = Ys(S, a, M), s !== null && (fo(s, S, M, _), Md(s, S, M)), M;
  }
  function nf(s) {
    if (s = s.current, !s.child)
      return null;
    switch (s.child.tag) {
      case 5:
        return s.child.stateNode;
      default:
        return s.child.stateNode;
    }
  }
  function Dx(s, a) {
    if (s = s.memoizedState, s !== null && s.dehydrated !== null) {
      var f = s.retryLane;
      s.retryLane = f !== 0 && f < a ? f : a;
    }
  }
  function Qh(s, a) {
    Dx(s, a), (s = s.alternate) && Dx(s, a);
  }
  function q_() {
    return null;
  }
  var Ix = typeof reportError == "function" ? reportError : function(s) {
    console.error(s);
  };
  function em(s) {
    this._internalRoot = s;
  }
  rf.prototype.render = em.prototype.render = function(s) {
    var a = this._internalRoot;
    if (a === null)
      throw Error(n(409));
    tf(s, a, null, null);
  }, rf.prototype.unmount = em.prototype.unmount = function() {
    var s = this._internalRoot;
    if (s !== null) {
      this._internalRoot = null;
      var a = s.containerInfo;
      Gi(function() {
        tf(null, s, null, null);
      }), a[us] = null;
    }
  };
  function rf(s) {
    this._internalRoot = s;
  }
  rf.prototype.unstable_scheduleHydration = function(s) {
    if (s) {
      var a = wy();
      s = { blockedOn: null, target: s, priority: a };
      for (var f = 0; f < Fs.length && a !== 0 && a < Fs[f].priority; f++)
        ;
      Fs.splice(f, 0, s), f === 0 && Cy(s);
    }
  };
  function tm(s) {
    return !(!s || s.nodeType !== 1 && s.nodeType !== 9 && s.nodeType !== 11);
  }
  function of(s) {
    return !(!s || s.nodeType !== 1 && s.nodeType !== 9 && s.nodeType !== 11 && (s.nodeType !== 8 || s.nodeValue !== " react-mount-point-unstable "));
  }
  function Vx() {
  }
  function Y_(s, a, f, h, S) {
    if (S) {
      if (typeof h == "function") {
        var _ = h;
        h = function() {
          var ue = nf(M);
          _.call(ue);
        };
      }
      var M = $x(a, h, s, 0, null, !1, !1, "", Vx);
      return s._reactRootContainer = M, s[us] = M.current, ic(s.nodeType === 8 ? s.parentNode : s), Gi(), M;
    }
    for (; S = s.lastChild; )
      s.removeChild(S);
    if (typeof h == "function") {
      var U = h;
      h = function() {
        var ue = nf(X);
        U.call(ue);
      };
    }
    var X = Jh(s, 0, !1, null, null, !1, !1, "", Vx);
    return s._reactRootContainer = X, s[us] = X.current, ic(s.nodeType === 8 ? s.parentNode : s), Gi(function() {
      tf(a, X, f, h);
    }), X;
  }
  function sf(s, a, f, h, S) {
    var _ = f._reactRootContainer;
    if (_) {
      var M = _;
      if (typeof S == "function") {
        var U = S;
        S = function() {
          var X = nf(M);
          U.call(X);
        };
      }
      tf(a, M, s, S);
    } else
      M = Y_(f, a, s, S, h);
    return nf(M);
  }
  by = function(s) {
    switch (s.tag) {
      case 3:
        var a = s.stateNode;
        if (a.current.memoizedState.isDehydrated) {
          var f = Wl(a.pendingLanes);
          f !== 0 && (Eg(a, f | 1), or(a, on()), !(ht & 6) && (Wa = on() + 500, Ks()));
        }
        break;
      case 13:
        Gi(function() {
          var h = gs(s, 1);
          if (h !== null) {
            var S = Wn();
            fo(h, s, 1, S);
          }
        }), Qh(s, 1);
    }
  }, Pg = function(s) {
    if (s.tag === 13) {
      var a = gs(s, 134217728);
      if (a !== null) {
        var f = Wn();
        fo(a, s, 134217728, f);
      }
      Qh(s, 134217728);
    }
  }, xy = function(s) {
    if (s.tag === 13) {
      var a = Qs(s), f = gs(s, a);
      if (f !== null) {
        var h = Wn();
        fo(f, s, a, h);
      }
      Qh(s, a);
    }
  }, wy = function() {
    return Pt;
  }, Sy = function(s, a) {
    var f = Pt;
    try {
      return Pt = s, a();
    } finally {
      Pt = f;
    }
  }, $n = function(s, a, f) {
    switch (a) {
      case "input":
        if (Ot(s, f), a = f.name, f.type === "radio" && a != null) {
          for (f = s; f.parentNode; )
            f = f.parentNode;
          for (f = f.querySelectorAll("input[name=" + JSON.stringify("" + a) + '][type="radio"]'), a = 0; a < f.length; a++) {
            var h = f[a];
            if (h !== s && h.form === s.form) {
              var S = Sd(h);
              if (!S)
                throw Error(n(90));
              He(h), Ot(h, S);
            }
          }
        }
        break;
      case "textarea":
        Et(s, f);
        break;
      case "select":
        a = f.value, a != null && At(s, !!f.multiple, a, !1);
    }
  }, Nr = Gh, cs = Gi;
  var X_ = { usingClientEntryPoint: !1, Events: [cc, Ma, Sd, ko, hr, Gh] }, jc = { findFiberByHostInstance: Ii, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, Z_ = { bundleType: jc.bundleType, version: jc.version, rendererPackageName: jc.rendererPackageName, rendererConfig: jc.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: k.ReactCurrentDispatcher, findHostInstanceByFiber: function(s) {
    return s = dy(s), s === null ? null : s.stateNode;
  }, findFiberByHostInstance: jc.findFiberByHostInstance || q_, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var af = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!af.isDisabled && af.supportsFiber)
      try {
        rd = af.inject(Z_), To = af;
      } catch {
      }
  }
  return sr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = X_, sr.createPortal = function(s, a) {
    var f = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!tm(a))
      throw Error(n(200));
    return K_(s, a, null, f);
  }, sr.createRoot = function(s, a) {
    if (!tm(s))
      throw Error(n(299));
    var f = !1, h = "", S = Ix;
    return a != null && (a.unstable_strictMode === !0 && (f = !0), a.identifierPrefix !== void 0 && (h = a.identifierPrefix), a.onRecoverableError !== void 0 && (S = a.onRecoverableError)), a = Jh(s, 1, !1, null, null, f, !1, h, S), s[us] = a.current, ic(s.nodeType === 8 ? s.parentNode : s), new em(a);
  }, sr.findDOMNode = function(s) {
    if (s == null)
      return null;
    if (s.nodeType === 1)
      return s;
    var a = s._reactInternals;
    if (a === void 0)
      throw typeof s.render == "function" ? Error(n(188)) : (s = Object.keys(s).join(","), Error(n(268, s)));
    return s = dy(a), s = s === null ? null : s.stateNode, s;
  }, sr.flushSync = function(s) {
    return Gi(s);
  }, sr.hydrate = function(s, a, f) {
    if (!of(a))
      throw Error(n(200));
    return sf(null, s, a, !0, f);
  }, sr.hydrateRoot = function(s, a, f) {
    if (!tm(s))
      throw Error(n(405));
    var h = f != null && f.hydratedSources || null, S = !1, _ = "", M = Ix;
    if (f != null && (f.unstable_strictMode === !0 && (S = !0), f.identifierPrefix !== void 0 && (_ = f.identifierPrefix), f.onRecoverableError !== void 0 && (M = f.onRecoverableError)), a = $x(a, null, s, 1, f ?? null, S, !1, _, M), s[us] = a.current, ic(s), h)
      for (s = 0; s < h.length; s++)
        f = h[s], S = f._getVersion, S = S(f._source), a.mutableSourceEagerHydrationData == null ? a.mutableSourceEagerHydrationData = [f, S] : a.mutableSourceEagerHydrationData.push(
          f,
          S
        );
    return new rf(a);
  }, sr.render = function(s, a, f) {
    if (!of(a))
      throw Error(n(200));
    return sf(null, s, a, !1, f);
  }, sr.unmountComponentAtNode = function(s) {
    if (!of(s))
      throw Error(n(40));
    return s._reactRootContainer ? (Gi(function() {
      sf(null, null, s, !1, function() {
        s._reactRootContainer = null, s[us] = null;
      });
    }), !0) : !1;
  }, sr.unstable_batchedUpdates = Gh, sr.unstable_renderSubtreeIntoContainer = function(s, a, f, h) {
    if (!of(f))
      throw Error(n(200));
    if (s == null || s._reactInternals === void 0)
      throw Error(n(38));
    return sf(s, a, f, !1, h);
  }, sr.version = "18.3.1-next-f1338f8080-20240426", sr;
}
function cj() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(cj);
    } catch (e) {
      console.error(e);
    }
}
cj(), lj.exports = ok();
var Cr = lj.exports;
const Cv = /* @__PURE__ */ ju(Cr);
class sk extends Error {
  constructor(t, n) {
    super(t), this.error = t, this.errorData = n;
  }
}
const Ec = async (e, { onError: t, onLoading: n, onResult: r, params: o, rawText: i, ...l }) => {
  try {
    n == null || n(!0);
    const c = o ? new URLSearchParams(o).toString() : "", d = c ? `?${c}` : "", p = await fetch(`${e}${d}`, l);
    if (!p.ok) {
      const m = await p.json();
      throw new sk(m.error || "Request failed!", m.errorData);
    }
    const g = i ? await p.text() : await p.json();
    return r == null || r(g), g;
  } catch (c) {
    const d = c instanceof Error ? c : new Error(c);
    return t == null || t(d), d;
  } finally {
    n == null || n(!1);
  }
};
class ts {
  static async get(t, n) {
    return Ec(t, { ...n, method: "GET" });
  }
  static async post(t, n) {
    return Ec(t, { ...n, method: "POST" });
  }
  static async put(t, n) {
    return Ec(t, { ...n, method: "PUT" });
  }
  static async patch(t, n) {
    return Ec(t, { ...n, method: "PATCH" });
  }
  static async delete(t, n) {
    return Ec(t, { ...n, method: "DELETE" });
  }
}
function gt(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var ik = {};
function Op() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : ik;
}
var uj = Object.assign, np = Object.getOwnPropertyDescriptor, Ko = Object.defineProperty, Cu = Object.prototype, x1 = [];
Object.freeze(x1);
var Ev = {};
Object.freeze(Ev);
var ak = typeof Proxy < "u", lk = /* @__PURE__ */ Object.toString();
function dj() {
  ak || gt("Proxy not available");
}
function fj(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var rl = function() {
};
function So(e) {
  return typeof e == "function";
}
function ia(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function Lp(e) {
  return e !== null && typeof e == "object";
}
function Os(e) {
  if (!Lp(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n.toString() === lk;
}
function pj(e) {
  var t = e == null ? void 0 : e.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Eu(e, t, n) {
  Ko(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function gj(e, t, n) {
  Ko(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function Ci(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function(r) {
    return Lp(r) && r[n] === !0;
  };
}
function Ol(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function ck(e) {
  var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t), r = Object.getPrototypeOf(n);
  return r === null;
}
function Ss(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
var hj = typeof Object.getOwnPropertySymbols < "u";
function uk(e) {
  var t = Object.keys(e);
  if (!hj)
    return t;
  var n = Object.getOwnPropertySymbols(e);
  return n.length ? [].concat(t, n.filter(function(r) {
    return Cu.propertyIsEnumerable.call(e, r);
  })) : t;
}
var gl = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : hj ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function mj(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function _s(e, t) {
  return Cu.hasOwnProperty.call(e, t);
}
var dk = Object.getOwnPropertyDescriptors || function(t) {
  var n = {};
  return gl(t).forEach(function(r) {
    n[r] = np(t, r);
  }), n;
};
function Sr(e, t) {
  return !!(e & t);
}
function jr(e, t, n) {
  return n ? e |= t : e &= ~t, e;
}
function Wx(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Gx(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, pk(r.key), r);
  }
}
function Ll(e, t, n) {
  return t && Gx(e.prototype, t), n && Gx(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ol(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = gk(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aa() {
  return aa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, aa.apply(null, arguments);
}
function vj(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, w1(e, t);
}
function w1(e, t) {
  return w1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, w1(e, t);
}
function fk(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function pk(e) {
  var t = fk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function gk(e, t) {
  if (e) {
    if (typeof e == "string")
      return Wx(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Wx(e, t) : void 0;
  }
}
var Uo = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function qo(e) {
  function t(n, r) {
    if (_u(r))
      return e.decorate_20223_(n, r);
    Pu(n, r, e);
  }
  return Object.assign(t, e);
}
function Pu(e, t, n) {
  _s(e, Uo) || Eu(e, Uo, aa({}, e[Uo])), jk(n) || (e[Uo][t] = n);
}
function hk(e) {
  return _s(e, Uo) || Eu(e, Uo, aa({}, e[Uo])), e[Uo];
}
function _u(e) {
  return typeof e == "object" && typeof e.kind == "string";
}
var Ue = /* @__PURE__ */ Symbol("mobx administration"), Ei = /* @__PURE__ */ function() {
  function e(n) {
    n === void 0 && (n = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = xt.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.reportObserved = function() {
    return Aj(this);
  }, t.reportChanged = function() {
    qr(), Rj(this), Yr();
  }, t.toString = function() {
    return this.name_;
  }, Ll(e, [{
    key: "isBeingObserved",
    get: function() {
      return Sr(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return Sr(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return Sr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
Ei.isBeingObservedMask_ = 1;
Ei.isPendingUnobservationMask_ = 2;
Ei.diffValueMask_ = 4;
var Pv = /* @__PURE__ */ Ci("Atom", Ei);
function yj(e, t, n) {
  t === void 0 && (t = rl), n === void 0 && (n = rl);
  var r = new Ei(e);
  return t !== rl && TT(r, t), n !== rl && Fj(r, n), r;
}
function mk(e, t) {
  return e === t;
}
function vk(e, t) {
  return Mv(e, t);
}
function yk(e, t) {
  return Mv(e, t, 1);
}
function bk(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var hl = {
  identity: mk,
  structural: vk,
  default: bk,
  shallow: yk
};
function la(e, t, n) {
  return Tv(e) ? e : Array.isArray(e) ? An.array(e, {
    name: n
  }) : Os(e) ? An.object(e, void 0, {
    name: n
  }) : Ol(e) ? An.map(e, {
    name: n
  }) : Ss(e) ? An.set(e, {
    name: n
  }) : typeof e == "function" && !su(e) && !iu(e) ? pj(e) ? ua(e) : ou(n, e) : e;
}
function xk(e, t, n) {
  if (e == null || ml(e) || Mu(e) || Pi(e) || mo(e))
    return e;
  if (Array.isArray(e))
    return An.array(e, {
      name: n,
      deep: !1
    });
  if (Os(e))
    return An.object(e, void 0, {
      name: n,
      deep: !1
    });
  if (Ol(e))
    return An.map(e, {
      name: n,
      deep: !1
    });
  if (Ss(e))
    return An.set(e, {
      name: n,
      deep: !1
    });
}
function Mp(e) {
  return e;
}
function wk(e, t) {
  return Mv(e, t) ? t : e;
}
var Sk = "override";
function jk(e) {
  return e.annotationType_ === Sk;
}
function ku(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Ck,
    extend_: Ek,
    decorate_20223_: Pk
  };
}
function Ck(e, t, n, r) {
  var o;
  if ((o = this.options_) != null && o.bound)
    return this.extend_(e, t, n, !1) === null ? 0 : 1;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if (su(n.value))
    return 1;
  var i = bj(e, this, t, n, !1);
  return Ko(r, t, i), 2;
}
function Ek(e, t, n, r) {
  var o = bj(e, this, t, n);
  return e.defineProperty_(t, o, r);
}
function Pk(e, t) {
  var n = t.kind, r = t.name, o = t.addInitializer, i = this, l = function(p) {
    var g, m, v, b;
    return ca((g = (m = i.options_) == null ? void 0 : m.name) != null ? g : r.toString(), p, (v = (b = i.options_) == null ? void 0 : b.autoAction) != null ? v : !1);
  };
  if (n == "field")
    return function(d) {
      var p, g = d;
      return su(g) || (g = l(g)), (p = i.options_) != null && p.bound && (g = g.bind(this), g.isMobxAction = !0), g;
    };
  if (n == "method") {
    var c;
    return su(e) || (e = l(e)), (c = this.options_) != null && c.bound && o(function() {
      var d = this, p = d[r].bind(d);
      p.isMobxAction = !0, d[r] = p;
    }), e;
  }
  gt("Cannot apply '" + i.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + (`
'` + i.annotationType_ + "' can only be used on properties with a function value."));
}
function _k(e, t, n, r) {
  t.annotationType_, r.value;
}
function bj(e, t, n, r, o) {
  var i, l, c, d, p, g, m;
  o === void 0 && (o = Te.safeDescriptors), _k(e, t, n, r);
  var v = r.value;
  if ((i = t.options_) != null && i.bound) {
    var b;
    v = v.bind((b = e.proxy_) != null ? b : e.target_);
  }
  return {
    value: ca(
      (l = (c = t.options_) == null ? void 0 : c.name) != null ? l : n.toString(),
      v,
      (d = (p = t.options_) == null ? void 0 : p.autoAction) != null ? d : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (g = t.options_) != null && g.bound ? (m = e.proxy_) != null ? m : e.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: o ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !o
  };
}
function xj(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: kk,
    extend_: Tk,
    decorate_20223_: Ok
  };
}
function kk(e, t, n, r) {
  var o;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ((o = this.options_) != null && o.bound && (!_s(e.target_, t) || !iu(e.target_[t])) && this.extend_(e, t, n, !1) === null)
    return 0;
  if (iu(n.value))
    return 1;
  var i = wj(e, this, t, n, !1, !1);
  return Ko(r, t, i), 2;
}
function Tk(e, t, n, r) {
  var o, i = wj(e, this, t, n, (o = this.options_) == null ? void 0 : o.bound);
  return e.defineProperty_(t, i, r);
}
function Ok(e, t) {
  var n, r = t.name, o = t.addInitializer;
  return iu(e) || (e = ua(e)), (n = this.options_) != null && n.bound && o(function() {
    var i = this, l = i[r].bind(i);
    l.isMobXFlow = !0, i[r] = l;
  }), e;
}
function Lk(e, t, n, r) {
  t.annotationType_, r.value;
}
function wj(e, t, n, r, o, i) {
  i === void 0 && (i = Te.safeDescriptors), Lk(e, t, n, r);
  var l = r.value;
  if (iu(l) || (l = ua(l)), o) {
    var c;
    l = l.bind((c = e.proxy_) != null ? c : e.target_), l.isMobXFlow = !0;
  }
  return {
    value: l,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function _v(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: Mk,
    extend_: Ak,
    decorate_20223_: Rk
  };
}
function Mk(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Ak(e, t, n, r) {
  return Nk(e, this, t, n), e.defineComputedProperty_(t, aa({}, this.options_, {
    get: n.get,
    set: n.set
  }), r);
}
function Rk(e, t) {
  var n = this, r = t.name, o = t.addInitializer;
  return o(function() {
    var i = va(this)[Ue], l = aa({}, n.options_, {
      get: e,
      context: this
    });
    l.name || (l.name = "ObservableObject." + r.toString()), i.values_.set(r, new jo(l));
  }), function() {
    return this[Ue].getObservablePropValue_(r);
  };
}
function Nk(e, t, n, r) {
  t.annotationType_, r.get;
}
function Ap(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: $k,
    extend_: Dk,
    decorate_20223_: Ik
  };
}
function $k(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Dk(e, t, n, r) {
  var o, i;
  return Vk(e, this), e.defineObservableProperty_(t, n.value, (o = (i = this.options_) == null ? void 0 : i.enhancer) != null ? o : la, r);
}
function Ik(e, t) {
  var n = this, r = t.kind, o = t.name, i = /* @__PURE__ */ new WeakSet();
  function l(c, d) {
    var p, g, m = va(c)[Ue], v = new yi(d, (p = (g = n.options_) == null ? void 0 : g.enhancer) != null ? p : la, "ObservableObject." + o.toString(), !1);
    m.values_.set(o, v), i.add(c);
  }
  if (r == "accessor")
    return {
      get: function() {
        return i.has(this) || l(this, e.get.call(this)), this[Ue].getObservablePropValue_(o);
      },
      set: function(d) {
        return i.has(this) || l(this, d), this[Ue].setObservablePropValue_(o, d);
      },
      init: function(d) {
        return i.has(this) || l(this, d), d;
      }
    };
}
function Vk(e, t, n, r) {
  t.annotationType_;
}
var Hk = "true", Fk = /* @__PURE__ */ Sj();
function Sj(e) {
  return {
    annotationType_: Hk,
    options_: e,
    make_: zk,
    extend_: Bk,
    decorate_20223_: Uk
  };
}
function zk(e, t, n, r) {
  var o, i;
  if (n.get)
    return Rp.make_(e, t, n, r);
  if (n.set) {
    var l = ca(t.toString(), n.set);
    return r === e.target_ ? e.defineProperty_(t, {
      configurable: Te.safeDescriptors ? e.isPlainObject_ : !0,
      set: l
    }) === null ? 0 : 2 : (Ko(r, t, {
      configurable: !0,
      set: l
    }), 2);
  }
  if (r !== e.target_ && typeof n.value == "function") {
    var c;
    if (pj(n.value)) {
      var d, p = (d = this.options_) != null && d.autoBind ? ua.bound : ua;
      return p.make_(e, t, n, r);
    }
    var g = (c = this.options_) != null && c.autoBind ? ou.bound : ou;
    return g.make_(e, t, n, r);
  }
  var m = ((o = this.options_) == null ? void 0 : o.deep) === !1 ? An.ref : An;
  if (typeof n.value == "function" && (i = this.options_) != null && i.autoBind) {
    var v;
    n.value = n.value.bind((v = e.proxy_) != null ? v : e.target_);
  }
  return m.make_(e, t, n, r);
}
function Bk(e, t, n, r) {
  var o, i;
  if (n.get)
    return Rp.extend_(e, t, n, r);
  if (n.set)
    return e.defineProperty_(t, {
      configurable: Te.safeDescriptors ? e.isPlainObject_ : !0,
      set: ca(t.toString(), n.set)
    }, r);
  if (typeof n.value == "function" && (o = this.options_) != null && o.autoBind) {
    var l;
    n.value = n.value.bind((l = e.proxy_) != null ? l : e.target_);
  }
  var c = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? An.ref : An;
  return c.extend_(e, t, n, r);
}
function Uk(e, t) {
  gt("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var Wk = "observable", Gk = "observable.ref", Kk = "observable.shallow", qk = "observable.struct", jj = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(jj);
function lf(e) {
  return e || jj;
}
var S1 = /* @__PURE__ */ Ap(Wk), Yk = /* @__PURE__ */ Ap(Gk, {
  enhancer: Mp
}), Xk = /* @__PURE__ */ Ap(Kk, {
  enhancer: xk
}), Zk = /* @__PURE__ */ Ap(qk, {
  enhancer: wk
}), Cj = /* @__PURE__ */ qo(S1);
function cf(e) {
  return e.deep === !0 ? la : e.deep === !1 ? Mp : Qk(e.defaultDecorator);
}
function Jk(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : Sj(e) : void 0;
}
function Qk(e) {
  var t, n;
  return e && (t = (n = e.options_) == null ? void 0 : n.enhancer) != null ? t : la;
}
function Ej(e, t, n) {
  if (_u(t))
    return S1.decorate_20223_(e, t);
  if (ia(t)) {
    Pu(e, t, S1);
    return;
  }
  return Tv(e) ? e : Os(e) ? An.object(e, t, n) : Array.isArray(e) ? An.array(e, t) : Ol(e) ? An.map(e, t) : Ss(e) ? An.set(e, t) : typeof e == "object" && e !== null ? e : An.box(e, t);
}
uj(Ej, Cj);
var eT = {
  box: function(t, n) {
    var r = lf(n);
    return new yi(t, cf(r), r.name, !0, r.equals);
  },
  array: function(t, n) {
    var r = lf(n);
    return (Te.useProxies === !1 || r.proxy === !1 ? eO : UT)(t, cf(r), r.name);
  },
  map: function(t, n) {
    var r = lf(n);
    return new Kj(t, cf(r), r.name);
  },
  set: function(t, n) {
    var r = lf(n);
    return new qj(t, cf(r), r.name);
  },
  object: function(t, n, r) {
    return _i(function() {
      return Bj(Te.useProxies === !1 || (r == null ? void 0 : r.proxy) === !1 ? va({}, r) : HT({}, r), t, n);
    });
  },
  ref: /* @__PURE__ */ qo(Yk),
  shallow: /* @__PURE__ */ qo(Xk),
  deep: Cj,
  struct: /* @__PURE__ */ qo(Zk)
}, An = /* @__PURE__ */ uj(Ej, eT), Pj = "computed", tT = "computed.struct", j1 = /* @__PURE__ */ _v(Pj), nT = /* @__PURE__ */ _v(tT, {
  equals: hl.structural
}), Rp = function(t, n) {
  if (_u(n))
    return j1.decorate_20223_(t, n);
  if (ia(n))
    return Pu(t, n, j1);
  if (Os(t))
    return qo(_v(Pj, t));
  var r = Os(n) ? n : {};
  return r.get = t, r.name || (r.name = t.name || ""), new jo(r);
};
Object.assign(Rp, j1);
Rp.struct = /* @__PURE__ */ qo(nT);
var Kx, qx, rp = 0, rT = 1, oT = (Kx = (qx = /* @__PURE__ */ np(function() {
}, "name")) == null ? void 0 : qx.configurable) != null ? Kx : !1, Yx = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function ca(e, t, n, r) {
  n === void 0 && (n = !1);
  function o() {
    return sT(e, n, t, r || this, arguments);
  }
  return o.isMobxAction = !0, o.toString = function() {
    return t.toString();
  }, oT && (Yx.value = e, Ko(o, "name", Yx)), o;
}
function sT(e, t, n, r, o) {
  var i = iT(e, t);
  try {
    return n.apply(r, o);
  } catch (l) {
    throw i.error_ = l, l;
  } finally {
    aT(i);
  }
}
function iT(e, t, n, r) {
  var o = !1, i = 0, l = Te.trackingDerivation, c = !t || !l;
  qr();
  var d = Te.allowStateChanges;
  c && (ma(), d = Np(!0));
  var p = kv(!0), g = {
    runAsAction_: c,
    prevDerivation_: l,
    prevAllowStateChanges_: d,
    prevAllowStateReads_: p,
    notifySpy_: o,
    startTime_: i,
    actionId_: rT++,
    parentActionId_: rp
  };
  return rp = g.actionId_, g;
}
function aT(e) {
  rp !== e.actionId_ && gt(30), rp = e.parentActionId_, e.error_ !== void 0 && (Te.suppressReactionErrors = !0), $p(e.prevAllowStateChanges_), Hc(e.prevAllowStateReads_), Yr(), e.runAsAction_ && ks(e.prevDerivation_), Te.suppressReactionErrors = !1;
}
function lT(e, t) {
  var n = Np(e);
  try {
    return t();
  } finally {
    $p(n);
  }
}
function Np(e) {
  var t = Te.allowStateChanges;
  return Te.allowStateChanges = e, t;
}
function $p(e) {
  Te.allowStateChanges = e;
}
var yi = /* @__PURE__ */ function(e) {
  function t(r, o, i, l, c) {
    var d;
    return i === void 0 && (i = "ObservableValue"), c === void 0 && (c = hl.default), d = e.call(this, i) || this, d.enhancer = void 0, d.name_ = void 0, d.equals = void 0, d.hasUnreportedChange_ = !1, d.interceptors_ = void 0, d.changeListeners_ = void 0, d.value_ = void 0, d.dehancer = void 0, d.enhancer = o, d.name_ = i, d.equals = c, d.value_ = o(r, void 0, i), d;
  }
  vj(t, e);
  var n = t.prototype;
  return n.dehanceValue = function(o) {
    return this.dehancer !== void 0 ? this.dehancer(o) : o;
  }, n.set = function(o) {
    this.value_, o = this.prepareNewValue_(o), o !== Te.UNCHANGED && this.setNewValue_(o);
  }, n.prepareNewValue_ = function(o) {
    if (Gr(this)) {
      var i = Kr(this, {
        object: this,
        type: Yo,
        newValue: o
      });
      if (!i)
        return Te.UNCHANGED;
      o = i.newValue;
    }
    return o = this.enhancer(o, this.value_, this.name_), this.equals(this.value_, o) ? Te.UNCHANGED : o;
  }, n.setNewValue_ = function(o) {
    var i = this.value_;
    this.value_ = o, this.reportChanged(), yo(this) && bo(this, {
      type: Yo,
      object: this,
      newValue: o,
      oldValue: i
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(o) {
    return Ou(this, o);
  }, n.observe_ = function(o, i) {
    return i && o({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: Yo,
      newValue: this.value_,
      oldValue: void 0
    }), Lu(this, o);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return mj(this.get());
  }, n[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, t;
}(Ei), cT = /* @__PURE__ */ Ci("ObservableValue", yi), jo = /* @__PURE__ */ function() {
  function e(n) {
    this.dependenciesState_ = xt.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = xt.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new sp(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = op.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || gt(31), this.derivation = n.get, this.name_ = n.name || "ComputedValue", n.set && (this.setter_ = ca("ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? hl.structural : hl.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    gT(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.get = function() {
    if (this.isComputing && gt(32, this.name_, this.derivation), Te.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      C1(this) && (this.warnAboutUntrackedRead_(), qr(), this.value_ = this.computeValue_(!1), Yr());
    else if (Aj(this), C1(this)) {
      var r = Te.trackingContext;
      this.keepAlive_ && !r && (Te.trackingContext = this), this.trackAndCompute() && pT(this), Te.trackingContext = r;
    }
    var o = this.value_;
    if (Kf(o))
      throw o.cause;
    return o;
  }, t.set = function(r) {
    if (this.setter_) {
      this.isRunningSetter && gt(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, r);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      gt(34, this.name_);
  }, t.trackAndCompute = function() {
    var r = this.value_, o = (
      /* see #1208 */
      this.dependenciesState_ === xt.NOT_TRACKING_
    ), i = this.computeValue_(!0), l = o || Kf(r) || Kf(i) || !this.equals_(r, i);
    return l && (this.value_ = i), l;
  }, t.computeValue_ = function(r) {
    this.isComputing = !0;
    var o = Np(!1), i;
    if (r)
      i = _j(this, this.derivation, this.scope_);
    else if (Te.disableErrorBoundaries === !0)
      i = this.derivation.call(this.scope_);
    else
      try {
        i = this.derivation.call(this.scope_);
      } catch (l) {
        i = new sp(l);
      }
    return $p(o), this.isComputing = !1, i;
  }, t.suspend_ = function() {
    this.keepAlive_ || (E1(this), this.value_ = void 0);
  }, t.observe_ = function(r, o) {
    var i = this, l = !0, c = void 0;
    return CT(function() {
      var d = i.get();
      if (!l || o) {
        var p = ma();
        r({
          observableKind: "computed",
          debugObjectName: i.name_,
          type: Yo,
          object: i,
          newValue: d,
          oldValue: c
        }), ks(p);
      }
      l = !1, c = d;
    });
  }, t.warnAboutUntrackedRead_ = function() {
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return mj(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, Ll(e, [{
    key: "isComputing",
    get: function() {
      return Sr(this.flags_, e.isComputingMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isComputingMask_, r);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return Sr(this.flags_, e.isRunningSetterMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isRunningSetterMask_, r);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return Sr(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return Sr(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return Sr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
jo.isComputingMask_ = 1;
jo.isRunningSetterMask_ = 2;
jo.isBeingObservedMask_ = 4;
jo.isPendingUnobservationMask_ = 8;
jo.diffValueMask_ = 16;
var Tu = /* @__PURE__ */ Ci("ComputedValue", jo), xt;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(xt || (xt = {}));
var op;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(op || (op = {}));
var sp = function(t) {
  this.cause = void 0, this.cause = t;
};
function Kf(e) {
  return e instanceof sp;
}
function C1(e) {
  switch (e.dependenciesState_) {
    case xt.UP_TO_DATE_:
      return !1;
    case xt.NOT_TRACKING_:
    case xt.STALE_:
      return !0;
    case xt.POSSIBLY_STALE_: {
      for (var t = kv(!0), n = ma(), r = e.observing_, o = r.length, i = 0; i < o; i++) {
        var l = r[i];
        if (Tu(l)) {
          if (Te.disableErrorBoundaries)
            l.get();
          else
            try {
              l.get();
            } catch {
              return ks(n), Hc(t), !0;
            }
          if (e.dependenciesState_ === xt.STALE_)
            return ks(n), Hc(t), !0;
        }
      }
      return Tj(e), ks(n), Hc(t), !1;
    }
  }
}
function _j(e, t, n) {
  var r = kv(!0);
  Tj(e), e.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    e.runId_ === 0 ? 100 : e.observing_.length
  ), e.unboundDepsCount_ = 0, e.runId_ = ++Te.runId;
  var o = Te.trackingDerivation;
  Te.trackingDerivation = e, Te.inBatch++;
  var i;
  if (Te.disableErrorBoundaries === !0)
    i = t.call(n);
  else
    try {
      i = t.call(n);
    } catch (l) {
      i = new sp(l);
    }
  return Te.inBatch--, Te.trackingDerivation = o, uT(e), Hc(r), i;
}
function uT(e) {
  for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = xt.UP_TO_DATE_, o = 0, i = e.unboundDepsCount_, l = 0; l < i; l++) {
    var c = n[l];
    c.diffValue === 0 && (c.diffValue = 1, o !== l && (n[o] = c), o++), c.dependenciesState_ > r && (r = c.dependenciesState_);
  }
  for (n.length = o, e.newObserving_ = null, i = t.length; i--; ) {
    var d = t[i];
    d.diffValue === 0 && Lj(d, e), d.diffValue = 0;
  }
  for (; o--; ) {
    var p = n[o];
    p.diffValue === 1 && (p.diffValue = 0, fT(p, e));
  }
  r !== xt.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function E1(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var n = t.length; n--; )
    Lj(t[n], e);
  e.dependenciesState_ = xt.NOT_TRACKING_;
}
function kj(e) {
  var t = ma();
  try {
    return e();
  } finally {
    ks(t);
  }
}
function ma() {
  var e = Te.trackingDerivation;
  return Te.trackingDerivation = null, e;
}
function ks(e) {
  Te.trackingDerivation = e;
}
function kv(e) {
  var t = Te.allowStateReads;
  return Te.allowStateReads = e, t;
}
function Hc(e) {
  Te.allowStateReads = e;
}
function Tj(e) {
  if (e.dependenciesState_ !== xt.UP_TO_DATE_) {
    e.dependenciesState_ = xt.UP_TO_DATE_;
    for (var t = e.observing_, n = t.length; n--; )
      t[n].lowestObserverState_ = xt.UP_TO_DATE_;
  }
}
var qf = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, Yf = !0, Oj = !1, Te = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ Op();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (Yf = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new qf().version && (Yf = !1), Yf ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new qf()) : (setTimeout(function() {
    Oj || gt(35);
  }, 1), new qf());
}();
function dT() {
  if ((Te.pendingReactions.length || Te.inBatch || Te.isRunningReactions) && gt(36), Oj = !0, Yf) {
    var e = Op();
    --e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), Te = new qf();
  }
}
function fT(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function Lj(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && Mj(e);
}
function Mj(e) {
  e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, Te.pendingUnobservations.push(e));
}
function qr() {
  Te.inBatch++;
}
function Yr() {
  if (--Te.inBatch === 0) {
    Nj();
    for (var e = Te.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof jo && n.suspend_());
    }
    Te.pendingUnobservations = [];
  }
}
function Aj(e) {
  var t = Te.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && Te.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (e.observers_.size === 0 && Te.inBatch > 0 && Mj(e), !1);
}
function Rj(e) {
  e.lowestObserverState_ !== xt.STALE_ && (e.lowestObserverState_ = xt.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === xt.UP_TO_DATE_ && t.onBecomeStale_(), t.dependenciesState_ = xt.STALE_;
  }));
}
function pT(e) {
  e.lowestObserverState_ !== xt.STALE_ && (e.lowestObserverState_ = xt.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === xt.POSSIBLY_STALE_ ? t.dependenciesState_ = xt.STALE_ : t.dependenciesState_ === xt.UP_TO_DATE_ && (e.lowestObserverState_ = xt.UP_TO_DATE_);
  }));
}
function gT(e) {
  e.lowestObserverState_ === xt.UP_TO_DATE_ && (e.lowestObserverState_ = xt.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === xt.UP_TO_DATE_ && (t.dependenciesState_ = xt.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
var Jo = /* @__PURE__ */ function() {
  function e(n, r, o, i) {
    n === void 0 && (n = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = xt.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = op.NONE, this.name_ = n, this.onInvalidate_ = r, this.errorHandler_ = o, this.requiresObservable_ = i;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, Te.pendingReactions.push(this), Nj());
  }, t.runReaction_ = function() {
    if (!this.isDisposed) {
      qr(), this.isScheduled = !1;
      var r = Te.trackingContext;
      if (Te.trackingContext = this, C1(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_();
        } catch (o) {
          this.reportExceptionInDerivation_(o);
        }
      }
      Te.trackingContext = r, Yr();
    }
  }, t.track = function(r) {
    if (!this.isDisposed) {
      qr(), this.isRunning = !0;
      var o = Te.trackingContext;
      Te.trackingContext = this;
      var i = _j(this, r, void 0);
      Te.trackingContext = o, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && E1(this), Kf(i) && this.reportExceptionInDerivation_(i.cause), Yr();
    }
  }, t.reportExceptionInDerivation_ = function(r) {
    var o = this;
    if (this.errorHandler_) {
      this.errorHandler_(r, this);
      return;
    }
    if (Te.disableErrorBoundaries)
      throw r;
    var i = "[mobx] uncaught error in '" + this + "'";
    Te.suppressReactionErrors || console.error(i, r), Te.globalReactionErrorHandlers.forEach(function(l) {
      return l(r, o);
    });
  }, t.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (qr(), E1(this), Yr()));
  }, t.getDisposer_ = function(r) {
    var o = this, i = function l() {
      o.dispose(), r == null || r.removeEventListener == null || r.removeEventListener("abort", l);
    };
    return r == null || r.addEventListener == null || r.addEventListener("abort", i), i[Ue] = this, i;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(r) {
  }, Ll(e, [{
    key: "isDisposed",
    get: function() {
      return Sr(this.flags_, e.isDisposedMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isDisposedMask_, r);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return Sr(this.flags_, e.isScheduledMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isScheduledMask_, r);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return Sr(this.flags_, e.isTrackPendingMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isTrackPendingMask_, r);
    }
  }, {
    key: "isRunning",
    get: function() {
      return Sr(this.flags_, e.isRunningMask_);
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.isRunningMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return Sr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = jr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
}();
Jo.isDisposedMask_ = 1;
Jo.isScheduledMask_ = 2;
Jo.isTrackPendingMask_ = 4;
Jo.isRunningMask_ = 8;
Jo.diffValueMask_ = 16;
var hT = 100, P1 = function(t) {
  return t();
};
function Nj() {
  Te.inBatch > 0 || Te.isRunningReactions || P1(mT);
}
function mT() {
  Te.isRunningReactions = !0;
  for (var e = Te.pendingReactions, t = 0; e.length > 0; ) {
    ++t === hT && (console.error("[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var n = e.splice(0), r = 0, o = n.length; r < o; r++)
      n[r].runReaction_();
  }
  Te.isRunningReactions = !1;
}
var ip = /* @__PURE__ */ Ci("Reaction", Jo);
function vT(e) {
  var t = P1;
  P1 = function(r) {
    return e(function() {
      return t(r);
    });
  };
}
function Fc() {
  return !1;
}
function yT(e) {
  return console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  };
}
var $j = "action", bT = "action.bound", Dj = "autoAction", xT = "autoAction.bound", wT = "<unnamed action>", _1 = /* @__PURE__ */ ku($j), ST = /* @__PURE__ */ ku(bT, {
  bound: !0
}), k1 = /* @__PURE__ */ ku(Dj, {
  autoAction: !0
}), jT = /* @__PURE__ */ ku(xT, {
  autoAction: !0,
  bound: !0
});
function Ij(e) {
  var t = function(r, o) {
    if (So(r))
      return ca(r.name || wT, r, e);
    if (So(o))
      return ca(r, o, e);
    if (_u(o))
      return (e ? k1 : _1).decorate_20223_(r, o);
    if (ia(o))
      return Pu(r, o, e ? k1 : _1);
    if (ia(r))
      return qo(ku(e ? Dj : $j, {
        name: r,
        autoAction: e
      }));
  };
  return t;
}
var Ji = /* @__PURE__ */ Ij(!1);
Object.assign(Ji, _1);
var ou = /* @__PURE__ */ Ij(!0);
Object.assign(ou, k1);
Ji.bound = /* @__PURE__ */ qo(ST);
ou.bound = /* @__PURE__ */ qo(jT);
function su(e) {
  return So(e) && e.isMobxAction === !0;
}
function CT(e, t) {
  var n, r, o, i;
  t === void 0 && (t = Ev);
  var l = (n = (r = t) == null ? void 0 : r.name) != null ? n : "Autorun", c = !t.scheduler && !t.delay, d;
  if (c)
    d = new Jo(l, function() {
      this.track(m);
    }, t.onError, t.requiresObservable);
  else {
    var p = Vj(t), g = !1;
    d = new Jo(l, function() {
      g || (g = !0, p(function() {
        g = !1, d.isDisposed || d.track(m);
      }));
    }, t.onError, t.requiresObservable);
  }
  function m() {
    e(d);
  }
  return (o = t) != null && (o = o.signal) != null && o.aborted || d.schedule_(), d.getDisposer_((i = t) == null ? void 0 : i.signal);
}
var ET = function(t) {
  return t();
};
function Vj(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : ET;
}
function Hj(e, t, n) {
  var r, o, i;
  n === void 0 && (n = Ev);
  var l = (r = n.name) != null ? r : "Reaction", c = Ji(l, n.onError ? PT(n.onError, t) : t), d = !n.scheduler && !n.delay, p = Vj(n), g = !0, m = !1, v, b = n.compareStructural ? hl.structural : n.equals || hl.default, x = new Jo(l, function() {
    g || d ? w() : m || (m = !0, p(w));
  }, n.onError, n.requiresObservable);
  function w() {
    if (m = !1, !x.isDisposed) {
      var j = !1, C = v;
      x.track(function() {
        var E = lT(!1, function() {
          return e(x);
        });
        j = g || !b(v, E), v = E;
      }), (g && n.fireImmediately || !g && j) && c(v, C, x), g = !1;
    }
  }
  return (o = n) != null && (o = o.signal) != null && o.aborted || x.schedule_(), x.getDisposer_((i = n) == null ? void 0 : i.signal);
}
function PT(e, t) {
  return function() {
    try {
      return t.apply(this, arguments);
    } catch (n) {
      e.call(this, n);
    }
  };
}
var _T = "onBO", kT = "onBUO";
function TT(e, t, n) {
  return zj(_T, e, t, n);
}
function Fj(e, t, n) {
  return zj(kT, e, t, n);
}
function zj(e, t, n, r) {
  var o = typeof r == "function" ? vl(t, n) : vl(t), i = So(r) ? r : n, l = e + "L";
  return o[l] ? o[l].add(i) : o[l] = /* @__PURE__ */ new Set([i]), function() {
    var c = o[l];
    c && (c.delete(i), c.size === 0 && delete o[l]);
  };
}
var OT = "never", uf = "always", LT = "observed";
function MT(e) {
  e.isolateGlobalState === !0 && dT();
  var t = e.useProxies, n = e.enforceActions;
  if (t !== void 0 && (Te.useProxies = t === uf ? !0 : t === OT ? !1 : typeof Proxy < "u"), t === "ifavailable" && (Te.verifyProxies = !0), n !== void 0) {
    var r = n === uf ? uf : n === LT;
    Te.enforceActions = r, Te.allowStateChanges = !(r === !0 || r === uf);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(o) {
    o in e && (Te[o] = !!e[o]);
  }), Te.allowStateReads = !Te.observableRequiresReaction, e.reactionScheduler && vT(e.reactionScheduler);
}
function Bj(e, t, n, r) {
  var o = dk(t);
  return _i(function() {
    var i = va(e, r)[Ue];
    gl(o).forEach(function(l) {
      i.extend_(
        l,
        o[l],
        // must pass "undefined" for { key: undefined }
        n && l in n ? n[l] : !0
      );
    });
  }), e;
}
function AT(e, t) {
  return Uj(vl(e, t));
}
function Uj(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = RT(e.observing_).map(Uj)), t;
}
function RT(e) {
  return Array.from(new Set(e));
}
var NT = 0;
function Wj() {
  this.message = "FLOW_CANCELLED";
}
Wj.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var om = /* @__PURE__ */ xj("flow"), $T = /* @__PURE__ */ xj("flow.bound", {
  bound: !0
}), ua = /* @__PURE__ */ Object.assign(function(t, n) {
  if (_u(n))
    return om.decorate_20223_(t, n);
  if (ia(n))
    return Pu(t, n, om);
  var r = t, o = r.name || "<unnamed flow>", i = function() {
    var c = this, d = arguments, p = ++NT, g = Ji(o + " - runid: " + p + " - init", r).apply(c, d), m, v = void 0, b = new Promise(function(x, w) {
      var j = 0;
      m = w;
      function C(k) {
        v = void 0;
        var T;
        try {
          T = Ji(o + " - runid: " + p + " - yield " + j++, g.next).call(g, k);
        } catch (O) {
          return w(O);
        }
        P(T);
      }
      function E(k) {
        v = void 0;
        var T;
        try {
          T = Ji(o + " - runid: " + p + " - yield " + j++, g.throw).call(g, k);
        } catch (O) {
          return w(O);
        }
        P(T);
      }
      function P(k) {
        if (So(k == null ? void 0 : k.then)) {
          k.then(P, w);
          return;
        }
        return k.done ? x(k.value) : (v = Promise.resolve(k.value), v.then(C, E));
      }
      C(void 0);
    });
    return b.cancel = Ji(o + " - runid: " + p + " - cancel", function() {
      try {
        v && Xx(v);
        var x = g.return(void 0), w = Promise.resolve(x.value);
        w.then(rl, rl), Xx(w), m(new Wj());
      } catch (j) {
        m(j);
      }
    }), b;
  };
  return i.isMobXFlow = !0, i;
}, om);
ua.bound = /* @__PURE__ */ qo($T);
function Xx(e) {
  So(e.cancel) && e.cancel();
}
function iu(e) {
  return (e == null ? void 0 : e.isMobXFlow) === !0;
}
function DT(e, t) {
  return e ? t !== void 0 ? ml(e) ? e[Ue].values_.has(t) : !1 : ml(e) || !!e[Ue] || Pv(e) || ip(e) || Tu(e) : !1;
}
function Tv(e) {
  return DT(e);
}
function IT(e) {
  if (ml(e))
    return e[Ue].ownKeys_();
  gt(38);
}
function df(e, t, n) {
  return e.set(t, n), n;
}
function el(e, t) {
  if (e == null || typeof e != "object" || e instanceof Date || !Tv(e))
    return e;
  if (cT(e) || Tu(e))
    return el(e.get(), t);
  if (t.has(e))
    return t.get(e);
  if (Mu(e)) {
    var n = df(t, e, new Array(e.length));
    return e.forEach(function(l, c) {
      n[c] = el(l, t);
    }), n;
  }
  if (mo(e)) {
    var r = df(t, e, /* @__PURE__ */ new Set());
    return e.forEach(function(l) {
      r.add(el(l, t));
    }), r;
  }
  if (Pi(e)) {
    var o = df(t, e, /* @__PURE__ */ new Map());
    return e.forEach(function(l, c) {
      o.set(c, el(l, t));
    }), o;
  } else {
    var i = df(t, e, {});
    return IT(e).forEach(function(l) {
      Cu.propertyIsEnumerable.call(e, l) && (i[l] = el(e[l], t));
    }), i;
  }
}
function gi(e, t) {
  return el(e, /* @__PURE__ */ new Map());
}
function js(e, t) {
  t === void 0 && (t = void 0), qr();
  try {
    return e.apply(t);
  } finally {
    Yr();
  }
}
function Ka(e) {
  return e[Ue];
}
var VT = {
  has: function(t, n) {
    return Ka(t).has_(n);
  },
  get: function(t, n) {
    return Ka(t).get_(n);
  },
  set: function(t, n, r) {
    var o;
    return ia(n) ? (o = Ka(t).set_(n, r, !0)) != null ? o : !0 : !1;
  },
  deleteProperty: function(t, n) {
    var r;
    return ia(n) ? (r = Ka(t).delete_(n, !0)) != null ? r : !0 : !1;
  },
  defineProperty: function(t, n, r) {
    var o;
    return (o = Ka(t).defineProperty_(n, r)) != null ? o : !0;
  },
  ownKeys: function(t) {
    return Ka(t).ownKeys_();
  },
  preventExtensions: function(t) {
    gt(13);
  }
};
function HT(e, t) {
  var n, r;
  return dj(), e = va(e, t), (r = (n = e[Ue]).proxy_) != null ? r : n.proxy_ = new Proxy(e, VT);
}
function Gr(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function Ou(e, t) {
  var n = e.interceptors_ || (e.interceptors_ = []);
  return n.push(t), fj(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function Kr(e, t) {
  var n = ma();
  try {
    for (var r = [].concat(e.interceptors_ || []), o = 0, i = r.length; o < i && (t = r[o](t), t && !t.type && gt(14), !!t); o++)
      ;
    return t;
  } finally {
    ks(n);
  }
}
function yo(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function Lu(e, t) {
  var n = e.changeListeners_ || (e.changeListeners_ = []);
  return n.push(t), fj(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function bo(e, t) {
  var n = ma(), r = e.changeListeners_;
  if (r) {
    r = r.slice();
    for (var o = 0, i = r.length; o < i; o++)
      r[o](t);
    ks(n);
  }
}
function FT(e, t, n) {
  return _i(function() {
    var r, o = va(e, n)[Ue];
    (r = t) != null || (t = hk(e)), gl(t).forEach(function(i) {
      return o.make_(i, t[i]);
    });
  }), e;
}
var sm = /* @__PURE__ */ Symbol("mobx-keys");
function Yn(e, t, n) {
  return Os(e) ? Bj(e, e, t, n) : (_i(function() {
    var r = va(e, n)[Ue];
    if (!e[sm]) {
      var o = Object.getPrototypeOf(e), i = new Set([].concat(gl(e), gl(o)));
      i.delete("constructor"), i.delete(Ue), Eu(o, sm, i);
    }
    e[sm].forEach(function(l) {
      return r.make_(
        l,
        // must pass "undefined" for { key: undefined }
        t && l in t ? t[l] : !0
      );
    });
  }), e);
}
var Zx = "splice", Yo = "update", zT = 1e4, BT = {
  get: function(t, n) {
    var r = t[Ue];
    return n === Ue ? r : n === "length" ? r.getArrayLength_() : typeof n == "string" && !isNaN(n) ? r.get_(parseInt(n)) : _s(ap, n) ? ap[n] : t[n];
  },
  set: function(t, n, r) {
    var o = t[Ue];
    return n === "length" && o.setArrayLength_(r), typeof n == "symbol" || isNaN(n) ? t[n] = r : o.set_(parseInt(n), r), !0;
  },
  preventExtensions: function() {
    gt(15);
  }
}, Ov = /* @__PURE__ */ function() {
  function e(n, r, o, i) {
    n === void 0 && (n = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = o, this.legacyMode_ = i, this.atom_ = new Ei(n), this.enhancer_ = function(l, c) {
      return r(l, c, "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.dehanceValues_ = function(r) {
    return this.dehancer !== void 0 && r.length > 0 ? r.map(this.dehancer) : r;
  }, t.intercept_ = function(r) {
    return Ou(this, r);
  }, t.observe_ = function(r, o) {
    return o === void 0 && (o = !1), o && r({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), Lu(this, r);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(r) {
    (typeof r != "number" || isNaN(r) || r < 0) && gt("Out of range: " + r);
    var o = this.values_.length;
    if (r !== o)
      if (r > o) {
        for (var i = new Array(r - o), l = 0; l < r - o; l++)
          i[l] = void 0;
        this.spliceWithArray_(o, 0, i);
      } else
        this.spliceWithArray_(r, o - r);
  }, t.updateArrayLength_ = function(r, o) {
    r !== this.lastKnownLength_ && gt(16), this.lastKnownLength_ += o, this.legacyMode_ && o > 0 && Jj(r + o + 1);
  }, t.spliceWithArray_ = function(r, o, i) {
    var l = this;
    this.atom_;
    var c = this.values_.length;
    if (r === void 0 ? r = 0 : r > c ? r = c : r < 0 && (r = Math.max(0, c + r)), arguments.length === 1 ? o = c - r : o == null ? o = 0 : o = Math.max(0, Math.min(o, c - r)), i === void 0 && (i = x1), Gr(this)) {
      var d = Kr(this, {
        object: this.proxy_,
        type: Zx,
        index: r,
        removedCount: o,
        added: i
      });
      if (!d)
        return x1;
      o = d.removedCount, i = d.added;
    }
    if (i = i.length === 0 ? i : i.map(function(m) {
      return l.enhancer_(m, void 0);
    }), this.legacyMode_) {
      var p = i.length - o;
      this.updateArrayLength_(c, p);
    }
    var g = this.spliceItemsIntoValues_(r, o, i);
    return (o !== 0 || i.length !== 0) && this.notifyArraySplice_(r, i, g), this.dehanceValues_(g);
  }, t.spliceItemsIntoValues_ = function(r, o, i) {
    if (i.length < zT) {
      var l;
      return (l = this.values_).splice.apply(l, [r, o].concat(i));
    } else {
      var c = this.values_.slice(r, r + o), d = this.values_.slice(r + o);
      this.values_.length += i.length - o;
      for (var p = 0; p < i.length; p++)
        this.values_[r + p] = i[p];
      for (var g = 0; g < d.length; g++)
        this.values_[r + i.length + g] = d[g];
      return c;
    }
  }, t.notifyArrayChildUpdate_ = function(r, o, i) {
    var l = !this.owned_ && Fc(), c = yo(this), d = c || l ? {
      observableKind: "array",
      object: this.proxy_,
      type: Yo,
      debugObjectName: this.atom_.name_,
      index: r,
      newValue: o,
      oldValue: i
    } : null;
    this.atom_.reportChanged(), c && bo(this, d);
  }, t.notifyArraySplice_ = function(r, o, i) {
    var l = !this.owned_ && Fc(), c = yo(this), d = c || l ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: Zx,
      index: r,
      removed: i,
      added: o,
      removedCount: i.length,
      addedCount: o.length
    } : null;
    this.atom_.reportChanged(), c && bo(this, d);
  }, t.get_ = function(r) {
    if (this.legacyMode_ && r >= this.values_.length) {
      console.warn("[mobx] Out of bounds read: " + r);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[r]);
  }, t.set_ = function(r, o) {
    var i = this.values_;
    if (this.legacyMode_ && r > i.length && gt(17, r, i.length), r < i.length) {
      this.atom_;
      var l = i[r];
      if (Gr(this)) {
        var c = Kr(this, {
          type: Yo,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: r,
          newValue: o
        });
        if (!c)
          return;
        o = c.newValue;
      }
      o = this.enhancer_(o, l);
      var d = o !== l;
      d && (i[r] = o, this.notifyArrayChildUpdate_(r, o, l));
    } else {
      for (var p = new Array(r + 1 - i.length), g = 0; g < p.length - 1; g++)
        p[g] = void 0;
      p[p.length - 1] = o, this.spliceWithArray_(i.length, 0, p);
    }
  }, e;
}();
function UT(e, t, n, r) {
  return n === void 0 && (n = "ObservableArray"), r === void 0 && (r = !1), dj(), _i(function() {
    var o = new Ov(n, t, r, !1);
    gj(o.values_, Ue, o);
    var i = new Proxy(o.values_, BT);
    return o.proxy_ = i, e && e.length && o.spliceWithArray_(0, 0, e), i;
  });
}
var ap = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var n = this[Ue];
    return n.spliceWithArray_(0, n.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, n) {
    for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)
      o[i - 2] = arguments[i];
    var l = this[Ue];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return l.spliceWithArray_(t);
      case 2:
        return l.spliceWithArray_(t, n);
    }
    return l.spliceWithArray_(t, n, o);
  },
  spliceWithArray: function(t, n, r) {
    return this[Ue].spliceWithArray_(t, n, r);
  },
  push: function() {
    for (var t = this[Ue], n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.spliceWithArray_(t.values_.length, 0, r), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[Ue].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[Ue], n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.spliceWithArray_(0, 0, r), t.values_.length;
  },
  reverse: function() {
    return Te.trackingDerivation && gt(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    Te.trackingDerivation && gt(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var n = this[Ue], r = n.dehanceValues_(n.values_).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }
};
Ft("at", Mr);
Ft("concat", Mr);
Ft("flat", Mr);
Ft("includes", Mr);
Ft("indexOf", Mr);
Ft("join", Mr);
Ft("lastIndexOf", Mr);
Ft("slice", Mr);
Ft("toString", Mr);
Ft("toLocaleString", Mr);
Ft("toSorted", Mr);
Ft("toSpliced", Mr);
Ft("with", Mr);
Ft("every", Co);
Ft("filter", Co);
Ft("find", Co);
Ft("findIndex", Co);
Ft("findLast", Co);
Ft("findLastIndex", Co);
Ft("flatMap", Co);
Ft("forEach", Co);
Ft("map", Co);
Ft("some", Co);
Ft("toReversed", Co);
Ft("reduce", Gj);
Ft("reduceRight", Gj);
function Ft(e, t) {
  typeof Array.prototype[e] == "function" && (ap[e] = t(e));
}
function Mr(e) {
  return function() {
    var t = this[Ue];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_);
    return n[e].apply(n, arguments);
  };
}
function Co(e) {
  return function(t, n) {
    var r = this, o = this[Ue];
    o.atom_.reportObserved();
    var i = o.dehanceValues_(o.values_);
    return i[e](function(l, c) {
      return t.call(n, l, c, r);
    });
  };
}
function Gj(e) {
  return function() {
    var t = this, n = this[Ue];
    n.atom_.reportObserved();
    var r = n.dehanceValues_(n.values_), o = arguments[0];
    return arguments[0] = function(i, l, c) {
      return o(i, l, c, t);
    }, r[e].apply(r, arguments);
  };
}
var WT = /* @__PURE__ */ Ci("ObservableArrayAdministration", Ov);
function Mu(e) {
  return Lp(e) && WT(e[Ue]);
}
var GT = {}, hi = "add", lp = "delete", Kj = /* @__PURE__ */ function() {
  function e(n, r, o) {
    var i = this;
    r === void 0 && (r = la), o === void 0 && (o = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[Ue] = GT, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = r, this.name_ = o, So(Map) || gt(18), _i(function() {
      i.keysAtom_ = yj("ObservableMap.keys()"), i.data_ = /* @__PURE__ */ new Map(), i.hasMap_ = /* @__PURE__ */ new Map(), n && i.merge(n);
    });
  }
  var t = e.prototype;
  return t.has_ = function(r) {
    return this.data_.has(r);
  }, t.has = function(r) {
    var o = this;
    if (!Te.trackingDerivation)
      return this.has_(r);
    var i = this.hasMap_.get(r);
    if (!i) {
      var l = i = new yi(this.has_(r), Mp, "ObservableMap.key?", !1);
      this.hasMap_.set(r, l), Fj(l, function() {
        return o.hasMap_.delete(r);
      });
    }
    return i.get();
  }, t.set = function(r, o) {
    var i = this.has_(r);
    if (Gr(this)) {
      var l = Kr(this, {
        type: i ? Yo : hi,
        object: this,
        newValue: o,
        name: r
      });
      if (!l)
        return this;
      o = l.newValue;
    }
    return i ? this.updateValue_(r, o) : this.addValue_(r, o), this;
  }, t.delete = function(r) {
    var o = this;
    if (this.keysAtom_, Gr(this)) {
      var i = Kr(this, {
        type: lp,
        object: this,
        name: r
      });
      if (!i)
        return !1;
    }
    if (this.has_(r)) {
      var l = Fc(), c = yo(this), d = c || l ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: lp,
        object: this,
        oldValue: this.data_.get(r).value_,
        name: r
      } : null;
      return js(function() {
        var p;
        o.keysAtom_.reportChanged(), (p = o.hasMap_.get(r)) == null || p.setNewValue_(!1);
        var g = o.data_.get(r);
        g.setNewValue_(void 0), o.data_.delete(r);
      }), c && bo(this, d), !0;
    }
    return !1;
  }, t.updateValue_ = function(r, o) {
    var i = this.data_.get(r);
    if (o = i.prepareNewValue_(o), o !== Te.UNCHANGED) {
      var l = Fc(), c = yo(this), d = c || l ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Yo,
        object: this,
        oldValue: i.value_,
        name: r,
        newValue: o
      } : null;
      i.setNewValue_(o), c && bo(this, d);
    }
  }, t.addValue_ = function(r, o) {
    var i = this;
    this.keysAtom_, js(function() {
      var p, g = new yi(o, i.enhancer_, "ObservableMap.key", !1);
      i.data_.set(r, g), o = g.value_, (p = i.hasMap_.get(r)) == null || p.setNewValue_(!0), i.keysAtom_.reportChanged();
    });
    var l = Fc(), c = yo(this), d = c || l ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: hi,
      object: this,
      name: r,
      newValue: o
    } : null;
    c && bo(this, d);
  }, t.get = function(r) {
    return this.has(r) ? this.dehanceValue_(this.data_.get(r).get()) : this.dehanceValue_(void 0);
  }, t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var r = this, o = this.keys();
    return Jx({
      next: function() {
        var l = o.next(), c = l.done, d = l.value;
        return {
          done: c,
          value: c ? void 0 : r.get(d)
        };
      }
    });
  }, t.entries = function() {
    var r = this, o = this.keys();
    return Jx({
      next: function() {
        var l = o.next(), c = l.done, d = l.value;
        return {
          done: c,
          value: c ? void 0 : [d, r.get(d)]
        };
      }
    });
  }, t[Symbol.iterator] = function() {
    return this.entries();
  }, t.forEach = function(r, o) {
    for (var i = ol(this), l; !(l = i()).done; ) {
      var c = l.value, d = c[0], p = c[1];
      r.call(o, p, d, this);
    }
  }, t.merge = function(r) {
    var o = this;
    return Pi(r) && (r = new Map(r)), js(function() {
      Os(r) ? uk(r).forEach(function(i) {
        return o.set(i, r[i]);
      }) : Array.isArray(r) ? r.forEach(function(i) {
        var l = i[0], c = i[1];
        return o.set(l, c);
      }) : Ol(r) ? (ck(r) || gt(19, r), r.forEach(function(i, l) {
        return o.set(l, i);
      })) : r != null && gt(20, r);
    }), this;
  }, t.clear = function() {
    var r = this;
    js(function() {
      kj(function() {
        for (var o = ol(r.keys()), i; !(i = o()).done; ) {
          var l = i.value;
          r.delete(l);
        }
      });
    });
  }, t.replace = function(r) {
    var o = this;
    return js(function() {
      for (var i = KT(r), l = /* @__PURE__ */ new Map(), c = !1, d = ol(o.data_.keys()), p; !(p = d()).done; ) {
        var g = p.value;
        if (!i.has(g)) {
          var m = o.delete(g);
          if (m)
            c = !0;
          else {
            var v = o.data_.get(g);
            l.set(g, v);
          }
        }
      }
      for (var b = ol(i.entries()), x; !(x = b()).done; ) {
        var w = x.value, j = w[0], C = w[1], E = o.data_.has(j);
        if (o.set(j, C), o.data_.has(j)) {
          var P = o.data_.get(j);
          l.set(j, P), E || (c = !0);
        }
      }
      if (!c)
        if (o.data_.size !== l.size)
          o.keysAtom_.reportChanged();
        else
          for (var k = o.data_.keys(), T = l.keys(), O = k.next(), A = T.next(); !O.done; ) {
            if (O.value !== A.value) {
              o.keysAtom_.reportChanged();
              break;
            }
            O = k.next(), A = T.next();
          }
      o.data_ = l;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(r, o) {
    return Lu(this, r);
  }, t.intercept_ = function(r) {
    return Ou(this, r);
  }, Ll(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
}(), Pi = /* @__PURE__ */ Ci("ObservableMap", Kj);
function Jx(e) {
  return e[Symbol.toStringTag] = "MapIterator", Av(e);
}
function KT(e) {
  if (Ol(e) || Pi(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (Os(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var n in e)
      t.set(n, e[n]);
    return t;
  } else
    return gt(21, e);
}
var qT = {}, qj = /* @__PURE__ */ function() {
  function e(n, r, o) {
    var i = this;
    r === void 0 && (r = la), o === void 0 && (o = "ObservableSet"), this.name_ = void 0, this[Ue] = qT, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = o, So(Set) || gt(22), this.enhancer_ = function(l, c) {
      return r(l, c, o);
    }, _i(function() {
      i.atom_ = yj(i.name_), n && i.replace(n);
    });
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.clear = function() {
    var r = this;
    js(function() {
      kj(function() {
        for (var o = ol(r.data_.values()), i; !(i = o()).done; ) {
          var l = i.value;
          r.delete(l);
        }
      });
    });
  }, t.forEach = function(r, o) {
    for (var i = ol(this), l; !(l = i()).done; ) {
      var c = l.value;
      r.call(o, c, c, this);
    }
  }, t.add = function(r) {
    var o = this;
    if (this.atom_, Gr(this)) {
      var i = Kr(this, {
        type: hi,
        object: this,
        newValue: r
      });
      if (!i)
        return this;
    }
    if (!this.has(r)) {
      js(function() {
        o.data_.add(o.enhancer_(r, void 0)), o.atom_.reportChanged();
      });
      var l = !1, c = yo(this), d = c || l ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: hi,
        object: this,
        newValue: r
      } : null;
      c && bo(this, d);
    }
    return this;
  }, t.delete = function(r) {
    var o = this;
    if (Gr(this)) {
      var i = Kr(this, {
        type: lp,
        object: this,
        oldValue: r
      });
      if (!i)
        return !1;
    }
    if (this.has(r)) {
      var l = !1, c = yo(this), d = c || l ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: lp,
        object: this,
        oldValue: r
      } : null;
      return js(function() {
        o.atom_.reportChanged(), o.data_.delete(r);
      }), c && bo(this, d), !0;
    }
    return !1;
  }, t.has = function(r) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(r));
  }, t.entries = function() {
    var r = 0, o = Array.from(this.keys()), i = Array.from(this.values());
    return Qx({
      next: function() {
        var c = r;
        return r += 1, c < i.length ? {
          value: [o[c], i[c]],
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var r = this, o = 0, i = Array.from(this.data_.values());
    return Qx({
      next: function() {
        return o < i.length ? {
          value: r.dehanceValue_(i[o++]),
          done: !1
        } : {
          value: void 0,
          done: !0
        };
      }
    });
  }, t.intersection = function(r) {
    if (Ss(r) && !mo(r))
      return r.intersection(this);
    var o = new Set(this);
    return o.intersection(r);
  }, t.union = function(r) {
    if (Ss(r) && !mo(r))
      return r.union(this);
    var o = new Set(this);
    return o.union(r);
  }, t.difference = function(r) {
    return new Set(this).difference(r);
  }, t.symmetricDifference = function(r) {
    if (Ss(r) && !mo(r))
      return r.symmetricDifference(this);
    var o = new Set(this);
    return o.symmetricDifference(r);
  }, t.isSubsetOf = function(r) {
    return new Set(this).isSubsetOf(r);
  }, t.isSupersetOf = function(r) {
    return new Set(this).isSupersetOf(r);
  }, t.isDisjointFrom = function(r) {
    if (Ss(r) && !mo(r))
      return r.isDisjointFrom(this);
    var o = new Set(this);
    return o.isDisjointFrom(r);
  }, t.replace = function(r) {
    var o = this;
    return mo(r) && (r = new Set(r)), js(function() {
      Array.isArray(r) ? (o.clear(), r.forEach(function(i) {
        return o.add(i);
      })) : Ss(r) ? (o.clear(), r.forEach(function(i) {
        return o.add(i);
      })) : r != null && gt("Cannot initialize set from " + r);
    }), this;
  }, t.observe_ = function(r, o) {
    return Lu(this, r);
  }, t.intercept_ = function(r) {
    return Ou(this, r);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Symbol.iterator] = function() {
    return this.values();
  }, Ll(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
}(), mo = /* @__PURE__ */ Ci("ObservableSet", qj);
function Qx(e) {
  return e[Symbol.toStringTag] = "SetIterator", Av(e);
}
var ew = /* @__PURE__ */ Object.create(null), tw = "remove", Yj = /* @__PURE__ */ function() {
  function e(n, r, o, i) {
    r === void 0 && (r = /* @__PURE__ */ new Map()), i === void 0 && (i = Fk), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = n, this.values_ = r, this.name_ = o, this.defaultAnnotation_ = i, this.keysAtom_ = new Ei("ObservableObject.keys"), this.isPlainObject_ = Os(this.target_);
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(r) {
    return this.values_.get(r).get();
  }, t.setObservablePropValue_ = function(r, o) {
    var i = this.values_.get(r);
    if (i instanceof jo)
      return i.set(o), !0;
    if (Gr(this)) {
      var l = Kr(this, {
        type: Yo,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: o
      });
      if (!l)
        return null;
      o = l.newValue;
    }
    if (o = i.prepareNewValue_(o), o !== Te.UNCHANGED) {
      var c = yo(this), d = !1, p = c || d ? {
        type: Yo,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: i.value_,
        name: r,
        newValue: o
      } : null;
      i.setNewValue_(o), c && bo(this, p);
    }
    return !0;
  }, t.get_ = function(r) {
    return Te.trackingDerivation && !_s(this.target_, r) && this.has_(r), this.target_[r];
  }, t.set_ = function(r, o, i) {
    return i === void 0 && (i = !1), _s(this.target_, r) ? this.values_.has(r) ? this.setObservablePropValue_(r, o) : i ? Reflect.set(this.target_, r, o) : (this.target_[r] = o, !0) : this.extend_(r, {
      value: o,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, i);
  }, t.has_ = function(r) {
    if (!Te.trackingDerivation)
      return r in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var o = this.pendingKeys_.get(r);
    return o || (o = new yi(r in this.target_, Mp, "ObservableObject.key?", !1), this.pendingKeys_.set(r, o)), o.get();
  }, t.make_ = function(r, o) {
    if (o === !0 && (o = this.defaultAnnotation_), o !== !1) {
      if (!(r in this.target_)) {
        var i;
        if ((i = this.target_[Uo]) != null && i[r])
          return;
        gt(1, o.annotationType_, this.name_ + "." + r.toString());
      }
      for (var l = this.target_; l && l !== Cu; ) {
        var c = np(l, r);
        if (c) {
          var d = o.make_(this, r, c, l);
          if (d === 0)
            return;
          if (d === 1)
            break;
        }
        l = Object.getPrototypeOf(l);
      }
      rw(this, o, r);
    }
  }, t.extend_ = function(r, o, i, l) {
    if (l === void 0 && (l = !1), i === !0 && (i = this.defaultAnnotation_), i === !1)
      return this.defineProperty_(r, o, l);
    var c = i.extend_(this, r, o, l);
    return c && rw(this, i, r), c;
  }, t.defineProperty_ = function(r, o, i) {
    i === void 0 && (i = !1), this.keysAtom_;
    try {
      qr();
      var l = this.delete_(r);
      if (!l)
        return l;
      if (Gr(this)) {
        var c = Kr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: hi,
          newValue: o.value
        });
        if (!c)
          return null;
        var d = c.newValue;
        o.value !== d && (o = aa({}, o, {
          value: d
        }));
      }
      if (i) {
        if (!Reflect.defineProperty(this.target_, r, o))
          return !1;
      } else
        Ko(this.target_, r, o);
      this.notifyPropertyAddition_(r, o.value);
    } finally {
      Yr();
    }
    return !0;
  }, t.defineObservableProperty_ = function(r, o, i, l) {
    l === void 0 && (l = !1), this.keysAtom_;
    try {
      qr();
      var c = this.delete_(r);
      if (!c)
        return c;
      if (Gr(this)) {
        var d = Kr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: hi,
          newValue: o
        });
        if (!d)
          return null;
        o = d.newValue;
      }
      var p = nw(r), g = {
        configurable: Te.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: p.get,
        set: p.set
      };
      if (l) {
        if (!Reflect.defineProperty(this.target_, r, g))
          return !1;
      } else
        Ko(this.target_, r, g);
      var m = new yi(o, i, "ObservableObject.key", !1);
      this.values_.set(r, m), this.notifyPropertyAddition_(r, m.value_);
    } finally {
      Yr();
    }
    return !0;
  }, t.defineComputedProperty_ = function(r, o, i) {
    i === void 0 && (i = !1), this.keysAtom_;
    try {
      qr();
      var l = this.delete_(r);
      if (!l)
        return l;
      if (Gr(this)) {
        var c = Kr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: hi,
          newValue: void 0
        });
        if (!c)
          return null;
      }
      o.name || (o.name = "ObservableObject.key"), o.context = this.proxy_ || this.target_;
      var d = nw(r), p = {
        configurable: Te.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: d.get,
        set: d.set
      };
      if (i) {
        if (!Reflect.defineProperty(this.target_, r, p))
          return !1;
      } else
        Ko(this.target_, r, p);
      this.values_.set(r, new jo(o)), this.notifyPropertyAddition_(r, void 0);
    } finally {
      Yr();
    }
    return !0;
  }, t.delete_ = function(r, o) {
    if (o === void 0 && (o = !1), this.keysAtom_, !_s(this.target_, r))
      return !0;
    if (Gr(this)) {
      var i = Kr(this, {
        object: this.proxy_ || this.target_,
        name: r,
        type: tw
      });
      if (!i)
        return null;
    }
    try {
      var l;
      qr();
      var c = yo(this), d = !1, p = this.values_.get(r), g = void 0;
      if (!p && (c || d)) {
        var m;
        g = (m = np(this.target_, r)) == null ? void 0 : m.value;
      }
      if (o) {
        if (!Reflect.deleteProperty(this.target_, r))
          return !1;
      } else
        delete this.target_[r];
      if (p && (this.values_.delete(r), p instanceof yi && (g = p.value_), Rj(p)), this.keysAtom_.reportChanged(), (l = this.pendingKeys_) == null || (l = l.get(r)) == null || l.set(r in this.target_), c || d) {
        var v = {
          type: tw,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: g,
          name: r
        };
        c && bo(this, v);
      }
    } finally {
      Yr();
    }
    return !0;
  }, t.observe_ = function(r, o) {
    return Lu(this, r);
  }, t.intercept_ = function(r) {
    return Ou(this, r);
  }, t.notifyPropertyAddition_ = function(r, o) {
    var i, l = yo(this), c = !1;
    if (l || c) {
      var d = l || c ? {
        type: hi,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: o
      } : null;
      l && bo(this, d);
    }
    (i = this.pendingKeys_) == null || (i = i.get(r)) == null || i.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), gl(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
}();
function va(e, t) {
  var n;
  if (_s(e, Ue))
    return e;
  var r = (n = t == null ? void 0 : t.name) != null ? n : "ObservableObject", o = new Yj(e, /* @__PURE__ */ new Map(), String(r), Jk(t));
  return Eu(e, Ue, o), e;
}
var YT = /* @__PURE__ */ Ci("ObservableObjectAdministration", Yj);
function nw(e) {
  return ew[e] || (ew[e] = {
    get: function() {
      return this[Ue].getObservablePropValue_(e);
    },
    set: function(n) {
      return this[Ue].setObservablePropValue_(e, n);
    }
  });
}
function ml(e) {
  return Lp(e) ? YT(e[Ue]) : !1;
}
function rw(e, t, n) {
  var r;
  (r = e.target_[Uo]) == null || delete r[n];
}
var XT = /* @__PURE__ */ Zj(0), ZT = /* @__PURE__ */ function() {
  var e = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      e = !0;
    }
  }), Object.create(t)[0] = 1, e === !1;
}(), im = 0, Xj = function() {
};
function JT(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
JT(Xj, Array.prototype);
var Lv = /* @__PURE__ */ function(e) {
  function t(r, o, i, l) {
    var c;
    return i === void 0 && (i = "ObservableArray"), l === void 0 && (l = !1), c = e.call(this) || this, _i(function() {
      var d = new Ov(i, o, l, !0);
      d.proxy_ = c, gj(c, Ue, d), r && r.length && c.spliceWithArray(0, 0, r), ZT && Object.defineProperty(c, "0", XT);
    }), c;
  }
  vj(t, e);
  var n = t.prototype;
  return n.concat = function() {
    this[Ue].atom_.reportObserved();
    for (var o = arguments.length, i = new Array(o), l = 0; l < o; l++)
      i[l] = arguments[l];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      i.map(function(c) {
        return Mu(c) ? c.slice() : c;
      })
    );
  }, n[Symbol.iterator] = function() {
    var r = this, o = 0;
    return Av({
      next: function() {
        return o < r.length ? {
          value: r[o++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, Ll(t, [{
    key: "length",
    get: function() {
      return this[Ue].getArrayLength_();
    },
    set: function(o) {
      this[Ue].setArrayLength_(o);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
}(Xj);
Object.entries(ap).forEach(function(e) {
  var t = e[0], n = e[1];
  t !== "concat" && Eu(Lv.prototype, t, n);
});
function Zj(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[Ue].get_(e);
    },
    set: function(n) {
      this[Ue].set_(e, n);
    }
  };
}
function QT(e) {
  Ko(Lv.prototype, "" + e, Zj(e));
}
function Jj(e) {
  if (e > im) {
    for (var t = im; t < e + 100; t++)
      QT(t);
    im = e;
  }
}
Jj(1e3);
function eO(e, t, n) {
  return new Lv(e, t, n);
}
function vl(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Mu(e))
      return t !== void 0 && gt(23), e[Ue].atom_;
    if (mo(e))
      return e.atom_;
    if (Pi(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var n = e.data_.get(t) || e.hasMap_.get(t);
      return n || gt(25, t, T1(e)), n;
    }
    if (ml(e)) {
      if (!t)
        return gt(26);
      var r = e[Ue].values_.get(t);
      return r || gt(27, t, T1(e)), r;
    }
    if (Pv(e) || Tu(e) || ip(e))
      return e;
  } else if (So(e) && ip(e[Ue]))
    return e[Ue];
  gt(28);
}
function Qj(e, t) {
  if (e || gt(29), t !== void 0)
    return Qj(vl(e, t));
  if (Pv(e) || Tu(e) || ip(e) || Pi(e) || mo(e))
    return e;
  if (e[Ue])
    return e[Ue];
  gt(24, e);
}
function T1(e, t) {
  var n;
  if (t !== void 0)
    n = vl(e, t);
  else {
    if (su(e))
      return e.name;
    ml(e) || Pi(e) || mo(e) ? n = Qj(e) : n = vl(e);
  }
  return n.name_;
}
function _i(e) {
  var t = ma(), n = Np(!0);
  qr();
  try {
    return e();
  } finally {
    Yr(), $p(n), ks(t);
  }
}
var ow = Cu.toString;
function Mv(e, t, n) {
  return n === void 0 && (n = -1), O1(e, t, n);
}
function O1(e, t, n, r, o) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var i = typeof e;
  if (i !== "function" && i !== "object" && typeof t != "object")
    return !1;
  var l = ow.call(e);
  if (l !== ow.call(t))
    return !1;
  switch (l) {
    case "[object RegExp]":
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  e = sw(e), t = sw(t);
  var c = l === "[object Array]";
  if (!c) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var d = e.constructor, p = t.constructor;
    if (d !== p && !(So(d) && d instanceof d && So(p) && p instanceof p) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), r = r || [], o = o || [];
  for (var g = r.length; g--; )
    if (r[g] === e)
      return o[g] === t;
  if (r.push(e), o.push(t), c) {
    if (g = e.length, g !== t.length)
      return !1;
    for (; g--; )
      if (!O1(e[g], t[g], n - 1, r, o))
        return !1;
  } else {
    var m = Object.keys(e), v;
    if (g = m.length, Object.keys(t).length !== g)
      return !1;
    for (; g--; )
      if (v = m[g], !(_s(t, v) && O1(e[v], t[v], n - 1, r, o)))
        return !1;
  }
  return r.pop(), o.pop(), !0;
}
function sw(e) {
  return Mu(e) ? e.slice() : Ol(e) || Pi(e) || Ss(e) || mo(e) ? Array.from(e.entries()) : e;
}
var iw, tO = ((iw = Op().Iterator) == null ? void 0 : iw.prototype) || {};
function Av(e) {
  return e[Symbol.iterator] = nO, Object.assign(Object.create(tO), e);
}
function nO() {
  return this;
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = Op();
  typeof t[e] > "u" && gt("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: yT,
  extras: {
    getDebugName: T1
  },
  $mobx: Ue
});
const eC = "app.grapesjs.com", tC = "app-stage.grapesjs.com", rO = "app2.grapesjs.com", oO = "app-stage2.grapesjs.com", nC = "gs-studio-root", aw = [
  eC,
  rO,
  tC,
  oO,
  "localhost",
  "127.0.0.1",
  ".local-credentialless.webcontainer.io",
  // For stackblitz.com demos
  ".local.webcontainer.io",
  // For stackblitz.com demos
  "-sandpack.codesandbox.io"
  // For Sandpack demos
], sO = "license:check:start", lw = "license:check:end", ns = () => typeof window < "u", yl = (e) => e && e.stopPropagation(), iO = (e) => e.getAttributeNames().reduce(
  (t, n) => ({
    ...t,
    [n]: e.getAttribute(n) || ""
  }),
  {}
), aO = (e, t) => {
  const n = (r) => r.key === e && t();
  return document.addEventListener("keydown", n), () => document.removeEventListener("keydown", n);
}, lO = (e = "") => {
  const t = document.createElement("textarea");
  t.value = e, t.setAttribute("readonly", ""), t.style.position = "absolute", t.style.left = "-9999px", document.body.appendChild(t), t.select(), document.execCommand("copy"), document.body.removeChild(t);
}, cO = (e) => aO("Escape", e), uO = (e, t = {}) => {
  const n = Dt(e) ? { id: e, src: e } : e;
  return new Promise((r, o) => {
    var v, b;
    const { loadedScripts: i } = t, { id: l, src: c } = n, d = document.querySelector(`script[src="${c}"]`);
    if (d) {
      if ((v = t.onScript) == null || v.call(t, d), i && !i.get(c)) {
        d.addEventListener("load", () => r(l)), d.addEventListener("error", () => o(l));
        return;
      }
      return r(l);
    }
    const p = window.define;
    window.define = void 0;
    const g = () => {
      i == null || i.set(c, !0), window.define = p;
    }, m = document.createElement("script");
    m.src = c, m.onload = () => {
      r(l), g();
    }, m.onerror = () => {
      o(l), g();
    }, document.head.appendChild(m), (b = t.onScript) == null || b.call(t, m);
  });
}, dO = (e) => {
  const t = e.map((n) => uO(n));
  return Promise.allSettled(t);
};
function fO(e) {
  const t = e.ownerDocument.createElement("script");
  return t.text = e.innerHTML, Array.from(e.attributes).forEach((n) => t.setAttribute(n.nodeName, n.nodeValue)), t;
}
function cw(e) {
  const t = (r) => {
    var o;
    if (r.length) {
      const i = r.shift(), l = fO(i);
      l.onerror = l.onload = t.bind(null, r), (o = i.parentNode) == null || o.replaceChild(l, i);
    }
  }, n = Array.from(e.querySelectorAll("script"));
  t(n);
}
const rC = (e) => new DOMParser().parseFromString(e, "text/html"), pO = (e = "") => rC(`<body>${e}</body>`).body.innerHTML, gO = (e = "") => rC(`<head>${e}</head>`).head.innerHTML, hO = (e = "", t) => {
  const r = new DOMParser().parseFromString(e, "text/html");
  if (t) {
    const i = r.querySelectorAll("svg")[0].style || {}, l = wO(t) ? `${t}px` : t;
    i.width = l, i.height = l, i.fill = "currentColor";
  }
  return new XMLSerializer().serializeToString(r);
}, mO = ({ isDev: e, isStage: t }) => `${e ? "" : `https://${t ? tC : eC}`}/api`, oC = (e = {}) => {
  const { width: t = 300, height: n, text: r = "IMAGE", bg: o = "777", fg: i = "white" } = e, l = n ? `x${n}` : "";
  return `https://placehold.co/${t}${l}/${o}/${i}.png?text=${r}`;
}, vO = oC(), Rv = () => {
  const e = ns() && window.location.hostname;
  return !!e && (aw.includes(e) || aw.some((t) => e.endsWith(t)));
}, Wo = (e) => e && e.charAt(0).toUpperCase() + e.substring(1), yO = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, n) => (n ? "-" : "") + t.toLowerCase()), bO = () => {
}, xO = 240, Rn = (e) => typeof e < "u", Dt = (e) => typeof e == "string", wO = (e) => typeof e == "number";
function Ct(e) {
  return typeof e == "function";
}
function Qo(e) {
  return e && !Array.isArray(e) && typeof e == "object";
}
const SO = (e) => !e || Object.keys(e).length === 0, au = (e, t) => {
  const n = { ...e }, r = { ...t };
  for (const o in r) {
    const i = n[o], l = r[o];
    Qo(i) && Qo(l) ? n[o] = au(i, l) : n[o] = l;
  }
  return n;
}, ll = (e, t) => {
  const n = (e || "").toLocaleLowerCase(), r = (t || "").toLocaleLowerCase();
  return n.includes(r);
}, jO = (e = "") => {
  const t = e[0] === "?" ? e.substring(1) : e, n = new URLSearchParams(t);
  return Object.fromEntries(n);
}, CO = (e = 16) => {
  let t = "";
  const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = n.length;
  for (let o = 0; o < e; o++)
    t += n.charAt(Math.floor(Math.random() * r));
  return t;
}, EO = (e) => !!e.Components.getType("mjml"), Nv = (e) => (e || "").toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-._]+/g, "").replace(/--+/g, "-").trim();
var ff, PO = new Uint8Array(16);
function _O() {
  if (!ff && (ff = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !ff))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ff(PO);
}
const kO = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function TO(e) {
  return typeof e == "string" && kO.test(e);
}
var Ln = [];
for (var am = 0; am < 256; ++am)
  Ln.push((am + 256).toString(16).substr(1));
function OO(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (Ln[e[t + 0]] + Ln[e[t + 1]] + Ln[e[t + 2]] + Ln[e[t + 3]] + "-" + Ln[e[t + 4]] + Ln[e[t + 5]] + "-" + Ln[e[t + 6]] + Ln[e[t + 7]] + "-" + Ln[e[t + 8]] + Ln[e[t + 9]] + "-" + Ln[e[t + 10]] + Ln[e[t + 11]] + Ln[e[t + 12]] + Ln[e[t + 13]] + Ln[e[t + 14]] + Ln[e[t + 15]]).toLowerCase();
  if (!TO(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function sC(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || _O)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (var o = 0; o < 16; ++o)
      t[n + o] = r[o];
    return t;
  }
  return OO(r);
}
var ke = /* @__PURE__ */ ((e) => (e.toastAdd = "studio:toastAdd", e.toastRemove = "studio:toastRemove", e.dialogOpen = "studio:dialogOpen", e.dialogClose = "studio:dialogClose", e.sidebarLeftSet = "studio:sidebarLeft:set", e.sidebarLeftGet = "studio:sidebarLeft:get", e.sidebarLeftToggle = "studio:sidebarLeft:toggle", e.sidebarRightSet = "studio:sidebarRight:set", e.sidebarRightGet = "studio:sidebarRight:get", e.sidebarRightToggle = "studio:sidebarRight:toggle", e.sidebarTopSet = "studio:sidebarTop:set", e.sidebarTopGet = "studio:sidebarTop:get", e.sidebarTopToggle = "studio:sidebarTop:toggle", e.sidebarBottomSet = "studio:sidebarBottom:set", e.sidebarBottomGet = "studio:sidebarBottom:get", e.sidebarBottomToggle = "studio:sidebarBottom:toggle", e.symbolAdd = "studio:symbolAdd", e.symbolDetach = "studio:symbolDetach", e.symbolOverride = "studio:symbolOverride", e.symbolPropagateStyles = "studio:propagateStyles", e.getPagesConfig = "studio:getPagesConfig", e.setPagesConfig = "studio:setPagesConfig", e.getPageSettings = "studio:getPageSettings", e.setPageSettings = "studio:setPageSettings", e.projectFiles = "studio:projectFiles", e.canvasReload = "studio:canvasReload", e.getBlocksPanel = "studio:getBlocksPanel", e.setBlocksPanel = "studio:setBlocksPanel", e.getStateContextMenu = "studio:getStateContextMenu", e.setStateContextMenu = "studio:setStateContextMenu", e.contextMenuComponent = "studio:contextMenuComponent", e.layoutAdd = "studio:layoutAdd", e.layoutRemove = "studio:layoutRemove", e.layoutToggle = "studio:layoutToggle", e.layoutUpdate = "studio:layoutUpdate", e.layoutGet = "studio:layoutGet", e.layoutConfigGet = "studio:layoutConfigGet", e.layoutConfigSet = "studio:layoutConfigSet", e.getStateTheme = "studio:getStateTheme", e.setStateTheme = "studio:setStateTheme", e.assetProviderGet = "studio:assetProviderGet", e.assetProviderAdd = "studio:assetProviderAdd", e.assetProviderRemove = "studio:assetProviderRemove", e.fontGet = "studio:fontGet", e.fontAdd = "studio:fontAdd", e.fontRemove = "studio:fontRemove", e.fontManagerOpen = "studio:fontManagerOpen", e.menuFontLoad = "studio:menuFontLoad", e.toggleStateDataSource = "studio:toggleStateDataSource", e.getStateDataSource = "studio:getStateDataSource", e.dataSourceSetGlobalData = "studio:dataSourceSetGlobalData", e.dataSourceSetImporter = "studio:dataSourceSetImporter", e.dataSourceSetExporter = "studio:dataSourceSetExporter", e.setDragAbsolute = "studio:setDragAbsolute", e))(ke || {}), kr = /* @__PURE__ */ ((e) => (e.layoutToggleId = "studio:layoutToggle:", e.toggleBlocksPanel = "studio:toggleBlocksPanel", e.pageSettingsUpdate = "studio:pageSettingsUpdate", e.toggleDataSourcesPreview = "studio:toggleDataSourcesPreview", e))(kr || {});
const iC = /* @__PURE__ */ new Set(), _r = /* @__PURE__ */ new WeakMap(), cl = /* @__PURE__ */ new WeakMap(), da = /* @__PURE__ */ new WeakMap(), L1 = /* @__PURE__ */ new WeakMap(), LO = /* @__PURE__ */ new WeakMap(), bl = /* @__PURE__ */ new WeakMap(), cp = /* @__PURE__ */ new WeakMap();
let xi;
const Qi = "__aa_tgt", M1 = "__aa_del", MO = (e) => {
  const t = DO(e);
  t && t.forEach((n) => IO(n));
}, AO = (e) => {
  e.forEach((t) => {
    t.target === xi && NO(), _r.has(t.target) && ya(t.target);
  });
};
function RO(e) {
  const t = L1.get(e);
  t == null || t.disconnect();
  let n = _r.get(e), r = 0;
  const o = 5;
  n || (n = xl(e), _r.set(e, n));
  const { offsetWidth: i, offsetHeight: l } = xi, d = [
    n.top - o,
    i - (n.left + o + n.width),
    l - (n.top + o + n.height),
    n.left - o
  ].map((g) => `${-1 * Math.floor(g)}px`).join(" "), p = new IntersectionObserver(() => {
    ++r > 1 && ya(e);
  }, {
    root: xi,
    threshold: 1,
    rootMargin: d
  });
  p.observe(e), L1.set(e, p);
}
function ya(e) {
  clearTimeout(cp.get(e));
  const t = Dp(e), n = typeof t == "function" ? 500 : t.duration;
  cp.set(e, setTimeout(() => {
    const r = da.get(e);
    (!r || r.finished) && (_r.set(e, xl(e)), RO(e));
  }, n));
}
function NO() {
  clearTimeout(cp.get(xi)), cp.set(xi, setTimeout(() => {
    iC.forEach((e) => cC(e, (t) => aC(() => ya(t))));
  }, 100));
}
function $O(e) {
  setTimeout(() => {
    LO.set(e, setInterval(() => aC(ya.bind(null, e)), 2e3));
  }, Math.round(2e3 * Math.random()));
}
function aC(e) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => e()) : requestAnimationFrame(() => e());
}
let A1, sl;
typeof window < "u" && (xi = document.documentElement, A1 = new MutationObserver(MO), sl = new ResizeObserver(AO), sl.observe(xi));
function DO(e) {
  return e.reduce((t, n) => {
    if (t === !1)
      return !1;
    if (n.target instanceof Element) {
      if (lm(n.target), !t.has(n.target)) {
        t.add(n.target);
        for (let r = 0; r < n.target.children.length; r++) {
          const o = n.target.children.item(r);
          if (o) {
            if (M1 in o)
              return !1;
            lm(n.target, o), t.add(o);
          }
        }
      }
      if (n.removedNodes.length)
        for (let r = 0; r < n.removedNodes.length; r++) {
          const o = n.removedNodes[r];
          if (M1 in o)
            return !1;
          o instanceof Element && (t.add(o), lm(n.target, o), cl.set(o, [
            n.previousSibling,
            n.nextSibling
          ]));
        }
    }
    return t;
  }, /* @__PURE__ */ new Set());
}
function lm(e, t) {
  !t && !(Qi in e) ? Object.defineProperty(e, Qi, { value: e }) : t && !(Qi in t) && Object.defineProperty(t, Qi, { value: e });
}
function IO(e) {
  var t;
  const n = xi.contains(e), r = _r.has(e);
  n && cl.has(e) && cl.delete(e), da.has(e) && ((t = da.get(e)) === null || t === void 0 || t.cancel()), r && n ? VO(e) : r && !n ? FO(e) : HO(e);
}
function $o(e) {
  return Number(e.replace(/[^0-9.\-]/g, ""));
}
function xl(e) {
  const t = e.getBoundingClientRect();
  return {
    top: t.top + window.scrollY,
    left: t.left + window.scrollX,
    width: t.width,
    height: t.height
  };
}
function lC(e, t, n) {
  let r = t.width, o = t.height, i = n.width, l = n.height;
  const c = getComputedStyle(e);
  if (c.getPropertyValue("box-sizing") === "content-box") {
    const p = $o(c.paddingTop) + $o(c.paddingBottom) + $o(c.borderTopWidth) + $o(c.borderBottomWidth), g = $o(c.paddingLeft) + $o(c.paddingRight) + $o(c.borderRightWidth) + $o(c.borderLeftWidth);
    r -= g, i -= g, o -= p, l -= p;
  }
  return [r, i, o, l].map(Math.round);
}
function Dp(e) {
  return Qi in e && bl.has(e[Qi]) ? bl.get(e[Qi]) : { duration: 250, easing: "ease-in-out" };
}
function cC(e, ...t) {
  t.forEach((n) => n(e, bl.has(e)));
  for (let n = 0; n < e.children.length; n++) {
    const r = e.children.item(n);
    r && t.forEach((o) => o(r, bl.has(r)));
  }
}
function VO(e) {
  const t = _r.get(e), n = xl(e);
  let r;
  if (!t)
    return;
  const o = Dp(e);
  if (typeof o != "function") {
    const i = t.left - n.left, l = t.top - n.top, [c, d, p, g] = lC(e, t, n), m = {
      transform: `translate(${i}px, ${l}px)`
    }, v = {
      transform: "translate(0, 0)"
    };
    c !== d && (m.width = `${c}px`, v.width = `${d}px`), p !== g && (m.height = `${p}px`, v.height = `${g}px`), r = e.animate([m, v], o);
  } else
    r = new Animation(o(e, "remain", t, n)), r.play();
  da.set(e, r), _r.set(e, n), r.addEventListener("finish", ya.bind(null, e));
}
function HO(e) {
  const t = xl(e);
  _r.set(e, t);
  const n = Dp(e);
  let r;
  typeof n != "function" ? r = e.animate([
    { transform: "scale(.98)", opacity: 0 },
    { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
    { transform: "scale(1)", opacity: 1 }
  ], {
    duration: n.duration * 1.5,
    easing: "ease-in"
  }) : (r = new Animation(n(e, "add", t)), r.play()), da.set(e, r), r.addEventListener("finish", ya.bind(null, e));
}
function FO(e) {
  if (!cl.has(e) || !_r.has(e))
    return;
  const [t, n] = cl.get(e);
  Object.defineProperty(e, M1, { value: !0 }), n && n.parentNode && n.parentNode instanceof Element ? n.parentNode.insertBefore(e, n) : t && t.parentNode && t.parentNode.appendChild(e);
  const [r, o, i, l] = zO(e), c = Dp(e), d = _r.get(e);
  let p;
  Object.assign(e.style, {
    position: "absolute",
    top: `${r}px`,
    left: `${o}px`,
    width: `${i}px`,
    height: `${l}px`,
    margin: 0,
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: 100
  }), typeof c != "function" ? p = e.animate([
    {
      transform: "scale(1)",
      opacity: 1
    },
    {
      transform: "scale(.98)",
      opacity: 0
    }
  ], { duration: c.duration, easing: "ease-out" }) : (p = new Animation(c(e, "remove", d)), p.play()), da.set(e, p), p.addEventListener("finish", () => {
    var g;
    e.remove(), _r.delete(e), cl.delete(e), da.delete(e), (g = L1.get(e)) === null || g === void 0 || g.disconnect();
  });
}
function zO(e) {
  const t = _r.get(e), [n, , r] = lC(e, t, xl(e));
  let o = e.parentElement;
  for (; o && (getComputedStyle(o).position === "static" || o instanceof HTMLBodyElement); )
    o = o.parentElement;
  o || (o = document.body);
  const i = getComputedStyle(o), l = _r.get(o) || xl(o), c = Math.round(t.top - l.top) - $o(i.borderTopWidth), d = Math.round(t.left - l.left) - $o(i.borderLeftWidth);
  return [c, d, n, r];
}
function BO(e, t = {}) {
  A1 && sl && (getComputedStyle(e).position === "static" && Object.assign(e.style, { position: "relative" }), cC(e, ya, $O, (n) => sl == null ? void 0 : sl.observe(n)), typeof t == "function" ? bl.set(e, t) : bl.set(e, { duration: 250, easing: "ease-in-out", ...t }), A1.observe(e, { childList: !0 }), iC.add(e));
}
function UO(e) {
  const t = y.useRef(null);
  return y.useEffect(() => {
    t.current instanceof HTMLElement && BO(t.current, e);
  }, [t]), t;
}
if (!y.useState)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!FT)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function WO(e) {
  e();
}
function GO(e) {
  e || (e = WO), MT({ reactionScheduler: e });
}
function KO(e) {
  return AT(e);
}
var qO = 1e4, YO = 1e4, XO = (
  /** @class */
  function() {
    function e(t) {
      var n = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(r) {
          r === void 0 && (r = qO), clearTimeout(n.sweepTimeout), n.sweepTimeout = void 0;
          var o = Date.now();
          n.registrations.forEach(function(i, l) {
            o - i.registeredAt >= r && (n.finalize(i.value), n.registrations.delete(l));
          }), n.registrations.size > 0 && n.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          n.sweep(0);
        }
      });
    }
    return Object.defineProperty(e.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t, n, r) {
        this.registrations.set(r, {
          value: n,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(e.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t) {
        this.registrations.delete(t);
      }
    }), Object.defineProperty(e.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, YO));
      }
    }), e;
  }()
), ZO = typeof FinalizationRegistry < "u" ? FinalizationRegistry : XO, R1 = new ZO(function(e) {
  var t;
  (t = e.reaction) === null || t === void 0 || t.dispose(), e.reaction = null;
}), uC = { exports: {} }, cm = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uw;
function JO() {
  if (uw)
    return cm;
  uw = 1;
  var e = y;
  function t(m, v) {
    return m === v && (m !== 0 || 1 / m === 1 / v) || m !== m && v !== v;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, l = e.useDebugValue;
  function c(m, v) {
    var b = v(), x = r({ inst: { value: b, getSnapshot: v } }), w = x[0].inst, j = x[1];
    return i(function() {
      w.value = b, w.getSnapshot = v, d(w) && j({ inst: w });
    }, [m, b, v]), o(function() {
      return d(w) && j({ inst: w }), m(function() {
        d(w) && j({ inst: w });
      });
    }, [m]), l(b), b;
  }
  function d(m) {
    var v = m.getSnapshot;
    m = m.value;
    try {
      var b = v();
      return !n(m, b);
    } catch {
      return !0;
    }
  }
  function p(m, v) {
    return v();
  }
  var g = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : c;
  return cm.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : g, cm;
}
uC.exports = JO();
var QO = uC.exports;
function dw(e) {
  e.reaction = new Jo("observer".concat(e.name), function() {
    var t;
    e.stateVersion = Symbol(), (t = e.onStoreChange) === null || t === void 0 || t.call(e);
  });
}
function e4(e, t) {
  t === void 0 && (t = "observed");
  var n = Q.useRef(null);
  if (!n.current) {
    var r = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: t,
      subscribe: function(c) {
        return R1.unregister(r), r.onStoreChange = c, r.reaction || (dw(r), r.stateVersion = Symbol()), function() {
          var d;
          r.onStoreChange = null, (d = r.reaction) === null || d === void 0 || d.dispose(), r.reaction = null;
        };
      },
      getSnapshot: function() {
        return r.stateVersion;
      }
    };
    n.current = r;
  }
  var o = n.current;
  o.reaction || (dw(o), R1.register(n, o, o)), Q.useDebugValue(o.reaction, KO), QO.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    o.subscribe,
    o.getSnapshot,
    o.getSnapshot
  );
  var i, l;
  if (o.reaction.track(function() {
    try {
      i = e();
    } catch (c) {
      l = c;
    }
  }), l)
    throw l;
  return i;
}
var um, dm, dC = typeof Symbol == "function" && Symbol.for, t4 = (dm = (um = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || um === void 0 ? void 0 : um.configurable) !== null && dm !== void 0 ? dm : !1, fw = dC ? Symbol.for("react.forward_ref") : typeof y.forwardRef == "function" && y.forwardRef(function(e) {
  return null;
}).$$typeof, pw = dC ? Symbol.for("react.memo") : typeof y.memo == "function" && y.memo(function(e) {
  return null;
}).$$typeof;
function xe(e, t) {
  var n;
  if (pw && e.$$typeof === pw)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var r = (n = t == null ? void 0 : t.forwardRef) !== null && n !== void 0 ? n : !1, o = e, i = e.displayName || e.name;
  if (fw && e.$$typeof === fw && (r = !0, o = e.render, typeof o != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var l = function(c, d) {
    return e4(function() {
      return o(c, d);
    }, i);
  };
  return l.displayName = e.displayName, t4 && Object.defineProperty(l, "name", {
    value: e.name,
    writable: !0,
    configurable: !0
  }), e.contextTypes && (l.contextTypes = e.contextTypes), r && (l = y.forwardRef(l)), l = y.memo(l), r4(e, l), l;
}
var n4 = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function r4(e, t) {
  Object.keys(e).forEach(function(n) {
    n4[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
  });
}
var fm;
GO(Cr.unstable_batchedUpdates);
fm = R1.finalizeAllImmediately;
const ge = ce;
function ce(...e) {
  return (Array.isArray(e[0]) ? e[0] : [...e]).filter(Boolean).flatMap((o) => typeof o == "string" ? o.split(" ").map((i) => {
    if (i = i.replace(/gjs-/g, "gs-utl-"), !i.includes("gs-utl-") && !i.startsWith("gs-")) {
      const l = i.split(":"), c = l.pop(), d = l.join(":"), p = c == null ? void 0 : c.startsWith("!"), m = `gs-utl-${p ? c == null ? void 0 : c.slice(1) : c}`, v = p ? `!${m}` : m;
      return d ? `${d}:${v}` : v;
    }
    return i;
  }) : o).join(" ");
}
var o4 = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M11 7H13V13H11V7M11 15H13V17H11V15Z", s4 = "M11 2H13V7H21V10H13V14H18V17H13V22H11V17H6V14H11V10H3V7H11V2Z", i4 = "M4 22H2V2H4V22M22 7H6V10H22V7M16 14H6V17H16V14Z", a4 = "M20 2H22V22H20V2M2 10H18V7H2V10M8 17H18V14H8V17Z", l4 = "M9.5,8.5L11,10L8,13L11,16L9.5,17.5L5,13L9.5,8.5M14.5,17.5L13,16L16,13L13,10L14.5,8.5L19,13L14.5,17.5M21,2H3A2,2 0 0,0 1,4V20A2,2 0 0,0 3,22H21A2,2 0 0,0 23,20V4A2,2 0 0,0 21,2M21,20H3V6H21V20Z", c4 = "M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z", u4 = "M9.5,13.09L10.91,14.5L6.41,19H10V21H3V14H5V17.59L9.5,13.09M10.91,9.5L9.5,10.91L5,6.41V10H3V3H10V5H6.41L10.91,9.5M14.5,13.09L19,17.59V14H21V21H14V19H17.59L13.09,14.5L14.5,13.09M13.09,9.5L17.59,5H14V3H21V10H19V6.41L14.5,10.91L13.09,9.5Z", d4 = "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z", f4 = "M20 13.5C20 17.09 17.09 20 13.5 20H6V18H13.5C16 18 18 16 18 13.5S16 9 13.5 9H7.83L10.91 12.09L9.5 13.5L4 8L9.5 2.5L10.92 3.91L7.83 7H13.5C17.09 7 20 9.91 20 13.5Z", p4 = "M10.5 18H18V20H10.5C6.91 20 4 17.09 4 13.5S6.91 7 10.5 7H16.17L13.08 3.91L14.5 2.5L20 8L14.5 13.5L13.09 12.09L16.17 9H10.5C8 9 6 11 6 13.5S8 18 10.5 18Z", g4 = "M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z", h4 = "M3,21V3H21V21H3M5,5V19H19V5H5Z", m4 = "M3 16C3 18.8 5.2 21 8 21H10V19H8C6.3 19 5 17.7 5 16V14H3V16M21 8C21 5.2 18.8 3 16 3H14V5H16C17.7 5 19 6.3 19 8V10H21V8M16 21C18.8 21 21 18.8 21 16V14H19V16C19 17.7 17.7 19 16 19H14V21H16M8 3C5.2 3 3 5.2 3 8V10H5V8C5 6.3 6.3 5 8 5H10V3H8Z", v4 = "M15,21H17V19H15M19,21H21V19H19M7,21H9V19H7M11,21H13V19H11M19,17H21V15H19M19,13H21V11H19M3,3V21H5V5H21V3M19,9H21V7H19", y4 = "M22,17H18V10H22M23,8H17A1,1 0 0,0 16,9V19A1,1 0 0,0 17,20H23A1,1 0 0,0 24,19V9A1,1 0 0,0 23,8M4,6H22V4H4A2,2 0 0,0 2,6V17H0V20H14V17H4V6Z", b4 = "M12,3C17.5,3 22,6.58 22,11C22,15.42 17.5,19 12,19C10.76,19 9.57,18.82 8.47,18.5C5.55,21 2,21 2,21C4.33,18.67 4.7,17.1 4.75,16.5C3.05,15.07 2,13.13 2,11C2,6.58 6.5,3 12,3Z", x4 = "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z", w4 = "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z", S4 = "M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z", j4 = "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z", C4 = "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z", E4 = "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z", P4 = "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z", _4 = "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z", k4 = "M11 20H6.5Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20H13V12.85L14.6 14.4L16 13L12 9L8 13L9.4 14.4L11 12.85Z", T4 = "M8,3A2,2 0 0,0 6,5V9A2,2 0 0,1 4,11H3V13H4A2,2 0 0,1 6,15V19A2,2 0 0,0 8,21H10V19H8V14A2,2 0 0,0 6,12A2,2 0 0,0 8,10V5H10V3M16,3A2,2 0 0,1 18,5V9A2,2 0 0,0 20,11H21V13H20A2,2 0 0,0 18,15V19A2,2 0 0,1 16,21H14V19H16V14A2,2 0 0,1 18,12A2,2 0 0,1 16,10V5H14V3H16Z", O4 = "M15,4V6H18V18H15V20H20V4M4,4V20H9V18H6V6H9V4H4Z", L4 = "M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M12.5,11H11.5A1.5,1.5 0 0,1 10,9.5A1.5,1.5 0 0,1 11.5,8H12.5A1.5,1.5 0 0,1 14,9.5H16A3.5,3.5 0 0,0 12.5,6H11.5A3.5,3.5 0 0,0 8,9.5A3.5,3.5 0 0,0 11.5,13H12.5A1.5,1.5 0 0,1 14,14.5A1.5,1.5 0 0,1 12.5,16H11.5A1.5,1.5 0 0,1 10,14.5H8A3.5,3.5 0 0,0 11.5,18H12.5A3.5,3.5 0 0,0 16,14.5A3.5,3.5 0 0,0 12.5,11Z", M4 = "M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z", A4 = "M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z", R4 = "M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z", N4 = "M19,1L17.74,3.75L15,5L17.74,6.26L19,9L20.25,6.26L23,5L20.25,3.75M9,4L6.5,9.5L1,12L6.5,14.5L9,20L11.5,14.5L17,12L11.5,9.5M19,15L17.74,17.74L15,19L17.74,20.25L19,23L20.25,20.25L23,19L20.25,17.74", $4 = "M23 19C22.9 19.2 22.8 19.4 22.7 19.5L18.3 15.1C20.5 15.6 22.2 17.1 23 19M12 5C15.9 5 18 6.5 18 7C18 7.5 15.9 8.9 12.2 9L14.1 10.9C15.6 10.7 17 10.3 18 9.7V12.5C17.7 12.7 17.4 12.9 17 13.1C18 13.1 19 13.3 20 13.7V7C20 4.8 16.4 3 12 3C10.1 3 8.4 3.3 7.1 3.9L8.7 5.5C9.5 5.2 10.7 5 12 5M22.1 21.5L20.8 22.8L20.2 22.2C19.2 22.7 18.1 23.1 17 23.1C14.3 23.1 11.9 21.4 11 19.1C11.6 17.7 12.6 16.6 13.9 15.9L12.4 14.4C11.7 14.8 11.1 15.4 10.5 16C8.8 15.9 7.2 15.5 5.9 14.8V17C5.9 17.3 7 18.2 8.9 18.6L8.8 19L9.1 19.7C9.3 20.1 9.4 20.4 9.6 20.8C6.4 20.3 4 18.8 4 17V7C4 6.7 4.1 6.4 4.2 6.1L1.1 3L2.4 1.7L22.1 21.5M12.1 14L8.7 10.6C7.6 10.4 6.7 10 5.9 9.6V12.4C7.2 13.4 9.5 13.9 11.9 13.9C12 14 12.1 14 12.1 14M18.8 20.7L17.7 19.6C17.6 19.9 17.3 20 17 20C16.4 20 16 19.6 16 19C16 18.7 16.1 18.4 16.4 18.2L15.3 17.1C14.8 17.6 14.5 18.2 14.5 18.9C14.5 20.3 15.6 21.4 17 21.4C17.7 21.5 18.4 21.2 18.8 20.7Z", D4 = "M9.1 19.7L8.8 19L9 18.6C7.1 18.1 6 17.3 6 17V14.8C7.3 15.4 8.8 15.8 10.6 16C11.3 15.2 12.2 14.5 13.1 14H12C9.6 14 7.3 13.4 6 12.5V9.6C7.5 10.4 9.6 11 12 11S16.5 10.5 18 9.6V12.4C17.7 12.6 17.4 12.8 17 13C18 13 19 13.2 20 13.6V7C20 4.8 16.4 3 12 3S4 4.8 4 7V17C4 18.8 6.4 20.3 9.7 20.8C9.5 20.5 9.3 20.1 9.1 19.7M12 5C15.9 5 18 6.5 18 7S15.9 9 12 9 6 7.5 6 7 8.1 5 12 5M17 18C17.6 18 18 18.4 18 19S17.6 20 17 20 16 19.6 16 19 16.4 18 17 18M17 15C14.3 15 11.9 16.7 11 19C11.9 21.3 14.3 23 17 23S22.1 21.3 23 19C22.1 16.7 19.7 15 17 15M17 21.5C15.6 21.5 14.5 20.4 14.5 19S15.6 16.5 17 16.5 19.5 17.6 19.5 19 18.4 21.5 17 21.5Z", I4 = "M12 3C7.58 3 4 4.79 4 7V17C4 19.21 7.59 21 12 21S20 19.21 20 17V7C20 4.79 16.42 3 12 3M18 17C18 17.5 15.87 19 12 19S6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16S16.39 15.55 18 14.77V17M18 12.45C16.7 13.4 14.42 14 12 14C9.58 14 7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11C14.39 11 16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5C15.87 5 18 6.5 18 7S15.87 9 12 9Z", V4 = "M20 13.09V7C20 4.79 16.42 3 12 3S4 4.79 4 7V17C4 19.21 7.59 21 12 21C12.46 21 12.9 21 13.33 20.94C13.12 20.33 13 19.68 13 19L13 18.95C12.68 19 12.35 19 12 19C8.13 19 6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16C12.65 16 13.27 15.96 13.88 15.89C14.93 14.16 16.83 13 19 13C19.34 13 19.67 13.04 20 13.09M18 12.45C16.7 13.4 14.42 14 12 14S7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11S16.53 10.47 18 9.64V12.45M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5 18 6.5 18 7 15.87 9 12 9M20.41 19L22.54 21.12L21.12 22.54L19 20.41L16.88 22.54L15.47 21.12L17.59 19L15.47 16.88L16.88 15.47L19 17.59L21.12 15.47L22.54 16.88L20.41 19", H4 = "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z", F4 = "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z", z4 = "M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z", B4 = "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z", U4 = "M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z", W4 = "M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z", G4 = "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z", K4 = "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z", q4 = "M6.92,19L5,17.08L13.06,9L15,10.94M20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L13.84,6.41L11.91,4.5L10.5,5.91L11.92,7.33L3,16.25V21H7.75L16.67,12.08L18.09,13.5L19.5,12.09L17.58,10.17L20.7,7.05C21.1,6.65 21.1,6 20.71,5.63Z", Y4 = "M17.66 11.2C17.43 10.9 17.15 10.64 16.89 10.38C16.22 9.78 15.46 9.35 14.82 8.72C13.33 7.26 13 4.85 13.95 3C13 3.23 12.17 3.75 11.46 4.32C8.87 6.4 7.85 10.07 9.07 13.22C9.11 13.32 9.15 13.42 9.15 13.55C9.15 13.77 9 13.97 8.8 14.05C8.57 14.15 8.33 14.09 8.14 13.93C8.08 13.88 8.04 13.83 8 13.76C6.87 12.33 6.69 10.28 7.45 8.64C5.78 10 4.87 12.3 5 14.47C5.06 14.97 5.12 15.47 5.29 15.97C5.43 16.57 5.7 17.17 6 17.7C7.08 19.43 8.95 20.67 10.96 20.92C13.1 21.19 15.39 20.8 17.03 19.32C18.86 17.66 19.5 15 18.56 12.72L18.43 12.46C18.22 12 17.66 11.2 17.66 11.2M14.5 17.5C14.22 17.74 13.76 18 13.4 18.1C12.28 18.5 11.16 17.94 10.5 17.28C11.69 17 12.4 16.12 12.61 15.23C12.78 14.43 12.46 13.77 12.33 13C12.21 12.26 12.23 11.63 12.5 10.94C12.69 11.32 12.89 11.7 13.13 12C13.9 13 15.11 13.44 15.37 14.8C15.41 14.94 15.43 15.08 15.43 15.23C15.46 16.05 15.1 16.95 14.5 17.5H14.5Z", X4 = "M7,11H1V13H7V11M9.17,7.76L7.05,5.64L5.64,7.05L7.76,9.17L9.17,7.76M13,1H11V7H13V1M18.36,7.05L16.95,5.64L14.83,7.76L16.24,9.17L18.36,7.05M17,11V13H23V11H17M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M14.83,16.24L16.95,18.36L18.36,16.95L16.24,14.83L14.83,16.24M5.64,16.95L7.05,18.36L9.17,16.24L7.76,14.83L5.64,16.95M11,23H13V17H11V23Z", Z4 = "M5,3A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5.5L18.5,3H17V9A1,1 0 0,1 16,10H8A1,1 0 0,1 7,9V3H5M12,4V9H15V4H12M7,12H17A1,1 0 0,1 18,13V19H6V13A1,1 0 0,1 7,12Z", J4 = "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z", Q4 = "M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z", eL = "M11,9H13V11H11V9M9,11H11V13H9V11M13,11H15V13H13V11M15,9H17V11H15V9M7,9H9V11H7V9M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M9,18H7V16H9V18M13,18H11V16H13V18M17,18H15V16H17V18M19,11H17V13H19V15H17V13H15V15H13V13H11V15H9V13H7V15H5V13H7V11H5V5H19V11Z", tL = "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z", nL = "M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z", rL = "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z", oL = "M13.5,4A1.5,1.5 0 0,0 12,5.5A1.5,1.5 0 0,0 13.5,7A1.5,1.5 0 0,0 15,5.5A1.5,1.5 0 0,0 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z", sL = "M12,16L19.36,10.27L21,9L12,2L3,9L4.63,10.27M12,18.54L4.62,12.81L3,14.07L12,21.07L21,14.07L19.37,12.8L12,18.54Z", iL = "M11 15H6L13 1V9H18L11 23V15Z", aL = "M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z", lL = "M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z", cL = "M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z", uL = "M18 1C15.24 1 13 3.24 13 6V8H4C2.9 8 2 8.89 2 10V20C2 21.11 2.9 22 4 22H16C17.11 22 18 21.11 18 20V10C18 8.9 17.11 8 16 8H15V6C15 4.34 16.34 3 18 3C19.66 3 21 4.34 21 6V8H23V6C23 3.24 20.76 1 18 1M10 13C11.1 13 12 13.89 12 15C12 16.11 11.11 17 10 17C8.9 17 8 16.11 8 15C8 13.9 8.9 13 10 13Z", dL = "M7,10L12,15L17,10H7Z", fL = "M20 5L20 19L4 19L4 5H20M20 3H4C2.89 3 2 3.89 2 5V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V5C22 3.89 21.11 3 20 3M18 15H6V17H18V15M10 7H6V13H10V7M12 9H18V7H12V9M18 11H12V13H18V11Z", pL = "M12,2C13.85,2 15.55,2.78 16.9,4.1L18.6,1.93L20.18,3.16L18.2,5.68C19.33,7.41 20,9.6 20,12C20,17.5 16.42,22 12,22C10.15,22 8.45,21.22 7.1,19.9L5.4,22.07L3.82,20.84L5.8,18.32C4.67,16.59 4,14.4 4,12C4,6.5 7.58,2 12,2M12,4C8.69,4 6,7.58 6,12C6,13.73 6.41,15.33 7.11,16.64L15.67,5.67C14.66,4.62 13.38,4 12,4M12,20C15.31,20 18,16.42 18,12C18,10.27 17.59,8.67 16.89,7.36L8.33,18.33C9.34,19.38 10.62,20 12,20Z", gL = "M4,17V9H2V7H6V17H4M22,15C22,16.11 21.1,17 20,17H16V15H20V13H18V11H20V9H16V7H20A2,2 0 0,1 22,9V10.5A1.5,1.5 0 0,1 20.5,12A1.5,1.5 0 0,1 22,13.5V15M14,15V17H8V13C8,11.89 8.9,11 10,11H12V9H8V7H12A2,2 0 0,1 14,9V11C14,12.11 13.1,13 12,13H10V15H14Z", hL = "M2.53,19.65L3.87,20.21V11.18L1.44,17.04C1.03,18.06 1.5,19.23 2.53,19.65M22.03,15.95L17.07,4C16.76,3.23 16.03,2.77 15.26,2.75C15,2.75 14.73,2.79 14.47,2.9L7.1,5.95C6.35,6.26 5.89,7 5.87,7.75C5.86,8 5.91,8.29 6,8.55L11,20.5C11.29,21.28 12.03,21.74 12.81,21.75C13.07,21.75 13.33,21.7 13.58,21.6L20.94,18.55C21.96,18.13 22.45,16.96 22.03,15.95M7.88,8.75A1,1 0 0,1 6.88,7.75A1,1 0 0,1 7.88,6.75C8.43,6.75 8.88,7.2 8.88,7.75C8.88,8.3 8.43,8.75 7.88,8.75M5.88,19.75A2,2 0 0,0 7.88,21.75H9.33L5.88,13.41V19.75Z", mL = "M12,2.5L8,7H16L12,2.5M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M8,17L12,21.5L16,17H8Z", vL = "M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z", yL = "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z", bL = "M17,13H13V17H11V13H7V11H11V7H13V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z", xL = "M16,7V3H14V7H10V3H8V7H8C7,7 6,8 6,9V14.5L9.5,18V21H14.5V18L18,14.5V9C18,8 17,7 16,7Z", wL = "M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z", SL = "M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 4L20 12L12 20L4 12Z", jL = "M13.13 22.19L11.5 18.36C13.07 17.78 14.54 17 15.9 16.09L13.13 22.19M5.64 12.5L1.81 10.87L7.91 8.1C7 9.46 6.22 10.93 5.64 12.5M21.61 2.39C21.61 2.39 16.66 .269 11 5.93C8.81 8.12 7.5 10.53 6.65 12.64C6.37 13.39 6.56 14.21 7.11 14.77L9.24 16.89C9.79 17.45 10.61 17.63 11.36 17.35C13.5 16.53 15.88 15.19 18.07 13C23.73 7.34 21.61 2.39 21.61 2.39M14.54 9.46C13.76 8.68 13.76 7.41 14.54 6.63S16.59 5.85 17.37 6.63C18.14 7.41 18.15 8.68 17.37 9.46C16.59 10.24 15.32 10.24 14.54 9.46M8.88 16.53L7.47 15.12L8.88 16.53M6.24 22L9.88 18.36C9.54 18.27 9.21 18.12 8.91 17.91L4.83 22H6.24M2 22H3.41L8.18 17.24L6.76 15.83L2 20.59V22M2 19.17L6.09 15.09C5.88 14.79 5.73 14.47 5.64 14.12L2 17.76V19.17Z", CL = "M18,18H6V6H18V18Z", EL = "M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.89,2 2,2.89 2,4V11C2,11.55 2.22,12.05 2.59,12.41L11.58,21.41C11.95,21.77 12.45,22 13,22C13.55,22 14.05,21.77 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.44 21.77,11.94 21.41,11.58Z", PL = "M11,2V4.07C7.38,4.53 4.53,7.38 4.07,11H2V13H4.07C4.53,16.62 7.38,19.47 11,19.93V22H13V19.93C16.62,19.47 19.47,16.62 19.93,13H22V11H19.93C19.47,7.38 16.62,4.53 13,4.07V2M11,6.08V8H13V6.09C15.5,6.5 17.5,8.5 17.92,11H16V13H17.91C17.5,15.5 15.5,17.5 13,17.92V16H11V17.91C8.5,17.5 6.5,15.5 6.08,13H8V11H6.09C6.5,8.5 8.5,6.5 11,6.08M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11Z", _L = "M22.08,11.04H20.08V4H13.05V2H11.04V4H4V11.04H2V13.05H4V20.08H11.04V22.08H13.05V20.08H20.08V13.05H22.08V11.04M18.07,18.07H13.05V16.06H11.04V18.07H6V13.05H8.03V11.04H6V6H11.04V8.03H13.05V6H18.07V11.04H16.06V13.05H18.07V18.07M13.05,12.05A1,1 0 0,1 12.05,13.05C11.5,13.05 11.04,12.6 11.04,12.05C11.04,11.5 11.5,11.04 12.05,11.04C12.6,11.04 13.05,11.5 13.05,12.05Z", kL = "M16,15H9V13H16M19,11H9V9H19M19,7H9V5H19M21,1H7C5.89,1 5,1.89 5,3V17C5,18.11 5.9,19 7,19H21C22.11,19 23,18.11 23,17V3C23,1.89 22.1,1 21,1M3,5V21H19V23H3A2,2 0 0,1 1,21V5H3Z", TL = "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z", OL = "M17 6H7C3.69 6 1 8.69 1 12S3.69 18 7 18H17C20.31 18 23 15.31 23 12S20.31 6 17 6M17 16H7C4.79 16 3 14.21 3 12S4.79 8 7 8H17C19.21 8 21 9.79 21 12S19.21 16 17 16M17 9C15.34 9 14 10.34 14 12S15.34 15 17 15 20 13.66 20 12 18.66 9 17 9Z", LL = "M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z", ML = "M16.59,5.41L15.17,4L12,7.17L8.83,4L7.41,5.41L12,10M7.41,18.59L8.83,20L12,16.83L15.17,20L16.58,18.59L12,14L7.41,18.59Z", AL = "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z", RL = "M13,3V9H21V3M13,21H21V11H13M3,21H11V15H3M3,13H11V3H3V13Z", NL = "M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z", $L = "M13 3V11H21V3H13M3 21H11V13H3V21M3 3V11H11V3H3M13 16H16V13H18V16H21V18H18V21H16V18H13V16Z", DL = "M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z", IL = "M12.89,3L14.85,3.4L11.11,21L9.15,20.6L12.89,3M19.59,12L16,8.41V5.58L22.42,12L16,18.41V15.58L19.59,12M1.58,12L8,5.58V8.41L4.41,12L8,15.58V18.41L1.58,12Z";
const G = Q.forwardRef(function({ as: t, children: n, className: r, col: o, revert: i, full: l, nowrap: c, space: d, gap: p, justify: g, items: m, ...v }, b) {
  const x = t || "div";
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ u.jsx(
      x,
      {
        ref: b,
        className: ce([
          r,
          "gs-utl-flex",
          o && !i && "gs-utl-flex-col",
          o && i && "gs-utl-flex-col-reverse",
          !o && i && "gs-utl-flex-row-reverse",
          l && !o && "gs-utl-w-full",
          l && o && "gs-utl-h-full",
          c ? "gs-utl-flex-nowrap" : "gs-utl-flex-wrap",
          d === "x2s" && (o ? "gs-utl-space-y-0.5" : "gs-utl-space-x-0.5"),
          d === "xs" && (o ? "gs-utl-space-y-1" : "gs-utl-space-x-1"),
          d === "s" && (o ? "gs-utl-space-y-2" : "gs-utl-space-x-2"),
          d === "m" && (o ? "gs-utl-space-y-4" : "gs-utl-space-x-4"),
          d === "l" && (o ? "gs-utl-space-y-6" : "gs-utl-space-x-6"),
          d === "xl" && (o ? "gs-utl-space-y-8" : "gs-utl-space-x-8"),
          // Gap
          p === "x2s" && "gs-utl-gap-0.5",
          p === "xs" && "gs-utl-gap-1",
          p === "s" && "gs-utl-gap-2",
          p === "m" && "gs-utl-gap-4",
          p === "l" && "gs-utl-gap-6",
          p === "xl" && "gs-utl-gap-8",
          // Items
          m === "start" && "gs-utl-items-start",
          m === "end" && "gs-utl-items-end",
          m === "center" && "gs-utl-items-center",
          // Justify
          g === "start" && "gs-utl-justify-start",
          g === "end" && "gs-utl-justify-end",
          g === "center" && "gs-utl-justify-center",
          g === "between" && "gs-utl-justify-between"
        ]),
        ...v,
        children: n
      }
    )
  );
}), Y = Q.forwardRef(function({ children: t, className: n, grow: r, ...o }, i) {
  return /* @__PURE__ */ u.jsx("div", { ref: i, className: ce([n, r && "flex-1"]), ...o, children: t });
});
var pm = { exports: {} }, gm, gw;
function VL() {
  if (gw)
    return gm;
  gw = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return gm = e, gm;
}
var hm, hw;
function HL() {
  if (hw)
    return hm;
  hw = 1;
  var e = VL();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, hm = function() {
    function r(l, c, d, p, g, m) {
      if (m !== e) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, hm;
}
var mw;
function FL() {
  return mw || (mw = 1, pm.exports = HL()()), pm.exports;
}
var zL = function(e) {
  var t = {};
  function n(r) {
    if (t[r])
      return t[r].exports;
    var o = t[r] = { i: r, l: !1, exports: {} };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  return n.m = e, n.c = t, n.d = function(r, o, i) {
    n.o(r, o) || Object.defineProperty(r, o, { enumerable: !0, get: i });
  }, n.r = function(r) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(r, "__esModule", { value: !0 });
  }, n.t = function(r, o) {
    if (1 & o && (r = n(r)), 8 & o || 4 & o && typeof r == "object" && r && r.__esModule)
      return r;
    var i = /* @__PURE__ */ Object.create(null);
    if (n.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: r }), 2 & o && typeof r != "string")
      for (var l in r)
        n.d(i, l, (function(c) {
          return r[c];
        }).bind(null, l));
    return i;
  }, n.n = function(r) {
    var o = r && r.__esModule ? function() {
      return r.default;
    } : function() {
      return r;
    };
    return n.d(o, "a", o), o;
  }, n.o = function(r, o) {
    return Object.prototype.hasOwnProperty.call(r, o);
  }, n.p = "", n(n.s = 2);
}([function(e, t) {
  e.exports = FL();
}, function(e, t) {
  e.exports = y;
}, function(e, t, n) {
  n.r(t);
  var r = n(1), o = n(0), i = function() {
    return (i = Object.assign || function(x) {
      for (var w, j = 1, C = arguments.length; j < C; j++)
        for (var E in w = arguments[j])
          Object.prototype.hasOwnProperty.call(w, E) && (x[E] = w[E]);
      return x;
    }).apply(this, arguments);
  }, l = function(x, w) {
    var j = {};
    for (var C in x)
      Object.prototype.hasOwnProperty.call(x, C) && w.indexOf(C) < 0 && (j[C] = x[C]);
    if (x != null && typeof Object.getOwnPropertySymbols == "function") {
      var E = 0;
      for (C = Object.getOwnPropertySymbols(x); E < C.length; E++)
        w.indexOf(C[E]) < 0 && Object.prototype.propertyIsEnumerable.call(x, C[E]) && (j[C[E]] = x[C[E]]);
    }
    return j;
  }, c = 0, d = r.forwardRef(function(x, w) {
    var j = x.title, C = j === void 0 ? null : j, E = x.description, P = E === void 0 ? null : E, k = x.size, T = k === void 0 ? null : k, O = x.color, A = O === void 0 ? "currentColor" : O, $ = x.horizontal, N = $ === void 0 ? null : $, R = x.vertical, z = R === void 0 ? null : R, D = x.rotate, Z = D === void 0 ? null : D, K = x.spin, H = K === void 0 ? null : K, q = x.style, te = q === void 0 ? {} : q, I = x.children, F = l(x, ["title", "description", "size", "color", "horizontal", "vertical", "rotate", "spin", "style", "children"]);
    c++;
    var V, L = H !== null && H, W = r.Children.map(I, function(me) {
      var oe = me;
      L !== !0 && (L = (H === null ? oe.props.spin : H) === !0);
      var se = oe.props.size;
      typeof T == "number" && typeof oe.props.size == "number" && (se = oe.props.size / T);
      var de = { size: se, color: A === null ? oe.props.color : A, horizontal: N === null ? oe.props.horizontal : N, vertical: z === null ? oe.props.vertical : z, rotate: Z === null ? oe.props.rotate : Z, spin: H === null ? oe.props.spin : H, inStack: !0 };
      return r.cloneElement(oe, de);
    });
    T !== null && (te.width = typeof T == "string" ? T : 1.5 * T + "rem");
    var ie, re = "stack_labelledby_" + c, le = "stack_describedby_" + c;
    if (C)
      V = P ? re + " " + le : re;
    else if (ie = "presentation", P)
      throw new Error("title attribute required when description is set");
    return r.createElement("svg", i({ ref: w, viewBox: "0 0 24 24", style: te, role: ie, "aria-labelledby": V }, F), C && r.createElement("title", { id: re }, C), P && r.createElement("desc", { id: le }, P), L && r.createElement("style", null, "@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }", "@keyframes spin-inverse { from { transform: rotate(0deg) } to { transform: rotate(-360deg) } }"), W);
  });
  d.displayName = "Stack", d.propTypes = { size: o.oneOfType([o.number, o.string]), color: o.string, horizontal: o.bool, vertical: o.bool, rotate: o.number, spin: o.oneOfType([o.bool, o.number]), children: o.oneOfType([o.arrayOf(o.node), o.node]).isRequired, className: o.string, style: o.object }, d.defaultProps = { size: null, color: null, horizontal: null, vertical: null, rotate: null, spin: null };
  var p = d;
  n.d(t, "Icon", function() {
    return b;
  }), n.d(t, "Stack", function() {
    return p;
  });
  var g = function() {
    return (g = Object.assign || function(x) {
      for (var w, j = 1, C = arguments.length; j < C; j++)
        for (var E in w = arguments[j])
          Object.prototype.hasOwnProperty.call(w, E) && (x[E] = w[E]);
      return x;
    }).apply(this, arguments);
  }, m = function(x, w) {
    var j = {};
    for (var C in x)
      Object.prototype.hasOwnProperty.call(x, C) && w.indexOf(C) < 0 && (j[C] = x[C]);
    if (x != null && typeof Object.getOwnPropertySymbols == "function") {
      var E = 0;
      for (C = Object.getOwnPropertySymbols(x); E < C.length; E++)
        w.indexOf(C[E]) < 0 && Object.prototype.propertyIsEnumerable.call(x, C[E]) && (j[C[E]] = x[C[E]]);
    }
    return j;
  }, v = 0, b = r.forwardRef(function(x, w) {
    var j = x.path, C = x.id, E = C === void 0 ? ++v : C, P = x.title, k = P === void 0 ? null : P, T = x.description, O = T === void 0 ? null : T, A = x.size, $ = A === void 0 ? null : A, N = x.color, R = N === void 0 ? "currentColor" : N, z = x.horizontal, D = z !== void 0 && z, Z = x.vertical, K = Z !== void 0 && Z, H = x.rotate, q = H === void 0 ? 0 : H, te = x.spin, I = te !== void 0 && te, F = x.style, V = F === void 0 ? {} : F, L = x.inStack, W = L !== void 0 && L, ie = m(x, ["path", "id", "title", "description", "size", "color", "horizontal", "vertical", "rotate", "spin", "style", "inStack"]), re = {}, le = [];
    $ !== null && (W ? le.push("scale(" + $ + ")") : (V.width = typeof $ == "string" ? $ : 1.5 * $ + "rem", V.height = V.width)), D && le.push("scaleX(-1)"), K && le.push("scaleY(-1)"), q !== 0 && le.push("rotate(" + q + "deg)"), R !== null && (re.fill = R);
    var me = r.createElement("path", g({ d: j, style: re }, W ? ie : {})), oe = me;
    le.length > 0 && (V.transform = le.join(" "), V.transformOrigin = "center", W && (oe = r.createElement("g", { style: V }, me, r.createElement("rect", { width: "24", height: "24", fill: "transparent" }))));
    var se, de = oe, we = I === !0 || typeof I != "number" ? 2 : I, je = !W && (D || K);
    if (we < 0 && (je = !je), I && (de = r.createElement("g", { style: { animation: "spin" + (je ? "-inverse" : "") + " linear " + Math.abs(we) + "s infinite", transformOrigin: "center" } }, oe, !(D || K || q !== 0) && r.createElement("rect", { width: "24", height: "24", fill: "transparent" }))), W)
      return de;
    var He, Le = "icon_labelledby_" + E, ot = "icon_describedby_" + E;
    if (k)
      se = O ? Le + " " + ot : Le;
    else if (He = "presentation", O)
      throw new Error("title attribute required when description is set");
    return r.createElement("svg", g({ ref: w, viewBox: "0 0 24 24", style: V, role: He, "aria-labelledby": se }, ie), k && r.createElement("title", { id: Le }, k), O && r.createElement("desc", { id: ot }, O), !W && I && (je ? r.createElement("style", null, "@keyframes spin-inverse { from { transform: rotate(0deg) } to { transform: rotate(-360deg) } }") : r.createElement("style", null, "@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }")), de);
  });
  b.displayName = "Icon", b.propTypes = { path: o.string.isRequired, size: o.oneOfType([o.number, o.string]), color: o.string, horizontal: o.bool, vertical: o.bool, rotate: o.number, spin: o.oneOfType([o.bool, o.number]), style: o.object, inStack: o.bool, className: o.string }, b.defaultProps = { size: null, color: "currentColor", horizontal: !1, vertical: !1, rotate: 0, spin: !1 }, t.default = b;
}]);
const BL = /* @__PURE__ */ ju(zL);
var fC = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", l = 0; l < arguments.length; l++) {
        var c = arguments[l];
        c && (i = o(i, r(c)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var l = "";
      for (var c in i)
        t.call(i, c) && i[c] && (l = o(l, c));
      return l;
    }
    function o(i, l) {
      return l ? i ? i + " " + l : i + l : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(fC);
var UL = fC.exports;
const B = /* @__PURE__ */ ju(UL), vw = /* @__PURE__ */ new Map(), $v = Q.forwardRef(function({ svg: t, iconSize: n, ...r }, o) {
  let i = vw.get(t);
  return i || (i = hO(t, n), vw.set(t, i)), /* @__PURE__ */ u.jsx("div", { ...r, ref: o, dangerouslySetInnerHTML: { __html: i } });
});
var fe = /* @__PURE__ */ ((e) => (e.alertRhombus = "alertRhombus", e.alignHorizontalCenter = "alignHorizontalCenter", e.alignHorizontalLeft = "alignHorizontalLeft", e.alignHorizontalRight = "alignHorizontalRight", e.applicationBracketsOutline = "applicationBracketsOutline", e.arrowDown = "arrowDown", e.arrowExpandAll = "arrowExpandAll", e.arrowRight = "arrowRight", e.arrowULeftTop = "arrowULeftTop", e.arrowURightTop = "arrowURightTop", e.borderAllVariant = "borderAllVariant", e.borderRadius = "borderRadius", e.borderStyle = "borderStyle", e.cellphoneLink = "cellphoneLink", e.check = "check", e.checkBold = "checkBold", e.checkboxBlank = "checkboxBlank", e.chevronUp = "chevronUp", e.chevronDown = "chevronDown", e.chevronLeft = "chevronLeft", e.chevronRight = "chevronRight", e.close = "close", e.codeBraces = "codeBraces", e.cog = "cog", e.contentCopy = "contentCopy", e.contentSave = "contentSave", e.delete = "delete", e.dotsVertical = "dotsVertical", e.email = "email", e.emailOutline = "emailOutline", e.eye = "eye", e.eyedropperVariant = "eyedropperVariant", e.eyeOff = "eyeOff", e.eyeOffOutline = "eyeOffOutline", e.eyeOutline = "eyeOutline", e.fire = "fire", e.flare = "flare", e.floppy = "floppy", e.folder = "folder", e.fullscreen = "fullscreen", e.gradientVertical = "gradientVertical", e.helpCircle = "helpCircle", e.image = "image", e.information = "information", e.informationVariant = "informationVariant", e.layers = "layers", e.link = "link", e.lock = "lock", e.lockOpenVariant = "lockOpenVariant", e.menuDown = "menuDown", e.newspaperVariantOutline = "newspaperVariantOutline", e.paletteSwatch = "paletteSwatch", e.panVertical = "panVertical", e.phone = "phone", e.plus = "plus", e.plusBox = "plusBox", e.powerPlug = "powerPlug", e.refresh = "refresh", e.rhombusOutline = "rhombusOutline", e.tag = "tag", e.target = "target", e.targetVariant = "targetVariant", e.textBoxMultiple = "textBoxMultiple", e.trayArrowDown = "trayArrowDown", e.unfoldLessHorizontal = "unfoldLessHorizontal", e.unfoldMoreHorizontal = "unfoldMoreHorizontal", e.viewDayOutline = "viewDayOutline", e.viewGridPlus = "viewGridPlus", e.web = "web", e.xml = "xml", e.databaseOutline = "databaseOutline", e.databaseOutlineOn = "databaseOutlineOn", e.databaseOutlineOff = "databaseOutlineOff", e.databaseOutlineRemove = "databaseOutlineRemove", e.toggleSwitchOutline = "toggleSwitchOutline", e.toggleSwitchOffOutline = "toggleSwitchOffOutline", e.codeBrackets = "codeBrackets", e.null = "null", e.codeString = "string", e.number = "number", e.cloudUpload = "cloudUpload", e.chat = "chat", e.creation = "creation", e.viewDashboard = "viewDashboard", e.rocketLaunch = "rocketLaunch", e.lightningBolt = "lightningBolt", e.stop = "stop", e.arrowUp = "arrowUp", e))(fe || {});
const Xf = {
  alertRhombus: o4,
  alignHorizontalCenter: s4,
  alignHorizontalLeft: i4,
  alignHorizontalRight: a4,
  applicationBracketsOutline: l4,
  arrowDown: c4,
  arrowExpandAll: u4,
  arrowRight: d4,
  arrowULeftTop: f4,
  arrowURightTop: p4,
  borderAllVariant: h4,
  borderRadius: m4,
  borderStyle: v4,
  cellphoneLink: y4,
  check: x4,
  checkBold: w4,
  checkboxBlank: S4,
  chevronUp: P4,
  chevronDown: j4,
  chevronLeft: C4,
  chevronRight: E4,
  close: _4,
  codeBraces: T4,
  cog: M4,
  contentCopy: A4,
  contentSave: R4,
  delete: H4,
  dotsVertical: F4,
  email: z4,
  emailOutline: B4,
  eye: U4,
  eyedropperVariant: q4,
  eyeOff: W4,
  eyeOffOutline: G4,
  eyeOutline: K4,
  fire: Y4,
  flare: X4,
  floppy: Z4,
  folder: J4,
  fullscreen: Q4,
  gradientVertical: eL,
  helpCircle: tL,
  image: nL,
  information: rL,
  informationVariant: oL,
  layers: sL,
  link: aL,
  lock: cL,
  lockOpenVariant: uL,
  menuDown: dL,
  newspaperVariantOutline: fL,
  paletteSwatch: hL,
  panVertical: mL,
  phone: vL,
  plus: yL,
  plusBox: bL,
  powerPlug: xL,
  refresh: wL,
  rhombusOutline: SL,
  tag: EL,
  target: PL,
  targetVariant: _L,
  textBoxMultiple: kL,
  trayArrowDown: LL,
  unfoldLessHorizontal: ML,
  unfoldMoreHorizontal: AL,
  viewDayOutline: NL,
  viewGridPlus: $L,
  web: DL,
  xml: IL,
  databaseOutline: I4,
  databaseOutlineOn: D4,
  databaseOutlineOff: $4,
  databaseOutlineRemove: V4,
  codeBrackets: O4,
  toggleSwitchOutline: OL,
  toggleSwitchOffOutline: TL,
  null: pL,
  string: L4,
  number: gL,
  cloudUpload: k4,
  chat: b4,
  creation: N4,
  viewDashboard: RL,
  rocketLaunch: jL,
  lightningBolt: iL,
  stop: CL,
  arrowUp: g4
}, WL = "gs-cmp-icon", ye = xe(function({
  className: t,
  icon: n,
  size: r,
  rotate: o,
  horizontal: i,
  vertical: l
}) {
  var m;
  const c = (m = tH()) == null ? void 0 : m.sdkCustomIcons, d = (c == null ? void 0 : c[n]) || (Xf == null ? void 0 : Xf[n]) || n, p = [i && "scaleX(-1)", l && "scaleY(-1)", o && `rotate(${o}deg)`].filter((v) => !!v).join(" ");
  if (!d)
    return null;
  const g = B(WL, t);
  return d.startsWith("<svg") || d.startsWith("<?xml") ? /* @__PURE__ */ u.jsx(
    $v,
    {
      className: g,
      style: {
        transform: p || void 0
      },
      svg: d,
      iconSize: r
    }
  ) : /* @__PURE__ */ u.jsx(
    BL,
    {
      className: g,
      path: d,
      size: r,
      rotate: o,
      horizontal: i,
      vertical: l
    }
  );
}), pC = 150;
var dt = /* @__PURE__ */ ((e) => (e.txt = "gs-theme-cl-txt", e.bg = "gs-theme-cl-bg", e.br = "gs-theme-cl-br", e.bgA = "gs-theme-cl-bgA", e.bgA2 = "gs-theme-cl-bgA2", e.hBgAct = "gs-theme-cl-hBgAct", e.hBgA2 = "gs-theme-cl-hBgA2", e.tA = "gs-theme-cl-tA", e.tAo = "gs-theme-cl-tAo", e.hTAo = "gs-theme-cl-hTAo", e.grouphTAo = "gs-theme-cl-grouphTAo", e.bA = "gs-theme-cl-bA", e.bg0 = "gs-theme-cl-bg0", e.bgH = "gs-theme-cl-bgH", e.hBgH = "gs-theme-cl-hBgH", e.bgH2 = "gs-theme-cl-bgH2", e.hBgH2 = "gs-theme-cl-hBgH2", e.sel = "gs-theme-cl-sel", e.selBr = "gs-theme-cl-selBr", e.cmp = "gs-theme-cl-cmp", e.cmpBgSoft = "gs-theme-cl-cmpBgSoft", e.cmpBgSoftX = "gs-theme-cl-cmpBgSoftX", e.cmpBr = "gs-theme-cl-cmpBr", e.cmpSymbol = "gs-theme-cl-cmpSymbol", e.cmpBgSymbolSoft = "gs-theme-cl-cmpBgSymbolSoft", e.cmpBgSymbolSoftX = "gs-theme-cl-cmpBgSymbolSoftX", e.cmpSymbolBr = "gs-theme-cl-cmpSymbolBr", e.cmpTxtActive = "gs-theme-cl-cmpTxtActive", e.focus = "gs-theme-ring-focus", e.inputText = "gs-theme-elStyles-inputText", e))(dt || {});
const ee = {
  /** background transparent */
  bgTr: "gs-utl-bg-transparent",
  /** text */
  txt: "gs-theme-cl-txt gs-utl-text-gray-900 dark:gs-utl-text-gray-400",
  /** text low emphasis */
  txtLowEmphasis: "gs-utl-text-neutral-500 dark:gs-utl-text-neutral-500",
  /** text high emphasis */
  txtHighEmphasis: "gs-utl-text-black dark:gs-utl-text-gray-200",
  /** text high emphasis hovered */
  txtHighEmphasisH: "hover:gs-utl-text-black hover:dark:gs-utl-text-gray-200",
  /** text active */
  tA: "gs-theme-cl-tA gs-utl-text-violet-400",
  /** text active opaque */
  tAo: "gs-theme-cl-tAo gs-utl-text-violet-800 dark:gs-utl-text-violet-400",
  /** text active hovered opaque */
  hTAo: "gs-theme-cl-hTAo hover:gs-utl-text-violet-800 hover:dark:gs-utl-text-violet-400",
  /** text active group hovered opaque */
  grouphTAo: "gs-theme-cl-grouphTAo group-hover:gs-utl-text-violet-800 group-hover:dark:gs-utl-text-violet-400",
  /** border active */
  bA: "gs-theme-cl-bA gs-utl-border-violet-400",
  /** background active */
  bgA: "gs-theme-cl-bgA gs-utl-bg-violet-400 gs-utl-text-white dark:gs-utl-bg-violet-500",
  /** background active level 2 */
  bgA2: "gs-theme-cl-bgA2 gs-utl-bg-violet-500 gs-utl-text-white",
  /** background opaque */
  bgO: "gs-theme-cl-bg0 gs-utl-bg-violet-50 gs-utl-text-violet-900 dark:gs-utl-bg-zinc-800 dark:gs-utl-text-violet-400",
  /** background */
  bg: "gs-theme-cl-bg gs-utl-bg-white dark:gs-utl-bg-zinc-900",
  /** background that blurs content behind it */
  bgBlur: "gs-utl-bg-white/50 dark:gs-utl-bg-zinc-900/50 gs-utl-backdrop-blur-sm",
  /** background heading */
  bgH: "gs-theme-cl-bgH gs-utl-bg-gray-100 dark:gs-utl-bg-zinc-700",
  /** background heading 75 */
  bgH75: "gs-utl-bg-gray-100/75 dark:gs-utl-bg-zinc-700/75",
  /** background hovered heading */
  hBgH: "gs-theme-cl-hBgH hover:gs-utl-bg-gray-50 hover:dark:gs-utl-bg-zinc-800",
  /** background heading 2 */
  bgH2: "gs-theme-cl-bgH2 gs-utl-bg-gray-25 dark:gs-utl-bg-zinc-800",
  /** background hovered heading 2 */
  hBgH2: "gs-theme-cl-hBgH2 hover:gs-utl-bg-gray-25 hover:dark:gs-utl-bg-zinc-800",
  /** background hovered active */
  hBgAct: "gs-theme-cl-hBgAct hover:gs-utl-bg-violet-800 hover:dark:gs-utl-bg-violet-400",
  /** background hovered active 2 */
  hBgA2: "gs-theme-cl-hBgA2 hover:gs-utl-bg-violet-500 hover:dark:gs-utl-bg-violet-600",
  /** background hovered dark */
  hBgDark: "hover:gs-utl-bg-black/10",
  /** selector */
  sel: "gs-theme-cl-sel gs-utl-bg-pink-200 gs-utl-text-pink-900",
  /** selector border */
  selBr: "gs-theme-cl-selBr gs-utl-border-pink-900",
  /** component */
  cmp: "gs-theme-cl-cmp gs-utl-bg-blue-450 gs-utl-text-white",
  /** component symbol */
  cmpSymbol: "gs-theme-cl-cmpSymbol gs-utl-bg-[#7b61ff] gs-utl-text-white",
  /** component background soft */
  cmpBgSoft: "gs-theme-cl-cmpBgSoft gs-utl-bg-blue-100 dark:gs-utl-bg-sky-800",
  /** component background symbol soft */
  cmpBgSymbolSoft: "gs-theme-cl-cmpBgSymbolSoft gs-utl-bg-violet-200 dark:gs-utl-bg-violet-800",
  /** component background soft X?? */
  cmpBgSoftX: "gs-theme-cl-cmpBgSoftX gs-utl-bg-blue-50 dark:gs-utl-bg-gray-800",
  /** component background symbol soft X?? */
  cmpBgSymbolSoftX: "gs-theme-cl-cmpBgSymbolSoftX gs-utl-bg-[#edebff] dark:gs-utl-bg-[#2d1b4b]",
  /** component text active */
  cmpTxtActive: "gs-theme-cl-cmpTxtActive dark:gs-utl-text-gray-300",
  /** component border */
  cmpBr: "gs-theme-cl-cmpBr gs-utl-border-blue-450",
  /** component symbol border */
  cmpSymbolBr: "gs-theme-cl-cmpSymbolBr gs-utl-border-[#7b61ff]",
  /** component target background */
  cmpTargetBg: "gs-utl-bg-amber-500 gs-utl-text-white",
  /** component target background opaque */
  cmpTargetBgOpac: "gs-utl-bg-amber-500/5",
  /** component target border */
  cmpTargetBr: "gs-utl-border-amber-500",
  // warning
  /** text warning */
  tW: "gs-utl-text-amber-500",
  /** background warning */
  bgW: "gs-utl-bg-amber-500",
  /** background red */
  bgRed: "gs-utl-bg-red-500",
  /** hovered background red */
  hBgRed: "hover:gs-utl-bg-red-600",
  /** hovered background warning */
  hBgW: "hover:gs-utl-bg-amber-600",
  /** border */
  br: "gs-theme-cl-br gs-utl-border-gray-300 dark:gs-utl-border-zinc-700",
  brRed: "gs-utl-border-red-500",
  /** border light */
  brLight: "gs-utl-border-white/25"
}, Dv = {
  enter: "gs-utl-transition gs-utl-duration-100 gs-utl-ease-out",
  enterFrom: "gs-utl-scale-95 gs-utl-opacity-0",
  enterTo: "gs-utl-opacity-100",
  leave: "gs-utl-transition gs-utl-ease-in gs-utl-duration-100",
  leaveFrom: "gs-utl-scale-100 gs-utl-opacity-100",
  leaveTo: "gs-utl-scale-95 gs-utl-opacity-0"
}, gC = {
  enter: "gs-utl-transition gs-utl-duration-100 gs-utl-ease-out",
  enterFrom: "gs-utl-opacity-0",
  enterTo: "gs-utl-opacity-100"
}, GL = {
  leave: "gs-utl-transition gs-utl-ease-in gs-utl-duration-100",
  leaveFrom: "gs-utl-opacity-100",
  leaveTo: "gs-utl-opacity-0"
}, Au = {
  ...gC,
  ...GL
}, tt = {
  xy: "gs-utl-px-4 gs-utl-py-2",
  xyS: "gs-utl-px-2 gs-utl-py-1",
  xyS2: "gs-utl-px-2 gs-utl-py-0.5",
  x: "gs-utl-px-4",
  xS: "gs-utl-px-2",
  y: "gs-utl-py-2",
  s: "gs-utl-p-2"
}, Iv = {
  bg: ee.bg,
  bgH: ee.bgH
}, yw = {
  bg: "gs-utl-bg-zinc-700",
  //'gs-utl-bg-gray-800',
  txt: "gs-utl-text-white",
  block: "gs-utl-text-xs gs-utl-mt-1 gs-utl-bg-white/10 gs-utl-rounded gs-utl-px-2 gs-utl-py-1"
}, ve = {
  /** rounded */
  rnd: "gs-utl-rounded",
  pill: "gs-utl-rounded-full",
  /** border */
  b: "gs-utl-border",
  /** border transparent */
  bT: "gs-utl-border-transparent",
  /** border super? */
  bS: "gs-utl-border-2",
  /** border top */
  bt: "gs-utl-border-t",
  /** border bottom */
  bb: "gs-utl-border-b",
  /** border right */
  br: "gs-utl-border-r",
  /** border left */
  bl: "gs-utl-border-l",
  /** border active */
  bA: "gs-theme-cl-bA gs-utl-border-violet-400 dark:gs-utl-border-violet-500"
}, lu = {
  focus: "gs-theme-ring-focus focus:gs-utl-outline-none focus-visible:gs-utl-ring-2 gs-utl-ring-violet-300 gs-utl-ring-opacity-80",
  deepFocus: "focus:gs-utl-outline-none [&:has(:focus-visible)]:gs-utl-ring-2 gs-utl-ring-violet-300 gs-utl-ring-opacity-80"
}, Ee = {
  s3x: "13px",
  s2x: "14px",
  sx: "16px",
  s: "18px",
  m: "20px",
  l: "22px"
}, nt = {
  click: "gs-utl-cursor-pointer gs-utl-transition-opacity gs-utl-opacity-75 hover:gs-utl-opacity-100",
  hover: "gs-utl-transition-opacity gs-utl-opacity-50 hover:gs-utl-opacity-100",
  hoverGroup: "group-hover:gs-utl-opacity-100 gs-utl-opacity-0 gs-utl-transition-opacity",
  dot: "gs-utl-w-[6px] gs-utl-h-[6px] gs-utl-rounded-full",
  scrollX: "gs-utl-overflow-x-auto gs-utl-overflow-y-hidden",
  scrollY: "gs-utl-overflow-y-auto gs-utl-overflow-x-hidden",
  txtEllips: "gs-utl-text-ellipsis gs-utl-overflow-hidden gs-utl-whitespace-nowrap",
  coverAbs: "gs-utl-absolute gs-utl-top-0 gs-utl-left-0 gs-utl-w-full gs-utl-h-full",
  hiddenVisually: "gs-utl-w-[1px] gs-utl-h-[1px] gs-utl-opacity-[0.001]",
  disabled: "gs-utl-opacity-50 gs-utl-pointer-events-none",
  disabledM: "gs-utl-opacity-50 gs-utl-cursor-not-allowed",
  noFocusOut: "focus:gs-utl-outline-none",
  spin: "gs-utl-animate-spin-fast"
}, wl = {
  link: ce(ee.tAo),
  inputText: "gs-theme-elStyles-inputText focus:gs-utl-outline-none gs-utl-placeholder:text-neutral-400 placeholder:dark:gs-utl-text-neutral-500"
}, Vv = {
  itemList: ({ index: e = 0, open: t = !1, length: n = 0 } = {}) => ce(ee.bgH2, tt.xyS, ee.br, e && ve.bt, (t || e === n - 1) && ve.bb)
}, hC = (e) => ({
  bg: e ? "#18181b" : "#f9f9f9",
  text: e ? "#9ca3af" : "#111827",
  link: e ? "#a78bfa" : "#5b21b6"
}), Ml = (e) => {
  let t = {
    isSymbol: !1,
    bg: ee.cmp,
    bgSoft: `${ee.cmpBgSoft} ${ee.cmpTxtActive}`,
    bgSoftX: ee.cmpBgSoftX,
    border: ee.cmpBr,
    txt: ""
  };
  if (!(e != null && e.em))
    return t;
  const { isSymbol: n } = e.em.Components.getSymbolInfo(e);
  return n && (t = {
    isSymbol: n,
    bg: ee.cmpSymbol,
    bgSoft: `${ee.cmpBgSymbolSoft} ${ee.cmpTxtActive}`,
    bgSoftX: ee.cmpBgSymbolSoftX,
    border: ee.cmpSymbolBr,
    txt: ""
  }), t;
}, mC = ({
  variant: e,
  size: t = "m",
  className: n,
  disabledClassName: r,
  active: o,
  border: i = !0,
  rounded: l = !0,
  disabled: c = !1,
  withBg: d,
  block: p,
  full: g
}) => {
  const m = e === "pr", v = e === "out", b = e === "out-clear", x = e === "warn", w = e === "danger", j = i && (v || b || !e);
  return [
    "gs-utl-transition-colors gs-utl-cursor-pointer",
    p && "gs-utl-block",
    t === "x2s" && "gs-utl-text-xs",
    t === "s" && "gs-utl-p-1 gs-utl-text-sm",
    t === "m" && "gs-utl-p-1 gs-utl-px-2",
    t === "m2" && "gs-utl-p-1 gs-utl-px-3",
    t === "lg" && "gs-utl-p-2 gs-utl-px-4 gs-utl-text-lg",
    n,
    l && ve.rnd,
    j && `${ve.b} ${ee.br}`,
    d && ee.bg,
    // isDef && !disabled && !active && cl.hBgH,
    j && ce(ve.b, v && ee.bA, v && ee.tAo, !c && ee.hBgH),
    x && ce(ee.bgW, ee.hBgW, !c && ee.hBgW, "gs-utl-text-white"),
    w && ce(ee.bgRed, !c && ee.hBgRed, "gs-utl-text-white"),
    m && ce(ee.bgA2, !c && ee.hBgAct),
    o && ee.bgA,
    c && (r ?? "disabled:gs-utl-opacity-80 gs-utl-cursor-not-allowed"),
    g && "gs-utl-w-full",
    lu.focus
  ];
};
function ut({ children: e, ...t }) {
  const {
    variant: n,
    size: r,
    active: o,
    border: i,
    rounded: l,
    block: c,
    full: d,
    className: p,
    icon: g,
    loading: m,
    withBg: v,
    type: b = "button",
    disabledClassName: x,
    ...w
  } = t, j = m ? { icon: lL, size: "18px", className: ce("animate-spin-fast") } : Dt(g) ? { icon: g, size: "18px" } : g;
  return /* @__PURE__ */ u.jsx("button", { className: ce(mC(t)), disabled: t.disabled, type: b, ...w, children: j ? /* @__PURE__ */ u.jsxs(G, { className: ce("gap-2"), items: "center", justify: "center", nowrap: !0, children: [
    /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ye, { ...j }) }),
    e && /* @__PURE__ */ u.jsx(Y, { children: e })
  ] }) : e });
}
function qa(e, t, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var i, l, c, d;
    let p;
    n.key && ((i = n.debug) != null && i.call(n)) && (p = Date.now());
    const g = e();
    if (!(g.length !== r.length || g.some((b, x) => r[x] !== b)))
      return o;
    r = g;
    let v;
    if (n.key && ((l = n.debug) != null && l.call(n)) && (v = Date.now()), o = t(...g), n.key && ((c = n.debug) != null && c.call(n))) {
      const b = Math.round((Date.now() - p) * 100) / 100, x = Math.round((Date.now() - v) * 100) / 100, w = x / 16, j = (C, E) => {
        for (C = String(C); C.length < E; )
          C = " " + C;
        return C;
      };
      console.info(
        `%c⏱ ${j(x, 5)} /${j(b, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * w, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (d = n == null ? void 0 : n.onChange) == null || d.call(n, o), o;
  };
}
function mm(e, t) {
  if (e === void 0)
    throw new Error(`Unexpected undefined${t ? `: ${t}` : ""}`);
  return e;
}
const KL = (e, t) => Math.abs(e - t) < 1, qL = (e, t, n) => {
  let r;
  return function(...o) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, o), n);
  };
}, YL = (e) => e, XL = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let o = t; o <= n; o++)
    r.push(o);
  return r;
}, ZL = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const o = (l) => {
    const { width: c, height: d } = l;
    t({ width: Math.round(c), height: Math.round(d) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((l) => {
    const c = l[0];
    if (c != null && c.borderBoxSize) {
      const d = c.borderBoxSize[0];
      if (d) {
        o({ width: d.inlineSize, height: d.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, bw = {
  passive: !0
}, JL = typeof window > "u" ? !0 : "onscrollend" in window, QL = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = JL ? () => {
  } : qL(
    r,
    () => {
      t(o, !1);
    },
    e.options.isScrollingResetDelay
  ), l = (p) => () => {
    const { horizontal: g, isRtl: m } = e.options;
    o = g ? n.scrollLeft * (m && -1 || 1) : n.scrollTop, i(), t(o, p);
  }, c = l(!0), d = l(!1);
  return d(), n.addEventListener("scroll", c, bw), n.addEventListener("scrollend", d, bw), () => {
    n.removeEventListener("scroll", c), n.removeEventListener("scrollend", d);
  };
}, eM = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, tM = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var o, i;
  const l = e + t;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: l,
    behavior: n
  });
};
class nM {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var o;
          (o = r()) == null || o.disconnect(), n = null;
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: YL,
        rangeExtractor: XL,
        onChange: () => {
        },
        measureElement: eM,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, o;
      (o = (r = this.options).onChange) == null || o.call(r, this, n);
    }, this.maybeNotify = qa(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: !1,
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((o) => {
          this.observer.observe(o);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let l = r - 1; l >= 0; l--) {
        const c = n[l];
        if (o.has(c.lane))
          continue;
        const d = i.get(
          c.lane
        );
        if (d == null || c.end > d.end ? i.set(c.lane, c) : c.end < d.end && o.set(c.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((l, c) => l.end === c.end ? l.index - c.index : l.end - c.end)[0] : void 0;
    }, this.getMeasurementOptions = qa(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, l) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: l
      }),
      {
        key: !1
      }
    ), this.getMeasurements = qa(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: l }, c) => {
        if (!l)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((g) => {
          this.itemSizeCache.set(g.key, g.size);
        }));
        const d = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const p = this.measurementsCache.slice(0, d);
        for (let g = d; g < n; g++) {
          const m = i(g), v = this.options.lanes === 1 ? p[g - 1] : this.getFurthestMeasurement(p, g), b = v ? v.end + this.options.gap : r + o, x = c.get(m), w = typeof x == "number" ? x : this.options.estimateSize(g), j = b + w, C = v ? v.lane : g % this.options.lanes;
          p[g] = {
            index: g,
            start: b,
            size: w,
            end: j,
            key: m,
            lane: C
          };
        }
        return this.measurementsCache = p, p;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.calculateRange = qa(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? rM({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getIndexes = qa(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, i) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: i
      }),
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.measurementsCache[o];
      if (!i)
        return;
      const l = i.key, c = this.elementsCache.get(l);
      c !== n && (c && this.observer.unobserve(c), this.observer.observe(n), this.elementsCache.set(l, n)), n.isConnected && this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, l = r - i;
      l !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, l, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += l,
        behavior: void 0
      }), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, o) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(o));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = qa(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, l = n.length; i < l; i++) {
          const c = n[i], d = r[c];
          o.push(d);
        }
        return o;
      },
      {
        key: !1,
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return mm(
          r[vC(
            0,
            r.length - 1,
            (o) => mm(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), i = this.getScrollOffset();
      r === "auto" && (n <= i ? r = "start" : n >= i + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const l = this.options.horizontal ? "scrollWidth" : "scrollHeight", d = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[l] : this.scrollElement[l] : 0) - o;
      return Math.max(Math.min(d, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.measurementsCache[n];
      if (!o)
        return;
      const i = this.getSize(), l = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= l + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= l + this.options.scrollPaddingStart)
          r = "start";
        else
          return [l, r];
      const c = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(c, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i)
        return;
      const [l, c] = i;
      this._scrollToOffset(l, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [p] = mm(
            this.getOffsetForIndex(n, c)
          );
          KL(p, this.getScrollOffset()) || this.scrollToIndex(n, { align: c, behavior: o });
        } else
          this.scrollToIndex(n, { align: c, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((i) => i.end)
      ), Math.max(
        o - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const vC = (e, t, n, r) => {
  for (; e <= t; ) {
    const o = (e + t) / 2 | 0, i = n(o);
    if (i < r)
      e = o + 1;
    else if (i > r)
      t = o - 1;
    else
      return o;
  }
  return e > 0 ? e - 1 : 0;
};
function rM({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, i = vC(0, r, (c) => e[c].start, n);
  let l = i;
  for (; l < r && e[l].end < n + t; )
    l++;
  return { startIndex: i, endIndex: l };
}
const oM = typeof document < "u" ? y.useLayoutEffect : y.useEffect;
function sM(e) {
  const t = y.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (o, i) => {
      var l;
      i ? Cr.flushSync(t) : t(), (l = e.onChange) == null || l.call(e, o, i);
    }
  }, [r] = y.useState(
    () => new nM(n)
  );
  return r.setOptions(n), y.useEffect(() => r._didMount(), []), oM(() => r._willUpdate()), r;
}
function iM(e) {
  return sM({
    observeElementRect: ZL,
    observeElementOffset: QL,
    scrollToFn: tM,
    ...e
  });
}
var aM = Object.defineProperty, lM = (e, t, n) => t in e ? aM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, vm = (e, t, n) => (lM(e, typeof t != "symbol" ? t + "" : t, n), n);
let cM = class {
  constructor() {
    vm(this, "current", this.detect()), vm(this, "handoffState", "pending"), vm(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, Ts = new cM(), lt = (e, t) => {
  Ts.isServer ? y.useEffect(e, t) : y.useLayoutEffect(e, t);
};
function mn(e) {
  let t = y.useRef(e);
  return lt(() => {
    t.current = e;
  }, [e]), t;
}
function Ru(e, t) {
  let [n, r] = y.useState(e), o = mn(e);
  return lt(() => r(o.current), [o, r, ...t]), n;
}
let he = function(e) {
  let t = mn(e);
  return Q.useCallback((...n) => t.current(...n), [t]);
};
function Ip(e, t, n) {
  let [r, o] = y.useState(n), i = e !== void 0, l = y.useRef(i), c = y.useRef(!1), d = y.useRef(!1);
  return i && !l.current && !c.current ? (c.current = !0, l.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && l.current && !d.current && (d.current = !0, l.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : r, he((p) => (i || o(p), t == null ? void 0 : t(p)))];
}
function Nu(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Qr() {
  let e = [], t = { addEventListener(n, r, o, i) {
    return n.addEventListener(r, o, i), t.add(() => n.removeEventListener(r, o, i));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return Nu(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, o) {
    let i = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: o }), this.add(() => {
      Object.assign(n.style, { [r]: i });
    });
  }, group(n) {
    let r = Qr();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0)
        for (let o of e.splice(r, 1))
          o();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function eo() {
  let [e] = y.useState(Qr);
  return y.useEffect(() => () => e.dispose(), [e]), e;
}
function uM() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in ru ? ((t) => t.useSyncExternalStore)(ru)(() => () => {
  }, () => !1, () => !e) : !1;
}
function Al() {
  let e = uM(), [t, n] = y.useState(Ts.isHandoffComplete);
  return t && Ts.isHandoffComplete === !1 && n(!1), y.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), y.useEffect(() => Ts.handoff(), []), e ? !1 : t;
}
var xw;
let Tt = (xw = Q.useId) != null ? xw : function() {
  let e = Al(), [t, n] = Q.useState(e ? () => Ts.nextId() : null);
  return lt(() => {
    t === null && n(Ts.nextId());
  }, [t]), t != null ? "" + t : void 0;
};
function Ke(e, t, ...n) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, Ke), r;
}
function ki(e) {
  return Ts.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let N1 = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var kt = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(kt || {}), vo = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(vo || {}), dM = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(dM || {});
function Vp(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(N1)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Hp = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Hp || {});
function Hv(e, t = 0) {
  var n;
  return e === ((n = ki(e)) == null ? void 0 : n.body) ? !1 : Ke(t, { 0() {
    return e.matches(N1);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(N1))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var fM = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(fM || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function na(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let pM = ["textarea", "input"].join(",");
function gM(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, pM)) != null ? n : !1;
}
function Cs(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let o = t(n), i = t(r);
    if (o === null || i === null)
      return 0;
    let l = o.compareDocumentPosition(i);
    return l & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : l & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function hn(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: o = [] } = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, l = Array.isArray(e) ? n ? Cs(e) : e : Vp(e);
  o.length > 0 && l.length > 1 && (l = l.filter((b) => !o.includes(b))), r = r ?? i.activeElement;
  let c = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, l.indexOf(r)) - 1;
    if (t & 4)
      return Math.max(0, l.indexOf(r)) + 1;
    if (t & 8)
      return l.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), p = t & 32 ? { preventScroll: !0 } : {}, g = 0, m = l.length, v;
  do {
    if (g >= m || g + m <= 0)
      return 0;
    let b = d + g;
    if (t & 16)
      b = (b + m) % m;
    else {
      if (b < 0)
        return 3;
      if (b >= m)
        return 1;
    }
    v = l[b], v == null || v.focus(p), g += c;
  } while (v !== i.activeElement);
  return t & 6 && gM(v) && v.select(), 2;
}
function yC() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function hM() {
  return /Android/gi.test(window.navigator.userAgent);
}
function bC() {
  return yC() || hM();
}
function pf(e, t, n) {
  let r = mn(t);
  y.useEffect(() => {
    function o(i) {
      r.current(i);
    }
    return document.addEventListener(e, o, n), () => document.removeEventListener(e, o, n);
  }, [e, n]);
}
function xC(e, t, n) {
  let r = mn(t);
  y.useEffect(() => {
    function o(i) {
      r.current(i);
    }
    return window.addEventListener(e, o, n), () => window.removeEventListener(e, o, n);
  }, [e, n]);
}
function Fp(e, t, n = !0) {
  let r = y.useRef(!1);
  y.useEffect(() => {
    requestAnimationFrame(() => {
      r.current = n;
    });
  }, [n]);
  function o(l, c) {
    if (!r.current || l.defaultPrevented)
      return;
    let d = c(l);
    if (d === null || !d.getRootNode().contains(d) || !d.isConnected)
      return;
    let p = function g(m) {
      return typeof m == "function" ? g(m()) : Array.isArray(m) || m instanceof Set ? m : [m];
    }(e);
    for (let g of p) {
      if (g === null)
        continue;
      let m = g instanceof HTMLElement ? g : g.current;
      if (m != null && m.contains(d) || l.composed && l.composedPath().includes(m))
        return;
    }
    return !Hv(d, Hp.Loose) && d.tabIndex !== -1 && l.preventDefault(), t(l, d);
  }
  let i = y.useRef(null);
  pf("pointerdown", (l) => {
    var c, d;
    r.current && (i.current = ((d = (c = l.composedPath) == null ? void 0 : c.call(l)) == null ? void 0 : d[0]) || l.target);
  }, !0), pf("mousedown", (l) => {
    var c, d;
    r.current && (i.current = ((d = (c = l.composedPath) == null ? void 0 : c.call(l)) == null ? void 0 : d[0]) || l.target);
  }, !0), pf("click", (l) => {
    bC() || i.current && (o(l, () => i.current), i.current = null);
  }, !0), pf("touchend", (l) => o(l, () => l.target instanceof HTMLElement ? l.target : null), !0), xC("blur", (l) => o(l, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function $s(...e) {
  return y.useMemo(() => ki(...e), [...e]);
}
function ww(e) {
  var t;
  if (e.type)
    return e.type;
  let n = (t = e.as) != null ? t : "button";
  if (typeof n == "string" && n.toLowerCase() === "button")
    return "button";
}
function Rl(e, t) {
  let [n, r] = y.useState(() => ww(e));
  return lt(() => {
    r(ww(e));
  }, [e.type, e.as]), lt(() => {
    n || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [n, t]), n;
}
let wC = Symbol();
function Fv(e, t = !0) {
  return Object.assign(e, { [wC]: t });
}
function rt(...e) {
  let t = y.useRef(e);
  y.useEffect(() => {
    t.current = e;
  }, [e]);
  let n = he((r) => {
    for (let o of t.current)
      o != null && (typeof o == "function" ? o(r) : o.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[wC])) ? void 0 : n;
}
function Sw(e) {
  return [e.screenX, e.screenY];
}
function SC() {
  let e = y.useRef([-1, -1]);
  return { wasMoved(t) {
    let n = Sw(t);
    return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
  }, update(t) {
    e.current = Sw(t);
  } };
}
function jC({ container: e, accept: t, walk: n, enabled: r = !0 }) {
  let o = y.useRef(t), i = y.useRef(n);
  y.useEffect(() => {
    o.current = t, i.current = n;
  }, [t, n]), lt(() => {
    if (!e || !r)
      return;
    let l = ki(e);
    if (!l)
      return;
    let c = o.current, d = i.current, p = Object.assign((m) => c(m), { acceptNode: c }), g = l.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, p, !1);
    for (; g.nextNode(); )
      d(g.currentNode);
  }, [e, r, o, i]);
}
function cu(e, t) {
  let n = y.useRef([]), r = he(e);
  y.useEffect(() => {
    let o = [...n.current];
    for (let [i, l] of t.entries())
      if (n.current[i] !== l) {
        let c = r(t, o);
        return n.current = t, c;
      }
  }, [r, ...t]);
}
function up(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
var zn = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(zn || {}), mi = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(mi || {});
function Je({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: o, visible: i = !0, name: l, mergeRefs: c }) {
  c = c ?? mM;
  let d = CC(t, e);
  if (i)
    return gf(d, n, r, l, c);
  let p = o ?? 0;
  if (p & 2) {
    let { static: g = !1, ...m } = d;
    if (g)
      return gf(m, n, r, l, c);
  }
  if (p & 1) {
    let { unmount: g = !0, ...m } = d;
    return Ke(g ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return gf({ ...m, hidden: !0, style: { display: "none" } }, n, r, l, c);
    } });
  }
  return gf(d, n, r, l, c);
}
function gf(e, t = {}, n, r, o) {
  let { as: i = n, children: l, refName: c = "ref", ...d } = ym(e, ["unmount", "static"]), p = e.ref !== void 0 ? { [c]: e.ref } : {}, g = typeof l == "function" ? l(t) : l;
  "className" in d && d.className && typeof d.className == "function" && (d.className = d.className(t));
  let m = {};
  if (t) {
    let v = !1, b = [];
    for (let [x, w] of Object.entries(t))
      typeof w == "boolean" && (v = !0), w === !0 && b.push(x);
    v && (m["data-headlessui-state"] = b.join(" "));
  }
  if (i === y.Fragment && Object.keys(Sl(d)).length > 0) {
    if (!y.isValidElement(g) || Array.isArray(g) && g.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(d).map((w) => `  - ${w}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((w) => `  - ${w}`).join(`
`)].join(`
`));
    let v = g.props, b = typeof (v == null ? void 0 : v.className) == "function" ? (...w) => up(v == null ? void 0 : v.className(...w), d.className) : up(v == null ? void 0 : v.className, d.className), x = b ? { className: b } : {};
    return y.cloneElement(g, Object.assign({}, CC(g.props, Sl(ym(d, ["ref"]))), m, p, { ref: o(g.ref, p.ref) }, x));
  }
  return y.createElement(i, Object.assign({}, ym(d, ["ref"]), i !== y.Fragment && p, i !== y.Fragment && m), g);
}
function zv() {
  let e = y.useRef([]), t = y.useCallback((n) => {
    for (let r of e.current)
      r != null && (typeof r == "function" ? r(n) : r.current = n);
  }, []);
  return (...n) => {
    if (!n.every((r) => r == null))
      return e.current = n, t;
  };
}
function mM(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e)
      n != null && (typeof n == "function" ? n(t) : n.current = t);
  };
}
function CC(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let o in r)
      o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n)
    Object.assign(t, { [r](o, ...i) {
      let l = n[r];
      for (let c of l) {
        if ((o instanceof Event || (o == null ? void 0 : o.nativeEvent) instanceof Event) && o.defaultPrevented)
          return;
        c(o, ...i);
      }
    } });
  return t;
}
function Qe(e) {
  var t;
  return Object.assign(y.forwardRef(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function Sl(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function ym(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t)
    r in n && delete n[r];
  return n;
}
let vM = "div";
var Tr = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Tr || {});
function yM(e, t) {
  var n;
  let { features: r = 1, ...o } = e, i = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : (n = o["aria-hidden"]) != null ? n : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return Je({ ourProps: i, theirProps: o, slot: {}, defaultTag: vM, name: "Hidden" });
}
let Or = Qe(yM), Bv = y.createContext(null);
Bv.displayName = "OpenClosedContext";
var wt = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(wt || {});
function Ti() {
  return y.useContext(Bv);
}
function $u({ value: e, children: t }) {
  return Q.createElement(Bv.Provider, { value: e }, t);
}
function bM(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let zo = [];
bM(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && zo[0] !== t.target && (zo.unshift(t.target), zo = zo.filter((n) => n != null && n.isConnected), zo.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function Ls(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && xM(n) ? !1 : r;
}
function xM(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
function wM(e) {
  throw new Error("Unexpected object: " + e);
}
var bt = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(bt || {});
function $1(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let r = t.resolveActiveIndex(), o = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < n.length; ++i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return r;
    }
    case 1: {
      for (let i = o - 1; i >= 0; --i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return r;
    }
    case 2: {
      for (let i = o + 1; i < n.length; ++i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return r;
    }
    case 3: {
      for (let i = n.length - 1; i >= 0; --i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return r;
    }
    case 4: {
      for (let i = 0; i < n.length; ++i)
        if (t.resolveId(n[i], i, n) === e.id)
          return i;
      return r;
    }
    case 5:
      return null;
    default:
      wM(e);
  }
}
function zp(e = {}, t = null, n = []) {
  for (let [r, o] of Object.entries(e))
    PC(n, EC(t, r), o);
  return n;
}
function EC(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function PC(e, t, n) {
  if (Array.isArray(n))
    for (let [r, o] of n.entries())
      PC(e, EC(t, r.toString()), o);
  else
    n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : zp(n, t, e);
}
function _C(e) {
  var t, n;
  let r = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (r) {
    for (let o of r.elements)
      if (o !== e && (o.tagName === "INPUT" && o.type === "submit" || o.tagName === "BUTTON" && o.type === "submit" || o.nodeName === "INPUT" && o.type === "image")) {
        o.click();
        return;
      }
    (n = r.requestSubmit) == null || n.call(r);
  }
}
var De = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(De || {}), SM = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(SM || {}), jM = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(jM || {}), CM = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(CM || {}), EM = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualOptions = 7] = "UpdateVirtualOptions", e))(EM || {});
function bm(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = t(e.options.slice()), o = r.length > 0 && r[0].dataRef.current.order !== null ? r.sort((l, c) => l.dataRef.current.order - c.dataRef.current.order) : Cs(r, (l) => l.dataRef.current.domRef.current), i = n ? o.indexOf(n) : null;
  return i === -1 && (i = null), { options: o, activeOptionIndex: i };
}
let PM = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1 };
}, 0(e) {
  var t, n;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0)
    return e;
  if ((n = e.dataRef.current) != null && n.value) {
    let r = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (r !== -1)
      return { ...e, activeOptionIndex: r, comboboxState: 0 };
  }
  return { ...e, comboboxState: 0 };
}, 2(e, t) {
  var n, r, o, i, l;
  if ((n = e.dataRef.current) != null && n.disabled || (r = e.dataRef.current) != null && r.optionsRef.current && !((o = e.dataRef.current) != null && o.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  if (e.virtual) {
    let g = t.focus === bt.Specific ? t.idx : $1(t, { resolveItems: () => e.virtual.options, resolveActiveIndex: () => {
      var v, b;
      return (b = (v = e.activeOptionIndex) != null ? v : e.virtual.options.findIndex((x) => !e.virtual.disabled(x))) != null ? b : null;
    }, resolveDisabled: e.virtual.disabled, resolveId() {
      throw new Error("Function not implemented.");
    } }), m = (i = t.trigger) != null ? i : 2;
    return e.activeOptionIndex === g && e.activationTrigger === m ? e : { ...e, activeOptionIndex: g, activationTrigger: m };
  }
  let c = bm(e);
  if (c.activeOptionIndex === null) {
    let g = c.options.findIndex((m) => !m.dataRef.current.disabled);
    g !== -1 && (c.activeOptionIndex = g);
  }
  let d = t.focus === bt.Specific ? t.idx : $1(t, { resolveItems: () => c.options, resolveActiveIndex: () => c.activeOptionIndex, resolveId: (g) => g.id, resolveDisabled: (g) => g.dataRef.current.disabled }), p = (l = t.trigger) != null ? l : 2;
  return e.activeOptionIndex === d && e.activationTrigger === p ? e : { ...e, ...c, activeOptionIndex: d, activationTrigger: p };
}, 3: (e, t) => {
  var n, r, o;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: [...e.options, t.payload] };
  let i = t.payload, l = bm(e, (d) => (d.push(i), d));
  e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.payload.dataRef.current.value) && (l.activeOptionIndex = l.options.indexOf(i));
  let c = { ...e, ...l, activationTrigger: 2 };
  return (o = e.dataRef.current) != null && o.__demoMode && e.dataRef.current.value === void 0 && (c.activeOptionIndex = 0), c;
}, 4: (e, t) => {
  var n;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: e.options.filter((o) => o.id !== t.id) };
  let r = bm(e, (o) => {
    let i = o.findIndex((l) => l.id === t.id);
    return i !== -1 && o.splice(i, 1), o;
  });
  return { ...e, ...r, activationTrigger: 2 };
}, 5: (e, t) => e.labelId === t.id ? e : { ...e, labelId: t.id }, 6: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 7: (e, t) => {
  var n;
  if (((n = e.virtual) == null ? void 0 : n.options) === t.options)
    return e;
  let r = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let o = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    o !== -1 ? r = o : r = null;
  }
  return { ...e, activeOptionIndex: r, virtual: Object.assign({}, e.virtual, { options: t.options }) };
} }, Uv = y.createContext(null);
Uv.displayName = "ComboboxActionsContext";
function Du(e) {
  let t = y.useContext(Uv);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Du), n;
  }
  return t;
}
let kC = y.createContext(null);
function _M(e) {
  var t;
  let n = ba("VirtualProvider"), [r, o] = y.useMemo(() => {
    let d = n.optionsRef.current;
    if (!d)
      return [0, 0];
    let p = window.getComputedStyle(d);
    return [parseFloat(p.paddingBlockStart || p.paddingTop), parseFloat(p.paddingBlockEnd || p.paddingBottom)];
  }, [n.optionsRef.current]), i = iM({ scrollPaddingStart: r, scrollPaddingEnd: o, count: n.virtual.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    var d;
    return (d = n.optionsRef.current) != null ? d : null;
  }, overscan: 12 }), [l, c] = y.useState(0);
  return lt(() => {
    c((d) => d + 1);
  }, [(t = n.virtual) == null ? void 0 : t.options]), Q.createElement(kC.Provider, { value: i }, Q.createElement("div", { style: { position: "relative", width: "100%", height: `${i.getTotalSize()}px` }, ref: (d) => {
    if (d) {
      if (typeof process < "u" && { NODE_ENV: "production", NPM_PACKAGE_VERSION: "1.0.0", STUDIO_NPM_PACKAGE_VERSION: "1.0.56" }.JEST_WORKER_ID !== void 0 || n.activationTrigger === 0)
        return;
      n.activeOptionIndex !== null && n.virtual.options.length > n.activeOptionIndex && i.scrollToIndex(n.activeOptionIndex);
    }
  } }, i.getVirtualItems().map((d) => {
    var p;
    return Q.createElement(y.Fragment, { key: d.key }, Q.cloneElement((p = e.children) == null ? void 0 : p.call(e, { option: n.virtual.options[d.index], open: n.comboboxState === 0 }), { key: `${l}-${d.key}`, "data-index": d.index, "aria-setsize": n.virtual.options.length, "aria-posinset": d.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${d.start}px)`, overflowAnchor: "none" } }));
  })));
}
let Wv = y.createContext(null);
Wv.displayName = "ComboboxDataContext";
function ba(e) {
  let t = y.useContext(Wv);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ba), n;
  }
  return t;
}
function kM(e, t) {
  return Ke(t.type, PM, e, t);
}
let TM = y.Fragment;
function OM(e, t) {
  let { value: n, defaultValue: r, onChange: o, form: i, name: l, by: c = null, disabled: d = !1, __demoMode: p = !1, nullable: g = !1, multiple: m = !1, immediate: v = !1, virtual: b = null, ...x } = e, w = !1, j = null, [C = m ? [] : void 0, E] = Ip(n, o, r), [P, k] = y.useReducer(kM, { dataRef: y.createRef(), comboboxState: p ? 0 : 1, options: [], virtual: null, activeOptionIndex: null, activationTrigger: 2, labelId: null }), T = y.useRef(!1), O = y.useRef({ static: !1, hold: !1 }), A = y.useRef(null), $ = y.useRef(null), N = y.useRef(null), R = y.useRef(null), z = he(typeof c == "string" ? (de, we) => {
    let je = c;
    return (de == null ? void 0 : de[je]) === (we == null ? void 0 : we[je]);
  } : c ?? ((de, we) => de === we)), D = he((de) => P.options.findIndex((we) => z(we.dataRef.current.value, de))), Z = y.useCallback((de) => Ke(H.mode, { 1: () => C.some((we) => z(we, de)), 0: () => z(C, de) }), [C]), K = he((de) => P.activeOptionIndex === D(de)), H = y.useMemo(() => ({ ...P, immediate: w, optionsPropsRef: O, labelRef: A, inputRef: $, buttonRef: N, optionsRef: R, value: C, defaultValue: r, disabled: d, mode: m ? 1 : 0, virtual: P.virtual, get activeOptionIndex() {
    if (T.current && P.activeOptionIndex === null && P.options.length > 0) {
      let de = P.options.findIndex((we) => !we.dataRef.current.disabled);
      if (de !== -1)
        return de;
    }
    return P.activeOptionIndex;
  }, calculateIndex: D, compare: z, isSelected: Z, isActive: K, nullable: g, __demoMode: p }), [C, r, d, m, g, p, P, j]);
  lt(() => {
  }, [j, void 0]), lt(() => {
    P.dataRef.current = H;
  }, [H]), Fp([H.buttonRef, H.inputRef, H.optionsRef], () => le.closeCombobox(), H.comboboxState === 0);
  let q = y.useMemo(() => {
    var de, we, je;
    return { open: H.comboboxState === 0, disabled: d, activeIndex: H.activeOptionIndex, activeOption: H.activeOptionIndex === null ? null : H.virtual ? H.virtual.options[(de = H.activeOptionIndex) != null ? de : 0] : (je = (we = H.options[H.activeOptionIndex]) == null ? void 0 : we.dataRef.current.value) != null ? je : null, value: C };
  }, [H, d, C]), te = he(() => {
    if (H.activeOptionIndex !== null) {
      if (H.virtual)
        ie(H.virtual.options[H.activeOptionIndex]);
      else {
        let { dataRef: de } = H.options[H.activeOptionIndex];
        ie(de.current.value);
      }
      le.goToOption(bt.Specific, H.activeOptionIndex);
    }
  }), I = he(() => {
    k({ type: 0 }), T.current = !0;
  }), F = he(() => {
    k({ type: 1 }), T.current = !1;
  }), V = he((de, we, je) => (T.current = !1, de === bt.Specific ? k({ type: 2, focus: bt.Specific, idx: we, trigger: je }) : k({ type: 2, focus: de, trigger: je }))), L = he((de, we) => (k({ type: 3, payload: { id: de, dataRef: we } }), () => {
    H.isActive(we.current.value) && (T.current = !0), k({ type: 4, id: de });
  })), W = he((de) => (k({ type: 5, id: de }), () => k({ type: 5, id: null }))), ie = he((de) => Ke(H.mode, { 0() {
    return E == null ? void 0 : E(de);
  }, 1() {
    let we = H.value.slice(), je = we.findIndex((He) => z(He, de));
    return je === -1 ? we.push(de) : we.splice(je, 1), E == null ? void 0 : E(we);
  } })), re = he((de) => {
    k({ type: 6, trigger: de });
  }), le = y.useMemo(() => ({ onChange: ie, registerOption: L, registerLabel: W, goToOption: V, closeCombobox: F, openCombobox: I, setActivationTrigger: re, selectActiveOption: te }), []), me = t === null ? {} : { ref: t }, oe = y.useRef(null), se = eo();
  return y.useEffect(() => {
    oe.current && r !== void 0 && se.addEventListener(oe.current, "reset", () => {
      E == null || E(r);
    });
  }, [oe, E]), Q.createElement(Uv.Provider, { value: le }, Q.createElement(Wv.Provider, { value: H }, Q.createElement($u, { value: Ke(H.comboboxState, { 0: wt.Open, 1: wt.Closed }) }, l != null && C != null && zp({ [l]: C }).map(([de, we], je) => Q.createElement(Or, { features: Tr.Hidden, ref: je === 0 ? (He) => {
    var Le;
    oe.current = (Le = He == null ? void 0 : He.closest("form")) != null ? Le : null;
  } : void 0, ...Sl({ key: de, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: i, disabled: d, name: de, value: we }) })), Je({ ourProps: me, theirProps: x, slot: q, defaultTag: TM, name: "Combobox" }))));
}
let LM = "input";
function MM(e, t) {
  var n, r, o, i, l;
  let c = Tt(), { id: d = `headlessui-combobox-input-${c}`, onChange: p, displayValue: g, type: m = "text", ...v } = e, b = ba("Combobox.Input"), x = Du("Combobox.Input"), w = rt(b.inputRef, t), j = $s(b.inputRef), C = y.useRef(!1), E = eo(), P = he(() => {
    x.onChange(null), b.optionsRef.current && (b.optionsRef.current.scrollTop = 0), x.goToOption(bt.Nothing);
  }), k = function() {
    var H;
    return typeof g == "function" && b.value !== void 0 ? (H = g(b.value)) != null ? H : "" : typeof b.value == "string" ? b.value : "";
  }();
  cu(([H, q], [te, I]) => {
    if (C.current)
      return;
    let F = b.inputRef.current;
    F && ((I === 0 && q === 1 || H !== te) && (F.value = H), requestAnimationFrame(() => {
      if (C.current || !F || (j == null ? void 0 : j.activeElement) !== F)
        return;
      let { selectionStart: V, selectionEnd: L } = F;
      Math.abs((L ?? 0) - (V ?? 0)) === 0 && V === 0 && F.setSelectionRange(F.value.length, F.value.length);
    }));
  }, [k, b.comboboxState, j]), cu(([H], [q]) => {
    if (H === 0 && q === 1) {
      if (C.current)
        return;
      let te = b.inputRef.current;
      if (!te)
        return;
      let I = te.value, { selectionStart: F, selectionEnd: V, selectionDirection: L } = te;
      te.value = "", te.value = I, L !== null ? te.setSelectionRange(F, V, L) : te.setSelectionRange(F, V);
    }
  }, [b.comboboxState]);
  let T = y.useRef(!1), O = he(() => {
    T.current = !0;
  }), A = he(() => {
    E.nextFrame(() => {
      T.current = !1;
    });
  }), $ = he((H) => {
    switch (C.current = !0, H.key) {
      case De.Enter:
        if (C.current = !1, b.comboboxState !== 0 || T.current)
          return;
        if (H.preventDefault(), H.stopPropagation(), b.activeOptionIndex === null) {
          x.closeCombobox();
          return;
        }
        x.selectActiveOption(), b.mode === 0 && x.closeCombobox();
        break;
      case De.ArrowDown:
        return C.current = !1, H.preventDefault(), H.stopPropagation(), Ke(b.comboboxState, { 0: () => x.goToOption(bt.Next), 1: () => x.openCombobox() });
      case De.ArrowUp:
        return C.current = !1, H.preventDefault(), H.stopPropagation(), Ke(b.comboboxState, { 0: () => x.goToOption(bt.Previous), 1: () => {
          x.openCombobox(), E.nextFrame(() => {
            b.value || x.goToOption(bt.Last);
          });
        } });
      case De.Home:
        if (H.shiftKey)
          break;
        return C.current = !1, H.preventDefault(), H.stopPropagation(), x.goToOption(bt.First);
      case De.PageUp:
        return C.current = !1, H.preventDefault(), H.stopPropagation(), x.goToOption(bt.First);
      case De.End:
        if (H.shiftKey)
          break;
        return C.current = !1, H.preventDefault(), H.stopPropagation(), x.goToOption(bt.Last);
      case De.PageDown:
        return C.current = !1, H.preventDefault(), H.stopPropagation(), x.goToOption(bt.Last);
      case De.Escape:
        return C.current = !1, b.comboboxState !== 0 ? void 0 : (H.preventDefault(), b.optionsRef.current && !b.optionsPropsRef.current.static && H.stopPropagation(), b.nullable && b.mode === 0 && b.value === null && P(), x.closeCombobox());
      case De.Tab:
        if (C.current = !1, b.comboboxState !== 0)
          return;
        b.mode === 0 && b.activationTrigger !== 1 && x.selectActiveOption(), x.closeCombobox();
        break;
    }
  }), N = he((H) => {
    p == null || p(H), b.nullable && b.mode === 0 && H.target.value === "" && P(), x.openCombobox();
  }), R = he((H) => {
    var q, te, I;
    let F = (q = H.relatedTarget) != null ? q : zo.find((V) => V !== H.currentTarget);
    if (C.current = !1, !((te = b.optionsRef.current) != null && te.contains(F)) && !((I = b.buttonRef.current) != null && I.contains(F)) && b.comboboxState === 0)
      return H.preventDefault(), b.mode === 0 && (b.nullable && b.value === null ? P() : b.activationTrigger !== 1 && x.selectActiveOption()), x.closeCombobox();
  }), z = he((H) => {
    var q, te, I;
    let F = (q = H.relatedTarget) != null ? q : zo.find((V) => V !== H.currentTarget);
    (te = b.buttonRef.current) != null && te.contains(F) || (I = b.optionsRef.current) != null && I.contains(F) || b.disabled || b.immediate && b.comboboxState !== 0 && (x.openCombobox(), E.nextFrame(() => {
      x.setActivationTrigger(1);
    }));
  }), D = Ru(() => {
    if (b.labelId)
      return [b.labelId].join(" ");
  }, [b.labelId]), Z = y.useMemo(() => ({ open: b.comboboxState === 0, disabled: b.disabled }), [b]), K = { ref: w, id: d, role: "combobox", type: m, "aria-controls": (n = b.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": b.comboboxState === 0, "aria-activedescendant": b.activeOptionIndex === null ? void 0 : b.virtual ? (r = b.options.find((H) => {
    var q;
    return !((q = b.virtual) != null && q.disabled(H.dataRef.current.value)) && b.compare(H.dataRef.current.value, b.virtual.options[b.activeOptionIndex]);
  })) == null ? void 0 : r.id : (o = b.options[b.activeOptionIndex]) == null ? void 0 : o.id, "aria-labelledby": D, "aria-autocomplete": "list", defaultValue: (l = (i = e.defaultValue) != null ? i : b.defaultValue !== void 0 ? g == null ? void 0 : g(b.defaultValue) : null) != null ? l : b.defaultValue, disabled: b.disabled, onCompositionStart: O, onCompositionEnd: A, onKeyDown: $, onChange: N, onFocus: z, onBlur: R };
  return Je({ ourProps: K, theirProps: v, slot: Z, defaultTag: LM, name: "Combobox.Input" });
}
let AM = "button";
function RM(e, t) {
  var n;
  let r = ba("Combobox.Button"), o = Du("Combobox.Button"), i = rt(r.buttonRef, t), l = Tt(), { id: c = `headlessui-combobox-button-${l}`, ...d } = e, p = eo(), g = he((w) => {
    switch (w.key) {
      case De.ArrowDown:
        return w.preventDefault(), w.stopPropagation(), r.comboboxState === 1 && o.openCombobox(), p.nextFrame(() => {
          var j;
          return (j = r.inputRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
        });
      case De.ArrowUp:
        return w.preventDefault(), w.stopPropagation(), r.comboboxState === 1 && (o.openCombobox(), p.nextFrame(() => {
          r.value || o.goToOption(bt.Last);
        })), p.nextFrame(() => {
          var j;
          return (j = r.inputRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
        });
      case De.Escape:
        return r.comboboxState !== 0 ? void 0 : (w.preventDefault(), r.optionsRef.current && !r.optionsPropsRef.current.static && w.stopPropagation(), o.closeCombobox(), p.nextFrame(() => {
          var j;
          return (j = r.inputRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
        }));
      default:
        return;
    }
  }), m = he((w) => {
    if (Ls(w.currentTarget))
      return w.preventDefault();
    r.comboboxState === 0 ? o.closeCombobox() : (w.preventDefault(), o.openCombobox()), p.nextFrame(() => {
      var j;
      return (j = r.inputRef.current) == null ? void 0 : j.focus({ preventScroll: !0 });
    });
  }), v = Ru(() => {
    if (r.labelId)
      return [r.labelId, c].join(" ");
  }, [r.labelId, c]), b = y.useMemo(() => ({ open: r.comboboxState === 0, disabled: r.disabled, value: r.value }), [r]), x = { ref: i, id: c, type: Rl(e, r.buttonRef), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (n = r.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": r.comboboxState === 0, "aria-labelledby": v, disabled: r.disabled, onClick: m, onKeyDown: g };
  return Je({ ourProps: x, theirProps: d, slot: b, defaultTag: AM, name: "Combobox.Button" });
}
let NM = "label";
function $M(e, t) {
  let n = Tt(), { id: r = `headlessui-combobox-label-${n}`, ...o } = e, i = ba("Combobox.Label"), l = Du("Combobox.Label"), c = rt(i.labelRef, t);
  lt(() => l.registerLabel(r), [r]);
  let d = he(() => {
    var g;
    return (g = i.inputRef.current) == null ? void 0 : g.focus({ preventScroll: !0 });
  }), p = y.useMemo(() => ({ open: i.comboboxState === 0, disabled: i.disabled }), [i]);
  return Je({ ourProps: { ref: c, id: r, onClick: d }, theirProps: o, slot: p, defaultTag: NM, name: "Combobox.Label" });
}
let DM = "ul", IM = zn.RenderStrategy | zn.Static;
function VM(e, t) {
  let n = Tt(), { id: r = `headlessui-combobox-options-${n}`, hold: o = !1, ...i } = e, l = ba("Combobox.Options"), c = rt(l.optionsRef, t), d = Ti(), p = (() => d !== null ? (d & wt.Open) === wt.Open : l.comboboxState === 0)();
  lt(() => {
    var b;
    l.optionsPropsRef.current.static = (b = e.static) != null ? b : !1;
  }, [l.optionsPropsRef, e.static]), lt(() => {
    l.optionsPropsRef.current.hold = o;
  }, [l.optionsPropsRef, o]), jC({ container: l.optionsRef.current, enabled: l.comboboxState === 0, accept(b) {
    return b.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : b.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(b) {
    b.setAttribute("role", "none");
  } });
  let g = Ru(() => {
    var b, x;
    return (x = l.labelId) != null ? x : (b = l.buttonRef.current) == null ? void 0 : b.id;
  }, [l.labelId, l.buttonRef.current]), m = y.useMemo(() => ({ open: l.comboboxState === 0, option: void 0 }), [l]), v = { "aria-labelledby": g, role: "listbox", "aria-multiselectable": l.mode === 1 ? !0 : void 0, id: r, ref: c };
  return l.virtual && l.comboboxState === 0 && Object.assign(i, { children: Q.createElement(_M, null, i.children) }), Je({ ourProps: v, theirProps: i, slot: m, defaultTag: DM, features: IM, visible: p, name: "Combobox.Options" });
}
let HM = "li";
function FM(e, t) {
  var n;
  let r = Tt(), { id: o = `headlessui-combobox-option-${r}`, disabled: i = !1, value: l, order: c = null, ...d } = e, p = ba("Combobox.Option"), g = Du("Combobox.Option"), m = p.virtual ? p.activeOptionIndex === p.calculateIndex(l) : p.activeOptionIndex === null ? !1 : ((n = p.options[p.activeOptionIndex]) == null ? void 0 : n.id) === o, v = p.isSelected(l), b = y.useRef(null), x = mn({ disabled: i, value: l, domRef: b, order: c }), w = y.useContext(kC), j = rt(t, b, w ? w.measureElement : null), C = he(() => g.onChange(l));
  lt(() => g.registerOption(o, x), [x, o]);
  let E = y.useRef(!(p.virtual || p.__demoMode));
  lt(() => {
    if (!p.virtual || !p.__demoMode)
      return;
    let R = Qr();
    return R.requestAnimationFrame(() => {
      E.current = !0;
    }), R.dispose;
  }, [p.virtual, p.__demoMode]), lt(() => {
    if (!E.current || p.comboboxState !== 0 || !m || p.activationTrigger === 0)
      return;
    let R = Qr();
    return R.requestAnimationFrame(() => {
      var z, D;
      (D = (z = b.current) == null ? void 0 : z.scrollIntoView) == null || D.call(z, { block: "nearest" });
    }), R.dispose;
  }, [b, m, p.comboboxState, p.activationTrigger, p.activeOptionIndex]);
  let P = he((R) => {
    var z;
    if (i || (z = p.virtual) != null && z.disabled(l))
      return R.preventDefault();
    C(), bC() || requestAnimationFrame(() => {
      var D;
      return (D = p.inputRef.current) == null ? void 0 : D.focus({ preventScroll: !0 });
    }), p.mode === 0 && requestAnimationFrame(() => g.closeCombobox());
  }), k = he(() => {
    var R;
    if (i || (R = p.virtual) != null && R.disabled(l))
      return g.goToOption(bt.Nothing);
    let z = p.calculateIndex(l);
    g.goToOption(bt.Specific, z);
  }), T = SC(), O = he((R) => T.update(R)), A = he((R) => {
    var z;
    if (!T.wasMoved(R) || i || (z = p.virtual) != null && z.disabled(l) || m)
      return;
    let D = p.calculateIndex(l);
    g.goToOption(bt.Specific, D, 0);
  }), $ = he((R) => {
    var z;
    T.wasMoved(R) && (i || (z = p.virtual) != null && z.disabled(l) || m && (p.optionsPropsRef.current.hold || g.goToOption(bt.Nothing)));
  }), N = y.useMemo(() => ({ active: m, selected: v, disabled: i }), [m, v, i]);
  return Je({ ourProps: { id: o, ref: j, role: "option", tabIndex: i === !0 ? void 0 : -1, "aria-disabled": i === !0 ? !0 : void 0, "aria-selected": v, disabled: void 0, onClick: P, onFocus: k, onPointerEnter: O, onMouseEnter: O, onPointerMove: A, onMouseMove: A, onPointerLeave: $, onMouseLeave: $ }, theirProps: d, slot: N, defaultTag: HM, name: "Combobox.Option" });
}
let zM = Qe(OM), BM = Qe(RM), UM = Qe(MM), WM = Qe($M), GM = Qe(VM), KM = Qe(FM), Ya = Object.assign(zM, { Input: UM, Button: BM, Label: WM, Options: GM, Option: KM });
function Gv(e, t, n, r) {
  let o = mn(n);
  y.useEffect(() => {
    e = e ?? window;
    function i(l) {
      o.current(l);
    }
    return e.addEventListener(t, i, r), () => e.removeEventListener(t, i, r);
  }, [e, t, r]);
}
function Nl() {
  let e = y.useRef(!1);
  return lt(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function TC(e) {
  let t = he(e), n = y.useRef(!1);
  y.useEffect(() => (n.current = !1, () => {
    n.current = !0, Nu(() => {
      n.current && t();
    });
  }), [t]);
}
var Er = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Er || {});
function Kv() {
  let e = y.useRef(0);
  return xC("keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function OC(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.current)
    n.current instanceof HTMLElement && t.add(n.current);
  return t;
}
let qM = "div";
var LC = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(LC || {});
function YM(e, t) {
  let n = y.useRef(null), r = rt(n, t), { initialFocus: o, containers: i, features: l = 30, ...c } = e;
  Al() || (l = 1);
  let d = $s(n);
  JM({ ownerDocument: d }, !!(l & 16));
  let p = QM({ ownerDocument: d, container: n, initialFocus: o }, !!(l & 2));
  eA({ ownerDocument: d, container: n, containers: i, previousActiveElement: p }, !!(l & 8));
  let g = Kv(), m = he((w) => {
    let j = n.current;
    j && ((C) => C())(() => {
      Ke(g.current, { [Er.Forwards]: () => {
        hn(j, kt.First, { skipElements: [w.relatedTarget] });
      }, [Er.Backwards]: () => {
        hn(j, kt.Last, { skipElements: [w.relatedTarget] });
      } });
    });
  }), v = eo(), b = y.useRef(!1), x = { ref: r, onKeyDown(w) {
    w.key == "Tab" && (b.current = !0, v.requestAnimationFrame(() => {
      b.current = !1;
    }));
  }, onBlur(w) {
    let j = OC(i);
    n.current instanceof HTMLElement && j.add(n.current);
    let C = w.relatedTarget;
    C instanceof HTMLElement && C.dataset.headlessuiFocusGuard !== "true" && (MC(j, C) || (b.current ? hn(n.current, Ke(g.current, { [Er.Forwards]: () => kt.Next, [Er.Backwards]: () => kt.Previous }) | kt.WrapAround, { relativeTo: w.target }) : w.target instanceof HTMLElement && na(w.target)));
  } };
  return Q.createElement(Q.Fragment, null, !!(l & 4) && Q.createElement(Or, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: m, features: Tr.Focusable }), Je({ ourProps: x, theirProps: c, defaultTag: qM, name: "FocusTrap" }), !!(l & 4) && Q.createElement(Or, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: m, features: Tr.Focusable }));
}
let XM = Qe(YM), Pc = Object.assign(XM, { features: LC });
function ZM(e = !0) {
  let t = y.useRef(zo.slice());
  return cu(([n], [r]) => {
    r === !0 && n === !1 && Nu(() => {
      t.current.splice(0);
    }), r === !1 && n === !0 && (t.current = zo.slice());
  }, [e, zo, t]), he(() => {
    var n;
    return (n = t.current.find((r) => r != null && r.isConnected)) != null ? n : null;
  });
}
function JM({ ownerDocument: e }, t) {
  let n = ZM(t);
  cu(() => {
    t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && na(n());
  }, [t]), TC(() => {
    t && na(n());
  });
}
function QM({ ownerDocument: e, container: t, initialFocus: n }, r) {
  let o = y.useRef(null), i = Nl();
  return cu(() => {
    if (!r)
      return;
    let l = t.current;
    l && Nu(() => {
      if (!i.current)
        return;
      let c = e == null ? void 0 : e.activeElement;
      if (n != null && n.current) {
        if ((n == null ? void 0 : n.current) === c) {
          o.current = c;
          return;
        }
      } else if (l.contains(c)) {
        o.current = c;
        return;
      }
      n != null && n.current ? na(n.current) : hn(l, kt.First) === vo.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.current = e == null ? void 0 : e.activeElement;
    });
  }, [r]), o;
}
function eA({ ownerDocument: e, container: t, containers: n, previousActiveElement: r }, o) {
  let i = Nl();
  Gv(e == null ? void 0 : e.defaultView, "focus", (l) => {
    if (!o || !i.current)
      return;
    let c = OC(n);
    t.current instanceof HTMLElement && c.add(t.current);
    let d = r.current;
    if (!d)
      return;
    let p = l.target;
    p && p instanceof HTMLElement ? MC(c, p) ? (r.current = p, na(p)) : (l.preventDefault(), l.stopPropagation(), na(d)) : na(r.current);
  }, !0);
}
function MC(e, t) {
  for (let n of e)
    if (n.contains(t))
      return !0;
  return !1;
}
let AC = y.createContext(!1);
function tA() {
  return y.useContext(AC);
}
function D1(e) {
  return Q.createElement(AC.Provider, { value: e.force }, e.children);
}
function nA(e) {
  let t = tA(), n = y.useContext(RC), r = $s(e), [o, i] = y.useState(() => {
    if (!t && n !== null || Ts.isServer)
      return null;
    let l = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (l)
      return l;
    if (r === null)
      return null;
    let c = r.createElement("div");
    return c.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(c);
  });
  return y.useEffect(() => {
    o !== null && (r != null && r.body.contains(o) || r == null || r.body.appendChild(o));
  }, [o, r]), y.useEffect(() => {
    t || n !== null && i(n.current);
  }, [n, i, t]), o;
}
let rA = y.Fragment;
function oA(e, t) {
  let n = e, r = y.useRef(null), o = rt(Fv((g) => {
    r.current = g;
  }), t), i = $s(r), l = nA(r), [c] = y.useState(() => {
    var g;
    return Ts.isServer ? null : (g = i == null ? void 0 : i.createElement("div")) != null ? g : null;
  }), d = y.useContext(I1), p = Al();
  return lt(() => {
    !l || !c || l.contains(c) || (c.setAttribute("data-headlessui-portal", ""), l.appendChild(c));
  }, [l, c]), lt(() => {
    if (c && d)
      return d.register(c);
  }, [d, c]), TC(() => {
    var g;
    !l || !c || (c instanceof Node && l.contains(c) && l.removeChild(c), l.childNodes.length <= 0 && ((g = l.parentElement) == null || g.removeChild(l)));
  }), p ? !l || !c ? null : Cr.createPortal(Je({ ourProps: { ref: o }, theirProps: n, defaultTag: rA, name: "Portal" }), c) : null;
}
let sA = y.Fragment, RC = y.createContext(null);
function iA(e, t) {
  let { target: n, ...r } = e, o = { ref: rt(t) };
  return Q.createElement(RC.Provider, { value: n }, Je({ ourProps: o, theirProps: r, defaultTag: sA, name: "Popover.Group" }));
}
let I1 = y.createContext(null);
function NC() {
  let e = y.useContext(I1), t = y.useRef([]), n = he((i) => (t.current.push(i), e && e.register(i), () => r(i))), r = he((i) => {
    let l = t.current.indexOf(i);
    l !== -1 && t.current.splice(l, 1), e && e.unregister(i);
  }), o = y.useMemo(() => ({ register: n, unregister: r, portals: t }), [n, r, t]);
  return [t, y.useMemo(() => function({ children: i }) {
    return Q.createElement(I1.Provider, { value: o }, i);
  }, [o])];
}
let aA = Qe(oA), lA = Qe(iA), V1 = Object.assign(aA, { Group: lA });
function cA(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const uA = typeof Object.is == "function" ? Object.is : cA, { useState: dA, useEffect: fA, useLayoutEffect: pA, useDebugValue: gA } = ru;
function hA(e, t, n) {
  const r = t(), [{ inst: o }, i] = dA({ inst: { value: r, getSnapshot: t } });
  return pA(() => {
    o.value = r, o.getSnapshot = t, xm(o) && i({ inst: o });
  }, [e, r, t]), fA(() => (xm(o) && i({ inst: o }), e(() => {
    xm(o) && i({ inst: o });
  })), [e]), gA(r), r;
}
function xm(e) {
  const t = e.getSnapshot, n = e.value;
  try {
    const r = t();
    return !uA(n, r);
  } catch {
    return !0;
  }
}
function mA(e, t, n) {
  return t();
}
const vA = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", yA = !vA, bA = yA ? mA : hA, xA = "useSyncExternalStore" in ru ? ((e) => e.useSyncExternalStore)(ru) : bA;
function wA(e) {
  return xA(e.subscribe, e.getSnapshot, e.getSnapshot);
}
function SA(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(o) {
    return r.add(o), () => r.delete(o);
  }, dispatch(o, ...i) {
    let l = t[o].call(n, ...i);
    l && (n = l, r.forEach((c) => c()));
  } };
}
function jA() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement;
    e = ((n = t.defaultView) != null ? n : window).innerWidth - r.clientWidth;
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, o = r.clientWidth - r.offsetWidth, i = e - o;
    n.style(r, "paddingRight", `${i}px`);
  } };
}
function CA() {
  return yC() ? { before({ doc: e, d: t, meta: n }) {
    function r(o) {
      return n.containers.flatMap((i) => i()).some((i) => i.contains(o));
    }
    t.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let c = Qr();
        c.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => c.dispose()));
      }
      let i = (o = window.scrollY) != null ? o : window.pageYOffset, l = null;
      t.addEventListener(e, "click", (c) => {
        if (c.target instanceof HTMLElement)
          try {
            let d = c.target.closest("a");
            if (!d)
              return;
            let { hash: p } = new URL(d.href), g = e.querySelector(p);
            g && !r(g) && (l = g);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (c) => {
        if (c.target instanceof HTMLElement)
          if (r(c.target)) {
            let d = c.target;
            for (; d.parentElement && r(d.parentElement); )
              d = d.parentElement;
            t.style(d, "overscrollBehavior", "contain");
          } else
            t.style(c.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (c) => {
        if (c.target instanceof HTMLElement)
          if (r(c.target)) {
            let d = c.target;
            for (; d.parentElement && d.dataset.headlessuiPortal !== "" && !(d.scrollHeight > d.clientHeight || d.scrollWidth > d.clientWidth); )
              d = d.parentElement;
            d.dataset.headlessuiPortal === "" && c.preventDefault();
          } else
            c.preventDefault();
      }, { passive: !1 }), t.add(() => {
        var c;
        let d = (c = window.scrollY) != null ? c : window.pageYOffset;
        i !== d && window.scrollTo(0, i), l && l.isConnected && (l.scrollIntoView({ block: "nearest" }), l = null);
      });
    });
  } } : {};
}
function EA() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function PA(e) {
  let t = {};
  for (let n of e)
    Object.assign(t, n(t));
  return t;
}
let ea = SA(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: Qr(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: PA(n) }, o = [CA(), jA(), EA()];
  o.forEach(({ before: i }) => i == null ? void 0 : i(r)), o.forEach(({ after: i }) => i == null ? void 0 : i(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
ea.subscribe(() => {
  let e = ea.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e)
    t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", o = n.count !== 0;
    (o && !r || !o && r) && ea.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && ea.dispatch("TEARDOWN", n);
  }
});
function _A(e, t, n) {
  let r = wA(ea), o = e ? r.get(e) : void 0, i = o ? o.count > 0 : !1;
  return lt(() => {
    if (!(!e || !t))
      return ea.dispatch("PUSH", e, n), () => ea.dispatch("POP", e, n);
  }, [t, e]), i;
}
let wm = /* @__PURE__ */ new Map(), _c = /* @__PURE__ */ new Map();
function jw(e, t = !0) {
  lt(() => {
    var n;
    if (!t)
      return;
    let r = typeof e == "function" ? e() : e.current;
    if (!r)
      return;
    function o() {
      var l;
      if (!r)
        return;
      let c = (l = _c.get(r)) != null ? l : 1;
      if (c === 1 ? _c.delete(r) : _c.set(r, c - 1), c !== 1)
        return;
      let d = wm.get(r);
      d && (d["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", d["aria-hidden"]), r.inert = d.inert, wm.delete(r));
    }
    let i = (n = _c.get(r)) != null ? n : 0;
    return _c.set(r, i + 1), i !== 0 || (wm.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0), o;
  }, [e, t]);
}
function $C({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  var r;
  let o = y.useRef((r = n == null ? void 0 : n.current) != null ? r : null), i = $s(o), l = he(() => {
    var c, d, p;
    let g = [];
    for (let m of e)
      m !== null && (m instanceof HTMLElement ? g.push(m) : "current" in m && m.current instanceof HTMLElement && g.push(m.current));
    if (t != null && t.current)
      for (let m of t.current)
        g.push(m);
    for (let m of (c = i == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? c : [])
      m !== document.body && m !== document.head && m instanceof HTMLElement && m.id !== "headlessui-portal-root" && (m.contains(o.current) || m.contains((p = (d = o.current) == null ? void 0 : d.getRootNode()) == null ? void 0 : p.host) || g.some((v) => m.contains(v)) || g.push(m));
    return g;
  });
  return { resolveContainers: l, contains: he((c) => l().some((d) => d.contains(c))), mainTreeNodeRef: o, MainTreeNode: y.useMemo(() => function() {
    return n != null ? null : Q.createElement(Or, { features: Tr.Hidden, ref: o });
  }, [o, n]) };
}
function kA() {
  let e = y.useRef(null);
  return { mainTreeNodeRef: e, MainTreeNode: y.useMemo(() => function() {
    return Q.createElement(Or, { features: Tr.Hidden, ref: e });
  }, [e]) };
}
let qv = y.createContext(() => {
});
qv.displayName = "StackContext";
var H1 = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(H1 || {});
function TA() {
  return y.useContext(qv);
}
function OA({ children: e, onUpdate: t, type: n, element: r, enabled: o }) {
  let i = TA(), l = he((...c) => {
    t == null || t(...c), i(...c);
  });
  return lt(() => {
    let c = o === void 0 || o === !0;
    return c && l(0, n, r), () => {
      c && l(1, n, r);
    };
  }, [l, n, r, o]), Q.createElement(qv.Provider, { value: l }, e);
}
let DC = y.createContext(null);
function IC() {
  let e = y.useContext(DC);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, IC), t;
  }
  return e;
}
function Bp() {
  let [e, t] = y.useState([]);
  return [e.length > 0 ? e.join(" ") : void 0, y.useMemo(() => function(n) {
    let r = he((i) => (t((l) => [...l, i]), () => t((l) => {
      let c = l.slice(), d = c.indexOf(i);
      return d !== -1 && c.splice(d, 1), c;
    }))), o = y.useMemo(() => ({ register: r, slot: n.slot, name: n.name, props: n.props }), [r, n.slot, n.name, n.props]);
    return Q.createElement(DC.Provider, { value: o }, n.children);
  }, [t])];
}
let LA = "p";
function MA(e, t) {
  let n = Tt(), { id: r = `headlessui-description-${n}`, ...o } = e, i = IC(), l = rt(t);
  lt(() => i.register(r), [r, i.register]);
  let c = { ref: l, ...i.props, id: r };
  return Je({ ourProps: c, theirProps: o, slot: i.slot || {}, defaultTag: LA, name: i.name || "Description" });
}
let AA = Qe(MA), Yv = Object.assign(AA, {});
var RA = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(RA || {}), NA = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(NA || {});
let $A = { 0(e, t) {
  return e.titleId === t.id ? e : { ...e, titleId: t.id };
} }, dp = y.createContext(null);
dp.displayName = "DialogContext";
function Iu(e) {
  let t = y.useContext(dp);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Iu), n;
  }
  return t;
}
function DA(e, t, n = () => [document.body]) {
  _A(e, t, (r) => {
    var o;
    return { containers: [...(o = r.containers) != null ? o : [], n] };
  });
}
function IA(e, t) {
  return Ke(t.type, $A, e, t);
}
let VA = "div", HA = zn.RenderStrategy | zn.Static;
function FA(e, t) {
  let n = Tt(), { id: r = `headlessui-dialog-${n}`, open: o, onClose: i, initialFocus: l, role: c = "dialog", __demoMode: d = !1, ...p } = e, [g, m] = y.useState(0), v = y.useRef(!1);
  c = function() {
    return c === "dialog" || c === "alertdialog" ? c : (v.current || (v.current = !0, console.warn(`Invalid role [${c}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let b = Ti();
  o === void 0 && b !== null && (o = (b & wt.Open) === wt.Open);
  let x = y.useRef(null), w = rt(x, t), j = $s(x), C = e.hasOwnProperty("open") || b !== null, E = e.hasOwnProperty("onClose");
  if (!C && !E)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!C)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!E)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof o != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${o}`);
  if (typeof i != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${i}`);
  let P = o ? 0 : 1, [k, T] = y.useReducer(IA, { titleId: null, descriptionId: null, panelRef: y.createRef() }), O = he(() => i(!1)), A = he((je) => T({ type: 0, id: je })), $ = Al() ? d ? !1 : P === 0 : !1, N = g > 1, R = y.useContext(dp) !== null, [z, D] = NC(), Z = { get current() {
    var je;
    return (je = k.panelRef.current) != null ? je : x.current;
  } }, { resolveContainers: K, mainTreeNodeRef: H, MainTreeNode: q } = $C({ portals: z, defaultContainers: [Z] }), te = N ? "parent" : "leaf", I = b !== null ? (b & wt.Closing) === wt.Closing : !1, F = (() => R || I ? !1 : $)(), V = y.useCallback(() => {
    var je, He;
    return (He = Array.from((je = j == null ? void 0 : j.querySelectorAll("body > *")) != null ? je : []).find((Le) => Le.id === "headlessui-portal-root" ? !1 : Le.contains(H.current) && Le instanceof HTMLElement)) != null ? He : null;
  }, [H]);
  jw(V, F);
  let L = (() => N ? !0 : $)(), W = y.useCallback(() => {
    var je, He;
    return (He = Array.from((je = j == null ? void 0 : j.querySelectorAll("[data-headlessui-portal]")) != null ? je : []).find((Le) => Le.contains(H.current) && Le instanceof HTMLElement)) != null ? He : null;
  }, [H]);
  jw(W, L);
  let ie = (() => !(!$ || N))();
  Fp(K, (je) => {
    je.preventDefault(), O();
  }, ie);
  let re = (() => !(N || P !== 0))();
  Gv(j == null ? void 0 : j.defaultView, "keydown", (je) => {
    re && (je.defaultPrevented || je.key === De.Escape && (je.preventDefault(), je.stopPropagation(), O()));
  });
  let le = (() => !(I || P !== 0 || R))();
  DA(j, le, K), y.useEffect(() => {
    if (P !== 0 || !x.current)
      return;
    let je = new ResizeObserver((He) => {
      for (let Le of He) {
        let ot = Le.target.getBoundingClientRect();
        ot.x === 0 && ot.y === 0 && ot.width === 0 && ot.height === 0 && O();
      }
    });
    return je.observe(x.current), () => je.disconnect();
  }, [P, x, O]);
  let [me, oe] = Bp(), se = y.useMemo(() => [{ dialogState: P, close: O, setTitleId: A }, k], [P, k, O, A]), de = y.useMemo(() => ({ open: P === 0 }), [P]), we = { ref: w, id: r, role: c, "aria-modal": P === 0 ? !0 : void 0, "aria-labelledby": k.titleId, "aria-describedby": me };
  return Q.createElement(OA, { type: "Dialog", enabled: P === 0, element: x, onUpdate: he((je, He) => {
    He === "Dialog" && Ke(je, { [H1.Add]: () => m((Le) => Le + 1), [H1.Remove]: () => m((Le) => Le - 1) });
  }) }, Q.createElement(D1, { force: !0 }, Q.createElement(V1, null, Q.createElement(dp.Provider, { value: se }, Q.createElement(V1.Group, { target: x }, Q.createElement(D1, { force: !1 }, Q.createElement(oe, { slot: de, name: "Dialog.Description" }, Q.createElement(Pc, { initialFocus: l, containers: K, features: $ ? Ke(te, { parent: Pc.features.RestoreFocus, leaf: Pc.features.All & ~Pc.features.FocusLock }) : Pc.features.None }, Q.createElement(D, null, Je({ ourProps: we, theirProps: p, slot: de, defaultTag: VA, features: HA, visible: P === 0, name: "Dialog" }))))))))), Q.createElement(q, null));
}
let zA = "div";
function BA(e, t) {
  let n = Tt(), { id: r = `headlessui-dialog-overlay-${n}`, ...o } = e, [{ dialogState: i, close: l }] = Iu("Dialog.Overlay"), c = rt(t), d = he((g) => {
    if (g.target === g.currentTarget) {
      if (Ls(g.currentTarget))
        return g.preventDefault();
      g.preventDefault(), g.stopPropagation(), l();
    }
  }), p = y.useMemo(() => ({ open: i === 0 }), [i]);
  return Je({ ourProps: { ref: c, id: r, "aria-hidden": !0, onClick: d }, theirProps: o, slot: p, defaultTag: zA, name: "Dialog.Overlay" });
}
let UA = "div";
function WA(e, t) {
  let n = Tt(), { id: r = `headlessui-dialog-backdrop-${n}`, ...o } = e, [{ dialogState: i }, l] = Iu("Dialog.Backdrop"), c = rt(t);
  y.useEffect(() => {
    if (l.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [l.panelRef]);
  let d = y.useMemo(() => ({ open: i === 0 }), [i]);
  return Q.createElement(D1, { force: !0 }, Q.createElement(V1, null, Je({ ourProps: { ref: c, id: r, "aria-hidden": !0 }, theirProps: o, slot: d, defaultTag: UA, name: "Dialog.Backdrop" })));
}
let GA = "div";
function KA(e, t) {
  let n = Tt(), { id: r = `headlessui-dialog-panel-${n}`, ...o } = e, [{ dialogState: i }, l] = Iu("Dialog.Panel"), c = rt(t, l.panelRef), d = y.useMemo(() => ({ open: i === 0 }), [i]), p = he((g) => {
    g.stopPropagation();
  });
  return Je({ ourProps: { ref: c, id: r, onClick: p }, theirProps: o, slot: d, defaultTag: GA, name: "Dialog.Panel" });
}
let qA = "h2";
function YA(e, t) {
  let n = Tt(), { id: r = `headlessui-dialog-title-${n}`, ...o } = e, [{ dialogState: i, setTitleId: l }] = Iu("Dialog.Title"), c = rt(t);
  y.useEffect(() => (l(r), () => l(null)), [r, l]);
  let d = y.useMemo(() => ({ open: i === 0 }), [i]);
  return Je({ ourProps: { ref: c, id: r }, theirProps: o, slot: d, defaultTag: qA, name: "Dialog.Title" });
}
let XA = Qe(FA), ZA = Qe(WA), JA = Qe(KA), QA = Qe(BA), eR = Qe(YA), kc = Object.assign(XA, { Backdrop: ZA, Panel: JA, Overlay: QA, Title: eR, Description: Yv });
var Cw;
let tR = (Cw = Q.startTransition) != null ? Cw : function(e) {
  e();
};
var nR = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(nR || {}), rR = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.LinkPanel = 4] = "LinkPanel", e[e.UnlinkPanel = 5] = "UnlinkPanel", e))(rR || {});
let oR = { 0: (e) => ({ ...e, disclosureState: Ke(e.disclosureState, { 0: 1, 1: 0 }) }), 1: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, 4(e) {
  return e.linkedPanel === !0 ? e : { ...e, linkedPanel: !0 };
}, 5(e) {
  return e.linkedPanel === !1 ? e : { ...e, linkedPanel: !1 };
}, 2(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 3(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, Xv = y.createContext(null);
Xv.displayName = "DisclosureContext";
function Zv(e) {
  let t = y.useContext(Xv);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Zv), n;
  }
  return t;
}
let Jv = y.createContext(null);
Jv.displayName = "DisclosureAPIContext";
function VC(e) {
  let t = y.useContext(Jv);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, VC), n;
  }
  return t;
}
let Qv = y.createContext(null);
Qv.displayName = "DisclosurePanelContext";
function sR() {
  return y.useContext(Qv);
}
function iR(e, t) {
  return Ke(t.type, oR, e, t);
}
let aR = y.Fragment;
function lR(e, t) {
  let { defaultOpen: n = !1, ...r } = e, o = y.useRef(null), i = rt(t, Fv((j) => {
    o.current = j;
  }, e.as === void 0 || e.as === y.Fragment)), l = y.useRef(null), c = y.useRef(null), d = y.useReducer(iR, { disclosureState: n ? 0 : 1, linkedPanel: !1, buttonRef: c, panelRef: l, buttonId: null, panelId: null }), [{ disclosureState: p, buttonId: g }, m] = d, v = he((j) => {
    m({ type: 1 });
    let C = ki(o);
    if (!C || !g)
      return;
    let E = (() => j ? j instanceof HTMLElement ? j : j.current instanceof HTMLElement ? j.current : C.getElementById(g) : C.getElementById(g))();
    E == null || E.focus();
  }), b = y.useMemo(() => ({ close: v }), [v]), x = y.useMemo(() => ({ open: p === 0, close: v }), [p, v]), w = { ref: i };
  return Q.createElement(Xv.Provider, { value: d }, Q.createElement(Jv.Provider, { value: b }, Q.createElement($u, { value: Ke(p, { 0: wt.Open, 1: wt.Closed }) }, Je({ ourProps: w, theirProps: r, slot: x, defaultTag: aR, name: "Disclosure" }))));
}
let cR = "button";
function uR(e, t) {
  let n = Tt(), { id: r = `headlessui-disclosure-button-${n}`, ...o } = e, [i, l] = Zv("Disclosure.Button"), c = sR(), d = c === null ? !1 : c === i.panelId, p = y.useRef(null), g = rt(p, t, d ? null : i.buttonRef), m = zv();
  y.useEffect(() => {
    if (!d)
      return l({ type: 2, buttonId: r }), () => {
        l({ type: 2, buttonId: null });
      };
  }, [r, l, d]);
  let v = he((E) => {
    var P;
    if (d) {
      if (i.disclosureState === 1)
        return;
      switch (E.key) {
        case De.Space:
        case De.Enter:
          E.preventDefault(), E.stopPropagation(), l({ type: 0 }), (P = i.buttonRef.current) == null || P.focus();
          break;
      }
    } else
      switch (E.key) {
        case De.Space:
        case De.Enter:
          E.preventDefault(), E.stopPropagation(), l({ type: 0 });
          break;
      }
  }), b = he((E) => {
    switch (E.key) {
      case De.Space:
        E.preventDefault();
        break;
    }
  }), x = he((E) => {
    var P;
    Ls(E.currentTarget) || e.disabled || (d ? (l({ type: 0 }), (P = i.buttonRef.current) == null || P.focus()) : l({ type: 0 }));
  }), w = y.useMemo(() => ({ open: i.disclosureState === 0 }), [i]), j = Rl(e, p), C = d ? { ref: g, type: j, onKeyDown: v, onClick: x } : { ref: g, id: r, type: j, "aria-expanded": i.disclosureState === 0, "aria-controls": i.linkedPanel ? i.panelId : void 0, onKeyDown: v, onKeyUp: b, onClick: x };
  return Je({ mergeRefs: m, ourProps: C, theirProps: o, slot: w, defaultTag: cR, name: "Disclosure.Button" });
}
let dR = "div", fR = zn.RenderStrategy | zn.Static;
function pR(e, t) {
  let n = Tt(), { id: r = `headlessui-disclosure-panel-${n}`, ...o } = e, [i, l] = Zv("Disclosure.Panel"), { close: c } = VC("Disclosure.Panel"), d = zv(), p = rt(t, i.panelRef, (x) => {
    tR(() => l({ type: x ? 4 : 5 }));
  });
  y.useEffect(() => (l({ type: 3, panelId: r }), () => {
    l({ type: 3, panelId: null });
  }), [r, l]);
  let g = Ti(), m = (() => g !== null ? (g & wt.Open) === wt.Open : i.disclosureState === 0)(), v = y.useMemo(() => ({ open: i.disclosureState === 0, close: c }), [i, c]), b = { ref: p, id: r };
  return Q.createElement(Qv.Provider, { value: i.panelId }, Je({ mergeRefs: d, ourProps: b, theirProps: o, slot: v, defaultTag: dR, features: fR, visible: m, name: "Disclosure.Panel" }));
}
let gR = Qe(lR), hR = Qe(uR), mR = Qe(pR), Sm = Object.assign(gR, { Button: hR, Panel: mR }), Ew = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Pw(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", o = e.cloneNode(!0);
  if (!(o instanceof HTMLElement))
    return r;
  let i = !1;
  for (let c of o.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    c.remove(), i = !0;
  let l = i ? (n = o.innerText) != null ? n : "" : r;
  return Ew.test(l) && (l = l.replace(Ew, "")), l;
}
function vR(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((o) => {
      let i = document.getElementById(o);
      if (i) {
        let l = i.getAttribute("aria-label");
        return typeof l == "string" ? l.trim() : Pw(i).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0)
      return r.join(", ");
  }
  return Pw(e).trim();
}
function yR(e) {
  let t = y.useRef(""), n = y.useRef("");
  return he(() => {
    let r = e.current;
    if (!r)
      return "";
    let o = r.innerText;
    if (t.current === o)
      return n.current;
    let i = vR(r).trim().toLowerCase();
    return t.current = o, n.current = i, i;
  });
}
var bR = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(bR || {}), xR = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(xR || {}), wR = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(wR || {}), SR = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.RegisterLabel = 7] = "RegisterLabel", e))(SR || {});
function jm(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = Cs(t(e.options.slice()), (i) => i.dataRef.current.domRef.current), o = n ? r.indexOf(n) : null;
  return o === -1 && (o = null), { options: r, activeOptionIndex: o };
}
let jR = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0)
    return e;
  let t = e.activeOptionIndex, { isSelected: n } = e.dataRef.current, r = e.options.findIndex((o) => n(o.dataRef.current.value));
  return r !== -1 && (t = r), { ...e, listboxState: 0, activeOptionIndex: t };
}, 2(e, t) {
  var n;
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let r = jm(e), o = $1(t, { resolveItems: () => r.options, resolveActiveIndex: () => r.activeOptionIndex, resolveId: (i) => i.id, resolveDisabled: (i) => i.dataRef.current.disabled });
  return { ...e, ...r, searchQuery: "", activeOptionIndex: o, activationTrigger: (n = t.trigger) != null ? n : 1 };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + t.value.toLowerCase(), o = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find((l) => {
    var c;
    return !l.dataRef.current.disabled && ((c = l.dataRef.current.textValue) == null ? void 0 : c.startsWith(r));
  }), i = o ? e.options.indexOf(o) : -1;
  return i === -1 || i === e.activeOptionIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeOptionIndex: i, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let n = { id: t.id, dataRef: t.dataRef }, r = jm(e, (o) => [...o, n]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), { ...e, ...r };
}, 6: (e, t) => {
  let n = jm(e, (r) => {
    let o = r.findIndex((i) => i.id === t.id);
    return o !== -1 && r.splice(o, 1), r;
  });
  return { ...e, ...n, activationTrigger: 1 };
}, 7: (e, t) => ({ ...e, labelId: t.id }) }, e0 = y.createContext(null);
e0.displayName = "ListboxActionsContext";
function Vu(e) {
  let t = y.useContext(e0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Vu), n;
  }
  return t;
}
let t0 = y.createContext(null);
t0.displayName = "ListboxDataContext";
function Hu(e) {
  let t = y.useContext(t0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Hu), n;
  }
  return t;
}
function CR(e, t) {
  return Ke(t.type, jR, e, t);
}
let ER = y.Fragment;
function PR(e, t) {
  let { value: n, defaultValue: r, form: o, name: i, onChange: l, by: c = (re, le) => re === le, disabled: d = !1, horizontal: p = !1, multiple: g = !1, ...m } = e;
  const v = p ? "horizontal" : "vertical";
  let b = rt(t), [x = g ? [] : void 0, w] = Ip(n, l, r), [j, C] = y.useReducer(CR, { dataRef: y.createRef(), listboxState: 1, options: [], searchQuery: "", labelId: null, activeOptionIndex: null, activationTrigger: 1 }), E = y.useRef({ static: !1, hold: !1 }), P = y.useRef(null), k = y.useRef(null), T = y.useRef(null), O = he(typeof c == "string" ? (re, le) => {
    let me = c;
    return (re == null ? void 0 : re[me]) === (le == null ? void 0 : le[me]);
  } : c), A = y.useCallback((re) => Ke($.mode, { 1: () => x.some((le) => O(le, re)), 0: () => O(x, re) }), [x]), $ = y.useMemo(() => ({ ...j, value: x, disabled: d, mode: g ? 1 : 0, orientation: v, compare: O, isSelected: A, optionsPropsRef: E, labelRef: P, buttonRef: k, optionsRef: T }), [x, d, g, j]);
  lt(() => {
    j.dataRef.current = $;
  }, [$]), Fp([$.buttonRef, $.optionsRef], (re, le) => {
    var me;
    C({ type: 1 }), Hv(le, Hp.Loose) || (re.preventDefault(), (me = $.buttonRef.current) == null || me.focus());
  }, $.listboxState === 0);
  let N = y.useMemo(() => ({ open: $.listboxState === 0, disabled: d, value: x }), [$, d, x]), R = he((re) => {
    let le = $.options.find((me) => me.id === re);
    le && te(le.dataRef.current.value);
  }), z = he(() => {
    if ($.activeOptionIndex !== null) {
      let { dataRef: re, id: le } = $.options[$.activeOptionIndex];
      te(re.current.value), C({ type: 2, focus: bt.Specific, id: le });
    }
  }), D = he(() => C({ type: 0 })), Z = he(() => C({ type: 1 })), K = he((re, le, me) => re === bt.Specific ? C({ type: 2, focus: bt.Specific, id: le, trigger: me }) : C({ type: 2, focus: re, trigger: me })), H = he((re, le) => (C({ type: 5, id: re, dataRef: le }), () => C({ type: 6, id: re }))), q = he((re) => (C({ type: 7, id: re }), () => C({ type: 7, id: null }))), te = he((re) => Ke($.mode, { 0() {
    return w == null ? void 0 : w(re);
  }, 1() {
    let le = $.value.slice(), me = le.findIndex((oe) => O(oe, re));
    return me === -1 ? le.push(re) : le.splice(me, 1), w == null ? void 0 : w(le);
  } })), I = he((re) => C({ type: 3, value: re })), F = he(() => C({ type: 4 })), V = y.useMemo(() => ({ onChange: te, registerOption: H, registerLabel: q, goToOption: K, closeListbox: Z, openListbox: D, selectActiveOption: z, selectOption: R, search: I, clearSearch: F }), []), L = { ref: b }, W = y.useRef(null), ie = eo();
  return y.useEffect(() => {
    W.current && r !== void 0 && ie.addEventListener(W.current, "reset", () => {
      w == null || w(r);
    });
  }, [W, w]), Q.createElement(e0.Provider, { value: V }, Q.createElement(t0.Provider, { value: $ }, Q.createElement($u, { value: Ke($.listboxState, { 0: wt.Open, 1: wt.Closed }) }, i != null && x != null && zp({ [i]: x }).map(([re, le], me) => Q.createElement(Or, { features: Tr.Hidden, ref: me === 0 ? (oe) => {
    var se;
    W.current = (se = oe == null ? void 0 : oe.closest("form")) != null ? se : null;
  } : void 0, ...Sl({ key: re, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: o, disabled: d, name: re, value: le }) })), Je({ ourProps: L, theirProps: m, slot: N, defaultTag: ER, name: "Listbox" }))));
}
let _R = "button";
function kR(e, t) {
  var n;
  let r = Tt(), { id: o = `headlessui-listbox-button-${r}`, ...i } = e, l = Hu("Listbox.Button"), c = Vu("Listbox.Button"), d = rt(l.buttonRef, t), p = eo(), g = he((j) => {
    switch (j.key) {
      case De.Space:
      case De.Enter:
      case De.ArrowDown:
        j.preventDefault(), c.openListbox(), p.nextFrame(() => {
          l.value || c.goToOption(bt.First);
        });
        break;
      case De.ArrowUp:
        j.preventDefault(), c.openListbox(), p.nextFrame(() => {
          l.value || c.goToOption(bt.Last);
        });
        break;
    }
  }), m = he((j) => {
    switch (j.key) {
      case De.Space:
        j.preventDefault();
        break;
    }
  }), v = he((j) => {
    if (Ls(j.currentTarget))
      return j.preventDefault();
    l.listboxState === 0 ? (c.closeListbox(), p.nextFrame(() => {
      var C;
      return (C = l.buttonRef.current) == null ? void 0 : C.focus({ preventScroll: !0 });
    })) : (j.preventDefault(), c.openListbox());
  }), b = Ru(() => {
    if (l.labelId)
      return [l.labelId, o].join(" ");
  }, [l.labelId, o]), x = y.useMemo(() => ({ open: l.listboxState === 0, disabled: l.disabled, value: l.value }), [l]), w = { ref: d, id: o, type: Rl(e, l.buttonRef), "aria-haspopup": "listbox", "aria-controls": (n = l.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": l.listboxState === 0, "aria-labelledby": b, disabled: l.disabled, onKeyDown: g, onKeyUp: m, onClick: v };
  return Je({ ourProps: w, theirProps: i, slot: x, defaultTag: _R, name: "Listbox.Button" });
}
let TR = "label";
function OR(e, t) {
  let n = Tt(), { id: r = `headlessui-listbox-label-${n}`, ...o } = e, i = Hu("Listbox.Label"), l = Vu("Listbox.Label"), c = rt(i.labelRef, t);
  lt(() => l.registerLabel(r), [r]);
  let d = he(() => {
    var g;
    return (g = i.buttonRef.current) == null ? void 0 : g.focus({ preventScroll: !0 });
  }), p = y.useMemo(() => ({ open: i.listboxState === 0, disabled: i.disabled }), [i]);
  return Je({ ourProps: { ref: c, id: r, onClick: d }, theirProps: o, slot: p, defaultTag: TR, name: "Listbox.Label" });
}
let LR = "ul", MR = zn.RenderStrategy | zn.Static;
function AR(e, t) {
  var n;
  let r = Tt(), { id: o = `headlessui-listbox-options-${r}`, ...i } = e, l = Hu("Listbox.Options"), c = Vu("Listbox.Options"), d = rt(l.optionsRef, t), p = eo(), g = eo(), m = Ti(), v = (() => m !== null ? (m & wt.Open) === wt.Open : l.listboxState === 0)();
  y.useEffect(() => {
    var C;
    let E = l.optionsRef.current;
    E && l.listboxState === 0 && E !== ((C = ki(E)) == null ? void 0 : C.activeElement) && E.focus({ preventScroll: !0 });
  }, [l.listboxState, l.optionsRef]);
  let b = he((C) => {
    switch (g.dispose(), C.key) {
      case De.Space:
        if (l.searchQuery !== "")
          return C.preventDefault(), C.stopPropagation(), c.search(C.key);
      case De.Enter:
        if (C.preventDefault(), C.stopPropagation(), l.activeOptionIndex !== null) {
          let { dataRef: E } = l.options[l.activeOptionIndex];
          c.onChange(E.current.value);
        }
        l.mode === 0 && (c.closeListbox(), Qr().nextFrame(() => {
          var E;
          return (E = l.buttonRef.current) == null ? void 0 : E.focus({ preventScroll: !0 });
        }));
        break;
      case Ke(l.orientation, { vertical: De.ArrowDown, horizontal: De.ArrowRight }):
        return C.preventDefault(), C.stopPropagation(), c.goToOption(bt.Next);
      case Ke(l.orientation, { vertical: De.ArrowUp, horizontal: De.ArrowLeft }):
        return C.preventDefault(), C.stopPropagation(), c.goToOption(bt.Previous);
      case De.Home:
      case De.PageUp:
        return C.preventDefault(), C.stopPropagation(), c.goToOption(bt.First);
      case De.End:
      case De.PageDown:
        return C.preventDefault(), C.stopPropagation(), c.goToOption(bt.Last);
      case De.Escape:
        return C.preventDefault(), C.stopPropagation(), c.closeListbox(), p.nextFrame(() => {
          var E;
          return (E = l.buttonRef.current) == null ? void 0 : E.focus({ preventScroll: !0 });
        });
      case De.Tab:
        C.preventDefault(), C.stopPropagation();
        break;
      default:
        C.key.length === 1 && (c.search(C.key), g.setTimeout(() => c.clearSearch(), 350));
        break;
    }
  }), x = Ru(() => {
    var C;
    return (C = l.buttonRef.current) == null ? void 0 : C.id;
  }, [l.buttonRef.current]), w = y.useMemo(() => ({ open: l.listboxState === 0 }), [l]), j = { "aria-activedescendant": l.activeOptionIndex === null || (n = l.options[l.activeOptionIndex]) == null ? void 0 : n.id, "aria-multiselectable": l.mode === 1 ? !0 : void 0, "aria-labelledby": x, "aria-orientation": l.orientation, id: o, onKeyDown: b, role: "listbox", tabIndex: 0, ref: d };
  return Je({ ourProps: j, theirProps: i, slot: w, defaultTag: LR, features: MR, visible: v, name: "Listbox.Options" });
}
let RR = "li";
function NR(e, t) {
  let n = Tt(), { id: r = `headlessui-listbox-option-${n}`, disabled: o = !1, value: i, ...l } = e, c = Hu("Listbox.Option"), d = Vu("Listbox.Option"), p = c.activeOptionIndex !== null ? c.options[c.activeOptionIndex].id === r : !1, g = c.isSelected(i), m = y.useRef(null), v = yR(m), b = mn({ disabled: o, value: i, domRef: m, get textValue() {
    return v();
  } }), x = rt(t, m);
  lt(() => {
    if (c.listboxState !== 0 || !p || c.activationTrigger === 0)
      return;
    let O = Qr();
    return O.requestAnimationFrame(() => {
      var A, $;
      ($ = (A = m.current) == null ? void 0 : A.scrollIntoView) == null || $.call(A, { block: "nearest" });
    }), O.dispose;
  }, [m, p, c.listboxState, c.activationTrigger, c.activeOptionIndex]), lt(() => d.registerOption(r, b), [b, r]);
  let w = he((O) => {
    if (o)
      return O.preventDefault();
    d.onChange(i), c.mode === 0 && (d.closeListbox(), Qr().nextFrame(() => {
      var A;
      return (A = c.buttonRef.current) == null ? void 0 : A.focus({ preventScroll: !0 });
    }));
  }), j = he(() => {
    if (o)
      return d.goToOption(bt.Nothing);
    d.goToOption(bt.Specific, r);
  }), C = SC(), E = he((O) => C.update(O)), P = he((O) => {
    C.wasMoved(O) && (o || p || d.goToOption(bt.Specific, r, 0));
  }), k = he((O) => {
    C.wasMoved(O) && (o || p && d.goToOption(bt.Nothing));
  }), T = y.useMemo(() => ({ active: p, selected: g, disabled: o }), [p, g, o]);
  return Je({ ourProps: { id: r, ref: x, role: "option", tabIndex: o === !0 ? void 0 : -1, "aria-disabled": o === !0 ? !0 : void 0, "aria-selected": g, disabled: void 0, onClick: w, onFocus: j, onPointerEnter: E, onMouseEnter: E, onPointerMove: P, onMouseMove: P, onPointerLeave: k, onMouseLeave: k }, theirProps: l, slot: T, defaultTag: RR, name: "Listbox.Option" });
}
let $R = Qe(PR), DR = Qe(kR), IR = Qe(OR), VR = Qe(AR), HR = Qe(NR), Tc = Object.assign($R, { Button: DR, Label: IR, Options: VR, Option: HR });
var FR = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(FR || {}), zR = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(zR || {});
let BR = { 0: (e) => {
  let t = { ...e, popoverState: Ke(e.popoverState, { 0: 1, 1: 0 }) };
  return t.popoverState === 0 && (t.__demoMode = !1), t;
}, 1(e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1 };
}, 2(e, t) {
  return e.button === t.button ? e : { ...e, button: t.button };
}, 3(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 4(e, t) {
  return e.panel === t.panel ? e : { ...e, panel: t.panel };
}, 5(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, n0 = y.createContext(null);
n0.displayName = "PopoverContext";
function Up(e) {
  let t = y.useContext(n0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Up), n;
  }
  return t;
}
let r0 = y.createContext(null);
r0.displayName = "PopoverAPIContext";
function o0(e) {
  let t = y.useContext(r0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, o0), n;
  }
  return t;
}
let s0 = y.createContext(null);
s0.displayName = "PopoverGroupContext";
function HC() {
  return y.useContext(s0);
}
let Wp = y.createContext(null);
Wp.displayName = "PopoverPanelContext";
function UR() {
  return y.useContext(Wp);
}
function WR(e, t) {
  return Ke(t.type, BR, e, t);
}
let GR = "div";
function KR(e, t) {
  var n;
  let { __demoMode: r = !1, ...o } = e, i = y.useRef(null), l = rt(t, Fv((q) => {
    i.current = q;
  })), c = y.useRef([]), d = y.useReducer(WR, { __demoMode: r, popoverState: r ? 0 : 1, buttons: c, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: y.createRef(), afterPanelSentinel: y.createRef() }), [{ popoverState: p, button: g, buttonId: m, panel: v, panelId: b, beforePanelSentinel: x, afterPanelSentinel: w }, j] = d, C = $s((n = i.current) != null ? n : g), E = y.useMemo(() => {
    if (!g || !v)
      return !1;
    for (let W of document.querySelectorAll("body > *"))
      if (Number(W == null ? void 0 : W.contains(g)) ^ Number(W == null ? void 0 : W.contains(v)))
        return !0;
    let q = Vp(), te = q.indexOf(g), I = (te + q.length - 1) % q.length, F = (te + 1) % q.length, V = q[I], L = q[F];
    return !v.contains(V) && !v.contains(L);
  }, [g, v]), P = mn(m), k = mn(b), T = y.useMemo(() => ({ buttonId: P, panelId: k, close: () => j({ type: 1 }) }), [P, k, j]), O = HC(), A = O == null ? void 0 : O.registerPopover, $ = he(() => {
    var q;
    return (q = O == null ? void 0 : O.isFocusWithinPopoverGroup()) != null ? q : (C == null ? void 0 : C.activeElement) && ((g == null ? void 0 : g.contains(C.activeElement)) || (v == null ? void 0 : v.contains(C.activeElement)));
  });
  y.useEffect(() => A == null ? void 0 : A(T), [A, T]);
  let [N, R] = NC(), z = $C({ mainTreeNodeRef: O == null ? void 0 : O.mainTreeNodeRef, portals: N, defaultContainers: [g, v] });
  Gv(C == null ? void 0 : C.defaultView, "focus", (q) => {
    var te, I, F, V;
    q.target !== window && q.target instanceof HTMLElement && p === 0 && ($() || g && v && (z.contains(q.target) || (I = (te = x.current) == null ? void 0 : te.contains) != null && I.call(te, q.target) || (V = (F = w.current) == null ? void 0 : F.contains) != null && V.call(F, q.target) || j({ type: 1 })));
  }, !0), Fp(z.resolveContainers, (q, te) => {
    j({ type: 1 }), Hv(te, Hp.Loose) || (q.preventDefault(), g == null || g.focus());
  }, p === 0);
  let D = he((q) => {
    j({ type: 1 });
    let te = (() => q ? q instanceof HTMLElement ? q : "current" in q && q.current instanceof HTMLElement ? q.current : g : g)();
    te == null || te.focus();
  }), Z = y.useMemo(() => ({ close: D, isPortalled: E }), [D, E]), K = y.useMemo(() => ({ open: p === 0, close: D }), [p, D]), H = { ref: l };
  return Q.createElement(Wp.Provider, { value: null }, Q.createElement(n0.Provider, { value: d }, Q.createElement(r0.Provider, { value: Z }, Q.createElement($u, { value: Ke(p, { 0: wt.Open, 1: wt.Closed }) }, Q.createElement(R, null, Je({ ourProps: H, theirProps: o, slot: K, defaultTag: GR, name: "Popover" }), Q.createElement(z.MainTreeNode, null))))));
}
let qR = "button";
function YR(e, t) {
  let n = Tt(), { id: r = `headlessui-popover-button-${n}`, ...o } = e, [i, l] = Up("Popover.Button"), { isPortalled: c } = o0("Popover.Button"), d = y.useRef(null), p = `headlessui-focus-sentinel-${Tt()}`, g = HC(), m = g == null ? void 0 : g.closeOthers, v = UR() !== null;
  y.useEffect(() => {
    if (!v)
      return l({ type: 3, buttonId: r }), () => {
        l({ type: 3, buttonId: null });
      };
  }, [v, r, l]);
  let [b] = y.useState(() => Symbol()), x = rt(d, t, v ? null : (z) => {
    if (z)
      i.buttons.current.push(b);
    else {
      let D = i.buttons.current.indexOf(b);
      D !== -1 && i.buttons.current.splice(D, 1);
    }
    i.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), z && l({ type: 2, button: z });
  }), w = rt(d, t), j = $s(d), C = he((z) => {
    var D, Z, K;
    if (v) {
      if (i.popoverState === 1)
        return;
      switch (z.key) {
        case De.Space:
        case De.Enter:
          z.preventDefault(), (Z = (D = z.target).click) == null || Z.call(D), l({ type: 1 }), (K = i.button) == null || K.focus();
          break;
      }
    } else
      switch (z.key) {
        case De.Space:
        case De.Enter:
          z.preventDefault(), z.stopPropagation(), i.popoverState === 1 && (m == null || m(i.buttonId)), l({ type: 0 });
          break;
        case De.Escape:
          if (i.popoverState !== 0)
            return m == null ? void 0 : m(i.buttonId);
          if (!d.current || j != null && j.activeElement && !d.current.contains(j.activeElement))
            return;
          z.preventDefault(), z.stopPropagation(), l({ type: 1 });
          break;
      }
  }), E = he((z) => {
    v || z.key === De.Space && z.preventDefault();
  }), P = he((z) => {
    var D, Z;
    Ls(z.currentTarget) || e.disabled || (v ? (l({ type: 1 }), (D = i.button) == null || D.focus()) : (z.preventDefault(), z.stopPropagation(), i.popoverState === 1 && (m == null || m(i.buttonId)), l({ type: 0 }), (Z = i.button) == null || Z.focus()));
  }), k = he((z) => {
    z.preventDefault(), z.stopPropagation();
  }), T = i.popoverState === 0, O = y.useMemo(() => ({ open: T }), [T]), A = Rl(e, d), $ = v ? { ref: w, type: A, onKeyDown: C, onClick: P } : { ref: x, id: i.buttonId, type: A, "aria-expanded": i.popoverState === 0, "aria-controls": i.panel ? i.panelId : void 0, onKeyDown: C, onKeyUp: E, onClick: P, onMouseDown: k }, N = Kv(), R = he(() => {
    let z = i.panel;
    if (!z)
      return;
    function D() {
      Ke(N.current, { [Er.Forwards]: () => hn(z, kt.First), [Er.Backwards]: () => hn(z, kt.Last) }) === vo.Error && hn(Vp().filter((Z) => Z.dataset.headlessuiFocusGuard !== "true"), Ke(N.current, { [Er.Forwards]: kt.Next, [Er.Backwards]: kt.Previous }), { relativeTo: i.button });
    }
    D();
  });
  return Q.createElement(Q.Fragment, null, Je({ ourProps: $, theirProps: o, slot: O, defaultTag: qR, name: "Popover.Button" }), T && !v && c && Q.createElement(Or, { id: p, features: Tr.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: R }));
}
let XR = "div", ZR = zn.RenderStrategy | zn.Static;
function JR(e, t) {
  let n = Tt(), { id: r = `headlessui-popover-overlay-${n}`, ...o } = e, [{ popoverState: i }, l] = Up("Popover.Overlay"), c = rt(t), d = Ti(), p = (() => d !== null ? (d & wt.Open) === wt.Open : i === 0)(), g = he((v) => {
    if (Ls(v.currentTarget))
      return v.preventDefault();
    l({ type: 1 });
  }), m = y.useMemo(() => ({ open: i === 0 }), [i]);
  return Je({ ourProps: { ref: c, id: r, "aria-hidden": !0, onClick: g }, theirProps: o, slot: m, defaultTag: XR, features: ZR, visible: p, name: "Popover.Overlay" });
}
let QR = "div", eN = zn.RenderStrategy | zn.Static;
function tN(e, t) {
  let n = Tt(), { id: r = `headlessui-popover-panel-${n}`, focus: o = !1, ...i } = e, [l, c] = Up("Popover.Panel"), { close: d, isPortalled: p } = o0("Popover.Panel"), g = `headlessui-focus-sentinel-before-${Tt()}`, m = `headlessui-focus-sentinel-after-${Tt()}`, v = y.useRef(null), b = rt(v, t, ($) => {
    c({ type: 4, panel: $ });
  }), x = $s(v), w = zv();
  lt(() => (c({ type: 5, panelId: r }), () => {
    c({ type: 5, panelId: null });
  }), [r, c]);
  let j = Ti(), C = (() => j !== null ? (j & wt.Open) === wt.Open : l.popoverState === 0)(), E = he(($) => {
    var N;
    switch ($.key) {
      case De.Escape:
        if (l.popoverState !== 0 || !v.current || x != null && x.activeElement && !v.current.contains(x.activeElement))
          return;
        $.preventDefault(), $.stopPropagation(), c({ type: 1 }), (N = l.button) == null || N.focus();
        break;
    }
  });
  y.useEffect(() => {
    var $;
    e.static || l.popoverState === 1 && (($ = e.unmount) == null || $) && c({ type: 4, panel: null });
  }, [l.popoverState, e.unmount, e.static, c]), y.useEffect(() => {
    if (l.__demoMode || !o || l.popoverState !== 0 || !v.current)
      return;
    let $ = x == null ? void 0 : x.activeElement;
    v.current.contains($) || hn(v.current, kt.First);
  }, [l.__demoMode, o, v, l.popoverState]);
  let P = y.useMemo(() => ({ open: l.popoverState === 0, close: d }), [l, d]), k = { ref: b, id: r, onKeyDown: E, onBlur: o && l.popoverState === 0 ? ($) => {
    var N, R, z, D, Z;
    let K = $.relatedTarget;
    K && v.current && ((N = v.current) != null && N.contains(K) || (c({ type: 1 }), ((z = (R = l.beforePanelSentinel.current) == null ? void 0 : R.contains) != null && z.call(R, K) || (Z = (D = l.afterPanelSentinel.current) == null ? void 0 : D.contains) != null && Z.call(D, K)) && K.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1 }, T = Kv(), O = he(() => {
    let $ = v.current;
    if (!$)
      return;
    function N() {
      Ke(T.current, { [Er.Forwards]: () => {
        var R;
        hn($, kt.First) === vo.Error && ((R = l.afterPanelSentinel.current) == null || R.focus());
      }, [Er.Backwards]: () => {
        var R;
        (R = l.button) == null || R.focus({ preventScroll: !0 });
      } });
    }
    N();
  }), A = he(() => {
    let $ = v.current;
    if (!$)
      return;
    function N() {
      Ke(T.current, { [Er.Forwards]: () => {
        var R;
        if (!l.button)
          return;
        let z = Vp(), D = z.indexOf(l.button), Z = z.slice(0, D + 1), K = [...z.slice(D + 1), ...Z];
        for (let H of K.slice())
          if (H.dataset.headlessuiFocusGuard === "true" || (R = l.panel) != null && R.contains(H)) {
            let q = K.indexOf(H);
            q !== -1 && K.splice(q, 1);
          }
        hn(K, kt.First, { sorted: !1 });
      }, [Er.Backwards]: () => {
        var R;
        hn($, kt.Previous) === vo.Error && ((R = l.button) == null || R.focus());
      } });
    }
    N();
  });
  return Q.createElement(Wp.Provider, { value: r }, C && p && Q.createElement(Or, { id: g, ref: l.beforePanelSentinel, features: Tr.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: O }), Je({ mergeRefs: w, ourProps: k, theirProps: i, slot: P, defaultTag: QR, features: eN, visible: C, name: "Popover.Panel" }), C && p && Q.createElement(Or, { id: m, ref: l.afterPanelSentinel, features: Tr.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: A }));
}
let nN = "div";
function rN(e, t) {
  let n = y.useRef(null), r = rt(n, t), [o, i] = y.useState([]), l = kA(), c = he((w) => {
    i((j) => {
      let C = j.indexOf(w);
      if (C !== -1) {
        let E = j.slice();
        return E.splice(C, 1), E;
      }
      return j;
    });
  }), d = he((w) => (i((j) => [...j, w]), () => c(w))), p = he(() => {
    var w;
    let j = ki(n);
    if (!j)
      return !1;
    let C = j.activeElement;
    return (w = n.current) != null && w.contains(C) ? !0 : o.some((E) => {
      var P, k;
      return ((P = j.getElementById(E.buttonId.current)) == null ? void 0 : P.contains(C)) || ((k = j.getElementById(E.panelId.current)) == null ? void 0 : k.contains(C));
    });
  }), g = he((w) => {
    for (let j of o)
      j.buttonId.current !== w && j.close();
  }), m = y.useMemo(() => ({ registerPopover: d, unregisterPopover: c, isFocusWithinPopoverGroup: p, closeOthers: g, mainTreeNodeRef: l.mainTreeNodeRef }), [d, c, p, g, l.mainTreeNodeRef]), v = y.useMemo(() => ({}), []), b = e, x = { ref: r };
  return Q.createElement(s0.Provider, { value: m }, Je({ ourProps: x, theirProps: b, slot: v, defaultTag: nN, name: "Popover.Group" }), Q.createElement(l.MainTreeNode, null));
}
let oN = Qe(KR), sN = Qe(YR), iN = Qe(JR), aN = Qe(tN), lN = Qe(rN), Cm = Object.assign(oN, { Button: sN, Overlay: iN, Panel: aN, Group: lN }), FC = y.createContext(null);
function zC() {
  let e = y.useContext(FC);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, zC), t;
  }
  return e;
}
function i0() {
  let [e, t] = y.useState([]);
  return [e.length > 0 ? e.join(" ") : void 0, y.useMemo(() => function(n) {
    let r = he((i) => (t((l) => [...l, i]), () => t((l) => {
      let c = l.slice(), d = c.indexOf(i);
      return d !== -1 && c.splice(d, 1), c;
    }))), o = y.useMemo(() => ({ register: r, slot: n.slot, name: n.name, props: n.props }), [r, n.slot, n.name, n.props]);
    return Q.createElement(FC.Provider, { value: o }, n.children);
  }, [t])];
}
let cN = "label";
function uN(e, t) {
  let n = Tt(), { id: r = `headlessui-label-${n}`, passive: o = !1, ...i } = e, l = zC(), c = rt(t);
  lt(() => l.register(r), [r, l.register]);
  let d = { ref: c, ...l.props, id: r };
  return o && ("onClick" in d && (delete d.htmlFor, delete d.onClick), "onClick" in i && delete i.onClick), Je({ ourProps: d, theirProps: i, slot: l.slot || {}, defaultTag: cN, name: l.name || "Label" });
}
let dN = Qe(uN), BC = Object.assign(dN, {});
function UC(e = 0) {
  let [t, n] = y.useState(e), r = Nl(), o = y.useCallback((d) => {
    r.current && n((p) => p | d);
  }, [t, r]), i = y.useCallback((d) => !!(t & d), [t]), l = y.useCallback((d) => {
    r.current && n((p) => p & ~d);
  }, [n, r]), c = y.useCallback((d) => {
    r.current && n((p) => p ^ d);
  }, [n]);
  return { flags: t, addFlag: o, hasFlag: i, removeFlag: l, toggleFlag: c };
}
var fN = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(fN || {});
let pN = { 0(e, t) {
  let n = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: Cs(n, (r) => r.element.current) };
}, 1(e, t) {
  let n = e.options.slice(), r = e.options.findIndex((o) => o.id === t.id);
  return r === -1 ? e : (n.splice(r, 1), { ...e, options: n });
} }, a0 = y.createContext(null);
a0.displayName = "RadioGroupDataContext";
function WC(e) {
  let t = y.useContext(a0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, WC), n;
  }
  return t;
}
let l0 = y.createContext(null);
l0.displayName = "RadioGroupActionsContext";
function GC(e) {
  let t = y.useContext(l0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, GC), n;
  }
  return t;
}
function gN(e, t) {
  return Ke(t.type, pN, e, t);
}
let hN = "div";
function mN(e, t) {
  let n = Tt(), { id: r = `headlessui-radiogroup-${n}`, value: o, defaultValue: i, form: l, name: c, onChange: d, by: p = (F, V) => F === V, disabled: g = !1, ...m } = e, v = he(typeof p == "string" ? (F, V) => {
    let L = p;
    return (F == null ? void 0 : F[L]) === (V == null ? void 0 : V[L]);
  } : p), [b, x] = y.useReducer(gN, { options: [] }), w = b.options, [j, C] = i0(), [E, P] = Bp(), k = y.useRef(null), T = rt(k, t), [O, A] = Ip(o, d, i), $ = y.useMemo(() => w.find((F) => !F.propsRef.current.disabled), [w]), N = y.useMemo(() => w.some((F) => v(F.propsRef.current.value, O)), [w, O]), R = he((F) => {
    var V;
    if (g || v(F, O))
      return !1;
    let L = (V = w.find((W) => v(W.propsRef.current.value, F))) == null ? void 0 : V.propsRef.current;
    return L != null && L.disabled ? !1 : (A == null || A(F), !0);
  });
  jC({ container: k.current, accept(F) {
    return F.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : F.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(F) {
    F.setAttribute("role", "none");
  } });
  let z = he((F) => {
    let V = k.current;
    if (!V)
      return;
    let L = ki(V), W = w.filter((ie) => ie.propsRef.current.disabled === !1).map((ie) => ie.element.current);
    switch (F.key) {
      case De.Enter:
        _C(F.currentTarget);
        break;
      case De.ArrowLeft:
      case De.ArrowUp:
        if (F.preventDefault(), F.stopPropagation(), hn(W, kt.Previous | kt.WrapAround) === vo.Success) {
          let ie = w.find((re) => re.element.current === (L == null ? void 0 : L.activeElement));
          ie && R(ie.propsRef.current.value);
        }
        break;
      case De.ArrowRight:
      case De.ArrowDown:
        if (F.preventDefault(), F.stopPropagation(), hn(W, kt.Next | kt.WrapAround) === vo.Success) {
          let ie = w.find((re) => re.element.current === (L == null ? void 0 : L.activeElement));
          ie && R(ie.propsRef.current.value);
        }
        break;
      case De.Space:
        {
          F.preventDefault(), F.stopPropagation();
          let ie = w.find((re) => re.element.current === (L == null ? void 0 : L.activeElement));
          ie && R(ie.propsRef.current.value);
        }
        break;
    }
  }), D = he((F) => (x({ type: 0, ...F }), () => x({ type: 1, id: F.id }))), Z = y.useMemo(() => ({ value: O, firstOption: $, containsCheckedOption: N, disabled: g, compare: v, ...b }), [O, $, N, g, v, b]), K = y.useMemo(() => ({ registerOption: D, change: R }), [D, R]), H = { ref: T, id: r, role: "radiogroup", "aria-labelledby": j, "aria-describedby": E, onKeyDown: z }, q = y.useMemo(() => ({ value: O }), [O]), te = y.useRef(null), I = eo();
  return y.useEffect(() => {
    te.current && i !== void 0 && I.addEventListener(te.current, "reset", () => {
      R(i);
    });
  }, [te, R]), Q.createElement(P, { name: "RadioGroup.Description" }, Q.createElement(C, { name: "RadioGroup.Label" }, Q.createElement(l0.Provider, { value: K }, Q.createElement(a0.Provider, { value: Z }, c != null && O != null && zp({ [c]: O }).map(([F, V], L) => Q.createElement(Or, { features: Tr.Hidden, ref: L === 0 ? (W) => {
    var ie;
    te.current = (ie = W == null ? void 0 : W.closest("form")) != null ? ie : null;
  } : void 0, ...Sl({ key: F, as: "input", type: "radio", checked: V != null, hidden: !0, readOnly: !0, form: l, disabled: g, name: F, value: V }) })), Je({ ourProps: H, theirProps: m, slot: q, defaultTag: hN, name: "RadioGroup" })))));
}
var vN = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(vN || {});
let yN = "div";
function bN(e, t) {
  var n;
  let r = Tt(), { id: o = `headlessui-radiogroup-option-${r}`, value: i, disabled: l = !1, ...c } = e, d = y.useRef(null), p = rt(d, t), [g, m] = i0(), [v, b] = Bp(), { addFlag: x, removeFlag: w, hasFlag: j } = UC(1), C = mn({ value: i, disabled: l }), E = WC("RadioGroup.Option"), P = GC("RadioGroup.Option");
  lt(() => P.registerOption({ id: o, element: d, propsRef: C }), [o, P, d, C]);
  let k = he((D) => {
    var Z;
    if (Ls(D.currentTarget))
      return D.preventDefault();
    P.change(i) && (x(2), (Z = d.current) == null || Z.focus());
  }), T = he((D) => {
    if (Ls(D.currentTarget))
      return D.preventDefault();
    x(2);
  }), O = he(() => w(2)), A = ((n = E.firstOption) == null ? void 0 : n.id) === o, $ = E.disabled || l, N = E.compare(E.value, i), R = { ref: p, id: o, role: "radio", "aria-checked": N ? "true" : "false", "aria-labelledby": g, "aria-describedby": v, "aria-disabled": $ ? !0 : void 0, tabIndex: (() => $ ? -1 : N || !E.containsCheckedOption && A ? 0 : -1)(), onClick: $ ? void 0 : k, onFocus: $ ? void 0 : T, onBlur: $ ? void 0 : O }, z = y.useMemo(() => ({ checked: N, disabled: $, active: j(2) }), [N, $, j]);
  return Q.createElement(b, { name: "RadioGroup.Description" }, Q.createElement(m, { name: "RadioGroup.Label" }, Je({ ourProps: R, theirProps: c, slot: z, defaultTag: yN, name: "RadioGroup.Option" })));
}
let xN = Qe(mN), wN = Qe(bN), _w = Object.assign(xN, { Option: wN, Label: BC, Description: Yv }), c0 = y.createContext(null);
c0.displayName = "GroupContext";
let SN = y.Fragment;
function jN(e) {
  var t;
  let [n, r] = y.useState(null), [o, i] = i0(), [l, c] = Bp(), d = y.useMemo(() => ({ switch: n, setSwitch: r, labelledby: o, describedby: l }), [n, r, o, l]), p = {}, g = e;
  return Q.createElement(c, { name: "Switch.Description" }, Q.createElement(i, { name: "Switch.Label", props: { htmlFor: (t = d.switch) == null ? void 0 : t.id, onClick(m) {
    n && (m.currentTarget.tagName === "LABEL" && m.preventDefault(), n.click(), n.focus({ preventScroll: !0 }));
  } } }, Q.createElement(c0.Provider, { value: d }, Je({ ourProps: p, theirProps: g, defaultTag: SN, name: "Switch.Group" }))));
}
let CN = "button";
function EN(e, t) {
  var n;
  let r = Tt(), { id: o = `headlessui-switch-${r}`, checked: i, defaultChecked: l = !1, onChange: c, disabled: d = !1, name: p, value: g, form: m, ...v } = e, b = y.useContext(c0), x = y.useRef(null), w = rt(x, t, b === null ? null : b.setSwitch), [j, C] = Ip(i, c, l), E = he(() => C == null ? void 0 : C(!j)), P = he((N) => {
    if (Ls(N.currentTarget))
      return N.preventDefault();
    N.preventDefault(), E();
  }), k = he((N) => {
    N.key === De.Space ? (N.preventDefault(), E()) : N.key === De.Enter && _C(N.currentTarget);
  }), T = he((N) => N.preventDefault()), O = y.useMemo(() => ({ checked: j }), [j]), A = { id: o, ref: w, role: "switch", type: Rl(e, x), tabIndex: e.tabIndex === -1 ? 0 : (n = e.tabIndex) != null ? n : 0, "aria-checked": j, "aria-labelledby": b == null ? void 0 : b.labelledby, "aria-describedby": b == null ? void 0 : b.describedby, disabled: d, onClick: P, onKeyUp: k, onKeyPress: T }, $ = eo();
  return y.useEffect(() => {
    var N;
    let R = (N = x.current) == null ? void 0 : N.closest("form");
    R && l !== void 0 && $.addEventListener(R, "reset", () => {
      C(l);
    });
  }, [x, C]), Q.createElement(Q.Fragment, null, p != null && j && Q.createElement(Or, { features: Tr.Hidden, ...Sl({ as: "input", type: "checkbox", hidden: !0, readOnly: !0, disabled: d, form: m, checked: j, name: p, value: g }) }), Je({ ourProps: A, theirProps: v, slot: O, defaultTag: CN, name: "Switch" }));
}
let PN = Qe(EN), _N = jN, Em = Object.assign(PN, { Group: _N, Label: BC, Description: Yv });
function kN({ onFocus: e }) {
  let [t, n] = y.useState(!0), r = Nl();
  return t ? Q.createElement(Or, { as: "button", type: "button", features: Tr.Focusable, onFocus: (o) => {
    o.preventDefault();
    let i, l = 50;
    function c() {
      if (l-- <= 0) {
        i && cancelAnimationFrame(i);
        return;
      }
      if (e()) {
        if (cancelAnimationFrame(i), !r.current)
          return;
        n(!1);
        return;
      }
      i = requestAnimationFrame(c);
    }
    i = requestAnimationFrame(c);
  } }) : null;
}
const KC = y.createContext(null);
function TN() {
  return { groups: /* @__PURE__ */ new Map(), get(e, t) {
    var n;
    let r = this.groups.get(e);
    r || (r = /* @__PURE__ */ new Map(), this.groups.set(e, r));
    let o = (n = r.get(t)) != null ? n : 0;
    r.set(t, o + 1);
    let i = Array.from(r.keys()).indexOf(t);
    function l() {
      let c = r.get(t);
      c > 1 ? r.set(t, c - 1) : r.delete(t);
    }
    return [i, l];
  } };
}
function ON({ children: e }) {
  let t = y.useRef(TN());
  return y.createElement(KC.Provider, { value: t }, e);
}
function qC(e) {
  let t = y.useContext(KC);
  if (!t)
    throw new Error("You must wrap your component in a <StableCollection>");
  let n = LN(), [r, o] = t.current.get(e, n);
  return y.useEffect(() => o, []), r;
}
function LN() {
  var e, t, n;
  let r = (n = (t = (e = y.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : e.ReactCurrentOwner) == null ? void 0 : t.current) != null ? n : null;
  if (!r)
    return Symbol();
  let o = [], i = r;
  for (; i; )
    o.push(i.index), i = i.return;
  return "$." + o.join(".");
}
var MN = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(MN || {}), AN = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(AN || {}), RN = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(RN || {});
let NN = { 0(e, t) {
  var n;
  let r = Cs(e.tabs, (g) => g.current), o = Cs(e.panels, (g) => g.current), i = r.filter((g) => {
    var m;
    return !((m = g.current) != null && m.hasAttribute("disabled"));
  }), l = { ...e, tabs: r, panels: o };
  if (t.index < 0 || t.index > r.length - 1) {
    let g = Ke(Math.sign(t.index - e.selectedIndex), { [-1]: () => 1, 0: () => Ke(Math.sign(t.index), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 });
    if (i.length === 0)
      return l;
    let m = Ke(g, { 0: () => r.indexOf(i[0]), 1: () => r.indexOf(i[i.length - 1]) });
    return { ...l, selectedIndex: m === -1 ? e.selectedIndex : m };
  }
  let c = r.slice(0, t.index), d = [...r.slice(t.index), ...c].find((g) => i.includes(g));
  if (!d)
    return l;
  let p = (n = r.indexOf(d)) != null ? n : e.selectedIndex;
  return p === -1 && (p = e.selectedIndex), { ...l, selectedIndex: p };
}, 1(e, t) {
  if (e.tabs.includes(t.tab))
    return e;
  let n = e.tabs[e.selectedIndex], r = Cs([...e.tabs, t.tab], (i) => i.current), o = e.selectedIndex;
  return e.info.current.isControlled || (o = r.indexOf(n), o === -1 && (o = e.selectedIndex)), { ...e, tabs: r, selectedIndex: o };
}, 2(e, t) {
  return { ...e, tabs: e.tabs.filter((n) => n !== t.tab) };
}, 3(e, t) {
  return e.panels.includes(t.panel) ? e : { ...e, panels: Cs([...e.panels, t.panel], (n) => n.current) };
}, 4(e, t) {
  return { ...e, panels: e.panels.filter((n) => n !== t.panel) };
} }, u0 = y.createContext(null);
u0.displayName = "TabsDataContext";
function jl(e) {
  let t = y.useContext(u0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, jl), n;
  }
  return t;
}
let d0 = y.createContext(null);
d0.displayName = "TabsActionsContext";
function f0(e) {
  let t = y.useContext(d0);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, f0), n;
  }
  return t;
}
function $N(e, t) {
  return Ke(t.type, NN, e, t);
}
let DN = y.Fragment;
function IN(e, t) {
  let { defaultIndex: n = 0, vertical: r = !1, manual: o = !1, onChange: i, selectedIndex: l = null, ...c } = e;
  const d = r ? "vertical" : "horizontal", p = o ? "manual" : "auto";
  let g = l !== null, m = mn({ isControlled: g }), v = rt(t), [b, x] = y.useReducer($N, { info: m, selectedIndex: l ?? n, tabs: [], panels: [] }), w = y.useMemo(() => ({ selectedIndex: b.selectedIndex }), [b.selectedIndex]), j = mn(i || (() => {
  })), C = mn(b.tabs), E = y.useMemo(() => ({ orientation: d, activation: p, ...b }), [d, p, b]), P = he((N) => (x({ type: 1, tab: N }), () => x({ type: 2, tab: N }))), k = he((N) => (x({ type: 3, panel: N }), () => x({ type: 4, panel: N }))), T = he((N) => {
    O.current !== N && j.current(N), g || x({ type: 0, index: N });
  }), O = mn(g ? e.selectedIndex : b.selectedIndex), A = y.useMemo(() => ({ registerTab: P, registerPanel: k, change: T }), []);
  lt(() => {
    x({ type: 0, index: l ?? n });
  }, [l]), lt(() => {
    if (O.current === void 0 || b.tabs.length <= 0)
      return;
    let N = Cs(b.tabs, (R) => R.current);
    N.some((R, z) => b.tabs[z] !== R) && T(N.indexOf(b.tabs[O.current]));
  });
  let $ = { ref: v };
  return Q.createElement(ON, null, Q.createElement(d0.Provider, { value: A }, Q.createElement(u0.Provider, { value: E }, E.tabs.length <= 0 && Q.createElement(kN, { onFocus: () => {
    var N, R;
    for (let z of C.current)
      if (((N = z.current) == null ? void 0 : N.tabIndex) === 0)
        return (R = z.current) == null || R.focus(), !0;
    return !1;
  } }), Je({ ourProps: $, theirProps: c, slot: w, defaultTag: DN, name: "Tabs" }))));
}
let VN = "div";
function HN(e, t) {
  let { orientation: n, selectedIndex: r } = jl("Tab.List"), o = rt(t);
  return Je({ ourProps: { ref: o, role: "tablist", "aria-orientation": n }, theirProps: e, slot: { selectedIndex: r }, defaultTag: VN, name: "Tabs.List" });
}
let FN = "button";
function zN(e, t) {
  var n, r;
  let o = Tt(), { id: i = `headlessui-tabs-tab-${o}`, ...l } = e, { orientation: c, activation: d, selectedIndex: p, tabs: g, panels: m } = jl("Tab"), v = f0("Tab"), b = jl("Tab"), x = y.useRef(null), w = rt(x, t);
  lt(() => v.registerTab(x), [v, x]);
  let j = qC("tabs"), C = g.indexOf(x);
  C === -1 && (C = j);
  let E = C === p, P = he((R) => {
    var z;
    let D = R();
    if (D === vo.Success && d === "auto") {
      let Z = (z = ki(x)) == null ? void 0 : z.activeElement, K = b.tabs.findIndex((H) => H.current === Z);
      K !== -1 && v.change(K);
    }
    return D;
  }), k = he((R) => {
    let z = g.map((D) => D.current).filter(Boolean);
    if (R.key === De.Space || R.key === De.Enter) {
      R.preventDefault(), R.stopPropagation(), v.change(C);
      return;
    }
    switch (R.key) {
      case De.Home:
      case De.PageUp:
        return R.preventDefault(), R.stopPropagation(), P(() => hn(z, kt.First));
      case De.End:
      case De.PageDown:
        return R.preventDefault(), R.stopPropagation(), P(() => hn(z, kt.Last));
    }
    if (P(() => Ke(c, { vertical() {
      return R.key === De.ArrowUp ? hn(z, kt.Previous | kt.WrapAround) : R.key === De.ArrowDown ? hn(z, kt.Next | kt.WrapAround) : vo.Error;
    }, horizontal() {
      return R.key === De.ArrowLeft ? hn(z, kt.Previous | kt.WrapAround) : R.key === De.ArrowRight ? hn(z, kt.Next | kt.WrapAround) : vo.Error;
    } })) === vo.Success)
      return R.preventDefault();
  }), T = y.useRef(!1), O = he(() => {
    var R;
    T.current || (T.current = !0, (R = x.current) == null || R.focus({ preventScroll: !0 }), v.change(C), Nu(() => {
      T.current = !1;
    }));
  }), A = he((R) => {
    R.preventDefault();
  }), $ = y.useMemo(() => {
    var R;
    return { selected: E, disabled: (R = e.disabled) != null ? R : !1 };
  }, [E, e.disabled]), N = { ref: w, onKeyDown: k, onMouseDown: A, onClick: O, id: i, role: "tab", type: Rl(e, x), "aria-controls": (r = (n = m[C]) == null ? void 0 : n.current) == null ? void 0 : r.id, "aria-selected": E, tabIndex: E ? 0 : -1 };
  return Je({ ourProps: N, theirProps: l, slot: $, defaultTag: FN, name: "Tabs.Tab" });
}
let BN = "div";
function UN(e, t) {
  let { selectedIndex: n } = jl("Tab.Panels"), r = rt(t), o = y.useMemo(() => ({ selectedIndex: n }), [n]);
  return Je({ ourProps: { ref: r }, theirProps: e, slot: o, defaultTag: BN, name: "Tabs.Panels" });
}
let WN = "div", GN = zn.RenderStrategy | zn.Static;
function KN(e, t) {
  var n, r, o, i;
  let l = Tt(), { id: c = `headlessui-tabs-panel-${l}`, tabIndex: d = 0, ...p } = e, { selectedIndex: g, tabs: m, panels: v } = jl("Tab.Panel"), b = f0("Tab.Panel"), x = y.useRef(null), w = rt(x, t);
  lt(() => b.registerPanel(x), [b, x, c]);
  let j = qC("panels"), C = v.indexOf(x);
  C === -1 && (C = j);
  let E = C === g, P = y.useMemo(() => ({ selected: E }), [E]), k = { ref: w, id: c, role: "tabpanel", "aria-labelledby": (r = (n = m[C]) == null ? void 0 : n.current) == null ? void 0 : r.id, tabIndex: E ? d : -1 };
  return !E && ((o = p.unmount) == null || o) && !((i = p.static) != null && i) ? Q.createElement(Or, { as: "span", "aria-hidden": "true", ...k }) : Je({ ourProps: k, theirProps: p, slot: P, defaultTag: WN, features: GN, visible: E, name: "Tabs.Panel" });
}
let qN = Qe(zN), YN = Qe(IN), XN = Qe(HN), ZN = Qe(UN), JN = Qe(KN), Oc = Object.assign(qN, { Group: YN, List: XN, Panels: ZN, Panel: JN });
function QN(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called)
      return t.called = !0, e(...n);
  };
}
function Pm(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function _m(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
function e6(e, t) {
  let n = Qr();
  if (!e)
    return n.dispose;
  let { transitionDuration: r, transitionDelay: o } = getComputedStyle(e), [i, l] = [r, o].map((d) => {
    let [p = 0] = d.split(",").filter(Boolean).map((g) => g.includes("ms") ? parseFloat(g) : parseFloat(g) * 1e3).sort((g, m) => m - g);
    return p;
  }), c = i + l;
  if (c !== 0) {
    n.group((p) => {
      p.setTimeout(() => {
        t(), p.dispose();
      }, c), p.addEventListener(e, "transitionrun", (g) => {
        g.target === g.currentTarget && p.dispose();
      });
    });
    let d = n.addEventListener(e, "transitionend", (p) => {
      p.target === p.currentTarget && (t(), d());
    });
  } else
    t();
  return n.add(() => t()), n.dispose;
}
function t6(e, t, n, r) {
  let o = n ? "enter" : "leave", i = Qr(), l = r !== void 0 ? QN(r) : () => {
  };
  o === "enter" && (e.removeAttribute("hidden"), e.style.display = "");
  let c = Ke(o, { enter: () => t.enter, leave: () => t.leave }), d = Ke(o, { enter: () => t.enterTo, leave: () => t.leaveTo }), p = Ke(o, { enter: () => t.enterFrom, leave: () => t.leaveFrom });
  return _m(e, ...t.base, ...t.enter, ...t.enterTo, ...t.enterFrom, ...t.leave, ...t.leaveFrom, ...t.leaveTo, ...t.entered), Pm(e, ...t.base, ...c, ...p), i.nextFrame(() => {
    _m(e, ...t.base, ...c, ...p), Pm(e, ...t.base, ...c, ...d), e6(e, () => (_m(e, ...t.base, ...c), Pm(e, ...t.base, ...t.entered), l()));
  }), i.dispose;
}
function n6({ immediate: e, container: t, direction: n, classes: r, onStart: o, onStop: i }) {
  let l = Nl(), c = eo(), d = mn(n);
  lt(() => {
    e && (d.current = "enter");
  }, [e]), lt(() => {
    let p = Qr();
    c.add(p.dispose);
    let g = t.current;
    if (g && d.current !== "idle" && l.current)
      return p.dispose(), o.current(d.current), p.add(t6(g, r.current, d.current === "enter", () => {
        p.dispose(), i.current(d.current);
      })), p.dispose;
  }, [n]);
}
function ri(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let Gp = y.createContext(null);
Gp.displayName = "TransitionContext";
var r6 = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(r6 || {});
function o6() {
  let e = y.useContext(Gp);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function s6() {
  let e = y.useContext(Kp);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let Kp = y.createContext(null);
Kp.displayName = "NestingContext";
function qp(e) {
  return "children" in e ? qp(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function YC(e, t) {
  let n = mn(e), r = y.useRef([]), o = Nl(), i = eo(), l = he((b, x = mi.Hidden) => {
    let w = r.current.findIndex(({ el: j }) => j === b);
    w !== -1 && (Ke(x, { [mi.Unmount]() {
      r.current.splice(w, 1);
    }, [mi.Hidden]() {
      r.current[w].state = "hidden";
    } }), i.microTask(() => {
      var j;
      !qp(r) && o.current && ((j = n.current) == null || j.call(n));
    }));
  }), c = he((b) => {
    let x = r.current.find(({ el: w }) => w === b);
    return x ? x.state !== "visible" && (x.state = "visible") : r.current.push({ el: b, state: "visible" }), () => l(b, mi.Unmount);
  }), d = y.useRef([]), p = y.useRef(Promise.resolve()), g = y.useRef({ enter: [], leave: [], idle: [] }), m = he((b, x, w) => {
    d.current.splice(0), t && (t.chains.current[x] = t.chains.current[x].filter(([j]) => j !== b)), t == null || t.chains.current[x].push([b, new Promise((j) => {
      d.current.push(j);
    })]), t == null || t.chains.current[x].push([b, new Promise((j) => {
      Promise.all(g.current[x].map(([C, E]) => E)).then(() => j());
    })]), x === "enter" ? p.current = p.current.then(() => t == null ? void 0 : t.wait.current).then(() => w(x)) : w(x);
  }), v = he((b, x, w) => {
    Promise.all(g.current[x].splice(0).map(([j, C]) => C)).then(() => {
      var j;
      (j = d.current.shift()) == null || j();
    }).then(() => w(x));
  });
  return y.useMemo(() => ({ children: r, register: c, unregister: l, onStart: m, onStop: v, wait: p, chains: g }), [c, l, r, m, v, g, p]);
}
function i6() {
}
let a6 = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function kw(e) {
  var t;
  let n = {};
  for (let r of a6)
    n[r] = (t = e[r]) != null ? t : i6;
  return n;
}
function l6(e) {
  let t = y.useRef(kw(e));
  return y.useEffect(() => {
    t.current = kw(e);
  }, [e]), t;
}
let c6 = "div", XC = zn.RenderStrategy;
function u6(e, t) {
  var n, r;
  let { beforeEnter: o, afterEnter: i, beforeLeave: l, afterLeave: c, enter: d, enterFrom: p, enterTo: g, entered: m, leave: v, leaveFrom: b, leaveTo: x, ...w } = e, j = y.useRef(null), C = rt(j, t), E = (n = w.unmount) == null || n ? mi.Unmount : mi.Hidden, { show: P, appear: k, initial: T } = o6(), [O, A] = y.useState(P ? "visible" : "hidden"), $ = s6(), { register: N, unregister: R } = $;
  y.useEffect(() => N(j), [N, j]), y.useEffect(() => {
    if (E === mi.Hidden && j.current) {
      if (P && O !== "visible") {
        A("visible");
        return;
      }
      return Ke(O, { hidden: () => R(j), visible: () => N(j) });
    }
  }, [O, j, N, R, P, E]);
  let z = mn({ base: ri(w.className), enter: ri(d), enterFrom: ri(p), enterTo: ri(g), entered: ri(m), leave: ri(v), leaveFrom: ri(b), leaveTo: ri(x) }), D = l6({ beforeEnter: o, afterEnter: i, beforeLeave: l, afterLeave: c }), Z = Al();
  y.useEffect(() => {
    if (Z && O === "visible" && j.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [j, O, Z]);
  let K = T && !k, H = k && P && T, q = (() => !Z || K ? "idle" : P ? "enter" : "leave")(), te = UC(0), I = he((re) => Ke(re, { enter: () => {
    te.addFlag(wt.Opening), D.current.beforeEnter();
  }, leave: () => {
    te.addFlag(wt.Closing), D.current.beforeLeave();
  }, idle: () => {
  } })), F = he((re) => Ke(re, { enter: () => {
    te.removeFlag(wt.Opening), D.current.afterEnter();
  }, leave: () => {
    te.removeFlag(wt.Closing), D.current.afterLeave();
  }, idle: () => {
  } })), V = YC(() => {
    A("hidden"), R(j);
  }, $), L = y.useRef(!1);
  n6({ immediate: H, container: j, classes: z, direction: q, onStart: mn((re) => {
    L.current = !0, V.onStart(j, re, I);
  }), onStop: mn((re) => {
    L.current = !1, V.onStop(j, re, F), re === "leave" && !qp(V) && (A("hidden"), R(j));
  }) });
  let W = w, ie = { ref: C };
  return H ? W = { ...W, className: up(w.className, ...z.current.enter, ...z.current.enterFrom) } : L.current && (W.className = up(w.className, (r = j.current) == null ? void 0 : r.className), W.className === "" && delete W.className), Q.createElement(Kp.Provider, { value: V }, Q.createElement($u, { value: Ke(O, { visible: wt.Open, hidden: wt.Closed }) | te.flags }, Je({ ourProps: ie, theirProps: W, defaultTag: c6, features: XC, visible: O === "visible", name: "Transition.Child" })));
}
function d6(e, t) {
  let { show: n, appear: r = !1, unmount: o = !0, ...i } = e, l = y.useRef(null), c = rt(l, t);
  Al();
  let d = Ti();
  if (n === void 0 && d !== null && (n = (d & wt.Open) === wt.Open), ![!0, !1].includes(n))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [p, g] = y.useState(n ? "visible" : "hidden"), m = YC(() => {
    g("hidden");
  }), [v, b] = y.useState(!0), x = y.useRef([n]);
  lt(() => {
    v !== !1 && x.current[x.current.length - 1] !== n && (x.current.push(n), b(!1));
  }, [x, n]);
  let w = y.useMemo(() => ({ show: n, appear: r, initial: v }), [n, r, v]);
  y.useEffect(() => {
    if (n)
      g("visible");
    else if (!qp(m))
      g("hidden");
    else {
      let P = l.current;
      if (!P)
        return;
      let k = P.getBoundingClientRect();
      k.x === 0 && k.y === 0 && k.width === 0 && k.height === 0 && g("hidden");
    }
  }, [n, m]);
  let j = { unmount: o }, C = he(() => {
    var P;
    v && b(!1), (P = e.beforeEnter) == null || P.call(e);
  }), E = he(() => {
    var P;
    v && b(!1), (P = e.beforeLeave) == null || P.call(e);
  });
  return Q.createElement(Kp.Provider, { value: m }, Q.createElement(Gp.Provider, { value: w }, Je({ ourProps: { ...j, as: y.Fragment, children: Q.createElement(ZC, { ref: c, ...j, ...i, beforeEnter: C, beforeLeave: E }) }, theirProps: {}, defaultTag: y.Fragment, features: XC, visible: p === "visible", name: "Transition" })));
}
function f6(e, t) {
  let n = y.useContext(Gp) !== null, r = Ti() !== null;
  return Q.createElement(Q.Fragment, null, !n && r ? Q.createElement(F1, { ref: t, ...e }) : Q.createElement(ZC, { ref: t, ...e }));
}
let F1 = Qe(d6), ZC = Qe(u6), p6 = Qe(f6), Xo = Object.assign(F1, { Child: p6, Root: F1 });
var Tw = function(t) {
  return t.reduce(function(n, r) {
    var o = r[0], i = r[1];
    return n[o] = i, n;
  }, {});
}, Ow = typeof window < "u" && window.document && window.document.createElement ? y.useLayoutEffect : y.useEffect, dr = "top", to = "bottom", no = "right", fr = "left", p0 = "auto", Fu = [dr, to, no, fr], Cl = "start", uu = "end", g6 = "clippingParents", JC = "viewport", Lc = "popper", h6 = "reference", Lw = /* @__PURE__ */ Fu.reduce(function(e, t) {
  return e.concat([t + "-" + Cl, t + "-" + uu]);
}, []), QC = /* @__PURE__ */ [].concat(Fu, [p0]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Cl, t + "-" + uu]);
}, []), m6 = "beforeRead", v6 = "read", y6 = "afterRead", b6 = "beforeMain", x6 = "main", w6 = "afterMain", S6 = "beforeWrite", j6 = "write", C6 = "afterWrite", E6 = [m6, v6, y6, b6, x6, w6, S6, j6, C6];
function es(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Lr(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function fa(e) {
  var t = Lr(e).Element;
  return e instanceof t || e instanceof Element;
}
function Jr(e) {
  var t = Lr(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function g0(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Lr(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function P6(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !Jr(i) || !es(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(l) {
      var c = o[l];
      c === !1 ? i.removeAttribute(l) : i.setAttribute(l, c === !0 ? "" : c);
    }));
  });
}
function _6(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, l = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), c = l.reduce(function(d, p) {
        return d[p] = "", d;
      }, {});
      !Jr(o) || !es(o) || (Object.assign(o.style, c), Object.keys(i).forEach(function(d) {
        o.removeAttribute(d);
      }));
    });
  };
}
const k6 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: P6,
  effect: _6,
  requires: ["computeStyles"]
};
function Zo(e) {
  return e.split("-")[0];
}
var ra = Math.max, fp = Math.min, El = Math.round;
function z1() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function eE() {
  return !/^((?!chrome|android).)*safari/i.test(z1());
}
function Pl(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && Jr(e) && (o = e.offsetWidth > 0 && El(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && El(r.height) / e.offsetHeight || 1);
  var l = fa(e) ? Lr(e) : window, c = l.visualViewport, d = !eE() && n, p = (r.left + (d && c ? c.offsetLeft : 0)) / o, g = (r.top + (d && c ? c.offsetTop : 0)) / i, m = r.width / o, v = r.height / i;
  return {
    width: m,
    height: v,
    top: g,
    right: p + m,
    bottom: g + v,
    left: p,
    x: p,
    y: g
  };
}
function h0(e) {
  var t = Pl(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function tE(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && g0(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ms(e) {
  return Lr(e).getComputedStyle(e);
}
function T6(e) {
  return ["table", "td", "th"].indexOf(es(e)) >= 0;
}
function Oi(e) {
  return ((fa(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Yp(e) {
  return es(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (g0(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Oi(e)
  );
}
function Mw(e) {
  return !Jr(e) || // https://github.com/popperjs/popper-core/issues/837
  Ms(e).position === "fixed" ? null : e.offsetParent;
}
function O6(e) {
  var t = /firefox/i.test(z1()), n = /Trident/i.test(z1());
  if (n && Jr(e)) {
    var r = Ms(e);
    if (r.position === "fixed")
      return null;
  }
  var o = Yp(e);
  for (g0(o) && (o = o.host); Jr(o) && ["html", "body"].indexOf(es(o)) < 0; ) {
    var i = Ms(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function zu(e) {
  for (var t = Lr(e), n = Mw(e); n && T6(n) && Ms(n).position === "static"; )
    n = Mw(n);
  return n && (es(n) === "html" || es(n) === "body" && Ms(n).position === "static") ? t : n || O6(e) || t;
}
function m0(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function zc(e, t, n) {
  return ra(e, fp(t, n));
}
function L6(e, t, n) {
  var r = zc(e, t, n);
  return r > n ? n : r;
}
function nE() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function rE(e) {
  return Object.assign({}, nE(), e);
}
function oE(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var M6 = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, rE(typeof t != "number" ? t : oE(t, Fu));
};
function A6(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, l = n.modifiersData.popperOffsets, c = Zo(n.placement), d = m0(c), p = [fr, no].indexOf(c) >= 0, g = p ? "height" : "width";
  if (!(!i || !l)) {
    var m = M6(o.padding, n), v = h0(i), b = d === "y" ? dr : fr, x = d === "y" ? to : no, w = n.rects.reference[g] + n.rects.reference[d] - l[d] - n.rects.popper[g], j = l[d] - n.rects.reference[d], C = zu(i), E = C ? d === "y" ? C.clientHeight || 0 : C.clientWidth || 0 : 0, P = w / 2 - j / 2, k = m[b], T = E - v[g] - m[x], O = E / 2 - v[g] / 2 + P, A = zc(k, O, T), $ = d;
    n.modifiersData[r] = (t = {}, t[$] = A, t.centerOffset = A - O, t);
  }
}
function R6(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || tE(t.elements.popper, o) && (t.elements.arrow = o));
}
const N6 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: A6,
  effect: R6,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function _l(e) {
  return e.split("-")[1];
}
var $6 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function D6(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: El(n * o) / o || 0,
    y: El(r * o) / o || 0
  };
}
function Aw(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, l = e.offsets, c = e.position, d = e.gpuAcceleration, p = e.adaptive, g = e.roundOffsets, m = e.isFixed, v = l.x, b = v === void 0 ? 0 : v, x = l.y, w = x === void 0 ? 0 : x, j = typeof g == "function" ? g({
    x: b,
    y: w
  }) : {
    x: b,
    y: w
  };
  b = j.x, w = j.y;
  var C = l.hasOwnProperty("x"), E = l.hasOwnProperty("y"), P = fr, k = dr, T = window;
  if (p) {
    var O = zu(n), A = "clientHeight", $ = "clientWidth";
    if (O === Lr(n) && (O = Oi(n), Ms(O).position !== "static" && c === "absolute" && (A = "scrollHeight", $ = "scrollWidth")), O = O, o === dr || (o === fr || o === no) && i === uu) {
      k = to;
      var N = m && O === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[A]
      );
      w -= N - r.height, w *= d ? 1 : -1;
    }
    if (o === fr || (o === dr || o === to) && i === uu) {
      P = no;
      var R = m && O === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[$]
      );
      b -= R - r.width, b *= d ? 1 : -1;
    }
  }
  var z = Object.assign({
    position: c
  }, p && $6), D = g === !0 ? D6({
    x: b,
    y: w
  }, Lr(n)) : {
    x: b,
    y: w
  };
  if (b = D.x, w = D.y, d) {
    var Z;
    return Object.assign({}, z, (Z = {}, Z[k] = E ? "0" : "", Z[P] = C ? "0" : "", Z.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + w + "px)" : "translate3d(" + b + "px, " + w + "px, 0)", Z));
  }
  return Object.assign({}, z, (t = {}, t[k] = E ? w + "px" : "", t[P] = C ? b + "px" : "", t.transform = "", t));
}
function I6(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, l = i === void 0 ? !0 : i, c = n.roundOffsets, d = c === void 0 ? !0 : c, p = {
    placement: Zo(t.placement),
    variation: _l(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Aw(Object.assign({}, p, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: d
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Aw(Object.assign({}, p, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: d
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const V6 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: I6,
  data: {}
};
var hf = {
  passive: !0
};
function H6(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, l = r.resize, c = l === void 0 ? !0 : l, d = Lr(t.elements.popper), p = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && p.forEach(function(g) {
    g.addEventListener("scroll", n.update, hf);
  }), c && d.addEventListener("resize", n.update, hf), function() {
    i && p.forEach(function(g) {
      g.removeEventListener("scroll", n.update, hf);
    }), c && d.removeEventListener("resize", n.update, hf);
  };
}
const F6 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: H6,
  data: {}
};
var z6 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Zf(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return z6[t];
  });
}
var B6 = {
  start: "end",
  end: "start"
};
function Rw(e) {
  return e.replace(/start|end/g, function(t) {
    return B6[t];
  });
}
function v0(e) {
  var t = Lr(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function y0(e) {
  return Pl(Oi(e)).left + v0(e).scrollLeft;
}
function U6(e, t) {
  var n = Lr(e), r = Oi(e), o = n.visualViewport, i = r.clientWidth, l = r.clientHeight, c = 0, d = 0;
  if (o) {
    i = o.width, l = o.height;
    var p = eE();
    (p || !p && t === "fixed") && (c = o.offsetLeft, d = o.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: c + y0(e),
    y: d
  };
}
function W6(e) {
  var t, n = Oi(e), r = v0(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = ra(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), l = ra(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), c = -r.scrollLeft + y0(e), d = -r.scrollTop;
  return Ms(o || n).direction === "rtl" && (c += ra(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: l,
    x: c,
    y: d
  };
}
function b0(e) {
  var t = Ms(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function sE(e) {
  return ["html", "body", "#document"].indexOf(es(e)) >= 0 ? e.ownerDocument.body : Jr(e) && b0(e) ? e : sE(Yp(e));
}
function Bc(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = sE(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Lr(r), l = o ? [i].concat(i.visualViewport || [], b0(r) ? r : []) : r, c = t.concat(l);
  return o ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(Bc(Yp(l)))
  );
}
function B1(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function G6(e, t) {
  var n = Pl(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Nw(e, t, n) {
  return t === JC ? B1(U6(e, n)) : fa(t) ? G6(t, n) : B1(W6(Oi(e)));
}
function K6(e) {
  var t = Bc(Yp(e)), n = ["absolute", "fixed"].indexOf(Ms(e).position) >= 0, r = n && Jr(e) ? zu(e) : e;
  return fa(r) ? t.filter(function(o) {
    return fa(o) && tE(o, r) && es(o) !== "body";
  }) : [];
}
function q6(e, t, n, r) {
  var o = t === "clippingParents" ? K6(e) : [].concat(t), i = [].concat(o, [n]), l = i[0], c = i.reduce(function(d, p) {
    var g = Nw(e, p, r);
    return d.top = ra(g.top, d.top), d.right = fp(g.right, d.right), d.bottom = fp(g.bottom, d.bottom), d.left = ra(g.left, d.left), d;
  }, Nw(e, l, r));
  return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
}
function iE(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Zo(r) : null, i = r ? _l(r) : null, l = t.x + t.width / 2 - n.width / 2, c = t.y + t.height / 2 - n.height / 2, d;
  switch (o) {
    case dr:
      d = {
        x: l,
        y: t.y - n.height
      };
      break;
    case to:
      d = {
        x: l,
        y: t.y + t.height
      };
      break;
    case no:
      d = {
        x: t.x + t.width,
        y: c
      };
      break;
    case fr:
      d = {
        x: t.x - n.width,
        y: c
      };
      break;
    default:
      d = {
        x: t.x,
        y: t.y
      };
  }
  var p = o ? m0(o) : null;
  if (p != null) {
    var g = p === "y" ? "height" : "width";
    switch (i) {
      case Cl:
        d[p] = d[p] - (t[g] / 2 - n[g] / 2);
        break;
      case uu:
        d[p] = d[p] + (t[g] / 2 - n[g] / 2);
        break;
    }
  }
  return d;
}
function du(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, l = i === void 0 ? e.strategy : i, c = n.boundary, d = c === void 0 ? g6 : c, p = n.rootBoundary, g = p === void 0 ? JC : p, m = n.elementContext, v = m === void 0 ? Lc : m, b = n.altBoundary, x = b === void 0 ? !1 : b, w = n.padding, j = w === void 0 ? 0 : w, C = rE(typeof j != "number" ? j : oE(j, Fu)), E = v === Lc ? h6 : Lc, P = e.rects.popper, k = e.elements[x ? E : v], T = q6(fa(k) ? k : k.contextElement || Oi(e.elements.popper), d, g, l), O = Pl(e.elements.reference), A = iE({
    reference: O,
    element: P,
    strategy: "absolute",
    placement: o
  }), $ = B1(Object.assign({}, P, A)), N = v === Lc ? $ : O, R = {
    top: T.top - N.top + C.top,
    bottom: N.bottom - T.bottom + C.bottom,
    left: T.left - N.left + C.left,
    right: N.right - T.right + C.right
  }, z = e.modifiersData.offset;
  if (v === Lc && z) {
    var D = z[o];
    Object.keys(R).forEach(function(Z) {
      var K = [no, to].indexOf(Z) >= 0 ? 1 : -1, H = [dr, to].indexOf(Z) >= 0 ? "y" : "x";
      R[Z] += D[H] * K;
    });
  }
  return R;
}
function Y6(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, l = n.padding, c = n.flipVariations, d = n.allowedAutoPlacements, p = d === void 0 ? QC : d, g = _l(r), m = g ? c ? Lw : Lw.filter(function(x) {
    return _l(x) === g;
  }) : Fu, v = m.filter(function(x) {
    return p.indexOf(x) >= 0;
  });
  v.length === 0 && (v = m);
  var b = v.reduce(function(x, w) {
    return x[w] = du(e, {
      placement: w,
      boundary: o,
      rootBoundary: i,
      padding: l
    })[Zo(w)], x;
  }, {});
  return Object.keys(b).sort(function(x, w) {
    return b[x] - b[w];
  });
}
function X6(e) {
  if (Zo(e) === p0)
    return [];
  var t = Zf(e);
  return [Rw(e), t, Rw(t)];
}
function Z6(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, l = n.altAxis, c = l === void 0 ? !0 : l, d = n.fallbackPlacements, p = n.padding, g = n.boundary, m = n.rootBoundary, v = n.altBoundary, b = n.flipVariations, x = b === void 0 ? !0 : b, w = n.allowedAutoPlacements, j = t.options.placement, C = Zo(j), E = C === j, P = d || (E || !x ? [Zf(j)] : X6(j)), k = [j].concat(P).reduce(function(re, le) {
      return re.concat(Zo(le) === p0 ? Y6(t, {
        placement: le,
        boundary: g,
        rootBoundary: m,
        padding: p,
        flipVariations: x,
        allowedAutoPlacements: w
      }) : le);
    }, []), T = t.rects.reference, O = t.rects.popper, A = /* @__PURE__ */ new Map(), $ = !0, N = k[0], R = 0; R < k.length; R++) {
      var z = k[R], D = Zo(z), Z = _l(z) === Cl, K = [dr, to].indexOf(D) >= 0, H = K ? "width" : "height", q = du(t, {
        placement: z,
        boundary: g,
        rootBoundary: m,
        altBoundary: v,
        padding: p
      }), te = K ? Z ? no : fr : Z ? to : dr;
      T[H] > O[H] && (te = Zf(te));
      var I = Zf(te), F = [];
      if (i && F.push(q[D] <= 0), c && F.push(q[te] <= 0, q[I] <= 0), F.every(function(re) {
        return re;
      })) {
        N = z, $ = !1;
        break;
      }
      A.set(z, F);
    }
    if ($)
      for (var V = x ? 3 : 1, L = function(le) {
        var me = k.find(function(oe) {
          var se = A.get(oe);
          if (se)
            return se.slice(0, le).every(function(de) {
              return de;
            });
        });
        if (me)
          return N = me, "break";
      }, W = V; W > 0; W--) {
        var ie = L(W);
        if (ie === "break")
          break;
      }
    t.placement !== N && (t.modifiersData[r]._skip = !0, t.placement = N, t.reset = !0);
  }
}
const J6 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Z6,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function $w(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Dw(e) {
  return [dr, no, to, fr].some(function(t) {
    return e[t] >= 0;
  });
}
function Q6(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, l = du(t, {
    elementContext: "reference"
  }), c = du(t, {
    altBoundary: !0
  }), d = $w(l, r), p = $w(c, o, i), g = Dw(d), m = Dw(p);
  t.modifiersData[n] = {
    referenceClippingOffsets: d,
    popperEscapeOffsets: p,
    isReferenceHidden: g,
    hasPopperEscaped: m
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": g,
    "data-popper-escaped": m
  });
}
const e8 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Q6
};
function t8(e, t, n) {
  var r = Zo(e), o = [fr, dr].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, l = i[0], c = i[1];
  return l = l || 0, c = (c || 0) * o, [fr, no].indexOf(r) >= 0 ? {
    x: c,
    y: l
  } : {
    x: l,
    y: c
  };
}
function n8(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, l = QC.reduce(function(g, m) {
    return g[m] = t8(m, t.rects, i), g;
  }, {}), c = l[t.placement], d = c.x, p = c.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += d, t.modifiersData.popperOffsets.y += p), t.modifiersData[r] = l;
}
const r8 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: n8
};
function o8(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = iE({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const s8 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: o8,
  data: {}
};
function i8(e) {
  return e === "x" ? "y" : "x";
}
function a8(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, l = n.altAxis, c = l === void 0 ? !1 : l, d = n.boundary, p = n.rootBoundary, g = n.altBoundary, m = n.padding, v = n.tether, b = v === void 0 ? !0 : v, x = n.tetherOffset, w = x === void 0 ? 0 : x, j = du(t, {
    boundary: d,
    rootBoundary: p,
    padding: m,
    altBoundary: g
  }), C = Zo(t.placement), E = _l(t.placement), P = !E, k = m0(C), T = i8(k), O = t.modifiersData.popperOffsets, A = t.rects.reference, $ = t.rects.popper, N = typeof w == "function" ? w(Object.assign({}, t.rects, {
    placement: t.placement
  })) : w, R = typeof N == "number" ? {
    mainAxis: N,
    altAxis: N
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, N), z = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (O) {
    if (i) {
      var Z, K = k === "y" ? dr : fr, H = k === "y" ? to : no, q = k === "y" ? "height" : "width", te = O[k], I = te + j[K], F = te - j[H], V = b ? -$[q] / 2 : 0, L = E === Cl ? A[q] : $[q], W = E === Cl ? -$[q] : -A[q], ie = t.elements.arrow, re = b && ie ? h0(ie) : {
        width: 0,
        height: 0
      }, le = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : nE(), me = le[K], oe = le[H], se = zc(0, A[q], re[q]), de = P ? A[q] / 2 - V - se - me - R.mainAxis : L - se - me - R.mainAxis, we = P ? -A[q] / 2 + V + se + oe + R.mainAxis : W + se + oe + R.mainAxis, je = t.elements.arrow && zu(t.elements.arrow), He = je ? k === "y" ? je.clientTop || 0 : je.clientLeft || 0 : 0, Le = (Z = z == null ? void 0 : z[k]) != null ? Z : 0, ot = te + de - Le - He, vt = te + we - Le, zt = zc(b ? fp(I, ot) : I, te, b ? ra(F, vt) : F);
      O[k] = zt, D[k] = zt - te;
    }
    if (c) {
      var Ot, ct = k === "x" ? dr : fr, vn = k === "x" ? to : no, St = O[T], At = T === "y" ? "height" : "width", en = St + j[ct], Bt = St - j[vn], Et = [dr, fr].indexOf(C) !== -1, it = (Ot = z == null ? void 0 : z[T]) != null ? Ot : 0, Lt = Et ? en : St - A[At] - $[At] - it + R.altAxis, Ut = Et ? St + A[At] + $[At] - it - R.altAxis : Bt, yn = b && Et ? L6(Lt, St, Ut) : zc(b ? Lt : en, St, b ? Ut : Bt);
      O[T] = yn, D[T] = yn - St;
    }
    t.modifiersData[r] = D;
  }
}
const l8 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: a8,
  requiresIfExists: ["offset"]
};
function c8(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function u8(e) {
  return e === Lr(e) || !Jr(e) ? v0(e) : c8(e);
}
function d8(e) {
  var t = e.getBoundingClientRect(), n = El(t.width) / e.offsetWidth || 1, r = El(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function f8(e, t, n) {
  n === void 0 && (n = !1);
  var r = Jr(t), o = Jr(t) && d8(t), i = Oi(t), l = Pl(e, o, n), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((es(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  b0(i)) && (c = u8(t)), Jr(t) ? (d = Pl(t, !0), d.x += t.clientLeft, d.y += t.clientTop) : i && (d.x = y0(i))), {
    x: l.left + c.scrollLeft - d.x,
    y: l.top + c.scrollTop - d.y,
    width: l.width,
    height: l.height
  };
}
function p8(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var l = [].concat(i.requires || [], i.requiresIfExists || []);
    l.forEach(function(c) {
      if (!n.has(c)) {
        var d = t.get(c);
        d && o(d);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function g8(e) {
  var t = p8(e);
  return E6.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function h8(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function m8(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Iw = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Vw() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function v8(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? Iw : o;
  return function(c, d, p) {
    p === void 0 && (p = i);
    var g = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Iw, i),
      modifiersData: {},
      elements: {
        reference: c,
        popper: d
      },
      attributes: {},
      styles: {}
    }, m = [], v = !1, b = {
      state: g,
      setOptions: function(C) {
        var E = typeof C == "function" ? C(g.options) : C;
        w(), g.options = Object.assign({}, i, g.options, E), g.scrollParents = {
          reference: fa(c) ? Bc(c) : c.contextElement ? Bc(c.contextElement) : [],
          popper: Bc(d)
        };
        var P = g8(m8([].concat(r, g.options.modifiers)));
        return g.orderedModifiers = P.filter(function(k) {
          return k.enabled;
        }), x(), b.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!v) {
          var C = g.elements, E = C.reference, P = C.popper;
          if (Vw(E, P)) {
            g.rects = {
              reference: f8(E, zu(P), g.options.strategy === "fixed"),
              popper: h0(P)
            }, g.reset = !1, g.placement = g.options.placement, g.orderedModifiers.forEach(function(R) {
              return g.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var k = 0; k < g.orderedModifiers.length; k++) {
              if (g.reset === !0) {
                g.reset = !1, k = -1;
                continue;
              }
              var T = g.orderedModifiers[k], O = T.fn, A = T.options, $ = A === void 0 ? {} : A, N = T.name;
              typeof O == "function" && (g = O({
                state: g,
                options: $,
                name: N,
                instance: b
              }) || g);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: h8(function() {
        return new Promise(function(j) {
          b.forceUpdate(), j(g);
        });
      }),
      destroy: function() {
        w(), v = !0;
      }
    };
    if (!Vw(c, d))
      return b;
    b.setOptions(p).then(function(j) {
      !v && p.onFirstUpdate && p.onFirstUpdate(j);
    });
    function x() {
      g.orderedModifiers.forEach(function(j) {
        var C = j.name, E = j.options, P = E === void 0 ? {} : E, k = j.effect;
        if (typeof k == "function") {
          var T = k({
            state: g,
            name: C,
            instance: b,
            options: P
          }), O = function() {
          };
          m.push(T || O);
        }
      });
    }
    function w() {
      m.forEach(function(j) {
        return j();
      }), m = [];
    }
    return b;
  };
}
var y8 = [F6, s8, V6, k6, r8, J6, l8, N6, e8], b8 = /* @__PURE__ */ v8({
  defaultModifiers: y8
}), x8 = typeof Element < "u", w8 = typeof Map == "function", S8 = typeof Set == "function", j8 = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Jf(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Jf(e[r], t[r]))
          return !1;
      return !0;
    }
    var i;
    if (w8 && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!Jf(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (S8 && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (j8 && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r]))
        return !1;
    if (x8 && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((o[r] === "_owner" || o[r] === "__v" || o[r] === "__o") && e.$$typeof) && !Jf(e[o[r]], t[o[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var C8 = function(t, n) {
  try {
    return Jf(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const E8 = /* @__PURE__ */ ju(C8);
var P8 = [], $l = function(t, n, r) {
  r === void 0 && (r = {});
  var o = y.useRef(null), i = {
    onFirstUpdate: r.onFirstUpdate,
    placement: r.placement || "bottom",
    strategy: r.strategy || "absolute",
    modifiers: r.modifiers || P8
  }, l = y.useState({
    styles: {
      popper: {
        position: i.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), c = l[0], d = l[1], p = y.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(b) {
        var x = b.state, w = Object.keys(x.elements);
        Cr.flushSync(function() {
          d({
            styles: Tw(w.map(function(j) {
              return [j, x.styles[j] || {}];
            })),
            attributes: Tw(w.map(function(j) {
              return [j, x.attributes[j]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), g = y.useMemo(function() {
    var v = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement,
      strategy: i.strategy,
      modifiers: [].concat(i.modifiers, [p, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return E8(o.current, v) ? o.current || v : (o.current = v, v);
  }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, p]), m = y.useRef();
  return Ow(function() {
    m.current && m.current.setOptions(g);
  }, [g]), Ow(function() {
    if (!(t == null || n == null)) {
      var v = r.createPopper || b8, b = v(t, n, g);
      return m.current = b, function() {
        b.destroy(), m.current = null;
      };
    }
  }, [t, n, r.createPopper]), {
    state: m.current ? m.current.state : null,
    styles: c.styles,
    attributes: c.attributes,
    update: m.current ? m.current.update : null,
    forceUpdate: m.current ? m.current.forceUpdate : null
  };
};
const pr = y.forwardRef(function({
  children: t,
  title: n,
  onClose: r,
  icon: o,
  skipOverflow: i,
  shadow: l = !0,
  padding: c = !0,
  border: d = !0,
  round: p = !0,
  className: g,
  classNameBody: m,
  size: v = "m",
  titleClass: b = ce("gs-utl-mb-2 gs-utl-mt-0.5"),
  style: x,
  bg: w,
  ...j
}, C) {
  const E = Qo(o) ? o : {};
  return /* @__PURE__ */ u.jsxs(
    "div",
    {
      ...j,
      ref: C,
      style: x,
      className: ce([
        "gs-utl-card",
        g,
        w || Iv.bg,
        ve.b,
        p && ve.rnd,
        d ? ee.br : ve.bT,
        !i && "gs-utl-overflow-auto",
        l && "gs-utl-shadow-md",
        c && v === "l" && "gs-utl-p-5",
        c && v === "m" && "gs-utl-px-4 gs-utl-py-2",
        c && v === "s" && "gs-utl-px-2 gs-utl-py-1",
        c && v === "xs" && "gs-utl-px-2 gs-utl-py-0.5",
        c && v === "x2s" && "gs-utl-px-0.5"
      ]),
      children: [
        (n || r) && n !== !1 && /* @__PURE__ */ u.jsxs(G, { className: ce("gs-utl-card-title", b), items: "center", children: [
          /* @__PURE__ */ u.jsx(Y, { className: ce("truncate"), grow: !0, children: n }),
          (r || o) && /* @__PURE__ */ u.jsx(
            Y,
            {
              onClick: r,
              className: ce("cursor-pointer transition-opacity opacity-50 hover:gs-utl-opacity-100"),
              children: /* @__PURE__ */ u.jsx(ye, { icon: (Dt(o) ? o : "") || fe.close, size: "18px", ...E })
            }
          )
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: ce("gs-utl-card-body", m), children: t })
      ]
    }
  );
});
var x0 = /* @__PURE__ */ ((e) => (e.canvas = "canvas", e.layers = "layers", e))(x0 || {}), ci = /* @__PURE__ */ ((e) => (e.selectParent = "selectParent", e.duplicate = "duplicate", e.delete = "delete", e.symbolCreate = "symbolCreate", e.symbolDetach = "symbolDetach", e.symbolOverride = "symbolOverride", e.symbolOverrideClear = "symbolOverrideClear", e))(ci || {}), _8 = /* @__PURE__ */ ((e) => (e.select = "select", e.hover = "hover", e.target = "target", e.spacing = "spacing", e))(_8 || {});
class k8 {
  constructor(t) {
    this.isOpen = !1, this.isEnabled = !0, this.items = [], this.coordinates = { x: 0, y: 0 }, this.getItemsForComponent = ua(function* (n, r = {}) {
      var C;
      if (!(n != null && n.em))
        return [];
      const o = n.em.getEditor(), { isSymbol: i, isRoot: l } = o.Components.getSymbolInfo(n), c = !!n.getSymbolOverride(), d = !!n.get("removable"), p = !!n.parent() && !!n.toolbar.length, g = !!n.get("copyable"), m = [
        p && {
          id: ci.selectParent,
          label: "Select parent",
          onClick: () => {
            o.runCommand("core:component-exit", { force: !0 });
          }
        },
        g && {
          id: ci.duplicate,
          label: "Duplicate",
          onClick: () => {
            o.runCommand("tlb-clone");
          }
        },
        !i && d && {
          id: ci.symbolCreate,
          label: "Create Symbol",
          onClick: () => {
            o.runCommand(ke.symbolAdd);
          }
        },
        i && l && {
          id: ci.symbolDetach,
          label: "Detach instance",
          onClick: () => {
            o.runCommand(ke.symbolDetach);
          }
        },
        i && !c && {
          id: ci.symbolOverride,
          label: "Make overridable",
          onClick: () => {
            o.runCommand(ke.symbolOverride, { override: !0 });
          }
        },
        i && c && {
          id: ci.symbolOverrideClear,
          label: "Clear overridable",
          onClick: () => {
            o.runCommand(ke.symbolOverride);
          }
        },
        d && {
          id: ci.delete,
          label: "Delete",
          onClick: () => {
            o.runCommand("core:component-delete");
          }
        }
      ].filter(Boolean), v = n.get("contextMenu"), b = {
        ...r,
        items: m,
        component: n,
        editor: o,
        type: n.get("type") || "default",
        source: r.source || x0.canvas
      }, x = yield Hw(v, b), w = (C = this.store.appEditorStore.sdkComponentsConfig) == null ? void 0 : C.contextMenu;
      return yield Hw(w, {
        ...b,
        items: x
      });
    }), this.store = t, Yn(this, {}, { autoBind: !0 });
  }
  get publicState() {
    return {
      enabled: this.isEnabled
    };
  }
  setPublicState(t) {
    t.enabled !== void 0 && (this.isEnabled = t.enabled);
  }
  *showForComponent(t, n) {
    const r = t == null ? void 0 : t.em;
    if (!r)
      return;
    n.skipSelect || r.selected.hasComponent(t) || r.setSelected(t);
    const o = yield this.getItemsForComponent(t, n);
    o.length && this.show({ ...n, items: o });
  }
  show({ items: t, x: n, y: r, w: o, h: i }) {
    this.isOpen = !0, this.coordinates = { x: n, y: r, w: o, h: i }, this.items = t;
  }
  hide() {
    this.isOpen = !1, setTimeout(this.clear, 101);
  }
  clear() {
    this.items = [], this.coordinates = { x: 0, y: 0 };
  }
}
const Hw = async (e, t) => Ct(e) ? (await e(t)).filter(Boolean) : t.items, w0 = () => Nn().contextMenu;
var aE, Fw = Cr;
aE = Fw.createRoot, Fw.hydrateRoot;
function lE(e, t) {
  y.useEffect(() => {
    const n = "pointerdown", { current: r } = e;
    if (!r || !t.enabled)
      return;
    function o(i) {
      const l = i.target;
      r && l && !r.contains(l) && t.onTrigger(l);
    }
    return document.addEventListener(n, o), () => {
      document.removeEventListener(n, o);
    };
  }, [e.current, t.enabled]);
}
const cE = (e, t) => {
  const { boxRectScreen: n, vwHeight: r, initialPos: o = "top-right", zoomMultiplier: i = 1 } = t, l = o.split("-"), c = l[0], d = l[1], p = c === "top" ? "bottom" : "top", g = d === "right" ? "left" : "right";
  y.useLayoutEffect(() => {
    const m = e.current;
    if (m) {
      const { offsetWidth: v, offsetHeight: b } = m, x = n.y - b, w = n.x + n.width - v, j = n.height + b > r, C = x < 0, E = C && !j ? p : c, P = w < 0 ? g : d;
      if (t.setPos(`${E}-${P}`), j) {
        const k = n.y + n.height, T = k < 0 ? x - k : x;
        m.style.top = C ? `${parseInt(`${-T}`) * i}px` : "";
      } else
        m.style.top = "";
    }
  }, [e.current, n]);
}, uE = (e) => {
  const { ref: t, show: n, node: r, styles: o, update: i, reload: l } = e, c = {
    all: "initial",
    zIndex: "10",
    fontFamily: "inherit",
    ...o
  };
  y.useEffect(() => {
    const d = t.current;
    if (d && n) {
      if (!d.__sh) {
        const m = d.attachShadow({ mode: "closed" });
        d.__sh = aE(m);
      }
      d.__sh.render(r), Object.keys(c).forEach((m) => {
        d.style.setProperty(yO(m), c[m], "important");
      });
      const p = new MutationObserver(l);
      p.observe(d, { attributeFilter: ["style"] });
      const g = new MutationObserver((m) => {
        Array.from(m[0].removedNodes).includes(d) && l();
      });
      return g.observe(d.parentNode, { childList: !0 }), () => {
        p.disconnect(), g.disconnect();
      };
    }
  }, [t.current, n, i]);
}, T8 = "gs-cmp-popover";
function rs({
  children: e,
  handler: t,
  title: n,
  size: r,
  padding: o = !0,
  border: i = !0,
  overlay: l,
  clickAway: c,
  topIcon: d,
  placement: p = "auto",
  offset: g,
  open: m,
  onClose: v,
  buttonAs: b,
  className: x,
  classNameBody: w,
  buttonProps: j = {},
  disabled: C
}) {
  const [E, P] = y.useState(!!m), [k, T] = y.useState(E), [O, A] = y.useState(null), [$, N] = y.useState(null), R = $l(O, $, {
    ...C0({ offset: g }),
    placement: p
  }), z = () => {
    T(!1), v == null || v();
  };
  lE(
    { current: $ },
    {
      onTrigger: z,
      enabled: c && E
    }
  ), y.useEffect(() => {
    T(!!m);
  }, [m]), y.useEffect(() => {
    var K;
    E && ((K = R.update) == null || K.call(R));
  }, [E, R.update]), y.useEffect(() => {
    const K = setTimeout(() => P(k), 10);
    return () => clearTimeout(K);
  }, [k]);
  const D = ce(
    "w-full transition-colors",
    C && "pointer-events-none",
    ...mC({ border: !1, size: "", ...j })
  ), Z = ce([
    "fixed z-20",
    d && "gjs-mt-5",
    r === "s" && "w-full max-w-64",
    r === "sm" && "w-full max-w-sm",
    r === "md" && "w-full max-w-md"
  ]);
  return /* @__PURE__ */ u.jsxs(Cm, { className: ce(T8, "relative flex", x), children: [
    /* @__PURE__ */ u.jsx(Cm.Button, { ref: A, as: b, className: D, children: /* @__PURE__ */ u.jsx("div", { onClick: () => !Rn(m) && !C && T(!E), children: t }) }),
    E && l && /* @__PURE__ */ u.jsx("div", { onClick: z, className: ce("z-10 fixed inset-0") }),
    k && /* @__PURE__ */ u.jsx(
      Cm.Panel,
      {
        static: !0,
        className: Z,
        ref: N,
        style: R.styles.popper,
        ...R.attributes.popper,
        children: /* @__PURE__ */ u.jsx(Xo, { as: y.Fragment, show: E, unmount: !1, ...Dv, children: /* @__PURE__ */ u.jsx(pr, { classNameBody: w, title: n, onClose: z, padding: o, border: i, children: typeof e == "function" ? e({ close: z }) : e }) })
      }
    )
  ] });
}
function Bu({ action: e, icon: t, label: n, className: r, items: o, ...i }) {
  const l = y.useRef(null), [c, d] = y.useState(), p = l.current, g = ce([
    r,
    "gs-utl-last:border-b-0 gs-utl-gap-2 gs-utl-select-none",
    ee.br,
    tt.xy,
    ve.bb,
    i.disabled && nt.disabled,
    ...e ? [ee.hBgH, "gs-utl-cursor-pointer"] : ["gs-utl-cursor-default"]
  ]), m = (b) => Ct(e) && e({ event: b });
  y.useEffect(() => {
    if (!p)
      return;
    const b = setTimeout(() => d(p.getBoundingClientRect()), i.active ? 0 : pC);
    return () => clearTimeout(b);
  }, [p, i.active]);
  const v = () => {
    var b;
    return (b = i.onActive) == null ? void 0 : b.call(i);
  };
  return /* @__PURE__ */ u.jsxs(G, { ref: l, items: "center", nowrap: !0, className: g, onClick: m, onPointerEnter: v, children: [
    t && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ye, { icon: t, size: Ee.s }) }),
    /* @__PURE__ */ u.jsx(Y, { className: ce(i.classNameLabel, nt.txtEllips), grow: !0, children: n }),
    !!(o != null && o.length) && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ye, { icon: fe.chevronRight, size: Ee.s, className: ce("-gs-utl-mr-2") }) }),
      c && i.active && /* @__PURE__ */ u.jsx(vE, { items: o, x: c.left, y: c.top, w: c.width, h: c.height, open: !0 })
    ] })
  ] });
}
function wi({
  className: e,
  as: t = "label",
  bold: n,
  m: r = "gjs-mb-1",
  size: o = "m",
  capitalize: i = !0,
  children: l,
  tip: c,
  onClear: d,
  ...p
}) {
  const g = t, m = !!d;
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */ u.jsxs(
      g,
      {
        className: B(
          e,
          r,
          m && ee.tAo,
          i && "gs-utl-capitalize",
          n && "gs-utl-font-semibold",
          o === "s" && "gs-utl-text-sm",
          c || m ? "gs-utl-flex gs-utl-gap-2 gs-utl-items-center" : "gs-utl-block"
        ),
        ...m && { htmlFor: "" },
        ...p,
        children: [
          !!c && /* @__PURE__ */ u.jsx(
            _n,
            {
              classNameWrp: "gs-utl-normal-case gs-utl-whitespace-normal",
              classNameContent: "gs-utl-max-w-60",
              title: c,
              children: /* @__PURE__ */ u.jsx(ye, { icon: fe.information, size: Ee.s2x })
            }
          ),
          l,
          m && /* @__PURE__ */ u.jsx(
            Qt,
            {
              title: "Clear value",
              onClick: d,
              icon: { icon: fe.close, size: Ee.s2x },
              variant: "out-clear",
              border: !1,
              size: "",
              block: !0
            }
          )
        ]
      }
    )
  );
}
var dE = /* @__PURE__ */ ((e) => (e.primary = "primary", e.outline = "outline", e.shallow = "shallow", e))(dE || {}), fE = /* @__PURE__ */ ((e) => (e.none = "", e.x2s = "x2s", e.xs = "xs", e.s = "s", e.m = "m", e.lg = "lg", e))(fE || {});
const O8 = "gs-cmp-button", Xp = y.memo(
  xe(function({
    classNameBtn: t,
    className: n,
    children: r,
    tooltip: o,
    variant: i,
    onClick: l,
    editorEvents: c,
    label: d,
    size: p,
    icon: g,
    active: m,
    buttonType: v,
    disabled: b,
    ...x
  }) {
    const { editor: w } = Re(), [j, C] = y.useState(() => ({
      disabled: b,
      variant: i,
      active: m,
      className: n,
      classNameBtn: t,
      tooltip: o,
      icon: g,
      size: p,
      label: d
    })), E = j.variant, P = E === "outline", k = E === "primary" ? "pr" : P ? "out-clear" : void 0, T = j.label, O = (A) => {
      w && (l == null || l({ event: A, editor: w, state: j, setState: ($) => C((N) => ({ ...N, ...$ })) }));
    };
    return y.useEffect(() => {
      if (!c || !w)
        return;
      const A = Object.keys(c).reduce(
        (N, R) => (N[R] = (z = {}) => {
          c[R]({
            fromEvent: z,
            editor: w,
            state: j,
            setState: (D) => C((Z) => ({ ...Z, ...D }))
          });
        }, N),
        {}
      ), $ = Object.keys(A);
      return $.forEach((N) => w.on(N, A[N])), () => {
        $.forEach((N) => w.off(N, A[N]));
      };
    }, [w, j]), /* @__PURE__ */ u.jsx(
      Qt,
      {
        title: j.tooltip,
        className: B(O8, j.classNameBtn),
        classNameWrp: j.className,
        variant: k,
        icon: j.icon,
        active: j.active,
        size: j.size,
        disabled: j.disabled,
        onClick: O,
        border: P,
        type: v,
        block: !0,
        ...x,
        children: T ? Ct(T) ? T({ editor: w }) : T : r
      }
    );
  })
);
var Zp = /* @__PURE__ */ ((e) => (e.m = "m", e.s = "s", e))(Zp || {});
const pE = "gs-input-field", pp = (e) => Rn(e) ? e : "", Uu = (e = {}) => B("gs-utl-w-full", ee.bgTr, wl.inputText, e.disabled && ee.txtLowEmphasis), S0 = ({ size: e = "m" } = {}) => B(
  "gs-input-container gs-utl-w-full",
  ee.bg,
  ve.b,
  ve.rnd,
  ee.br,
  e === "m" && tt.xy,
  e === "s" && "gs-utl-px-3 gs-utl-py-1"
), Li = ({
  className: e,
  style: t,
  row: n
}) => ({
  className: B(
    e,
    "gs-utl-w-full gs-utl-flex",
    n ? `${pE}--row gs-utl-gap-2 gs-utl-items-center` : "gs-utl-flex-col gs-utl-gap-1"
  ),
  style: t
}), Eo = (e) => {
  const {
    as: t,
    size: n = "m",
    label: r,
    description: o,
    hasClear: i,
    onChange: l,
    tip: c,
    row: d,
    afterLabel: p,
    afterLabelButtons: g
  } = e, m = !!r, v = !!o, b = i != null && i(e) ? () => l == null ? void 0 : l("") : void 0;
  if (!m && !(g != null && g.length) && !v)
    return null;
  const x = /* @__PURE__ */ u.jsx(u.Fragment, { children: m && /* @__PURE__ */ u.jsx(
    wi,
    {
      as: t,
      className: "gs-utl-w-full",
      size: n,
      tip: v ? void 0 : c,
      onClear: b,
      m: "",
      children: r
    }
  ) }), w = p || g != null && g.length ? /* @__PURE__ */ u.jsxs(G, { gap: "s", items: "center", nowrap: !0, children: [
    p,
    g == null ? void 0 : g.map((j, C) => /* @__PURE__ */ u.jsx(Xp, { ...j }, j.id ?? C))
  ] }) : null;
  return /* @__PURE__ */ u.jsxs(G, { className: B("gs-label-field-container", d && "gs-utl-whitespace-nowrap"), col: !0, children: [
    w ? /* @__PURE__ */ u.jsxs(G, { gap: "s", items: "center", nowrap: !0, children: [
      x,
      w
    ] }) : x,
    v && /* @__PURE__ */ u.jsx(wi, { size: n, tip: c, as: "span", className: B(ee.txtLowEmphasis), capitalize: !1, children: o })
  ] });
}, jt = y.forwardRef(function(t, n) {
  const {
    className: r,
    value: o,
    type: i,
    placeholder: l,
    required: c,
    disabled: d,
    readOnly: p,
    name: g,
    onInput: m,
    onChange: v,
    onBlur: b,
    labelAs: x
  } = t, [w, j] = y.useState(pp(o)), C = Uu(t), E = y.useRef(null);
  y.useImperativeHandle(n, () => E.current, []), y.useEffect(() => {
    j(pp(o));
  }, [o]);
  const P = ($, N) => {
    v == null || v($, N);
  }, k = ($) => {
    const { key: N } = $;
    switch (N) {
      case "Escape":
        return j(o);
      case "Enter":
        return P(w);
    }
  }, T = () => {
    P(w), b == null || b();
  }, O = ($) => {
    const N = $.target.value;
    j(N), m == null || m(N);
  }, A = Li({ ...t, className: B(pE, r) });
  return /* @__PURE__ */ u.jsxs("div", { ...A, ref: E, children: [
    /* @__PURE__ */ u.jsx(Eo, { ...t, as: x }),
    /* @__PURE__ */ u.jsxs(G, { className: S0(t), items: "center", gap: "x2s", children: [
      t.beforeInput,
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(
        "input",
        {
          className: C,
          name: g,
          value: w,
          onChange: O,
          placeholder: l,
          required: c,
          onBlur: T,
          onKeyDown: k,
          readOnly: p,
          disabled: d,
          type: i
        }
      ) }),
      t.afterInput
    ] })
  ] });
}), L8 = (e, t) => e.filter((n) => n.id === t)[0] || null, gE = (e, t) => (e == null ? void 0 : e.id) === (t == null ? void 0 : t.id), M8 = (e, t) => e.label.toLowerCase().indexOf(t.toLowerCase()) >= 0, hE = ce("cursor-default select-none focus:gs-utl-outline-none", "z-20 max-h-full"), j0 = {
  strategy: "fixed",
  placement: "bottom",
  modifiers: [
    {
      name: "offset",
      options: { offset: [0, 5] }
    },
    {
      name: "flip",
      options: { fallbackPlacements: ["top"] }
    }
  ]
};
function zw(e) {
  var i;
  const { option: t, active: n, selected: r } = e, o = ((i = e.isSelected) == null ? void 0 : i.call(e)) || !0;
  return /* @__PURE__ */ u.jsxs(G, { items: "center", className: ce([tt.xy, n && Iv.bgH]), children: [
    /* @__PURE__ */ u.jsx(Y, { className: ce("truncate"), grow: !0, children: t.label }),
    /* @__PURE__ */ u.jsx(Y, { className: ce("gjs-pl-2"), children: gE(t, r) && o && /* @__PURE__ */ u.jsx(ye, { className: ce(ee.tA), icon: fe.check, size: Ee.s }) })
  ] });
}
const A8 = "gs-select-field";
function Bw({ option: e }) {
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    e.icon && /* @__PURE__ */ u.jsx(ye, { ...Dt(e.icon) ? { icon: e.icon, size: Ee.s2x } : e.icon }),
    /* @__PURE__ */ u.jsx(Y, { className: ce("truncate"), grow: !0, children: e.content || e.label })
  ] });
}
function Ze(e) {
  const {
    value: t,
    onChange: n,
    onBlur: r,
    onFocus: o,
    handlerSelected: i,
    label: l,
    options: c,
    includeEmpty: d,
    className: p,
    search: g,
    open: m,
    caret: v = fe.chevronDown,
    size: b = "m",
    border: x,
    emptyState: w = "- Select an option -",
    name: j,
    required: C,
    disabled: E,
    classNameContainer: P,
    autoFocus: k,
    labelAs: T,
    hideCaret: O
  } = e, [A, $] = y.useState(null), [N, R] = y.useState(null), [z, D] = y.useState(""), { styles: Z, attributes: K } = $l(A, N, j0), H = typeof g == "object" ? g.onChange : void 0, q = [...c].filter((oe) => g ? H || M8(oe, z) : oe), te = g && (typeof g == "object" && g.value || z), I = te && q.length ? q[0] : L8(q, t), F = (oe) => n(oe.id), V = { id: null, label: w }, L = (I == null ? void 0 : I.content) || (I == null ? void 0 : I.label), W = I ? i ? i(I) : I.icon ? /* @__PURE__ */ u.jsx(G, { items: "center", gap: "s", children: /* @__PURE__ */ u.jsx(Bw, { option: I }) }) : L : i ? i(V) : w;
  d && q.unshift(V);
  const ie = (oe) => {
    const { value: se } = oe.target, de = se.trim();
    switch (oe.key) {
      case "Escape":
        n(null);
        break;
      case "Enter":
        n((q.length ? q[0].id : de) || null);
        break;
      case " ":
        yl(oe);
        break;
    }
  }, re = B("gs-utl-w-full gs-utl-text-left gs-utl-cursor-pointer gs-utl-block", ve.rnd, lu.focus), le = () => {
    r == null || r();
  }, me = Li({
    ...e,
    className: B(A8, P, "gs-utl-relative", b.includes("s") && "gs-utl-text-xs")
  });
  return /* @__PURE__ */ u.jsx(Tc, { value: I, onChange: F, disabled: E, children: ({ open: oe }) => /* @__PURE__ */ u.jsxs("div", { ...me, children: [
    l && /* @__PURE__ */ u.jsx(Tc.Label, { as: T, className: e.classNameLabel, children: /* @__PURE__ */ u.jsx(Eo, { as: "span", ...e }) }),
    j && /* @__PURE__ */ u.jsx(
      "input",
      {
        type: "input",
        name: j,
        value: (I == null ? void 0 : I.id) ?? "",
        onChange: () => {
        },
        className: ce("gs-utl-w-[1px] gs-utl-h-[1px] gs-utl-opacity-[0.001] gs-utl-absolute"),
        required: C,
        disabled: E
      }
    ),
    /* @__PURE__ */ u.jsx(Tc.Button, { ref: $, className: re, tabIndex: g ? -1 : void 0, children: g ? /* @__PURE__ */ u.jsx(
      "input",
      {
        autoFocus: k,
        value: typeof g == "object" && g.value || z,
        className: B([p, "gs-utl-w-full", ve.rnd, lu.focus, tt.xyS]),
        onChange: (se) => {
          D(se.target.value), H == null || H(se.target.value);
        },
        onKeyDown: ie,
        onClick: yl,
        onBlur: le,
        onFocus: o
      }
    ) : /* @__PURE__ */ u.jsx(
      pr,
      {
        border: x,
        size: b,
        title: W,
        icon: O ? { className: "gs-utl-opacity-0 gs-utl-pointer-events-none" } : v,
        shadow: !1,
        className: ce(p),
        titleClass: "",
        disabled: E
      }
    ) }),
    /* @__PURE__ */ u.jsx(
      Tc.Options,
      {
        static: m,
        className: hE,
        ref: R,
        style: Z.popper,
        ...K.popper,
        children: /* @__PURE__ */ u.jsxs(
          pr,
          {
            padding: !1,
            className: ce("h-full"),
            style: { minWidth: `${A == null ? void 0 : A.offsetWidth}px`, maxHeight: 200 },
            children: [
              !q.length && g && g !== !0 && /* @__PURE__ */ u.jsx("div", { className: ce(tt.xy), children: g.empty }),
              q.map((se, de) => /* @__PURE__ */ u.jsx(Tc.Option, { value: se, children: ({ active: we }) => /* @__PURE__ */ u.jsxs(G, { items: "center", gap: "s", className: ce([se.className, tt.xy, we && Iv.bgH]), children: [
                /* @__PURE__ */ u.jsx(Bw, { option: se }),
                /* @__PURE__ */ u.jsx(Y, { className: ce("gjs-pl-2"), children: gE(se, I) && !te && /* @__PURE__ */ u.jsx(ye, { className: ce(ee.tA), icon: fe.check, size: Ee.s }) })
              ] }) }, de))
            ]
          }
        )
      }
    )
  ] }) });
}
const Uw = ns() && document.body, C0 = (e = {}) => ({
  ...j0,
  placement: "right-start",
  modifiers: [
    {
      name: "offset",
      options: { offset: e.offset || [0, 5] }
    },
    {
      name: "flip",
      options: { boundary: e.boundary ?? Uw }
    },
    {
      name: "preventOverflow",
      options: { boundary: e.boundary ?? Uw }
    }
  ]
}), mE = C0(), mf = "gs-ctx-menu-list", vE = xe(function({ open: t, items: n, x: r, y: o, w: i, h: l }) {
  const c = w0(), [d, p] = y.useState(), [g, m] = y.useState(null), v = y.useMemo(() => ({ getBoundingClientRect: () => new DOMRect(r, o, i, l) }), [r, o, i, l, t]), { styles: b, attributes: x } = $l(v, g, mE), w = B(`${mf}-wrp gs-utl-z-20`), j = B(`${mf} gs-utl-z-20`), C = B(`${mf}-body gs-utl-max-w-56`), E = B(`${mf}-item`), P = "gs-utl-max-w-40", k = (T) => {
    const { action: O, onClick: A } = T;
    if (O || A)
      return ($) => {
        const N = {
          editor: c.store.appEditorStore.editor,
          ...$
        };
        Ct(O) ? (O(N), c.hide()) : Ct(A) && (A(N), c.hide());
      };
  };
  return /* @__PURE__ */ u.jsx("div", { className: w, ref: m, style: b.popper, ...x.popper, children: /* @__PURE__ */ u.jsx(Xo, { show: !!t, ...Au, unmount: !1, children: /* @__PURE__ */ u.jsx(pr, { padding: !1, className: j, classNameBody: C, children: n.map((T, O) => /* @__PURE__ */ y.createElement(
    Bu,
    {
      ...T,
      key: T.id ?? O,
      className: E,
      classNameLabel: P,
      action: k(T),
      onActive: () => p(T),
      active: d === T
    }
  )) }) }) });
}), km = "gs-cmp-tooltip";
function _n({
  className: e,
  classNameWrp: t,
  classNameContent: n,
  children: r,
  title: o,
  onClick: i,
  inline: l,
  size: c
}) {
  const [d, p] = y.useState(!1), [g, m] = y.useState(!1), v = Rn(c), [b, x] = y.useState(null), [w, j] = y.useState(null), C = $l(b, w, {
    ...C0(),
    placement: "bottom"
  });
  y.useEffect(() => {
    var k;
    d && ((k = C.update) == null || k.call(C));
  }, [d, C.update]), y.useEffect(() => {
    const k = setTimeout(() => p(g), 10);
    return () => clearTimeout(k);
  }, [g]);
  const E = B(`${km}-target`, !l && "gs-utl-block", e, !i && "gs-utl-cursor-auto"), P = B(
    `${km}-content`,
    n,
    "gs-utl-fixed gs-utl-z-30 gs-utl-text-sm",
    !v && !n && "gs-utl-whitespace-nowrap",
    c === "s" && "gs-utl-w-60"
  );
  return /* @__PURE__ */ u.jsxs("div", { className: B(km, "gs-utl-relative", t), children: [
    /* @__PURE__ */ u.jsx(
      "span",
      {
        ref: x,
        className: E,
        onMouseEnter: () => o && m(!0),
        onMouseLeave: () => m(!1),
        children: /* @__PURE__ */ u.jsx(
          "div",
          {
            className: B(l && "gs-utl-inline-block"),
            onClick: () => {
              m(!1), i == null || i();
            },
            children: r
          }
        )
      }
    ),
    !!g && /* @__PURE__ */ u.jsx(
      "div",
      {
        className: P,
        ref: j,
        style: C.styles.popper,
        ...C.attributes.popper,
        children: /* @__PURE__ */ u.jsx(Xo, { show: !!d, unmount: !1, ...Dv, children: /* @__PURE__ */ u.jsx(pr, { className: yw.txt, bg: yw.bg, size: "s", border: !1, children: o }) })
      }
    )
  ] });
}
function Qt({ children: e, title: t, classNameWrp: n, ...r }) {
  return /* @__PURE__ */ u.jsx(_n, { title: t, classNameWrp: n, children: /* @__PURE__ */ u.jsx(ut, { ...r, children: e }) });
}
var Gn = /* @__PURE__ */ ((e) => (e.Info = "info", e.Error = "error", e.Success = "success", e.Warning = "warning", e))(Gn || {});
const R8 = {
  [Gn.Info]: ee.bgA,
  [Gn.Error]: "bg-red-500",
  [Gn.Success]: "bg-green-500",
  [Gn.Warning]: "bg-orange-400"
}, N8 = Q.forwardRef(function(t, n) {
  const r = {
    [Gn.Info]: fe.informationVariant,
    [Gn.Error]: fe.fire,
    [Gn.Success]: fe.checkBold,
    [Gn.Warning]: fe.alertRhombus
  }, { children: o, className: i, content: l, id: c, buttons: d = [], variant: p = Gn.Info, autoHideTimeout: g = 3e3 } = t, m = y.useRef(null), v = y.useRef(), b = r[p], x = R8[p];
  y.useImperativeHandle(n, () => m.current, []);
  const w = () => {
    var P;
    return (P = t.onDismiss) == null ? void 0 : P.call(t, c);
  }, j = () => {
    g && (v.current = setTimeout(w, g));
  }, C = () => v.current && clearTimeout(v.current);
  y.useEffect(() => (j(), C), []);
  const E = l || o;
  return /* @__PURE__ */ u.jsx(
    pr,
    {
      className: ge(i, "overflow-hidden relative"),
      ref: m,
      onPointerEnter: C,
      onPointerLeave: j,
      children: /* @__PURE__ */ u.jsxs(G, { space: "m", items: "center", className: ge(tt.y), children: [
        /* @__PURE__ */ u.jsx(Y, { className: ge(x, ve.pill, "text-white gjs-p-1"), children: /* @__PURE__ */ u.jsx(ye, { icon: b, size: Ee.s }) }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, className: ge("gjs-pr-3"), children: /* @__PURE__ */ u.jsxs(G, { col: !0, space: "xs", children: [
          /* @__PURE__ */ u.jsx(Y, { className: ge("text-lg font-medium leading-6"), children: t.header }),
          E && /* @__PURE__ */ u.jsx(Y, { className: ge(ee.txtLowEmphasis), children: E }),
          !!d.length && /* @__PURE__ */ u.jsx(G, { space: "m", justify: "end", children: d.map(({ id: P, ...k }) => /* @__PURE__ */ u.jsx(ut, { ...k }, P)) })
        ] }) }),
        /* @__PURE__ */ u.jsx(Y, { className: ge("absolute top-1 right-1"), children: /* @__PURE__ */ u.jsx(Qt, { onClick: w, border: !1, children: /* @__PURE__ */ u.jsx(ye, { icon: fe.close, size: Ee.s }) }) })
      ] })
    }
  );
}), $8 = xe(
  Q.forwardRef(function({ className: t, toasts: n, onDismiss: r, ...o }, i) {
    const l = UO({});
    return (
      // For some reason with Grid, automate flickers
      /* @__PURE__ */ u.jsx("div", { className: ge(t, "w-80 gs-utl-z-30"), ...o, ref: l, children: n.map((c) => /* @__PURE__ */ u.jsx(N8, { ...c, className: ge("gjs-mb-2"), onDismiss: r }, c.uuid || c.id)) })
    );
  })
);
var U1 = /* @__PURE__ */ ((e) => (e.self = "self", e.cloud = "cloud", e))(U1 || {}), oa = /* @__PURE__ */ ((e) => (e.image = "image", e.video = "video", e))(oa || {}), po = /* @__PURE__ */ ((e) => (e.componentOutline = "componentOutline", e.preview = "preview", e.fullscreen = "fullscreen", e.showCode = "showCode", e.showImportCode = "showImportCode", e.clearCanvas = "clearCanvas", e.store = "store", e.undo = "undo", e.redo = "redo", e))(po || {}), kn = /* @__PURE__ */ ((e) => (e.variable = "data-variable", e.condition = "data-condition", e.conditionTrue = "data-condition-true-content", e.conditionFalse = "data-condition-false-content", e.collection = "data-collection", e.collectionItem = "data-collection-item", e))(kn || {}), D8 = /* @__PURE__ */ ((e) => (e.text = "text", e.number = "number", e.color = "color", e.selectFont = "selectFont", e.select = "select", e.radio = "radio", e))(D8 || {}), tl = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom", e))(tl || {}), nl = /* @__PURE__ */ ((e) => (e.popover = "popover", e.absolute = "absolute", e.static = "static", e.dialog = "dialog", e))(nl || {}), Xe = /* @__PURE__ */ ((e) => (e.web = "web", e.email = "email", e.document = "document", e.react = "react", e))(Xe || {}), ir = /* @__PURE__ */ ((e) => (e.components = "Components", e.rte = "Rich Text Editor", e.canvas = "Canvas", e.layout = "Layout", e.assetProviders = "Asset Providers", e))(ir || {}), xo = /* @__PURE__ */ ((e) => (e.dark = "dark", e.light = "light", e.auto = "auto", e))(xo || {}), W1 = /* @__PURE__ */ ((e) => (e.browser = "browser", e.self = "self", e.cloud = "cloud", e))(W1 || {});
const E0 = () => {
  const { baseApiUrl: e } = Jc();
  return `${e}/assets/sdk`;
}, I8 = (e) => `${E0()}/${e}`, V8 = async (e, t, n) => {
  const r = await ts.get(E0(), {
    params: { projectId: t, identityId: n, d: window.location.hostname, licenseKey: e }
  });
  return ((r == null ? void 0 : r.result) ?? []).map(({ asset: o, cdnUrl: i }) => ({
    ...o,
    size: parseInt(o.size),
    src: i
  }));
}, H8 = async (e, t, n, r) => {
  const o = await ts.post(E0(), {
    body: JSON.stringify({ fileMetadata: e, projectId: n, identityId: r }),
    params: { d: window.location.hostname, licenseKey: t }
  });
  return o == null ? void 0 : o.result;
}, F8 = async (e, t) => await ts.put(t, {
  body: e,
  rawText: !0
}), z8 = async (e, t, n, r) => Promise.all(
  e.map(
    (o) => H8(
      // don't send the whole file, just the metadata
      { name: o.name, size: o.size, type: o.type },
      t,
      n,
      r
    ).then(async (i) => {
      if (!i)
        throw new Error("No asset");
      const { asset: l, cdnUrl: c, uploadUrl: d } = i, p = await F8(o, d);
      if (p instanceof Error)
        throw console.error(p), new Error("Upload failed");
      return {
        ...l,
        size: parseInt(l.size),
        src: c,
        type: oa.image
      };
    })
  )
), B8 = async (e, t, n, r) => {
  const o = await ts.delete(I8(e), {
    body: JSON.stringify({ projectId: n, identityId: r }),
    params: { d: window.location.hostname, licenseKey: t }
  });
  return o == null ? void 0 : o.result;
}, Ww = async (e, t, n, r) => Promise.all(e.map((o) => B8(o.id || o.src, t, n, r)));
function Es(e, t, n) {
  let r, o, i, l, c;
  const d = t === void 0 ? 100 : t;
  function p() {
    const m = Date.now() - l;
    m < d && m >= 0 ? r = setTimeout(p, d - m) : (r = null, n || (c = e.apply(i, o), i = o = null));
  }
  const g = function() {
    i = this, o = arguments, l = Date.now();
    const m = n && !r;
    return r || (r = setTimeout(p, d)), m && (c = e.apply(i, o), i = o = null), c;
  };
  return g.clear = function() {
    r && (clearTimeout(r), r = null);
  }, g.flush = function() {
    r && (c = e.apply(i, o), i = o = null, clearTimeout(r), r = null);
  }, g;
}
const fu = (e) => e.replaceAll('"', "").replaceAll("'", ""), pa = (e) => e.includes(",") ? e : /\s/.test(e) ? `'${fu(e)}'` : fu(e), Gw = (e, t, n) => ({ family: e, variant: t, ...n }), Uc = (e, t) => {
  e = pa(e);
  const { menuVariant: n, variants: r } = t;
  return {
    family: e,
    familyLabel: fu(e),
    menuVariant: n && Gw(
      pa(`menuFont-${fu(e)}`),
      "regular",
      n
    ),
    variants: Object.assign(
      {},
      ...Object.entries(r).map(([o, i]) => ({
        [o]: Gw(e, o, i)
      }))
    )
  };
}, P0 = (e, t) => {
  var c;
  const n = Uc(e.family, e), r = n.menuVariant ?? ((c = Object.values(n.variants)) == null ? void 0 : c[0]);
  if (!r)
    return "Arial, Helvetica, sans-serif";
  const { source: o, descriptors: i } = r, l = fu(r.family);
  if (!t) {
    const d = new FontFace(l, `url("${o}")`, i), p = Array.from(document.fonts.values()).filter((g) => g.family === l);
    for (const g of p)
      document.fonts.delete(g);
    document.fonts.add(d), d.load().catch(() => {
    });
  }
  return pa(l);
}, Ro = ", sans-serif", Kw = [
  "Arial, Helvetica" + Ro,
  "Arial Black, Gadget" + Ro,
  "Brush Script MT" + Ro,
  "Comic Sans MS, cursive" + Ro,
  "Courier New, Courier, monospace",
  "Georgia, serif",
  "Helvetica" + Ro,
  "Impact, Charcoal" + Ro,
  "Lucida Sans Unicode, Lucida Grande" + Ro,
  "Tahoma, Geneva" + Ro,
  "Times New Roman, Times, serif",
  "Trebuchet MS, Helvetica" + Ro,
  "Verdana, Geneva" + Ro
].map((e) => ({ id: e, label: e.split(",")[0] })), U8 = String.raw, ys = (e, t) => {
  if (!t)
    return "";
  const n = e[0], r = e[1];
  return `${n}${t}${r}`;
}, W8 = ({ family: e, source: t, descriptors: n }) => {
  const {
    display: r,
    ascentOverride: o,
    descentOverride: i,
    featureSettings: l,
    lineGapOverride: c,
    stretch: d,
    style: p,
    unicodeRange: g,
    weight: m
  } = n ?? {}, v = [
    ys`font-ascent-override: ${o};`,
    ys`font-display: ${r};`,
    ys`font-descent-override: ${i};`,
    ys`font-feature-settings: ${l};`,
    ys`font-line-gap-override: ${c};`,
    ys`font-stretch: ${d};`,
    ys`font-style: ${p};`,
    ys`font-unicode-range: ${g};`,
    ys`font-weight: ${m};`
  ].filter(Boolean);
  return U8`
    @font-face {
      font-family: ${e};
      src: url('${t}');
      ${v.join(`
`)}
    }
  `;
}, yE = (e = {}) => {
  const t = Object.entries(e).map(([r, o]) => Uc(r, o));
  let n = "";
  for (const r of t)
    for (const o of Object.values(r.variants))
      n += W8(o) + `
`;
  return n.trim();
}, G1 = "data-project-fonts", K1 = "true", G8 = `${G1}="${K1}"`, bE = (e = {}) => {
  const t = yE(e);
  return t ? `<style ${G8}>
${t}
</style>` : "";
}, K8 = (e) => e.sort((t, n) => t.familyLabel < n.familyLabel ? -1 : t.familyLabel > n.familyLabel ? 1 : 0), q8 = (e) => e.sort((t, n) => t.id < n.id ? -1 : t.id > n.id ? 1 : 0), qw = (e) => !!e.id, Xa = (e) => (t) => (t.tagName || "").toLowerCase() === e, Vo = (...e) => e.map((t) => `[data-gjs-type="${t}"]`).join(","), Y8 = (e, ...t) => {
  var n;
  return t.indexOf((n = e == null ? void 0 : e.tagName) == null ? void 0 : n.toUpperCase()) >= 0;
}, ul = (e, ...t) => {
  var n;
  return !!e && t.indexOf((n = e.tagName) == null ? void 0 : n.toLowerCase()) >= 0;
}, Si = (e, t) => {
  var n;
  return (n = e == null ? void 0 : e.classList) == null ? void 0 : n.contains(t);
}, Wu = (e, t) => {
  var n;
  return !!((n = e == null ? void 0 : e.hasAttribute) != null && n.call(e, t));
}, Gu = (e, t) => {
  const n = e.Blocks.get(t);
  return n ? n.collection.indexOf(n) : -1;
}, X8 = (e) => e.replace(/[^a-z0-9.]/gi, "_").toLowerCase(), q1 = (e, t, n = "html") => {
  const { Pages: r } = e, o = ar({ page: t, key: "slug" }) ?? "";
  return `${r.getMain() === t ? "index" : Nv(o || t.getName())}.${n}`;
}, Z8 = (e, t) => {
  const { toolbar: n } = e;
  n.some((o) => o.id === t.id) || (n.unshift(t), e.set("toolbar", [...n]));
}, gp = "custom-html-body", hp = "data-custom-html-body", Yw = "data-global-custom-html-head", Xw = "data-global-custom-html-body", Zw = "global", J8 = function(e, t) {
  const n = (o) => {
    if (!o)
      return e.em.logError("loadGlobalHead: document not found");
    const i = Y1(t.appStore);
    let l = o.querySelector(`[${Yw}]`);
    l || (l = o.createElement("div"), l.setAttribute(Yw, "true"), o.head.insertBefore(l, o.head.firstChild));
    const c = bE(i.fonts), d = i.customCodeHead, p = [c, d].filter((g) => !!g).join(`
`);
    l.innerHTML = p, cw(l);
  }, r = (o) => {
    if (!o)
      return e.em.logError("loadGlobalBody: document not found");
    const i = Y1(t.appStore);
    let l = o.querySelector(`[${Xw}]`);
    if (!l) {
      l = o.createElement("div"), l.setAttribute(Xw, "true");
      const c = o.querySelector('[data-gjs-type="wrapper"]');
      c == null || c.appendChild(l);
    }
    l.innerHTML = i.customCodeBody || "", cw(l);
  };
  e.on(e.Canvas.events.frameLoad, (o) => {
    var i;
    return n((i = o.el.contentWindow) == null ? void 0 : i.document);
  }), e.on(e.Canvas.events.frameLoadBody, (o) => {
    var i;
    return r((i = o.el.contentWindow) == null ? void 0 : i.document);
  }), e.on(kr.pageSettingsUpdate, (o) => {
    var l, c;
    if (o.page)
      return;
    const i = (c = (l = e.Canvas.getFrames()[0]) == null ? void 0 : l.view) == null ? void 0 : c.getDoc();
    n(i), r(i);
  }), e.Components.addType(gp, {
    isComponent: (o) => Wu(o, hp),
    model: {
      defaults: {
        attributes: { [hp]: !0 },
        locked: !0,
        layerable: !1
      },
      toHTML: () => ""
    }
  }), e.on(e.events.projectLoad, () => {
    const { appStore: o } = t, { globalPageSettings: i } = o.projectDataCustom;
    let l = (i == null ? void 0 : i.customCodeHead) || "", c = (i == null ? void 0 : i.customCodeBody) || "";
    e.Pages.getAll().forEach((d) => {
      const p = d.getMainComponent(), g = p.head.components(), m = [];
      g.forEach((x) => {
        x.has(Zw) && m.push(x);
      }), m.forEach((x) => {
        const w = x.toHTML();
        l.includes(w) || (l += w), x.remove();
      });
      const v = [];
      p.findType(gp).forEach((x) => {
        x.has(Zw) && v.push(x);
      }), v.forEach((x) => {
        const w = x.getInnerHTML();
        c.includes(w) || (c += w), x.remove();
      });
    }), (l || c) && o.setProjectDataCustom({
      globalPageSettings: {
        ...i,
        customCodeHead: l,
        customCodeBody: c
      }
    });
  });
}, Jw = (e) => {
  const t = e.getDirtyCount() || 0;
  e.em.set({ changesCount: t + 1 }, {});
}, _0 = (e) => !!e.getSymbolOverride() ? /* @__PURE__ */ u.jsx(ye, { icon: fe.rhombusOutline, size: Ee.s3x }) : /* @__PURE__ */ u.jsx($v, { className: B("gs-cmp-svg-icon gs-utl-w-[16px] gs-utl-fill-current"), svg: e.getIcon() }), xE = (e) => {
  e.getModel().set({
    changesCount: e.getDirtyCount() + 1
  });
}, Q8 = (e) => e && e === e.em.Pages.getMain(), Rt = {
  title: ({ cmp: e }) => e.tagName === "title",
  favicon: ({ cmp: e }) => {
    var t;
    return e.tagName === "link" && ((t = e.attributes.attributes) == null ? void 0 : t.rel) === "icon";
  },
  description: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "description";
  },
  keywords: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "keywords";
  },
  socialTitle: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.property) === "og:title";
  },
  socialImage: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.property) === "og:image";
  },
  socialDescription: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.property) === "og:description";
  },
  charset: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.charset);
  },
  viewport: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "viewport";
  },
  robots: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "robots";
  },
  generator: ({ cmp: e }) => {
    var t;
    return e.tagName === "meta" && ((t = e.attributes.attributes) == null ? void 0 : t.name) === "generator";
  }
}, wE = (e) => {
  for (const t in Rt) {
    const n = t;
    if (Rt[n]({ cmp: e }))
      return n;
  }
}, SE = (e, t, n) => {
  const r = [];
  let o = n;
  return e.getMainComponent().findType(gp).forEach((i) => {
    r.push(i), o = (o || "") + i.getInnerHTML();
  }), { components: r, html: o, changed: o !== t };
}, e$ = (e, t) => {
  const n = { ...t }, r = e.getMainComponent(), { head: o } = r;
  if (o) {
    const l = [], c = o.components();
    c.forEach((p) => {
      Rt.title({ cmp: p }) ? (p.components(t.title), delete n.title) : Rt.favicon({ cmp: p }) ? (p.addAttributes({ href: t.favicon }), delete n.favicon) : Rt.description({ cmp: p }) ? (p.addAttributes({ content: t.description }), delete n.description) : Rt.keywords({ cmp: p }) ? (p.addAttributes({ content: t.keywords }), delete n.keywords) : Rt.socialTitle({ cmp: p }) ? (p.addAttributes({ content: t.socialTitle }), delete n.socialTitle) : Rt.socialDescription({ cmp: p }) ? (p.addAttributes({ content: t.socialDescription }), delete n.socialDescription) : Rt.socialImage({ cmp: p }) ? (p.addAttributes({ content: t.socialImage }), delete n.socialImage) : wE(p) || l.push(p);
    });
    const d = e.em.Parser.parseHtml(`<!DOCTYPE html><html><head>${t.customCodeHead}</head></html>`);
    d.head && (c.remove(l), d.head.components && c.add(d.head.components), delete n.customCodeHead);
  }
  const i = SE(e, n.customCodeBody);
  if (i.changed) {
    const [l, ...c] = i.components;
    (l || r.append({ type: gp })[0]).components(n.customCodeBody), c.forEach((p) => p.remove()), delete n.customCodeBody;
  }
  return e.set("settings", n);
}, t$ = (e) => {
  const t = { ...e.get("settings") ?? {} }, n = e.getMainComponent(), { head: r } = n;
  if (r) {
    const o = [];
    r.components().forEach((i) => {
      const { content: l, href: c } = i.getAttributes({ noClass: !0, noStyle: !0 });
      Rt.title({ cmp: i }) ? t.title = i.getInnerHTML() : Rt.favicon({ cmp: i }) ? t.favicon = c : Rt.description({ cmp: i }) ? t.description = l : Rt.keywords({ cmp: i }) ? t.keywords = l : Rt.socialTitle({ cmp: i }) ? t.socialTitle = l : Rt.socialDescription({ cmp: i }) ? t.socialDescription = l : Rt.socialImage({ cmp: i }) ? t.socialImage = l : wE(i) || o.push(i.toHTML());
    }), o.length && (t.customCodeHead = o.join(`
`));
  }
  return t.customCodeBody = SE(e, t.customCodeBody).html, t;
}, n$ = (e, t) => {
  e.getModel().set("customData", { ...kl(e), ...t });
}, kl = (e) => e.getModel().get("customData") ?? {}, Y1 = (e) => (e == null ? void 0 : e.projectDataCustom.globalPageSettings) ?? {}, ar = (e) => {
  const { page: t, key: n, appEditorStore: r, def: o, defPage: i } = e;
  return t ? t$(t)[n] ?? i : Y1(r)[n] ?? o;
}, oi = (e, t) => {
  const n = e.em.getEditor(), o = kl(n).globalPageSettings || {};
  return ar({ page: e, key: t }) || o[t];
}, Qw = (e, t) => {
  const n = (e == null ? void 0 : e.getName()) ?? "", r = {
    page: e,
    appEditorStore: t,
    def: "",
    pageDef: ""
  };
  return {
    name: n,
    slug: ar({ ...r, key: "slug", defPage: Nv(n) }),
    title: ar({ ...r, key: "title", defPage: n }),
    description: ar({ ...r, key: "description" }),
    favicon: ar({ ...r, key: "favicon" }),
    keywords: ar({ ...r, key: "keywords" }),
    socialTitle: ar({ ...r, key: "socialTitle", defPage: n }),
    socialImage: ar({ ...r, key: "socialImage" }),
    socialDescription: ar({ ...r, key: "socialDescription" }),
    customCodeHead: ar({ ...r, key: "customCodeHead" }),
    customCodeBody: ar({ ...r, key: "customCodeBody" })
  };
}, jE = (e, t) => {
  var n;
  return (n = e.Styles.getSectors().find((r) => !!r.getProperty(t))) == null ? void 0 : n.getProperty(t);
}, r$ = (e, t, n) => {
  const r = jE(e, t);
  return r == null ? void 0 : r.getProperty(n);
};
class eS {
  constructor(t, n) {
    this.assetsStore = t, this.layoutPanelId = n, this.itemLayout = void 0, this.isLoadingAssets = !1, this.typeFilter = void 0, this.searchValue = "", this.customTypes = void 0, this.customProviders = void 0, this.providerFilter = void 0, this.customAssetProps = void 0, this.customPages = void 0, this.totalItems = void 0, this.optionalType = !1, this.optionalProvider = !0, Yn(this, {}, { autoBind: !0 }), this.initTypeFilter(), this.initProviderFilter(), this.initOptionalType(), this.loadAssetsDebounced = Es(this.loadAssets, this.searchDebounceMs);
  }
  get typeFilterOptions() {
    return this.customTypes ?? [];
  }
  get providers() {
    return this.assetsStore.allProviders.map((t) => ({
      ...t,
      types: Array.isArray(t.types) ? t.types : [t.types]
    }));
  }
  get providerFilterOptions() {
    return this.providers.filter(
      (t) => (
        // filter by type
        (!this.typeFilter || t.types.includes(this.typeFilter)) && // filter by customProviders
        (!this.customProviders || this.customProviders.includes(t.id))
      )
    );
  }
  get provider() {
    return this.providers.find((t) => t.id === this.providerFilter);
  }
  get assetPropsFromPages() {
    if (!this.customPages)
      return;
    const t = [];
    for (const n of this.customPages)
      t.push(...n.items);
    return t;
  }
  get assetProps() {
    if (!!!this.assetPropsFromPages && this.isLoadingAssets)
      return [];
    const n = this.customAssetProps ?? this.assetPropsFromPages ?? this.assetsStore.projectAssetProps ?? [];
    return this.typeFilter ? n.filter((r) => r.type === this.typeFilter) : n;
  }
  get onProviderOrProjectDelete() {
    const { provider: t, assetsStore: n } = this;
    return t ? t.onDelete : n.onProjectDelete;
  }
  get t() {
    return this.assetsStore.t;
  }
  get isLoading() {
    return this.assetsStore.isLoadingAssets || this.isLoadingAssets;
  }
  get handleDelete() {
    return this.onProviderOrProjectDelete && this.handleDeleteCallback;
  }
  get shouldLoadNextPage() {
    var n;
    const t = (n = this.customPages) == null ? void 0 : n.at(-1);
    return t ? !t.isLastPage : !1;
  }
  get reloadOnInput() {
    var t, n;
    return ((n = (t = this.provider) == null ? void 0 : t.search) == null ? void 0 : n.reloadOnInput) ?? !1;
  }
  get searchDebounceMs() {
    var t, n;
    return ((n = (t = this.provider) == null ? void 0 : t.search) == null ? void 0 : n.debounceMs) ?? 1e3;
  }
  initOptionalType() {
    this.setOptionalType(!1);
  }
  initOptionalProvider() {
    this.setOptionalProvider(!1);
  }
  initTypeFilter() {
    this.setTypeFilter(oa.image);
  }
  initProviderFilter() {
    var t;
    this.setProviderFilter((t = this.assetsStore.sdkAssetConfig) == null ? void 0 : t.providerId);
  }
  setOptionalType(t) {
    this.optionalType = t;
  }
  setOptionalProvider(t) {
    this.optionalProvider = t;
  }
  setTypeFilter(t) {
    this.typeFilter = t;
  }
  setProviderFilter(t) {
    this.providerFilter = t;
  }
  setSearchValue(t) {
    this.searchValue = t, this.reloadOnInput && this.loadAssetsDebounced();
  }
  setCustomTypes(t) {
    this.customTypes = t;
  }
  setCustomProviders(t) {
    this.customProviders = t;
  }
  setCustomAssetProps(t) {
    this.customAssetProps = t;
  }
  setCustomPages(t) {
    this.customPages = t;
  }
  setItemLayout(t) {
    this.itemLayout = t;
  }
  setIsLoadingAssets(t) {
    this.isLoadingAssets = t;
  }
  selectProjectAssets() {
    this.setCustomAssetProps(void 0), this.setCustomPages(void 0), this.setItemLayout(void 0);
  }
  async loadProviderAssets(t) {
    var c, d, p, g;
    const { assetsStore: n } = this, { editor: r } = n;
    if (!r || !this.provider)
      return;
    t && (this.setCustomAssetProps(void 0), this.setCustomPages(void 0));
    const o = ((c = this.customPages) == null ? void 0 : c.length) ?? 0, i = (p = (d = this.customPages) == null ? void 0 : d.at(-1)) == null ? void 0 : p.nextPageCustomData, l = await this.provider.onLoad({
      editor: r,
      assetTypeFilter: this.typeFilter,
      pageIndex: o,
      searchValue: this.searchValue,
      pageCustomData: i
    }) ?? [];
    if (Array.isArray(l)) {
      const m = l.map(n.toAssetProps);
      this.setCustomAssetProps(m);
    } else {
      const m = {
        ...l,
        items: l.items.map(n.toAssetProps)
      };
      this.setCustomPages([...this.customPages ?? [], m]);
    }
    this.setItemLayout((g = this.provider) == null ? void 0 : g.itemLayout);
  }
  async loadAssets(t = !0) {
    const { assetsStore: n } = this, { toastStore: r } = n.store;
    try {
      this.provider ? (this.setIsLoadingAssets(!0), await this.loadProviderAssets(t)) : this.selectProjectAssets();
    } catch (o) {
      console.error(o), r.addError("assets-error-get", this.t("errorLoad"));
    } finally {
      this.setIsLoadingAssets(!1);
    }
  }
  async reloadAssets(t) {
    const { assetsStore: n } = this, { cachedOnLoadAssetProps: r } = n;
    await this.loadAssets(t == null ? void 0 : t.clearExisting), !this.provider && r && (n.cachedOnLoadAssetProps = void 0, await n.loadProjectAssets());
  }
  async handleDeleteCallback(t) {
    const { assetsStore: n, onProviderOrProjectDelete: r } = this, { appEditorStore: o } = n.store, { editor: i } = o;
    if (!(!i || !r))
      try {
        n.setIsLoadingAssets(!0), await r({
          assets: [n.toAsset(t)],
          assetProps: [t],
          editor: i,
          loadAssets: (l) => this.reloadAssets(l)
        });
      } catch (l) {
        console.error(l), n.store.toastStore.addError("assets-error-delete", {
          header: this.t("errorDelete"),
          content: l == null ? void 0 : l.message
        });
      } finally {
        n.setIsLoadingAssets(!1);
      }
  }
}
const CE = (e) => Nn().assetsStore.assetPanelStores[e];
class o$ {
  constructor(t) {
    this.store = t, this.isLoadingAssets = !1, this.mainPanelId = `main-${sC()}`, this.assetPanelStores = {}, this.cachedOnLoadAssetProps = void 0, this.projectAssetProps = void 0, this.allProviders = [], this.assetPanelStores[this.mainPanelId] = new eS(this, this.mainPanelId), this.setAllProviders(this.isUsingAssetCloud ? [this.userProvider] : []), Yn(this, {}, { autoBind: !0 });
  }
  get sdkAssetConfig() {
    return this.store.appEditorStore.sdkOptions.assets;
  }
  get isUsingAssetCloud() {
    var t;
    return ((t = this.sdkAssetConfig) == null ? void 0 : t.storageType) === U1.cloud;
  }
  get storageType() {
    var t;
    return (t = this.sdkAssetConfig) == null ? void 0 : t.storageType;
  }
  get isSelfStorage() {
    return this.storageType === U1.self;
  }
  get editor() {
    return this.store.appEditorStore.editor;
  }
  get customOnLoad() {
    var t;
    return (t = this.sdkAssetConfig) == null ? void 0 : t.onLoad;
  }
  get customOnDelete() {
    var t;
    return (t = this.sdkAssetConfig) == null ? void 0 : t.onDelete;
  }
  get customOnUpload() {
    var t;
    return (t = this.sdkAssetConfig) == null ? void 0 : t.onUpload;
  }
  get onCloudOrCustomUpload() {
    const { appEditorStore: t } = this.store, { sdkProps: n } = t, o = n.options.licenseKey, i = t.sdkProjectId, l = t.sdkIdentityId, c = ({ files: d }) => z8(d, o, i, l);
    return this.isUsingAssetCloud ? c : this.customOnUpload;
  }
  get onProjectDelete() {
    const { customOnDelete: t, isSelfStorage: n, isUsingAssetCloud: r } = this;
    return n ? t ? async (o) => {
      await t(o), this.deleteFromProjectAssets(o);
    } : void 0 : r ? async (o) => {
      var d, p;
      const { sdkOptions: i } = this.store.appEditorStore, l = (d = i.project) == null ? void 0 : d.id, c = (p = i.identity) == null ? void 0 : p.id;
      await Ww(o.assetProps, i.licenseKey, l, c), this.deleteFromProjectAssets(o);
    } : this.deleteFromProjectAssets;
  }
  get t() {
    return this.store.i18nStore.tScoped("assetManager");
  }
  get userProvider() {
    var c, d;
    const { appEditorStore: t } = this.store, { sdkOptions: n } = t, r = (c = n.project) == null ? void 0 : c.id, o = (d = n.identity) == null ? void 0 : d.id, i = n.licenseKey;
    return {
      id: "grapesjs-user-provider",
      label: () => this.t("userAssets"),
      types: oa.image,
      onLoad: () => V8(
        i,
        // both mandatory for storageType === 'cloud'
        r,
        o
      ),
      onDelete: async (p) => {
        const { assetProps: g, loadAssets: m } = p;
        await Ww(
          g,
          i,
          // both mandatory for storageType === 'cloud'
          r,
          o
        ), this.deleteFromProjectAssets(p), await m({ clearExisting: !1 });
      }
    };
  }
  onEditor() {
    const t = Es(() => !this.loadProjectAssets()), n = this.store.appEditorStore.editor;
    this.addSdkProviders();
    const r = n.Assets.events.all;
    n.on(r, t), this.loadProjectAssets();
  }
  /**
   * Add sdk providers after any asset providers are added from plugins
   */
  addSdkProviders() {
    var r;
    const t = ((r = this.sdkAssetConfig) == null ? void 0 : r.providers) ?? [], n = Ct(t) ? t({ providers: gi(this.allProviders) }) : [...this.allProviders, ...t];
    this.setAllProviders(n);
  }
  addProvider(t, n = this.allProviders.length) {
    const r = [...this.allProviders];
    let o = this.allProviders.findIndex((l) => l.id === t.id);
    const i = o !== -1;
    r.splice(n, 0, t), i && (o >= n && (o += 1), r.splice(o, 1)), this.setAllProviders(r);
  }
  hasType(t) {
    return !!this.allProviders.find((n) => Dt(n.types) ? n.types === t : n.types.includes(t));
  }
  createAssetManager(t) {
    const n = new eS(this, t);
    this.assetPanelStores[t] = n;
  }
  removeAssetManager(t) {
    delete this.assetPanelStores[t];
  }
  async loadProjectAssets() {
    const { editor: t, isSelfStorage: n, cachedOnLoadAssetProps: r, customOnLoad: o } = this, { toastStore: i } = this.store;
    let l;
    if (t) {
      try {
        if (this.setIsLoadingAssets(!0), n && o)
          if (r)
            l = r;
          else {
            const c = await o({ editor: t });
            this.cachedOnLoadAssetProps = c.map(this.toAssetProps), l = this.cachedOnLoadAssetProps;
          }
        else
          l = t.Assets.getAll().map(this.toAssetProps);
      } catch (c) {
        console.error(c), i.addError("assets-error-load", {
          header: this.t("errorLoad"),
          content: c == null ? void 0 : c.message
        });
      } finally {
        this.setIsLoadingAssets(!1);
      }
      l && this.setProjectAssetProps(l);
    }
  }
  deleteFromProjectAssets({ assets: t, editor: n, assetProps: r }) {
    const { cachedOnLoadAssetProps: o, customOnLoad: i } = this;
    if (i) {
      if (o) {
        const l = r.map((c) => c.id);
        this.cachedOnLoadAssetProps = o.filter(({ id: c }) => !l.includes(c)), this.setProjectAssetProps(this.cachedOnLoadAssetProps);
      }
    } else
      t.forEach((l) => n.Assets.remove(l)), Jw(n);
  }
  addToProjectAssets(t) {
    const n = this.store.appEditorStore.editor, { cachedOnLoadAssetProps: r, customOnLoad: o } = this;
    o ? r && (this.cachedOnLoadAssetProps = [...t, ...r], this.setProjectAssetProps(this.cachedOnLoadAssetProps)) : (n.Assets.add(t), Jw(n));
  }
  async handleUpload(t) {
    var i, l;
    const { editor: n, onCloudOrCustomUpload: r } = this, { toastStore: o } = this.store;
    if (!(!n || !r))
      try {
        this.setIsLoadingAssets(!0);
        const c = ((i = t.dataTransfer) == null ? void 0 : i.files) || ((l = t.target) == null ? void 0 : l.files) || [], d = Array.from(c), p = await r({ files: d, editor: n });
        if (p != null && p.length) {
          const g = p.map(this.toAssetProps);
          return this.addToProjectAssets(g), g;
        } else
          console.warn("No assets returned from the upload handler. Ensure to return an array of assets.");
      } catch (c) {
        console.error(c), o.addError("assets-error-upload", {
          header: this.t("errorUpload"),
          content: c == null ? void 0 : c.message
        });
      } finally {
        this.setIsLoadingAssets(!1);
      }
  }
  uploadFile(t) {
    var n;
    return (n = this.editor) == null ? void 0 : n.Assets.FileUploader().uploadFile(t);
  }
  isAsset(t) {
    return !!t.getSrc;
  }
  toAssetProps(t) {
    if (this.isAsset(t)) {
      const r = t;
      return {
        ...r.attributes,
        id: r.attributes.id || r.getSrc(),
        src: r.getSrc(),
        name: r.attributes.name ?? r.getFilename(),
        type: r.attributes.type ?? r.getType() ?? oa.image,
        asset: r
      };
    }
    return {
      ...t,
      type: t.type || oa.image,
      id: t.id || t.src
    };
  }
  toAsset(t) {
    const { editor: n } = this.store.appEditorStore;
    if (n)
      return t.asset ?? new n.AssetManager.Asset(t);
  }
  setProjectAssetProps(t) {
    this.projectAssetProps = t;
  }
  setIsLoadingAssets(t) {
    this.isLoadingAssets = t;
  }
  setAllProviders(t) {
    this.allProviders = t;
  }
}
const xa = () => Nn().assetsStore;
class s$ {
  constructor(t) {
    var r;
    this.store = t, this.fonts = {}, Yn(this, {}, { autoBind: !0 });
    const n = (r = this.sdkFontOptions) == null ? void 0 : r.default;
    this.sdkDefaultFonts = Ct(n) ? n({ baseDefault: Kw }) : n;
  }
  get staticFonts() {
    return this.sdkDefaultFonts ? this.sdkDefaultFonts.map((t) => Dt(t) ? { id: t, label: t } : qw(t) ? t : null).filter((t) => !!t) : Kw;
  }
  get defaultWebFonts() {
    return this.sdkDefaultFonts ? this.sdkDefaultFonts.filter((n) => !Dt(n) && !qw(n)).map((n) => Uc(n.family, n)) : [];
  }
  get sortedFonts() {
    return K8(Object.values(this.fonts));
  }
  get fontFamilyOptions() {
    const t = (n) => ({ id: n.family, label: n.familyLabel });
    return q8([...this.staticFonts, ...Object.values(this.fonts).map(t)]);
  }
  get sdkFontOptions() {
    return this.store.appEditorStore.sdkOptions.fonts;
  }
  get enableFontManager() {
    var t;
    return (t = this.sdkFontOptions) == null ? void 0 : t.enableFontManager;
  }
  get sdkShowProjectFonts() {
    const { showProjectFonts: t, enableFontManager: n } = this.sdkFontOptions || {};
    return Rn(t) ? t : n;
  }
  get sdkAddFonts() {
    const { addFonts: t, enableFontManager: n } = this.sdkFontOptions || {};
    return Rn(t) ? t : n;
  }
  loadFonts() {
    this.loadProjectFonts(), this.loadDefaultFonts();
  }
  loadProjectFonts() {
    const { editor: t } = this.store.appEditorStore;
    if (!t)
      return;
    const { globalPageSettings: n } = kl(t) ?? {}, { fonts: r } = n ?? {};
    if (r)
      for (const [o, i] of Object.entries(r)) {
        const l = Uc(o, i);
        this.addFont(l, { skipUpdate: !0 });
      }
  }
  loadDefaultFonts() {
    const { editor: t } = this.store.appEditorStore;
    if (t)
      for (const n of this.defaultWebFonts)
        this.addFont(n, { overwrite: !1, skipUpdate: !0 });
  }
  getFont(t) {
    return t = pa(t), this.fonts[t];
  }
  addFont(t, { skipUpdate: n, overwrite: r = !0 } = {}) {
    const o = Uc(t.family, t), { editor: i } = this.store.appEditorStore;
    if (!i)
      return;
    const { family: l } = o;
    !r && this.fonts[l] || (this.fonts[l] = o, n || this.updateProjectFonts(i));
  }
  removeFont(t) {
    t = pa(t);
    const { editor: n } = this.store.appEditorStore;
    n && (delete this.fonts[t], this.updateProjectFonts(n));
  }
  updateProjectFonts(t) {
    const r = {
      ...kl(t).globalPageSettings,
      fonts: gi(this.fonts)
    };
    this.store.appEditorStore.setProjectDataCustom({ globalPageSettings: r }), xE(t), t.trigger(kr.pageSettingsUpdate, { data: r });
  }
}
const Ku = () => Nn().fontsStore;
class i$ {
  constructor(t) {
    this.store = t, Yn(this, {}, { autoBind: !0 });
  }
  t(t, n = {}) {
    var o;
    const { editor: r } = this.store.appEditorStore;
    return ((o = r == null ? void 0 : r.I18n) == null ? void 0 : o.t(t, n)) || "";
  }
  tScoped(t) {
    return (n, r) => this.t(`${t}.${n}`, r);
  }
}
const qe = () => Nn().i18nStore, cr = (e, t) => y.Children.map(e, (n) => n && n.type === t ? n : null), tS = "gs-custom-layout", a$ = y.forwardRef(function({ className: t, component: n, noWrapper: r, id: o, render: i, ...l }, c) {
  const { editor: d } = Re(), p = y.useRef(null), g = n, m = g && d ? /* @__PURE__ */ u.jsx(g, { editor: d }) : null, v = B(tS, o && `${tS}__${o}`, t), b = r && !i;
  return y.useImperativeHandle(c, () => p.current, []), y.useEffect(() => {
    const x = p.current;
    if (!i || !x)
      return;
    const w = (E) => x.appendChild(E), j = (E) => x.removeChild(E), C = i({ editor: d, addEl: w, removeEl: j });
    if (Dt(C))
      x.innerHTML = C;
    else {
      if (C instanceof HTMLElement)
        return w(C), () => {
          j(C);
        };
      if (Ct(C))
        return () => {
          C();
        };
    }
  }, [i, d, p.current]), b ? m : /* @__PURE__ */ u.jsx("div", { className: v, ref: p, ...l, children: m });
}), X1 = xe(a$);
class l$ {
  constructor(t) {
    this.customConfig = void 0, this.layouts = [], this.layoutsById = /* @__PURE__ */ new Map(), this.store = t, Yn(
      this,
      {},
      {
        autoBind: !0,
        // The layout components might break due to the usage of mobx Proxies
        deep: !1
      }
    );
  }
  get editor() {
    return this.store.appEditorStore.editor;
  }
  setCustomConfig(t) {
    this.customConfig = t;
  }
  add(t, n) {
    var r;
    this.get(t) || (this.layouts = [
      ...this.layouts,
      {
        id: t,
        ...n
      }
    ], (r = this.editor) == null || r.trigger(`${kr.layoutToggleId}${t}`, { isOpen: !0 }));
  }
  remove(t, n) {
    var o;
    const r = n == null ? void 0 : n.layout;
    r && this.layouts.forEach((i) => {
      i.id === t && Object.assign(i, r);
    }), this.layouts = n != null && n.force ? this.layouts.filter((i) => i.id !== t) : this.layouts.map((i) => i.id === t ? { ...i, toRemove: !0 } : i), (o = this.editor) == null || o.trigger(`${kr.layoutToggleId}${t}`, { isOpen: !1 });
  }
  get(t) {
    return this.layouts.find((n) => n.id === t);
  }
  clear() {
    this.layouts = [];
  }
  get layoutChildren() {
    var r;
    const { children: t } = this.store.appEditorStore.sdkProps, n = ((r = cr(t, X1)) == null ? void 0 : r.filter(Boolean)) || [];
    return new Map(
      n.map(({ props: o }) => [o.id, o])
    );
  }
}
const k0 = () => Nn().layoutStore, c$ = () => dg().layoutStore;
class u$ {
  constructor(t) {
    this.isActive = !1, this.content = "", this.store = t, Yn(this, {}, { autoBind: !0 });
  }
  show(t) {
    this.isActive = !0, this.content = t;
  }
  hide() {
    this.isActive = !1, setTimeout(this.clear, 101);
  }
  clear() {
    this.content = "";
  }
}
const EE = () => Nn().pointerBadgeStore;
var Dl = /* @__PURE__ */ ((e) => (e.Projects = "projects", e.Settings = "settings", e))(Dl || {}), PE = /* @__PURE__ */ ((e) => (e.gjs = "gjs", e.gjsStudio = "gjs-studio", e))(PE || {});
const nS = {}, d$ = 1, f$ = (e = {}) => new Promise((t, n) => {
  const r = (e == null ? void 0 : e.db) || "gjs", o = r === "gjs-studio" ? d$ : 1, i = nS[r];
  if (i)
    t(i);
  else {
    if (!ns())
      return n(new Error("window context not found"));
    const l = window.indexedDB.open(r, o);
    l.onerror = n, l.onsuccess = () => {
      const c = l.result;
      c.onerror = n, nS[r] = c, t(c);
    }, l.onupgradeneeded = () => {
      const c = l.result;
      c.objectStoreNames.contains(
        "projects"
        /* Projects */
      ) || c.createObjectStore(
        "projects"
        /* Projects */
      ), c.objectStoreNames.contains(
        "settings"
        /* Settings */
      ) || c.createObjectStore(
        "settings"
        /* Settings */
      );
    };
  }
}), Jp = async (e, t) => (await f$(t)).transaction([e], "readwrite").objectStore(e), p$ = async (e, t) => {
  const n = await Jp(e, t);
  return new Promise((r, o) => {
    const i = [], l = n.openCursor();
    l.onerror = o, l.onsuccess = function(c) {
      const p = c.target.result;
      if (p) {
        const g = p.primaryKey, m = p.value;
        i.push({ key: g, data: m }), p.continue();
      } else
        r(i);
    };
  });
}, g$ = async (e, t, n) => {
  const r = await Jp(e, n);
  return new Promise((o, i) => {
    const l = r.get(t);
    l.onerror = i, l.onsuccess = () => o(l.result);
  });
}, _E = async (e, t, n, r) => {
  const o = await Jp(e, r);
  return new Promise((i, l) => {
    const c = o.put(n, t);
    c.onerror = l, c.onsuccess = () => i();
  });
}, h$ = async (e, t, n) => {
  const r = await Jp(e, n);
  return new Promise((o, i) => {
    const l = r.delete(t);
    l.onerror = i, l.onsuccess = () => o();
  });
};
var pu = /* @__PURE__ */ ((e) => (e.Existing = "existing", e.Templates = "templates", e))(pu || {});
const m$ = (e) => {
  const t = nH();
  return `${(t == null ? void 0 : t.baseApiUrl) || "/api"}/templates/${e}`;
}, v$ = (e, t) => ts.get(m$(e), {
  ...t
}), y$ = async (e) => {
  try {
    const t = await v$(e);
    return (t == null ? void 0 : t.result) ?? [];
  } catch (t) {
    return console.error(`Failed to load templates for type ${e}:`, t), [];
  }
}, kE = async (e = Xe.web) => typeof window > "u" ? [] : (await p$(Dl.Projects)).map(({ key: r, data: o }) => {
  var i;
  return {
    id: `${r}`,
    name: `${((i = o.custom) == null ? void 0 : i.projectName) || r}`,
    data: o
  };
}).filter((r) => {
  var o;
  return ((o = r.data.custom) == null ? void 0 : o.projectType) === e;
});
class b$ {
  constructor(t) {
    this.store = t, this._projectSourceFilter = pu.Existing, this._loadedProjects = void 0, this._loadedTemplates = void 0, this._projectTypeFilter = t.appEditorStore.projectType, Yn(this, {}, { autoBind: !0 });
  }
  get projectTypeFilter() {
    return this._projectTypeFilter;
  }
  get projectSourceFilter() {
    return this._projectSourceFilter;
  }
  get templates() {
    return this._loadedTemplates;
  }
  get projects() {
    return this._loadedProjects;
  }
  get filteredTemplates() {
    return this.projectSourceFilter === pu.Existing ? this.projects : this.templates;
  }
  async loadProjects() {
    const t = await kE(this.projectTypeFilter);
    this.setProjects(t);
  }
  async loadTemplates() {
    var o;
    const t = (o = this.store.appEditorStore.sdkOptions.templates) == null ? void 0 : o.onLoad, n = async () => await y$(this.projectTypeFilter);
    let r;
    if (t) {
      const i = this.store.appEditorStore.editor;
      r = await t({ editor: i, fetchCommunityTemplates: n });
    } else
      r = await n();
    this.setTemplates(r);
  }
  async loadAllTemplates() {
    await Promise.all([this.loadProjects(), this.loadTemplates()]);
  }
  async removeProject(t) {
    h$(Dl.Projects, t);
  }
  async setProjectTypeFilter(t) {
    this._projectTypeFilter = t, this.setProjects(void 0), this.setTemplates(void 0);
  }
  setProjectSourceFilter(t) {
    this._projectSourceFilter = t;
  }
  setTemplates(t) {
    this._loadedTemplates = t;
  }
  setProjects(t) {
    this._loadedProjects = t;
  }
}
const TE = () => Nn().templatesStore;
class x$ {
  constructor(t) {
    this.toasts = [], this.store = t, Yn(this, {}, { autoBind: !0 });
  }
  add(t, n) {
    this.toasts.find((r) => r.id === t) || this.toasts.push({
      id: t,
      ...n
    });
  }
  addError(t, n) {
    this.add(t, {
      ...Dt(n) ? { header: n } : n,
      variant: Gn.Error
    });
  }
  addWarning(t, n) {
    this.add(t, {
      ...Dt(n) ? { header: n } : n,
      variant: Gn.Warning
    });
  }
  addSuccess(t, n) {
    this.add(t, {
      ...Dt(n) ? { header: n } : n,
      variant: Gn.Success
    });
  }
  addInfo(t, n) {
    this.add(t, {
      ...Dt(n) ? { header: n } : n,
      variant: Gn.Info
    });
  }
  remove(t) {
    this.toasts = this.toasts.filter((n) => n.id !== t);
  }
}
const OE = () => Nn().toastStore;
class w$ {
  constructor(t) {
    this.isOpen = !1, this.store = t, Yn(this, {}, { autoBind: !0 });
  }
  setOpen(t) {
    this.isOpen = t, this.triggerEvent();
  }
  toggleOpen() {
    this.isOpen = !this.isOpen, this.triggerEvent();
  }
  triggerEvent() {
    var t;
    (t = this.store.appEditorStore.editor) == null || t.trigger(kr.toggleBlocksPanel, { isOpen: this.isOpen });
  }
}
const LE = () => Nn().blockManagerStore, S$ = "mjml-code-to-html";
function ME(e) {
  function t(d) {
    const p = document.createElement("textarea");
    return p.innerHTML = d, p.value;
  }
  const n = t(e || ""), r = [
    "checked",
    "disabled",
    "readonly",
    "required",
    "autofocus",
    "multiple",
    "selected",
    "hidden",
    "async",
    "defer",
    "formnovalidate",
    "novalidate",
    "ismap",
    "allowfullscreen",
    "autoplay",
    "controls",
    "loop",
    "muted",
    "open",
    "reversed",
    "scoped",
    "seamless",
    "typemustmatch",
    "default",
    "crossorigin"
  ], o = new RegExp(`\\s+(${r.join("|")})(?=\\s|\\/?>)`, "gi");
  return n.replace(/<[^>]+>/g, (d) => d.replace(o, (p, g) => ` ${g}="${g === "crossorigin" ? "anonymous" : g}"`)).replace(/(\s[\w:-]+=\s*)("[^"]*"|'[^']*')/g, (d, p, g) => {
    const m = g.slice(1, -1).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    return `${p}"${m}"`;
  }).replace(new RegExp("(?<!&)(?:&(?!#?\\w+;))", "g"), "&amp;");
}
var gu = /* @__PURE__ */ ((e) => (e.root = "mjml", e.head = "mj-head", e.body = "mj-body", e.include = "mj-include", e))(gu || {}), T0 = /* @__PURE__ */ ((e) => (e.attributes = "mj-attributes", e.breakpoint = "mj-breakpoint", e.font = "mj-font", e.htmlAttributes = "mj-html-attributes", e.preview = "mj-preview", e.style = "mj-style", e.title = "mj-title", e.class = "mj-class", e.all = "mj-all", e))(T0 || {}), AE = /* @__PURE__ */ ((e) => (e.accordion = "mj-accordion", e.accordionElement = "mj-accordion-element", e.accordionTitle = "mj-accordion-title", e.accordionText = "mj-accordion-text", e.button = "mj-button", e.carousel = "mj-carousel", e.carouselImage = "mj-carousel-image", e.column = "mj-column", e.divider = "mj-divider", e.group = "mj-group", e.hero = "mj-hero", e.image = "mj-image", e.navbar = "mj-navbar", e.navbarLink = "mj-navbar-link", e.raw = "mj-raw", e.section = "mj-section", e.social = "mj-social", e.socialElement = "mj-social-element", e.spacer = "mj-spacer", e.table = "mj-table", e.text = "mj-text", e.wrapper = "mj-wrapper", e))(AE || {}), wa = /* @__PURE__ */ ((e) => (e.globalStyles = "globalStyles", e.globalData = "globalData", e))(wa || {});
function j$(e) {
  const t = /* @__PURE__ */ new Map(), n = { items: [] };
  return e.forEach((o) => {
    const { category: i, item: l } = o;
    if (i) {
      const c = t.get(i.id);
      c ? (c.items.push(l), c.category = {
        ...c.category,
        ...i
      }) : t.set(i.id, { category: i, items: [l] });
    } else
      n.items.push(l);
  }), [...Array.from(t).map(([, o]) => o), n].filter((o) => o.items.length);
}
const RE = (e) => (e == null ? void 0 : e.get("groups")) || [], NE = (e, t) => RE(e).includes(t), C$ = (e, t) => {
  NE(e, t) || e.set("groups", [...RE(e), t]);
};
class E$ {
  constructor(t) {
    this.dataSourceKeyid = wa.globalStyles, this.records = [], this.openCategories = /* @__PURE__ */ new Map(), this.store = t, Yn(
      this,
      {
        // will be used only on the initial render of GlobalStyleManager
        openCategories: !1
      },
      { autoBind: !0 }
    );
  }
  get sdkOptionStyles() {
    var t;
    return ((t = this.store.appEditorStore.sdkOptions.globalStyles) == null ? void 0 : t.default) || [];
  }
  get editor() {
    return this.store.appEditorStore.editor;
  }
  get DataSources() {
    var t;
    return (t = this.editor) == null ? void 0 : t.DataSources;
  }
  get recordsByCategory() {
    const { records: t, sdkOptionStyles: n } = this, r = [], o = t.reduce((i, l) => (i.set(l.get("id"), l), i), /* @__PURE__ */ new Map());
    return n.forEach(({ id: i }) => {
      const l = o.get(i);
      l && (r.push(l), o.delete(i));
    }), Array.from(o).map(([, i]) => {
      i.get("_internal") || r.push(i);
    }), j$(r.map((i) => ({ category: i.get("category"), item: i })));
  }
  setCategoryOpen(t, n) {
    this.openCategories.set(t, n);
  }
  getDataSource() {
    var t;
    return (t = this.DataSources) == null ? void 0 : t.get(this.dataSourceKeyid);
  }
  getRuleByGroup(t) {
    var n;
    return (n = this.editor) == null ? void 0 : n.CssComposer.getAll().find((r) => NE(r, t));
  }
  addStyleRule(t, n = {}) {
    var m, v;
    const { editor: r } = this, o = t.get("id"), i = t.get("selector") || "", l = t.get("property"), c = t.getPath("value"), d = `${this.dataSourceKeyid}:${o}`, p = {
      [l]: {
        type: "data-variable",
        path: c,
        defaultValue: t.get("defaultValue")
      }
    };
    if (r && EO(r) && i.startsWith("mj-")) {
      const b = r.Components.getWrapper(), { head: x } = gu, { attributes: w } = T0, j = b.findFirstType(gu.root), C = j.findFirstType(x) || j.append({ type: x }, { at: 0 })[0], E = C.findFirstType(w) || C.append({ type: w })[0], P = E.findType(i).pop() || E.append({ type: i })[0], k = (P.get("attributes") || {})[l];
      Rn(k) && k !== "" && t.set("value", k), P.addAttributes(p, { silent: !0 });
      return;
    }
    let g = ((v = (m = n.selectorToRuleMap) == null ? void 0 : m.get(i)) == null ? void 0 : v.rule) || this.getRuleByGroup(d);
    g ? g.addStyle(p) : g = r == null ? void 0 : r.CssComposer.addCollection(
      [
        {
          selectors: [],
          selectorsAdd: i,
          style: p
        }
      ],
      {
        extend: !0,
        at: t.index
      }
    )[0], g && C$(g, d);
  }
  createDataSource() {
    return this.DataSources.add({
      id: this.dataSourceKeyid,
      records: []
    });
  }
  onLoad() {
    var i, l;
    const { sdkOptionStyles: t } = this, n = /* @__PURE__ */ new Map(), r = (i = this.editor) == null ? void 0 : i.Css;
    if (!t.length) {
      this.records = [];
      return;
    }
    const o = this.getDataSource() || this.createDataSource();
    t.forEach((c) => {
      const { id: d, selector: p, label: g, field: m, property: v, category: b } = c, x = o.getRecord(d);
      if (x) {
        const w = {
          label: g,
          field: m,
          category: b
        };
        x.set({ ...w, _undo: !0 });
      } else {
        const w = n.get(p), j = (w == null ? void 0 : w.rule) || (r == null ? void 0 : r.getRule(p)), C = (w == null ? void 0 : w.styles) || (j == null ? void 0 : j.getStyle()) || {}, E = C[v] || c.defaultValue;
        n.set(p, { rule: j, styles: C }), o.addRecord({
          value: void 0,
          // make the first undo work if value is not provided
          ...c,
          defaultValue: E,
          // @ts-expect-error custom prop
          _internal: !0,
          // setByGlobalStyleManager
          _undo: !0
          // Make globalStyle records undoable
        });
      }
    }), o.getRecords().forEach((c) => {
      this.addStyleRule(c, { selectorToRuleMap: n });
    }), o.listenTo(o.records, "add", (c) => {
      this.addStyleRule(c);
    }), (l = this.editor) == null || l.UndoManager.add(o.records), this.records = o.getRecords();
  }
}
const P$ = () => Nn().globalStylesStore, $E = (e, t) => {
  let n;
  try {
    const r = ns() && e && localStorage.getItem(e);
    r && (n = JSON.parse(r));
  } catch (r) {
    console.error(r);
  }
  return {
    lastProjectId: "",
    ...t,
    ...n
  };
}, rS = (e, t) => {
  const r = { ...$E(e), ...t };
  try {
    ns() && e && localStorage.setItem(e, JSON.stringify(r));
  } catch (o) {
    console.error(o);
  }
  return r;
}, Z1 = "gs-utl-dark", _$ = () => ns() && window.matchMedia("(prefers-color-scheme: dark)").matches, DE = (e) => e === "dark" || e === "auto" && _$(), oS = (e, t) => {
  if (e && ns() && t.rootEl) {
    const { classList: n } = t.rootEl;
    let r = !1;
    if (DE(e) ? (n.add(Z1), r = !0) : n.remove(Z1), t.updateAppShell) {
      const o = document.head.querySelector('meta[name="theme-color"]');
      o && (o.content = r ? "#18181b" : "#ffffff");
    }
    t.resolvedTheme = r ? xo.dark : xo.light;
  }
};
class k$ {
  constructor(t) {
    this.key = "", this.theme = xo.auto, this.resolvedTheme = xo.light, this.lastProjectId = "", this.updateAppShell = !1, this.rootEl = void 0, t && Object.keys(t).forEach((n) => {
      const r = n, o = t[r];
      o !== void 0 && (this[r] = o);
    }), this.resolvedTheme = this.theme, Yn(this, {}, { autoBind: !0 }), this.init();
  }
  init() {
    oS(this.theme, this);
  }
  changeTheme(t) {
    oS(t, this), rS(this.key, { theme: t });
  }
  setTheme(t) {
    this.theme = t;
  }
  setRootEl(t) {
    this.rootEl = t;
  }
  setLocalState(t) {
    Object.keys(t).forEach((n) => {
      const r = n, o = t[r];
      o !== void 0 && (this[r] = o);
    }), rS(this.key, t);
  }
  get isDarkTheme() {
    return DE(this.theme);
  }
}
const T$ = (e) => {
  Hj(
    () => e.theme,
    (t) => {
      e.changeTheme(t);
    }
  );
}, gr = () => Nn().localSettingsStore;
class O$ {
  constructor(t) {
    this.isOpen = !1, this.title = "", this.content = "", this.size = "l", this.fullH = !1, this.modalProps = {}, this.buttons = [], this.store = t, Yn(this, {}, { autoBind: !0 });
  }
  setModalProps(t) {
    this.modalProps = {
      title: "",
      size: "l",
      fullH: !1,
      buttons: [],
      ...t
    };
  }
  open({ content: t, ...n }) {
    this.isOpen = !0, this.content = t, this.setModalProps(n);
  }
  close() {
    this.isOpen = !1, setTimeout(this.clear, 101);
  }
  clear() {
    this.content = "", this.setModalProps({
      size: this.modalProps.size
    });
  }
  confirm({ content: t, size: n = "m", onConfirm: r, confirmButton: o, ...i }) {
    this.isOpen = !0, this.content = t;
    const l = () => {
      r == null || r(), this.close();
    };
    this.setModalProps({
      ...i,
      size: n,
      buttons: [
        { children: "Cancel", onClick: this.close, size: "m2" },
        { children: "Confirm", onClick: l, size: "m2", variant: "pr", ...o }
      ]
    });
  }
}
const os = () => Nn().modalStore, L$ = {
  add: "Add",
  delete: "Delete",
  duplicate: "Duplicate",
  rename: "Rename",
  remove: "Remove",
  clear: "Clear",
  select: "Select",
  selectList: "Select from the list",
  search: "Search",
  update: "Update",
  updated: "Updated!",
  confirm: "Confirm",
  cancel: "Cancel",
  enable: "Enable",
  disable: "Disable",
  upload: "Upload",
  close: "Close",
  load: "Load",
  copy: "Copy",
  save: "Save",
  current: "Current",
  toggleCss: "Toggle CSS",
  selectTarget: "Target Component",
  noCode: "No code available",
  noItems: "No items found",
  confirmAction: "Do you confirm this action?",
  eyeDropper: "Eyedropper",
  noEyeDropper: "Eyedropper not supported",
  unauthorized: "Unauthorized project",
  notItemsFound: "No items found",
  actions: {
    componentOutline: { title: "Component outline" },
    preview: { title: "Preview" },
    fullscreen: { title: "Fullscreen" },
    showCode: {
      title: "Code",
      exportButton: "Export to ZIP"
    },
    undo: { title: "Undo" },
    redo: { title: "Redo" },
    save: { title: "Save project" },
    store: { title: "Save content" },
    open: { title: "Open project" },
    importCode: {
      title: "Import code",
      parseError: "Parser error",
      content: "Paste here your HTML/CSS and click Import",
      button: "Import"
    },
    clearCanvas: {
      title: "Clear page",
      content: "Are you sure you want to clear the page?"
    },
    about: {
      title: "About"
    },
    embed: {
      title: "Embed Studio"
    },
    newProject: {
      title: "Load project"
    },
    installApp: {
      title: "Install App",
      installed: "App installed"
    }
  },
  modals: {
    styleCatalog: {
      title: "Style Catalog",
      noStyles: "No styles found"
    },
    openProject: {
      title: "Open project"
    }
  },
  pluginManager: {
    plugins: "Plugins",
    all: "Available",
    installed: "Installed",
    install: "Install",
    uninstall: "Uninstall",
    allPlugins: "All plugins",
    updateStudio: "Restart Studio for plugin updates"
  },
  globalStyleManager: {
    notFound: "No global styles found",
    globalStyles: "Global Styles"
  },
  pageManager: {
    pages: "Pages",
    page: "Page",
    newPage: "New Page",
    add: "Add page",
    rename: "Rename",
    duplicate: "Duplicate",
    copy: "Copy",
    delete: "Delete",
    deletePage: "Delete Page",
    confirmDelete: "Are you sure you want to delete the page?",
    settings: {
      label: "Settings",
      title: "Page settings",
      global: "Global settings",
      fields: {
        name: {
          label: "Name"
        },
        slug: {
          label: "Slug",
          description: "The slug is the URL-friendly version of the name. It is usually all lowercase and contains only letters, numbers, and hyphens."
        },
        favicon: {
          label: "Favicon",
          description: "The favicon is the small icon that appears in the browser tab."
        },
        title: {
          label: "Title",
          description: "The title is the name of the page that appears in the browser tab."
        },
        description: {
          label: "Description",
          description: "The description is a short summary of the page content."
        },
        keywords: {
          label: "Keywords",
          description: "Keywords are words or phrases that describe the content of the page."
        },
        socialTitle: {
          label: "Social title",
          description: "The title is the name of the page that appears on social networks."
        },
        socialImage: {
          label: "Social image",
          description: "The image is the picture that appears on social networks."
        },
        socialDescription: {
          label: "Social description",
          description: "The description is a short summary of the page content that appears on social networks."
        },
        customCodeHead: {
          label: "Custom HTML head",
          description: "Add any custom HTML (e.g., meta tags, stylesheets, scripts) to be included in the <head> section of the page."
        },
        customCodeBody: {
          label: "Custom HTML body",
          description: "Add any custom HTML (e.g., scripts, tracking codes) to be included just before the closing </body> tag."
        }
      }
    }
  },
  projectManager: {
    existentProjects: "Your projects",
    templates: "Templates",
    notAvailable: "No projects available",
    projectType: "Project type",
    projectName: "Project name",
    pages: "Pages"
  },
  templates: {
    notFound: "No templates found"
  },
  storageManager: {
    errorLoad: "Failed to load the project",
    errorStore: "Failed to save the project"
  },
  assetManager: {
    addUrl: "Add URL",
    projectAssets: "Assets in this project",
    userAssets: "Assets from all projects",
    errorLoad: "Failed to load assets",
    errorUpload: "Failed to upload",
    errorDelete: "Failed to delete",
    deleteConfirmQuestion: "Delete asset?",
    deleteConfirmExplanation: "This will affect existing and published projects that rely on this asset, if any exist.",
    assetTypes: {
      all: "All",
      image: "Images"
    },
    noProvider: "Project assets"
  },
  fontManager: {
    addFontToProject: "Add font to project",
    projectFonts: "Project fonts",
    emptyProjectFonts: "There are no fonts in this project.",
    selectFont: "Select a font"
  },
  blockManager: {
    notFound: "No blocks found",
    blocks: "Blocks",
    add: "Add more blocks",
    search: "Search...",
    labels: {
      section: "Section",
      column1: "1 Column",
      column2: "2 Columns",
      column3: "3 Columns",
      "column3-7": "2 Columns 3/7",
      gridRow: "Grid",
      heading: "Heading",
      divider: "Divider",
      imageBox: "Image Box",
      linkBox: "Link Box"
    },
    categories: {
      // 'category-id': 'Category Label',
    },
    types: {
      regular: "Regular",
      symbols: "Symbols"
    },
    symbols: {
      notFound: "No symbols found",
      instancesProject: "Instance/s in the project",
      delete: "Delete symbol",
      deleteConfirm: "Are you sure you want to delete the symbol? All instances inside the project will be detached."
    }
  },
  domComponents: {
    names: {
      section: "Section",
      gridRow: "Row",
      gridColumn: "Column",
      heading: "Heading",
      divider: "Divider",
      imageBox: "Image Box",
      linkBox: "Link Box"
    }
  },
  traitManager: {
    empty: "Select a component to see its properties",
    panelLabel: "Properties",
    traits: {
      labels: {
        loading: "Lazy load",
        target: "Open in new tab",
        showList: "Show element list",
        customAttributes: "Custom Attributes"
      },
      attributes: {
        // href: { placeholder: 'eg. https://google.com' },
      }
    }
  },
  deviceManager: {
    allDevices: "All devices"
  },
  selectorManager: {
    noSelecton: "You don't have any selected element.",
    selectFromCanvas: "Select an element from the canvas.",
    selectFromList: "Pick any style from the Style Catalog.",
    selectCustom: "Add your custom style selector.",
    selection: "Selection",
    selector: "Selector",
    addNewSelector: "Add new selector",
    removeSelector: "Remove selector",
    target: "Target",
    device: "Device",
    state: "State",
    deleteStyle: "Delete style",
    showCSS: "Show CSS code",
    searchStyle: "Search style",
    applyOnSelector: "Apply style changes on Selectors",
    noSelectors: "No Selectors applied",
    applyOnComponents: "Apply style changes on Components",
    noComponents: "No Components selected",
    currentSelection: "The current selection from which styles are displayed of"
    // label: 'Classes',
    // selected: 'Selected',
    // emptyState: '- State -',
    // states: {
    //   hover: 'Hover',
    //   active: 'Click',
    //   'nth-of-type(2n)': 'Even/Odd',
    // },
  },
  layerManager: {
    layers: "Layers"
  },
  dataSources: {
    confirm: "Confirm",
    clearDataValue: "Clear data value",
    connectDataValue: "Connect data value",
    variable: "Variable",
    defaultValue: "Default value",
    variablePath: "Variable path",
    selectVariablePath: "Select variable path",
    openPathExplorer: "Open path explorer",
    closePathExplorer: "Close path explorer",
    toggleResolvedPath: "Toggle resolved path",
    items: "{length} item/s",
    properties: "{length} propertie/s",
    editVariable: "Edit variable",
    editCondition: "Edit condition",
    editCollection: "Edit collection",
    condition: "Condition",
    conditionTrue: "True condition",
    conditionFalse: "False condition",
    conditionAnd: "AND",
    conditionOr: "OR",
    conditionElse: "Else",
    addCondition: "Add condition",
    deleteCondition: "Delete condition",
    operator: "Operator",
    leftValue: "Left value",
    rightValue: "Right value",
    ifTrue: "Value if true",
    ifFalse: "Value if false",
    valueTrue: "True",
    valueFalse: "False",
    collection: "Collection",
    collectionItem: "Collection item",
    collectionId: "Collection ID",
    collectionStartIndex: "Start index",
    collectionEndIndex: "End index",
    collectionUpToEndIndex: "All",
    operators: {
      // Number operations
      "=": "= (Equals)",
      "!=": "!= (Not equals)",
      ">": "> (Greater than)",
      ">=": ">= (Greater than or equals)",
      "<": "< (Less than)",
      "<=": "<= (Less than or equals)",
      // String operations
      contains: "Contains",
      startsWith: "Starts with",
      endsWith: "Ends with",
      matchesRegex: "Matches regex",
      equalsIgnoreCase: "Equals (ignore case)",
      trimEquals: "Trimmed equals",
      // Boolean operations
      and: "AND",
      or: "OR",
      xor: "XOR",
      // Data source operations
      equals: "Equals",
      isDefined: "Is defined",
      isNull: "Is null",
      isUndefined: "Is undefined",
      isTruthy: "Is truthy",
      isFalsy: "Is falsy",
      isDefaultValue: "Is default value",
      isArray: "Is array",
      isObject: "Is object",
      isString: "Is string",
      isNumber: "Is number",
      isBoolean: "Is boolean"
    }
  },
  styleManager: {
    panelLabel: "Styles",
    layout: {
      flexChild: "Flex child",
      display: {
        tips: {
          block: "Block generates a block element box, generating line breaks both before and after the element when in the normal flow.",
          inline: "Inline generates one or more inline element boxes that do not generate line breaks. The inline is generally default for text content.",
          "inline-block": "Inline-block is similar to inline but allows to define width and height properties.",
          flex: "Flex behaves like a block element and lays out its child elements on a vertical/horizontal axis",
          none: "The element is hidden from the layout"
        }
      },
      direction: {
        title: {
          row: "Horizontal",
          "row-reverse": "Horizontal reversed",
          column: "Vertical",
          "column-reverse": "Vertical reversed"
        }
      }
    },
    position: {
      tips: {
        static: "Default position",
        relative: "Similar to Static but with the ability to be moved relative to itself",
        absolute: "Absolute position, relative to its closest non-static parent",
        fixed: "Fixed position (even when the page is scrolled), relative to the browser viewport",
        sticky: "Elements are keept in place but moved when the page is scrolled, based on indicated distance"
      },
      presets: {
        title: "Presets",
        options: {
          topLeft: "Top left",
          topRight: "Top right",
          bottomLeft: "Bottom left",
          bottomRight: "Bottom right",
          left: "Left",
          right: "Right",
          bottom: "Bottom",
          top: "Top",
          full: "Full"
        }
      }
    },
    properties: {
      "margin-top": "Top",
      "margin-right": "Right",
      "margin-bottom": "Bottom",
      "margin-left": "Left",
      "padding-top": "Top",
      "padding-right": "Right",
      "padding-bottom": "Bottom",
      "padding-left": "Left",
      "border-top-left-radius": "Top Left",
      "border-top-right-radius": "Top Right",
      "border-bottom-right-radius": "Bottom Right",
      "border-bottom-left-radius": "Bottom Left",
      "mix-blend-mode": "Blend mode",
      "transform-style": "Type",
      "backface-visibility": "Backface",
      "perspective-origin": "Perspective origin",
      "perspective-origin-x": "Left",
      "perspective-origin-y": "Top",
      "transform-origin-x": "Left",
      "transform-origin-y": "Top",
      "align-items": "Align",
      "align-self": "Align",
      "justify-content": "Justify",
      "row-gap": "Row",
      "column-gap": "Column",
      // Typography
      "font-family": "Font",
      "font-size": "Size",
      "font-weight": "Weight",
      "letter-spacing": "Spacing",
      "text-align": "Align",
      "text-decoration": "Decoration",
      "text-transform": "Transform",
      "white-space": "Breaking",
      // Borders
      "border-top-width": "Top",
      "border-right-width": "Right",
      "border-bottom-width": "Bottom",
      "border-left-width": "Left",
      "border-top-style": "Top",
      "border-right-style": "Right",
      "border-bottom-style": "Bottom",
      "border-left-style": "Left",
      "border-top-color": "Top",
      "border-right-color": "Right",
      "border-bottom-color": "Bottom",
      "border-left-color": "Left",
      // Bg
      "background-position": "Position",
      "background-position-x": "Left",
      "background-position-y": "Top",
      "background-size": "Size",
      "background-size-x": "Left",
      "background-size-y": "Top",
      "background-repeat": "Repeat",
      "background-attachment": "Attachment",
      "background-origin": "Origin",
      "background-clip": "Clip",
      // Effects
      "overflow-x": "X",
      "overflow-y": "Y"
    },
    options: {
      "__background-type": {
        image: "Image",
        gradient: "Gradient",
        color: "Color"
      },
      display: {
        block: "Block",
        inline: "Inline",
        "inline-block": "Inline block",
        flex: "Flex",
        none: "None"
      },
      overflow: {
        visible: "Visible",
        hidden: "Hidden",
        scroll: "Scroll",
        auto: "Auto"
      },
      "flex-wrap": {
        nowrap: "No wrap",
        wrap: "Wrap",
        "wrap-reverse": "Reverse wrap"
      }
    }
  }
}, sS = "column1", iS = "column2", aS = "column3", J1 = "column3-7", M$ = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "gridRow", i = "gridColumn", l = "gjs-grid-row", c = "gjs-grid-column", d = { tl: 0, tc: 0, tr: 0, cl: 0, bl: 0, br: 0 }, p = "flex-basis", g = 1, m = 1, v = 1;
  n.addType(o, {
    isComponent: (j) => Si(j, l),
    model: {
      defaults: {
        emptyState: !0,
        droppable: Vo(i),
        highlightable: !1,
        attributes: { class: l },
        resizable: { ...d, keyHeight: "min-height" },
        icon: `
            <svg viewBox="0 0 24 24">
              <path d="M22 14c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v4M4 14h4v-4H4v4m6 0h4v-4h-4v4m6 0h4v-4h-4v4z"></path>
            </svg>
          `,
        "stylable-require": ["flex-align-items", "flex-align-items-v", "flex-direction-id", "flex-multiline"],
        traits: [
          "id",
          "title",
          {
            name: "add-column",
            labelButton: "Add column",
            type: "button",
            full: !0,
            command: (j) => {
              j.getSelected().components().add({ type: i });
            }
          }
        ],
        styles: `
            .${l} {
              display: flex;
              justify-content: flex-start;
              align-items: stretch;
              flex-direction: row;
              min-height: auto;
              padding: 10px 0;
            }
            @media (max-width: 992px) {
              .${l} {
                flex-direction: column;
              }
            }
          `
      }
    }
  }), n.addType(i, {
    isComponent: (j) => Si(j, c),
    model: {
      defaults: {
        emptyState: !0,
        attributes: { class: c },
        draggable: Vo(o),
        resizable: { ...d, bc: 0, keyWidth: p, currentUnit: v, minDim: g, step: m },
        icon: `
            <svg viewBox="0 0 24 24">
              <path d="M8 2h8c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2m0 8v4h8v-4H8m0 6v4h8v-4H8M8 4v4h8V4H8z"></path>
            </svg>
          `,
        unstylable: ["width"],
        "stylable-require": ["flex-basis", "flex-item-behaviour", "flex-item-h-align", "flex-order"],
        traits: [
          {
            label: "Center content",
            name: "center-content",
            type: "checkbox",
            changeProp: !0
          }
        ],
        styles: `
            .${c} {
              flex: 1 1 0%;
              padding: 5px 0;
            }
          `
      },
      init() {
        this.listenTo(this, "change:center-content", this.handleCenter);
      },
      handleCenter() {
        const j = this.get("center-content");
        this.addStyle({
          display: j ? "flex" : "block",
          "align-items": j ? "center" : "",
          "justify-content": j ? "center" : ""
        });
      }
    }
  });
  const b = {
    label: o,
    content: {
      type: o,
      components: [{ type: i }, { type: i }, { type: i }]
    },
    ...t.block
  }, x = { merge: !0 }, w = (j) => {
    var C;
    return ((C = r.get(j)) == null ? void 0 : C.category) || b.category;
  };
  r.add(
    sS,
    {
      ...b,
      category: w(sS),
      content: {
        type: o,
        components: [{ type: i }]
      }
    },
    x
  ), r.add(
    iS,
    {
      ...b,
      category: w(iS),
      content: {
        type: o,
        components: [{ type: i }, { type: i }]
      }
    },
    x
  ), r.add(
    aS,
    {
      ...b,
      category: w(aS),
      content: {
        type: o,
        components: [{ type: i }, { type: i }, { type: i }]
      }
    },
    x
  ), r.add(
    J1,
    {
      ...b,
      category: w(J1),
      content: {
        type: o,
        components: [{ type: i, style: { "flex-basis": "30%", "flex-grow": 0 } }, { type: i }]
      }
    },
    x
  );
}, $c = "section", Tm = "container", Om = "gjs-section", Lm = "gjs-container", A$ = function(e, t = {}) {
  const { Components: n, Blocks: r } = e;
  r.add(
    $c,
    {
      label: $c,
      media: `
        <svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z" />
        </svg>
      `,
      content: { type: $c },
      ...t.block
    },
    { at: Gu(e, J1) + 1 }
  ), n.addType($c, {
    isComponent: (o) => Si(o, Om),
    model: {
      defaults: {
        tagName: "section",
        emptyState: !0,
        draggable: Vo("wrapper"),
        droppable: Vo(Tm),
        attributes: { class: Om },
        components: { type: Tm },
        styles: `
            .${Om} {
              display: flex;
              padding: 50px 0;
            }
          `
      }
    }
  }), n.addType(Tm, {
    isComponent: (o) => Si(o, Lm),
    model: {
      defaults: {
        emptyState: !0,
        copyable: !1,
        removable: !1,
        draggable: !1,
        attributes: { class: Lm },
        styles: `
            .${Lm} {
              width: 90%;
              margin: 0 auto;
              max-width: 1200px;
            }
          `
      }
    }
  });
}, R$ = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "divider", i = "gjs-divider";
  r.add(
    o,
    {
      label: o,
      media: `
        <svg viewBox="0 0 24 24">
          <path d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z" />
        </svg>
      `,
      content: { type: o },
      ...t.block
    },
    { at: Gu(e, $c) + 1 }
  ), n.addType(o, {
    isComponent: (l) => Si(l, i),
    model: {
      defaults: {
        droppable: !1,
        highlightable: !1,
        attributes: { class: i },
        stylable: [
          "height",
          "width",
          "background-color",
          "margin",
          "margin-top",
          "margin-right",
          "margin-bottom",
          "margin-left"
        ],
        styles: `
            .${i} {
              height: 3px;
              width: 100%;
              margin: 10px;
              background-color: rgba(0, 0, 0, 0.05);
            }
          `
      }
    }
  });
}, lS = "page://", N$ = function(e) {
  const { Components: t, Blocks: n } = e, o = t.getType("wrapper").model.getDefaults(), i = t.getType("head").model;
  t.addType("wrapper", {
    model: {
      defaults: {
        emptyState: { styleIn: "height: 100vh", styleOut: "padding: 0;" },
        stylable: [
          ...o.stylable,
          "padding",
          "font-family",
          "color",
          "font-size",
          "font-weight",
          "line-height",
          "letter-spacing",
          "text-align",
          "vertical-align",
          "text-decoration",
          "text-transform",
          "direction",
          "white-space"
        ]
      }
    }
  }), t.addType("head", {
    model: {
      components(p, g) {
        return i.prototype.components.call(this, p, {
          ...g,
          skipDomReset: !0
        });
      }
    },
    view: {
      updateContent() {
      }
    }
  }), t.addType("text", {
    model: {
      defaults: {
        highlightable: !1,
        emptyState: { styleIn: "min-height: auto; font-size: inherit;" }
      }
    }
  }), t.addType("image", {
    model: {
      defaults: {
        traits: [
          {
            type: "image",
            name: "src",
            label: "Image",
            typeProps: { inputField: !0 }
          },
          "alt",
          {
            type: "checkbox",
            name: "loading",
            valueTrue: "lazy"
          }
        ]
      }
    }
  });
  const c = t.getType("link").model;
  c.typeExtends.add("text"), t.addType("link", {
    model: {
      defaults: {
        emptyState: !0,
        traits: [
          "title",
          {
            type: "checkbox",
            name: "target",
            valueTrue: "_blank"
          },
          {
            type: "href",
            name: "href"
          }
        ]
      },
      getAttrToHTML() {
        const p = c.prototype.getAttrToHTML.apply(this), { href: g } = p;
        if (g && g.indexOf(lS) === 0) {
          const m = g.replace(lS, ""), v = e.Pages.get(m);
          p.href = v ? `./${q1(e, v)}` : "##";
        }
        return p;
      }
    }
  }), n.add(
    "link",
    {
      label: "Link",
      content: {
        type: "link",
        content: "Link",
        style: { color: "#d983a6", padding: "10px" }
      }
    },
    { merge: !0 }
  ), t.addType("select", {
    model: {
      defaults: {
        traits: [
          { name: "name" },
          {
            type: "checkbox",
            name: "required"
          },
          {
            name: "options",
            type: "stack",
            getValue({ component: p }) {
              return p.components().map((g) => ({
                id: g.getAttributes().value || "",
                label: g.getInnerHTML()
              }));
            },
            setValue: ({ component: p, value: g, emitUpdate: m }) => {
              p.components(
                g.map((v) => ({
                  type: "option",
                  content: v.label,
                  attributes: { value: v.id }
                }))
              ), m();
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            properties: [{ name: "id" }, { name: "label" }]
          }
        ]
      }
    }
  });
  const d = "contentEditable";
  t.addType(d, {
    extend: "text",
    model: {
      defaults: {
        name: "Content",
        tagName: "span",
        hoverable: !1,
        draggable: !1,
        selectable: !1
      },
      toHTML(p) {
        return this.getInnerHTML(p);
      }
    }
  }), t.addType("button", {
    model: {
      defaults: {
        components: [
          {
            type: d,
            components: { type: "textnode", content: "Button" }
          }
        ],
        traits: [
          {
            type: "select",
            name: "type",
            options: [
              { id: "button", label: "Button" },
              { id: "submit", label: "Submit" },
              { id: "reset", label: "Reset" }
            ]
          }
        ]
      },
      init() {
        var g;
        const p = [...this.components().models];
        (p.length > 1 || !((g = p[0]) != null && g.is(d))) && this.append({ type: d })[0].append(p);
      }
    }
  });
}, $$ = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "heading";
  r.add(
    o,
    {
      label: o,
      media: `
        <svg viewBox="0 0 24 24">
          <path d="M8.3 11.5h7.4V6.9l-.2-1.6a1 1 0 00-.5-.5c-.3-.2-.7-.3-1-.3h-.6v-.4h6.8v.4h-.6c-.4 0-.7.1-1 .3a1 1 0 00-.6.6L18 6.9v10.3c0 .8 0 1.3.2 1.6 0 .2.2.3.4.5.4.2.7.3 1.1.3h.6v.4h-6.8v-.4h.5c.7 0 1.2-.2 1.5-.6.2-.3.3-.9.3-1.8v-4.9H8.3v4.9l.1 1.6.5.5c.3.2.7.3 1 .3h.7v.4H3.7v-.4h.6c.7 0 1.1-.2 1.4-.6.2-.3.3-.9.3-1.8V6.9L6 5.3a1 1 0 00-.5-.5l-1-.3h-.7v-.4h6.9v.4H10c-.4 0-.8.1-1 .3a1 1 0 00-.6.6l-.1 1.5v4.6z"></path>
        </svg>
      `,
      content: { type: o, components: "Insert your text here" },
      ...t.block
    },
    { at: Gu(e, "text") }
  ), n.addType(o, {
    extend: "text",
    isComponent: (i) => Y8(i, "H1", "H2", "H3", "H4", "H5", "H6"),
    model: {
      defaults: {
        emptyState: !0,
        tagName: "h1",
        traits: [
          {
            type: "select",
            options: [
              { value: "h1", name: "One (largest)" },
              { value: "h2", name: "Two" },
              { value: "h3", name: "Three" },
              { value: "h4", name: "Four" },
              { value: "h5", name: "Five" },
              { value: "h6", name: "Six (smallest)" }
            ],
            label: "Size",
            name: "tagName",
            changeProp: !0
          }
        ]
      }
    }
  });
}, D$ = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = e.Components.getType("default").model, i = "imageBox", l = "gjs-image-box";
  r.add(
    i,
    {
      label: i,
      media: `
        <svg viewBox="0 0 24 24">
          <path d="M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z" />
        </svg>
      `,
      content: { type: i },
      ...t.block
    },
    { at: Gu(e, "image") + 1 }
  ), n.addType(i, {
    extend: "image",
    isComponent: (c) => Si(c, l),
    model: {
      defaults: {
        tagName: "div",
        void: !1,
        droppable: !0,
        emptyState: !1,
        resizable: { tl: 0, tc: 0, tr: 0, cl: 0, cr: 0, bl: 0, br: 0 },
        traits: ["title"],
        attributes: { class: l },
        styles: `
            .${l} {
              height: 200px;
              width: 100%;
            }
          `
      },
      getAttrToHTML(...c) {
        return o.prototype.getAttrToHTML.apply(this, c);
      }
    },
    view: {
      // @ts-ignore TODO ts
      tagName: "div",
      updateSrc() {
        const { model: c, em: d } = this, p = c.getSrcResult(), g = c.isDefaultSrc(), m = c.getStyle(), v = `url('${p}')`;
        p && c.addStyle({
          "background-image": g && m["background-image"] || v,
          "background-size": m["background-size"] || "contain",
          "background-position": m["background-position"] || "center center",
          "background-attachment": m["background-attachment"] || "scroll",
          "background-repeat": m["background-repeat"] || "no-repeat"
        }), p && d.trigger("component:toggled"), this.$el[p ? "removeClass" : "addClass"](this.classEmpty);
      },
      onRender() {
        this.renderChildren(), this.updateSrc();
      }
    }
  });
}, I$ = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "linkBox", i = "gjs-link-box";
  r.add(
    o,
    {
      label: o,
      media: `
        <svg viewBox="0 0 24 24">
          <path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M11,16H10C8.39,16 6,14.94 6,12C6,9.07 8.39,8 10,8H11V10H10C9.54,10 8,10.17 8,12C8,13.9 9.67,14 10,14H11V16M14,16H13V14H14C14.46,14 16,13.83 16,12C16,10.1 14.33,10 14,10H13V8H14C15.61,8 18,9.07 18,12C18,14.94 15.61,16 14,16M15,13H9V11H15V13Z" />
        </svg>
      `,
      content: { type: o },
      ...t.block
    },
    { at: Gu(e, "link") + 1 }
  ), n.addType(o, {
    isComponent: (l) => Si(l, i),
    extend: "link",
    model: {
      defaults: {
        editable: !1,
        droppable: !0,
        attributes: { class: i },
        styles: `
            .${i} {
              color: inherit;
              display: inline-block;
              vertical-align: top;
              padding: 10px;
              max-width: 100%;
              text-decoration: none;
            }
          `
      }
    }
  });
}, cS = (e) => {
  const t = (e || "").split(" ");
  let n = t[0], r = t[0], o = t[0], i = t[0];
  return t.length === 4 ? (n = t[0], r = t[1], o = t[2], i = t[3]) : t.length === 3 ? (n = t[0], r = t[1], i = t[1], o = t[2]) : t.length === 2 && (n = t[0], r = t[1], i = t[1], o = t[0]), [n, r, o, i];
};
function V$(e) {
  const t = {};
  if (e.padding) {
    const n = e.padding.split(" ");
    let r = n[0], o = n[0], i = n[0], l = n[0];
    n.length === 4 ? (r = n[0], o = n[1], i = n[2], l = n[3]) : n.length === 3 ? (r = n[0], o = n[1], l = n[1], i = n[2]) : n.length === 2 && (r = n[0], o = n[1], l = n[1], i = n[0]), t["padding-top"] = e["padding-top"] || r, t["padding-right"] = e["padding-right"] || o, t["padding-bottom"] = e["padding-bottom"] || i, t["padding-left"] = e["padding-left"] || l, delete e.padding;
  }
  return {
    ...e,
    ...t
  };
}
const H$ = { ratioDefault: !0, tc: !1, cl: !1, cr: !1, bc: !1 }, uS = `<svg viewBox="0 0 24 24">
  <path d="M16 9h3l-5 7m-4-7h4l-2 8M5 9h3l2 7m5-12h2l2 3h-3m-5-3h2l1 3h-4M7 4h2L8 7H5m1-5L2 8l10 14L22 8l-4-6H6z"></path>
</svg>`, F$ = function(e, t = {}) {
  const { Components: n, Blocks: r } = e, o = "icon", i = "gjs-icon", l = "data-type-icon";
  r.add(
    o,
    {
      label: "Icon",
      media: uS,
      content: { type: o },
      ...t.block
    }
    //{ at: getBlockIndex(editor, 'link') + 1 }
  ), n.addType(o, {
    isComponent: (c) => Si(c, i) || Wu(c, l),
    model: {
      defaults: {
        droppable: !1,
        attributes: { class: i, [l]: !0 },
        resizable: H$,
        components: uS,
        traits: [
          "id",
          "title",
          {
            type: "code",
            label: "Content",
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            typeProps: {
              language: "html",
              clean: !0,
              padding: 5
            },
            getValue({ component: c }) {
              return c.getInnerHTML();
            },
            setValue: Es(({ editor: c, component: d, value: p }) => {
              const g = c.Parser.parseHtml(p).html, m = Array.isArray(g) ? g[0] : g;
              m && m.tagName === "svg" && d.components(m);
            }, 500)
          }
        ],
        styles: `
            .${i} {
              display: inline-block;
              text-decoration: none;
              color: inherit;
              vertical-align: middle;
              fill: currentColor;
              width: 50px;
              height: 50px;
            }
          `
      },
      init() {
        this.listenTo(this.components(), "change add", this.disableLayers), this.disableLayers();
      },
      disableLayers() {
        this.components().forEach((c) => c.set("layerable", !1));
      }
    },
    view: {
      init() {
        const { model: c } = this;
        this.listenTo(c.components(), "change", this.disableChildren);
      },
      onRender() {
        this.disableChildren();
      },
      disableChildren() {
        this.model.components().forEach((c) => {
          var p;
          const d = (p = c.view) == null ? void 0 : p.el;
          d && (d.style.pointerEvents = "none");
        });
      }
    }
  });
}, Mm = "__nc", z$ = (e) => {
  const t = e.getAttributes({ noClass: !0, noStyle: !0 });
  return e.traits.forEach((n) => {
    const r = n.getName();
    n.get("changeProp") || delete t[r];
  }), delete t.id, delete t.__p, t;
};
function B$(e) {
  const { Components: t } = e, n = (r) => {
    const { model: o, id: i } = r, l = o.getDefaults();
    t.addType(i, {
      model: {
        defaults: {
          traits: [
            ...l.traits,
            {
              name: "customAttributes",
              type: "stack",
              getValue({ component: c }) {
                const d = z$(c);
                return Object.keys(d).map((g) => ({
                  id: g,
                  value: d[g]
                }));
              },
              setValue: ({ component: c, value: d, options: p, emitUpdate: g }) => {
                const m = p.removed, v = p.previous, b = p.item;
                if (m)
                  c.removeAttributes(m.id);
                else {
                  v && b && v.id !== b.id && c.removeAttributes(v.id);
                  const x = d.reduce((w, j) => (w[j.id] = j.value || "", w), {});
                  c.addAttributes(x);
                }
                g();
              },
              addItem: () => ({
                id: Mm,
                value: !1
              }),
              labelItem: (c) => c.id === Mm || !c.id && !c.value ? "- Empty -" : `${c.id || ""}="${c.value || ""}"`,
              properties: [
                {
                  name: "id",
                  label: "Name",
                  getValue: (c) => c === Mm ? "" : c,
                  setValue: (c, d) => c.trim().toLowerCase().replace(/^[^a-z]{1}/gi, "_").replace(/\s+/g, "-") || d
                },
                {
                  name: "value",
                  label: "Value",
                  getValue: (c) => typeof c == "boolean" ? "" : c
                }
              ]
            }
          ]
        }
      }
    });
  };
  t.getTypes().forEach(n);
}
const U$ = "Basic";
function Am(e, t) {
  const { appStore: n } = t;
  e.Css.getConfig().onBeforeStyle = V$;
  const r = e.Parser.getConfig().optionsHtml;
  r.htmlType = "text/html";
  const o = n.sdkOptions.pages || {};
  (Rn(o.allowDocuments) ? o.allowDocuments : !0) && (r.detectDocument = !0, r.allowScripts = !0), e.Components.addType("trait-check", {
    model: {
      defaults: {
        traits: [
          "id",
          "title",
          {
            type: "select",
            name: "select-type",
            options: [
              { id: "value1", label: "Value 1" },
              { id: "value2", label: "Value 2" },
              { id: "value3", label: "Value 3" }
            ]
          },
          {
            type: "number",
            name: "number-type",
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TODO ts
            units: ["px", "rem", "%"]
          },
          {
            type: "checkbox",
            name: "checkbox-type"
          },
          {
            type: "color",
            name: "color-type"
          },
          {
            type: "button",
            name: "button-type",
            label: "Delete",
            command: "core:component-delete"
          }
        ]
      }
    }
  });
  const l = { category: U$, select: !0, activate: !0 };
  J8(e, t), N$(e), M$(e, { block: l }), $$(e, { block: l }), A$(e, { block: l }), R$(e, { block: l }), D$(e, { block: l }), I$(e, { block: l }), F$(e, { block: l }), B$(e);
}
function W$(e) {
  const { code: t, appStore: n, showToastError: r } = e, { appEditorStore: o, toastStore: i, i18nStore: l } = n.store, { isProjectTypeEmail: c } = o, d = (t || "").trim(), p = new DOMParser(), g = { input: t, output: "", error: "" };
  let m = "";
  try {
    if (c) {
      const v = ME(d), x = p.parseFromString(`<div>${v}</div>`, "text/xml").querySelector("parsererror div");
      g.error = (x == null ? void 0 : x.textContent) || "", m = v;
    } else {
      const v = p.parseFromString(d, "text/html");
      IE(v.documentElement);
    }
  } catch (v) {
    g.error = v.message;
  }
  return g.error ? r && i.addError("error-parser", {
    header: l.t("actions.importCode.parseError"),
    content: g.error
  }) : g.output = m || d, g;
}
function IE(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return;
  const t = Array.from(e.attributes), n = Array.from(e.children);
  for (const r of t)
    e.setAttribute(r.name, r.value);
  for (const r of n)
    IE(r);
}
function G$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function dS(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dS(Object(n), !0).forEach(function(r) {
      G$(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dS(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function K$(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function q$(e, t) {
  if (e == null)
    return {};
  var n = K$(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Y$(e, t) {
  return X$(e) || Z$(e, t) || J$(e, t) || Q$();
}
function X$(e) {
  if (Array.isArray(e))
    return e;
}
function Z$(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, o = !1, i = void 0;
    try {
      for (var l = e[Symbol.iterator](), c; !(r = (c = l.next()).done) && (n.push(c.value), !(t && n.length === t)); r = !0)
        ;
    } catch (d) {
      o = !0, i = d;
    } finally {
      try {
        !r && l.return != null && l.return();
      } finally {
        if (o)
          throw i;
      }
    }
    return n;
  }
}
function J$(e, t) {
  if (e) {
    if (typeof e == "string")
      return pS(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return pS(e, t);
  }
}
function pS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Q$() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function e9(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function gS(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gS(Object(n), !0).forEach(function(r) {
      e9(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gS(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function t9() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return t.reduceRight(function(o, i) {
      return i(o);
    }, r);
  };
}
function Dc(e) {
  return function t() {
    for (var n = this, r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return o.length >= e.length ? e.apply(this, o) : function() {
      for (var l = arguments.length, c = new Array(l), d = 0; d < l; d++)
        c[d] = arguments[d];
      return t.apply(n, [].concat(o, c));
    };
  };
}
function mp(e) {
  return {}.toString.call(e).includes("Object");
}
function n9(e) {
  return !Object.keys(e).length;
}
function hu(e) {
  return typeof e == "function";
}
function r9(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function o9(e, t) {
  return mp(t) || bi("changeType"), Object.keys(t).some(function(n) {
    return !r9(e, n);
  }) && bi("changeField"), t;
}
function s9(e) {
  hu(e) || bi("selectorType");
}
function i9(e) {
  hu(e) || mp(e) || bi("handlerType"), mp(e) && Object.values(e).some(function(t) {
    return !hu(t);
  }) && bi("handlersType");
}
function a9(e) {
  e || bi("initialIsRequired"), mp(e) || bi("initialType"), n9(e) && bi("initialContent");
}
function l9(e, t) {
  throw new Error(e[t] || e.default);
}
var c9 = {
  initialIsRequired: "initial state is required",
  initialType: "initial state should be an object",
  initialContent: "initial state shouldn't be an empty object",
  handlerType: "handler should be an object or a function",
  handlersType: "all handlers should be a functions",
  selectorType: "selector should be a function",
  changeType: "provided value of changes should be an object",
  changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
  default: "an unknown error accured in `state-local` package"
}, bi = Dc(l9)(c9), vf = {
  changes: o9,
  selector: s9,
  handler: i9,
  initial: a9
};
function u9(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  vf.initial(e), vf.handler(t);
  var n = {
    current: e
  }, r = Dc(p9)(n, t), o = Dc(f9)(n), i = Dc(vf.changes)(e), l = Dc(d9)(n);
  function c() {
    var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(g) {
      return g;
    };
    return vf.selector(p), p(n.current);
  }
  function d(p) {
    t9(r, o, i, l)(p);
  }
  return [c, d];
}
function d9(e, t) {
  return hu(t) ? t(e.current) : t;
}
function f9(e, t) {
  return e.current = hS(hS({}, e.current), t), t;
}
function p9(e, t, n) {
  return hu(t) ? t(e.current) : Object.keys(n).forEach(function(r) {
    var o;
    return (o = t[r]) === null || o === void 0 ? void 0 : o.call(t, e.current[r]);
  }), n;
}
var g9 = {
  create: u9
}, h9 = {
  paths: {
    vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs"
  }
};
function m9(e) {
  return function t() {
    for (var n = this, r = arguments.length, o = new Array(r), i = 0; i < r; i++)
      o[i] = arguments[i];
    return o.length >= e.length ? e.apply(this, o) : function() {
      for (var l = arguments.length, c = new Array(l), d = 0; d < l; d++)
        c[d] = arguments[d];
      return t.apply(n, [].concat(o, c));
    };
  };
}
function v9(e) {
  return {}.toString.call(e).includes("Object");
}
function y9(e) {
  return e || mS("configIsRequired"), v9(e) || mS("configType"), e.urls ? (b9(), {
    paths: {
      vs: e.urls.monacoBase
    }
  }) : e;
}
function b9() {
  console.warn(VE.deprecation);
}
function x9(e, t) {
  throw new Error(e[t] || e.default);
}
var VE = {
  configIsRequired: "the configuration object is required",
  configType: "the configuration object should be an object",
  default: "an unknown error accured in `@monaco-editor/loader` package",
  deprecation: `Deprecation warning!
    You are using deprecated way of configuration.

    Instead of using
      monaco.config({ urls: { monacoBase: '...' } })
    use
      monaco.config({ paths: { vs: '...' } })

    For more please check the link https://github.com/suren-atoyan/monaco-loader#config
  `
}, mS = m9(x9)(VE), w9 = {
  config: y9
}, S9 = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return function(o) {
    return n.reduceRight(function(i, l) {
      return l(i);
    }, o);
  };
};
function HE(e, t) {
  return Object.keys(t).forEach(function(n) {
    t[n] instanceof Object && e[n] && Object.assign(t[n], HE(e[n], t[n]));
  }), fS(fS({}, e), t);
}
var j9 = {
  type: "cancelation",
  msg: "operation is manually canceled"
};
function Rm(e) {
  var t = !1, n = new Promise(function(r, o) {
    e.then(function(i) {
      return t ? o(j9) : r(i);
    }), e.catch(o);
  });
  return n.cancel = function() {
    return t = !0;
  }, n;
}
var C9 = g9.create({
  config: h9,
  isInitialized: !1,
  resolve: null,
  reject: null,
  monaco: null
}), FE = Y$(C9, 2), qu = FE[0], Qp = FE[1];
function E9(e) {
  var t = w9.config(e), n = t.monaco, r = q$(t, ["monaco"]);
  Qp(function(o) {
    return {
      config: HE(o.config, r),
      monaco: n
    };
  });
}
function P9() {
  var e = qu(function(t) {
    var n = t.monaco, r = t.isInitialized, o = t.resolve;
    return {
      monaco: n,
      isInitialized: r,
      resolve: o
    };
  });
  if (!e.isInitialized) {
    if (Qp({
      isInitialized: !0
    }), e.monaco)
      return e.resolve(e.monaco), Rm(Nm);
    if (window.monaco && window.monaco.editor)
      return zE(window.monaco), e.resolve(window.monaco), Rm(Nm);
    S9(_9, T9)(O9);
  }
  return Rm(Nm);
}
function _9(e) {
  return document.body.appendChild(e);
}
function k9(e) {
  var t = document.createElement("script");
  return e && (t.src = e), t;
}
function T9(e) {
  var t = qu(function(r) {
    var o = r.config, i = r.reject;
    return {
      config: o,
      reject: i
    };
  }), n = k9("".concat(t.config.paths.vs, "/loader.js"));
  return n.onload = function() {
    return e();
  }, n.onerror = t.reject, n;
}
function O9() {
  var e = qu(function(n) {
    var r = n.config, o = n.resolve, i = n.reject;
    return {
      config: r,
      resolve: o,
      reject: i
    };
  }), t = window.require;
  t.config(e.config), t(["vs/editor/editor.main"], function(n) {
    zE(n), e.resolve(n);
  }, function(n) {
    e.reject(n);
  });
}
function zE(e) {
  qu().monaco || Qp({
    monaco: e
  });
}
function L9() {
  return qu(function(e) {
    var t = e.monaco;
    return t;
  });
}
var Nm = new Promise(function(e, t) {
  return Qp({
    resolve: e,
    reject: t
  });
}), BE = {
  config: E9,
  init: P9,
  __getMonacoInstance: L9
}, M9 = { wrapper: { display: "flex", position: "relative", textAlign: "initial" }, fullWidth: { width: "100%" }, hide: { display: "none" } }, $m = M9, A9 = { container: { display: "flex", height: "100%", width: "100%", justifyContent: "center", alignItems: "center" } }, R9 = A9;
function N9({ children: e }) {
  return Q.createElement("div", { style: R9.container }, e);
}
var $9 = N9, D9 = $9;
function I9({ width: e, height: t, isEditorReady: n, loading: r, _ref: o, className: i, wrapperProps: l }) {
  return Q.createElement("section", { style: { ...$m.wrapper, width: e, height: t }, ...l }, !n && Q.createElement(D9, null, r), Q.createElement("div", { ref: o, style: { ...$m.fullWidth, ...!n && $m.hide }, className: i }));
}
var V9 = I9, UE = y.memo(V9);
function H9(e) {
  y.useEffect(e, []);
}
var WE = H9;
function F9(e, t, n = !0) {
  let r = y.useRef(!0);
  y.useEffect(r.current || !n ? () => {
    r.current = !1;
  } : e, t);
}
var wr = F9;
function Wc() {
}
function il(e, t, n, r) {
  return z9(e, r) || B9(e, t, n, r);
}
function z9(e, t) {
  return e.editor.getModel(GE(e, t));
}
function B9(e, t, n, r) {
  return e.editor.createModel(t, n, r ? GE(e, r) : void 0);
}
function GE(e, t) {
  return e.Uri.parse(t);
}
function U9({ original: e, modified: t, language: n, originalLanguage: r, modifiedLanguage: o, originalModelPath: i, modifiedModelPath: l, keepCurrentOriginalModel: c = !1, keepCurrentModifiedModel: d = !1, theme: p = "light", loading: g = "Loading...", options: m = {}, height: v = "100%", width: b = "100%", className: x, wrapperProps: w = {}, beforeMount: j = Wc, onMount: C = Wc }) {
  let [E, P] = y.useState(!1), [k, T] = y.useState(!0), O = y.useRef(null), A = y.useRef(null), $ = y.useRef(null), N = y.useRef(C), R = y.useRef(j), z = y.useRef(!1);
  WE(() => {
    let H = BE.init();
    return H.then((q) => (A.current = q) && T(!1)).catch((q) => (q == null ? void 0 : q.type) !== "cancelation" && console.error("Monaco initialization: error:", q)), () => O.current ? K() : H.cancel();
  }), wr(() => {
    if (O.current && A.current) {
      let H = O.current.getOriginalEditor(), q = il(A.current, e || "", r || n || "text", i || "");
      q !== H.getModel() && H.setModel(q);
    }
  }, [i], E), wr(() => {
    if (O.current && A.current) {
      let H = O.current.getModifiedEditor(), q = il(A.current, t || "", o || n || "text", l || "");
      q !== H.getModel() && H.setModel(q);
    }
  }, [l], E), wr(() => {
    let H = O.current.getModifiedEditor();
    H.getOption(A.current.editor.EditorOption.readOnly) ? H.setValue(t || "") : t !== H.getValue() && (H.executeEdits("", [{ range: H.getModel().getFullModelRange(), text: t || "", forceMoveMarkers: !0 }]), H.pushUndoStop());
  }, [t], E), wr(() => {
    var H, q;
    (q = (H = O.current) == null ? void 0 : H.getModel()) == null || q.original.setValue(e || "");
  }, [e], E), wr(() => {
    let { original: H, modified: q } = O.current.getModel();
    A.current.editor.setModelLanguage(H, r || n || "text"), A.current.editor.setModelLanguage(q, o || n || "text");
  }, [n, r, o], E), wr(() => {
    var H;
    (H = A.current) == null || H.editor.setTheme(p);
  }, [p], E), wr(() => {
    var H;
    (H = O.current) == null || H.updateOptions(m);
  }, [m], E);
  let D = y.useCallback(() => {
    var te;
    if (!A.current)
      return;
    R.current(A.current);
    let H = il(A.current, e || "", r || n || "text", i || ""), q = il(A.current, t || "", o || n || "text", l || "");
    (te = O.current) == null || te.setModel({ original: H, modified: q });
  }, [n, t, o, e, r, i, l]), Z = y.useCallback(() => {
    var H;
    !z.current && $.current && (O.current = A.current.editor.createDiffEditor($.current, { automaticLayout: !0, ...m }), D(), (H = A.current) == null || H.editor.setTheme(p), P(!0), z.current = !0);
  }, [m, p, D]);
  y.useEffect(() => {
    E && N.current(O.current, A.current);
  }, [E]), y.useEffect(() => {
    !k && !E && Z();
  }, [k, E, Z]);
  function K() {
    var q, te, I, F;
    let H = (q = O.current) == null ? void 0 : q.getModel();
    c || ((te = H == null ? void 0 : H.original) == null || te.dispose()), d || ((I = H == null ? void 0 : H.modified) == null || I.dispose()), (F = O.current) == null || F.dispose();
  }
  return Q.createElement(UE, { width: b, height: v, isEditorReady: E, loading: g, _ref: $, className: x, wrapperProps: w });
}
var W9 = U9;
y.memo(W9);
function G9(e) {
  let t = y.useRef();
  return y.useEffect(() => {
    t.current = e;
  }, [e]), t.current;
}
var K9 = G9, yf = /* @__PURE__ */ new Map();
function q9({ defaultValue: e, defaultLanguage: t, defaultPath: n, value: r, language: o, path: i, theme: l = "light", line: c, loading: d = "Loading...", options: p = {}, overrideServices: g = {}, saveViewState: m = !0, keepCurrentModel: v = !1, width: b = "100%", height: x = "100%", className: w, wrapperProps: j = {}, beforeMount: C = Wc, onMount: E = Wc, onChange: P, onValidate: k = Wc }) {
  let [T, O] = y.useState(!1), [A, $] = y.useState(!0), N = y.useRef(null), R = y.useRef(null), z = y.useRef(null), D = y.useRef(E), Z = y.useRef(C), K = y.useRef(), H = y.useRef(r), q = K9(i), te = y.useRef(!1), I = y.useRef(!1);
  WE(() => {
    let L = BE.init();
    return L.then((W) => (N.current = W) && $(!1)).catch((W) => (W == null ? void 0 : W.type) !== "cancelation" && console.error("Monaco initialization: error:", W)), () => R.current ? V() : L.cancel();
  }), wr(() => {
    var W, ie, re, le;
    let L = il(N.current, e || r || "", t || o || "", i || n || "");
    L !== ((W = R.current) == null ? void 0 : W.getModel()) && (m && yf.set(q, (ie = R.current) == null ? void 0 : ie.saveViewState()), (re = R.current) == null || re.setModel(L), m && ((le = R.current) == null || le.restoreViewState(yf.get(i))));
  }, [i], T), wr(() => {
    var L;
    (L = R.current) == null || L.updateOptions(p);
  }, [p], T), wr(() => {
    !R.current || r === void 0 || (R.current.getOption(N.current.editor.EditorOption.readOnly) ? R.current.setValue(r) : r !== R.current.getValue() && (I.current = !0, R.current.executeEdits("", [{ range: R.current.getModel().getFullModelRange(), text: r, forceMoveMarkers: !0 }]), R.current.pushUndoStop(), I.current = !1));
  }, [r], T), wr(() => {
    var W, ie;
    let L = (W = R.current) == null ? void 0 : W.getModel();
    L && o && ((ie = N.current) == null || ie.editor.setModelLanguage(L, o));
  }, [o], T), wr(() => {
    var L;
    c !== void 0 && ((L = R.current) == null || L.revealLine(c));
  }, [c], T), wr(() => {
    var L;
    (L = N.current) == null || L.editor.setTheme(l);
  }, [l], T);
  let F = y.useCallback(() => {
    var L;
    if (!(!z.current || !N.current) && !te.current) {
      Z.current(N.current);
      let W = i || n, ie = il(N.current, r || e || "", t || o || "", W || "");
      R.current = (L = N.current) == null ? void 0 : L.editor.create(z.current, { model: ie, automaticLayout: !0, ...p }, g), m && R.current.restoreViewState(yf.get(W)), N.current.editor.setTheme(l), c !== void 0 && R.current.revealLine(c), O(!0), te.current = !0;
    }
  }, [e, t, n, r, o, i, p, g, m, l, c]);
  y.useEffect(() => {
    T && D.current(R.current, N.current);
  }, [T]), y.useEffect(() => {
    !A && !T && F();
  }, [A, T, F]), H.current = r, y.useEffect(() => {
    var L, W;
    T && P && ((L = K.current) == null || L.dispose(), K.current = (W = R.current) == null ? void 0 : W.onDidChangeModelContent((ie) => {
      I.current || P(R.current.getValue(), ie);
    }));
  }, [T, P]), y.useEffect(() => {
    if (T) {
      let L = N.current.editor.onDidChangeMarkers((W) => {
        var re;
        let ie = (re = R.current.getModel()) == null ? void 0 : re.uri;
        if (ie && W.find((le) => le.path === ie.path)) {
          let le = N.current.editor.getModelMarkers({ resource: ie });
          k == null || k(le);
        }
      });
      return () => {
        L == null || L.dispose();
      };
    }
    return () => {
    };
  }, [T, k]);
  function V() {
    var L, W;
    (L = K.current) == null || L.dispose(), v ? m && yf.set(i, R.current.saveViewState()) : (W = R.current.getModel()) == null || W.dispose(), R.current.dispose();
  }
  return Q.createElement(UE, { width: b, height: x, isEditorReady: T, loading: d, _ref: z, className: w, wrapperProps: j });
}
var Y9 = q9, X9 = y.memo(Y9), Z9 = X9;
const KE = (e) => {
  var t;
  (t = e.getAction("editor.action.formatDocument")) == null || t.run();
}, J9 = "gs-field-code", Q9 = {
  minimap: { enabled: !1 },
  lineNumbers: "off",
  scrollBeyondLastLine: !1,
  contextmenu: !1,
  fixedOverflowWidgets: !0,
  // Render widgets outside of the container
  showFoldingControls: "always",
  suggestOnTriggerCharacters: !1,
  lineDecorationsWidth: 0,
  renderLineHighlight: "none",
  wordWrapOverride1: "off",
  // disable wordWrap
  tabSize: 2,
  // formatOnType: true,
  // formatOnPaste: true,
  // autoIndent: true,
  scrollbar: {
    verticalScrollbarSize: 8,
    horizontal: "hidden",
    alwaysConsumeMouseWheel: !1
  }
  // readOnly: true,
  // language: 'json',
  // lineNumbers: (lineNumber: number) => lineNumber.toString(),
  // lineNumbersMinChars: 5,
  // selectOnLineNumbers: false,
  // matchBrackets: 'never',
};
function As(e) {
  const {
    defaultValue: t,
    value: n,
    language: r,
    onChange: o,
    clean: i,
    padding: l,
    isDarkTheme: c,
    className: d,
    containerClassName: p,
    minHeight: g = "170px",
    onMount: m,
    readOnly: v,
    name: b,
    required: x,
    disabled: w,
    formatOnMount: j = !0,
    monacoOptions: C,
    labelAs: E
  } = e, P = n !== void 0, k = r, T = P ? n : t, O = typeof T == "string" ? T : JSON.stringify(T ?? "", null, 2), A = Li({
    ...e,
    className: B(J9, "gs-utl-flex gs-utl-h-full", p, !e.row && "gs-utl-flex gs-utl-flex-col")
  }), $ = B("gs-utl-relative gs-utl-flex-grow");
  return (
    // This 3 div container fixes problems with autolayout, like not shrinking width on resize.
    /* @__PURE__ */ u.jsxs("div", { ...A, children: [
      /* @__PURE__ */ u.jsx(Eo, { ...e, as: E }),
      /* @__PURE__ */ u.jsxs("div", { className: $, style: { minHeight: g }, children: [
        b && /* @__PURE__ */ u.jsx(
          "input",
          {
            className: nt.hiddenVisually,
            name: b,
            value: O,
            disabled: w,
            required: x,
            onChange: () => {
            }
          }
        ),
        /* @__PURE__ */ u.jsx("div", { className: B("gs-utl-absolute gs-utl-inset-0", w && nt.disabled), children: /* @__PURE__ */ u.jsx(
          Z9,
          {
            ...P ? { language: k, value: O } : { defaultLanguage: k, defaultValue: O },
            theme: c ? "vs-dark" : "light",
            className: B(ve.b, ve.rnd, ee.br, d),
            options: {
              ...Q9,
              readOnly: v,
              ...i && {
                domReadOnly: !0,
                // disables "Cannot edit in read-only editor" tooltip when typing
                overviewRulerLanes: 0,
                // disable the right side ruler
                selectOnLineNumbers: !1,
                folding: !1,
                matchBrackets: "never",
                guides: {
                  indentation: !1
                }
              },
              ...Rn(l) && {
                lineDecorationsWidth: l * 2,
                padding: {
                  top: l,
                  bottom: l
                }
              },
              ...C
            },
            onChange: o,
            onMount: (N, R) => {
              if (j) {
                let z = !1;
                const D = () => KE(N);
                N.onDidChangeModelLanguageConfiguration(D), N.onDidScrollChange(() => {
                  z || (z = !0, D());
                }), setTimeout(D, 10);
              }
              m == null || m(N, R);
            }
          }
        ) })
      ] })
    ] })
  );
}
const qE = xe(function({ buttonProps: t, content: n, code: r, onAction: o }) {
  const i = os(), l = qe(), c = Re(), { isProjectTypeEmail: d } = c, p = c.editor, { isDarkTheme: g } = gr(), [m, v] = y.useState(), b = () => {
    let w = (m || "").trim();
    const j = W$({ code: w, appStore: c, showToastError: !0 });
    if (!j.error)
      w = j.output;
    else
      return;
    o ? o(w) : d ? p.loadProjectData({ pages: [{ component: w }] }) : p.setComponents(w), i.close();
  };
  y.useEffect(() => {
    r ? v(r) : (async () => {
      var k, T;
      const j = await p.runCommand(ke.projectFiles, {
        page: p.Pages.getSelected(),
        skipProject: !0,
        styles: "inline"
      }), C = (k = j.find((O) => O.mimeType === "text/html")) == null ? void 0 : k.content, E = (T = j.find((O) => O.mimeType === "text/mjml")) == null ? void 0 : T.content, P = d ? E : C;
      P && v(P);
    })();
  }, []);
  const x = (t == null ? void 0 : t.children) || l.t("actions.importCode.button");
  return /* @__PURE__ */ u.jsxs(G, { col: !0, space: "m", children: [
    /* @__PURE__ */ u.jsx(Y, { children: n ?? l.t("actions.importCode.content") }),
    /* @__PURE__ */ u.jsx(Y, { className: ce("h-96"), children: m !== void 0 && /* @__PURE__ */ u.jsx(
      As,
      {
        defaultValue: m,
        onChange: (w) => v(w || ""),
        isDarkTheme: g,
        language: "html"
      }
    ) }),
    /* @__PURE__ */ u.jsx(G, { justify: "end", children: /* @__PURE__ */ u.jsx(ut, { size: "m2", variant: "pr", onClick: b, ...t, children: x }) })
  ] });
}), Q1 = "data-type-empty", vS = (e, t) => {
  e.Canvas.getFrames().forEach((n) => {
    const { view: r } = n, o = Array.from(r.getDoc().querySelectorAll(`style[${Q1}]`));
    for (const i of o)
      i.disabled = !t;
  });
}, e7 = (e, t, n = "Empty", r = {}) => {
  const o = `[${Q1}="${t}"]`;
  if (!e.frameView.getDoc())
    return;
  const i = e.frameView.getHead(), { midSelector: l = "", styleOut: c = "", styleIn: d = "" } = r;
  if (!i.querySelector(`style${o}`)) {
    const p = document.createElement("style");
    p.setAttribute(Q1, t), p.innerHTML = `
    [data-gjs-type="${t}"]${l}:empty {
      text-decoration: none;
      padding: 5px;
      ${r.limitW ? "min-width: 50px;" : ""}
      ${c}
    }
    [data-gjs-type="${t}"]${l}:empty:before {
      background-color: #ddd;
      color: #000;
      font-size: 16px;
      font-weight: bold;
      font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", "Open Sans", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 30px;
      padding: 0 10px;
      opacity: 0.3;
      border-radius: 3px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      content: "${n}";
      ${r.limitH ? "height: auto;" : ""}
      ${r.smallH ? "min-height: 30px;" : ""}
      ${d}
    }`, i.appendChild(p);
  }
}, YE = (e, t) => {
  const { model: n } = t, r = n.constructor.getDefaults(), o = r.emptyState, i = n.get("type");
  if (!o || r.void === !0 || i !== e)
    return;
  const l = o === !0 ? {} : o;
  e7(t, i, n.getName({ noCustom: !0 }), l);
}, t7 = function(t) {
  const { Components: n } = t, r = (o) => {
    const { id: i } = o;
    n.addType(i, {
      extendFnView: ["onRender"],
      view: {
        onRender() {
          YE(i, this);
        }
      }
    });
  };
  n.getTypes().forEach(r), t.on("component:type:add", r);
};
function n7(e, t) {
  const { Components: n } = e, r = n.events, { modalStore: o, i18nStore: i, fontsStore: l } = t.appStore.store, { root: c, head: d, body: p } = gu, {
    attributes: g,
    class: m,
    font: v,
    all: b,
    preview: x,
    title: w,
    style: j,
    breakpoint: C
  } = T0, {
    section: E,
    column: P,
    text: k,
    button: T,
    image: O,
    divider: A,
    group: $,
    social: N,
    socialElement: R,
    spacer: z,
    navbar: D,
    navbarLink: Z,
    raw: K
  } = AE, { model: H } = n.getType("default"), { model: q } = n.getType(c), { model: te, view: I } = n.getType(d), { model: F, view: V } = n.getType(D), { model: L, view: W } = n.getType(Z), { model: ie, view: re } = n.getType(E), { model: le, view: me } = n.getType(P), { model: oe, view: se } = n.getType(k), { model: de, view: we } = n.getType(T), { model: je, view: He } = n.getType(A), { model: Le, view: ot } = n.getType(z), { view: vt, model: zt } = n.getType(N), { view: Ot, model: ct } = n.getType(R), { view: vn, model: St } = n.getType($), At = "css-class", en = {
    id: "link",
    name: "href",
    label: "Link",
    placeholder: "Link to redirect on click"
  }, Bt = {
    name: "src",
    changeProp: !0,
    type: "image",
    label: "Image"
  }, Et = {
    label: "Content",
    getValue: ({ component: pe }) => pe.getInnerHTML(),
    setValue: ({ component: pe, value: _e }) => pe.components(_e)
  }, it = (pe) => {
    o.open({
      title: pe.getName({ noCustom: !0 }),
      content: () => /* @__PURE__ */ u.jsx(
        qE,
        {
          content: "",
          code: pe.getInnerHTML(),
          onAction: (_e) => pe.components(_e),
          buttonProps: { children: i.t("save") }
        }
      )
    });
  }, Lt = (pe) => {
    var Oe;
    const _e = pe.getChildrenContainer();
    ((Oe = _e == null ? void 0 : _e.innerHTML) == null ? void 0 : Oe.trim()) === "" && (_e.innerHTML = "");
  }, Ut = (pe) => pe.set({ void: !1 }, { silent: !0 });
  function yn(pe = {}) {
    return H.prototype.toHTML.call(this, pe);
  }
  function Bn(pe) {
    const _e = pe.closestType(c), Oe = _e == null ? void 0 : _e.findType(d)[0];
    return (Oe == null ? void 0 : Oe.toHTML()) || "";
  }
  function Zn(pe) {
    const _e = pe.toHTML(), Oe = e.runCommand(S$, { mjml: _e }), fn = new DOMParser().parseFromString(Oe.html, "text/html");
    return {
      mjml: _e,
      mjmlToHtml: Oe,
      document: fn
    };
  }
  const Jn = function(pe) {
    const _e = pe.model, Oe = Es(() => {
      var Ye;
      return (Ye = _e.closestType(c)) == null ? void 0 : Ye.trigger("rerender");
    });
    pe.listenTo(_e.components(), "add remove reset change", Oe);
  }, oo = (pe, _e) => pe.replace(`<${c}>`, `<${c}>${Bn(_e)}`), as = (pe) => `cls-${pe.tagName}-${pe.getId()}`, Ni = (pe, _e) => {
    const Oe = _e.prototype.getMjmlAttributes.call(pe);
    return { ...Oe, [At]: `${Oe[At] || ""} ${as(pe)}`.trim() };
  }, nn = (pe, _e) => {
    const Oe = pe.closestType(c), Ye = (Oe == null ? void 0 : Oe.findFirstType(d)) || (Oe == null ? void 0 : Oe.append({ type: d })[0]);
    Ye == null || Ye.trigger(_e ? "rerenderHeadImmediate" : "rerenderHead");
  }, It = (pe) => function() {
    return Ni(this, pe);
  }, Mt = (pe, _e) => function(Oe) {
    const Ye = Oe.querySelector(`.${as(this.model)}`);
    return (_e ? Ye : Ye == null ? void 0 : Ye.outerHTML) || pe.prototype.getTemplateFromEl.call(this, Oe);
  }, at = (pe) => function(..._e) {
    const Oe = pe.prototype.toJSON.apply(this, _e), Ye = Oe.attributes || {};
    return delete Oe.style, delete Ye.style, delete Ye.__p, Oe;
  }, bn = (pe) => function(..._e) {
    const Oe = pe.prototype.getAttrToHTML.apply(this, _e);
    return delete Oe.__p, Oe;
  };
  function $n() {
    return {
      start: `<mjml>${Bn(this.model)}<mj-body><mj-column>`,
      end: "</mj-column></mj-body></mjml>"
    };
  }
  const rn = (pe, _e = {}) => {
    var $r;
    const Oe = pe.parents().filter((wn) => wn.tagName.startsWith("mj-")), Ye = Oe.map((wn) => `<${wn.tagName}>`).reverse().join(""), fn = Oe.map((wn) => `</${wn.tagName}>`).join(""), ln = _e.withHead ? Bn(pe) : "", xn = _e.withSiblings ? ($r = pe.parent()) == null ? void 0 : $r.components().filter((wn) => wn !== pe).map(({ tagName: wn }) => `<${wn}></${wn}>`).join("") : "";
    return {
      start: `<${c}>${ln}${Ye}`,
      end: `${xn || ""}${fn}${_e.beforeRootEnd || ""}</${c}>`
    };
  };
  n.addType("wrapper", {
    extendFn: ["init"],
    model: {
      defaults: {
        stylable: !1,
        delegate: {
          layer: (pe) => pe.findType(c)[0]
        }
      },
      init() {
        this.on(`${r.update}:components`, this.__updateLayersRoot);
      },
      __updateLayersRoot() {
        this.findFirstType(c) && e.Layers.setRoot(this);
      }
    }
  }), n.addType(c, {
    model: {
      defaults: {
        tagName: c,
        name: "Root",
        toolbar: []
      },
      toHTML: yn,
      toJSON: at(q)
    },
    view: {
      reset() {
        this.render();
      }
    }
  }), n.addType(d, {
    model: {
      defaults: {
        tagName: d,
        name: "Head",
        copyable: !1,
        stylable: !1,
        traits: [],
        icon: `<svg viewBox="0 0 24 24">
          <path d="M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z" />
        </svg>`
      },
      toJSON: at(te)
    },
    view: {
      init() {
        this.renderHeadDebounced = Es(this.renderHead, 30);
        const { em: pe, el: _e, model: Oe } = this, Ye = Oe.components(), fn = "core:preview", ln = pe.Commands.events;
        this.listenTo(pe, `${ln.runCommand}${fn}`, () => {
          _e.style.display = "none";
        }), this.listenTo(pe, `${ln.stopCommand}${fn}`, () => {
          _e.style.display = "";
        }), this.listenTo(Ye, "change", this.onComponentsChange), this.listenTo(Ye, "add remove reset", this.renderHead), this.listenTo(Oe, "rerenderHead", this.renderHeadDebounced), this.listenTo(Oe, "rerenderHeadImmediate", this.renderHead);
      },
      onComponentsChange(pe) {
        const _e = Object.keys(pe.changedAttributes());
        _e.length === 1 && _e[0] === "status" || this.renderHead();
      },
      /**
       * Render MJML head result into a separate DOM element
       */
      renderHead() {
        var $r;
        const { model: pe, el: _e } = this, Oe = _e.ownerDocument;
        if (!(Oe && Oe !== document))
          return;
        const fn = pe.closestType(c), ln = fn && Zn(fn), xn = ($r = ln == null ? void 0 : ln.document) == null ? void 0 : $r.head;
        if (xn) {
          const wn = "mjml-head-result", $i = Oe.querySelector(wn) || Oe.createElement(wn);
          $i.innerHTML = xn.innerHTML, !Oe.head.contains($i) && Oe.head.prepend($i);
        }
      },
      render(...pe) {
        const _e = I.prototype.render.apply(this, pe);
        return this.renderHeadDebounced(), _e;
      }
    }
  }), n.addType(g, {
    isComponent: Xa(g),
    model: {
      defaults: {
        tagName: g,
        name: "Attributes",
        copyable: !1,
        layerable: !1,
        stylable: !1,
        draggable: Vo(d),
        traits: []
      },
      toJSON: at(H)
    },
    view: {
      onRender() {
        this.el.style.display = "none";
      },
      init() {
        Jn(this);
      }
    }
  }), n.addType(m, {
    isComponent: Xa(m),
    model: {
      defaults: {
        tagName: m,
        name: "Class",
        stylable: !1,
        draggable: Vo(g),
        traits: []
      },
      toJSON: at(H)
    }
  }), n.addType(v, {
    model: {
      defaults: {
        tagName: v,
        name: "Font",
        stylable: !1,
        draggable: Vo(d),
        icon: '<svg viewBox="0 0 24 24"><path d="M17 8h3v12h1v1h-4v-1h1v-3h-4l-1.5 3H14v1h-4v-1h1l6-12m1 1-3.5 7H18V9M5 3h5a2 2 0 0 1 2 2v11H9v-5H6v5H3V5a2 2 0 0 1 2-2m1 2v4h3V5H6Z"/></svg>',
        traits: [
          {
            name: "name",
            placeholder: "Name of the font"
          },
          {
            name: "href",
            placeholder: "URL of a hosted CSS file"
          }
        ]
      },
      toJSON: at(H)
    },
    view: {
      tagName: () => "div",
      render() {
        return this.el.style.cssText = "", this;
      }
    }
  }), n.addType(C, {
    extend: c,
    isComponent: Xa(C),
    model: {
      defaults: {
        tagName: C,
        name: "Breakpoint",
        stylable: ["width"],
        removable: !0,
        droppable: !1,
        draggable: Vo(d),
        icon: '<svg viewBox="0 0 24 24"><path d="M22,17H18V10H22M23,8H17A1,1 0 0,0 16,9V19A1,1 0 0,0 17,20H23A1,1 0 0,0 24,19V9A1,1 0 0,0 23,8M4,6H22V4H4A2,2 0 0,0 2,6V17H0V20H14V17H4V6Z" /></svg>',
        traits: []
      }
    },
    view: {
      attributes: {},
      render() {
        return this.el.style.cssText = "", this;
      }
    }
  }), n.addType(b, {
    isComponent: Xa(b),
    model: {
      defaults: {
        tagName: b,
        name: "All",
        stylable: !1,
        void: !0,
        draggable: Vo(g),
        traits: []
      },
      toHTML(...pe) {
        return q.prototype.toHTML.apply(this, pe);
      },
      toJSON: at(H)
    }
  }), n.addType(x, {
    isComponent: Xa(x),
    model: {
      defaults: {
        tagName: x,
        name: "Preview",
        copyable: !1,
        droppable: !1,
        stylable: !1,
        draggable: Vo(d),
        traits: [Et],
        icon: `<svg viewBox="0 0 24 24">
          <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
        </svg>`
      },
      toJSON: at(H)
    },
    view: {
      tagName: () => "div",
      init() {
        const pe = this.model.components();
        this.onRender = Es(this.onRender, 1), this.listenTo(pe, "add remove reset change", this.onRender);
      },
      onRender() {
        const { model: pe, el: _e } = this, Oe = pe.getName({ noCustom: !0 }), Ye = pe.getInnerHTML();
        _e.innerHTML = `<b>${Oe}</b>: ${Ye}`, _e.style.padding = "5px 10px", _e.style.fontFamily = "system-ui";
      }
    }
  }), n.addType(w, {
    isComponent: Xa(w),
    extend: x,
    model: {
      defaults: {
        tagName: w,
        name: "Title",
        icon: '<svg viewBox="0 0 24 24"><path d="M5,4V7H10.5V19H13.5V7H19V4H5Z" /></svg>'
      }
    }
  }), n.addType(j, {
    model: {
      defaults: {
        tagName: j,
        name: "Style",
        droppable: !1,
        layerable: !1,
        stylable: !1,
        traits: []
      },
      toJSON: at(H)
    },
    view: {
      render() {
        return this;
      }
    }
  }), n.addType(p, {
    extendFn: ["init"],
    model: {
      defaults: {
        tagName: p,
        icon: `<svg viewBox="0 0 24 24">
          <path d="M6,2H18A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M6,8V16H18V8H6Z" />
        </svg>`,
        traits: [],
        emptyState: {
          midSelector: ">div",
          styleOut: "height: 100vh;"
        }
      },
      init() {
        Ut(this);
      },
      toJSON: at(H)
    }
  }), n.addType(E, {
    extendFn: ["init"],
    model: {
      defaults: {
        tagName: E,
        "style-default": {
          padding: "20px 0px",
          "text-align": "center"
        },
        icon: `<svg viewBox="0 0 24 24">
          <path d="M2,3V6H21V3M20,8H3A1,1 0 0,0 2,9V15A1,1 0 0,0 3,16H20A1,1 0 0,0 21,15V9A1,1 0 0,0 20,8M2,21H21V18H2V21Z" />
        </svg>`,
        traits: [
          {
            type: "checkbox",
            label: "Full width",
            name: "full-width",
            valueTrue: "full-width",
            valueFalse: ""
          }
        ],
        emptyState: {
          midSelector: ">div>table>tbody>tr>td"
        }
      },
      init() {
        Ut(this);
      },
      getAttrToHTML: bn(ie),
      getMjmlAttributes: It(ie),
      toJSON: at(ie)
    },
    extendFnView: ["render"],
    view: {
      getTemplateFromEl: Mt(re),
      getMjmlTemplate() {
        const { start: pe, end: _e } = re.prototype.getMjmlTemplate.call(this);
        return {
          start: oo(pe, this.model),
          end: _e
        };
      },
      render() {
        return Lt(this), this;
      },
      attributes: {}
    }
  }), n.addType($, {
    extendFn: ["init"],
    model: {
      defaults: {
        tagName: $,
        "style-default": {},
        icon: '<svg viewBox="0 0 24 24"><path d="M16,5V18H21V5M4,18H9V5H4M10,18H15V5H10V18Z" /></svg>'
      },
      init() {
        Ut(this);
      },
      getMjmlAttributes: It(St),
      toJSON: at(St)
    },
    extendFnView: ["init"],
    view: {
      init() {
        this.listenTo(this.model.components(), "add remove reset", this.render);
      },
      getTemplateFromEl: Mt(vn, !0),
      getChildrenContainer() {
        return this.el;
      },
      getMjmlTemplate() {
        return {
          start: "<mjml><mj-body><mj-section>",
          end: "</mj-section></mj-body></mjml>"
        };
      },
      render() {
        const pe = this.getTemplateFromMjml(), _e = iO(pe);
        return this.renderAttributes(), this.$el.attr(_e), this.el.innerHTML = pe.innerHTML, this.renderChildren(), this.childNodes = this.getChildrenContainer().childNodes, this.updateStatus(), this.postRender(), this;
      }
    }
  }), n.addType(P, {
    extendFn: ["init"],
    model: {
      defaults: {
        tagName: P,
        icon: `<svg viewBox="0 0 24 24" style="rotate: 90deg;">
          <path d="M2,3V6H21V3M20,8H3A1,1 0 0,0 2,9V15A1,1 0 0,0 3,16H20A1,1 0 0,0 21,15V9A1,1 0 0,0 20,8M2,21H21V18H2V21Z" />
        </svg>`,
        traits: [],
        emptyState: {
          midSelector: ">table>tbody",
          styleIn: "margin: 0 10px;"
        }
      },
      init() {
        Ut(this);
      },
      getMjmlAttributes: It(le),
      toJSON: at(le)
    },
    view: {
      getMjmlTemplate() {
        var Oe;
        const pe = (Oe = this.model.parent()) == null ? void 0 : Oe.is(g), _e = rn(this.model, {
          withSiblings: !pe,
          withHead: !pe,
          beforeRootEnd: pe ? `<${p}><${E}><${P}/></${E}></${p}>` : ""
        });
        return {
          start: _e.start,
          end: _e.end
        };
      },
      getTemplateFromEl: Mt(me, !0),
      getChildrenContainer() {
        const { el: pe } = this;
        return pe.querySelector("td > table tbody") || pe.querySelector("table tbody") || pe;
      },
      render() {
        this.renderAttributes();
        const pe = this.getTemplateFromMjml();
        return this.el.innerHTML = pe.content, this.$el.attr(pe.attributes), this.getChildrenContainer().innerHTML = this.model.get("content"), this.renderChildren(), this.updateStatus(), this.postRender(), nn(this.model, !0), this;
      }
    }
  }), n.addType(k, {
    model: {
      defaults: {
        tagName: k,
        emptyState: {
          midSelector: ' [contenteditable="false"]:not([data-type-data-variable])',
          styleIn: "min-height: 20px;",
          styleOut: "padding: 0 5px;"
        },
        traits: [],
        "style-default": {
          padding: "10px 25px"
          // Testing without defaults as at the moment this conflicts with head stuff (mj-all)
          // 'font-size': '13px',
          // align: 'left'
        }
      },
      getMjmlAttributes: It(oe),
      toJSON: at(oe)
    },
    view: {
      getMjmlTemplate: $n,
      getTemplateFromEl: Mt(se),
      attributes: {
        style: "display: table; width: 100%"
      }
    }
  }), n.addType(T, {
    model: {
      defaults: {
        tagName: T,
        traits: [en],
        "style-default": {
          // Testing without defaults as at the moment this conflicts with head stuff (mj-all)
          // 'background-color': '#414141',
          // 'border-radius': '3px',
          // 'font-size': '13px',
          // 'font-weight': '400',
          // 'color': '#ffffff',
          // 'vertical-align': 'middle',
          // 'padding-top': '10px',
          // 'padding-bottom': '10px',
          // 'padding-right': '25px',
          // 'padding-left': '25px',
          // 'align': 'center',
        }
      },
      getMjmlAttributes: It(de),
      toJSON: at(de)
    },
    view: {
      getMjmlTemplate: $n,
      getTemplateFromEl: Mt(we)
    }
  }), n.addType(O, {
    model: {
      defaults: {
        tagName: O,
        "style-default": {
          align: "center"
        },
        traits: [
          {
            name: "src",
            changeProp: !0,
            type: "image",
            label: "Image"
          },
          {
            id: "altText",
            name: "alt",
            placeholder: "Image description"
          },
          "title",
          en
        ]
      },
      toJSON: at(H)
    },
    view: {
      getMjmlTemplate() {
        return {
          start: `<mjml>${Bn(this.model)}<mj-body><mj-section><mj-column>`,
          end: "</mj-column></mj-section></mj-body></mjml>"
        };
      },
      getTemplateFromEl(pe) {
        var _e, Oe, Ye;
        return (Ye = (Oe = (_e = pe.querySelector("img")) == null ? void 0 : _e.closest("table")) == null ? void 0 : Oe.closest("tr")) == null ? void 0 : Ye.innerHTML;
      },
      attributes: {
        style: "display: table; width: 100%; user-select: none;"
      }
    }
  }), n.addType(A, {
    model: {
      defaults: {
        tagName: A,
        attributes: { align: "center" },
        "style-default": { width: "100%" },
        traits: [
          {
            name: "align",
            type: "radio",
            options: [
              {
                id: "left",
                title: "Left",
                labelReact: /* @__PURE__ */ u.jsx(ye, { icon: fe.alignHorizontalLeft, size: Ee.sx })
              },
              {
                id: "center",
                title: "Center",
                labelReact: /* @__PURE__ */ u.jsx(ye, { icon: fe.alignHorizontalCenter, size: Ee.sx })
              },
              {
                id: "right",
                title: "Right",
                labelReact: /* @__PURE__ */ u.jsx(ye, { icon: fe.alignHorizontalRight, size: Ee.sx })
              }
            ]
          }
        ]
      },
      getMjmlAttributes: It(je),
      toJSON: at(je)
    },
    view: {
      getMjmlTemplate: $n,
      getTemplateFromEl: Mt(He)
    }
  }), n.addType(N, {
    model: {
      defaults: {
        tagName: N,
        name: "Social",
        traits: [],
        emptyState: {
          midSelector: ">td"
        },
        "style-default": {
          align: "center"
        }
      },
      getMjmlAttributes: It(zt),
      toJSON: at(zt)
    },
    view: {
      getMjmlTemplate: $n,
      getTemplateFromEl: Mt(vt)
    }
  }), n.addType(R, {
    extendFn: ["init"],
    model: {
      defaults: {
        tagName: R,
        "style-default": { align: "center" },
        traits: [
          {
            type: "select",
            label: "Icon",
            name: "name",
            options: [
              { id: "custom", name: "Custom" },
              { id: "facebook", name: "Facebook" },
              { id: "twitter", name: "Twitter/X" },
              { id: "google", name: "Google" },
              { id: "instagram", name: "Instagram" },
              { id: "web", name: "Web" },
              { id: "youtube", name: "YouTube" },
              { id: "pinterest", name: "Pinterest" },
              { id: "linkedin", name: "Linkedin" },
              { id: "snapchat", name: "Snapchat" },
              { id: "vimeo", name: "Vimeo" },
              { id: "tumblr", name: "Tumblr" },
              { id: "github", name: "Github" },
              { id: "soundcloud", name: "SoundCloud" },
              { id: "medium", name: "Medium" },
              { id: "dribbble", name: "Dribbble" },
              { id: "xing", name: "Xing" }
            ]
          },
          Bt,
          en,
          Et
        ]
      },
      init() {
        Ut(this);
      },
      getMjmlAttributes() {
        const pe = Ni(this, ct);
        return { ...this.getDefaultIconProps()[pe.name], ...pe };
      },
      getAttrToHTML() {
        const pe = ct.prototype.getAttrToHTML.call(this);
        return { ...this.getDefaultIconProps()[pe.name], ...pe };
      },
      getDefaultIconProps() {
        return {
          twitter: {
            src: "https://upload.wikimedia.org/wikipedia/commons/5/57/X_logo_2023_%28white%29.png",
            "background-color": "black"
          }
        };
      },
      toJSON: at(ct)
    },
    extendFnView: ["init"],
    view: {
      init() {
        this.listenTo(this.model, "component:update:components", this.rerender);
      },
      getMjmlTemplate() {
        const { start: pe, end: _e } = Ot.prototype.getMjmlTemplate.call(this);
        return {
          start: oo(pe, this.model),
          end: _e
        };
      },
      getInnerMjmlTemplate() {
        var Ye;
        const { start: pe, end: _e } = Ot.prototype.getInnerMjmlTemplate.call(this), Oe = ((Ye = this.model.getInnerHTML()) == null ? void 0 : Ye.trim()) || "";
        return {
          start: `${pe}${Oe}`,
          end: _e
        };
      },
      getChildrenContainer() {
        var Ye;
        const { el: pe } = this, _e = (Ye = pe.querySelector("tbody > tr > td")) == null ? void 0 : Ye.nextElementSibling;
        return (_e == null ? void 0 : _e.firstElementChild) || pe.querySelector("img") || pe;
      }
    }
  }), n.addType(z, {
    model: {
      defaults: {
        tagName: z,
        traits: []
      },
      getMjmlAttributes: It(Le),
      toJSON: at(Le)
    },
    view: {
      getMjmlTemplate: $n,
      getTemplateFromEl: Mt(ot)
    }
  }), n.addType(D, {
    model: {
      defaults: {
        tagName: D,
        emptyState: {
          midSelector: ">td>div"
        }
      },
      getMjmlAttributes: It(F),
      toJSON: at(F)
    },
    view: {
      getMjmlTemplate: $n,
      getTemplateFromEl: Mt(V, !0),
      // Copying render here in order to avoid adding `<style>`
      render() {
        this.renderAttributes();
        const pe = this.getTemplateFromMjml();
        return this.el.innerHTML = pe.content, this.$el.attr(pe.attributes), this.getChildrenContainer().innerHTML = this.model.get("content"), this.renderChildren(), this.renderStyle(), this.postRender(), nn(this.model), this;
      }
    }
  }), n.addType(Z, {
    model: {
      defaults: {
        tagName: Z,
        icon: `<svg viewBox="0 0 24 24">
          <path fill="currentColor" d="M21,15.61L19.59,17L14.58,12L19.59,7L21,8.39L17.44,12L21,15.61M3,6H16V8H3V6M3,13V11H13V13H3M3,18V16H16V18H3Z" />
        </svg>`,
        emptyState: {
          midSelector: ">td>div"
        },
        "style-default": {}
      },
      toJSON: at(L)
    },
    view: {
      getMjmlTemplate() {
        const { start: pe, end: _e } = W.prototype.getMjmlTemplate.call(this);
        return {
          start: oo(pe, this.model),
          end: _e
        };
      },
      getTemplateFromEl(pe) {
        return pe.querySelector(".mj-inline-links").innerHTML;
      }
    }
  }), n.addType(K, {
    extendFn: ["initToolbar"],
    model: {
      defaults: {
        tagName: K,
        name: "HTML block",
        emptyState: {
          midSelector: ">div"
        }
      },
      initToolbar() {
        Z8(this, {
          id: "edit",
          command: () => it(this),
          label: `<svg viewBox="0 0 24 24">
            <path d="M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z"></path>
          </svg>`
        });
      },
      toJSON: at(H)
    },
    view: {
      events: {
        dblclick: "onActive"
      },
      onActive() {
        it(this.model);
      },
      attributes: {}
    }
  });
  const Qn = (pe) => {
    const { id: _e, view: Oe } = pe, Ye = Oe.prototype;
    n.addType(_e, {
      view: {
        // TODO FIX: mjml preset plugin removes onRender method
        render() {
          return Ye.render.apply(this, arguments), YE(_e, this), this;
        }
      }
    });
  };
  [p, E, P, k, D, N, K].forEach((pe) => Qn(n.getType(pe))), n.getTypes().forEach(({ id: pe, view: _e }) => {
    _e.prototype.disableEditing && n.addType(pe, {
      view: {
        onDisable(Oe = {}) {
          this.disableEditing({
            ...Oe,
            parserOptions: {
              htmlType: "text/html"
            }
          });
        }
      }
    });
  });
  const ko = () => {
    const _e = e.Components.getWrapper().findFirstType(c), Oe = _e.findFirstType(d) || _e.append({ type: d })[0];
    Oe.components().filter((xn) => xn.attributes[G1] == K1).forEach((xn) => xn.remove());
    const fn = yE(l.fonts);
    if (!fn)
      return;
    const ln = Oe.append({
      type: j,
      // using `content` instead of `components` to avoid the parser
      content: fn
    })[0];
    ln == null || ln.set({ [G1]: K1 }, { silent: !0 });
  }, hr = wa.globalStyles, Nr = () => {
    const pe = e.Css.rules.filter((ln) => {
      const xn = ln.attributes.groups;
      return !!(xn != null && xn.some(($r) => $r.startsWith(`${hr}:`)));
    }).map((ln) => ln.toCSS());
    if (!pe.length)
      return;
    const Oe = e.Components.getWrapper().findFirstType(gu.root), Ye = Oe.findFirstType(d) || Oe.append({ type: d })[0];
    (Ye.findType(j).find((ln) => ln.getAttributes()[At] === hr) || Ye.append({ type: j, attributes: { [At]: hr } })[0]).set("content", pe.join(`
`));
  }, cs = Es(Nr, 100);
  e.on(kr.pageSettingsUpdate, (pe) => {
    pe.page || ko();
  }), e.on(e.events.projectLoad, ({ loaded: pe }) => {
    pe && (Nr(), ko());
  }), e.on(e.Parser.events.htmlBefore, (pe) => {
    pe.input = ME(pe.input);
  }), e.onReady(() => {
    e.on(`${e.DataSources.events.pathSource}:${hr}`, cs);
  });
}
function r7(e) {
  const { Blocks: t } = e, n = "Content", r = "Layout", o = { className: "h-7", full: !0, space: "s", nowrap: !0 }, i = {
    category: r,
    full: !0
  }, l = "gjs-border-2 gjs-border-current gjs-rounded-sm", c = (d, p) => {
    t.add(d, {
      select: !0,
      category: n,
      ...p
    });
  };
  c("mj-text", {
    label: "Text",
    media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z" />
    </svg>`,
    content: "<mj-text>Insert text here</mj-text>",
    activate: !0
  }), c("mj-button", {
    label: "Button",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M20 20.5C20 21.3 19.3 22 18.5 22H13C12.6 22 12.3 21.9 12 21.6L8 17.4L8.7 16.6C8.9 16.4 9.2 16.3 9.5 16.3H9.7L12 18V9C12 8.4 12.4 8 13 8S14 8.4 14 9V13.5L15.2 13.6L19.1 15.8C19.6 16 20 16.6 20 17.1V20.5M20 2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H8V12H4V4H20V12H18V14H20C21.1 14 22 13.1 22 12V4C22 2.9 21.1 2 20 2Z" />
    </svg>`,
    content: "<mj-button>Button</mj-button>"
  }), c("mj-image", {
    label: "Image",
    media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M21,3H3C2,3 1,4 1,5V19A2,2 0 0,0 3,21H21C22,21 23,20 23,19V5C23,4 22,3 21,3M5,17L8.5,12.5L11,15.5L14.5,11L19,17H5Z" />
    </svg>`,
    content: `<mj-image src="${vO}"/>`,
    activate: !0
  }), c("mj-divider", {
    label: "Divider",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M21 18H2V20H21V18M19 10V14H4V10H19M20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8M21 4H2V6H21V4Z" />
    </svg>`,
    content: "<mj-divider/>"
  }), c("mj-social", {
    label: "Social",
    media: `<svg viewBox="0 0 24 24">
      <path fill="currentColor" d="M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z" />
    </svg>`,
    content: `<mj-social font-size="12px" icon-size="24px" border-radius="12px" mode="horizontal">
        <mj-social-element name="facebook"></mj-social-element>
        <mj-social-element name="linkedin"></mj-social-element>
        <mj-social-element name="twitter"></mj-social-element>
      </mj-social>`
  }), c("mj-social-element", {
    label: "Social Element",
    media: `<svg viewBox="0 0 24 24">
      <path d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12S8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5S19.66 2 18 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12S4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.34C15.11 18.55 15.08 18.77 15.08 19C15.08 20.61 16.39 21.91 18 21.91S20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08M18 4C18.55 4 19 4.45 19 5S18.55 6 18 6 17 5.55 17 5 17.45 4 18 4M6 13C5.45 13 5 12.55 5 12S5.45 11 6 11 7 11.45 7 12 6.55 13 6 13M18 20C17.45 20 17 19.55 17 19S17.45 18 18 18 19 18.45 19 19 18.55 20 18 20Z" />
    </svg>`,
    content: '<mj-social-element name="facebook">Facebook</mj-social-element>'
  }), c("mj-spacer", {
    label: "Spacer",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z" />
    </svg>`,
    content: "<mj-spacer/>"
  }), c("mj-navbar", {
    label: "Navbar",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
    </svg>`,
    content: `<mj-navbar>
      <mj-navbar-link>HOME</mj-navbar-link>
      <mj-navbar-link>ABOUT</mj-navbar-link>
      <mj-navbar-link>CONTACT</mj-navbar-link>
      <mj-navbar-link>BLOG</mj-navbar-link>
    </mj-navbar>`
  }), c("mj-hero", {
    label: "Hero",
    media: `<svg viewBox="0 0 24 24">
        <path fill="currentColor" d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4M6,9H18V11H6V9M6,13H16V15H6V13Z" />
    </svg>`,
    content: `<mj-hero mode="fixed-height" height="469px" background-width="600px" background-height="469px" background-url="${oC({ width: 600, height: 300, text: "Hero Image", fg: "555" })}" background-color="#2a3448" padding="100px 0px">
      <mj-text padding="20px" color="#ffffff" font-family="Helvetica" align="center" font-size="45px" line-height="45px" font-weight="900">
        Heading title
      </mj-text>
      <mj-text padding="20px" color="#ffffff" font-family="Helvetica" align="center">
        Place here your hero content text
      </mj-text>
      <mj-button href="https://mjml.io/" align="center">
        Call to action!
      </mj-button>
    </mj-hero>`
  }), c("mj-raw", {
    label: "HTML block",
    activate: !0,
    media: `<svg viewBox="0 0 24 24">
      <path d="M5.59 3.41L7 4.82L3.82 8L7 11.18L5.59 12.6L1 8L5.59 3.41M11.41 3.41L16 8L11.41 12.6L10 11.18L13.18 8L10 4.82L11.41 3.41M22 6V18C22 19.11 21.11 20 20 20H4C2.9 20 2 19.11 2 18V14H4V18H20V6H17.03V4H20C21.11 4 22 4.89 22 6Z" />
    </svg>`,
    content: `<mj-raw>
      <span>Insert here you custom HTML</span>
    </mj-raw>`
  }), c("mj-1-column", {
    ...i,
    label: "1 Column",
    mediaReact: /* @__PURE__ */ u.jsx(G, { ...o, children: /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 }) }),
    content: `<mj-section>
        <mj-column></mj-column>
      </mj-section>`
  }), c("mj-2-columns-50-50", {
    ...i,
    label: "2 Columns 50/50",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 }),
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 })
    ] }),
    content: `<mj-section>
      <mj-column></mj-column>
      <mj-column></mj-column>
    </mj-section>`
  }), c("mj-2-columns-25-75", {
    ...i,
    label: "2 Columns 25/75",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-3/4") })
    ] }),
    content: `<mj-section>
      <mj-column width="25%"></mj-column>
      <mj-column width="75%"></mj-column>
    </mj-section>`
  }), c("mj-2-columns-33-67", {
    ...i,
    label: "2 Columns 33/67",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/3") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-2/3") })
    ] }),
    content: `<mj-section>
      <mj-column width="33%"></mj-column>
      <mj-column width="67%"></mj-column>
    </mj-section>`
  }), c("mj-2-columns-67-33", {
    ...i,
    label: "2 Columns 67/33",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-2/3") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/3") })
    ] }),
    content: `<mj-section>
      <mj-column width="67%"></mj-column>
      <mj-column width="33%"></mj-column>
    </mj-section>`
  }), c("mj-2-columns-75-25", {
    ...i,
    label: "2 Columns 75/25",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-3/4") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/4") })
    ] }),
    content: `<mj-section>
      <mj-column width="75%"></mj-column>
      <mj-column width="25%"></mj-column>
    </mj-section>`
  }), c("mj-3-columns", {
    ...i,
    label: "3 Columns",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 }),
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 }),
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 })
    ] }),
    content: `<mj-section>
        <mj-column></mj-column>
        <mj-column></mj-column>
        <mj-column></mj-column>
      </mj-section>`
  }), c("mj-3-columns-25-25-50", {
    ...i,
    label: "3 Columns 25/25/50",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-2/4") })
    ] }),
    content: `<mj-section>
        <mj-column width="25%"></mj-column>
        <mj-column width="25%"></mj-column>
        <mj-column width="50%"></mj-column>
      </mj-section>`
  }), c("mj-3-columns-25-50-25", {
    ...i,
    label: "3 Columns 25/50/25",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-2/4") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/4") })
    ] }),
    content: `<mj-section>
        <mj-column width="25%"></mj-column>
        <mj-column width="50%"></mj-column>
        <mj-column width="25%"></mj-column>
      </mj-section>`
  }), c("mj-3-columns-50-25-25", {
    ...i,
    label: "3 Columns 50/25/25",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-2/4") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/4") }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(l, "gs-utl-basis-1/4") })
    ] }),
    content: `<mj-section>
        <mj-column width="50%"></mj-column>
        <mj-column width="25%"></mj-column>
        <mj-column width="25%"></mj-column>
      </mj-section>`
  }), c("mj-4-columns", {
    ...i,
    label: "4 Columns",
    mediaReact: /* @__PURE__ */ u.jsxs(G, { ...o, children: [
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 }),
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 }),
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 }),
      /* @__PURE__ */ u.jsx(Y, { className: l, grow: !0 })
    ] }),
    content: `<mj-section>
        <mj-column></mj-column>
        <mj-column></mj-column>
        <mj-column></mj-column>
        <mj-column></mj-column>
      </mj-section>`
  });
}
const o7 = (e, t) => ({
  [Xe.web]: (r) => Am(r, t),
  [Xe.document]: (r) => Am(r, t),
  [Xe.react]: (r) => Am(r, t),
  [Xe.email]: (r) => n7(r, t)
})[e], Il = "https://cdn.jsdelivr.net/npm/", Dm = {
  id: "gjs-blocks-basic",
  src: `${Il}grapesjs-blocks-basic@1.0.1/dist/index.js`
}, s7 = {
  id: "grapesjs-plugin-forms",
  src: `${Il}grapesjs-plugin-forms@2.0.5/dist/index.js`
}, Im = {
  id: "grapesjs-parser-postcss",
  src: `${Il}grapesjs-parser-postcss@1.0.1/dist/index.js`
}, i7 = {
  id: "grapesjs-navbar",
  src: `${Il}grapesjs-navbar@1.0.1/dist/index.js`,
  options: { block: { category: "Extra" } }
}, Vm = {
  id: "grapesjs-plugin-export",
  src: `${Il}grapesjs-plugin-export@1.0.11/dist/index.js`,
  options: {
    isBinary: (e, t) => {
      const n = t.split(".")[1];
      return /[\x00-\x08\x0E-\x1F]/.test(e) && !(n && ["html", "css"].indexOf(n) >= 0);
    }
  }
}, a7 = {
  id: "grapesjs-mjml",
  src: `${Il}grapesjs-mjml@1.0.7/dist/index.js`,
  options: {
    columnsPadding: "",
    // avoid injecting custom styles
    useCustomTheme: !1,
    // avoid loading the default panel for devices
    resetDevices: !1,
    // no need to reset blocks
    resetBlocks: !1,
    blocks: [],
    // allow to import mjml void strings like '<mj-image ... />'
    useXmlParser: !0,
    // no need to reset style manager
    resetStyleManager: !1
  }
}, l7 = {
  [Xe.email]: [
    // Adding blocks before so the icon will be transferred from Blocks to Components (via blockIconsToComponent plugin)
    r7,
    a7
  ],
  [Xe.web]: [Dm, s7, Vm, Im, i7],
  [Xe.document]: [Dm, Vm, Im],
  [Xe.react]: [Dm, Vm, Im]
};
function c7(e, t) {
  const { blocks: n } = t.appStore.sdkOptions;
  Array.isArray(n == null ? void 0 : n.default) && e.BlockManager.blocks.add(n.default), e.on("rteToolbarPosUpdate", (r) => {
    const o = -r.canvasOffset.left;
    r.left < o && (r.left = o);
  });
}
const u7 = (e) => e.Assets.getAll().reduce((r, o) => {
  const i = o.getSrc(), l = i.match(/^data:([^;]+);/);
  if (l) {
    const c = i.split(",")[1], d = X8(o.get("name"));
    r[i] = {
      mime: l[1],
      name: d,
      base64: c
    };
  }
  return r;
}, {}), d7 = (e) => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), yS = (e, t, n = {}) => {
  let r = e;
  const o = n.pathPfx || "";
  for (const i in t)
    if (r.includes(i)) {
      const l = t[i];
      r = r.replace(new RegExp(d7(i), "g"), `${o}${l.name}`), l.found = !0;
    }
  return r;
}, f7 = (e, t, n) => `${t || ""}${e || ""}${n || ""}`, p7 = (e, t) => {
  const n = e ? `<div ${hp}>${e}</div>` : "", r = t ? `<div ${hp} data-gjs-global>${t}</div>` : "";
  return `${n}${r}`;
}, g7 = async (e, t = {}) => {
  const { page: n, skipProject: r, assetsFolder: o = "assets", filenameCss: i = "style.css", styles: l, isMJML: c, exportConfig: d } = t, p = { ...d, ...e.config.optsHtml || {}, ...t.optionsHtml }, g = [], m = n ? [n] : e.Pages.getAll(), v = u7(e), b = `${o}/`, x = e.getCss({ keepUnusedStyles: !0, component: n == null ? void 0 : n.getMainComponent() }) || "", w = yS(x, v, { pathPfx: b }), j = l === "inline", C = l === "skip", E = kl(e).globalPageSettings || {}, P = m.map((k) => {
    var en, Bt, Et;
    const T = k.getName(), O = oi(k, "title") || T, A = oi(k, "favicon"), $ = oi(k, "description"), N = oi(k, "keywords"), R = oi(k, "socialTitle"), z = oi(k, "socialDescription"), D = oi(k, "socialImage"), Z = bE(oi(k, "fonts")), K = ar({ page: k, key: "customCodeHead" }) ?? "", H = f7(K, E.customCodeHead, Z), q = ar({ page: k, key: "customCodeBody" }) ?? "", te = p7(q, E.customCodeBody), I = k.getMainComponent(), F = e.getJs({ component: I }), V = F ? `<script>${F}<\/script>` : "", L = [], W = [], ie = { asDocument: !1, ...p }, re = I.toHTML(ie).replace("</body>", `${te}${V}</body>`), le = I.head;
    let me = O && `<title>${O}</title>`, oe = A && `<link rel="icon" href="${A}"/>`, se = $ && `<meta name="description" content="${$}"/>`, de = N && `<meta name="keywords" content="${N}"/>`, we = R && `<meta property="og:title" content="${R}"/>`, je = z && `<meta property="og:description" content="${z}"/>`, He = D && `<meta property="og:image" content="${D}"/>`, Le = '<meta charset="utf-8">', ot = '<meta name="viewport" content="width=device-width,initial-scale=1">', vt = '<meta name="robots" content="index,follow">', zt = '<meta name="generator" content="GrapesJS Studio">';
    le.components().forEach((it) => {
      const Lt = it.toHTML(p);
      Rt.title({ cmp: it }) ? me = Lt : Rt.favicon({ cmp: it }) ? oe = Lt : Rt.description({ cmp: it }) ? se = Lt : Rt.keywords({ cmp: it }) ? de = Lt : Rt.socialTitle({ cmp: it }) ? we = Lt : Rt.socialDescription({ cmp: it }) ? je = Lt : Rt.socialImage({ cmp: it }) ? He = Lt : Rt.charset({ cmp: it }) ? Le = Lt : Rt.viewport({ cmp: it }) ? ot = Lt : Rt.robots({ cmp: it }) ? vt = Lt : Rt.generator({ cmp: it }) && (zt = Lt);
    }), me && L.push(me), Le && L.push(Le), ot && L.push(ot), vt && L.push(vt), zt && L.push(zt), se && L.push(se), de && L.push(de), we && L.push(we), je && L.push(je), He && L.push(He), oe && L.push(oe), W.length && L.push(...W), H && L.push(H), w && !C && L.push(j ? `<style>${w}</style>` : `<link rel="stylesheet" href="./${i}">`);
    const Ot = I.doctype || "<!DOCTYPE html>", ct = (Bt = (en = I.docEl).__attrToString) == null ? void 0 : Bt.call(en), vn = (Et = le.__attrToString) == null ? void 0 : Et.call(le), St = e.getHtml(p).trim(), At = c ? e.runCommand("mjml-code-to-html", { mjml: St }).html : `${Ot}
<html${ct ? ` ${ct}` : ""}>
  <head${vn ? ` ${vn}` : ""}>
    ${L.join(`
  `)}
  </head>
  ${re}
</html>
`;
    return {
      filename: q1(e, k),
      content: yS(At, v, { pathPfx: b }),
      mimeType: "text/html"
    };
  });
  g.push(...P), c && m.forEach((k) => {
    g.push({
      filename: q1(e, k, "mjml"),
      content: k.getMainComponent().toHTML(p),
      mimeType: "text/mjml"
    });
  });
  for (const k in v) {
    const T = v[k];
    T.found && g.push({
      path: o,
      filename: T.name,
      content: atob(T.base64),
      mimeType: T.mime
    });
  }
  return w && !j && !C && g.push({
    filename: i,
    content: w,
    mimeType: "text/css"
  }), r || g.push({
    filename: "gjs-project.grapesjs",
    content: JSON.stringify(e.getProjectData()),
    mimeType: "application/json"
  }), g;
};
function h7(e) {
  const { Components: t, Blocks: n } = e, r = (o) => {
    const { model: i, id: l } = o, c = i.getDefaults(), d = n.get(l), p = c.icon, g = d == null ? void 0 : d.get("media"), m = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14z"></path></svg>', v = p && p !== m && !g ? p : g || m;
    t.addType(l, {
      model: {
        defaults: { icon: v }
      }
    });
  };
  t.getTypes().forEach(r), e.on("component:type:add", r);
}
const m7 = (e, t) => {
  const { contextMenu: n } = t.appStore.store, { Canvas: r } = e;
  e.on(r.events.frameLoad, ({ window: o, el: i }) => {
    o.document.addEventListener("contextmenu", async (c) => {
      if (!n.isEnabled)
        return;
      c.preventDefault();
      const d = c.target, p = e.getModel().get("componentHovered") || e.Utils.helpers.getModel(d);
      if (p) {
        const g = i.getBoundingClientRect(), m = r.getZoomDecimal();
        e.runCommand(ke.contextMenuComponent, {
          component: p,
          event: c,
          x: c.clientX * m + g.left,
          y: c.clientY * m + g.top
        });
      }
    });
  });
}, O0 = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
<path fill="currentColor" d="M20 6c0-2.168-3.663-4-8-4S4 3.832 4 6v2c0 2.168 3.663 4 8 4s8-1.832 8-4zm-8 13c-4.337 0-8-1.832-8-4v3c0 2.168 3.663 4 8 4s8-1.832 8-4v-3c0 2.168-3.663 4-8 4"/><path fill="currentColor" d="M20 10c0 2.168-3.663 4-8 4s-8-1.832-8-4v3c0 2.168 3.663 4 8 4s8-1.832 8-4z"/></svg>`, ta = "--before-content", L0 = {
  select: !0,
  activate: !0,
  category: { id: "data-sources", label: "Data Sources" }
}, XE = {
  stylable: !1,
  traits: []
};
function v7(e) {
  return typeof e == "object" && e.type === kn.variable;
}
function bS(e) {
  if (v7(e)) {
    const { path: t } = e;
    return ZE(t || "");
  }
  return e;
}
function ZE(e) {
  return `{{ ${e} }}`;
}
function y7(e) {
  const t = {};
  return e.DataSources.getAll().forEach((n) => {
    const r = n.get("id");
    if (!r)
      return;
    const o = n.getRecords();
    if (!o) {
      t[r] = {};
      return;
    }
    t[r] = o.reduce((i, l) => {
      if (!l)
        return i;
      let c = { ...l.attributes };
      return delete c.__p, delete c.id, r === wa.globalStyles && (c = {
        value: c.value
      }), {
        ...i,
        [l.id]: c
      };
    }, {});
  }), t;
}
function JE(e) {
  return Object.entries(e || {}).map(([t, n]) => ({ id: t, data: n }));
}
const M0 = (e) => {
  var i, l;
  const { isProjectTypeEmail: t, sdkOptions: n } = e;
  return ((l = (i = n.dataSources) == null ? void 0 : i.exportConfig) == null ? void 0 : l.skipTags) ?? t ? { ...XE } : {};
}, ev = (e) => {
  var i, l;
  const { isProjectTypeEmail: t, sdkOptions: n } = e, r = (l = (i = n.dataSources) == null ? void 0 : i.exportConfig) == null ? void 0 : l.skipTags;
  return t || r === !0 ? { ...XE } : {};
}, b7 = (e) => !!e && typeof e == "object" && "logicalOperator" in e;
function x7(e, t) {
  var b;
  const { Components: n, I18n: r } = e, { appStore: o } = t, i = r.t("dataSources.collection"), l = kn.collection, c = kn.collectionItem, d = "data-type-data-collection", p = '<svg viewBox="0 0 24 24"><path d="M2 14H8V20H2M16 8H10V10H16M2 10H8V4H2M10 4V6H22V4M10 20H16V18H10M10 16H22V14H10" /></svg>', g = (b = t.appStore.sdkOptions.dataSources) == null ? void 0 : b.blocks, m = (x) => {
    const w = x.is(l) ? x : x.closestType(l);
    if (!w)
      return;
    const j = "dataCollectionPicker", C = {
      id: j,
      header: !1,
      layout: {
        type: "panelDataCollectionPicker",
        component: w,
        onConfirm: () => e.runCommand(ke.layoutRemove, { id: j })
      },
      placer: { type: "dialog", title: r.t("dataSources.editCollection"), size: "l" }
    };
    e.runCommand(ke.layoutToggle, { ...C });
  }, v = ({ items: x, component: w }) => [
    {
      id: `open-${l}-picker`,
      label: O0,
      command: () => m(w)
    },
    ...x
  ];
  n.addType(c, {
    isComponent: (x) => ul(x, c),
    model: {
      defaults: {
        ...ev(o),
        name: r.t("dataSources.collectionItem"),
        copyable: !1,
        emptyState: !0,
        icon: '<svg viewBox="0 0 24 24"><path d="M22 13H14V11H22V13M22 7H14V9H22V7M14 17H22V15H14V17M12 9V15C12 16.1 11.1 17 10 17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H10C11.1 7 12 7.9 12 9M10.5 15L8.3 12L6.5 14.3L5.3 12.8L3.5 15H10.5Z" /></svg>',
        toolbarItems: v
      }
    }
  }), n.addType(l, {
    isComponent: (x) => Wu(x, d) || ul(x, l),
    block: g && {
      label: i,
      media: p,
      content: {
        type: l,
        components: { type: c },
        dataResolver: {
          startIndex: 0,
          endIndex: 1,
          dataSource: {
            type: "data-variable",
            path: ""
          }
        }
      },
      ...L0
    },
    model: {
      defaults: {
        ...M0(o),
        icon: p,
        name: i,
        attributes: { [d]: !0 },
        toolbarItems: v
      },
      init() {
        const x = "collection-";
        if (!this.getCollectionId()) {
          const j = x + Math.random().toString(36).substring(2, 9);
          this.setCollectionId(j);
        }
      }
    },
    view: {
      onActive(x) {
        x == null || x.stopPropagation(), m(this.model);
      }
    }
  });
}
function w7(e, t) {
  var C;
  const { Components: n, I18n: r } = e, o = r.t("dataSources.condition"), i = r.t("dataSources.conditionTrue"), l = r.t("dataSources.conditionFalse"), c = r.t("dataSources.conditionElse"), { appStore: d } = t, p = (C = d.sdkOptions.dataSources) == null ? void 0 : C.blocks, g = kn.condition, m = kn.conditionTrue, v = kn.conditionFalse, b = "data-type-data-condition", x = `<svg viewBox="0 0 24 24">
  <path d="M14,4L16.29,6.29L13.41,9.17L14.83,10.59L17.71,7.71L20,10V4M10,4H4V10L6.29,7.71L11,12.41V20H13V11.59L7.71,6.29" />
</svg>`, w = (E) => {
    const P = E.is(g) ? E : E.closestType(g);
    if (!P)
      return;
    const k = "dataConditionPicker", T = {
      id: k,
      header: !1,
      layout: {
        type: "panelDataConditionPicker",
        component: P,
        onConfirm: () => e.runCommand(ke.layoutRemove, { id: k })
      },
      placer: { type: "dialog", title: r.t("dataSources.editCondition"), size: "l" }
    };
    e.runCommand(ke.layoutToggle, { ...T });
  }, j = ({ items: E, component: P }) => [
    {
      id: `open-${g}-picker`,
      label: O0,
      command: () => w(P)
    },
    ...E
  ];
  n.addType(m, {
    isComponent: (E) => ul(E, m),
    model: {
      defaults: {
        ...ev(d),
        tagName: "span",
        name: i,
        copyable: !1,
        emptyState: { styleIn: "display: inherit;" },
        icon: '<svg viewBox="0 0 24 24"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></svg>',
        toolbarItems: j
      }
    }
  }), n.addType(v, {
    isComponent: (E) => ul(E, v),
    model: {
      defaults: {
        ...ev(d),
        tagName: "span",
        name: l,
        copyable: !1,
        emptyState: { styleIn: "display: inherit;" },
        icon: '<svg viewBox="0 0 24 24"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>',
        toolbarItems: j
      }
    }
  }), n.addType(g, {
    isComponent: (E) => Wu(E, b) || ul(E, g),
    block: p && {
      label: o,
      media: x,
      content: {
        type: g,
        dataResolver: {
          condition: {
            logicalOperator: "and",
            statements: [{ left: 1, operator: ">", right: 0 }]
          }
        },
        components: [{ type: m }, { type: v }]
      },
      ...L0
    },
    model: {
      defaults: {
        ...M0(d),
        icon: x,
        name: o,
        textable: !0,
        stylable: !1,
        tagName: "span",
        attributes: { [b]: !0 },
        toolbarItems: j
      }
    },
    view: {
      events: () => ({
        dblclick: "onActive"
      }),
      init() {
        const { em: E } = this;
        this.listenTo(E, kr.toggleDataSourcesPreview, this.renderDataResolver);
      },
      onActive(E) {
        e.getEditing() || (E == null || E.stopPropagation(), w(this.model));
      },
      getConditionString() {
        const { model: E } = this, { operator: P, statements: k = [] } = E.getCondition(), T = P === "AND" ? " AND " : " OR ", A = k.map(($) => {
          const { left: N = "", operator: R = "", right: z = "" } = $, D = bS(N), Z = bS(z);
          return `(${D} ${R} ${Z})`;
        }).join(T);
        return `${o}: ${A}`;
      },
      renderDataResolver() {
        const E = this.model, P = E.getIfTrueContent(), k = E.getIfFalseContent(), T = P == null ? void 0 : P.getEl(), O = k == null ? void 0 : k.getEl();
        if (e.runCommand(ke.getStateDataSource).showPlaceholder) {
          T && (T.style.display = "", T.style.setProperty(ta, `"${this.getConditionString()} "`)), O && (O.style.display = "", O.style.setProperty(ta, `" ${c} "`));
          return;
        }
        const $ = E.isTrue();
        T && (T.style.removeProperty(ta), T.style.display = $ ? "" : "none"), O && (O.style.removeProperty(ta), O.style.display = $ ? "none" : "");
      }
    }
  });
}
function S7(e, t) {
  var m;
  const { Components: n, I18n: r } = e, o = kn.variable, i = "data-type-data-variable", l = "Variable", c = `<svg viewBox="0 0 24 24"><path fill="currentColor" d="${Xf.codeBraces}"/></svg>`, { appStore: d } = t, p = (m = d.sdkOptions.dataSources) == null ? void 0 : m.blocks, g = (v) => {
    const b = "dataVariablePicker", x = {
      id: b,
      header: !1,
      layout: {
        type: "panelDataVariablePicker",
        component: v,
        onConfirm: () => e.runCommand(ke.layoutRemove, { id: b })
      },
      placer: { type: "dialog", title: r.t("dataSources.editVariable"), size: "l" }
    };
    e.runCommand(ke.layoutToggle, { ...x });
  };
  n.addType(o, {
    isComponent: (v) => Wu(v, i) || ul(v, o),
    block: p && {
      label: l,
      media: c,
      content: {
        type: o,
        dataResolver: { path: "", defaultValue: r.t("dataSources.defaultValue") }
      },
      ...L0
    },
    model: {
      defaults: {
        ...M0(d),
        icon: c,
        name: l,
        textable: !0,
        tagName: "span",
        // Conflicts with preview
        // emptyState: { styleIn: 'display: inline-flex;' },
        attributes: { [i]: !0 },
        toolbarItems: ({ items: v, component: b }) => [
          {
            id: `open-${o}-modal`,
            label: O0,
            command: () => g(b)
          },
          ...v
        ]
      }
    },
    view: {
      events: () => ({
        dblclick: "onActive"
      }),
      init() {
        const { em: v } = this;
        this.listenTo(v, kr.toggleDataSourcesPreview, this.renderDataResolver);
      },
      onActive(v) {
        e.getEditing() || (v == null || v.stopPropagation(), g(this.model));
      },
      renderDataResolver() {
        const { model: v, el: b } = this;
        if (e.runCommand(ke.getStateDataSource).showPlaceholder) {
          const w = v.getPath();
          b.textContent = "", b.style.setProperty(ta, `"${ZE(w)}"`);
          return;
        }
        b.style.removeProperty(ta), b.textContent = v.getDataValue();
      }
    }
  });
}
const Za = (e, t, n) => {
  const r = e.Components.getType(t);
  if (!r) {
    console.warn(`Component type ${t} not found`);
    return;
  }
  const o = r.model;
  e.Components.addType(t, {
    model: {
      ...n,
      toHTML(i) {
        var c;
        const { exporter: l } = i ?? {};
        return l ? ((c = n.toHTML) == null ? void 0 : c.call(this, i)) ?? "" : o.prototype.toHTML.call(this, i) ?? "";
      }
    }
  });
};
function bf({
  component: e,
  value: t,
  getCustomPath: n
}) {
  if (Qo(t) && t.path && !t.collectionId && n) {
    const r = t.path ?? "", o = r.split(".");
    return {
      ...t,
      path: n({ component: e, path: r, paths: o })
    };
  }
  return t;
}
function j7(e, {
  isProjectTypeEmail: t
}) {
  const n = ({ content: i }) => t ? `<mj-raw>${i}</mj-raw>` : i, r = ({ content: i }) => i;
  function o(i) {
    const l = this.getInnerHTML(i);
    if (t || i.skipTags)
      return l;
    const c = this.tagName, d = this.__attrToString(i), p = d ? ` ${d}` : "", g = `<${c}${p}>`, m = `</${c}>`;
    return `${g}${l}${m}`;
  }
  Za(e, kn.variable, {
    toHTML(i) {
      var j;
      const l = i.skipTags ?? t, c = i.exporter, d = i.wrapTemplateContent ?? r, p = (C) => d({ component: this, content: C }), g = this.tagName, m = this.__attrToString(i), v = (j = this.getDataResolver) == null ? void 0 : j.call(this), b = bf({
        component: this,
        value: v,
        getCustomPath: i == null ? void 0 : i.getCustomPath
      }), x = c.getVariableSyntax({ component: this, dataResolver: b }), w = p(x);
      return l ? w : `<${g}${m ? ` ${m}` : ""}>${w}</${g}>`;
    }
  }), Za(e, kn.condition, {
    toHTML(i) {
      var P, k, T;
      const { exporter: l } = i, c = i.wrapTemplateContent ?? n, d = (O) => c({ component: this, content: O }), p = { component: this }, g = i == null ? void 0 : i.getCustomPath, [m, v] = ((P = this.components()) == null ? void 0 : P.models) ?? [], b = (k = this.getDataResolver) == null ? void 0 : k.call(this), x = ((T = this.resolveCondition) == null ? void 0 : T.call(this, b == null ? void 0 : b.condition, g)) ?? {};
      let w = "";
      if (v) {
        const O = l.getConditionElseSyntax(p);
        w = `
${d(O)}
  ${v.toHTML(i) ?? ""}`;
      }
      const j = l.getConditionalStartSyntax({ ...p, dataResolver: { condition: x } }), C = l.getConditionalEndSyntax(p);
      return `
${`${d(j)}
  ${(m == null ? void 0 : m.toHTML(i)) ?? ""}${w}
${d(C)}`}
`;
    },
    resolveCondition(i, l) {
      if (typeof i == "boolean")
        return i;
      if (!i)
        return {};
      if (b7(i))
        return {
          ...i,
          statements: i.statements.map((d) => this.resolveCondition(d, l)) ?? []
        };
      const c = { component: this, getCustomPath: l };
      return {
        ...i,
        left: bf({ ...c, value: i.left }),
        right: bf({ ...c, value: i.right })
      };
    }
  }), Za(e, kn.collection, {
    toHTML(i) {
      const l = i.skipTags ?? t, { exporter: c } = i, d = i.wrapTemplateContent ?? n, p = (A) => d({ component: this, content: A }), g = { component: this }, m = this.getDataResolver(), v = {
        ...m,
        dataSource: bf({
          component: this,
          value: m == null ? void 0 : m.dataSource,
          getCustomPath: i == null ? void 0 : i.getCustomPath
        })
      }, b = this.components().at(0), x = c.getCollectionStartSyntax({
        ...g,
        dataResolver: v
      }), w = c.getCollectionEndSyntax(g), j = (b == null ? void 0 : b.toHTML(i)) ?? "", C = `${p(x)}
  ${j}
${p(w)}`;
      if (l)
        return `
${C}
`;
      const E = this.tagName, P = this.__attrToString(i), k = P ? ` ${P}` : "", T = `<${E}${k}>`, O = `</${E}>`;
      return `
${T}${C}${O}
`;
    }
  }), Za(e, kn.conditionTrue, { toHTML: o }), Za(e, kn.conditionFalse, { toHTML: o }), Za(e, kn.collectionItem, { toHTML: o });
}
const C7 = function(e, t) {
  const { Components: n, Canvas: r, events: o } = e;
  if (!n.getType(kn.conditionTrue))
    return;
  const { isProjectTypeEmail: i, sdkOptions: l } = t.appStore, { dataSources: c } = l;
  c != null && c.globalData && e.on(o.projectLoad, () => {
    e.DataSources.add({
      id: wa.globalData,
      records: JE(c.globalData),
      skipFromStorage: !0
    });
  }), e.on(r.events.frameLoadBody, ({ window: d }) => {
    const p = "data-outline-ds", g = d.document;
    if (g.querySelector(`style[${p}]`))
      return;
    const v = g.createElement("style"), b = [
      kn.variable,
      kn.condition,
      kn.collection
    ].map((x) => `.gjs-dashed [data-gjs-highlightable][data-gjs-type="${x}"]`);
    v.setAttribute(p, ""), v.textContent = `
      ${b.join(",")} {
        outline: 2px dotted #8b5cf6;
      }

      .gjs-dashed *[data-gjs-type="data-condition-true-content"],
      .gjs-dashed *[data-gjs-type="data-condition-false-content"] {
        outline: none !important;
      }

      [data-gjs-type="data-variable"]::before,
      [data-gjs-type="data-condition-true-content"]::before,
      [data-gjs-type="data-condition-false-content"]::before {
          content: var(${ta});
          font-style: italic;
          color: #666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
          font-size: .9rem;
          font-weight: 500;
          font-family: sans-serif;
      }
    `, g.head.appendChild(v);
  }), S7(e, t), w7(e, t), x7(e, t), j7(e, { isProjectTypeEmail: i });
};
function E7(e) {
  const { Components: t } = e, n = (r) => {
    const { id: o, model: i } = r;
    if (o === "custom-code") {
      const l = "<span>Insert here your custom code</span>";
      t.addType(o, {
        model: {
          defaults: {
            emptyState: !0,
            icon: '<svg viewBox="0 0 24 24"><path d="M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z"></path></svg>',
            classes: "gjs-custom-code",
            components: l,
            "custom-code-plugin__code": l,
            styles: ".gjs-custom-code { padding: 5px; }"
          }
        }
      });
    }
    if (o === "typed") {
      const l = i.getDefaults().traits.map(
        (c) => c.name === "strings" ? {
          ...c,
          type: "stack",
          addItem(d) {
            return {
              id: d,
              label: `New string ${d}`
            };
          },
          getValue({ component: d }) {
            return d.get("strings").map((p, g) => ({
              id: `${g}`,
              label: p
            }));
          },
          setValue: ({ component: d, value: p }) => {
            const g = p.map((m) => m.label);
            d.set({ strings: g }), d.trigger("rerender");
          },
          properties: [{ name: "label" }]
        } : c
      );
      t.addType(o, {
        model: {
          defaults: {
            traits: l,
            strings: [
              "These are the default values...!!!",
              "Use your own strings from Properties!",
              "Have a great day!"
            ],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"><path d="M212.3 44l2.3 49.6h-6A60 60 0 00204 75c-3.2-6-7.5-10.5-12.9-13.3a44.9 44.9 0 00-21.1-4.3h-29.8V219c0 13 1.4 21 4.2 24.3 4 4.4 10 6.6 18.2 6.6h7.4v5.7H80.2V250h7.5c9 0 15.3-2.7 19-8.2 2.4-3.3 3.5-10.9 3.5-22.7V57.3H84.8a71 71 0 00-21.1 2.2 29 29 0 00-13.9 11.3 46.1 46.1 0 00-6.9 22.8H37L39.5 44h172.8zM245 22h18v256h-18z"/></svg>',
            classes: "gjs-typed",
            styles: `
                  .gjs-typed {
                    padding: 5px;
                  }
                `
          }
        }
      });
    }
    if (["tabs", "tab-content", "tab-contents", "tab", "tab-container"].indexOf(o) >= 0) {
      const c = {
        emptyState: !0,
        icon: o === "tabs" ? `
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 9.3c0-.8-.5-1.3-1.3-1.3H3.4C2.5 8 2 8.5 2 9.3v7.4c0 .8.5 1.3 1.3 1.3h17.4c.8 0 1.3-.5 1.3-1.3V9.3zM21 17H3V9h18v8z" fill-rule="nonzero"/><rect x="3" y="5" width="4" height="2" rx=".5"/><rect x="8" y="5" width="4" height="2" rx=".5"/><rect x="13" y="5" width="4" height="2" rx=".5"/>
            </svg>
          ` : void 0
      };
      o === "tab" && (c.traits = [
        {
          type: "button",
          label: !1,
          text: "Style Active",
          command: (d) => {
            d.select(), d.runCommand(e5), setTimeout(() => d.Selectors.select(".tab.tab-active"));
          }
        }
      ]), t.addType(o, {
        model: {
          defaults: c
        }
      });
    }
  };
  e.on("component:type:add", n);
}
const P7 = (e, t) => {
  const n = t.appStore.store.globalStylesStore;
  e.on(e.events.projectLoad, ({ loaded: r }) => r && n.onLoad());
}, _7 = (e, t) => {
  const { assetsStore: n } = t.appStore.store;
  if (n.onCloudOrCustomUpload) {
    const { Assets: r } = e;
    r.getConfig().uploadFile = async (...o) => {
      const i = o[0], l = await n.handleUpload(i), c = o[1];
      l && (c == null || c({ data: l }));
    };
  }
}, k7 = (e, t) => {
  t.runCommand(ke.fontAdd, {
    font: e
  });
}, A0 = (e, { onSelect: t, ...n } = {}) => {
  const r = "font", l = e.runCommand(ke.assetProviderGet).filter((c) => Dt(c.types) ? c.types === r : c.types.includes(r))[0];
  if (!l) {
    e.em.logWarning("No font provider found");
    return;
  }
  e.Assets.open({
    // @ts-expect-error not typed
    types: [],
    modalTitle: e.I18n.t("fontManager.selectFont"),
    optionalProvider: !1,
    typeId: r,
    providerId: l.id,
    onSelect: (c) => {
      const d = c.assetProps;
      k7(d.customData.font, e), t == null || t(c);
    },
    content: {
      header: {
        addUrl: !1,
        upload: !1
      },
      itemsPerRow: 1
    },
    ...n
  });
}, T7 = () => {
  const { baseApiUrl: e } = Jc();
  return `${e}/sdk/projects`;
}, QE = (e) => `${T7()}/${e}`, O7 = async ({ licenseKey: e, projectId: t, ...n }) => {
  const r = await ts.put(QE(t), {
    body: JSON.stringify(n),
    params: { d: window.location.hostname, licenseKey: e }
  });
  return r == null ? void 0 : r.result;
}, L7 = async (e, t) => await ts.put(t, {
  body: e,
  headers: {
    "Content-Type": "application/json"
  }
}), M7 = async (e, t, n, r) => {
  const o = JSON.stringify(e), i = await O7({
    licenseKey: t,
    projectId: n,
    fileMetadata: { size: new Blob([o]).size },
    identityId: r,
    name: e.name,
    description: e.description
  });
  if (!i)
    throw new Error("Project not found");
  const { uploadUrl: l } = i;
  await L7(o, l);
}, A7 = (e, t, n) => ts.get(QE(t), {
  params: { d: window.location.hostname, licenseKey: e, identityId: n }
}), R7 = async (e) => await ts.get(e), N7 = async (e, t, n, r) => {
  const o = await A7(t, n, r), i = o == null ? void 0 : o.result, l = o == null ? void 0 : o.errorData;
  if (!i && (l != null && l.notFoundInDb))
    return { id: n, project: {} };
  if (!i)
    throw new Error("Project not found");
  const { downloadUrl: c } = i, d = await R7(c);
  if (!d || d instanceof Error)
    throw new Error("Project download failed");
  return { id: n, project: d };
}, $7 = (e, t) => {
  const { appEditorStore: n, toastStore: r, i18nStore: o } = t.appStore.store, { isUsingProjectSelfHosted: i, isUsingProjectCloud: l, sdkOptions: c } = n, d = c.storage || {}, {
    project: p,
    onLoad: g,
    onSave: m,
    autosaveChanges: v,
    autosaveIntervalMs: b
  } = d;
  let x, w, j, C;
  if (i)
    j = g, C = m, x = v, w = b;
  else if (l) {
    const O = c.licenseKey, A = n.sdkProjectId, $ = n.sdkIdentityId, N = 10, R = 1e4;
    C = ({ project: z }) => M7(z, O, A, $), j = ({ editor: z }) => N7(z, O, A, $), x = Math.max(N, v ?? N), b && (w = Math.max(R, b));
  }
  const { Storage: E, events: P } = e, { events: k } = E;
  let T = !1;
  if (e.once(P.projectLoad, (O) => {
    T = !!O.loaded;
  }), e.once("change:readyLoad", () => {
    var A;
    const O = (A = c.project) == null ? void 0 : A.default;
    !T && O && e.loadProjectData(O);
  }), e.on(k.startStore, () => n.setIsSaving(!0)), e.on(k.endStore, () => n.setIsSaving(!1)), (j || p) && C) {
    const O = "remote";
    E.setCurrent(O), E.add(O, {
      async load() {
        return p || (await j({ editor: e })).project;
      },
      async store(A) {
        await C({ project: A, editor: e });
      }
    }), e.on(k.errorLoad, (A) => {
      r.addError("storage-error-load", {
        header: o.t("storageManager.errorLoad"),
        content: A.message
      });
    }), e.on(k.errorStore, (A) => {
      r.addError("storage-error-store", {
        header: o.t("storageManager.errorStore"),
        content: A.message
      });
    }), x && E.setStepsBeforeSave(x), w && e.onReady(() => {
      const A = setInterval(async () => {
        e.getDirtyCount() > 0 && !n.isSaving && await e.store();
      }, w);
      e.on("destroy", () => clearInterval(A));
    });
  }
}, vp = "select-target", e5 = "enable-sm";
function D7(e, t) {
  var K, H, q, te;
  const {
    appEditorStore: n,
    blockManagerStore: r,
    toastStore: o,
    modalStore: i,
    layoutStore: l,
    contextMenu: c,
    assetsStore: d,
    fontsStore: p
  } = t.appStore.store, { projectIdToLoad: g, nextProjectData: m, sdkOptions: v } = n, b = () => r.toggleOpen(), x = () => n.toggleLeftSidebar(), w = () => n.toggleRightSidebar(), j = e.getConfig(), { Assets: C, Storage: E, Commands: P } = e, k = P.events, T = e.events, O = (H = (K = v.gjsOptions) == null ? void 0 : K.assetManager) == null ? void 0 : H.custom;
  let A = !1;
  if (C.all.model.prototype.idAttribute = "src", Rn(O) && (C.getConfig().custom = O), m && (j.projectData = m, n.setNextProjectData()), g) {
    const I = E.getConfig().options;
    I && (I.local.key = g);
  }
  e.on(T.projectLoad, ({ project: I }) => {
    var F;
    t.appStore.setProjectDataCustom(I.custom || { projectType: (F = n.sdkOptions.project) == null ? void 0 : F.type }), p.loadFonts();
  }), e.on(T.projectGet, ({ project: I }) => {
    I.custom = kl(e);
  }), e.RichTextEditor.getConfig().custom = !0;
  const { Canvas: $ } = e, N = Es(() => n.setCanvasPanning(!1), 200);
  e.on($.events.coords, () => {
    n.setCanvasPanning(!0), N();
  }), e.on($.events.frameLoad, ({ el: I }) => {
    I.tabIndex = -1;
  });
  const { Parser: R } = e, z = ((q = n.sdkOptions.parser) == null ? void 0 : q.showErrors) !== !1;
  (te = R.events) != null && te.css && z && e.on(R.events.css, (I) => {
    const { error: F } = I;
    if (F) {
      const V = Dt(F) ? F : F.name && F.reason ? `${F.name}: ${F.reason}` : F.message;
      o.addError("css-error", { header: "CSS Parser Error", content: V });
    }
  }), [
    // { id: `save`, keys: 'ctrl+s, ⌘+s', cmd: 'save-page' },
    // { id: `duplicate`, keys: 'ctrl+d, ⌘+d', cmd: 'tlb-clone' },
    // { id: `custom-component`, keys: 'ctrl+k, ⌘+k', cmd: 'open-custom-block' },
    { id: "toggle-lsidebar", keys: "alt+ctrl+,", cmd: x },
    { id: "toggle-lsidebar2", keys: "alt+⌘+,", cmd: x },
    { id: "toggle-rsidebar", keys: "alt+ctrl+., alt+⌘+.", cmd: w },
    { id: "show-blocks", keys: "ctrl+b, ⌘+b", cmd: b },
    { id: "add-symbol", keys: "alt+ctrl+k, alt+⌘+k", cmd: ke.symbolAdd },
    { id: "detach-symbol", keys: "shift+alt+ctrl+k, shift+alt+⌘+k", cmd: ke.symbolDetach }
  ].forEach(({ id: I, keys: F, cmd: V }) => {
    e.Keymaps.add(`preset:${I}`, F, V, { prevent: !0 });
  }), e.on(`${k.runCommand}core:preview`, () => {
    n.setPreview(!0), r.setOpen(!1), vS(e, !1);
  }), e.on(`${k.stopCommand}core:preview`, () => {
    n.setPreview(!1), vS(e, !0), setTimeout(() => {
      e.refresh();
    }, n.transitionTime);
  });
  const D = "target-selection", { Components: Z } = e;
  P.add(vp, {
    opts: {},
    init() {
      this.beforeSelect = this.beforeSelect.bind(this);
    },
    onComponentHover(I, F) {
      const V = { id: D, type: "target", component: F };
      F ? $.addSpot(V) : $.removeSpots(V);
    },
    beforeSelect(I, F = {}) {
      F.abort = !0, F.useValid = !1, this.opts.onSelect(I), e.stopCommand(vp);
    },
    run(I, F, V) {
      this.opts = V, e.on("component:select:before", this.beforeSelect), e.on("change:componentHovered", this.onComponentHover);
    },
    stop() {
      e.off("component:select:before", this.beforeSelect), e.off("change:componentHovered", this.onComponentHover), $.removeSpots({ id: D }), n.setSelectingTarget(!1);
    }
  }), P.add(e5, () => {
    n.setSelectedDesignerTab("style");
  }), P.add(ke.toastAdd, (I, F, V) => {
    o.add(V.id, V);
  }), P.add(ke.toastRemove, (I, F, V) => {
    o.remove(V.id);
  }), P.add(ke.dialogOpen, (I, F, V) => {
    i.open(V);
  }), P.add(ke.dialogClose, () => {
    i.close();
  }), P.add(ke.sidebarLeftGet, () => ({
    visible: n.isLeftSidebarOpen
  })), P.add(ke.sidebarLeftSet, (I, F, V) => {
    n.setLeftSidebarOpen(!!V.visible);
  }), P.add(ke.sidebarLeftToggle, () => {
    n.setLeftSidebarOpen(!n.isLeftSidebarOpen);
  }), P.add(ke.sidebarRightGet, () => ({
    visible: n.isRightSidebarOpen
  })), P.add(ke.sidebarRightSet, (I, F, V) => {
    n.setRightSidebarOpen(!!V.visible);
  }), P.add(ke.sidebarRightToggle, () => {
    n.setRightSidebarOpen(!n.isRightSidebarOpen);
  }), P.add(ke.sidebarTopGet, () => ({
    visible: n.isTopSidebarOpen
  })), P.add(ke.sidebarTopSet, (I, F, V) => {
    n.setTopSidebarOpen(!!V.visible);
  }), P.add(ke.sidebarTopToggle, () => {
    n.setTopSidebarOpen(!n.isTopSidebarOpen);
  }), P.add(ke.sidebarBottomGet, () => ({
    visible: n.isBottomSidebarOpen
  })), P.add(ke.sidebarBottomSet, (I, F, V) => {
    n.setBottomSidebarOpen(!!V.visible);
  }), P.add(ke.sidebarBottomToggle, () => {
    n.setBottomSidebarOpen(!n.isBottomSidebarOpen);
  }), P.add(ke.layoutAdd, (I, F, V) => {
    V.id && l.add(V.id, V);
  }), P.add(ke.layoutRemove, (I, F, V) => {
    const { id: L, ...W } = V;
    l.remove(L, W);
  }), P.add(ke.layoutToggle, (I, F, V) => {
    const { id: L, ...W } = V;
    L && (l.get(L) ? l.remove(L, W) : l.add(L, W));
  }), P.add(ke.layoutUpdate, (I, F, V) => {
    const L = V;
    e.runCommand(ke.layoutRemove, {
      id: L.id,
      layout: { placer: { ...L.placer, skipCleanup: !0 } },
      force: !0
    }), setTimeout(() => e.runCommand(ke.layoutAdd, { ...L }));
  }), P.add(ke.layoutGet, (I, F, V) => [gi(l.get(V.id))]), P.add(ke.layoutConfigGet, () => gi(l.customConfig)), P.add(ke.layoutConfigSet, (I, F, V) => {
    const L = V;
    l.setCustomConfig(L);
  }), P.add(ke.getStateTheme, () => n.publicStateTheme), P.add(ke.setStateTheme, (I, F, V) => n.setPublicStateTheme(V)), P.add(ke.getPagesConfig, () => n.sdkPagesConfig), P.add(ke.setPagesConfig, (I, F, V) => {
    const { config: L } = V || {};
    Rn(L) && n.setSdkPagesConfig(L);
  }), P.add(ke.getPageSettings, () => JSON.parse(JSON.stringify(n.panelPageSettings))), P.add(ke.setPageSettings, (I, F, V) => {
    n.setPanelPageSettings(V);
  }), P.add(ke.projectFiles, (I, F, V) => {
    var re, le;
    const L = (re = n.sdkOptions.dataSources) == null ? void 0 : re.exportConfig, W = ((le = V.exportConfig) == null ? void 0 : le.exportPreset) ?? L, ie = { isMJML: n.isProjectTypeEmail, exportConfig: W, ...V };
    return g7(I, ie);
  }), P.add(ke.getBlocksPanel, () => ({
    isOpen: r.isOpen
  })), P.add(ke.setBlocksPanel, (I, F, V) => {
    const L = V || {};
    Rn(L.isOpen) && r.setOpen(L.isOpen);
  }), P.add(ke.canvasReload, () => {
    const I = e.getSelected(), F = $.getCanvasView(), { frames: V } = $.canvas;
    V.once("loaded:all", () => {
      const L = I == null ? void 0 : I.getView();
      L && !L.isInViewport() && L.el.scrollIntoView({ block: "center" });
    }), F.renderFrames();
  }), P.add(ke.contextMenuComponent, (I, F, V) => {
    const { component: L, ...W } = V;
    c.showForComponent(L, W);
  }), P.add(ke.getStateContextMenu, () => c.publicState), P.add(ke.setStateContextMenu, (I, F, V) => {
    c.setPublicState(V);
  }), P.add(ke.symbolAdd, (I, F, V) => {
    const L = V.component || e.getSelected();
    if (L)
      return Z.getSymbolInfo(L).isSymbol ? o.add("skip-symbol", {
        header: "The selected element is already a symbol",
        variant: Gn.Warning
      }) : Z.addSymbol(L);
  }), P.add(ke.symbolDetach, (I, F, V) => {
    const L = V.component || e.getSelected();
    L && Z.getSymbolInfo(L).isRoot && Z.detachSymbol(L);
  }), P.add(ke.symbolOverride, (I, F, V) => {
    const L = V.component || e.getSelected();
    L && (L.setSymbolOverride(V.override), e.Layers.updateLayer(L));
  }), P.add(
    ke.symbolPropagateStyles,
    (I, F, V) => {
      const L = V.component || e.getSelected();
      if (!L)
        return;
      const { Css: W } = e, ie = W.getComponentRules(L, { current: !0 })[0];
      if (ie) {
        const { state: re, mediaText: le } = ie.attributes, me = ie.getStyle();
        Z.getSymbolInfo(L).relatives.forEach((oe) => {
          W.setIdRule(oe.getId(), me, { state: re, mediaText: le });
        });
      }
      V.deep && L.components().forEach((re) => e.runCommand(ke.symbolPropagateStyles, { ...V, component: re }));
    }
  ), P.add(ke.assetProviderGet, () => gi(d.allProviders)), P.add(
    ke.assetProviderAdd,
    (I, F, { provider: V, index: L }) => {
      d.addProvider(V, L);
    }
  ), P.add(ke.assetProviderRemove, (I, F, { id: V }) => {
    const L = d.allProviders.filter((W) => W.id !== V);
    d.setAllProviders(L);
  }), P.add(ke.fontGet, () => gi(p.fonts)), P.add(ke.fontAdd, (I, F, { font: V }) => {
    p.addFont(V);
  }), P.add(ke.fontRemove, (I, F, { family: V }) => {
    p.removeFont(V);
  }), P.add(ke.fontManagerOpen, (I, F, V) => {
    A0(I, V);
  }), P.add(ke.menuFontLoad, (I, F, { font: V }) => P0(V, !1)), P.add(ke.toggleStateDataSource, () => (A = !A, e.trigger(kr.toggleDataSourcesPreview, { showPlaceholder: A }), e.refresh({ tools: !0 }), { showPlaceholder: A })), P.add(ke.getStateDataSource, () => ({ showPlaceholder: A })), P.add(ke.dataSourceSetGlobalData, (I, F, { globalData: V }) => {
    const L = JE(V);
    return e.DataSources.get(wa.globalData).setRecords(L);
  }), P.add(ke.setDragAbsolute, (I, F, { enabled: V }) => {
    n.setIsDraggingAbsolute(!!V);
  }), P.add(ke.dataSourceSetImporter, (I, F, V) => {
    e.on(e.Parser.events.htmlBefore, (L) => {
      L.input = V.import(L.input);
    });
  }), P.add(ke.dataSourceSetExporter, (I, F, V) => {
    e.config.optsHtml = {
      ...e.config.optsHtml,
      exporter: V
    };
  }), _7(e, t), $7(e, t), P7(e, t), E7(e), h7(e), t7(e), m7(e, t), C7(e, t);
}
const I7 = /\s(?![^(]*\))/, xS = /^-?[0-9]+[a-zA-Z%]{0,}$/;
function wS(e) {
  const t = e.split(I7), n = t.indexOf("inset") >= 0, r = t.filter((g) => g !== "inset"), o = r.filter((g) => !xS.test(g))[0] || "currentColor", i = r.filter((g) => xS.test(g)), [l = "0", c = "0", d = "0", p = "0"] = i;
  return {
    x: l,
    y: c,
    blur: d,
    spread: p,
    inset: n,
    color: o
  };
}
function eg(e) {
  const t = e.indexOf("(") + 1, n = e.lastIndexOf(")");
  return {
    name: e.substring(0, t - 1).trim(),
    value: String.prototype.substring.apply(e, [t, n >= 0 ? n : void 0]).trim()
  };
}
var V7 = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, bs = function(e) {
  return typeof e == "string" ? e.length > 0 : typeof e == "number";
}, Pn = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n + 0;
}, Xr = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e > t ? e : t;
}, t5 = function(e) {
  return (e = isFinite(e) ? e % 360 : 0) > 0 ? e : e + 360;
}, SS = function(e) {
  return { r: Xr(e.r, 0, 255), g: Xr(e.g, 0, 255), b: Xr(e.b, 0, 255), a: Xr(e.a) };
}, Hm = function(e) {
  return { r: Pn(e.r), g: Pn(e.g), b: Pn(e.b), a: Pn(e.a, 3) };
}, H7 = /^#([0-9a-f]{3,8})$/i, xf = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, n5 = function(e) {
  var t = e.r, n = e.g, r = e.b, o = e.a, i = Math.max(t, n, r), l = i - Math.min(t, n, r), c = l ? i === t ? (n - r) / l : i === n ? 2 + (r - t) / l : 4 + (t - n) / l : 0;
  return { h: 60 * (c < 0 ? c + 6 : c), s: i ? l / i * 100 : 0, v: i / 255 * 100, a: o };
}, r5 = function(e) {
  var t = e.h, n = e.s, r = e.v, o = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var i = Math.floor(t), l = r * (1 - n), c = r * (1 - (t - i) * n), d = r * (1 - (1 - t + i) * n), p = i % 6;
  return { r: 255 * [r, c, l, l, d, r][p], g: 255 * [d, r, r, c, l, l][p], b: 255 * [l, l, d, r, r, c][p], a: o };
}, jS = function(e) {
  return { h: t5(e.h), s: Xr(e.s, 0, 100), l: Xr(e.l, 0, 100), a: Xr(e.a) };
}, CS = function(e) {
  return { h: Pn(e.h), s: Pn(e.s), l: Pn(e.l), a: Pn(e.a, 3) };
}, ES = function(e) {
  return r5((n = (t = e).s, { h: t.h, s: (n *= ((r = t.l) < 50 ? r : 100 - r) / 100) > 0 ? 2 * n / (r + n) * 100 : 0, v: r + n, a: t.a }));
  var t, n, r;
}, Gc = function(e) {
  return { h: (t = n5(e)).h, s: (o = (200 - (n = t.s)) * (r = t.v) / 100) > 0 && o < 200 ? n * r / 100 / (o <= 100 ? o : 200 - o) * 100 : 0, l: o / 2, a: t.a };
  var t, n, r, o;
}, F7 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, z7 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, B7 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, U7 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, tv = { string: [[function(e) {
  var t = H7.exec(e);
  return t ? (e = t[1]).length <= 4 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? Pn(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : e.length === 6 || e.length === 8 ? { r: parseInt(e.substr(0, 2), 16), g: parseInt(e.substr(2, 2), 16), b: parseInt(e.substr(4, 2), 16), a: e.length === 8 ? Pn(parseInt(e.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(e) {
  var t = B7.exec(e) || U7.exec(e);
  return t ? t[2] !== t[4] || t[4] !== t[6] ? null : SS({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : null;
}, "rgb"], [function(e) {
  var t = F7.exec(e) || z7.exec(e);
  if (!t)
    return null;
  var n, r, o = jS({ h: (n = t[1], r = t[2], r === void 0 && (r = "deg"), Number(n) * (V7[r] || 1)), s: Number(t[3]), l: Number(t[4]), a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1) });
  return ES(o);
}, "hsl"]], object: [[function(e) {
  var t = e.r, n = e.g, r = e.b, o = e.a, i = o === void 0 ? 1 : o;
  return bs(t) && bs(n) && bs(r) ? SS({ r: Number(t), g: Number(n), b: Number(r), a: Number(i) }) : null;
}, "rgb"], [function(e) {
  var t = e.h, n = e.s, r = e.l, o = e.a, i = o === void 0 ? 1 : o;
  if (!bs(t) || !bs(n) || !bs(r))
    return null;
  var l = jS({ h: Number(t), s: Number(n), l: Number(r), a: Number(i) });
  return ES(l);
}, "hsl"], [function(e) {
  var t = e.h, n = e.s, r = e.v, o = e.a, i = o === void 0 ? 1 : o;
  if (!bs(t) || !bs(n) || !bs(r))
    return null;
  var l = function(c) {
    return { h: t5(c.h), s: Xr(c.s, 0, 100), v: Xr(c.v, 0, 100), a: Xr(c.a) };
  }({ h: Number(t), s: Number(n), v: Number(r), a: Number(i) });
  return r5(l);
}, "hsv"]] }, PS = function(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n][0](e);
    if (r)
      return [r, t[n][1]];
  }
  return [null, void 0];
}, W7 = function(e) {
  return typeof e == "string" ? PS(e.trim(), tv.string) : typeof e == "object" && e !== null ? PS(e, tv.object) : [null, void 0];
}, Fm = function(e, t) {
  var n = Gc(e);
  return { h: n.h, s: Xr(n.s + 100 * t, 0, 100), l: n.l, a: n.a };
}, zm = function(e) {
  return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3 / 255;
}, _S = function(e, t) {
  var n = Gc(e);
  return { h: n.h, s: n.s, l: Xr(n.l + 100 * t, 0, 100), a: n.a };
}, nv = function() {
  function e(t) {
    this.parsed = W7(t)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return e.prototype.isValid = function() {
    return this.parsed !== null;
  }, e.prototype.brightness = function() {
    return Pn(zm(this.rgba), 2);
  }, e.prototype.isDark = function() {
    return zm(this.rgba) < 0.5;
  }, e.prototype.isLight = function() {
    return zm(this.rgba) >= 0.5;
  }, e.prototype.toHex = function() {
    return t = Hm(this.rgba), n = t.r, r = t.g, o = t.b, l = (i = t.a) < 1 ? xf(Pn(255 * i)) : "", "#" + xf(n) + xf(r) + xf(o) + l;
    var t, n, r, o, i, l;
  }, e.prototype.toRgb = function() {
    return Hm(this.rgba);
  }, e.prototype.toRgbString = function() {
    return t = Hm(this.rgba), n = t.r, r = t.g, o = t.b, (i = t.a) < 1 ? "rgba(" + n + ", " + r + ", " + o + ", " + i + ")" : "rgb(" + n + ", " + r + ", " + o + ")";
    var t, n, r, o, i;
  }, e.prototype.toHsl = function() {
    return CS(Gc(this.rgba));
  }, e.prototype.toHslString = function() {
    return t = CS(Gc(this.rgba)), n = t.h, r = t.s, o = t.l, (i = t.a) < 1 ? "hsla(" + n + ", " + r + "%, " + o + "%, " + i + ")" : "hsl(" + n + ", " + r + "%, " + o + "%)";
    var t, n, r, o, i;
  }, e.prototype.toHsv = function() {
    return t = n5(this.rgba), { h: Pn(t.h), s: Pn(t.s), v: Pn(t.v), a: Pn(t.a, 3) };
    var t;
  }, e.prototype.invert = function() {
    return No({ r: 255 - (t = this.rgba).r, g: 255 - t.g, b: 255 - t.b, a: t.a });
    var t;
  }, e.prototype.saturate = function(t) {
    return t === void 0 && (t = 0.1), No(Fm(this.rgba, t));
  }, e.prototype.desaturate = function(t) {
    return t === void 0 && (t = 0.1), No(Fm(this.rgba, -t));
  }, e.prototype.grayscale = function() {
    return No(Fm(this.rgba, -1));
  }, e.prototype.lighten = function(t) {
    return t === void 0 && (t = 0.1), No(_S(this.rgba, t));
  }, e.prototype.darken = function(t) {
    return t === void 0 && (t = 0.1), No(_S(this.rgba, -t));
  }, e.prototype.rotate = function(t) {
    return t === void 0 && (t = 15), this.hue(this.hue() + t);
  }, e.prototype.alpha = function(t) {
    return typeof t == "number" ? No({ r: (n = this.rgba).r, g: n.g, b: n.b, a: t }) : Pn(this.rgba.a, 3);
    var n;
  }, e.prototype.hue = function(t) {
    var n = Gc(this.rgba);
    return typeof t == "number" ? No({ h: t, s: n.s, l: n.l, a: n.a }) : Pn(n.h);
  }, e.prototype.isEqual = function(t) {
    return this.toHex() === No(t).toHex();
  }, e;
}(), No = function(e) {
  return e instanceof nv ? e : new nv(e);
}, kS = [], G7 = function(e) {
  e.forEach(function(t) {
    kS.indexOf(t) < 0 && (t(nv, tv), kS.push(t));
  });
};
function K7(e, t) {
  var n = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r = {};
  for (var o in n)
    r[n[o]] = o;
  var i = {};
  e.prototype.toName = function(l) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b))
      return "transparent";
    var c, d, p = r[this.toHex()];
    if (p)
      return p;
    if (l != null && l.closest) {
      var g = this.toRgb(), m = 1 / 0, v = "black";
      if (!i.length)
        for (var b in n)
          i[b] = new e(n[b]).toRgb();
      for (var x in n) {
        var w = (c = g, d = i[x], Math.pow(c.r - d.r, 2) + Math.pow(c.g - d.g, 2) + Math.pow(c.b - d.b, 2));
        w < m && (m = w, v = x);
      }
      return v;
    }
  }, t.string.push([function(l) {
    var c = l.toLowerCase(), d = c === "transparent" ? "#0000" : n[c];
    return d ? new e(d).toRgb() : null;
  }, "name"]);
}
function tg() {
  return (tg = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function o5(e, t) {
  if (e == null)
    return {};
  var n, r, o = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++)
    t.indexOf(n = i[r]) >= 0 || (o[n] = e[n]);
  return o;
}
function rv(e) {
  var t = y.useRef(e), n = y.useRef(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var Tl = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, Kc = function(e) {
  return "touches" in e;
}, ov = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, TS = function(e, t, n) {
  var r = e.getBoundingClientRect(), o = Kc(t) ? function(i, l) {
    for (var c = 0; c < i.length; c++)
      if (i[c].identifier === l)
        return i[c];
    return i[0];
  }(t.touches, n) : t;
  return { left: Tl((o.pageX - (r.left + ov(e).pageXOffset)) / r.width), top: Tl((o.pageY - (r.top + ov(e).pageYOffset)) / r.height) };
}, OS = function(e) {
  !Kc(e) && e.preventDefault();
}, R0 = Q.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = o5(e, ["onMove", "onKey"]), o = y.useRef(null), i = rv(t), l = rv(n), c = y.useRef(null), d = y.useRef(!1), p = y.useMemo(function() {
    var b = function(j) {
      OS(j), (Kc(j) ? j.touches.length > 0 : j.buttons > 0) && o.current ? i(TS(o.current, j, c.current)) : w(!1);
    }, x = function() {
      return w(!1);
    };
    function w(j) {
      var C = d.current, E = ov(o.current), P = j ? E.addEventListener : E.removeEventListener;
      P(C ? "touchmove" : "mousemove", b), P(C ? "touchend" : "mouseup", x);
    }
    return [function(j) {
      var C = j.nativeEvent, E = o.current;
      if (E && (OS(C), !function(k, T) {
        return T && !Kc(k);
      }(C, d.current) && E)) {
        if (Kc(C)) {
          d.current = !0;
          var P = C.changedTouches || [];
          P.length && (c.current = P[0].identifier);
        }
        E.focus(), i(TS(E, C, c.current)), w(!0);
      }
    }, function(j) {
      var C = j.which || j.keyCode;
      C < 37 || C > 40 || (j.preventDefault(), l({ left: C === 39 ? 0.05 : C === 37 ? -0.05 : 0, top: C === 40 ? 0.05 : C === 38 ? -0.05 : 0 }));
    }, w];
  }, [l, i]), g = p[0], m = p[1], v = p[2];
  return y.useEffect(function() {
    return v;
  }, [v]), Q.createElement("div", tg({}, r, { onTouchStart: g, onMouseDown: g, className: "react-colorful__interactive", ref: o, onKeyDown: m, tabIndex: 0, role: "slider" }));
}), ng = function(e) {
  return e.filter(Boolean).join(" ");
}, N0 = function(e) {
  var t = e.color, n = e.left, r = e.top, o = r === void 0 ? 0.5 : r, i = ng(["react-colorful__pointer", e.className]);
  return Q.createElement("div", { className: i, style: { top: 100 * o + "%", left: 100 * n + "%" } }, Q.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, qn = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, s5 = function(e) {
  var t = e.s, n = e.v, r = e.a, o = (200 - t) * n / 100;
  return { h: qn(e.h), s: qn(o > 0 && o < 200 ? t * n / 100 / (o <= 100 ? o : 200 - o) * 100 : 0), l: qn(o / 2), a: qn(r, 2) };
}, sv = function(e) {
  var t = s5(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, Bm = function(e) {
  var t = s5(e);
  return "hsla(" + t.h + ", " + t.s + "%, " + t.l + "%, " + t.a + ")";
}, q7 = function(e) {
  var t = e.h, n = e.s, r = e.v, o = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var i = Math.floor(t), l = r * (1 - n), c = r * (1 - (t - i) * n), d = r * (1 - (1 - t + i) * n), p = i % 6;
  return { r: qn(255 * [r, c, l, l, d, r][p]), g: qn(255 * [d, r, r, c, l, l][p]), b: qn(255 * [l, l, d, r, r, c][p]), a: qn(o, 2) };
}, Y7 = function(e) {
  var t = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
  return t ? X7({ r: Number(t[1]) / (t[2] ? 100 / 255 : 1), g: Number(t[3]) / (t[4] ? 100 / 255 : 1), b: Number(t[5]) / (t[6] ? 100 / 255 : 1), a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1) }) : { h: 0, s: 0, v: 0, a: 1 };
}, X7 = function(e) {
  var t = e.r, n = e.g, r = e.b, o = e.a, i = Math.max(t, n, r), l = i - Math.min(t, n, r), c = l ? i === t ? (n - r) / l : i === n ? 2 + (r - t) / l : 4 + (t - n) / l : 0;
  return { h: qn(60 * (c < 0 ? c + 6 : c)), s: qn(i ? l / i * 100 : 0), v: qn(i / 255 * 100), a: o };
}, Z7 = Q.memo(function(e) {
  var t = e.hue, n = e.onChange, r = ng(["react-colorful__hue", e.className]);
  return Q.createElement("div", { className: r }, Q.createElement(R0, { onMove: function(o) {
    n({ h: 360 * o.left });
  }, onKey: function(o) {
    n({ h: Tl(t + 360 * o.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": qn(t), "aria-valuemax": "360", "aria-valuemin": "0" }, Q.createElement(N0, { className: "react-colorful__hue-pointer", left: t / 360, color: sv({ h: t, s: 100, v: 100, a: 1 }) })));
}), J7 = Q.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: sv({ h: t.h, s: 100, v: 100, a: 1 }) };
  return Q.createElement("div", { className: "react-colorful__saturation", style: r }, Q.createElement(R0, { onMove: function(o) {
    n({ s: 100 * o.left, v: 100 - 100 * o.top });
  }, onKey: function(o) {
    n({ s: Tl(t.s + 100 * o.left, 0, 100), v: Tl(t.v - 100 * o.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + qn(t.s) + "%, Brightness " + qn(t.v) + "%" }, Q.createElement(N0, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: sv(t) })));
}), Q7 = function(e, t) {
  if (e === t)
    return !0;
  for (var n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}, eD = function(e, t) {
  return e.replace(/\s/g, "") === t.replace(/\s/g, "");
};
function tD(e, t, n) {
  var r = rv(n), o = y.useState(function() {
    return e.toHsva(t);
  }), i = o[0], l = o[1], c = y.useRef({ color: t, hsva: i });
  y.useEffect(function() {
    if (!e.equal(t, c.current.color)) {
      var p = e.toHsva(t);
      c.current = { hsva: p, color: t }, l(p);
    }
  }, [t, e]), y.useEffect(function() {
    var p;
    Q7(i, c.current.hsva) || e.equal(p = e.fromHsva(i), c.current.color) || (c.current = { hsva: i, color: p }, r(p));
  }, [i, e, r]);
  var d = y.useCallback(function(p) {
    l(function(g) {
      return Object.assign({}, g, p);
    });
  }, []);
  return [i, d];
}
var nD = typeof window < "u" ? y.useLayoutEffect : y.useEffect, rD = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, LS = /* @__PURE__ */ new Map(), oD = function(e) {
  nD(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !LS.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, LS.set(t, n);
      var r = rD();
      r && n.setAttribute("nonce", r), t.head.appendChild(n);
    }
  }, []);
}, sD = function(e) {
  var t = e.className, n = e.hsva, r = e.onChange, o = { backgroundImage: "linear-gradient(90deg, " + Bm(Object.assign({}, n, { a: 0 })) + ", " + Bm(Object.assign({}, n, { a: 1 })) + ")" }, i = ng(["react-colorful__alpha", t]), l = qn(100 * n.a);
  return Q.createElement("div", { className: i }, Q.createElement("div", { className: "react-colorful__alpha-gradient", style: o }), Q.createElement(R0, { onMove: function(c) {
    r({ a: c.left });
  }, onKey: function(c) {
    r({ a: Tl(n.a + c.left) });
  }, "aria-label": "Alpha", "aria-valuetext": l + "%", "aria-valuenow": l, "aria-valuemin": "0", "aria-valuemax": "100" }, Q.createElement(N0, { className: "react-colorful__alpha-pointer", left: n.a, color: Bm(n) })));
}, iD = function(e) {
  var t = e.className, n = e.colorModel, r = e.color, o = r === void 0 ? n.defaultColor : r, i = e.onChange, l = o5(e, ["className", "colorModel", "color", "onChange"]), c = y.useRef(null);
  oD(c);
  var d = tD(n, o, i), p = d[0], g = d[1], m = ng(["react-colorful", t]);
  return Q.createElement("div", tg({}, l, { ref: c, className: m }), Q.createElement(J7, { hsva: p, onChange: g }), Q.createElement(Z7, { hue: p.h, onChange: g }), Q.createElement(sD, { hsva: p, onChange: g, className: "react-colorful__last-control" }));
}, aD = { defaultColor: "rgba(0, 0, 0, 1)", toHsva: Y7, fromHsva: function(e) {
  var t = q7(e);
  return "rgba(" + t.r + ", " + t.g + ", " + t.b + ", " + t.a + ")";
}, equal: eD }, lD = function(e) {
  return Q.createElement(iD, tg({}, e, { colorModel: aD }));
};
G7([K7]);
const cD = "gs-cmp-color-picker", uD = { backgroundSize: "10px" }, dD = [0, 15], fD = (e) => e.startsWith("rgba") ? e : No(e).toRgbString();
function i5({ className: e, value: t, onChange: n, disabled: r }) {
  const o = fD(t || ""), [i, l] = y.useState(!1), c = ns() && !!window.EyeDropper, d = B(
    `${cD}-handler gs-utl-bg-checker gs-utl-overflow-hidden gs-utl-cursor-pointer`,
    e,
    ve.b,
    ve.rnd,
    ee.br
  ), p = (x) => {
    n == null || n(x, !0);
  }, g = () => {
    c && new window.EyeDropper().open().then((w) => p(w.sRGBHex));
  }, m = () => {
    l(!0);
  }, v = () => {
    n == null || n(o, !1), l(!1);
  }, b = /* @__PURE__ */ u.jsxs("div", { style: uD, className: d, children: [
    i && /* @__PURE__ */ u.jsx(
      "div",
      {
        onPointerUp: v,
        className: B("gs-utl-fixed gs-utl-inset-0 gs-utl-z-50 gs-utl-cursor-grabbing")
      }
    ),
    /* @__PURE__ */ u.jsx("div", { className: B("gs-utl-w-4 gs-utl-h-4"), style: { backgroundColor: t } })
  ] });
  return /* @__PURE__ */ u.jsxs(
    rs,
    {
      handler: b,
      title: "Color",
      size: "s",
      placement: "left-end",
      offset: dD,
      clickAway: !0,
      disabled: r,
      children: [
        /* @__PURE__ */ u.jsx(
          lD,
          {
            className: "color-picker",
            color: o,
            onChange: p,
            onPointerDown: m,
            onPointerUp: v
          }
        ),
        /* @__PURE__ */ u.jsxs(G, { className: B("gs-utl-mt-3"), space: "s", children: [
          /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(jt, { size: "s", value: o, onChange: p }) }),
          c && /* @__PURE__ */ u.jsx(ut, { type: "button", onClick: g, children: /* @__PURE__ */ u.jsx(ye, { icon: fe.eyedropperVariant, size: Ee.s }) })
        ] })
      ]
    }
  );
}
const pD = (e) => {
  const t = parseFloat(e), n = e.replace(`${t}`, "").trim();
  return { number: t || t === 0 ? `${t}` : "", unit: n };
}, a5 = ({ value: e, step: t }) => {
  const n = parseFloat(`${e}`);
  let r = 0;
  if (Math.floor(n) !== n && t) {
    const o = `${t}`.split(".")[1];
    r = (o == null ? void 0 : o.length) || 0;
  }
  return r ? parseFloat(n.toFixed(r)) : n;
}, gD = ({
  value: e,
  key: t,
  shiftKey: n,
  min: r,
  max: o,
  step: i = 1
}) => {
  const l = t === "ArrowUp", c = t === "ArrowDown";
  let d = null;
  if (l || c) {
    d = Number(e);
    const p = parseFloat(`${i}`);
    l && (d += (n ? 10 : 1) * p), c && (d -= (n ? 10 : 1) * p), d = `${rg({ min: r, max: o, value: d })}`, d = a5({ value: d, step: i });
  }
  return d;
}, rg = ({ min: e, max: t, value: n }) => {
  const r = parseFloat(`${n}`);
  let o = r || 0;
  return Rn(e) && (o = Math.max(o, parseFloat(`${e}`) || 0)), Rn(t) && (o = Math.min(o, parseFloat(`${t}`) || 0)), `${`${r}` != `${n}` ? n : o}`;
}, hD = (e, t, n, r = {}) => {
  const o = parseInt(`${e}`, 10) || 0, { min: i, max: l, step: c = 1 } = r;
  let d = o;
  const p = (m) => {
    const v = m.clientY - t, b = o - v * parseFloat(`${c}`);
    d = a5({
      value: rg({ min: i, max: l, value: b }),
      step: c
    }), n(d, !0);
  }, g = () => {
    window.removeEventListener("mousemove", p), window.removeEventListener("mouseup", g), n(d);
  };
  window.addEventListener("mousemove", p), window.addEventListener("mouseup", g);
}, mD = (e, t, n = {}) => {
  const { partial: r } = n, o = (i, l) => i === l || r && i.startsWith(l);
  return t.some((i) => o(typeof i == "string" ? i : i.id, e));
}, MS = (e) => Rn(e) ? e : "", vD = "gs-cmp-number-field";
function et(e) {
  const {
    className: t,
    value: n,
    units: r,
    valueUnit: o,
    size: i = "m",
    pan: l = !0,
    min: c,
    max: d,
    step: p,
    placeholder: g,
    disabled: m,
    onChange: v,
    onChangeUnit: b
  } = e, [x, w] = y.useState(MS(n)), [j, C] = y.useState(!1), E = (r == null ? void 0 : r.map((N) => ({ id: N, label: N }))) || [], P = { min: c, max: d, step: p };
  y.useEffect(() => {
    w(MS(n));
  }, [n, o]);
  const k = (N, R) => {
    v == null || v(rg({ min: c, max: d, value: N }), R);
  }, T = (N) => {
    if (m)
      return;
    C(!0);
    const R = (z, D) => {
      k(z, !!D), !D && C(!1);
    };
    hD(x, N.clientY, R, P);
  }, O = (N) => {
    const { key: R, shiftKey: z } = N;
    switch (R) {
      case "Escape":
        return w(n);
      case "Enter":
        return k(x);
    }
    const D = gD({ step: p, value: n, key: R, shiftKey: z });
    D !== null && (N.preventDefault(), k(D));
  }, A = () => {
    k(x);
  }, $ = Li({ ...e, className: B(vD, t) });
  return /* @__PURE__ */ u.jsxs("div", { ...$, children: [
    j && /* @__PURE__ */ u.jsx("div", { className: B("gs-utl-fixed gs-utl-inset-0 gs-utl-z-50 gs-utl-cursor-ns") }),
    /* @__PURE__ */ u.jsx(Eo, { as: e.labelAs, ...e }),
    /* @__PURE__ */ u.jsxs(G, { className: S0(e), items: "center", space: "x2s", children: [
      !!l && /* @__PURE__ */ u.jsx(
        Y,
        {
          onMouseDown: T,
          className: B(
            "gs-utl-opacity-50 gs-utl-cursor-ns",
            i === "m" && "-gs-utl-ml-3",
            i === "s" && "-gs-utl-ml-2",
            l !== !0 && "gs-utl-mr-0.5 -gs-utl-ml-1"
          ),
          children: l === !0 ? /* @__PURE__ */ u.jsx(ye, { icon: fe.panVertical, size: Ee.s2x }) : l
        }
      ),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(
        "input",
        {
          className: Uu(e),
          value: x,
          disabled: m,
          onChange: (N) => w(N.target.value),
          placeholder: g,
          onBlur: A,
          onKeyDown: O
        }
      ) }),
      !!E.length && /* @__PURE__ */ u.jsx(Y, { className: B(E.length === 1 && "gs-utl-opacity-50 gs-utl-pointer-events-none"), children: /* @__PURE__ */ u.jsx(
        Ze,
        {
          caret: "",
          size: "x2s",
          pos: "right",
          width: "75px",
          emptyState: "-",
          border: !1,
          value: o,
          disabled: m,
          onChange: (N) => b == null ? void 0 : b(N),
          options: E
        }
      ) })
    ] })
  ] });
}
const yD = "gs-cmp-switch-field";
function mu(e) {
  const { className: t, value: n, label: r, labelAs: o, border: i, disabled: l, onChange: c } = e, d = !!n, p = B(
    "gs-utl-relative gs-utl-inline-flex gs-utl-items-center gs-utl-h-6 gs-utl-rounded-full gs-utl-w-11 gs-utl-transition-colors focus:gs-utl-outline-none",
    d ? ee.bgA : ee.bgH,
    lu.focus,
    i && `${ee.br} ${ve.b}`
  );
  return /* @__PURE__ */ u.jsx(Em.Group, { children: /* @__PURE__ */ u.jsxs(G, { items: "center", className: B(yD, t), full: !0, children: [
    !!r && /* @__PURE__ */ u.jsx(Em.Label, { as: o, className: B("gs-utl-mr-4 gs-utl-flex-1"), passive: !0, children: /* @__PURE__ */ u.jsx(Eo, { ...e, as: "span" }) }),
    /* @__PURE__ */ u.jsx(Em, { checked: d, onChange: c, className: p, disabled: l, children: /* @__PURE__ */ u.jsx(
      "span",
      {
        className: B(
          ee.bg,
          "gs-utl-inline-block gs-utl-w-4 gs-utl-h-4 gs-utl-transform gs-utl-rounded-full gs-utl-transition-transform",
          d ? "gs-utl-translate-x-6" : "gs-utl-translate-x-1"
        )
      }
    ) })
  ] }) });
}
const bD = /^-?[0-9]+(\.[0-9]+)?[a-zA-Z%]{0,}$/, xD = /,(?![^(]*\))/, Um = /\s(?![^(]*\))/, wD = /^(closest-side|closest-corner|farthest-side|farthest-corner)/i, Wm = /^circle|ellipse/i, $0 = (e) => {
  var g;
  const t = [], { name: n, value: r } = eg(e), [o, ...i] = r.split(xD).map((m) => m.trim()).filter(Boolean), l = i.length > 1, c = l ? o : "", d = { type: "none" }, p = l ? i : [o, ...i];
  if (bD.test(c))
    d.type = "angle", d.value = c;
  else if (/^to\s/.test(c))
    d.type = "side-or-corner", d.value = c;
  else if (wD.test(c))
    d.type = "size", d.value = c;
  else if (Wm.test(c) || /^at\s/.test(c) || /\sat\s/.test(c)) {
    d.type = "at", d.value = c;
    const m = ((g = c.match(Wm)) == null ? void 0 : g[0]) || "circle";
    d.shape = m;
    const v = { x: "0%", y: "0%" }, b = { x: "0%", y: "0%" }, [x, w] = c.replace(Wm, "").trim().split("at").map((j) => j.trim());
    if (x) {
      const [j, C] = x.split(Um);
      v.x = j, v.y = C || j;
    }
    if (w) {
      const [j, C] = w.split(Um);
      b.x = j, b.y = C || j;
    }
    d.size = v, d.position = b;
  }
  return p.forEach((m) => {
    const [v, b] = m.split(Um);
    t.push({ color: v, hint: b ? parseFloat(b) : null });
  }), t.forEach((m, v) => {
    m.hint === null && (m.hint = v / (t.length - 1) * 100);
  }), {
    name: n,
    orientation: d,
    colorStops: t
  };
}, si = ({
  stops: e,
  orientation: t = "to right",
  name: n = "linear-gradient"
}) => {
  const o = (e.length === 1 ? [
    { color: e[0].color, hint: null },
    { color: e[0].color, hint: null }
  ] : e).map((i) => `${i.color} ${i.hint ? `${i.hint}%` : ""}`.trim()).join(", ");
  return o ? `${n}(${t}, ${o})` : "none";
}, SD = (e) => e.slice().sort((t, n) => (t.hint || 0) - (n.hint || 0)), jD = "gs-cmp-grad-picker";
function CD({ className: e, value: t, onChange: n }) {
  var q, te, I;
  const r = $0(t), [o, i] = y.useState(r.colorStops), [l, c] = y.useState(null), d = y.useRef(null), p = ce(jD, "gs-grad-picker gs-utl-select-none gs-utl-gap-1", e, ve.rnd), g = r.name || "linear-gradient", m = g.indexOf("radial") >= 0, v = g.indexOf("repeating") >= 0, b = r.orientation.value, x = `${parseFloat(`${b}`) || 180}`, w = `${parseFloat(`${(q = r.orientation.size) == null ? void 0 : q.x}`) || 0}`, j = `${parseFloat(`${(te = r.orientation.position) == null ? void 0 : te.x}`) || 0}`, C = `${parseFloat(`${(I = r.orientation.position) == null ? void 0 : I.y}`) || 0}`, E = 0, P = 100, k = (F, V = !1) => {
    const L = SD(F);
    i(L), n == null || n(si({ name: g, orientation: b, stops: L }), V);
  }, T = (F, V = !1) => {
    n == null || n(si({ stops: o, name: g, orientation: `${F}deg` }), V);
  }, O = (F, V = !1) => {
    n == null || n(si({ stops: o, name: g, orientation: `${F}px at ${j}% ${C}%` }), V);
  }, A = (F, V = !1) => {
    n == null || n(si({ stops: o, name: g, orientation: `${w}px at ${F}% ${C}%` }), V);
  }, $ = (F, V = !1) => {
    n == null || n(si({ stops: o, name: g, orientation: `${w}px at ${j}% ${F}%` }), V);
  }, N = (F) => {
    const V = `${F ? "repeating-" : ""}${m ? "radial" : "linear"}-gradient`;
    n == null || n(si({ stops: o, orientation: b, name: V }));
  }, R = (F) => {
    const V = `${v ? "repeating-" : ""}${F ? "radial" : "linear"}-gradient`;
    n == null || n(si({ stops: o, orientation: F ? "100px at 50% 50%" : "90deg", name: V }));
  };
  y.useEffect(() => {
    if (!l)
      return;
    const F = parseFloat(`${l.stop.hint}`), V = (W) => {
      let re = (W.clientX - l.x) * 100;
      re = re / l.w, re = F + re, re = re < E ? E : re, re = re > P ? P : re, l.stop.hint = parseInt(`${re}`, 10), k(o, !0);
    }, L = () => {
      c(null), k(o);
    };
    return window.addEventListener("pointermove", V), window.addEventListener("pointerup", L), () => {
      window.removeEventListener("pointermove", V), window.removeEventListener("pointerup", L), L();
    };
  }, [l]);
  const z = (F, V) => {
    const L = d.current;
    c({
      stop: V,
      w: (L == null ? void 0 : L.clientWidth) || 0,
      h: (L == null ? void 0 : L.clientHeight) || 0,
      x: F.clientX,
      y: F.clientY
    });
  }, D = (F) => {
    const V = d.current, L = (V == null ? void 0 : V.clientWidth) || 0, W = (V == null ? void 0 : V.clientHeight) || 0, ie = F.nativeEvent.offsetX - ((V == null ? void 0 : V.clientLeft) || 0), re = F.nativeEvent.offsetY - ((V == null ? void 0 : V.clientTop) || 0), le = ie / L * 100, me = document.createElement("canvas"), oe = me.getContext("2d");
    if (!oe)
      return;
    me.width = L, me.height = W;
    const se = oe.createLinearGradient(0, 0, L, W);
    o.forEach((Le) => se.addColorStop(parseFloat(`${Le.hint}`) / 100, Le.color)), oe.fillStyle = se, oe.fillRect(0, 0, me.width, me.height), me.style.background = "black";
    const de = oe.getImageData(ie, re, 1, 1).data, we = de[3] ? (100 / 255 * de[3] / 100).toFixed(2) : 0, je = `rgba(${de[0]}, ${de[1]}, ${de[2]}, ${we})`, He = je === "rgba(0, 0, 0, 0)" ? "#000" : je;
    k([...o, { color: He, hint: le }]);
  }, Z = (F) => {
    k(o.filter((V) => V !== F));
  }, K = (F, V, L) => {
    V && (F.color = V), k(o, L);
  }, H = (F) => (l == null ? void 0 : l.stop) === F;
  return /* @__PURE__ */ u.jsxs(G, { className: p, col: !0, children: [
    !!(l != null && l.stop) && /* @__PURE__ */ u.jsx("div", { className: ce("fixed inset-0 z-50 cursor-colr") }),
    /* @__PURE__ */ u.jsxs("div", { className: ce("relative gjs-mb-6 gjs-mt-3"), children: [
      /* @__PURE__ */ u.jsx("div", { className: ce("bg-checker h-8", ve.rnd), children: /* @__PURE__ */ u.jsx(
        "div",
        {
          ref: d,
          className: ce("w-full h-full cursor-cross", ve.b, ve.rnd, ee.br),
          style: { backgroundImage: si({ stops: o }) },
          onClick: D
        }
      ) }),
      o.map((F, V) => /* @__PURE__ */ u.jsxs("div", { className: ce("absolute top-0 h-full"), style: { left: `${F.hint}%` }, children: [
        /* @__PURE__ */ u.jsx(
          "div",
          {
            className: ce("cursor-pointer absolute gs-utl-translate-x-[-50%] gs-utl-top-[-14px]"),
            onClick: () => Z(F),
            children: /* @__PURE__ */ u.jsx(ye, { icon: fe.close, size: Ee.s3x })
          }
        ),
        /* @__PURE__ */ u.jsx(
          "div",
          {
            onPointerDown: (L) => z(L, F),
            className: ce(
              "h-full w-1 gs-utl-translate-x-[-50%] cursor-colr opacity-50 gjs-border-white",
              ve.br,
              ve.bl,
              H(F) ? "gjs-bg-white" : "gjs-bg-black"
            )
          }
        ),
        /* @__PURE__ */ u.jsx("div", { className: ce("cursor-pointer gs-utl-bottom-[-17px] gs-utl-left-[-7px] absolute"), children: /* @__PURE__ */ u.jsx(
          i5,
          {
            value: F.color,
            onChange: (L, W) => K(F, L, W),
            className: ce("h-4 w-4 gjs-rounded-full gjs-border-2")
          }
        ) })
      ] }, V))
    ] }),
    /* @__PURE__ */ u.jsxs(G, { space: "s", items: "center", children: [
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(mu, { label: "Repeat", value: v, onChange: N }) }),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(mu, { label: "Radial", value: m, onChange: R }) })
    ] }),
    m ? /* @__PURE__ */ u.jsxs(G, { space: "s", col: !0, children: [
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(G, { space: "s", items: "center", children: /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(et, { pan: "S", size: "s", value: w, onChange: O, valueUnit: "px", units: ["px"] }) }) }) }),
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsxs(G, { space: "s", children: [
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(et, { pan: "X", size: "s", value: j, onChange: A, valueUnit: "%", units: ["%"] }) }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(et, { pan: "Y", size: "s", value: C, onChange: $, valueUnit: "%", units: ["%"] }) })
      ] }) })
    ] }) : /* @__PURE__ */ u.jsx(G, { space: "s", items: "center", nowrap: !0, children: /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(et, { pan: "A", size: "s", value: x, onChange: T, valueUnit: "deg", units: ["deg"] }) }) })
  ] });
}
const l5 = y.createContext(null), ED = ({ children: e }) => {
  const [t, n] = y.useState({
    setEditor: (r) => {
      n((o) => ({ ...o, editor: r }));
    }
  });
  return /* @__PURE__ */ u.jsx(l5.Provider, { value: t, children: e });
}, ro = () => {
  const e = y.useContext(l5);
  if (!e)
    throw new Error("useEditorInstance must be used within EditorInstanceProvider");
  return e;
}, Ar = () => {
  const { editor: e } = ro();
  if (!e)
    throw new Error(
      "useEditor used before the load of the editor instance. You can wrap your component in `<WithEditor>` or make use of `useEditorMaybe` hook and ensure the `editor` exists."
    );
  return e;
}, D0 = () => ro().editor, c5 = y.createContext(null), PD = ({ children: e }) => {
  const [t, n] = y.useState(() => ({
    setRefCanvas(r) {
      n((o) => ({ ...o, refCanvas: r }));
    },
    setCustomModal(r) {
      n((o) => ({ ...o, customModal: r }));
    },
    setCustomAssets(r) {
      n((o) => ({ ...o, customAssets: r }));
    },
    setCustomBlocks(r) {
      n((o) => ({ ...o, customBlocks: r }));
    },
    setCustomRte(r) {
      n((o) => ({ ...o, customRte: r }));
    },
    setCustomStyles(r) {
      n((o) => ({ ...o, customStyles: r }));
    },
    setCustomLayers(r) {
      n((o) => ({ ...o, customLayers: r }));
    },
    setCustomSelectors(r) {
      n((o) => ({ ...o, customSelectors: r }));
    },
    setCustomTraits(r) {
      n((o) => ({ ...o, customTraits: r }));
    },
    setReady(r) {
      n((o) => ({ ...o, ready: r }));
    }
  }));
  return /* @__PURE__ */ u.jsx(c5.Provider, { value: t, children: e });
}, ss = () => {
  const e = y.useContext(c5);
  if (!e)
    throw new Error("useEditorOptions must be used within EditorOptionsProvider");
  return e;
};
function _D(...e) {
  return (Array.isArray(e[0]) ? e[0] : [...e]).filter(Boolean).join(" ");
}
function Mi(e) {
  return typeof e == "function";
}
function wo() {
}
const u5 = (e) => typeof e == "string", kD = async (e) => {
  const t = document.createElement("link");
  t.href = e, t.rel = "stylesheet", document.head.appendChild(t);
}, d5 = (e) => {
  const t = u5(e) ? { id: e, src: e } : e;
  return new Promise((n, r) => {
    const o = document.createElement("script");
    if (document.querySelector(`script[src="${t.src}"]`))
      return n(t.id);
    o.src = t.src, o.onload = () => n(t.id), o.onerror = () => r(t.id), document.head.appendChild(o);
  });
}, TD = (e) => {
  const t = e.map((n) => d5(n));
  return Promise.allSettled(t);
}, AS = (e) => function() {
  const t = y.useRef(null);
  return y.useEffect(() => {
    const { current: n } = t;
    n && (u5(e) ? n.innerHTML = e : n.appendChild(e));
  }, [t.current]), /* @__PURE__ */ u.jsx("div", { ref: t });
}, RS = /* @__PURE__ */ new WeakMap();
function Vl(e) {
  if (!e)
    return () => /* @__PURE__ */ u.jsx(u.Fragment, {});
  const t = RS.get(e);
  if (t)
    return t;
  const n = function({ children: r }) {
    return Cr.createPortal(y.createElement("div", null, r), e);
  };
  return RS.set(e, n), n;
}
const OD = y.memo(function({ children: e }) {
  const { editor: t } = ro(), n = ss(), [r, o] = y.useState(!1), [i, l] = y.useState({
    assets: [],
    types: [],
    close: () => {
    },
    select: () => {
    },
    Container: () => /* @__PURE__ */ u.jsx(u.Fragment, {})
  });
  return y.useEffect(() => {
    if (!t)
      return;
    const c = t.Assets.events.custom, d = ({ open: p, assets: g, types: m, select: v, close: b, container: x }) => {
      p && l({
        assets: g,
        types: m,
        select: v,
        close: b,
        Container: Vl(x)
      }), o(p);
    };
    return t.on(c, d), () => {
      t.off(c, d);
    };
  }, [t]), y.useEffect(() => n.setCustomAssets(!0), []), t ? Mi(e) ? e({ open: r, ...i }) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
});
y.memo(function({ children: e }) {
  const { editor: t } = ro(), n = ss(), [r, o] = y.useState(() => ({
    blocks: [],
    dragStart: wo,
    dragStop: wo,
    mapCategoryBlocks: /* @__PURE__ */ new Map(),
    Container: () => /* @__PURE__ */ u.jsx(u.Fragment, {})
  }));
  return y.useEffect(() => {
    if (!t)
      return;
    const i = t.Blocks.events.custom, l = ({ blocks: c, container: d, dragStart: p, dragStop: g }) => {
      const m = c.reduce((v, b) => {
        const x = b.getCategoryLabel(), w = v.get(x);
        return w ? w.push(b) : v.set(x, [b]), v;
      }, /* @__PURE__ */ new Map());
      o({
        blocks: c,
        dragStart: p,
        dragStop: g,
        mapCategoryBlocks: m,
        Container: Vl(d)
      });
    };
    return t.on(i, l), t.Blocks.__trgCustom(), () => {
      t.off(i, l);
    };
  }, [t]), y.useEffect(() => n.setCustomBlocks(!0), []), t ? Mi(e) ? e(r) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
});
function LD({ children: e, ...t }) {
  const n = ss(), r = y.useRef(null);
  return y.useEffect(() => {
    r.current && n.setRefCanvas(r.current);
  }, [r.current]), /* @__PURE__ */ u.jsx("div", { ...t, ref: r, children: e });
}
const MD = y.memo(function({ children: e }) {
  const { editor: t } = ro(), [n, r] = y.useState(() => ({
    devices: [],
    selected: "",
    select: wo
  }));
  return y.useEffect(() => {
    if (!t)
      return;
    const { Devices: o } = t, i = o.events.all, l = () => {
      var c;
      r({
        devices: o.getDevices(),
        selected: (c = o.getSelected()) == null ? void 0 : c.id,
        select: (d) => o.select(d)
      });
    };
    return t.on(i, l), l(), () => {
      t.off(i, l);
    };
  }, [t]), t ? Mi(e) ? e(n) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
}), AD = (e) => !!(e && !Array.isArray(e) && typeof e == "object");
async function RD(e) {
  const t = e.map(({ id: i, src: l }) => ({ id: i, src: l })), n = e.reduce(
    (i, l) => (i[l.id] = l, i),
    {}
  ), r = [], o = [];
  return (await TD(t)).forEach((i) => {
    i.status === "fulfilled" ? r.push(n[i.value]) : o.push(n[i.reason]);
  }), { loaded: r, failed: o };
}
const ND = async (e) => {
  const t = [...e], n = {};
  if (t.length) {
    const r = {}, o = [];
    if (t.forEach((i, l) => {
      AD(i) && (r[i.id] = { index: l }, o.push(i));
    }), o.length) {
      const { loaded: i } = await RD(o);
      i.forEach(({ id: l, options: c }) => {
        r[l].loaded = !0, n[l] = c || {};
      });
    }
    Object.keys(r).forEach((i) => {
      const l = r[i];
      l.loaded ? t[l.index] = i : t[l.index] = !1;
    });
  }
  return {
    plugins: t.filter(Boolean),
    pluginOptions: n
  };
}, $D = y.memo(function({
  children: e,
  className: t,
  style: n,
  options: r = {},
  plugins: o = [],
  grapesjs: i,
  grapesjsCss: l,
  onEditor: c = wo,
  onReady: d,
  onUpdate: p,
  waitReady: g,
  ...m
}) {
  const { setEditor: v } = ro(), b = ss(), [x, w] = y.useState(!1), j = y.useRef(null);
  y.useEffect(() => {
    if (!b.ready || !j.current)
      return;
    const A = j.current, $ = b.refCanvas;
    let N, R = {}, z = [];
    const D = (Z) => {
      const K = {
        height: "100%",
        ...r,
        plugins: [...z, ...r.plugins || []],
        pluginsOpts: {
          ...r.pluginsOpts,
          ...R
        },
        modal: {
          custom: !!b.customModal,
          ...r.modal
        },
        assetManager: {
          custom: !!b.customAssets,
          ...r.assetManager
        },
        styleManager: {
          custom: !!b.customStyles,
          ...r.styleManager
        },
        blockManager: {
          custom: !!b.customBlocks,
          ...r.blockManager
        },
        richTextEditor: {
          custom: !!b.customRte,
          ...r.richTextEditor
        },
        layerManager: {
          custom: !!b.customLayers,
          ...r.layerManager
        },
        traitManager: {
          custom: !!b.customTraits,
          ...r.traitManager
        },
        selectorManager: {
          custom: !!b.customSelectors,
          ...r.selectorManager
        },
        container: $ || A,
        customUI: !!$,
        // Disables all default panels if Canvas is used
        ...$ ? {
          panels: { defaults: [] }
        } : {}
      };
      N = Z.init(K), v(N), c(N), p && N.on("update", () => {
        p(N.getProjectData(), N);
      }), N.onReady(() => {
        w(!0), d == null || d(N);
      });
    };
    return (async () => {
      l && await kD(l);
      const Z = await ND(o);
      z = Z.plugins, R = Z.pluginOptions, typeof i == "string" ? (await d5(i), D(window.grapesjs)) : D(i);
    })(), () => N == null ? void 0 : N.destroy();
  }, [b.ready]);
  const C = r.height ?? "100%", E = r.width ?? "100%", P = _D("gjs-editor-wrapper", t), k = g && !x, T = y.useMemo(
    () => ({
      ...n,
      height: C,
      width: E
    }),
    [C, E, n]
  ), O = y.useMemo(
    () => ({
      ...T,
      ...k ? {
        opacity: 0,
        width: 0,
        height: 0
      } : {}
    }),
    [T, k]
  );
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    g && !x ? /* @__PURE__ */ u.jsx("div", { className: P, style: T, children: g }) : null,
    /* @__PURE__ */ u.jsx("div", { ...m, ref: j, className: P, style: O, children: e })
  ] });
}), DD = y.memo(function() {
  const e = ss();
  return y.useEffect(() => e.setReady(!0), []), /* @__PURE__ */ u.jsx(u.Fragment, {});
}), ID = y.memo(function({ children: e, ...t }) {
  return /* @__PURE__ */ u.jsx(ED, { children: /* @__PURE__ */ u.jsx(PD, { children: /* @__PURE__ */ u.jsxs($D, { ...t, children: [
    e,
    /* @__PURE__ */ u.jsx(DD, {})
  ] }) }) });
}), f5 = y.memo(function({ children: e }) {
  const { editor: t } = ro(), n = ss(), [r, o] = y.useState(() => ({
    root: void 0,
    Container: () => /* @__PURE__ */ u.jsx(u.Fragment, {})
  }));
  return y.useEffect(() => {
    if (!t)
      return;
    const { Layers: i } = t, l = i.events.custom, c = ({ container: d }) => {
      o({
        root: i.getRoot(),
        Container: Vl(d)
      });
    };
    return t.on(l, c), i.__trgCustom({}), () => {
      t.off(l, c);
    };
  }, [t]), y.useEffect(() => n.setCustomLayers(!0), []), t ? Mi(e) ? e(r) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
}), VD = y.memo(function({ children: e }) {
  const { editor: t } = ro(), n = ss(), [r, o] = y.useState(!1), [i, l] = y.useState({
    title: /* @__PURE__ */ u.jsx(u.Fragment, {}),
    content: /* @__PURE__ */ u.jsx(u.Fragment, {}),
    attributes: {},
    close: wo
  });
  return y.useEffect(() => {
    if (!t)
      return;
    const c = "modal", d = ({ open: p, title: g, content: m, close: v, attributes: b }) => {
      p && l({
        title: y.createElement(AS(g)),
        content: y.createElement(AS(m)),
        attributes: b,
        close: v
      }), o(p);
    };
    return t.on(c, d), () => {
      t.off(c, d);
    };
  }, [t]), y.useEffect(() => n.setCustomModal(!0), []), t ? typeof e == "function" ? e({ open: r, ...i }) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
}), p5 = y.memo(function({ children: e }) {
  const { editor: t } = ro(), [n, r] = y.useState(() => ({
    pages: [],
    selected: void 0,
    select: wo,
    add: wo,
    remove: wo
  }));
  return y.useEffect(() => {
    if (!t)
      return;
    const { Pages: o } = t, i = o.events.all, l = () => {
      r({
        pages: o.getAll(),
        selected: o.getSelected(),
        select: (...c) => o.select(...c),
        add: (...c) => o.add(...c),
        remove: (...c) => o.remove(...c)
      });
    };
    return t.on(i, l), l(), () => {
      t.off(i, l);
    };
  }, [t]), t ? Mi(e) ? e(n) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
}), g5 = y.memo(function({ children: e }) {
  const { editor: t } = ro(), n = ss(), [r, o] = y.useState(() => ({
    selectors: [],
    states: [],
    selectedState: "",
    targets: [],
    addSelector: wo,
    removeSelector: wo,
    setState: wo,
    Container: () => /* @__PURE__ */ u.jsx(u.Fragment, {})
  }));
  return y.useEffect(() => {
    if (!t)
      return;
    const { Selectors: i } = t, l = i.events.custom, c = ({ container: d }) => {
      o({
        selectors: i.getSelected(),
        states: i.getStates(),
        selectedState: i.getState(),
        targets: i.getSelectedTargets().map((p) => p.getSelectorsString()),
        addSelector: (...p) => i.addSelected(...p),
        removeSelector: (...p) => i.removeSelected(...p),
        setState: (...p) => i.setState(...p),
        Container: Vl(d)
      });
    };
    return t.on(l, c), () => {
      t.off(l, c);
    };
  }, [t]), y.useEffect(() => n.setCustomSelectors(!0), []), t ? Mi(e) ? e(r) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
}), h5 = y.memo(function({ children: e }) {
  const { editor: t } = ro(), n = ss(), [r, o] = y.useState(() => ({
    sectors: [],
    Container: () => /* @__PURE__ */ u.jsx(u.Fragment, {})
  }));
  return y.useEffect(() => {
    if (!t)
      return;
    const { Styles: i } = t, l = i.events.custom, c = ({ container: d }) => {
      o({
        sectors: i.getSectors({ visible: !0 }),
        Container: Vl(d)
      });
    };
    return t.on(l, c), () => {
      t.off(l, c);
    };
  }, [t]), y.useEffect(() => n.setCustomStyles(!0), []), t ? Mi(e) ? e(r) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
}), iv = y.memo(function({ children: e }) {
  const { editor: t } = ro(), n = ss(), [r, o] = y.useState(() => ({
    traits: [],
    Container: () => /* @__PURE__ */ u.jsx(u.Fragment, {})
  }));
  return y.useEffect(() => {
    if (!t)
      return;
    const { Traits: i } = t, l = i.events.custom, c = ({ container: d }) => {
      o({
        traits: i.getCurrent(),
        Container: Vl(d)
      });
    };
    return t.on(l, c), i.__trgCustom(), () => {
      t.off(l, c);
    };
  }, [t]), y.useEffect(() => n.setCustomTraits(!0), []), t ? Mi(e) ? e(r) : /* @__PURE__ */ u.jsx(u.Fragment, {}) : /* @__PURE__ */ u.jsx(u.Fragment, {});
}), Sa = ({ children: e }) => D0() ? /* @__PURE__ */ u.jsx(u.Fragment, { children: e }) : /* @__PURE__ */ u.jsx(u.Fragment, {});
function ji(e) {
  return ["data-variable", "data-condition"].includes((e == null ? void 0 : e.type) ?? "");
}
const HD = (e) => {
  const { value: t = {}, onConfirm: n, additionalSources: r, editor: o } = e;
  if (!o)
    return;
  const i = "DataValuePicker", l = {
    id: i,
    header: !1,
    layout: {
      type: "panelDataValuePicker",
      value: t,
      onConfirm: ({ value: c }) => {
        n == null || n(c), o.runCommand(ke.layoutRemove, { id: i });
      },
      additionalSources: r
    },
    placer: {
      type: "dialog",
      size: "l"
    }
  };
  o.runCommand(ke.layoutToggle, { ...l });
};
function m5(e) {
  const {
    initialDataValue: t,
    handleDataValueChange: n,
    handleValueClear: r,
    editor: o,
    additionalSources: i,
    enableDataValue: l,
    hasDataResolverValue: c
  } = e;
  if (!o || !l)
    return [];
  const d = {
    type: "button",
    className: c ? ee.tAo : "",
    variant: "out-clear",
    size: "x2s",
    block: !0,
    border: !1
  }, p = [
    {
      ...d,
      title: o.I18n.t("dataSources.connectDataValue"),
      icon: { icon: fe.databaseOutline, size: Ee.s2x },
      onClick: () => HD({
        value: t,
        onConfirm: n,
        additionalSources: i,
        editor: o
      })
    }
  ];
  return c && p.push({
    ...d,
    title: o.I18n.t("dataSources.clearDataValue"),
    icon: { icon: fe.close, size: Ee.s2x },
    onClick: r
  }), p;
}
const I0 = "gs-cmp-accordion", av = `${I0}-handler`, wf = `${av}__content`, FD = `${I0}-content`;
function ja({
  className: e,
  classNameWrap: t,
  classNameContent: n,
  style: r,
  handler: o,
  handlerIcon: i,
  children: l,
  inverted: c,
  disabled: d,
  sticky: p,
  onChange: g,
  open: m
}) {
  return /* @__PURE__ */ u.jsx(Sm, { as: "div", defaultOpen: m, className: ce(I0, t, "relative"), children: ({ open: v }) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      Sm.Button,
      {
        as: d ? "div" : "button",
        disabled: d,
        style: r,
        onClick: (b) => g == null ? void 0 : g({ event: b, open: !v }),
        className: ({ open: b }) => B(
          av,
          Ct(e) ? e(b) : e,
          p && "gs-utl-sticky gs-utl-top-0 gs-utl-z-10",
          "gs-utl-w-full"
        ),
        children: ({ open: b }) => /* @__PURE__ */ u.jsxs(G, { items: "center", className: ce("gap-2"), full: !0, children: [
          /* @__PURE__ */ u.jsx(Y, { className: ce(wf, "text-left"), grow: !0, children: Ct(o) ? o(b) : /* @__PURE__ */ u.jsxs(G, { items: "center", className: ce(`${wf}-wrp`, "gap-3"), nowrap: !0, children: [
            !!i && /* @__PURE__ */ u.jsx(ye, { className: ce(`${wf}-icon`), icon: i, size: Ee.s2x }),
            /* @__PURE__ */ u.jsx(Y, { className: ce(`${wf}-label gs-utl-w-full`), children: o })
          ] }) }),
          /* @__PURE__ */ u.jsx(Y, { className: ce(`${av}-toggle`, c && "-order-1", d && "gs-utl-hidden"), children: /* @__PURE__ */ u.jsx(
            ye,
            {
              icon: fe.chevronDown,
              className: ce("w-5 h-5 transition-transform", b && "rotate-180")
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ u.jsx(Sm.Panel, { className: ce(FD, n), children: l })
  ] }) });
}
function ui({
  label: e,
  property: t,
  hasValue: n,
  empty: r,
  onClear: o,
  children: i,
  shallow: l,
  row: c,
  tooltip: d,
  skipClear: p,
  className: g,
  ...m
}) {
  const v = e || (t == null ? void 0 : t.getLabel()), b = t == null ? void 0 : t.getParentTarget(), x = n || !r && (t == null ? void 0 : t.hasValue({ noParent: !0 })), w = !x && (t == null ? void 0 : t.hasValue()) && b, j = b == null ? void 0 : b.getDevice(), C = b == null ? void 0 : b.getState(), E = b == null ? void 0 : b.getComponent(), P = () => o ? o() : t == null ? void 0 : t.clear(), k = {
    className: B(g, "gs-utl-text-sm gs-utl-w-full"),
    col: !c,
    items: c ? "center" : void 0,
    ...m
  }, T = B("gs-utl-flex-1", x && !l && ee.tAo);
  return t && !t.isVisible() ? null : /* @__PURE__ */ u.jsxs(G, { gap: "xs", ...k, children: [
    /* @__PURE__ */ u.jsxs(G, { className: T, as: "label", items: "center", gap: "xs", nowrap: !0, children: [
      d && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(_n, { title: d, children: /* @__PURE__ */ u.jsx(ye, { icon: fe.information, size: Ee.sx }) }) }),
      /* @__PURE__ */ u.jsx(Y, { children: r ? /* @__PURE__ */ u.jsx("span", { children: " " }) : v }),
      !!w && !l && /* @__PURE__ */ u.jsx(
        _n,
        {
          title: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsx("div", { className: B("gs-utl-mb-1"), children: "Value inherited from" }),
            !!j && /* @__PURE__ */ u.jsxs(G, { gap: "s", children: [
              /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ye, { icon: fe.cellphoneLink, size: Ee.sx }) }),
              /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx("b", { children: j.getName() }) })
            ] }),
            /* @__PURE__ */ u.jsxs(G, { gap: "s", children: [
              /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ye, { icon: E ? fe.targetVariant : fe.tag, size: Ee.sx }) }),
              /* @__PURE__ */ u.jsxs(Y, { children: [
                /* @__PURE__ */ u.jsx("b", { children: E ? "Components" : "Selectors" }),
                /* @__PURE__ */ u.jsxs("span", { className: B("gs-utl-text-xs gs-utl-opacity-75"), children: [
                  " ",
                  b == null ? void 0 : b.selectorsToString({ skipState: 1 })
                ] })
              ] })
            ] }),
            !!C && /* @__PURE__ */ u.jsxs(G, { gap: "s", children: [
              /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ye, { icon: fe.flare, size: Ee.sx }) }),
              /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx("b", { children: C.getLabel() }) })
            ] })
          ] }),
          children: /* @__PURE__ */ u.jsx("div", { className: B("gs-utl-w-[6px] gs-utl-h-[6px] gs-utl-rounded-full", ee.bgW) })
        }
      ),
      x && !l && !p && /* @__PURE__ */ u.jsx(_n, { title: "Clear value", onClick: P, children: /* @__PURE__ */ u.jsx(ye, { className: nt.click, icon: fe.close, size: Ee.s2x }) })
    ] }),
    !!i && /* @__PURE__ */ u.jsx(Y, { grow: !0, className: "gs-utl-max-w-full", children: i })
  ] });
}
function Kn(e) {
  const { className: t, options: n, name: r, value: o, size: i = "m", required: l, disabled: c, onChange: d, labelAs: p } = e, g = (b) => {
    const x = n.filter((w) => w.id === b)[0];
    return n.indexOf(x) === n.length - 1;
  }, m = (b, x) => B(
    "gs-utl-cursor-pointer",
    i === "m" && tt.xy,
    i === "s" && "gs-utl-px-2 gs-utl-py-1 text-sm",
    i === "xs" && "gs-utl-p-1 text-sm",
    ee.br,
    b && ee.bgO,
    !g(x) && ve.br
  ), v = Li({ ...e, className: "gs-field-buttons" });
  return /* @__PURE__ */ u.jsxs(_w, { value: o, onChange: d, disabled: c, ...v, children: [
    /* @__PURE__ */ u.jsx(Eo, { ...e, as: p }),
    r && /* @__PURE__ */ u.jsx("input", { type: "hidden", name: r, value: o, required: l }),
    /* @__PURE__ */ u.jsx(G, { className: B(t, ve.b, ve.rnd, ee.br, "gs-utl-cursor-pointer"), items: "center", full: !0, nowrap: !0, children: n.map(({ id: b, label: x, title: w, icon: j }) => /* @__PURE__ */ u.jsx(_n, { title: w, className: B("gs-utl-w-full"), classNameWrp: B("gs-utl-flex-1"), children: /* @__PURE__ */ u.jsx(_w.Option, { value: b, className: ({ checked: C }) => m(C, b), children: /* @__PURE__ */ u.jsxs(G, { justify: "center", gap: "s", full: !0, children: [
      !!j && /* @__PURE__ */ u.jsx(ye, { ...Dt(j) ? { icon: j, size: Ee.s } : j }),
      x && /* @__PURE__ */ u.jsx(Y, { children: x })
    ] }) }) }, b)) })
  ] });
}
const zD = "gs-cmp-color-field";
function Rs(e) {
  const { className: t, value: n, placeholder: r, preventSubmitOnEnter: o = !1, onChange: i, labelAs: l, disabled: c } = e, [d, p] = y.useState(pp(n)), g = Uu(e);
  y.useEffect(() => {
    p(pp(n));
  }, [n]);
  const m = (w, j) => {
    i == null || i(w, j);
  }, v = (w) => {
    switch (w.key) {
      case "Escape":
        return p(n);
      case "Enter":
        m(d), o && (w.preventDefault(), w.stopPropagation());
    }
  }, b = () => {
    m(d);
  }, x = Li({ ...e, className: B(zD, t) });
  return /* @__PURE__ */ u.jsxs("div", { ...x, children: [
    /* @__PURE__ */ u.jsx(Eo, { ...e, as: l }),
    /* @__PURE__ */ u.jsxs(G, { className: S0(e), items: "center", space: "s", children: [
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(i5, { value: n, onChange: i, disabled: c }) }),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(
        "input",
        {
          className: B(g, c && "gs-utl-pointer-events-none"),
          value: d,
          onChange: (w) => p(w.target.value),
          placeholder: r,
          onBlur: b,
          onKeyDown: v,
          disabled: c
        }
      ) })
    ] })
  ] });
}
const Xi = "gs-cmp-file-field";
function vu(e) {
  var T;
  const {
    className: t,
    value: n,
    btnLabel: r,
    nameLabel: o,
    size: i,
    isContain: l,
    clear: c,
    inputField: d,
    placeholder: p,
    preview: g = 50,
    disabled: m,
    hideButton: v,
    labelAs: b,
    onChange: x,
    onOpen: w
  } = e, j = (n || "").replace(/^"|"$/gi, ""), C = ((T = j.split("/").pop()) == null ? void 0 : T.split("?")[0]) || "", E = { minWidth: g, minHeight: g }, P = j ? { ...E, backgroundImage: `url("${j}")` } : E, k = B(
    " gs-utl-w-full gs-utl-bg-checker gs-utl-bg-no-repeat gs-utl-bg-center",
    l ? "gs-utl-bg-contain" : "gs-utl-bg-cover",
    ve.b,
    ve.rnd,
    ee.br
  );
  return /* @__PURE__ */ u.jsxs(G, { className: B(Xi, t, "gs-utl-gap-1"), col: !0, nowrap: !0, children: [
    /* @__PURE__ */ u.jsx(Eo, { ...e, as: b }),
    /* @__PURE__ */ u.jsxs(G, { className: B(`${Xi}-content gs-utl-gap-1`, ee.bg), items: "center", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(Y, { className: B(`${Xi}-preview`), children: /* @__PURE__ */ u.jsx("div", { className: k, style: P }) }),
      /* @__PURE__ */ u.jsxs(Y, { className: B(`${Xi}-fields gs-utl-overflow-hidden`), grow: !0, children: [
        C && o !== !1 && /* @__PURE__ */ u.jsx(
          wi,
          {
            className: B(`${Xi}-name`, "gs-utl-mb-2", nt.txtEllips),
            as: "div",
            size: i,
            capitalize: !1,
            children: C
          }
        ),
        /* @__PURE__ */ u.jsxs(G, { className: B(`${Xi}-buttons`), space: "s", nowrap: !0, children: [
          !v && /* @__PURE__ */ u.jsx(ut, { onClick: () => w == null ? void 0 : w(n), size: i, type: "button", block: !0, full: !0, disabled: m, children: r || "Select image" }),
          !!n && c && /* @__PURE__ */ u.jsx(
            Qt,
            {
              onClick: () => x == null ? void 0 : x(""),
              title: c.tooltip,
              size: i,
              icon: { icon: fe.close, size: Ee.s },
              type: "button",
              block: !0
            }
          )
        ] })
      ] })
    ] }),
    d && /* @__PURE__ */ u.jsx(
      jt,
      {
        className: B(`${Xi}-input`),
        value: j,
        onChange: x,
        size: i,
        placeholder: p
      }
    )
  ] });
}
const og = xe((e) => {
  const { buttonClassName: t, value: n, ...r } = e, { editor: o } = Re(), i = qe(), l = xa(), c = Ku(), d = [...r.options || [], ...c.fontFamilyOptions].map((p) => {
    const g = c.getFont(p.id), m = g ? P0(g) : p.id;
    return {
      ...p,
      content: /* @__PURE__ */ u.jsx(G, { col: !0, children: /* @__PURE__ */ u.jsx(Y, { style: { fontFamily: m }, children: p.label }) })
    };
  });
  return /* @__PURE__ */ u.jsx(
    Ze,
    {
      ...r,
      value: pa(n),
      options: d,
      afterLabel: c.sdkAddFonts && l.hasType("font") && /* @__PURE__ */ u.jsx(
        Qt,
        {
          className: t,
          title: i.t("fontManager.addFontToProject"),
          icon: fe.plus,
          size: "xs",
          border: !1,
          block: !0,
          onClick: () => o && A0(o, {
            onSelect: ({ assetProps: p }) => {
              const {
                customData: { font: g }
              } = p;
              r.onChange(pa(g.family));
            }
          })
        }
      )
    }
  );
});
function BD() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return y.useMemo(
    () => (r) => {
      t.forEach((o) => o(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const sg = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function Hl(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function V0(e) {
  return "nodeType" in e;
}
function Ai(e) {
  var t, n;
  return e ? Hl(e) ? e : V0(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function H0(e) {
  const {
    Document: t
  } = Ai(e);
  return e instanceof t;
}
function Fl(e) {
  return Hl(e) ? !1 : e instanceof Ai(e).HTMLElement;
}
function v5(e) {
  return e instanceof Ai(e).SVGElement;
}
function zl(e) {
  return e ? Hl(e) ? e.document : V0(e) ? H0(e) ? e : Fl(e) || v5(e) ? e.ownerDocument : document : document : document;
}
const ga = sg ? y.useLayoutEffect : y.useEffect;
function UD(e) {
  const t = y.useRef(e);
  return ga(() => {
    t.current = e;
  }), y.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
function WD() {
  const e = y.useRef(null), t = y.useCallback((r, o) => {
    e.current = setInterval(r, o);
  }, []), n = y.useCallback(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function Yu(e, t) {
  const n = y.useRef();
  return y.useMemo(
    () => {
      const r = e(n.current);
      return n.current = r, r;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function F0(e) {
  const t = UD(e), n = y.useRef(null), r = y.useCallback(
    (o) => {
      o !== n.current && (t == null || t(o, n.current)), n.current = o;
    },
    //eslint-disable-next-line
    []
  );
  return [n, r];
}
let Gm = {};
function Xu(e, t) {
  return y.useMemo(() => {
    if (t)
      return t;
    const n = Gm[e] == null ? 0 : Gm[e] + 1;
    return Gm[e] = n, e + "-" + n;
  }, [e, t]);
}
function y5(e) {
  return function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return r.reduce((i, l) => {
      const c = Object.entries(l);
      for (const [d, p] of c) {
        const g = i[d];
        g != null && (i[d] = g + e * p);
      }
      return i;
    }, {
      ...t
    });
  };
}
const yu = /* @__PURE__ */ y5(1), b5 = /* @__PURE__ */ y5(-1);
function GD(e) {
  return "clientX" in e && "clientY" in e;
}
function KD(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = Ai(e.target);
  return t && e instanceof t;
}
function qD(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = Ai(e.target);
  return t && e instanceof t;
}
function lv(e) {
  if (qD(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return GD(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const bu = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [bu.Translate.toString(e), bu.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: r
      } = e;
      return t + " " + n + "ms " + r;
    }
  }
}), YD = {
  display: "none"
};
function XD(e) {
  let {
    id: t,
    value: n
  } = e;
  return Q.createElement("div", {
    id: t,
    style: YD
  }, n);
}
function ZD(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: r = "assertive"
  } = e;
  const o = {
    position: "fixed",
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return Q.createElement("div", {
    id: t,
    style: o,
    role: "status",
    "aria-live": r,
    "aria-atomic": !0
  }, n);
}
function JD() {
  const [e, t] = y.useState("");
  return {
    announce: y.useCallback((r) => {
      r != null && t(r);
    }, []),
    announcement: e
  };
}
const QD = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, eI = {
  onDragStart(e) {
    return `Picked up draggable item ${e}.`;
  },
  onDragOver(e, t) {
    return t ? `Draggable item ${e} was moved over droppable area ${t}.` : `Draggable item ${e} is no longer over a droppable area.`;
  },
  onDragEnd(e, t) {
    return t ? `Draggable item ${e} was dropped over droppable area ${t}` : `Draggable item ${e} was dropped.`;
  },
  onDragCancel(e) {
    return `Dragging was cancelled. Draggable item ${e} was dropped.`;
  }
};
var Nt;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(Nt || (Nt = {}));
function Km(...e) {
}
class qc extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter(({
      disabled: t
    }) => !t);
  }
  getNodeFor(t) {
    var n, r;
    return (n = (r = this.get(t)) == null ? void 0 : r.node.current) != null ? n : void 0;
  }
}
const ig = /* @__PURE__ */ y.createContext({
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  activeNodeClientRect: null,
  activators: [],
  ariaDescribedById: {
    draggable: ""
  },
  containerNodeRect: null,
  dispatch: Km,
  draggableNodes: {},
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new qc(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: Km
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  recomputeLayouts: Km,
  windowRect: null,
  willRecomputeLayouts: !1
});
function tI() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: {},
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new qc()
    }
  };
}
function nI(e, t) {
  switch (t.type) {
    case Nt.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case Nt.DragMove:
      return e.draggable.active ? {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      } : e;
    case Nt.DragEnd:
    case Nt.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Nt.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: r
      } = n, o = new qc(e.droppable.containers);
      return o.set(r, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: o
        }
      };
    }
    case Nt.SetDroppableDisabled: {
      const {
        id: n,
        key: r,
        disabled: o
      } = t, i = e.droppable.containers.get(n);
      if (!i || r !== i.key)
        return e;
      const l = new qc(e.droppable.containers);
      return l.set(n, {
        ...i,
        disabled: o
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: l
        }
      };
    }
    case Nt.UnregisterDroppable: {
      const {
        id: n,
        key: r
      } = t, o = e.droppable.containers.get(n);
      if (!o || r !== o.key)
        return e;
      const i = new qc(e.droppable.containers);
      return i.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    default:
      return e;
  }
}
const x5 = /* @__PURE__ */ y.createContext({
  type: null,
  event: null
});
function rI({
  onDragStart: e,
  onDragMove: t,
  onDragOver: n,
  onDragEnd: r,
  onDragCancel: o
}) {
  const i = y.useContext(x5), l = y.useRef(i);
  y.useEffect(() => {
    if (i !== l.current) {
      const {
        type: c,
        event: d
      } = i;
      switch (c) {
        case Nt.DragStart:
          e == null || e(d);
          break;
        case Nt.DragMove:
          t == null || t(d);
          break;
        case Nt.DragOver:
          n == null || n(d);
          break;
        case Nt.DragCancel:
          o == null || o(d);
          break;
        case Nt.DragEnd:
          r == null || r(d);
          break;
      }
      l.current = i;
    }
  }, [i, e, t, n, r, o]);
}
function oI({
  announcements: e = eI,
  hiddenTextDescribedById: t,
  screenReaderInstructions: n
}) {
  const {
    announce: r,
    announcement: o
  } = JD(), i = Xu("DndLiveRegion"), [l, c] = y.useState(!1);
  return y.useEffect(() => {
    c(!0);
  }, []), rI(y.useMemo(() => ({
    onDragStart({
      active: d
    }) {
      r(e.onDragStart(d.id));
    },
    onDragMove({
      active: d,
      over: p
    }) {
      e.onDragMove && r(e.onDragMove(d.id, p == null ? void 0 : p.id));
    },
    onDragOver({
      active: d,
      over: p
    }) {
      r(e.onDragOver(d.id, p == null ? void 0 : p.id));
    },
    onDragEnd({
      active: d,
      over: p
    }) {
      r(e.onDragEnd(d.id, p == null ? void 0 : p.id));
    },
    onDragCancel({
      active: d
    }) {
      r(e.onDragCancel(d.id));
    }
  }), [r, e])), l ? Cr.createPortal(Q.createElement(Q.Fragment, null, Q.createElement(XD, {
    id: t,
    value: n.draggable
  }), Q.createElement(ZD, {
    id: i,
    announcement: o
  })), document.body) : null;
}
const Ns = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function w5(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function NS(e, t = e.offsetLeft, n = e.offsetTop) {
  return {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const sI = ({
  collisionRect: e,
  droppableContainers: t
}) => {
  const n = NS(e, e.left, e.top);
  let r = 1 / 0, o = null;
  for (const i of t) {
    const {
      rect: {
        current: l
      }
    } = i;
    if (l) {
      const c = w5(NS(l), n);
      c < r && (r = c, o = i.id);
    }
  }
  return o;
};
function iI(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function aI(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : Ns;
}
function lI(e) {
  return function(n, ...r) {
    return r.reduce((o, i) => ({
      ...o,
      top: o.top + e * i.y,
      bottom: o.bottom + e * i.y,
      left: o.left + e * i.x,
      right: o.right + e * i.x,
      offsetLeft: o.offsetLeft + e * i.x,
      offsetTop: o.offsetTop + e * i.y
    }), {
      ...n
    });
  };
}
const $S = /* @__PURE__ */ lI(1);
function cI(e, t = window.getComputedStyle(e)) {
  return t.position === "fixed";
}
function uI(e, t = window.getComputedStyle(e)) {
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].find((o) => {
    const i = t[o];
    return typeof i == "string" ? n.test(i) : !1;
  }) != null;
}
function z0(e) {
  const t = [];
  function n(r) {
    if (!r)
      return t;
    if (H0(r) && r.scrollingElement != null && !t.includes(r.scrollingElement))
      return t.push(r.scrollingElement), t;
    if (!Fl(r) || v5(r) || t.includes(r))
      return t;
    const o = window.getComputedStyle(r);
    return uI(r, o) && t.push(r), cI(r, o) ? t : n(r.parentNode);
  }
  return e ? n(e.parentNode) : t;
}
function qm(e) {
  return !sg || !e ? null : Hl(e) ? e : V0(e) ? H0(e) || e === zl(e).scrollingElement ? window : Fl(e) ? e : null : null;
}
function cv(e) {
  return Hl(e) ? {
    x: e.scrollX,
    y: e.scrollY
  } : {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}
var al;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(al || (al = {}));
function S5(e) {
  const t = {
    x: 0,
    y: 0
  }, n = {
    x: e.scrollWidth - e.clientWidth,
    y: e.scrollHeight - e.clientHeight
  }, r = e.scrollTop <= t.y, o = e.scrollLeft <= t.x, i = e.scrollTop >= n.y, l = e.scrollLeft >= n.x;
  return {
    isTop: r,
    isLeft: o,
    isBottom: i,
    isRight: l,
    maxScroll: n,
    minScroll: t
  };
}
function dI(e) {
  return !sg || !e ? !1 : e === document.scrollingElement;
}
const fI = {
  x: 0.2,
  y: 0.2
};
function pI(e, t, {
  top: n,
  left: r,
  right: o,
  bottom: i
}, l = 10, c = fI) {
  const {
    clientHeight: d,
    clientWidth: p
  } = e, g = dI(e) ? {
    top: 0,
    left: 0,
    right: p,
    bottom: d,
    width: p,
    height: d
  } : t, {
    isTop: m,
    isBottom: v,
    isLeft: b,
    isRight: x
  } = S5(e), w = {
    x: 0,
    y: 0
  }, j = {
    x: 0,
    y: 0
  }, C = {
    height: g.height * c.y,
    width: g.width * c.x
  };
  return !m && n <= g.top + C.height ? (w.y = al.Backward, j.y = l * Math.abs((g.top + C.height - n) / C.height)) : !v && i >= g.bottom - C.height && (w.y = al.Forward, j.y = l * Math.abs((g.bottom - C.height - i) / C.height)), !x && o >= g.right - C.width ? (w.x = al.Forward, j.x = l * Math.abs((g.right - C.width - o) / C.width)) : !b && r <= g.left + C.width && (w.x = al.Backward, j.x = l * Math.abs((g.left + C.width - r) / C.width)), {
    direction: w,
    speed: j
  };
}
function gI(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: i,
      innerHeight: l
    } = window;
    return {
      top: 0,
      left: 0,
      right: i,
      bottom: l,
      width: i,
      height: l
    };
  }
  const {
    top: t,
    left: n,
    right: r,
    bottom: o
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: r,
    bottom: o,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function j5(e) {
  return e.reduce((t, n) => yu(t, cv(n)), Ns);
}
function C5(e, t, n = Ns) {
  if (!e || !Fl(e))
    return n;
  const r = {
    x: n.x + e.offsetLeft,
    y: n.y + e.offsetTop
  };
  return e.offsetParent === t ? r : C5(e.offsetParent, t, r);
}
function ag(e) {
  const {
    offsetWidth: t,
    offsetHeight: n
  } = e, {
    x: r,
    y: o
  } = C5(e, null);
  return {
    width: t,
    height: n,
    offsetTop: o,
    offsetLeft: r
  };
}
function lg(e) {
  if (Hl(e)) {
    const p = window.innerWidth, g = window.innerHeight;
    return {
      top: 0,
      left: 0,
      right: p,
      bottom: g,
      width: p,
      height: g,
      offsetTop: 0,
      offsetLeft: 0
    };
  }
  const {
    offsetTop: t,
    offsetLeft: n
  } = ag(e), {
    width: r,
    height: o,
    top: i,
    bottom: l,
    left: c,
    right: d
  } = e.getBoundingClientRect();
  return {
    width: r,
    height: o,
    top: i,
    bottom: l,
    right: d,
    left: c,
    offsetTop: t,
    offsetLeft: n
  };
}
function uv(e) {
  const {
    width: t,
    height: n,
    offsetTop: r,
    offsetLeft: o
  } = ag(e), i = z0(e), l = j5(i), c = r - l.y, d = o - l.x;
  return {
    width: t,
    height: n,
    top: c,
    bottom: c + n,
    right: d + t,
    left: d,
    offsetTop: r,
    offsetLeft: o
  };
}
function DS(e) {
  return "top" in e;
}
function IS(e, t = e.offsetLeft, n = e.offsetTop) {
  return [{
    x: t,
    y: n
  }, {
    x: t + e.width,
    y: n
  }, {
    x: t,
    y: n + e.height
  }, {
    x: t + e.width,
    y: n + e.height
  }];
}
const hI = ({
  collisionRect: e,
  droppableContainers: t
}) => {
  let n = 1 / 0, r = null;
  const o = IS(e, e.left, e.top);
  for (const i of t) {
    const {
      rect: {
        current: l
      }
    } = i;
    if (l) {
      const c = IS(l, DS(l) ? l.left : void 0, DS(l) ? l.top : void 0), d = o.reduce((g, m, v) => g + w5(c[v], m), 0), p = Number((d / 4).toFixed(4));
      p < n && (n = p, r = i.id);
    }
  }
  return r;
};
function mI(e, t) {
  const n = Math.max(t.top, e.offsetTop), r = Math.max(t.left, e.offsetLeft), o = Math.min(t.left + t.width, e.offsetLeft + e.width), i = Math.min(t.top + t.height, e.offsetTop + e.height), l = o - r, c = i - n;
  if (r < o && n < i) {
    const d = t.width * t.height, p = e.width * e.height, g = l * c, m = g / (d + p - g);
    return Number(m.toFixed(4));
  }
  return 0;
}
const vI = ({
  collisionRect: e,
  droppableContainers: t
}) => {
  let n = 0, r = null;
  for (const o of t) {
    const {
      rect: {
        current: i
      }
    } = o;
    if (i) {
      const l = mI(i, e);
      l > n && (n = l, r = o.id);
    }
  }
  return r;
};
var Yc;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(Yc || (Yc = {}));
var yp;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(yp || (yp = {}));
function yI({
  acceleration: e,
  activator: t = Yc.Pointer,
  canScroll: n,
  draggingRect: r,
  enabled: o,
  interval: i = 5,
  order: l = yp.TreeOrder,
  pointerCoordinates: c,
  scrollableAncestors: d,
  scrollableAncestorRects: p,
  threshold: g
}) {
  const [m, v] = WD(), b = y.useRef({
    x: 1,
    y: 1
  }), x = y.useMemo(() => {
    switch (t) {
      case Yc.Pointer:
        return c ? {
          top: c.y,
          bottom: c.y,
          left: c.x,
          right: c.x
        } : null;
      case Yc.DraggableRect:
        return r;
    }
    return null;
  }, [t, r, c]), w = y.useRef(Ns), j = y.useRef(null), C = y.useCallback(() => {
    const P = j.current;
    if (!P)
      return;
    const k = b.current.x * w.current.x, T = b.current.y * w.current.y;
    P.scrollBy(k, T);
  }, []), E = y.useMemo(() => l === yp.TreeOrder ? [...d].reverse() : d, [l, d]);
  y.useEffect(
    () => {
      if (!o || !d.length || !x) {
        v();
        return;
      }
      for (const P of E) {
        if ((n == null ? void 0 : n(P)) === !1)
          continue;
        const k = d.indexOf(P), T = p[k];
        if (!T)
          continue;
        const {
          direction: O,
          speed: A
        } = pI(P, T, x, e, g);
        if (A.x > 0 || A.y > 0) {
          v(), j.current = P, m(C, i), b.current = A, w.current = O;
          return;
        }
      }
      b.current = {
        x: 0,
        y: 0
      }, w.current = {
        x: 0,
        y: 0
      }, v();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      e,
      C,
      n,
      v,
      o,
      i,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(x),
      m,
      d,
      E,
      p,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(g)
    ]
  );
}
function bI(e, t) {
  const n = t !== null ? e[t] : void 0, r = n ? n.node.current : null;
  return Yu((o) => {
    var i;
    return t === null ? null : (i = r ?? o) != null ? i : null;
  }, [r, t]);
}
function xI(e, t) {
  return y.useMemo(() => e.reduce((n, r) => {
    const {
      sensor: o
    } = r, i = o.activators.map((l) => ({
      eventName: l.eventName,
      handler: t(l.handler, r)
    }));
    return [...n, ...i];
  }, []), [e, t]);
}
function E5(e) {
  const t = y.useRef(e);
  return ga(() => {
    t.current !== e && (t.current = e);
  }, [e]), t;
}
var xu;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(xu || (xu = {}));
var dv;
(function(e) {
  e.Optimized = "optimized";
})(dv || (dv = {}));
const VS = /* @__PURE__ */ new Map(), wI = {
  measure: ag,
  strategy: xu.WhileDragging,
  frequency: dv.Optimized
};
function SI(e, {
  dragging: t,
  dependencies: n,
  config: r
}) {
  const [o, i] = y.useState(!1), {
    frequency: l,
    measure: c,
    strategy: d
  } = {
    ...wI,
    ...r
  }, p = y.useRef(e), g = y.useCallback(() => i(!0), []), m = y.useRef(null), v = x(), b = Yu((w) => {
    if (v && !t)
      return VS;
    if (!w || w === VS || p.current !== e || o) {
      for (let j of e)
        j && (j.rect.current = j.node.current ? c(j.node.current) : null);
      return jI(e);
    }
    return w;
  }, [e, t, v, c, o]);
  return y.useEffect(() => {
    p.current = e;
  }, [e]), y.useEffect(() => {
    o && i(!1);
  }, [o]), y.useEffect(
    function() {
      v || requestAnimationFrame(g);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, v]
  ), y.useEffect(
    function() {
      v || typeof l != "number" || m.current !== null || (m.current = setTimeout(() => {
        g(), m.current = null;
      }, l));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, v, g, ...n]
  ), {
    layoutRectMap: b,
    recomputeLayouts: g,
    willRecomputeLayouts: o
  };
  function x() {
    switch (d) {
      case xu.Always:
        return !1;
      case xu.BeforeDragging:
        return t;
      default:
        return !t;
    }
  }
}
function jI(e) {
  const t = /* @__PURE__ */ new Map();
  if (e)
    for (const n of e) {
      if (!n)
        continue;
      const {
        id: r,
        rect: o
      } = n;
      o.current != null && t.set(r, o.current);
    }
  return t;
}
function CI(e) {
  const [t, n] = y.useState(null), r = y.useRef(e), o = y.useCallback((i) => {
    const l = qm(i.target);
    l && n((c) => c ? (c.set(l, cv(l)), new Map(c)) : null);
  }, []);
  return y.useEffect(() => {
    const i = r.current;
    if (e !== i) {
      l(i);
      const c = e.map((d) => {
        const p = qm(d);
        return p ? (p.addEventListener("scroll", o, {
          passive: !0
        }), [p, cv(p)]) : null;
      }).filter((d) => d != null);
      n(c.length ? new Map(c) : null), r.current = e;
    }
    return () => {
      l(e), l(i);
    };
    function l(c) {
      c.forEach((d) => {
        const p = qm(d);
        p == null || p.removeEventListener("scroll", o);
      });
    }
  }, [o, e]), y.useMemo(() => e.length ? t ? Array.from(t.values()).reduce((i, l) => yu(i, l), Ns) : j5(e) : Ns, [e, t]);
}
const EI = [];
function PI(e) {
  const t = y.useRef(e), n = Yu((r) => e ? r && e && t.current && e.parentNode === t.current.parentNode ? r : z0(e) : EI, [e]);
  return y.useEffect(() => {
    t.current = e;
  }, [e]), n;
}
function _I(e) {
  y.useEffect(
    () => {
      if (!sg)
        return;
      const t = e.map(({
        sensor: n
      }) => n.setup == null ? void 0 : n.setup());
      return () => {
        for (const n of t)
          n == null || n();
      };
    },
    // TO-DO: Sensors lenght could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map(({
      sensor: t
    }) => t)
  );
}
function kI(e, t) {
  return y.useMemo(() => e.reduce((n, {
    eventName: r,
    handler: o
  }) => (n[r] = (i) => {
    o(i, t);
  }, n), {}), [e, t]);
}
const Ym = /* @__PURE__ */ _5(lg), TI = /* @__PURE__ */ OI(lg);
function P5(e, t, n) {
  const r = y.useRef(e);
  return Yu((o) => e ? n || !o && e || e !== r.current ? Fl(e) && e.parentNode == null ? null : t(e) : o ?? null : null, [e, n, t]);
}
function _5(e) {
  return (t, n) => P5(t, e, n);
}
function OI(e) {
  const t = [];
  return function(r, o) {
    const i = y.useRef(r);
    return Yu((l) => r.length ? o || !l && r.length || r !== i.current ? r.map((c) => e(c)) : l ?? t : t, [r, o]);
  };
}
function LI(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return Fl(t) ? t : e;
}
function MI(e) {
  const {
    width: t,
    height: n,
    offsetLeft: r,
    offsetTop: o
  } = ag(e);
  return {
    top: o,
    bottom: o + n,
    left: r,
    right: r + t,
    width: t,
    height: n,
    offsetTop: o,
    offsetLeft: r
  };
}
const AI = /* @__PURE__ */ _5(MI);
function RI({
  disabled: e,
  forceRecompute: t
}) {
  const [n, r] = F0(), o = AI(e ? null : LI(n.current), t);
  return y.useMemo(() => ({
    nodeRef: n,
    rect: o,
    setRef: r
  }), [o, n, r]);
}
function HS(e, t) {
  return y.useMemo(
    () => ({
      sensor: e,
      options: t ?? {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function NI(...e) {
  return y.useMemo(
    () => [...e].filter((t) => t != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...e]
  );
}
class Xc {
  constructor(t) {
    this.target = t, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var r;
        return (r = this.target) == null ? void 0 : r.removeEventListener(...n);
      });
    };
  }
  add(t, n, r) {
    var o;
    (o = this.target) == null || o.addEventListener(t, n, r), this.listeners.push([t, n, r]);
  }
}
function $I(e) {
  const {
    EventTarget: t
  } = Ai(e);
  return e instanceof t ? e : zl(e);
}
function Xm(e, t) {
  const n = Math.abs(e.x), r = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t ? r > t.y : !1;
}
var Wr;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(Wr || (Wr = {}));
function FS(e) {
  e.preventDefault();
}
function DI(e) {
  e.stopPropagation();
}
var pt;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter";
})(pt || (pt = {}));
const k5 = {
  start: [pt.Space, pt.Enter],
  cancel: [pt.Esc],
  end: [pt.Space, pt.Enter]
}, II = (e, {
  currentCoordinates: t
}) => {
  switch (e.code) {
    case pt.Right:
      return {
        ...t,
        x: t.x + 25
      };
    case pt.Left:
      return {
        ...t,
        x: t.x - 25
      };
    case pt.Down:
      return {
        ...t,
        y: t.y + 25
      };
    case pt.Up:
      return {
        ...t,
        y: t.y - 25
      };
  }
};
class B0 {
  constructor(t) {
    this.props = t, this.autoScrollEnabled = !1, this.coordinates = Ns;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new Xc(zl(n)), this.windowListeners = new Xc(Ai(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(Wr.Resize, this.handleCancel), this.windowListeners.add(Wr.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(Wr.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props;
    if (!t.node.current)
      throw new Error("Active draggable node is undefined");
    const r = lg(t.node.current), o = {
      x: r.left,
      y: r.top
    };
    this.coordinates = o, n(o);
  }
  handleKeyDown(t) {
    if (KD(t)) {
      const {
        coordinates: n
      } = this, {
        active: r,
        context: o,
        options: i
      } = this.props, {
        keyboardCodes: l = k5,
        coordinateGetter: c = II,
        scrollBehavior: d = "smooth"
      } = i, {
        code: p
      } = t;
      if (l.end.includes(p)) {
        this.handleEnd(t);
        return;
      }
      if (l.cancel.includes(p)) {
        this.handleCancel(t);
        return;
      }
      const g = c(t, {
        active: r,
        context: o.current,
        currentCoordinates: n
      });
      if (g) {
        const m = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: v
        } = o.current;
        for (const b of v) {
          const x = t.code, w = b5(g, n), {
            isTop: j,
            isRight: C,
            isLeft: E,
            isBottom: P,
            maxScroll: k,
            minScroll: T
          } = S5(b), O = gI(b), A = {
            x: Math.min(x === pt.Right ? O.right - O.width / 2 : O.right, Math.max(x === pt.Right ? O.left : O.left + O.width / 2, g.x)),
            y: Math.min(x === pt.Down ? O.bottom - O.height / 2 : O.bottom, Math.max(x === pt.Down ? O.top : O.top + O.height / 2, g.y))
          }, $ = x === pt.Right && !C || x === pt.Left && !E, N = x === pt.Down && !P || x === pt.Up && !j;
          if ($ && A.x !== g.x) {
            if (x === pt.Right && b.scrollLeft + w.x <= k.x || x === pt.Left && b.scrollLeft + w.x >= T.x) {
              b.scrollBy({
                left: w.x,
                behavior: d
              });
              return;
            }
            m.x = x === pt.Right ? b.scrollLeft - k.x : b.scrollLeft - T.x, b.scrollBy({
              left: -m.x,
              behavior: d
            });
            break;
          } else if (N && A.y !== g.y) {
            if (x === pt.Down && b.scrollTop + w.y <= k.y || x === pt.Up && b.scrollTop + w.y >= T.y) {
              b.scrollBy({
                top: w.y,
                behavior: d
              });
              return;
            }
            m.y = x === pt.Down ? b.scrollTop - k.y : b.scrollTop - T.y, b.scrollBy({
              top: -m.y,
              behavior: d
            });
            break;
          }
        }
        this.handleMove(t, yu(g, m));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: r
    } = this.props;
    t.preventDefault(), r(n), this.coordinates = n;
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
B0.activators = [{
  eventName: "onKeyDown",
  handler: (e, {
    keyboardCodes: t = k5,
    onActivation: n
  }) => {
    const {
      code: r
    } = e.nativeEvent;
    return t.start.includes(r) ? (e.preventDefault(), n == null || n({
      event: e.nativeEvent
    }), !0) : !1;
  }
}];
function zS(e) {
  return !!(e && "distance" in e);
}
function BS(e) {
  return !!(e && "delay" in e);
}
class U0 {
  constructor(t, n, r = $I(t.event.target)) {
    this.props = t, this.events = n, this.autoScrollEnabled = !0, this.activated = !1, this.timeoutId = null;
    const {
      event: o
    } = t, {
      target: i
    } = o;
    this.props = t, this.events = n, this.document = zl(i), this.documentListeners = new Xc(this.document), this.listeners = new Xc(r), this.windowListeners = new Xc(Ai(i)), this.initialCoordinates = lv(o), this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), this.windowListeners.add(Wr.Resize, this.handleCancel), this.windowListeners.add(Wr.DragStart, FS), this.windowListeners.add(Wr.VisibilityChange, this.handleCancel), this.windowListeners.add(Wr.ContextMenu, FS), this.documentListeners.add(Wr.Keydown, this.handleKeydown), n) {
      if (zS(n))
        return;
      if (BS(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(Wr.Click, DI, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(Wr.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    const {
      activated: n,
      initialCoordinates: r,
      props: o
    } = this, {
      onMove: i,
      options: {
        activationConstraint: l
      }
    } = o;
    if (!r)
      return;
    const c = lv(t), d = b5(r, c);
    if (!n && l) {
      if (BS(l))
        return Xm(d, l.tolerance) ? this.handleCancel() : void 0;
      if (zS(l))
        return l.tolerance != null && Xm(d, l.tolerance) ? this.handleCancel() : Xm(d, l.distance) ? this.handleStart() : void 0;
    }
    t.cancelable && t.preventDefault(), i(c);
  }
  handleEnd() {
    const {
      onEnd: t
    } = this.props;
    this.detach(), t();
  }
  handleCancel() {
    const {
      onCancel: t
    } = this.props;
    this.detach(), t();
  }
  handleKeydown(t) {
    t.code === pt.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const VI = {
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class W0 extends U0 {
  constructor(t) {
    const {
      event: n
    } = t, r = zl(n.target);
    super(t, VI, r);
  }
}
W0.activators = [{
  eventName: "onPointerDown",
  handler: ({
    nativeEvent: e
  }, {
    onActivation: t
  }) => !e.isPrimary || e.button !== 0 ? !1 : (t == null || t({
    event: e
  }), !0)
}];
const HI = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var fv;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(fv || (fv = {}));
class FI extends U0 {
  constructor(t) {
    super(t, HI, zl(t.event.target));
  }
}
FI.activators = [{
  eventName: "onMouseDown",
  handler: ({
    nativeEvent: e
  }, {
    onActivation: t
  }) => e.button === fv.RightClick ? !1 : (t == null || t({
    event: e
  }), !0)
}];
const Zm = {
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class zI extends U0 {
  constructor(t) {
    super(t, Zm);
  }
  static setup() {
    return window.addEventListener(Zm.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(Zm.move.name, t);
    };
    function t() {
    }
  }
}
zI.activators = [{
  eventName: "onTouchStart",
  handler: ({
    nativeEvent: e
  }, {
    onActivation: t
  }) => {
    const {
      touches: n
    } = e;
    return n.length > 1 ? !1 : (t == null || t({
      event: e
    }), !0);
  }
}];
function BI(e, {
  transform: t,
  ...n
}) {
  return e != null && e.length ? e.reduce((r, o) => o({
    transform: r,
    ...n
  }), t) : t;
}
const UI = [{
  sensor: W0,
  options: {}
}, {
  sensor: B0,
  options: {}
}], WI = {
  current: {}
}, T5 = /* @__PURE__ */ y.createContext({
  ...Ns,
  scaleX: 1,
  scaleY: 1
}), GI = /* @__PURE__ */ y.memo(function({
  id: t,
  autoScroll: n = !0,
  announcements: r,
  children: o,
  sensors: i = UI,
  collisionDetection: l = vI,
  measuring: c,
  modifiers: d,
  screenReaderInstructions: p = QD,
  ...g
}) {
  var m, v, b, x, w;
  const j = y.useReducer(nI, void 0, tI), [C, E] = j, [P, k] = y.useState(() => ({
    type: null,
    event: null
  })), [T, O] = y.useState(!1), {
    draggable: {
      active: A,
      nodes: $,
      translate: N
    },
    droppable: {
      containers: R
    }
  } = C, z = A ? $[A] : null, D = y.useRef({
    initial: null,
    translated: null
  }), Z = y.useMemo(() => {
    var nn;
    return A != null ? {
      id: A,
      // It's possible for the active node to unmount while dragging
      data: (nn = z == null ? void 0 : z.data) != null ? nn : WI,
      rect: D
    } : null;
  }, [A, z]), K = y.useRef(null), [H, q] = y.useState(null), [te, I] = y.useState(null), F = y.useRef(g), V = Xu("DndDescribedBy", t), L = y.useMemo(() => R.getEnabled(), [R]), {
    layoutRectMap: W,
    recomputeLayouts: ie,
    willRecomputeLayouts: re
  } = SI(L, {
    dragging: T,
    dependencies: [N.x, N.y],
    config: c == null ? void 0 : c.droppable
  }), le = bI($, A), me = te ? lv(te) : null, oe = P5(le, (m = c == null || (v = c.draggable) == null ? void 0 : v.measure) != null ? m : uv), se = Ym(le), de = y.useRef(null), we = de.current, je = y.useRef({
    active: null,
    activeNode: le,
    collisionRect: null,
    droppableRects: W,
    draggableNodes: $,
    draggingNodeRect: null,
    droppableContainers: R,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null,
    translatedRect: null
  }), He = R.getNodeFor((b = je.current.over) == null ? void 0 : b.id), Le = Ym(le ? le.ownerDocument.defaultView : null), ot = Ym(le ? le.parentElement : null), vt = PI(A ? He ?? le : null), zt = TI(vt), Ot = RI({
    disabled: A == null,
    forceRecompute: re
  }), ct = (x = Ot.rect) != null ? x : oe, vn = ct === oe ? aI(oe, we) : Ns, St = BI(d, {
    transform: {
      x: N.x - vn.x,
      y: N.y - vn.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: te,
    active: Z,
    activeNodeRect: se,
    containerNodeRect: ot,
    draggingNodeRect: ct,
    over: je.current.over,
    overlayNodeRect: Ot.rect,
    scrollableAncestors: vt,
    scrollableAncestorRects: zt,
    windowRect: Le
  }), At = me ? yu(me, N) : null, en = CI(vt), Bt = yu(St, en), Et = ct ? $S(ct, St) : null, it = Et ? $S(Et, en) : null, Lt = Z && it ? l({
    active: Z,
    collisionRect: it,
    droppableContainers: L
  }) : null, [Ut, yn] = y.useState(null), Bn = iI(St, (w = Ut == null ? void 0 : Ut.rect) != null ? w : null, oe), Zn = y.useCallback((nn, {
    sensor: It,
    options: Mt
  }) => {
    if (!K.current)
      return;
    const at = $[K.current];
    if (!at)
      return;
    const bn = new It({
      active: K.current,
      activeNode: at,
      event: nn.nativeEvent,
      options: Mt,
      // Sensors need to be instantiated with refs for arguments that change over time
      // otherwise they are frozen in time with the stale arguments
      context: je,
      onStart(rn) {
        const Qn = K.current;
        if (!Qn)
          return;
        const ls = $[Qn];
        if (!ls)
          return;
        const {
          onDragStart: ko
        } = F.current, hr = {
          active: {
            id: Qn,
            data: ls.data,
            rect: D
          }
        };
        Cr.unstable_batchedUpdates(() => {
          E({
            type: Nt.DragStart,
            initialCoordinates: rn,
            active: Qn
          }), k({
            type: Nt.DragStart,
            event: hr
          });
        }), ko == null || ko(hr);
      },
      onMove(rn) {
        E({
          type: Nt.DragMove,
          coordinates: rn
        });
      },
      onEnd: $n(Nt.DragEnd),
      onCancel: $n(Nt.DragCancel)
    });
    Cr.unstable_batchedUpdates(() => {
      q(bn), I(nn.nativeEvent);
    });
    function $n(rn) {
      return async function() {
        const {
          active: ls,
          over: ko,
          scrollAdjustedTranslate: hr
        } = je.current;
        let Nr = null;
        if (ls && hr) {
          const {
            cancelDrop: cs
          } = F.current;
          Nr = {
            active: ls,
            delta: hr,
            over: ko
          }, rn === Nt.DragEnd && typeof cs == "function" && await Promise.resolve(cs(Nr)) && (rn = Nt.DragCancel);
        }
        if (K.current = null, Cr.unstable_batchedUpdates(() => {
          E({
            type: rn
          }), yn(null), O(!1), q(null), I(null), Nr && k({
            type: rn,
            event: Nr
          });
        }), Nr) {
          const {
            onDragCancel: cs,
            onDragEnd: pe
          } = F.current, _e = rn === Nt.DragEnd ? pe : cs;
          _e == null || _e(Nr);
        }
      };
    }
  }, [E, $]), Jn = y.useCallback((nn, It) => (Mt, at) => {
    const bn = Mt.nativeEvent;
    // No active draggable
    K.current !== null || // Event has already been captured
    bn.dndKit || bn.defaultPrevented || nn(Mt, It.options) === !0 && (bn.dndKit = {
      capturedBy: It.sensor
    }, K.current = at, Zn(Mt, It));
  }, [Zn]), oo = xI(i, Jn);
  _I(i), ga(
    () => {
      F.current = g;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(g)
  ), y.useEffect(() => {
    A != null && O(!0);
  }, [A]), y.useEffect(() => {
    Z || (de.current = null), Z && oe && !de.current && (de.current = oe);
  }, [oe, Z]), y.useEffect(() => {
    const {
      onDragMove: nn
    } = F.current, {
      active: It,
      over: Mt
    } = je.current;
    if (!It)
      return;
    const at = {
      active: It,
      delta: {
        x: Bt.x,
        y: Bt.y
      },
      over: Mt
    };
    k({
      type: Nt.DragMove,
      event: at
    }), nn == null || nn(at);
  }, [Bt.x, Bt.y]), y.useEffect(
    () => {
      const {
        active: nn,
        droppableContainers: It,
        scrollAdjustedTranslate: Mt
      } = je.current;
      if (!nn || !K.current || !Mt)
        return;
      const {
        onDragOver: at
      } = F.current, bn = It.get(Lt), $n = bn && bn.rect.current ? {
        id: bn.id,
        rect: bn.rect.current,
        data: bn.data,
        disabled: bn.disabled
      } : null, rn = {
        active: nn,
        delta: {
          x: Mt.x,
          y: Mt.y
        },
        over: $n
      };
      Cr.unstable_batchedUpdates(() => {
        yn($n), k({
          type: Nt.DragOver,
          event: rn
        }), at == null || at(rn);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Lt]
  ), ga(() => {
    je.current = {
      active: Z,
      activeNode: le,
      collisionRect: it,
      droppableRects: W,
      draggableNodes: $,
      draggingNodeRect: ct,
      droppableContainers: R,
      over: Ut,
      scrollableAncestors: vt,
      scrollAdjustedTranslate: Bt,
      translatedRect: Et
    }, D.current = {
      initial: ct,
      translated: Et
    };
  }, [Z, le, it, $, ct, W, R, Ut, vt, Bt, Et]), yI({
    ...Ni(),
    draggingRect: Et,
    pointerCoordinates: At,
    scrollableAncestors: vt,
    scrollableAncestorRects: zt
  });
  const as = y.useMemo(() => ({
    active: Z,
    activeNode: le,
    activeNodeRect: oe,
    activeNodeClientRect: se,
    activatorEvent: te,
    activators: oo,
    ariaDescribedById: {
      draggable: V
    },
    containerNodeRect: ot,
    dispatch: E,
    dragOverlay: Ot,
    draggableNodes: $,
    droppableContainers: R,
    droppableRects: W,
    over: Ut,
    recomputeLayouts: ie,
    scrollableAncestors: vt,
    scrollableAncestorRects: zt,
    willRecomputeLayouts: re,
    windowRect: Le
  }), [Z, le, se, oe, te, oo, ot, Ot, E, $, V, R, W, Ut, ie, vt, zt, re, Le]);
  return Q.createElement(x5.Provider, {
    value: P
  }, Q.createElement(ig.Provider, {
    value: as
  }, Q.createElement(T5.Provider, {
    value: Bn
  }, o)), Q.createElement(oI, {
    announcements: r,
    hiddenTextDescribedById: V,
    screenReaderInstructions: p
  }));
  function Ni() {
    const nn = (H == null ? void 0 : H.autoScrollEnabled) === !1, It = typeof n == "object" ? n.enabled === !1 : n === !1, Mt = !nn && !It;
    return typeof n == "object" ? {
      ...n,
      enabled: Mt
    } : {
      enabled: Mt
    };
  }
}), KI = /* @__PURE__ */ y.createContext(null), US = "button", qI = "Droppable";
function YI({
  id: e,
  data: t,
  disabled: n = !1,
  attributes: r
}) {
  const o = Xu(qI), {
    active: i,
    activeNodeRect: l,
    activatorEvent: c,
    ariaDescribedById: d,
    draggableNodes: p,
    droppableRects: g,
    activators: m,
    over: v
  } = y.useContext(ig), {
    role: b = US,
    roleDescription: x = "draggable",
    tabIndex: w = 0
  } = r ?? {}, j = (i == null ? void 0 : i.id) === e, C = y.useContext(j ? T5 : KI), [E, P] = F0(), k = kI(m, e), T = E5(t);
  y.useEffect(
    () => (p[e] = {
      id: e,
      key: o,
      node: E,
      data: T
    }, () => {
      const A = p[e];
      A && A.key === o && delete p[e];
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [p, e]
  );
  const O = y.useMemo(() => ({
    role: b,
    tabIndex: w,
    "aria-pressed": j && b === US ? !0 : void 0,
    "aria-roledescription": x,
    "aria-describedby": d.draggable
  }), [b, w, j, x, d.draggable]);
  return {
    active: i,
    activeNodeRect: l,
    activatorEvent: c,
    attributes: O,
    droppableRects: g,
    isDragging: j,
    listeners: n ? void 0 : k,
    node: E,
    over: v,
    setNodeRef: P,
    transform: C
  };
}
function XI() {
  return y.useContext(ig);
}
const ZI = "Droppable";
function JI({
  data: e,
  disabled: t = !1,
  id: n
}) {
  const r = Xu(ZI), {
    active: o,
    dispatch: i,
    over: l
  } = y.useContext(ig), c = y.useRef(null), [d, p] = F0(), g = E5(e);
  return ga(
    () => (i({
      type: Nt.RegisterDroppable,
      element: {
        id: n,
        key: r,
        disabled: t,
        node: d,
        rect: c,
        data: g
      }
    }), () => i({
      type: Nt.UnregisterDroppable,
      key: r,
      id: n
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  ), y.useEffect(
    () => {
      i({
        type: Nt.SetDroppableDisabled,
        id: n,
        key: r,
        disabled: t
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t]
  ), {
    active: o,
    rect: c,
    isOver: (l == null ? void 0 : l.id) === n,
    node: d,
    over: l,
    setNodeRef: p
  };
}
function QI(e, t, n) {
  const r = {
    ...e
  };
  return t.top + e.y <= n.top ? r.y = n.top - t.top : t.bottom + e.y >= n.top + n.height && (r.y = n.top + n.height - t.bottom), t.left + e.x <= n.left ? r.x = n.left - t.left : t.right + e.x >= n.left + n.width && (r.x = n.left + n.width - t.right), r;
}
const eV = ({
  draggingNodeRect: e,
  transform: t,
  scrollableAncestorRects: n
}) => {
  const r = n[0];
  return !e || !r ? t : QI(t, e, r);
}, tV = ({
  transform: e
}) => ({
  ...e,
  x: 0
});
function O5(e, t, n) {
  const r = e.slice();
  return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function nV(e, t) {
  return e.reduce((n, r, o) => {
    const i = t.get(r);
    return i && (n[o] = i), n;
  }, Array(e.length));
}
function Sf(e) {
  return e !== null && e >= 0;
}
const L5 = ({
  layoutRects: e,
  activeIndex: t,
  overIndex: n,
  index: r
}) => {
  const o = O5(e, n, t), i = e[r], l = o[r];
  return !l || !i ? null : {
    x: l.offsetLeft - i.offsetLeft,
    y: l.offsetTop - i.offsetTop,
    scaleX: l.width / i.width,
    scaleY: l.height / i.height
  };
}, jf = {
  scaleX: 1,
  scaleY: 1
}, rV = ({
  activeIndex: e,
  activeNodeRect: t,
  index: n,
  layoutRects: r,
  overIndex: o
}) => {
  var i;
  const l = (i = r[e]) != null ? i : t;
  if (!l)
    return null;
  if (n === e) {
    const d = r[o];
    return d ? {
      x: 0,
      y: e < o ? d.offsetTop + d.height - (l.offsetTop + l.height) : d.offsetTop - l.offsetTop,
      ...jf
    } : null;
  }
  const c = oV(r, n, e);
  return n > e && n <= o ? {
    x: 0,
    y: -l.height - c,
    ...jf
  } : n < e && n >= o ? {
    x: 0,
    y: l.height + c,
    ...jf
  } : {
    x: 0,
    y: 0,
    ...jf
  };
};
function oV(e, t, n) {
  const r = e[t], o = e[t - 1], i = e[t + 1];
  return r ? n < t ? o ? r.offsetTop - (o.offsetTop + o.height) : i ? i.offsetTop - (r.offsetTop + r.height) : 0 : i ? i.offsetTop - (r.offsetTop + r.height) : o ? r.offsetTop - (o.offsetTop + o.height) : 0 : 0;
}
const M5 = "Sortable", A5 = /* @__PURE__ */ Q.createContext({
  activeIndex: -1,
  containerId: M5,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: L5,
  wasDragging: {
    current: !1
  }
});
function sV({
  children: e,
  id: t,
  items: n,
  strategy: r = L5
}) {
  const {
    active: o,
    dragOverlay: i,
    droppableRects: l,
    over: c,
    recomputeLayouts: d,
    willRecomputeLayouts: p
  } = XI(), g = Xu(M5, t), m = i.rect !== null, v = y.useMemo(() => n.map((A) => typeof A == "string" ? A : A.id), [n]), b = o != null, x = y.useRef(!1), w = o ? v.indexOf(o.id) : -1, j = w !== -1, C = c ? v.indexOf(c.id) : -1, E = y.useRef(v), P = nV(v, l), k = !iV(v, E.current), T = C !== -1 && w === -1 || k;
  ga(() => {
    k && j && !p && d();
  }, [k, j, d, p]), y.useEffect(() => {
    E.current = v;
  }, [v]), y.useEffect(() => {
    const A = setTimeout(() => {
      x.current = b;
    }, 100);
    return () => clearTimeout(A);
  }, [b]);
  const O = y.useMemo(() => ({
    activeIndex: w,
    containerId: g,
    disableTransforms: T,
    items: v,
    overIndex: C,
    useDragOverlay: m,
    sortedRects: P,
    strategy: r,
    wasDragging: x
  }), [w, g, T, v, C, P, m, r, x]);
  return Q.createElement(A5.Provider, {
    value: O
  }, e);
}
function iV(e, t) {
  return e.join() === t.join();
}
const aV = ({
  id: e,
  items: t,
  activeIndex: n,
  overIndex: r
}) => O5(t, n, r).indexOf(e), lV = ({
  containerId: e,
  isSorting: t,
  wasDragging: n,
  index: r,
  items: o,
  newIndex: i,
  previousItems: l,
  previousContainerId: c,
  transition: d
}) => !d || !n || l !== o && r === i ? !1 : t ? !0 : i !== r && e === c, cV = {
  duration: 200,
  easing: "ease"
}, R5 = "transform", uV = /* @__PURE__ */ bu.Transition.toString({
  property: R5,
  duration: 0,
  easing: "linear"
}), dV = {
  roleDescription: "sortable"
};
function fV({
  disabled: e,
  index: t,
  node: n,
  rect: r
}) {
  const [o, i] = y.useState(null), l = y.useRef(t);
  return ga(() => {
    if (!e && t !== l.current && n.current) {
      const c = r.current;
      if (c) {
        const d = lg(n.current), p = {
          x: c.offsetLeft - d.offsetLeft,
          y: c.offsetTop - d.offsetTop,
          scaleX: c.width / d.width,
          scaleY: c.height / d.height
        };
        (p.x || p.y) && i(p);
      }
    }
    t !== l.current && (l.current = t);
  }, [e, t, n, r]), y.useEffect(() => {
    o && requestAnimationFrame(() => {
      i(null);
    });
  }, [o]), o;
}
function pV({
  animateLayoutChanges: e = lV,
  attributes: t,
  disabled: n,
  data: r,
  getNewIndex: o = aV,
  id: i,
  strategy: l,
  transition: c = cV
}) {
  const {
    items: d,
    containerId: p,
    activeIndex: g,
    disableTransforms: m,
    sortedRects: v,
    overIndex: b,
    useDragOverlay: x,
    strategy: w,
    wasDragging: j
  } = y.useContext(A5), C = d.indexOf(i), E = y.useMemo(() => ({
    sortable: {
      containerId: p,
      index: C,
      items: d
    },
    ...r
  }), [p, r, C, d]), {
    rect: P,
    node: k,
    setNodeRef: T
  } = JI({
    id: i,
    data: E
  }), {
    active: O,
    activeNodeRect: A,
    activatorEvent: $,
    attributes: N,
    setNodeRef: R,
    listeners: z,
    isDragging: D,
    over: Z,
    transform: K
  } = YI({
    id: i,
    data: E,
    attributes: {
      ...dV,
      ...t
    },
    disabled: n
  }), H = BD(T, R), q = !!O, te = q && j.current && !m && Sf(g) && Sf(b), I = !x && D, F = I && te ? K : null, L = te ? F ?? (l ?? w)({
    layoutRects: v,
    activeNodeRect: A,
    activeIndex: g,
    overIndex: b,
    index: C
  }) : null, W = Sf(g) && Sf(b) ? o({
    id: i,
    items: d,
    activeIndex: g,
    overIndex: b
  }) : C, ie = y.useRef(d), re = d !== ie.current, le = y.useRef(W), me = y.useRef(p), oe = e({
    active: O,
    containerId: p,
    isDragging: D,
    isSorting: q,
    id: i,
    index: C,
    items: d,
    newIndex: le.current,
    previousItems: ie.current,
    previousContainerId: me.current,
    transition: c,
    wasDragging: j.current
  }), se = fV({
    disabled: !oe,
    index: C,
    node: k,
    rect: P
  });
  return y.useEffect(() => {
    q && le.current !== W && (le.current = W), p !== me.current && (me.current = p), d !== ie.current && (ie.current = d);
  }, [q, W, p, d]), {
    active: O,
    attributes: N,
    activatorEvent: $,
    rect: P,
    index: C,
    isSorting: q,
    isDragging: D,
    listeners: z,
    node: k,
    overIndex: b,
    over: Z,
    setNodeRef: H,
    setDroppableNodeRef: T,
    setDraggableNodeRef: R,
    transform: se ?? L,
    transition: de()
  };
  function de() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      se || // Or to prevent items jumping to back to their "new" position when items change
      re && le.current === C
    )
      return uV;
    if (!(I || !c) && (q || oe))
      return bu.Transition.toString({
        ...c,
        property: R5
      });
  }
}
const gV = [pt.Down, pt.Right, pt.Up, pt.Left], hV = (e, {
  context: {
    active: t,
    droppableContainers: n,
    translatedRect: r,
    scrollableAncestors: o
  }
}) => {
  if (gV.includes(e.code)) {
    if (e.preventDefault(), !t || !r)
      return;
    const l = [];
    n.getEnabled().forEach((d) => {
      if (!d || d != null && d.disabled)
        return;
      const p = d == null ? void 0 : d.node.current;
      if (!p)
        return;
      const g = uv(p), m = {
        ...d,
        rect: {
          current: g
        }
      };
      switch (e.code) {
        case pt.Down:
          r.top + r.height <= g.top && l.push(m);
          break;
        case pt.Up:
          r.top >= g.top + g.height && l.push(m);
          break;
        case pt.Left:
          r.left >= g.left + g.width && l.push(m);
          break;
        case pt.Right:
          r.left + r.width <= g.left && l.push(m);
          break;
      }
    });
    const c = hI({
      active: t,
      collisionRect: r,
      droppableContainers: l
    });
    if (c) {
      var i;
      const d = (i = n.get(c)) == null ? void 0 : i.node.current;
      if (d) {
        const g = z0(d).some((x, w) => o[w] !== x), m = uv(d), v = g ? {
          x: 0,
          y: 0
        } : {
          x: r.width - m.width,
          y: r.height - m.height
        };
        return {
          x: m.left - v.x,
          y: m.top - v.y
        };
      }
    }
  }
};
function mV(e) {
  const { id: t, item: n, className: r, select: o, remove: i, renderItem: l, previewStyle: c, sortable: d = !0, disabled: p } = e, { attributes: g, listeners: m, setNodeRef: v, transform: b, transition: x } = pV({ id: t, disabled: p }), w = {
    transform: bu.Transform.toString(b),
    transition: x
  }, j = () => !p && (o == null ? void 0 : o(n));
  return /* @__PURE__ */ u.jsx("div", { ...d ? { ref: v, style: w, ...g } : {}, children: /* @__PURE__ */ u.jsxs(
    G,
    {
      space: "s",
      onClick: j,
      className: r,
      items: "center",
      nowrap: !0,
      children: [
        d && /* @__PURE__ */ u.jsx(Y, { className: ce(!p && nt.hover, !p && "cursor-grab"), ...m, children: /* @__PURE__ */ u.jsx(ye, { icon: fe.dotsVertical, size: Ee.sx }) }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, className: ce("overflow-hidden"), children: /* @__PURE__ */ u.jsxs(G, { children: [
          /* @__PURE__ */ u.jsx(Y, { grow: !0, className: ce("overflow-ellipsis overflow-hidden"), children: l(n) }),
          !!c && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx("div", { className: ce("w-4 h-4 gjs-bg-white", ve.b, ve.rnd), style: c(n) }) })
        ] }) }),
        /* @__PURE__ */ u.jsx(
          Y,
          {
            className: ce(!p && nt.click),
            onClick: (C) => {
              yl(C), !p && (i == null || i(n));
            },
            children: /* @__PURE__ */ u.jsx(ye, { icon: fe.close, size: Ee.sx })
          }
        )
      ]
    },
    n.getIndex ? n.getIndex() : n.id || n.cid
  ) });
}
function Ho(e) {
  const {
    className: t,
    items: n,
    selected: r,
    renderItem: o,
    select: i,
    add: l,
    remove: c,
    move: d,
    previewStyle: p,
    getItemId: g = (A) => A.id || A.name || A.title || A.label || "",
    label: m,
    labelAs: v,
    children: b,
    title: x = "Select",
    titleAdd: w = "Add",
    emptyState: j,
    disabled: C = !1
  } = e, E = NI(
    HS(W0),
    HS(B0, { coordinateGetter: hV })
  );
  function P(A) {
    const { active: $, over: N } = A;
    if ($.id !== (N == null ? void 0 : N.id)) {
      const R = n.find((D) => g(D) === $.id), z = n.findIndex((D) => g(D) === (N == null ? void 0 : N.id));
      R && (d == null || d(R, z));
    }
  }
  const k = ce(ve.rnd, ee.br, n.length && ve.b, n.length && "gjs-mt-1");
  let T = /* @__PURE__ */ u.jsxs("div", { className: k, children: [
    n.length === 0 && j && /* @__PURE__ */ u.jsx(G, { className: B("gs-utl-p-2 gs-utl-text-center", ee.txtLowEmphasis), items: "center", justify: "center", children: j }),
    n.map((A, $) => {
      const N = g(A), R = A === r, z = ce(
        "gjs-px-2 gjs-py-2 text-xs",
        ee.br,
        $ && ve.bt,
        !!i && !R && !C && ee.hBgH2,
        R && ee.bgH,
        C && "opacity-75"
      );
      return /* @__PURE__ */ u.jsx(
        mV,
        {
          id: N,
          item: A,
          className: z,
          select: i,
          remove: c,
          renderItem: o,
          previewStyle: p,
          sortable: !!d,
          disabled: C
        },
        N
      );
    })
  ] });
  d && (T = /* @__PURE__ */ u.jsx(
    GI,
    {
      sensors: E,
      collisionDetection: sI,
      onDragEnd: P,
      modifiers: [tV, eV],
      children: /* @__PURE__ */ u.jsx(sV, { items: n.map(g), strategy: rV, children: T })
    }
  )), i && (T = /* @__PURE__ */ u.jsx(
    rs,
    {
      placement: "left",
      size: "s",
      buttonAs: "div",
      title: x,
      classNameBody: "gs-utl-gap-2 gs-utl-flex gs-utl-flex-col",
      open: !!r && !C,
      onClose: () => i == null ? void 0 : i(null),
      handler: T,
      children: b
    }
  ));
  const O = l ? [
    {
      type: "button",
      icon: fe.plus,
      tooltip: w,
      variant: "outline",
      size: "xs",
      disabled: C,
      onClick: l
    }
  ] : [];
  return /* @__PURE__ */ u.jsxs("div", { className: ce(t, "w-full"), children: [
    !!(m || l) && /* @__PURE__ */ u.jsx(Eo, { ...e, as: v, afterLabelButtons: O }),
    T
  ] });
}
function N5(e) {
  return e.isFull() || ["slider", "composite", "stack", "file"].includes(e.getType());
}
const WS = "gs-cmp-style-field";
function $5({ property: e, sector: t, styleManagerDataConfig: n, fieldProps: r }) {
  const o = B(WS, `${WS}__${e.id}`), i = { sector: t, styleManagerDataConfig: n };
  switch (e.getType()) {
    case "selectFont":
      return /* @__PURE__ */ u.jsx(og, { className: o, ...H5(e, i) });
    case "number":
    case "slider":
    case "integer":
      return /* @__PURE__ */ u.jsx(et, { className: o, ..._t(e, i), ...r });
    case "color":
      return /* @__PURE__ */ u.jsx(Rs, { className: o, ...ha(e, i) });
    case "select":
      return /* @__PURE__ */ u.jsx(Ze, { className: o, ...Jt(e, i), ...r });
    case "radio":
      return /* @__PURE__ */ u.jsx(
        Kn,
        {
          className: o,
          ...Bo(e, i),
          ...r
        }
      );
    case "file":
      return /* @__PURE__ */ u.jsx(vu, { className: o, ...$V(e, i) });
    case "composite":
      return /* @__PURE__ */ u.jsx(
        ur,
        {
          className: o,
          property: e,
          corners: e.get("corners"),
          generic: e.get("generic"),
          ...i
        }
      );
    case "stack": {
      const l = e.getProperties();
      return /* @__PURE__ */ u.jsx(Ho, { className: o, ...di(e, i), children: /* @__PURE__ */ u.jsx(G0, { properties: l, sector: t }) });
    }
    default:
      return /* @__PURE__ */ u.jsx(jt, { className: o, ...K0(e, i) });
  }
}
const GS = "gs-cmp-style-prop-row";
function G0({ properties: e, sector: t, styleManagerDataConfig: n }) {
  const r = { sector: t, styleManagerDataConfig: n };
  return /* @__PURE__ */ u.jsx(u.Fragment, { children: e.map((o) => {
    const i = o.getId(), l = B(GS, `${GS}__${i}`, N5(o) && "gs-utl-col-span-full");
    return o.isVisible() ? /* @__PURE__ */ u.jsx("div", { className: l, children: /* @__PURE__ */ u.jsx($5, { property: o, ...r }) }, i) : null;
  }) });
}
function vV({ sector: e, styleManagerDataConfig: t }) {
  const n = Ku(), r = e.getProperties().filter((o) => o.isVisible()).map((o) => (n.sdkAddFonts && o.getId() === "font-family" && o.set("type", "selectFont"), o));
  return /* @__PURE__ */ u.jsx("div", { className: B("gs-utl-grid gs-utl-grid-cols-2 gs-utl-gap-2"), children: /* @__PURE__ */ u.jsx(G0, { properties: r, sector: e, styleManagerDataConfig: t }) });
}
const yV = "gs-cmp-sector-row";
function Ve({ className: e, children: t, bottom: n, separator: r, separatorTop: o, property: i, ...l }) {
  const c = /* @__PURE__ */ u.jsx("div", { className: ce("gjs-mb-2 -gjs-ml-2 -gjs-mr-2", ve.bb, ee.br) }), d = ce(yV, e, "w-full gs-utl-gap-2", n), p = (Array.isArray(i) ? i : [i]).filter(Boolean);
  return (p.length ? p.some((m) => m.isVisible()) : !0) ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    o && c,
    /* @__PURE__ */ u.jsx(G, { className: d, nowrap: !0, ...l, children: t }),
    r && c
  ] }) : null;
}
function Mc(e, t, n = {}) {
  const r = e.getType(), { compact: o = !1, sector: i, styleManagerDataConfig: l } = n, c = e.getParent(), d = { sector: i, styleManagerDataConfig: l }, p = e.getDefaultValue();
  if (r === "select") {
    const m = { property: c.getName() };
    return /* @__PURE__ */ u.jsx(
      Ze,
      {
        ...Jt(e, d, m),
        ...t ? {
          value: t.same ? e.getValue({ noDefault: !0 }) : "",
          emptyState: t.same ? e.getOptionLabel(p, m) || p : "Custom",
          onChange: (v) => t.all.map((b) => b.upValue(v))
        } : {},
        label: void 0
      }
    );
  } else
    return r === "color" ? /* @__PURE__ */ u.jsx(
      Rs,
      {
        ...ha(e, d),
        ...t ? {
          value: t.same ? e.getValue({ noDefault: !0 }) : "",
          placeholder: t.same ? p : "Custom",
          onChange: (g, m) => t.all.map((v) => v.upValue(g, { partial: m }))
        } : {},
        label: void 0
      }
    ) : /* @__PURE__ */ u.jsx(
      et,
      {
        ..._t(e, d),
        ...o ? { pan: e.getLabel()[0] } : {},
        ...t ? {
          value: t.same ? e.getValue({ noDefault: !0 }) : "",
          valueUnit: t.same ? e.getUnit() : "",
          placeholder: t.same ? p : "Custom",
          onChange: (g, m) => t.all.map((v) => v.upValue(g, { partial: m })),
          onChangeUnit: (g) => t.all.map((m) => m.upUnit(g))
        } : {},
        label: void 0
      }
    );
}
const Cf = "gs-cmp-style-prop-composite";
function ur({
  className: e,
  property: t,
  sector: n,
  styleManagerDataConfig: r,
  corners: o,
  compact: i,
  generic: l,
  children: c,
  options: d
}) {
  const [p, g] = y.useState(null);
  if (!(t != null && t.isVisible()))
    return null;
  const m = {
    id: "custom",
    label: /* @__PURE__ */ u.jsx(ye, { icon: fe.borderStyle, size: Ee.s }),
    title: "Custom"
  }, v = [
    { id: "all", label: /* @__PURE__ */ u.jsx(ye, { icon: fe.borderAllVariant, size: Ee.s }), title: "All" },
    m
  ], b = t.isDetached(), x = t.getProperties(), w = x.length, [j, C, E, P] = x, k = j.getFullValue(), O = x.map((I) => I.getFullValue()).every((I) => I === k), A = p !== null ? p : O || d ? "all" : m.id, $ = d ? [...d, m] : [], N = t.getFullValue(), R = $.some((I) => I.id === N), z = A === m.id || (d ? !R : !1) || !!l, D = { compact: i, sector: n, styleManagerDataConfig: r }, Z = /* @__PURE__ */ u.jsx(ui, { property: i ? null : j, shallow: !b, children: Mc(j, null, D) }), K = /* @__PURE__ */ u.jsx(ui, { property: i ? null : C, shallow: !b, children: Mc(C, null, D) }), H = !!E && /* @__PURE__ */ u.jsx(ui, { property: i ? null : E, shallow: !b, children: Mc(E, null, D) }), q = !!P && /* @__PURE__ */ u.jsx(ui, { property: i ? null : P, shallow: !b, children: Mc(P, null, D) }), te = i ? { label: t.getLabel() } : { property: t };
  return /* @__PURE__ */ u.jsxs(G, { className: ce(Cf, e, "gs-utl-w-full gs-utl-gap-2"), col: !0, nowrap: !0, children: [
    /* @__PURE__ */ u.jsx(Ve, { className: `${Cf}__main`, children: /* @__PURE__ */ u.jsx(ui, { ...te, children: !l && /* @__PURE__ */ u.jsx(Ve, { bottom: "0", children: c !== void 0 ? c : d ? /* @__PURE__ */ u.jsx(u.Fragment, { children: /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(
      Kn,
      {
        size: "s",
        options: $,
        value: z ? m.id : N,
        onChange: (I) => {
          I === m.id ? g(I) : (t.upValue(I), g(""));
        }
      }
    ) }) }) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: Mc(j, { same: O, all: x }, D) }),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(Kn, { size: "s", options: v, value: A, onChange: g }) })
    ] }) }) }) }),
    z && /* @__PURE__ */ u.jsx(Ve, { col: !0, className: ce(`${Cf}__details`, "gjs-px-2 gjs-py-1", ee.bgH2, ve.rnd, ve.b, ee.br), children: l ? /* @__PURE__ */ u.jsx("div", { className: ce(`${Cf}__props`, "grid grid-cols-2 gap-2"), children: x.map((I) => /* @__PURE__ */ u.jsx(
      ui,
      {
        property: I,
        shallow: !b,
        className: ce(N5(I) && "col-span-full"),
        children: /* @__PURE__ */ u.jsx($5, { property: I, ...D, fieldProps: { label: void 0 } })
      },
      I.getId()
    )) }) : w === 2 ? /* @__PURE__ */ u.jsx(u.Fragment, { children: /* @__PURE__ */ u.jsxs(G, { space: "s", children: [
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: Z }),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: K })
    ] }) }) : w === 3 ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsxs(G, { space: "s", children: [
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: Z }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: K })
      ] }),
      /* @__PURE__ */ u.jsx(G, { space: "s", children: /* @__PURE__ */ u.jsx(Y, { grow: !0, children: H }) })
    ] }) : o ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsxs(G, { space: "s", children: [
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: Z }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: K })
      ] }),
      /* @__PURE__ */ u.jsxs(G, { space: "s", children: [
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: q }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: H })
      ] })
    ] }) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(G, { className: ce("gs-utl-w-1/2 gjs-m-auto"), children: Z }),
      /* @__PURE__ */ u.jsxs(G, { space: "s", children: [
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: q }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: K })
      ] }),
      /* @__PURE__ */ u.jsx(G, { className: ce("gs-utl-w-1/2 gjs-m-auto"), children: H })
    ] }) })
  ] });
}
function bV({ sector: e, styleManagerDataConfig: t }) {
  const n = e.getProperty("border-radius"), r = { sector: e, styleManagerDataConfig: t };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(ur, { property: n, corners: !0, ...r }),
    /* @__PURE__ */ u.jsx(ur, { property: e.getProperty("border-width"), ...r }),
    /* @__PURE__ */ u.jsx(ur, { property: e.getProperty("border-style"), ...r }),
    /* @__PURE__ */ u.jsx(ur, { property: e.getProperty("border-color"), ...r })
  ] });
}
const Zi = (e) => rg({ value: parseFloat(e), min: -3, max: 3 }), Jm = (e, t = "filter", n) => {
  const r = e.getProperty(`${t}-value`), o = e.getProperty(`${t}-name`).getOption() || {}, i = o.units || [], l = r.getUnit(), c = mD(l, i) ? l : i[0];
  return {
    ..._t(r, n),
    units: i,
    valueUnit: c,
    onChange: (d, p) => {
      r.upValue(d, {
        partial: p,
        units: i,
        min: o.min,
        max: o.max
      });
    }
  };
}, KS = (e, t, n, r) => {
  const o = e.getProperty(`${t}-name`), i = e.getProperty(`${t}-value`);
  return {
    ...Jt(o, n, r),
    onChange: (l) => {
      o.upValue(l), i.upValue("");
    }
  };
}, xV = {
  "text-shadow-h": "1px",
  "text-shadow-v": "1px",
  "text-shadow-blur": "5px"
};
function wV({ sector: e, styleManagerDataConfig: t }) {
  const n = e.getProperty("box-shadow"), r = e.getProperty("text-shadow"), o = e.getProperty("filter"), i = e.getProperty("backdrop-filter"), l = e.getProperty("transition"), c = e.getProperty("transform"), d = e.getProperty("perspective-origin"), p = e.getProperty("backface-visibility"), g = e.getProperty("perspective"), m = e.getProperty("transform-style"), v = e.getProperty("opacity"), b = e.getProperty("mix-blend-mode"), x = e.getProperty("cursor"), w = { sector: e, styleManagerDataConfig: t }, j = (E) => {
    const {
      boxShadowH: P,
      boxShadowV: k,
      boxShadowBlur: T,
      boxShadowColor: O,
      boxShadowSpread: A,
      boxShadowType: $
    } = E.getValues({ camelCase: !0 }), N = Zi(P), R = Zi(k), z = Zi(T), D = Zi(A), Z = `${N}px ${R}px ${z}px ${D}px ${O} ${$}`.trim();
    return /* @__PURE__ */ u.jsxs(G, { space: "s", items: "center", children: [
      /* @__PURE__ */ u.jsxs(Y, { grow: !0, children: [
        P,
        " ",
        k,
        " ",
        T,
        " ",
        A
      ] }),
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx("div", { className: ce("w-4 h-4 gjs-bg-white", ve.b, ve.rnd), style: { boxShadow: Z } }) })
    ] });
  }, C = (E) => {
    const {
      textShadowH: P,
      textShadowV: k,
      textShadowBlur: T,
      textShadowColor: O
    } = E.getValues({ camelCase: !0 }), A = Zi(P), $ = Zi(k), N = Zi(T), R = `${A}px ${$}px ${N}px ${O}`.trim();
    return /* @__PURE__ */ u.jsxs(G, { space: "s", items: "center", children: [
      /* @__PURE__ */ u.jsxs(Y, { grow: !0, children: [
        P,
        " ",
        k,
        " ",
        T
      ] }),
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx("div", { className: ce("w-4 h-4 gjs-bg-white", ve.b, ve.rnd), style: { boxShadow: R } }) })
    ] });
  };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs(Ve, { property: [v, b], children: [
      /* @__PURE__ */ u.jsx(et, { ..._t(v, w) }),
      /* @__PURE__ */ u.jsx(Ze, { ...Jt(b, w) })
    ] }),
    /* @__PURE__ */ u.jsx(Ve, { property: x, separator: !0, children: /* @__PURE__ */ u.jsx(Ze, { ...Jt(x, w) }) }),
    /* @__PURE__ */ u.jsx(Ve, { property: n, separator: !0, children: /* @__PURE__ */ u.jsxs(Ho, { ...di(n, w), renderItem: j, children: [
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(
        Kn,
        {
          ...Bo(n.getProperty("box-shadow-type"), w),
          label: ""
        }
      ) }),
      /* @__PURE__ */ u.jsxs(Ve, { children: [
        /* @__PURE__ */ u.jsx(
          et,
          {
            ..._t(n.getProperty("box-shadow-h"), w),
            label: "X offset"
          }
        ),
        /* @__PURE__ */ u.jsx(
          et,
          {
            ..._t(n.getProperty("box-shadow-v"), w),
            label: "Y offset"
          }
        )
      ] }),
      /* @__PURE__ */ u.jsxs(Ve, { children: [
        /* @__PURE__ */ u.jsx(
          et,
          {
            ..._t(n.getProperty("box-shadow-blur"), w),
            label: "Blur"
          }
        ),
        /* @__PURE__ */ u.jsx(
          et,
          {
            ..._t(n.getProperty("box-shadow-spread"), w),
            label: "Spread"
          }
        )
      ] }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(Rs, { ...ha(n.getProperty("box-shadow-color"), w), label: "Color" }) })
    ] }) }),
    /* @__PURE__ */ u.jsx(Ve, { property: r, separator: !0, children: /* @__PURE__ */ u.jsxs(Ho, { ...di(r, w, xV), renderItem: C, children: [
      /* @__PURE__ */ u.jsxs(Ve, { children: [
        /* @__PURE__ */ u.jsx(
          et,
          {
            ..._t(r.getProperty("text-shadow-h"), w),
            label: "X offset"
          }
        ),
        /* @__PURE__ */ u.jsx(
          et,
          {
            ..._t(r.getProperty("text-shadow-v"), w),
            label: "Y offset"
          }
        )
      ] }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(
        et,
        {
          ..._t(r.getProperty("text-shadow-blur"), w),
          label: "Blur"
        }
      ) }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(
        Rs,
        {
          ...ha(r.getProperty("text-shadow-color"), w),
          label: "Color"
        }
      ) })
    ] }) }),
    /* @__PURE__ */ u.jsx(Ve, { property: o, separator: !0, children: /* @__PURE__ */ u.jsx(Ho, { ...di(o, w, { "filter-name": "blur", "filter-value": "3px" }), children: /* @__PURE__ */ u.jsxs(Ve, { children: [
      /* @__PURE__ */ u.jsx(Ze, { ...KS(o, "filter", w), label: "Type" }),
      /* @__PURE__ */ u.jsx(et, { ...Jm(o, void 0, w), label: "Value" })
    ] }) }) }),
    /* @__PURE__ */ u.jsx(Ve, { property: i, separator: !0, children: /* @__PURE__ */ u.jsx(
      Ho,
      {
        ...di(i, w, {
          "backdrop-filter-name": "blur",
          "backdrop-filter-value": "3px"
        }),
        children: /* @__PURE__ */ u.jsxs(Ve, { children: [
          /* @__PURE__ */ u.jsx(
            Ze,
            {
              ...Jt(i.getProperty("backdrop-filter-name"), w),
              label: "Type"
            }
          ),
          /* @__PURE__ */ u.jsx(et, { ...Jm(i, "backdrop-filter", w), label: "Value" })
        ] })
      }
    ) }),
    /* @__PURE__ */ u.jsx(Ve, { property: l, separator: !0, children: /* @__PURE__ */ u.jsxs(Ho, { ...di(l, w), children: [
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(
        Ze,
        {
          ...Jt(l.getProperty("transition-property"), w),
          label: "Type"
        }
      ) }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(
        Ze,
        {
          ...Jt(l.getProperty("transition-timing-function"), w),
          label: "Easing"
        }
      ) }),
      /* @__PURE__ */ u.jsxs(Ve, { children: [
        /* @__PURE__ */ u.jsx(
          et,
          {
            ..._t(l.getProperty("transition-duration"), w),
            label: "Duration"
          }
        ),
        /* @__PURE__ */ u.jsx(
          et,
          {
            ..._t(l.getProperty("transition-delay"), w),
            label: "Delay"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ u.jsx(Ve, { property: c, separator: !0, children: /* @__PURE__ */ u.jsx(Ho, { ...di(c, w), children: /* @__PURE__ */ u.jsxs(Ve, { children: [
      /* @__PURE__ */ u.jsx(Ze, { ...KS(c, "transform", w), label: "Type" }),
      /* @__PURE__ */ u.jsx(et, { ...Jm(c, "transform", w), label: "Value" })
    ] }) }) }),
    /* @__PURE__ */ u.jsx(ur, { property: e.getProperty("transform-origin"), ...w }),
    /* @__PURE__ */ u.jsx(ur, { property: e.getProperty("overflow"), ...w }),
    /* @__PURE__ */ u.jsx(Ve, { property: p, children: /* @__PURE__ */ u.jsx(Kn, { ...Bo(p, w) }) }),
    /* @__PURE__ */ u.jsx(Ve, { property: [g, m, d], separatorTop: !0, children: "Children transform" }),
    /* @__PURE__ */ u.jsxs(Ve, { property: [g, m], children: [
      /* @__PURE__ */ u.jsx(et, { ..._t(g, w) }),
      /* @__PURE__ */ u.jsx(Kn, { ...Bo(m, w) })
    ] }),
    /* @__PURE__ */ u.jsx(ur, { property: d, ...w })
  ] });
}
function SV(e, t) {
  return e.indexOf(t) >= 0;
}
const Ht = Ee.s, Ef = "M6 6v12h13V6H6zm0 13v5H5V0h1v5h13c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H6zm6-14h1v14h-1V5z", Pf = "M6 6v12h13V6H6zm0-1h13c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H6a1 1 0 01-1-1V6c0-.6.4-1 1-1zm6-5h1v24h-1V0z", _f = "M6 6v12h13V6H6zm13-1V0h1v24h-1v-5H6a1 1 0 01-1-1V6c0-.6.4-1 1-1h13zm-7 0h1v14h-1V5z", qS = "M2 6v12h6V6H2zm0 13v5H1V0h1v5h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H2zM16 6v12h6V6h-6zm6-1V0h1v24h-1v-5h-6a1 1 0 01-1-1V6c0-.6.4-1 1-1h6z", YS = "M11 0h1v24h-1V0zM1 6h6v12H1V6zm0-1h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H1a1 1 0 01-1-1V6c0-.6.4-1 1-1zm15 1h6v12h-6V6zm0-1h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1h-6a1 1 0 01-1-1V6c0-.6.4-1 1-1z", jV = "M3 6v12h6V6H3zm0-1h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1H3a1 1 0 01-1-1V6c0-.6.4-1 1-1zM0 0h1v24H0V0zm14 6v12h6V6h-6zm0-1h6c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1h-6a1 1 0 01-1-1V6c0-.6.4-1 1-1zm8-5h1v24h-1V0zM11 0h1v24h-1V0z", Qm = "M15 19H9V6h6v13zM8 6v13H0v1h24v-1h-8V6h8V5H0v1h8z";
function CV({ sector: e, styleManagerDataConfig: t }) {
  const n = e.em.getEditor(), r = qe(), [o, i] = y.useState({}), [l, c] = y.useState({}), d = e.getProperty("display"), p = e.getProperty("flex-direction"), g = e.getProperty("justify-content"), m = e.getProperty("align-items"), v = e.getProperty("flex-wrap"), b = e.getProperty("align-content"), x = e.getProperty("align-self"), w = e.getProperty("order"), j = e.getProperty("gap"), C = e.getProperty("flex"), E = { sector: e, styleManagerDataConfig: t }, P = [
    d,
    p,
    g,
    m,
    v,
    b,
    x,
    w,
    j,
    C
  ].map((I) => I.id), k = e.getProperties().filter((I) => !P.includes(`${I.id}`)), T = (I) => r.t(`styleManager.layout.${I}`), O = d.getValue(), A = O === "flex", $ = (l.display || "").indexOf("flex") >= 0, N = p.getValue(), R = N.indexOf("reverse") >= 0, z = !SV(["column", "column-reverse"], N), D = [
    { id: "row", label: /* @__PURE__ */ u.jsx(ye, { icon: fe.arrowRight, size: Ee.sx }), title: T("direction.title.row") },
    {
      id: "row-reverse",
      label: /* @__PURE__ */ u.jsx(ye, { icon: fe.arrowRight, size: Ht, horizontal: !0 }),
      title: T("direction.title.row-reverse")
    },
    {
      id: "column",
      label: /* @__PURE__ */ u.jsx(ye, { icon: fe.arrowDown, size: Ee.sx }),
      title: T("direction.title.column")
    },
    {
      id: "column-reverse",
      label: /* @__PURE__ */ u.jsx(ye, { icon: fe.arrowDown, size: Ht, vertical: !0 }),
      title: T("direction.title.column-reverse")
    }
  ], Z = [
    {
      id: "flex-start",
      title: "Start",
      label: /* @__PURE__ */ u.jsx(
        ye,
        {
          icon: Ef,
          size: Ht,
          rotate: z ? 0 : 90,
          horizontal: z && R,
          vertical: !z && R
        }
      )
    },
    { id: "center", title: "Center", label: /* @__PURE__ */ u.jsx(ye, { icon: Pf, size: Ht, rotate: z ? 0 : 90 }) },
    {
      id: "flex-end",
      title: "End",
      label: /* @__PURE__ */ u.jsx(
        ye,
        {
          icon: _f,
          size: Ht,
          rotate: z ? 0 : 90,
          horizontal: z && R,
          vertical: !z && R
        }
      )
    },
    {
      id: "space-between",
      title: "Space between",
      label: /* @__PURE__ */ u.jsx(ye, { icon: qS, size: Ht, rotate: z ? 0 : 90 })
    },
    {
      id: "space-around",
      title: "Space around",
      label: /* @__PURE__ */ u.jsx(ye, { icon: YS, size: Ht, rotate: z ? 0 : 90 })
    },
    {
      id: "space-evenly",
      title: "Space evenly",
      label: /* @__PURE__ */ u.jsx(ye, { icon: jV, size: Ht, rotate: z ? 0 : 90 })
    }
  ], K = [
    {
      id: "stretch",
      title: "Stretch",
      label: /* @__PURE__ */ u.jsx(ye, { icon: Qm, size: Ht, rotate: z ? 0 : 90 })
    },
    { id: "flex-start", title: "Start", label: /* @__PURE__ */ u.jsx(ye, { icon: Ef, size: Ht, rotate: z ? 90 : 0 }) },
    { id: "center", title: "Center", label: /* @__PURE__ */ u.jsx(ye, { icon: Pf, size: Ht, rotate: z ? 90 : 0 }) },
    { id: "flex-end", title: "End", label: /* @__PURE__ */ u.jsx(ye, { icon: _f, size: Ht, rotate: z ? 90 : 0 }) }
  ], H = [
    {
      id: "flex-start",
      title: "Start",
      label: /* @__PURE__ */ u.jsx(
        ye,
        {
          icon: Ef,
          size: Ht,
          rotate: z ? 90 : 0,
          horizontal: z && R,
          vertical: !z && R
        }
      )
    },
    { id: "center", title: "Center", label: /* @__PURE__ */ u.jsx(ye, { icon: Pf, size: Ht, rotate: z ? 90 : 0 }) },
    {
      id: "flex-end",
      title: "End",
      label: /* @__PURE__ */ u.jsx(
        ye,
        {
          icon: _f,
          size: Ht,
          rotate: z ? 90 : 0,
          horizontal: z && R,
          vertical: !z && R
        }
      )
    },
    {
      id: "space-between",
      title: "Space between",
      label: /* @__PURE__ */ u.jsx(ye, { icon: qS, size: Ht, rotate: z ? 90 : 0 })
    },
    {
      id: "space-around",
      title: "Space around",
      label: /* @__PURE__ */ u.jsx(ye, { icon: YS, size: Ht, rotate: z ? 90 : 0 })
    },
    { id: "stretch", title: "Stretch", label: /* @__PURE__ */ u.jsx(ye, { icon: Qm, size: Ht, rotate: z ? 0 : 90 }) }
  ], q = [
    { id: "auto", title: "Auto", label: /* @__PURE__ */ u.jsx(ye, { icon: fe.close, size: Ht }) },
    { id: "flex-start", title: "Start", label: /* @__PURE__ */ u.jsx(ye, { icon: Ef, size: Ht, rotate: 90 }) },
    { id: "center", title: "Center", label: /* @__PURE__ */ u.jsx(ye, { icon: Pf, size: Ht, rotate: 90 }) },
    { id: "flex-end", title: "End", label: /* @__PURE__ */ u.jsx(ye, { icon: _f, size: Ht, rotate: 90 }) },
    { id: "stretch", title: "Stretch", label: /* @__PURE__ */ u.jsx(ye, { icon: Qm, size: Ht, rotate: 0 }) }
  ], te = [
    { id: "0 0 auto", label: /* @__PURE__ */ u.jsx(ye, { icon: fe.close, size: Ht }), title: "Auto" },
    // IconNames.formatVerticalAlignCenter
    {
      id: "1 1 0%",
      label: /* @__PURE__ */ u.jsx(ye, { icon: fe.unfoldMoreHorizontal, size: Ht, rotate: 90 }),
      title: "Fill container"
    },
    {
      id: "0 1 auto",
      label: /* @__PURE__ */ u.jsx(ye, { icon: fe.unfoldLessHorizontal, size: Ht, rotate: 90 }),
      title: "Hug contents"
    }
  ];
  return y.useEffect(() => {
    if (!n)
      return () => {
      };
    const { Styles: I } = n, F = () => {
      const L = n.getSelected();
      let W = {}, ie = {};
      if (L) {
        const re = L.getEl();
        if (re) {
          W = window.getComputedStyle(re);
          const le = re.parentElement;
          le && (ie = window.getComputedStyle(le));
        }
      }
      i(W), c(ie);
    }, V = I.events.target;
    return n.on(V, F), F(), () => n.off(V, F);
  }, [n]), /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(
      Ze,
      {
        ...Jt(d, E),
        ...pv,
        tip: T(`display.tips.${O}`)
      }
    ) }),
    A && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(Kn, { ...Bo(p, E), options: D }) }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(Kn, { ...Bo(g, E), options: Z }) }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(Kn, { ...Bo(m, E), options: K }) }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(ur, { property: j, ...E }) }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(Ze, { ...Jt(v, E), ...pv }) }),
      v.getValue() !== "nowrap" && /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(Kn, { ...Bo(b, E), options: H }) })
    ] }),
    $ && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(Ve, { separatorTop: !0, children: T("flexChild") }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(ur, { property: C, options: te, ...E }) }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(Kn, { ...Bo(x, E), options: q }) }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(et, { ..._t(w, { sector: e, styleManagerDataConfig: t }) }) })
    ] }),
    k.length > 0 && /* @__PURE__ */ u.jsx(G0, { properties: k, ...E })
  ] });
}
const EV = [
  "topLeft",
  "topRight",
  "bottomLeft",
  "bottomRight",
  "left",
  "right",
  "bottom",
  "top",
  "full"
];
function PV({ sector: e, styleManagerDataConfig: t }) {
  var x;
  const n = qe(), r = e.getProperty("position"), o = r.getValue(), i = e.getProperty("top"), l = e.getProperty("right"), c = e.getProperty("bottom"), d = e.getProperty("left"), p = { sector: e, styleManagerDataConfig: t }, g = (w) => n.t(`styleManager.position.${w}`), m = EV.map((w) => ({ id: w, label: g(`presets.options.${w}`) })), v = ["absolute", "fixed"].includes(o), b = (w) => {
    let j = "auto", C = "auto", E = "auto", P = "auto";
    switch (w) {
      case "topLeft":
        j = "0%", P = "0%";
        break;
      case "topRight":
        j = "0%", C = "0%";
        break;
      case "bottomLeft":
        E = "0%", P = "0%";
        break;
      case "bottomRight":
        E = "0%", C = "0%";
        break;
      case "left":
        j = "0%", E = "0%", P = "0%";
        break;
      case "right":
        j = "0%", E = "0%", C = "0%";
        break;
      case "bottom":
        P = "0%", E = "0%", C = "0%";
        break;
      case "top":
        P = "0%", j = "0%", C = "0%";
        break;
      case "full":
        P = "0%", j = "0%", C = "0%", E = "0%";
        break;
    }
    i.upValue(j), l.upValue(C), c.upValue(E), d.upValue(P);
  };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs(Ve, { property: r, children: [
      /* @__PURE__ */ u.jsx(
        Ze,
        {
          ...Jt(r, p),
          tip: g(`tips.${(x = r.getOption()) == null ? void 0 : x.id}`),
          ...pv
        }
      ),
      v && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(_n, { title: g("presets.title"), children: /* @__PURE__ */ u.jsx(Ze, { options: m, onChange: b, emptyState: "P", size: "s", caret: "", value: !0 }) }) })
    ] }),
    o !== "static" && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsxs(Ve, { col: !0, children: [
        /* @__PURE__ */ u.jsx(G, { className: ce("gs-utl-w-1/2 gjs-m-auto"), children: /* @__PURE__ */ u.jsx(et, { ..._t(i, p) }) }),
        /* @__PURE__ */ u.jsxs(G, { gap: "s", children: [
          /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(et, { ..._t(d, p) }) }),
          /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(et, { ..._t(l, p) }) })
        ] }),
        /* @__PURE__ */ u.jsx(G, { className: ce("gs-utl-w-1/2 gjs-m-auto"), children: /* @__PURE__ */ u.jsx(et, { ..._t(c, p) }) })
      ] }),
      /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(et, { ..._t(e.getProperty("z-index"), p) }) })
    ] })
  ] });
}
function _V({ sector: e, styleManagerDataConfig: t }) {
  const n = e.getProperty("width"), r = e.getProperty("min-width"), o = e.getProperty("max-width"), i = e.getProperty("height"), l = e.getProperty("min-height"), c = e.getProperty("max-height"), d = { sector: e, styleManagerDataConfig: t };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs(Ve, { property: [n, i], children: [
      /* @__PURE__ */ u.jsx(et, { ..._t(n, d) }),
      /* @__PURE__ */ u.jsx(et, { ..._t(i, d) })
    ] }),
    /* @__PURE__ */ u.jsxs(Ve, { property: [r, l], children: [
      /* @__PURE__ */ u.jsx(et, { ..._t(r, d) }),
      /* @__PURE__ */ u.jsx(et, { ..._t(l, d) })
    ] }),
    /* @__PURE__ */ u.jsxs(Ve, { property: [o, c], children: [
      /* @__PURE__ */ u.jsx(et, { ..._t(o, d) }),
      /* @__PURE__ */ u.jsx(et, { ..._t(c, d) })
    ] })
  ] });
}
function kV({ sector: e, styleManagerDataConfig: t }) {
  const n = { sector: e, styleManagerDataConfig: t };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(ur, { property: e.getProperty("padding"), ...n }),
    /* @__PURE__ */ u.jsx(ur, { property: e.getProperty("margin"), ...n })
  ] });
}
function TV({ sector: e, styleManagerDataConfig: t }) {
  const n = e.getProperty("font-family"), r = e.getProperty("color"), o = e.getProperty("font-size"), i = e.getProperty("font-weight"), l = e.getProperty("line-height"), c = e.getProperty("letter-spacing"), d = e.getProperty("text-align"), p = e.getProperty("vertical-align"), g = e.getProperty("text-decoration"), m = e.getProperty("text-transform"), v = e.getProperty("direction"), b = e.getProperty("white-space"), x = { sector: e, styleManagerDataConfig: t }, { sdkAddFonts: w } = Ku();
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    !!n && /* @__PURE__ */ u.jsx(Ve, { property: n, children: w ? /* @__PURE__ */ u.jsx(og, { ...H5(n, x) }) : /* @__PURE__ */ u.jsx(Ze, { ...Jt(n, x) }) }),
    !!r && /* @__PURE__ */ u.jsx(Ve, { property: r, children: /* @__PURE__ */ u.jsx(Rs, { ...ha(r, x) }) }),
    /* @__PURE__ */ u.jsxs(Ve, { property: [o, i], children: [
      !!o && /* @__PURE__ */ u.jsx(et, { ..._t(o, x) }),
      !!i && /* @__PURE__ */ u.jsx(Ze, { ...Jt(i, x) })
    ] }),
    /* @__PURE__ */ u.jsxs(Ve, { property: [l, c], children: [
      !!l && /* @__PURE__ */ u.jsx(et, { ..._t(l, x) }),
      !!c && /* @__PURE__ */ u.jsx(et, { ..._t(c, x) })
    ] }),
    /* @__PURE__ */ u.jsxs(Ve, { property: [d, p], children: [
      !!d && /* @__PURE__ */ u.jsx(Ze, { ...Jt(d, x) }),
      !!p && /* @__PURE__ */ u.jsx(Ze, { ...Jt(p, x) })
    ] }),
    /* @__PURE__ */ u.jsxs(Ve, { property: [m, v], children: [
      !!m && /* @__PURE__ */ u.jsx(Ze, { ...Jt(m, x) }),
      !!v && /* @__PURE__ */ u.jsx(Ze, { ...Jt(v, x) })
    ] }),
    /* @__PURE__ */ u.jsxs(Ve, { property: [b, g], children: [
      !!b && /* @__PURE__ */ u.jsx(Ze, { ...Jt(b, x) }),
      !!g && /* @__PURE__ */ u.jsx(Ze, { ...Jt(g, x) })
    ] })
  ] });
}
const pv = {
  row: !0,
  classNameLabel: "gs-utl-w-full"
}, OV = ({ property: e, skipClear: t, label: n, afterLabelButtons: r = [] }) => /* @__PURE__ */ u.jsxs(G, { nowrap: !0, full: !0, items: "center", justify: "between", gap: "s", children: [
  /* @__PURE__ */ u.jsx(Y, { grow: !1, children: /* @__PURE__ */ u.jsx(ui, { property: e, skipClear: t, label: n }) }),
  !!r.length && /* @__PURE__ */ u.jsx(G, { nowrap: !0, items: "center", justify: "start", gap: "x2s", children: r.map((o, i) => /* @__PURE__ */ u.jsx(Qt, { ...o }, i)) })
] }), D5 = "gs-style-manager", bp = `${D5}-sector`, LV = `${bp}-header`, MV = `${bp}-content`, I5 = (e, t = 0, n = !0) => ce(LV, ee.bgH2, tt.xyS, ee.br, t && ve.bt, (e || n) && ve.bb), AV = (e, t = {}) => e.getOptions().map((n) => ({
  id: e.getOptionId(n),
  label: e.getOptionLabel(e.getOptionId(n), t),
  title: n.title
})), RV = (e, t) => t.map((n) => ({
  ...n,
  title: e.getOptionLabel(e.getOptionId(n))
})), Zu = (e, t) => {
  const n = NV(e, t), r = m5(n), { hasDataResolverValue: o } = n, { label: i } = t;
  return {
    connectDataSources: n,
    commonProps: {
      size: "s",
      disabled: o,
      placeholder: e.getDefaultValue(),
      labelAs: r.length ? "span" : void 0,
      label: /* @__PURE__ */ u.jsx(
        OV,
        {
          property: e,
          skipClear: o,
          label: i,
          afterLabelButtons: r
        }
      )
    }
  };
}, K0 = (e, t) => {
  const { connectDataSources: n, commonProps: r } = Zu(e, t);
  return {
    ...r,
    value: n.dataResolverValue ?? e.getValue({ noDefault: !0 }),
    onChange: (o, i) => e.upValue(o, { partial: i })
  };
}, V5 = (e, t, n) => {
  const { connectDataSources: r, commonProps: o } = Zu(e, t), { hasDataResolverValue: i, initialDataValue: l } = r;
  return {
    fieldProps: {
      ...o,
      value: i ? l : e.getValue(),
      options: AV(e, n ?? {}),
      onChange: (c) => e.upValue(c)
    },
    connectDataSources: r
  };
}, Bo = (e, t, n) => V5(e, t, n).fieldProps, Jt = (e, t, n) => {
  const { fieldProps: r, connectDataSources: o } = V5(e, t, n), { hasDataResolverValue: i } = o, l = i ? e.getValue() || " " : r.emptyState;
  return {
    ...r,
    emptyState: l,
    hideCaret: i
  };
}, H5 = (e, t) => {
  const { commonProps: n, connectDataSources: r } = Zu(e, t), o = r.hasDataResolverValue ? e.getValue() || " " : void 0;
  return {
    ...n,
    options: void 0,
    emptyState: o,
    hideCaret: r.hasDataResolverValue,
    value: r.dataResolverValue ?? e.getValue(),
    onChange: (i) => e.upValue(i)
  };
}, di = (e, t, n = {}) => {
  const { connectDataSources: r, commonProps: o } = Zu(e, t), { hasDataResolverValue: i, dataResolverValue: l } = r;
  return {
    ...o,
    title: e.getLabel(),
    emptyState: i ? l : void 0,
    titleAdd: `Add new ${e.getLabel()}`,
    items: i ? [] : e.getLayers(),
    selected: e.getSelectedLayer(),
    renderItem: (c) => e.getLayerLabel(c),
    add: i ? void 0 : () => e.addLayer(n, { at: 0 }),
    select: (c) => e.selectLayer(c),
    remove: (c) => e.removeLayer(c),
    move: (c, d = 0) => e.moveLayer(c, d)
  };
}, _t = (e, t) => {
  const { connectDataSources: n, commonProps: r } = Zu(e, t), { hasDataResolverValue: o } = n;
  return {
    ...r,
    value: n.dataResolverValue ?? e.getValue({ noDefault: !0 }),
    onChange: (i, l) => e.upValue(i, { partial: l }),
    valueUnit: e.getUnit(),
    pan: !o,
    units: o ? [] : e.getUnits(),
    min: e.getMin(),
    max: e.getMax() || void 0,
    step: e.getStep(),
    onChangeUnit: (i) => e.upUnit(i)
  };
};
function NV(e, t) {
  const { styleManagerDataConfig: n = !1, sector: r } = t, o = e.em.getEditor(), { Styles: i } = o, l = o.getSelected(), c = i.getSelectedAll(), d = i.getSelected();
  let p = !1;
  n === !0 ? p = !0 : l && Qo(n) && Ct(n.enable) && (p = n.enable({
    property: e,
    sector: r,
    component: l,
    editor: o
  }));
  const g = e.getName(), m = (d == null ? void 0 : d.getStyle("", { skipResolve: !0 })[g]) ?? "", v = ji(m), b = l == null ? void 0 : l.collectionsStateMap;
  return {
    hasDataResolverValue: v,
    dataResolverValue: v ? d == null ? void 0 : d.getStyle()[g] : void 0,
    enableDataValue: p,
    initialDataValue: m,
    handleDataValueChange: (x) => {
      c.forEach((w) => {
        w.addStyle({ [g]: x });
      });
    },
    handleValueClear: () => {
      c.forEach((x) => {
        const w = x.getStyle()[g] ?? "";
        x.addStyle({ [g]: w });
      });
    },
    editor: o,
    additionalSources: b
  };
}
const ha = (e, t) => K0(e, t), $V = (e, t) => {
  const { label: n, ...r } = K0(e, t);
  return {
    ...r,
    label: n,
    hideButton: r.disabled,
    onOpen() {
      const o = e.em.Assets;
      o.open({
        select(i) {
          e.upValue(i.getSrc()), o.close();
        }
      });
    }
  };
}, DV = (e, { styleManagerDataConfig: t }) => {
  const n = e.getId();
  let r = vV;
  switch (n) {
    case "gs-layout":
      r = CV;
      break;
    case "gs-size":
      r = _V;
      break;
    case "gs-space":
      r = kV;
      break;
    case "gs-position":
      r = PV;
      break;
    case "gs-borders":
      r = bV;
      break;
    case "gs-effects":
      r = wV;
      break;
    case "gs-typography":
      r = TV;
      break;
    case "gs-background":
      r = HV;
      break;
  }
  return /* @__PURE__ */ u.jsx(r, { sector: e, styleManagerDataConfig: t });
}, e1 = {}, F5 = xe(function({
  className: t,
  sectors: n
}) {
  var v;
  const [r, o] = y.useState(e1), i = Re(), { editor: l } = i, c = l == null ? void 0 : l.Styles, d = c == null ? void 0 : c.getSelected(), p = l == null ? void 0 : l.getSelected();
  if (y.useEffect(() => {
    if (p && l) {
      const b = setTimeout(() => {
        let x = e1;
        const w = p.get("styleManager");
        Ct(w) && (x = w({ editor: l, component: p })), o(x || e1);
      });
      return () => clearTimeout(b);
    }
  }, [p, l]), !c || !d)
    return null;
  const g = n.length ? n : c.getSectors({ visible: !0 }), m = (v = i.sdkOptions.dataSources) == null ? void 0 : v.styleManager;
  return r.disabled ? null : /* @__PURE__ */ u.jsx("div", { className: ce(D5, t, "select-none"), children: g.map((b, x) => /* @__PURE__ */ u.jsx(
    ja,
    {
      classNameWrap: B(bp, `${bp}__${b.id}`),
      sticky: !0,
      handler: () => {
        const w = b.getProperties({ withValue: !0 }).length > 0, j = b.getProperties({ withParentValue: !0 }).length > 0;
        return /* @__PURE__ */ u.jsxs(G, { gap: "xs", items: "center", children: [
          /* @__PURE__ */ u.jsx(Y, { className: ce("gjs-mr-2"), children: b.getName() }),
          w && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx("div", { className: ce(nt.dot, ee.bgA2) }) }),
          j && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx("div", { className: ce(nt.dot, ee.bgW) }) })
        ] });
      },
      className: (w) => I5(w, x, x === g.length - 1),
      children: /* @__PURE__ */ u.jsx(G, { className: ce(MV, "gs-utl-p-2 gs-utl-gap-2"), col: !0, children: DV(b, { styleManagerDataConfig: m }) })
    },
    b.id
  )) });
});
var vi = /* @__PURE__ */ ((e) => (e.Image = "image", e.Gradient = "gradient", e.Color = "color", e))(vi || {});
const Qf = "background-image", Go = "__background-type", Zc = Qf, z5 = "https://placehold.co/150/777/white.png?text=IMAGE", gv = "50px", IV = {
  [Go]: "image",
  "background-image": `url("${z5}")`,
  "background-size": `${gv} ${gv}`,
  "background-repeat": "repeat",
  "background-position": "0px 0px"
}, VV = (e) => (e.includes("gradient(") ? $0(e).colorStops[0].color : e) || "";
function HV({ sector: e, styleManagerDataConfig: t }) {
  var E;
  const n = Ar(), r = e.getProperty("background"), o = r.getProperty(Go), i = r.getProperty("background-image"), l = r.getProperty("background-position"), c = r.getProperty("background-size"), d = e.getProperty("background-color"), p = e.getProperty("background-clip"), g = { sector: e, styleManagerDataConfig: t }, m = ((E = r.getSelectedLayer()) == null ? void 0 : E.getIndex()) || -1, v = o == null ? void 0 : o.getValue(), b = v === "image", x = i.getValue(), w = () => {
    const P = n.Assets;
    P.open({
      select(k) {
        const T = k.getSrc();
        i.upValue(`url("${T}")`), P.close();
      }
    });
  }, j = (P) => {
    let k = "none", T = "100%";
    P === "image" ? (k = `url("${z5}")`, T = gv) : P === "gradient" ? k = "linear-gradient(90deg, black 10%, white 90%)" : P === "color" && (k = "rgba(0, 0, 0, 0.5)"), i.upValue(k), o.upValue(P), l.upValue("0 0"), c.upValue(`${T} ${T}`);
  }, C = RV(o, [
    { id: "image", label: /* @__PURE__ */ u.jsx(ye, { icon: fe.image, size: Ee.s }) },
    { id: "gradient", label: /* @__PURE__ */ u.jsx(ye, { icon: fe.gradientVertical, size: Ee.s }) },
    { id: "color", label: /* @__PURE__ */ u.jsx(ye, { icon: fe.checkboxBlank, size: Ee.s }) }
  ]);
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(Ve, { property: r, separator: !0, children: /* @__PURE__ */ u.jsxs(
      Ho,
      {
        ...di(r, g, IV),
        previewStyle: (P) => r.getStyleFromLayer(P, { camelCase: !0 }),
        children: [
          /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(
            Kn,
            {
              ...Bo(o, g),
              options: C,
              onChange: j,
              label: void 0
            }
          ) }),
          /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsxs(ui, { children: [
            b && /* @__PURE__ */ u.jsx(vu, { value: eg(x).value, onOpen: w }),
            v === "color" && /* @__PURE__ */ u.jsx(
              Rs,
              {
                ...ha(i, g),
                value: VV(x),
                label: void 0
              }
            ),
            v === "gradient" && /* @__PURE__ */ u.jsx(
              CD,
              {
                value: x,
                onChange: (P, k) => i.upValue(P, { partial: k })
              },
              m
            )
          ] }) }),
          b && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsx(Ve, { col: !0, children: /* @__PURE__ */ u.jsx(ur, { property: l, ...g }) }),
            /* @__PURE__ */ u.jsx(Ve, { col: !0, children: /* @__PURE__ */ u.jsx(ur, { property: c, ...g }) }),
            /* @__PURE__ */ u.jsxs(Ve, { children: [
              /* @__PURE__ */ u.jsx(
                Ze,
                {
                  ...Jt(r.getProperty("background-repeat"), { sector: e })
                }
              ),
              /* @__PURE__ */ u.jsx(
                Ze,
                {
                  ...Jt(r.getProperty("background-attachment"), { sector: e })
                }
              )
            ] }),
            /* @__PURE__ */ u.jsx(Ve, { children: /* @__PURE__ */ u.jsx(
              Ze,
              {
                ...Jt(r.getProperty("background-origin"), { sector: e })
              }
            ) })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ u.jsx(Ve, { property: d, children: /* @__PURE__ */ u.jsx(Rs, { ...ha(d, g) }) }),
    /* @__PURE__ */ u.jsx(Ve, { property: p, children: /* @__PURE__ */ u.jsx(Ze, { ...Jt(p, g) }) })
  ] });
}
const kf = ["%"], Tf = ["s", "ms"], Ac = ["deg", "rad", "grad"], Do = ["px", "%", "em", "rem", "vw", "vh"], XS = {
  type: "select",
  options: ["visible", "hidden", "scroll", "auto"].map((e) => ({ id: e })),
  default: "visible"
}, FV = (e) => `linear-gradient(${e} 1%, ${e} 100%)`, xp = (e) => ({ id: e, label: e.split("-").map(Wo).join(" ") }), B5 = (e) => ({ property: t, to: n }) => {
  if (n.value) {
    const r = t.getOption(), o = t.getParent().getProperty(e), i = o.getUnit(), l = {
      units: r.units || [],
      min: r.min,
      max: r.max,
      unit: ""
    };
    (!i || (l == null ? void 0 : l.units.indexOf(i)) < 0) && (l.unit = (l == null ? void 0 : l.units[0]) || ""), o.up(l);
  }
}, zV = (e) => {
  const t = `${e}-name`, n = `${e}-value`;
  return (r, { separatorLayers: o }) => {
    const i = r[e] || "";
    return i ? i.split(o).map((l) => {
      const { name: c, value: d } = eg(l);
      return { [t]: c, [n]: d };
    }) : [];
  };
}, ZS = (e) => {
  const t = {
    [Zc]: e
  };
  if (e.indexOf("url(") > -1)
    t[Go] = vi.Image;
  else if (e.indexOf("gradient(") > -1) {
    const n = $0(e), r = n.colorStops, o = n.name.indexOf("linear") >= 0;
    r.length === 2 && o && r[0].color === r[1].color ? t[Go] = vi.Color : t[Go] = vi.Gradient;
  } else
    t[Go] = vi.Color, t[Zc] = FV(e);
  return t;
}, JS = (e = "filter") => {
  const t = `${e}-name`, n = `${e}-value`;
  return {
    property: e,
    type: "stack",
    layerSeparator: " ",
    fromStyle(r, { separatorLayers: o }) {
      const i = r[e] || "";
      return i ? i.split(o).map((l) => {
        const { name: c, value: d } = eg(l);
        return { [t]: c, [n]: d };
      }) : [];
    },
    toStyle(r, { name: o }) {
      return { [o]: `${r[t]}(${r[n] || "0"})` };
    },
    properties: [
      {
        property: t,
        type: "select",
        default: "blur",
        options: [
          { id: "blur", label: "Blur", min: 0, units: ["px", "em", "rem", "vw", "vh"] },
          { id: "brightness", label: "Brightness", min: 0, units: ["%"] },
          { id: "contrast", label: "Contrast", min: 0, units: ["%"] },
          { id: "grayscale", label: "Grayscale", min: 0, max: 100, units: ["%"] },
          { id: "hue-rotate", label: "Hue rotate", min: 0, max: 360, units: ["deg", "rad", "grad"] },
          { id: "invert", label: "Invert", min: 0, max: 100, units: ["%"] },
          { id: "saturate", label: "Saturate", min: 0, units: ["%"] },
          { id: "sepia", label: "Sepia", min: 0, max: 100, units: ["%"] }
        ],
        onChange: B5(n)
      },
      {
        property: n,
        type: "integer"
      }
    ]
  };
}, Of = (e, { x: t, y: n, mergable: r } = {}) => {
  const o = {
    property: `${e}-x`,
    type: "integer",
    units: Do,
    ...t
  }, i = {
    property: `${e}-y`,
    type: "integer",
    units: Do,
    ...n
  };
  return {
    property: e,
    type: "composite",
    properties: [o, i],
    ...r && {
      fromStyle(l, { name: c, separator: d, property: p }) {
        const [g, m] = p.getProperties(), [v, b] = (l[c] || "").split(d);
        return {
          [g.getId()]: l[g.getName()] || v || "",
          [m.getId()]: l[m.getName()] || b || v || ""
        };
      },
      toStyle(l, { name: c, property: d }) {
        const [p, g] = d.getProperties(), m = l[p.getId()], v = l[g.getId()];
        return {
          [c]: m === v ? m : `${m} ${v}`
        };
      }
    }
  };
}, BV = (e, t = "") => {
  const n = `${e}-name`, r = `${e}-value`;
  return (o, { name: i }) => ({ [i]: `${o[n]}(${o[r] || t})` });
}, UV = [
  {
    name: "Size",
    open: !1,
    buildProps: ["width", "height", "max-width", "min-height"],
    properties: [
      {
        property: "icon-size",
        type: "number",
        defaults: "20px",
        units: ["px", "%"]
      }
    ]
  },
  {
    name: "Space",
    open: !1,
    buildProps: ["margin", "padding", "vertical-align"],
    properties: [
      {
        property: "margin",
        properties: [
          { name: "Top", property: "margin-top" },
          { name: "Right", property: "margin-right" },
          { name: "Bottom", property: "margin-bottom" },
          { name: "Left", property: "margin-left" }
        ]
      },
      {
        property: "padding",
        properties: [
          { name: "Top", property: "padding-top" },
          { name: "Right", property: "padding-right" },
          { name: "Bottom", property: "padding-bottom" },
          { name: "Left", property: "padding-left" }
        ]
      },
      {
        property: "vertical-align",
        type: "select",
        options: ["top", "middle", "bottom"].map(xp)
      }
    ]
  },
  {
    name: "Typography",
    open: !1,
    buildProps: [
      "font-family",
      "font-size",
      "font-weight",
      "letter-spacing",
      "color",
      "line-height",
      "text-align",
      "align",
      "text-decoration",
      "font-style"
    ],
    properties: [
      { name: "Font", property: "font-family" },
      { name: "Weight", property: "font-weight" },
      { name: "Font color", property: "color" },
      {
        property: "text-align",
        defaults: "left",
        type: "select",
        options: [
          { id: "left", label: "Left" },
          { id: "center", label: "Center" },
          { id: "right", label: "Right" },
          { id: "justify", label: "Justify" }
        ]
      },
      {
        property: "align",
        defaults: "left",
        type: "select",
        options: [
          { id: "left", label: "Left" },
          { id: "center", label: "Center" },
          { id: "right", label: "Right" },
          { id: "justify", label: "Justify" }
        ]
      },
      {
        property: "text-decoration",
        type: "select",
        defaults: "none",
        options: [
          { id: "none", label: "None" },
          { id: "underline", label: "underline" },
          { id: "line-through", label: "Line-through" }
        ]
      },
      {
        property: "font-style",
        type: "select",
        defaults: "normal",
        options: [
          { id: "normal", label: "Normal" },
          { id: "italic", label: "Italic" }
        ]
      }
    ]
  },
  {
    name: "Borders",
    open: !1,
    buildProps: ["border-radius", "border"],
    properties: [
      {
        property: "border-radius",
        // @ts-ignore custom property for our UI
        corners: !0,
        properties: [
          { name: "Top", property: "border-top-left-radius" },
          { name: "Right", property: "border-top-right-radius" },
          { name: "Bottom", property: "border-bottom-left-radius" },
          { name: "Left", property: "border-bottom-right-radius" }
        ]
      },
      {
        property: "border",
        // @ts-ignore custom property for our UI
        generic: !0
      },
      {
        property: "border-detached",
        name: "Border",
        type: "composite",
        detached: !0,
        // @ts-ignore custom property for our UI
        generic: !0,
        properties: [
          { name: "Width", property: "border-width", type: "integer", units: ["px", "%"] },
          {
            name: "Style",
            property: "border-style",
            type: "select",
            options: ["none", "solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset"].map(
              xp
            )
          },
          { name: "Color", property: "border-color", type: "color" }
        ]
      }
    ]
  },
  {
    name: "Decorations",
    open: !1,
    buildProps: [
      "background-color",
      "container-background-color",
      "background-url",
      "background-repeat",
      "background-size"
    ],
    properties: [
      {
        name: "Background color",
        property: "container-background-color",
        full: !0,
        type: "color"
      },
      {
        property: "background-url",
        type: "file"
      }
    ]
  }
], WV = [
  {
    id: "gs-layout",
    name: "Layout",
    properties: [
      { extend: "display" },
      {
        extend: "flex-direction",
        name: "Direction",
        type: "radio",
        default: "row"
      },
      {
        extend: "justify-content",
        type: "radio",
        default: "flex-start"
      },
      {
        extend: "align-items",
        type: "radio",
        default: "stretch"
      },
      Of("gap", {
        x: { property: "row-gap", min: 0, default: "0" },
        y: { property: "column-gap", min: 0, default: "0" },
        mergable: !0
      }),
      { extend: "flex-wrap" },
      { extend: "align-content" },
      { extend: "align-self" },
      { extend: "order" },
      {
        property: "flex",
        type: "composite",
        // detached: true,
        properties: [
          {
            type: "integer",
            property: "flex-grow",
            default: "0",
            min: 0
          },
          {
            type: "integer",
            property: "flex-shrink",
            default: "0",
            min: 0
          },
          {
            type: "integer",
            property: "flex-basis",
            fixedValues: ["auto"],
            default: "auto",
            units: Do,
            min: 0
          }
        ]
      }
    ]
  },
  {
    id: "gs-size",
    name: "Size",
    properties: [
      { extend: "width" },
      { extend: "min-width" },
      { extend: "max-width" },
      { extend: "height" },
      { extend: "min-height" },
      { extend: "max-height" }
    ]
  },
  {
    id: "gs-space",
    name: "Space",
    properties: [
      {
        extend: "padding",
        detached: !0
      },
      {
        extend: "margin",
        detached: !0
      }
    ]
  },
  {
    id: "gs-position",
    name: "Position",
    properties: [
      {
        extend: "position",
        options: [
          { id: "static", label: "Static" },
          { id: "relative", label: "Relative" },
          { id: "absolute", label: "Absolute" },
          { id: "fixed", label: "Fixed" },
          { id: "sticky", label: "Sticky" }
        ],
        onChange({ opts: e, property: t }) {
          if (e.__clear) {
            const n = { top: "", right: "", bottom: "", left: "", "z-index": "" };
            t.__upTargetsStyle(n, e);
          }
        }
      },
      { extend: "top" },
      { extend: "right" },
      { extend: "bottom" },
      { extend: "left" },
      {
        extend: "z-index",
        type: "integer",
        default: "0"
      }
    ]
  },
  {
    id: "gs-typography",
    name: "Typography",
    properties: [
      { extend: "font-family" },
      { extend: "color" },
      { extend: "font-size" },
      { extend: "font-weight" },
      { extend: "line-height", min: 0 },
      { extend: "letter-spacing" },
      { extend: "text-align" },
      {
        property: "vertical-align",
        type: "select",
        default: "baseline",
        options: ["baseline", "top", "middle", "bottom"].map(xp)
      },
      {
        extend: "text-decoration",
        type: "select",
        default: "none",
        options: [
          { id: "none", label: "None" },
          { id: "underline", label: "Underline" },
          { id: "overline", label: "Overline" },
          { id: "line-through", label: "Line through" }
        ]
      },
      {
        extend: "text-transform",
        type: "select",
        default: "none",
        options: [
          { id: "none", label: "None" },
          { id: "capitalize", label: "Capitalize" },
          { id: "uppercase", label: "Uppercase" },
          { id: "lowercase", label: "Lowercase" }
        ]
      },
      {
        extend: "direction",
        type: "radio",
        default: "ltr",
        options: [
          { id: "ltr", label: "LTR" },
          { id: "rtl", label: "RTL" }
        ]
      },
      {
        extend: "white-space",
        type: "select",
        default: "normal",
        options: [
          { id: "normal", label: "Normal" },
          { id: "nowrap", label: "No wrap" },
          { id: "pre", label: "Pre" },
          { id: "pre-wrap", label: "Pre wrap" },
          { id: "pre-line", label: "Pre line" },
          { id: "break-spaces", label: "Break spaces" }
        ]
      }
      // text-overflow: ellipsis; white-space: nowrap; overflow: hidden;
      // List of default fonts: https://stackoverflow.com/a/62755574
      //  Safe webfonts: https://web.mit.edu/jmorzins/www/fonts.html#sans-serif
      //  List per platform: https://granneman.com/webdev/coding/css/fonts-and-formatting/default-fonts
    ]
  },
  {
    id: "gs-background",
    name: "Background",
    properties: [
      // Stack of backgrounds (Color - Gradient - Image/Patterns)
      {
        property: "background",
        type: "stack",
        layerSeparator: new RegExp("(?<!\\(.*[^)]),(?![^(]*\\))"),
        layerJoin: ", ",
        // 1. "simple" -> 1
        // 2. "simple, simple" -> 2
        // 3. "rgba(1px, 2px, 3px)" -> 1
        // 4. "rgba(1px, 2px, 3px), rgba(1px, 2px, 3px)" -> 2
        // 5. "rgba(1px, rgba(11px, 22px, 33px), 3px), rgba(1px, rgba(11px, 22px, 33px), 3px)" -> 2
        // 6. "rgba(1px, rgba(11px, 22px, 33px), 3px)" -> 1
        // 7a. "linear(rgb(1, 2, 3, 5), rgb(1, 2, 3, 5))" -> 1 || "/(?<!\(.*[^)]),(?![^(]*\))/"
        // 7b. "linear(rgb(1, 2, 3, 5) 1px, rgb(1, 2, 3, 5))" -> 1
        // /(?<!\(*[^)]),(?![^(]*\))/ > fails 2.
        // /(?<!\(.*[^)]),(?![^(]*\))/ > fails 7a.
        detached: !0,
        layerLabel: (e, { values: t, property: n }) => n.getProperty(Go).getOptionLabel(t[Go]),
        toStyle(e) {
          const t = e[Go];
          let n = e[Zc];
          return t === "color" && n.indexOf("linear-gradient") < 0 && (n = `linear-gradient(${n} 1%, ${n} 100%)`), {
            ...e,
            [Zc]: n
          };
        },
        fromStyle(e, { property: t, name: n, separatorLayers: r }) {
          const o = r, i = t.getProperties();
          let l = [];
          return e[Qf] ? (l = t.__splitStyleName(e, Qf, o).map(ZS), i.forEach((c) => {
            const d = c.getId(), p = c.getName();
            p !== Qf && t.__splitStyleName(e, p, o).map((g) => ({ [d]: g || c.getDefaultValue() })).forEach((g, m) => {
              l[m] = l[m] ? { ...l[m], ...g } : g;
            });
          })) : e[n] && (l = t.__splitStyleName(e, n, /(?![^)(]*\([^)(]*?\)\)),(?![^\(]*\))/).map((c) => c.substring(0, c.lastIndexOf(")") + 1)).map(ZS)), l;
        },
        properties: [
          {
            property: Go,
            type: "radio",
            default: "image",
            options: [{ id: vi.Image }, { id: vi.Gradient }, { id: vi.Color }]
          },
          {
            // Specs: https://www.w3.org/TR/css-images-3/
            // <url> | <gradient> (https://github.com/rafaelcaricio/gradient-parser)
            // <gradient> = <linear-gradient()> | <repeating-linear-gradient()> | <radial-gradient()> | <repeating-radial-gradient()>
            // <linear-gradient()> = linear-gradient([ <angle> | to <side-or-corner> ]? , <color-stop-list>)
            // <radial-gradient()> = radial-gradient([ <ending-shape> || <size> ]? [ at <position> ]? , <color-stop-list>
            //    radial-gradient(5em circle at top left, yellow, blue)
            // <color-stop-list> = <linear-color-stop> , [ <linear-color-hint>? , <linear-color-stop> ]
            //  fn(red 40%, white) | fn(white calc(-25px + 50%), blue)
            // Regex
            // <side-or-corner>: /^to (left (top|bottom)|right (top|bottom)|top (left|right)|bottom (left|right)|left|right|top|bottom)/i,
            // <ending-shape>: /^circle|ellipse/i,
            // <size>: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/, // | <length> | <length-percentage>{2}
            // <position>: /^at/ // position: at top left, at 20px, at 10% 15%
            property: Zc,
            default: "none"
            // url(), gradient, none
          },
          {
            property: "background-position",
            type: "composite",
            // default: '0%', // left | center | right | top | bottom
            properties: ["background-position-x", "background-position-y"].map((e) => ({
              type: "integer",
              property: e,
              units: Do,
              default: "0px"
            }))
          },
          {
            // Keyword: contain | cover; One-value syntax; Two-value syntax
            property: "background-size",
            type: "composite",
            properties: ["background-size-x", "background-size-y"].map((e) => ({
              type: "integer",
              property: e,
              units: Do,
              default: "auto"
            }))
          },
          {
            property: "background-repeat",
            // box (x, y)
            default: "repeat",
            type: "select",
            options: [
              // background-repeat-x background-repeat-x
              { id: "repeat", label: "Repeat" },
              { id: "repeat-x", label: "Repeat x" },
              { id: "repeat-y", label: "Repeat y" },
              { id: "no-repeat", label: "No repeat" },
              { id: "space", label: "Space" },
              { id: "round", label: "Round" }
            ]
          },
          {
            property: "background-attachment",
            default: "scroll",
            type: "select",
            options: [
              { id: "scroll", label: "Scroll" },
              { id: "fixed", label: "Fixed" }
            ]
          },
          {
            property: "background-origin",
            default: "padding-box",
            type: "select",
            options: [
              { id: "padding-box", label: "Padding box" },
              { id: "border-box", label: "Border box" },
              { id: "content-box", label: "Content box" }
            ]
          }
        ]
      },
      {
        property: "background-color",
        type: "color",
        default: "none"
      },
      {
        property: "background-clip",
        default: "border-box",
        type: "select",
        options: [
          { id: "border-box", label: "Border box" },
          { id: "padding-box", label: "Padding box" },
          { id: "content-box", label: "Content box" },
          { id: "text", label: "Text" }
        ],
        onChange({ to: e, property: t, opts: n }) {
          const { value: r } = e;
          if (r !== void 0) {
            const o = r === "text";
            t.__upTargetsStyle(
              {
                "-webkit-background-clip": o ? r : "",
                "-webkit-text-fill-color": o ? "transparent" : ""
              },
              n
            );
          }
        }
      }
    ]
  },
  {
    id: "gs-borders",
    name: "Borders",
    properties: [
      {
        extend: "border-radius",
        detached: !0
      },
      {
        extend: "border-width",
        type: "composite",
        detached: !0,
        properties: ["border-top-width", "border-right-width", "border-bottom-width", "border-left-width"].map(
          (e) => ({
            type: "integer",
            property: e,
            default: "0",
            units: Do
          })
        )
      },
      {
        extend: "border-style",
        type: "composite",
        detached: !0,
        properties: ["border-top-style", "border-right-style", "border-bottom-style", "border-left-style"].map(
          (e) => ({
            type: "select",
            property: e,
            default: "none",
            options: [
              { id: "none", label: "None" },
              { id: "solid", label: "Solid" },
              { id: "dotted", label: "Dotted" },
              { id: "dashed", label: "Dashed" },
              { id: "double", label: "Double" },
              { id: "groove", label: "Groove" },
              { id: "ridge", label: "Ridge" },
              { id: "inset", label: "Inset" },
              { id: "outset", label: "Outset" }
            ]
          })
        )
      },
      {
        extend: "border-color",
        type: "composite",
        detached: !0,
        properties: ["border-top-color", "border-right-color", "border-bottom-color", "border-left-color"].map(
          (e) => ({
            type: "color",
            property: e,
            default: "currentColor"
          })
        )
      }
    ]
  },
  {
    id: "gs-effects",
    name: "Effects",
    properties: [
      {
        property: "opacity",
        type: "integer",
        min: 0,
        max: 100,
        default: "100",
        units: ["%"]
      },
      {
        property: "mix-blend-mode",
        type: "select",
        default: "normal",
        options: [
          { id: "normal", label: "Normal" },
          { id: "multiply", label: "Multiply" },
          { id: "screen", label: "Screen" },
          { id: "overlay", label: "Overlay" },
          { id: "darken", label: "Darken" },
          { id: "lighten", label: "Lighten" },
          { id: "color-dodge", label: "Color dodge" },
          { id: "color-burn", label: "Color burn" },
          { id: "hard-light", label: "Hard light" },
          { id: "soft-light", label: "Soft light" },
          { id: "difference", label: "Difference" },
          { id: "exclusion", label: "Exclusion" },
          { id: "hue", label: "Hue" },
          { id: "saturation", label: "Saturation" },
          { id: "color", label: "Color" },
          { id: "luminosity", label: "Luminosity" }
        ]
      },
      { extend: "cursor" },
      Of("overflow", {
        x: XS,
        y: XS,
        mergable: !0
      }),
      {
        extend: "box-shadow",
        fromStyle(e, { separatorLayers: t }) {
          const n = e["box-shadow"] || "";
          return n ? n.split(t).map((o) => {
            const { x: i, y: l, blur: c, spread: d, inset: p, color: g } = wS(o);
            return {
              "box-shadow-h": i,
              "box-shadow-v": l,
              "box-shadow-blur": c,
              "box-shadow-spread": d,
              "box-shadow-color": g,
              "box-shadow-type": p ? "inset" : ""
            };
          }) : [];
        }
      },
      {
        extend: "text-shadow",
        fromStyle(e, { separatorLayers: t }) {
          const n = e["text-shadow"] || "";
          return n ? n.split(t).map((o) => {
            const { x: i, y: l, blur: c, color: d } = wS(o);
            return {
              "text-shadow-h": i,
              "text-shadow-v": l,
              "text-shadow-blur": c,
              "text-shadow-color": d
            };
          }) : [];
        }
      },
      JS(),
      JS("backdrop-filter"),
      {
        property: "transition",
        type: "stack",
        layerLabel: (e, { values: t }) => `${Wo(t["transition-property"])}: ${t["transition-duration"]}`,
        properties: [
          {
            property: "transition-property",
            type: "select",
            default: "opacity",
            options: [
              // Size
              "width",
              "height",
              "min-width",
              "min-height",
              "max-width",
              "max-height",
              // Layout
              "padding",
              "margin",
              // Typography
              "color",
              "font-size",
              "line-height",
              "letter-height",
              // Border
              "border",
              "border-radius",
              // 'border-color', 'border-width',
              // Background
              "background",
              // Effects
              "opacity",
              "box-shadow",
              "text-shadow",
              "filter",
              "backdrop-filter",
              "transform",
              // Extra
              "all"
            ].map(xp)
          },
          {
            property: "transition-duration",
            type: "integer",
            default: "1s",
            unit: Tf[0],
            units: Tf,
            min: 0
          },
          {
            property: "transition-timing-function",
            type: "select",
            default: "ease",
            options: [
              { id: "ease", label: "Ease" },
              { id: "ease-in", label: "Ease-In" },
              { id: "ease-in-out", label: "Ease-In-Out" },
              { id: "ease-out", label: "Ease-Out" },
              { id: "linear", label: "Linear" }
            ]
          },
          {
            property: "transition-delay",
            type: "integer",
            default: "0s",
            unit: Tf[0],
            units: Tf
          }
        ]
      },
      {
        property: "transform",
        type: "stack",
        layerSeparator: " ",
        layerLabel: (e, { values: t, property: n }) => {
          const r = n.getProperty("transform-name").getOptionLabel(t["transform-name"]);
          return `${Wo(r)}: ${t["transform-value"]}`;
        },
        fromStyle: zV("transform"),
        toStyle: BV("transform", "0"),
        properties: [
          {
            property: "transform-name",
            type: "select",
            default: "translateX",
            options: [
              { id: "translateX", label: "Move X", units: Do },
              { id: "translateY", label: "Move Y", units: Do },
              { id: "translateZ", label: "Move Z", units: Do },
              { id: "rotateX", label: "Rotate X", units: Ac },
              { id: "rotateY", label: "Rotate Y", units: Ac },
              { id: "rotateZ", label: "Rotate Z", units: Ac },
              { id: "scale", label: "Scale", units: kf },
              { id: "scaleX", label: "Scale X", units: kf },
              { id: "scaleY", label: "Scale Y", units: kf },
              { id: "scaleZ", label: "Scale Z", units: kf },
              { id: "skewX", label: "Skew X", units: Ac },
              { id: "skewY", label: "Skew Y", units: Ac }
            ],
            onChange: B5("transform-value")
          },
          {
            property: "transform-value",
            type: "integer",
            default: "0"
          }
        ]
      },
      Of("transform-origin", {
        x: { default: "50%" },
        y: { default: "50%" }
      }),
      {
        property: "backface-visibility",
        type: "radio",
        default: "visible",
        options: [
          { id: "visible", label: "Visible" },
          { id: "hidden", label: "Hidden" }
        ]
      },
      {
        // Activate on parent element to enable 3D transforms on all of its children
        property: "perspective",
        type: "integer",
        min: 0,
        default: "none",
        units: Do
      },
      Of("perspective-origin", {
        x: { default: "50%" },
        y: { default: "50%" }
      }),
      {
        property: "transform-style",
        type: "radio",
        default: "flat",
        options: [
          { id: "flat", label: "2D" },
          { id: "preserve-3d", label: "3D" }
        ]
      }
    ]
  }
], QS = [
  { id: "desktop", name: "Desktop", width: "" },
  { id: "mobilePortrait", name: "Mobile", width: "320px", widthMedia: "480px" }
];
function U5(e, t) {
  return [
    (n) => c7(n, t),
    ...l7[e],
    (n) => D7(n, t),
    o7(e, t)
  ];
}
function W5(e, t = {}) {
  var l;
  const n = e === Xe.email, { devices: r } = t, o = r ? {
    default: r.selected,
    devices: r.default ?? (n ? QS : void 0)
  } : n ? {
    devices: QS
  } : {}, i = {
    undoManager: { trackSelection: !1 },
    showOffsets: !0,
    cssIcons: "",
    assetManager: {},
    styleManager: {
      sectors: n ? UV : WV
    },
    parser: {
      optionsHtml: {
        convertDataGjsAttributesHyphens: !0
      }
    },
    selectorManager: {
      componentFirst: !0
    },
    i18n: {
      messagesAdd: au({ en: L$ }, ((l = t.i18n) == null ? void 0 : l.locales) ?? {})
    },
    deviceManager: o,
    canvasCss: `
      [contenteditable] { outline: 0px solid transparent;}
    `,
    canvas: {
      // infiniteCanvas: true,
      customSpots: {
        select: !0,
        hover: !0,
        spacing: !0,
        target: !0
        // resize: true,
      }
    },
    telemetry: !1
  };
  return au(i, t.gjsOptions ?? {});
}
class GV {
  constructor(t) {
    this.loadCounter = 0, this.pendingInstalled = [], this.pendingUninstalled = [], this.selectedShown = !1, this.store = t, Yn(this, {}, { autoBind: !0 });
  }
  get hasPending() {
    return !!this.pendingInstalled.length || !!this.pendingUninstalled.length;
  }
  *initProjectPlugins(t) {
    this.clearPending();
    const r = (yield cg()).filter((o) => o.projectType.includes(t));
    this.setProjectPlugins(r);
  }
  setProjectPlugins(t, n = {}) {
    this.projectPlugins = [...t], n.clearPending && this.clearPending();
  }
  clearPending() {
    this.pendingInstalled = [], this.pendingUninstalled = [];
  }
  getPluginsToLoad(t, n) {
    const r = [...U5(t, { appStore: n }), ...this.projectPlugins || []], o = n.sdkOptions.plugins || [];
    return Ct(o) ? o({ plugins: r }) : [...r, ...o];
  }
  addPendingInstalled(t) {
    const { pendingInstalled: n, pendingUninstalled: r } = this, o = t.id;
    r.includes(o) ? this.pendingUninstalled = r.filter((i) => i !== o) : n.includes(o) || n.push(o);
  }
  addPendingUninstalled(t) {
    const { pendingInstalled: n, pendingUninstalled: r } = this, o = t.id;
    n.includes(o) ? this.pendingInstalled = n.filter((i) => i !== o) : r.push(o);
  }
  setSelectedShown(t) {
    this.selectedShown = t;
  }
}
const q0 = { db: PE.gjsStudio }, cg = () => new Promise(async (e) => {
  let t = [];
  try {
    t = await g$(Dl.Settings, "plugins", q0) || [];
  } catch (n) {
    ns() && console.error(n);
  }
  e(t);
}), KV = (e, t = {}) => new Promise(async (n) => {
  try {
    const o = [...t.installed || await cg(), e];
    G5().addPendingInstalled(e), t.skipUpdateLocal || await _E(Dl.Settings, "plugins", o, q0);
  } catch (r) {
    console.error(r);
  }
  n();
}), qV = (e, t = {}) => new Promise(async (n) => {
  try {
    const o = (t.installed || await cg()).filter((i) => i.id !== e.id);
    G5().addPendingUninstalled(e), t.skipUpdateLocal || await _E(Dl.Settings, "plugins", o, q0);
  } catch (r) {
    console.error(r);
  }
  n();
}), Y0 = () => Nn().pluginStore, G5 = () => dg().pluginStore;
let wp;
const K5 = y.createContext(void 0);
class ug {
  constructor(t) {
    this.blockManagerStore = new w$(this), this.appEditorStore = new JV(this, t == null ? void 0 : t.appEditorStore), this.localSettingsStore = new k$(t == null ? void 0 : t.localSettingsStore), this.toastStore = new x$(this), this.modalStore = new O$(this), this.i18nStore = new i$(this), this.pluginStore = new GV(this), this.pointerBadgeStore = new u$(this), this.contextMenu = new k8(this), this.layoutStore = new l$(this), this.templatesStore = new b$(this), this.assetsStore = new o$(this), this.globalStylesStore = new E$(this), this.fontsStore = new s$(this), this.appEditorStore.init(), Rv() && (window.__gjss = this);
  }
}
const YV = (e) => {
  T$(e.localSettingsStore), eH(e.appEditorStore);
}, XV = ({ children: e, initialState: t }) => (wp = y.useMemo(() => {
  const n = new ug(t);
  return YV(n), n;
}, []), /* @__PURE__ */ u.jsx(K5.Provider, { value: wp, children: e })), Nn = () => {
  const e = y.useContext(K5);
  if (!e)
    throw new Error("useStore must be used inside of StoreProvider");
  return e;
}, dg = () => {
  if (!wp)
    throw new Error("Store has not been initialized");
  return wp;
}, Lf = ({
  icon: e,
  layout: t,
  tooltip: n,
  className: r,
  forceRemove: o,
  removeLayouts: i
}) => ({
  type: "button",
  icon: e,
  tooltip: n,
  className: r,
  size: "s",
  editorEvents: {
    [`${kr.layoutToggleId}${t.id}`]: ({ fromEvent: l, setState: c }) => {
      c({ active: l.isOpen });
    }
  },
  onClick: ({ editor: l }) => {
    i == null || i.forEach((c) => l.runCommand(ke.layoutRemove, { id: c, force: o })), l.runCommand(ke.layoutToggle, { ...t });
  }
}), e2 = { type: "static", layoutId: "leftPanelsContainer" }, t2 = { width: 240, overflow: "hidden" };
Lf({
  // icon: IconNames.plusBox,
  tooltip: "Blocks",
  removeLayouts: ["pagesLayers", "ps"],
  layout: {
    id: "blocks",
    layout: "panelBlocks",
    header: { label: "Blocks" },
    style: t2,
    placer: e2
  }
}), Lf({
  // icon: IconNames.layers,
  tooltip: "Pages & Layers",
  removeLayouts: ["blocks", "ps"],
  layout: {
    id: "pagesLayers",
    layout: "panelPagesLayers",
    header: !1,
    style: t2,
    placer: e2
  }
}), Lf({
  // icon: IconNames.cog,
  tooltip: "Page Settings",
  removeLayouts: ["pagesLayers", "blocks"],
  layout: {
    id: "ps",
    layout: "panelPageSettings",
    header: { label: "Page Settings" },
    style: { marginLeft: 40 }
  }
}), Lf({
  icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,10.11C13.03,10.11 13.87,10.95 13.87,12C13.87,13 13.03,13.85 12,13.85C10.97,13.85 10.13,13 10.13,12C10.13,10.95 10.97,10.11 12,10.11M7.37,20C8,20.38 9.38,19.8 10.97,18.3C10.45,17.71 9.94,17.07 9.46,16.4C8.64,16.32 7.83,16.2 7.06,16.04C6.55,18.18 6.74,19.65 7.37,20M8.08,14.26L7.79,13.75C7.68,14.04 7.57,14.33 7.5,14.61C7.77,14.67 8.07,14.72 8.38,14.77C8.28,14.6 8.18,14.43 8.08,14.26M14.62,13.5L15.43,12L14.62,10.5C14.32,9.97 14,9.5 13.71,9.03C13.17,9 12.6,9 12,9C11.4,9 10.83,9 10.29,9.03C10,9.5 9.68,9.97 9.38,10.5L8.57,12L9.38,13.5C9.68,14.03 10,14.5 10.29,14.97C10.83,15 11.4,15 12,15C12.6,15 13.17,15 13.71,14.97C14,14.5 14.32,14.03 14.62,13.5M12,6.78C11.81,7 11.61,7.23 11.41,7.5C11.61,7.5 11.8,7.5 12,7.5C12.2,7.5 12.39,7.5 12.59,7.5C12.39,7.23 12.19,7 12,6.78M12,17.22C12.19,17 12.39,16.77 12.59,16.5C12.39,16.5 12.2,16.5 12,16.5C11.8,16.5 11.61,16.5 11.41,16.5C11.61,16.77 11.81,17 12,17.22M16.62,4C16,3.62 14.62,4.2 13.03,5.7C13.55,6.29 14.06,6.93 14.54,7.6C15.36,7.68 16.17,7.8 16.94,7.96C17.45,5.82 17.26,4.35 16.62,4M15.92,9.74L16.21,10.25C16.32,9.96 16.43,9.67 16.5,9.39C16.23,9.33 15.93,9.28 15.62,9.23C15.72,9.4 15.82,9.57 15.92,9.74M17.37,2.69C18.84,3.53 19,5.74 18.38,8.32C20.92,9.07 22.75,10.31 22.75,12C22.75,13.69 20.92,14.93 18.38,15.68C19,18.26 18.84,20.47 17.37,21.31C15.91,22.15 13.92,21.19 12,19.36C10.08,21.19 8.09,22.15 6.62,21.31C5.16,20.47 5,18.26 5.62,15.68C3.08,14.93 1.25,13.69 1.25,12C1.25,10.31 3.08,9.07 5.62,8.32C5,5.74 5.16,3.53 6.62,2.69C8.09,1.85 10.08,2.81 12,4.64C13.92,2.81 15.91,1.85 17.37,2.69M17.08,12C17.42,12.75 17.72,13.5 17.97,14.26C20.07,13.63 21.25,12.73 21.25,12C21.25,11.27 20.07,10.37 17.97,9.74C17.72,10.5 17.42,11.25 17.08,12M6.92,12C6.58,11.25 6.28,10.5 6.03,9.74C3.93,10.37 2.75,11.27 2.75,12C2.75,12.73 3.93,13.63 6.03,14.26C6.28,13.5 6.58,12.75 6.92,12M15.92,14.26C15.82,14.43 15.72,14.6 15.62,14.77C15.93,14.72 16.23,14.67 16.5,14.61C16.43,14.33 16.32,14.04 16.21,13.75L15.92,14.26M13.03,18.3C14.62,19.8 16,20.38 16.62,20C17.26,19.65 17.45,18.18 16.94,16.04C16.17,16.2 15.36,16.32 14.54,16.4C14.06,17.07 13.55,17.71 13.03,18.3M8.08,9.74C8.18,9.57 8.28,9.4 8.38,9.23C8.07,9.28 7.77,9.33 7.5,9.39C7.57,9.67 7.68,9.96 7.79,10.25L8.08,9.74M10.97,5.7C9.38,4.2 8,3.62 7.37,4C6.74,4.35 6.55,5.82 7.06,7.96C7.83,7.8 8.64,7.68 9.46,7.6C9.94,6.93 10.45,6.29 10.97,5.7Z" /></svg>',
  tooltip: "Custom Component",
  className: "gs-utl-mt-auto",
  layout: {
    id: "customLayout",
    layout: { type: "custom", component: () => /* @__PURE__ */ u.jsx("div", { children: "Custom Reat component" }) },
    header: { label: "Custom" },
    style: { marginLeft: 40 }
  }
});
const ZV = {
  type: "row",
  style: { height: "100%" },
  children: [{ type: "sidebarLeft" }, { type: "canvasSidebarTop" }, { type: "sidebarRight" }]
};
class JV {
  constructor(t, n) {
    this.projectType = Xe.web, this.editor = void 0, this.sdkProps = {}, this.sdkLicenseError = "", this.licenseCheckRetry = 0, this.showPoweredBy = !1, this.isInPreview = !1, this.isCssPanelActive = !1, this.isLeftSidebarOpen = !0, this.isRightSidebarOpen = !0, this.isTopSidebarOpen = !0, this.isBottomSidebarOpen = !0, this.isSelectingTarget = !1, this.leftSidebarSize = 240, this.rightSidebarSize = 240, this.transitionTime = 152, this.topBarSize = 36, this.isDev = !1, this.isStage = !1, this.editorKey = 0, this.appInstalled = !1, this.licenseKey = "", this.licenseCheckStarted = !1, this.studioSdkVersion = "1.0.56", this.projectDataCustom = {}, this.displayMode = "browser", this.projectPlugins = [], this.queryParams = {}, this.isCanvasPanning = !1, this.selectedDesignerTab = "style", this.customAssets = void 0, this.nextProjectData = void 0, this.isDraggingAbsolute = !1, this.isSaving = !1, this.isReady = !1, this.sdkPagesConfigUpdates = 0, this.panelPageSettings = {
      isOpen: !1,
      width: 300,
      page: void 0
    }, this.rootElWidth = 0, this._projectId = "", this.store = t, n && Object.keys(n).forEach((o) => {
      const i = o, l = n[i];
      l !== void 0 && (this[i] = l);
    });
    const r = ns() ? window.location.search : "";
    this.queryParams = jO(r), Yn(
      this,
      {
        sdkProps: !1
      },
      { autoBind: !0 }
    );
  }
  get baseApiUrl() {
    const { isDev: t, isStage: n } = this;
    return mO({ isDev: t, isStage: n });
  }
  get projectId() {
    var r, o;
    const { project: t, storage: n } = this.sdkOptions;
    return this._projectId || ((o = (r = (n == null ? void 0 : n.project) || (t == null ? void 0 : t.default)) == null ? void 0 : r.custom) == null ? void 0 : o.id) || "";
  }
  get projectIdToLoad() {
    return this.store.localSettingsStore.lastProjectId || this.projectId;
  }
  get currentProjectId() {
    return this.projectDataCustom.id || this.projectId;
  }
  get isBrowserMode() {
    return this.displayMode === "browser";
  }
  get sdkOptions() {
    return this.sdkProps.options;
  }
  get sdkProjectId() {
    var t, n;
    return (n = (t = this.sdkOptions.project) == null ? void 0 : t.id) == null ? void 0 : n.toString();
  }
  get sdkIdentityId() {
    var t, n;
    return (n = (t = this.sdkOptions.identity) == null ? void 0 : t.id) == null ? void 0 : n.toString();
  }
  get sdkPagesConfig() {
    return this.sdkPagesConfigUpdates, this.sdkOptions.pages;
  }
  get sdkLayoutConfig() {
    return this.sdkOptions.layout;
  }
  get sdkComponentsConfig() {
    return this.sdkOptions.components;
  }
  get sdkGlobalStylesConfig() {
    return this.sdkOptions.globalStyles;
  }
  get currentLayout() {
    const { sdkLayoutConfig: t, rootElWidth: n, store: r } = this, { customConfig: o } = r.layoutStore, i = (o == null ? void 0 : o.responsive) || (t == null ? void 0 : t.responsive);
    let l = (o == null ? void 0 : o.default) || (t == null ? void 0 : t.default) || ZV;
    if (n && i) {
      const d = Object.keys(i).map(Number).sort((p, g) => p - g).find((p) => n <= p);
      l = d ? i[d] : l;
    }
    return l;
  }
  get sdkCustomIcons() {
    var t;
    return (t = this.sdkOptions.customTheme) == null ? void 0 : t.icons;
  }
  get isProjectTypeEmail() {
    return this.projectType === Xe.email;
  }
  get showPages() {
    return this.isReady && this.sdkPagesConfig !== !1 && !this.isProjectTypeEmail;
  }
  get showSelectors() {
    return !this.isProjectTypeEmail;
  }
  get sdkMisconfigurationError() {
    if (this.store.assetsStore.isUsingAssetCloud || this.isUsingProjectCloud) {
      const n = this.sdkProjectId, r = this.sdkIdentityId;
      if (!n || !r)
        return 'SDK Misconfiguration Error: When using assets.storageType == "cloud" or storage.type === "cloud", project.id and identity.id are required.';
    }
    return "";
  }
  get isUsingProjectSelfHosted() {
    var t;
    return ((t = this.sdkOptions.storage) == null ? void 0 : t.type) === W1.self;
  }
  get isUsingProjectCloud() {
    var t;
    return ((t = this.sdkOptions.storage) == null ? void 0 : t.type) === W1.cloud;
  }
  get publicStateTheme() {
    const { theme: t, resolvedTheme: n } = this.store.localSettingsStore;
    return {
      theme: t,
      resolvedTheme: n
    };
  }
  setPublicStateTheme(t) {
    t.theme !== void 0 && (this.store.localSettingsStore.theme = t.theme);
  }
  *init() {
    var m, v;
    const { store: t, sdkOptions: n } = this, { lastProjectId: r, lastProjectType: o } = t.localSettingsStore, i = (m = n.project) == null ? void 0 : m.default, { project: l } = n.storage || {};
    let c, d;
    o && (this.store.templatesStore._projectTypeFilter = o), r && (c = (v = (yield kE(o)).find((x) => x.id === r)) == null ? void 0 : v.data), c ? d = c : l ? d = l : i && (d = i);
    const p = (d == null ? void 0 : d.custom) || {}, g = p.projectType;
    g && (this.projectType = g), p.projectType = this.projectType, this.setProjectDataCustom({ ...p, id: this.projectIdToLoad }), yield t.pluginStore.initProjectPlugins(this.projectType), this.editorKey++;
  }
  setInstallEvent(t) {
    this.installEvent = t;
  }
  setAppInstalled(t) {
    this.appInstalled = t;
  }
  setDisplayMode(t) {
    this.displayMode = t;
  }
  setProject(t) {
    const n = this.editor, { id: r, data: o, isTemplate: i } = t, l = n.Storage.getConfig().options.local, c = i ? `${r}__${CO()}` : r;
    this._projectId = c, l.key = c, SO(o) || this.loadProjectData({
      ...o,
      custom: {
        ...o.custom,
        id: c,
        projectType: this.store.templatesStore.projectTypeFilter
      }
    });
  }
  setProjectDataCustom(t) {
    const n = {
      ...this.projectDataCustom,
      ...t
    };
    this.projectDataCustom = n, this.projectType = n.projectType || Xe.web, this.editor && n$(this.editor, n), n.id && this.store.localSettingsStore.setLocalState({
      lastProjectId: n.id,
      lastProjectType: this.projectType
    });
  }
  /**
   * Load new GrapesJS JSON (eg. from .grapesjs file)
   */
  loadProjectData(t) {
    const n = t.custom || {};
    if (QV(t) !== this.projectType)
      this.setNextProjectData(t), this.setProjectDataCustom(n), this.updateStudio();
    else {
      const r = this.editor;
      r.loadProjectData(t), r.UndoManager.clear(), this.setProjectDataCustom(n);
    }
  }
  setNextProjectData(t) {
    this.nextProjectData = t;
  }
  setLeftSidebarSize(t) {
    this.leftSidebarSize = t;
  }
  setRightSidebarSize(t) {
    this.rightSidebarSize = t;
  }
  setEditor(t) {
    this.editor = t;
  }
  setPreview(t) {
    this.isInPreview = t;
  }
  toggleCssPanel() {
    this.isCssPanelActive = !this.isCssPanelActive;
  }
  toggleLeftSidebar() {
    this.isLeftSidebarOpen = !this.isLeftSidebarOpen, this.refreshEditorPostTransition();
  }
  setLeftSidebarOpen(t) {
    this.isLeftSidebarOpen = t, this.refreshEditorPostTransition();
  }
  toggleRightSidebar() {
    this.isRightSidebarOpen = !this.isRightSidebarOpen, this.refreshEditorPostTransition();
  }
  setRightSidebarOpen(t) {
    this.isRightSidebarOpen = t, this.refreshEditorPostTransition();
  }
  setTopSidebarOpen(t) {
    this.isTopSidebarOpen = t, this.refreshEditorPostTransition();
  }
  setBottomSidebarOpen(t) {
    this.isBottomSidebarOpen = t, this.refreshEditorPostTransition();
  }
  refreshEditorPostTransition() {
    setTimeout(() => {
      var t;
      return (t = this.editor) == null ? void 0 : t.refresh();
    }, this.transitionTime);
  }
  setCanvasPanning(t) {
    this.isCanvasPanning = t;
  }
  setSelectingTarget(t) {
    this.isSelectingTarget = t;
  }
  setSelectedDesignerTab(t) {
    this.selectedDesignerTab = t;
  }
  setCustomAssets(t) {
    this.customAssets = t;
  }
  setIsDraggingAbsolute(t) {
    this.isDraggingAbsolute = t;
  }
  setIsSaving(t) {
    this.isSaving = t;
  }
  setIsReady(t) {
    this.isReady = t;
  }
  setPanelPageSettings(t) {
    this.panelPageSettings = {
      ...this.panelPageSettings,
      ...t
    };
  }
  setSdkPagesConfig(t) {
    this.sdkProps.options.pages = t && {
      ...this.sdkPagesConfig,
      ...t
    }, ++this.sdkPagesConfigUpdates;
  }
  setRootElWidth(t) {
    this.rootElWidth = t, this.refreshEditorCanvas();
  }
  *loadLicense() {
    const { editor: t } = this;
    try {
      this.licenseCheckStarted = !0;
      const { licenseKey: n, baseApiUrl: r, studioSdkVersion: o } = this;
      t == null || t.trigger(sO, { baseApiUrl: r });
      const i = yield ts.post(`${r}/sdk/${n || "na"}`, {
        params: { d: window.location.hostname, v: o }
      });
      if (i instanceof Error)
        throw i;
      const l = i.result || {}, { license: c, error: d, plan: p } = l;
      d ? this.sdkLicenseError = d : (this.sdkLicense = c, p != null && p.poweredBy && (this.showPoweredBy = !0)), t == null || t.trigger(lw, l);
    } catch (n) {
      this.licenseCheckRetry < 3 ? (this.licenseCheckRetry++, setTimeout(() => this.loadLicense(), 3e3)) : (console.error(n), this.showPoweredBy = !0, t == null || t.trigger(lw, {}));
    }
  }
  *updateStudio() {
    const { pluginStore: t } = this.store, { projectType: n } = this.projectDataCustom;
    yield t.initProjectPlugins(n), this.editorKey++;
  }
  refreshStudio() {
    var t;
    this.editorKey && (this.setNextProjectData((t = this.editor) == null ? void 0 : t.getProjectData()), this.store.layoutStore.clear(), this.editorKey++);
  }
  refreshEditorCanvas() {
    var t;
    (t = this.editor) == null || t.refresh({ tools: !0 });
  }
}
const QV = (e) => {
  var t;
  return ((t = e.custom) == null ? void 0 : t.projectType) || Xe.web;
}, eH = (e) => {
  Hj(
    () => e.currentLayout,
    () => e.refreshStudio()
  );
}, Re = () => Nn().appEditorStore, tH = () => {
  try {
    return Re();
  } catch {
  }
}, Jc = () => dg().appEditorStore, nH = () => {
  try {
    return dg().appEditorStore;
  } catch {
  }
}, fg = () => {
  const [e, t] = y.useState(0), n = Nn().appEditorStore, { transitionTime: r } = n;
  return y.useEffect(() => {
    setTimeout(() => t((o) => ++o), r);
  }, [r]), [e];
}, rH = {
  light: {
    colors: {
      global: {
        background1: "rgba(244, 244, 244, 1)",
        background2: "rgba(253, 253, 253, 1)",
        background3: "rgba(255, 255, 255, 1)",
        backgroundHover: "rgba(244, 244, 244, 1)",
        text: "rgba(24, 24, 24, 1)",
        border: "rgba(210, 210, 210, 1)",
        focus: "rgba(195, 180, 253, 80%)",
        placeholder: "rgba(163, 163, 163, 1)"
      },
      primary: {
        background1: "rgba(137.09, 90.27, 246.33, 1)",
        background3: "rgba(242.25, 239.7, 255, 1)",
        backgroundHover: "rgba(89.86, 33.2, 181, 1)",
        text: "rgba(255, 255, 255, 1)"
      },
      component: {
        background1: "rgba(31.87, 127.5, 223.12, 1)",
        background2: "rgba(121.12, 178.5, 235.87, 1)",
        background3: "rgba(210.37, 229.5, 248.62, 1)",
        text: "rgba(255, 255, 255, 1)"
      },
      selector: {
        background1: "rgba(129.28, 23.71, 65.94, 1)",
        background2: "rgba(250.92, 208.08, 225.22, 1)",
        text: "rgba(255, 255, 255, 1)"
      },
      symbol: {
        background1: "rgba(137.09, 90.27, 246.33, 1)",
        background2: "rgba(221.68, 215.22, 253.98, 1)",
        background3: "rgba(242.25, 239.7, 255, 1)",
        text: "rgba(255, 255, 255, 1)"
      }
    }
  },
  dark: {
    colors: {
      global: {
        background1: "rgba(63, 63, 63, 1)",
        background2: "rgba(39, 39, 39, 1)",
        background3: "rgba(24, 24, 24, 1)",
        backgroundHover: "rgba(55, 55, 55, 1)",
        text: "rgba(163, 163, 163, 1)",
        border: "rgba(63, 63, 63, 1)",
        focus: "rgba(194.95, 180.41, 253.09, 0.8)",
        placeholder: "rgba(163, 163, 163, 1)"
      },
      primary: {
        background1: "rgba(137.09, 90.27, 246.33, 1)",
        background3: "rgba(39, 39, 39, 1)",
        backgroundHover: "rgba(89.86, 33.2, 181, 1)",
        text: "rgba(255, 255, 255, 1)"
      },
      component: {
        background1: "rgba(50.06, 135.15, 220.24, 1)",
        background2: "rgba(6.89, 87.44, 130.82, 1)",
        background3: "rgba(31.21, 41.33, 55.49, 1)",
        text: "rgba(255, 255, 255, 1)"
      },
      selector: {
        background1: "rgba(129.28, 23.71, 65.94, 1)",
        background2: "rgba(250.92, 208.08, 225.22, 1)",
        text: "rgba(255, 255, 255, 1)"
      },
      symbol: {
        background1: "rgba(137.09, 90.27, 246.33, 1)",
        background2: "rgba(89.86, 33.2, 181, 1)",
        background3: "rgba(44.61, 27.03, 74.97, 1)",
        text: "rgba(255, 255, 255, 1)"
      }
    }
  }
}, q5 = String.raw, mt = (e, t) => {
  if (t == null)
    return "";
  const n = e[0], r = e[1];
  return `${n}${t}${r}`;
}, oH = (e, t = "") => {
  var n, r, o, i, l, c, d, p, g, m, v, b, x, w, j, C, E, P, k, T, O, A, $, N, R, z, D, Z, K, H, q, te, I, F, V, L, W, ie, re, le, me, oe, se, de, we, je, He, Le, ot, vt, zt, Ot, ct, vn, St, At, en, Bt, Et, it, Lt, Ut, yn, Bn, Zn, Jn;
  return q5`
  ${t}.${dt.txt} {
    ${mt`color: ${(r = (n = e.colors) == null ? void 0 : n.global) == null ? void 0 : r.text};`}
  }

  ${t}.${dt.bg} {
    ${mt`background-color: ${(i = (o = e.colors) == null ? void 0 : o.global) == null ? void 0 : i.background3};`}
  }

  ${t}.${dt.br} {
    ${mt`border-color: ${(c = (l = e.colors) == null ? void 0 : l.global) == null ? void 0 : c.border};`}
  }

  ${t}.${dt.bgA} {
    ${mt`background-color: ${(p = (d = e.colors) == null ? void 0 : d.primary) == null ? void 0 : p.background1};`}
    ${mt`color: ${(m = (g = e.colors) == null ? void 0 : g.primary) == null ? void 0 : m.text};`}
  }

  ${t}.${dt.bgA2} {
    ${mt`background-color: ${(b = (v = e.colors) == null ? void 0 : v.primary) == null ? void 0 : b.background1};`}
    ${mt`color: ${(w = (x = e.colors) == null ? void 0 : x.primary) == null ? void 0 : w.text};`}
  }

  ${t}.${dt.hBgAct}:hover.${dt.hBgAct}:hover,
  ${t}.${dt.hBgA2}:hover.${dt.hBgA2}:hover {
    ${mt`background-color: ${(C = (j = e.colors) == null ? void 0 : j.primary) == null ? void 0 : C.backgroundHover};`}
  }

  ${t}.${dt.tA} {
    ${mt`color: ${(P = (E = e.colors) == null ? void 0 : E.primary) == null ? void 0 : P.background1};`}
  }

  ${t}.${dt.tAo} {
    ${mt`color: ${(T = (k = e.colors) == null ? void 0 : k.primary) == null ? void 0 : T.background1};`}
  }

  ${t}.${dt.hTAo}:hover.${dt.hTAo}:hover,
  ${t}.group:hover .${dt.grouphTAo} {
    ${mt`color: ${(A = (O = e.colors) == null ? void 0 : O.primary) == null ? void 0 : A.backgroundHover};`}
  }

  ${t}.${dt.bA} {
    ${mt`border-color: ${(N = ($ = e.colors) == null ? void 0 : $.primary) == null ? void 0 : N.background1};`}
  }

  ${t}.${dt.bg0} {
    ${mt`background-color: ${(z = (R = e.colors) == null ? void 0 : R.primary) == null ? void 0 : z.background3};`}
    ${mt`color: ${(Z = (D = e.colors) == null ? void 0 : D.primary) == null ? void 0 : Z.background1};`}
  }

  ${t}.${dt.bgH} {
    ${mt`background-color: ${(H = (K = e.colors) == null ? void 0 : K.global) == null ? void 0 : H.background1};`}
  }

  ${t}.${dt.bgH2} {
    ${mt`background-color: ${(te = (q = e.colors) == null ? void 0 : q.global) == null ? void 0 : te.background2};`}
  }

  ${t}.${dt.hBgH}:hover,
  ${t}.${dt.hBgH2}:hover {
    ${mt`background-color: ${(F = (I = e.colors) == null ? void 0 : I.global) == null ? void 0 : F.backgroundHover};`}
  }

  ${t}.${dt.sel} {
    ${mt`background-color: ${(L = (V = e.colors) == null ? void 0 : V.selector) == null ? void 0 : L.background2};`}
    ${mt`color: ${(ie = (W = e.colors) == null ? void 0 : W.selector) == null ? void 0 : ie.text};`}
  }

  ${t}.${dt.selBr} {
    ${mt`border-color: ${(le = (re = e.colors) == null ? void 0 : re.selector) == null ? void 0 : le.background1};`}
  }

  ${t}.${dt.cmp} {
    ${mt`background-color: ${(oe = (me = e.colors) == null ? void 0 : me.component) == null ? void 0 : oe.background1};`}
    ${mt`color: ${(de = (se = e.colors) == null ? void 0 : se.component) == null ? void 0 : de.text};`}
  }

  ${t}.${dt.cmpBgSoft} {
    ${mt`background-color: ${(je = (we = e.colors) == null ? void 0 : we.component) == null ? void 0 : je.background2};`}
  }

  ${t}.${dt.cmpBgSoftX} {
    ${mt`background-color: ${(Le = (He = e.colors) == null ? void 0 : He.component) == null ? void 0 : Le.background3};`}
  }

  ${t}.${dt.cmpBr} {
    ${mt`border-color: ${(vt = (ot = e.colors) == null ? void 0 : ot.component) == null ? void 0 : vt.background1};`}
  }

  ${t}.${dt.cmpSymbol} {
    ${mt`background-color: ${(Ot = (zt = e.colors) == null ? void 0 : zt.symbol) == null ? void 0 : Ot.background1};`}
    ${mt`color: ${(vn = (ct = e.colors) == null ? void 0 : ct.symbol) == null ? void 0 : vn.text};`}
  }

  ${t}.${dt.cmpBgSymbolSoft} {
    ${mt`background-color: ${(At = (St = e.colors) == null ? void 0 : St.symbol) == null ? void 0 : At.background2};`}
  }

  ${t}.${dt.cmpBgSymbolSoftX} {
    ${mt`background-color: ${(Bt = (en = e.colors) == null ? void 0 : en.symbol) == null ? void 0 : Bt.background3};`}
  }

  ${t}.${dt.cmpSymbolBr} {
    ${mt`border-color: ${(it = (Et = e.colors) == null ? void 0 : Et.symbol) == null ? void 0 : it.background1};`}
  }

  ${t}.${dt.cmpTxtActive} {
    ${mt`color: ${(Ut = (Lt = e.colors) == null ? void 0 : Lt.component) == null ? void 0 : Ut.text};`}
  }

  ${t}.${dt.focus}:focus-visible {
    ${mt`box-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) ${(Bn = (yn = e.colors) == null ? void 0 : yn.global) == null ? void 0 : Bn.focus};`}
  }

  ${t}.${dt.inputText}::placeholder {
    ${mt`color: ${(Jn = (Zn = e.colors) == null ? void 0 : Zn.global) == null ? void 0 : Jn.placeholder};`}
  }
`;
}, sH = (e) => {
  var l, c, d, p, g;
  const t = (l = e.colors) == null ? void 0 : l.global, n = (c = e.colors) == null ? void 0 : c.primary, r = (d = e.colors) == null ? void 0 : d.component, o = (p = e.colors) == null ? void 0 : p.symbol, i = (g = e.colors) == null ? void 0 : g.selector;
  return `
  :root {
    --gs-theme-cl-glb-bg1: ${t == null ? void 0 : t.background1};
    --gs-theme-cl-glb-bg2: ${t == null ? void 0 : t.background2};
    --gs-theme-cl-glb-bg3: ${t == null ? void 0 : t.background3};
    --gs-theme-cl-glb-bgh: ${t == null ? void 0 : t.backgroundHover};
    --gs-theme-cl-glb-br: ${t == null ? void 0 : t.border};
    --gs-theme-cl-glb-fcs: ${t == null ? void 0 : t.focus};
    --gs-theme-cl-glb-plh: ${t == null ? void 0 : t.placeholder};
    --gs-theme-cl-glb-txt: ${t == null ? void 0 : t.text};
    --gs-theme-cl-prm-bg1: ${n == null ? void 0 : n.background1};
    --gs-theme-cl-prm-bg2: ${n == null ? void 0 : n.background2};
    --gs-theme-cl-prm-bg3: ${n == null ? void 0 : n.background3};
    --gs-theme-cl-prm-bgh: ${n == null ? void 0 : n.backgroundHover};
    --gs-theme-cl-prm-txt: ${n == null ? void 0 : n.text};
    --gs-theme-cl-cmp-bg1: ${r == null ? void 0 : r.background1};
    --gs-theme-cl-cmp-bg2: ${r == null ? void 0 : r.background2};
    --gs-theme-cl-cmp-bg3: ${r == null ? void 0 : r.background3};
    --gs-theme-cl-cmp-bgh: ${r == null ? void 0 : r.backgroundHover};
    --gs-theme-cl-cmp-txt: ${r == null ? void 0 : r.text};
    --gs-theme-cl-symb-bg1: ${o == null ? void 0 : o.background1};
    --gs-theme-cl-symb-bg2: ${o == null ? void 0 : o.background2};
    --gs-theme-cl-symb-bg3: ${o == null ? void 0 : o.background3};
    --gs-theme-cl-symb-bgh: ${o == null ? void 0 : o.backgroundHover};
    --gs-theme-cl-symb-txt: ${o == null ? void 0 : o.text};
    --gs-theme-cl-sel-bg1: ${i == null ? void 0 : i.background1};
    --gs-theme-cl-sel-bg2: ${i == null ? void 0 : i.background2};
    --gs-theme-cl-sel-bg3: ${i == null ? void 0 : i.background3};
    --gs-theme-cl-sel-bgh: ${i == null ? void 0 : i.backgroundHover};
    --gs-theme-cl-sel-txt: ${i == null ? void 0 : i.text};
  }
`;
}, iH = () => {
  const { sdkOptions: e, publicStateTheme: t } = Re(), [n, r] = y.useState(""), { customTheme: o } = e, { resolvedTheme: i } = t, l = e.theme === xo.light, c = o == null ? void 0 : o.default, d = y.useMemo(() => {
    const m = rH[i], v = au(au({}, m || {}), c || {});
    return sH(v).trim();
  }, [i]), p = q5`
    ${c ? oH(c, l ? `:not(.gs-utl-${xo.dark}) ` : `.gs-utl-${xo.dark} `) : ""}
  `.trim(), g = `
    ${d}
    ${p}
  `.trim();
  return y.useEffect(() => {
    r(g);
  }, [g]), /* @__PURE__ */ u.jsx("style", { "data-gs-editor-theme": !0, children: n });
}, aH = xe(iH), lH = xe(function() {
  const t = w0(), { isOpen: n, items: r, coordinates: o } = t, { x: i, y: l } = o;
  return y.useEffect(() => {
    const c = window.document, d = (p) => p.key === "Escape" && t.hide();
    return c.addEventListener("keydown", d), () => {
      c.removeEventListener("keydown", d);
    };
  }, []), /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(vE, { open: n, items: r, x: i, y: l }),
    n && /* @__PURE__ */ u.jsx("div", { onClick: t.hide, className: ge("z-10 fixed inset-0") })
  ] });
});
function dn({ children: e, label: t, s: n = "m", pill: r, border: o, nopad: i, className: l, block: c, ...d }) {
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: B(
        !c && "gs-utl-inline-block",
        l,
        !i && tt.xyS2,
        r ? ve.pill : ve.rnd,
        o && `${ve.b} ${ee.br}`,
        n === "s" && "gs-utl-text-sm",
        n === "xs" && "gs-utl-p-1"
      ),
      ...d,
      children: t || e
    }
  );
}
const n2 = 15, cH = xe(function() {
  const { isActive: t, content: n } = EE(), [r, o] = y.useState({ x: 0, y: 0 });
  y.useEffect(() => {
    const l = (c) => {
      o({ x: c.clientX, y: Math.max(0, c.clientY) });
    };
    return t && window.addEventListener("pointermove", l), () => {
      window.removeEventListener("pointermove", l);
    };
  }, [t]);
  const i = y.useMemo(
    () => ({
      transform: `translate(${r.x + n2}px, ${r.y + n2}px)`
    }),
    [r]
  );
  return /* @__PURE__ */ u.jsx(Xo, { show: t, ...Au, children: /* @__PURE__ */ u.jsx("div", { className: ge("fixed top-0 left-0 pointer-badge pointer-events-none z-10"), style: i, children: /* @__PURE__ */ u.jsx(dn, { className: ge("gjs-px-4 gjs-py-2", ee.bgBlur, ee.txtHighEmphasis), pill: !0, border: !0, nopad: !0, children: n }) }) });
}), uH = xe(function() {
  const t = OE();
  return /* @__PURE__ */ u.jsx(
    $8,
    {
      className: ce("fixed top-5 right-5 z-20"),
      toasts: t.toasts,
      onDismiss: t.remove
    }
  );
}), t1 = typeof window < "u" ? window.location.hostname : "";
t1 || // [::1] is the IPv6 localhost address.
t1 === "[::1]" || // 127.0.0.0/8 are considered localhost for IPv4.
t1.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/);
function dH(e) {
  if (
    // ({"NODE_ENV":"production","NPM_PACKAGE_VERSION":"1.0.0","STUDIO_NPM_PACKAGE_VERSION":"1.0.56"}).NODE_ENV === 'production' &&
    "serviceWorker" in navigator
  ) {
    if (new URL({ NODE_ENV: "production", NPM_PACKAGE_VERSION: "1.0.0", STUDIO_NPM_PACKAGE_VERSION: "1.0.56" }.PUBLIC_URL || "", window.location.href).origin !== window.location.origin)
      return;
    window.addEventListener("beforeinstallprompt", (o) => {
      o.preventDefault(), Jc().setInstallEvent(o);
    }), window.addEventListener("appinstalled", () => {
      Jc().setAppInstalled(!0);
    }), navigator.serviceWorker.addEventListener("controllerchange", () => {
    });
    const n = (o) => {
      let i = "browser";
      const l = navigator.standalone || document.referrer.startsWith("android-app://");
      (o || l) && (i = "standalone"), Jc().setDisplayMode(i);
    }, r = window.matchMedia("(display-mode: standalone)");
    r.addEventListener("change", (o) => n(o.matches)), n(r.matches);
  }
}
const fH = y.forwardRef(function({ children: t }, n) {
  const [r, o] = y.useState(""), i = gr(), l = y.useRef(null), c = Re(), {
    style: d,
    className: p,
    options: g = jv,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onUpdate: m,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onEditor: v,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onReady: b,
    ...x
  } = c.sdkProps, { autoHeight: w = !0, serviceWorker: j } = g;
  y.useImperativeHandle(n, () => l.current, []);
  const C = y.useMemo(
    () => ({
      ...d,
      height: r || (d == null ? void 0 : d.height) || ""
    }),
    [d, r]
  );
  return y.useEffect(() => {
    const E = l.current, P = () => {
      var O;
      return (O = E == null ? void 0 : E.parentElement) == null ? void 0 : O.offsetHeight;
    }, k = P(), T = () => {
      const O = E.style.position;
      E.style.position = "absolute";
      const A = P();
      A && o(`${A}px`), E.style.position = O;
    };
    if (k && w)
      return o(`${k}px`), window.addEventListener("resize", T), () => window.removeEventListener("resize", T);
  }, [w, l.current]), y.useEffect(() => {
    const E = l.current;
    if (!E)
      return;
    i.rootEl || i.setRootEl(E), i.init();
    const P = new ResizeObserver(() => {
      c.setRootElWidth(E.offsetWidth);
    });
    return c.setRootElWidth(E.offsetWidth), P.observe(E), () => {
      P.disconnect();
    };
  }, [l.current]), y.useEffect(() => {
    j && dH();
  }, []), /* @__PURE__ */ u.jsxs(
    "div",
    {
      ref: l,
      className: B(ge(nC, "gs-studio-editor overflow-hidden h-full w-full text-base"), p),
      style: C,
      ...x,
      children: [
        /* @__PURE__ */ u.jsx(aH, {}),
        t,
        /* @__PURE__ */ u.jsxs("div", { className: ge("gs-studio-els", ee.txt), children: [
          /* @__PURE__ */ u.jsx(uH, {}),
          /* @__PURE__ */ u.jsx(cH, {}),
          /* @__PURE__ */ u.jsx(lH, {})
        ] })
      ]
    }
  );
});
var Ic = /* @__PURE__ */ ((e) => (e.REGULAR = "regular", e.SYMBOLS = "symbols", e))(Ic || {});
const Mf = "gs-cmp-tabs";
function Ds({
  tabs: e,
  className: t,
  classNamePanel: n,
  classNameTab: r,
  variant: o,
  style: i,
  onChange: l = bO,
  value: c
}) {
  const d = o === "pills", p = d ? B("gs-utl-rounded-full gs-utl-text-sm gs-utl-px-[2px] gs-utl-py-[2px]", ee.bgH) : "", g = (w) => d ? B("gs-utl-rounded-full gs-utl-px-3 gs-utl-py-1", w ? ee.bg : "") : B("gs-utl-border-b-2", tt.xy), m = (w) => {
    w && (w.tabIndex = -1);
  }, v = (w) => {
    const j = w.currentTarget;
    setTimeout(() => j.blur(), 10);
  }, b = Rn(c) ? e.findIndex((w) => w.id === c) : void 0, x = !e.some((w) => !!w.content);
  return /* @__PURE__ */ u.jsxs(
    Oc.Group,
    {
      onChange: (w) => l(e[w].id),
      defaultIndex: e.findIndex((w) => w.id === c),
      selectedIndex: b,
      children: [
        /* @__PURE__ */ u.jsx(Oc.List, { as: G, className: B(Mf, t, p), style: i, full: !0, nowrap: !0, children: e.map((w) => /* @__PURE__ */ u.jsx(
          Oc,
          {
            disabled: w.disabled,
            className: ({ selected: j }) => B(
              `${Mf}__tab`,
              "gs-utl-flex-1 focus:gs-utl-outline-none",
              w.disabled && "gs-utl-cursor-not-allowed gs-utl-opacity-50",
              lu.focus,
              g(j),
              j ? `${ee.tAo} ${ee.bA}` : ee.br,
              r
            ),
            children: w.label
          },
          w.id
        )) }),
        /* @__PURE__ */ u.jsx(
          Oc.Panels,
          {
            className: B(
              `${Mf}__panels`,
              "gs-utl-overflow-hidden gs-utl-flex-1",
              x && "gs-utl-hidden",
              n
            ),
            children: e.map((w) => /* @__PURE__ */ u.jsx(
              Oc.Panel,
              {
                tabIndex: -1,
                className: B(`${Mf}__panel`, "gs-utl-h-full"),
                ref: m,
                onFocus: v,
                children: w.content
              },
              w.id
            ))
          }
        )
      ]
    }
  );
}
const pH = "gs-cmp-button-group-field", gH = y.memo(
  xe(function({
    className: t,
    label: n,
    name: r,
    value: o,
    options: i,
    size: l,
    required: c,
    disabled: d,
    onChange: p,
    editorEvents: g
  }) {
    const { editor: m } = Re(), [v, b] = y.useState(() => ({
      className: t,
      label: n,
      name: r,
      value: o,
      options: i,
      size: l,
      required: c,
      disabled: d
    })), x = (w) => {
      p({
        value: w,
        editor: m,
        state: v,
        setState: (j) => b((C) => ({ ...C, ...j }))
      });
    };
    return Ul({
      editor: m,
      editorEvents: g,
      localState: v,
      setLocalState: b
    }), /* @__PURE__ */ u.jsx(
      Kn,
      {
        className: B(pH, v.className),
        label: v.label,
        name: v.name,
        value: v.value,
        options: v.options ?? [],
        size: v.size,
        required: v.required,
        disabled: v.disabled,
        onChange: x
      }
    );
  })
);
function pg({ colors: e, ...t }) {
  return e ? /* @__PURE__ */ u.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 79 79", ...t, children: [
    /* @__PURE__ */ u.jsx("path", { fill: "url(#a)", d: "M39.6 77.1a37.5 37.5 0 1 0 0-75 37.5 37.5 0 0 0 0 75Z" }),
    /* @__PURE__ */ u.jsx(
      "path",
      {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "5",
        d: "m40 19-14.58 8.79a6.36 6.36 0 0 0-2.82 5.33v14.13a6.14 6.14 0 0 0 3.12 5.13l11.21 5.8a6.12 6.12 0 0 0 6.14 0l11.41-6.3a6.09 6.09 0 0 0 3.12-5.13V33.12c0-1.28-1.4-2.07-2.52-1.48l-15.08 8"
      }
    ),
    /* @__PURE__ */ u.jsx("defs", { children: /* @__PURE__ */ u.jsxs("linearGradient", { id: "a", x1: "2.1", x2: "77.2", y1: "39.6", y2: "39.6", gradientUnits: "userSpaceOnUse", children: [
      /* @__PURE__ */ u.jsx("stop", { stopColor: "#D7709E" }),
      /* @__PURE__ */ u.jsx("stop", { offset: "1", stopColor: "#A84A87" })
    ] }) })
  ] }) : /* @__PURE__ */ u.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 76 76", ...t, children: /* @__PURE__ */ u.jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M64.117 64.117a37.5 37.5 0 1 1-53.034-53.034 37.5 37.5 0 0 1 53.034 53.034ZM39.29 19.14a2.5 2.5 0 1 0-2.582-4.282l-14.583 8.79-.05.03-.047.032a8.861 8.861 0 0 0-2.917 3.229 8.729 8.729 0 0 0-1.011 4.203V45.293l.002.047a8.64 8.64 0 0 0 1.25 4.164 8.78 8.78 0 0 0 3.115 3.043l.05.03.053.027 11.165 5.769a8.62 8.62 0 0 0 4.264 1.127c1.507 0 2.99-.394 4.295-1.145l11.394-6.276.006-.004a8.585 8.585 0 0 0 3.178-3.05 8.443 8.443 0 0 0 1.227-4.225V31.123c0-3.265-3.502-5.122-6.19-3.688l-.005.003-15.076 7.995a2.5 2.5 0 0 0 2.342 4.418l13.93-7.387v12.263a3.444 3.444 0 0 1-.502 1.703 3.584 3.584 0 0 1-1.326 1.271l-.003.002-11.409 6.284-.024.014-.023.013a3.619 3.619 0 0 1-1.814.486 3.62 3.62 0 0 1-1.814-.486l-.052-.03-.054-.028-11.155-5.764a3.78 3.78 0 0 1-1.297-1.283 3.642 3.642 0 0 1-.527-1.715V31.081a3.73 3.73 0 0 1 .432-1.806 3.858 3.858 0 0 1 1.23-1.377L39.29 19.14Z",
      clipRule: "evenodd"
    }
  ) });
}
const hH = y.memo(
  xe(function() {
    const { isStage: e, updateStudio: t } = Re(), { isDarkTheme: n } = gr(), r = y.useRef(null), { bg: o, text: i } = hC(n);
    return uE({
      ref: r,
      show: e,
      update: n,
      reload: t,
      styles: {
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        bottom: "0",
        right: "0",
        left: "0"
      },
      node: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        /* @__PURE__ */ u.jsx("style", { children: `
              .gs-banner {
                  box-shadow: 0 0 5px #1c1b1b21;
                  padding: 30px 10px;
                  border-radius: 10px;
                  margin: 5px;
                  font-size: 30px;
                  background-color: ${o};
                  color: ${i};
                  width: 95%;
              }
              .gs-banner-row {
                  justify-content: center;
                  align-items: center;
                  display: flex;
                  gap: 10px;
              }
              .gs-gs-logo {
                  width: 35px;
              }
            ` }),
        /* @__PURE__ */ u.jsx(pr, { className: "gs-banner", children: /* @__PURE__ */ u.jsxs(G, { className: "gs-banner-row", children: [
          /* @__PURE__ */ u.jsx(pg, { className: "gs-gs-logo", colors: !0 }),
          /* @__PURE__ */ u.jsx("div", { children: "GrapesJS Studio Demo!" })
        ] }) })
      ] })
    }), /* @__PURE__ */ u.jsx("div", { ref: r });
  })
), mH = () => `https://grapesjs.com?ref=${window.location.host}`, vH = y.memo(
  xe(function() {
    const { updateStudio: e, showPoweredBy: t } = Re(), { isDarkTheme: n } = gr(), r = y.useRef(null), { bg: o, text: i, link: l } = hC(n);
    return uE({
      ref: r,
      show: t,
      update: n,
      reload: e,
      styles: {
        display: "flex",
        justifyContent: "center",
        position: "absolute",
        bottom: "0",
        left: "0"
      },
      node: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        /* @__PURE__ */ u.jsx("style", { children: `
              .gs-banner {
                  box-shadow: 0 0 5px #1c1b1b21;
                  padding: 5px 10px;
                  border-radius: 9999px;
                  margin: 5px;
                  font-size: 12px;
                  background-color: ${o};
                  color: ${i};
              }
              .gs-banner-row {
                  justify-content: center;
                  align-items: center;
                  display: flex;
                  gap: 3px;
              }
              .gs-link {
                  color: ${l};
                  text-decoration: none;
              }
              .gs-logo {
                  width: 20px;
              }
             ` }),
        /* @__PURE__ */ u.jsx(pr, { className: "gs-banner", children: /* @__PURE__ */ u.jsxs(G, { className: "gs-banner-row", children: [
          /* @__PURE__ */ u.jsx("a", { className: "gs-link", href: mH(), target: "_blank", children: "GrapesJS Studio" }),
          /* @__PURE__ */ u.jsx(pg, { className: "gs-logo", colors: !0 })
        ] }) })
      ] })
    }), /* @__PURE__ */ u.jsx("div", { ref: r });
  })
), Ju = Q.forwardRef(function({ full: t, abs: n, small: r, className: o, bg: i }, l) {
  const c = B(t && "gs-utl-w-full gs-utl-h-full", n ? nt.coverAbs : "gs-utl-relative", o), d = B(
    r ? "gs-utl-w-5 gs-utl-h-5" : "gs-utl-w-10 gs-utl-h-10",
    "gs-utl-animate-spin-fast",
    "!gs-utl-border-y-transparent !gs-utl-border-r-transparent",
    ve.pill,
    ve.bS,
    ve.bA
  );
  return /* @__PURE__ */ u.jsxs(G, { ref: l, className: c, items: "center", justify: "center", children: [
    !!i && /* @__PURE__ */ u.jsx("div", { className: B(nt.coverAbs, ee.bg, nt.disabled) }),
    /* @__PURE__ */ u.jsx("div", { className: d })
  ] });
}), r2 = "gs-canvas-content", yH = y.memo(
  xe(function() {
    const { isReady: t } = Re(), n = B(`${r2}__overlay gs-utl-pointer-events-none gs-utl-absolute gs-utl-inset-0`, ee.bgH2);
    return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsxs("div", { className: r2, children: [
        /* @__PURE__ */ u.jsx("div", { className: n }),
        !t && /* @__PURE__ */ u.jsx(Ju, { className: B("gs-utl-z-10"), abs: !0, full: !0 })
      ] }),
      /* @__PURE__ */ u.jsx(hH, {}),
      /* @__PURE__ */ u.jsx(vH, {})
    ] });
  })
), bH = "gs-canvas", Y5 = y.memo(function({ className: t, style: n, grow: r }) {
  return /* @__PURE__ */ u.jsx(LD, { style: n, className: B(bH, "gs-utl-relative", r && "gs-utl-flex-grow", t), children: /* @__PURE__ */ u.jsx(Sa, { children: /* @__PURE__ */ u.jsx(yH, {}) }) });
}), gg = ({
  className: e,
  grow: t,
  alignItems: n,
  justifyContent: r
}) => B(
  e,
  ee.br,
  t && "gs-utl-flex-grow",
  n === "start" && "gs-utl-items-start",
  n === "end" && "gs-utl-items-end",
  n === "center" && "gs-utl-items-center",
  n === "baseline" && "gs-utl-items-baseline",
  n === "stretch" && "gs-utl-items-stretch",
  r === "start" && "gs-utl-justify-start",
  r === "end" && "gs-utl-justify-end",
  r === "center" && "gs-utl-justify-center",
  r === "between" && "gs-utl-justify-between",
  r === "around" && "gs-utl-justify-around",
  r === "evenly" && "gs-utl-justify-evenly"
), hg = ({
  style: e,
  width: t,
  height: n,
  gap: r
}) => ({
  height: n,
  gap: r,
  width: t,
  ...e
}), Rr = y.memo(
  xe(function({
    id: t,
    children: n,
    className: r,
    style: o,
    width: i,
    gap: l,
    height: c,
    grow: d,
    alignItems: p,
    justifyContent: g,
    htmlAttrs: m,
    ...v
  }) {
    const { layoutsById: b } = k0(), [x, w] = y.useState({}), { className: j, style: C, ...E } = m || {}, P = r ?? j, k = o ?? C, T = y.useMemo(
      () => hg({
        height: c,
        gap: l,
        width: i,
        style: k
      }),
      [k, i, c, l]
    ), O = gg({ className: P, grow: d, alignItems: p, justifyContent: g });
    y.useEffect(() => {
      if (t)
        return b.set(t, { state: x, setState: w }), () => {
          b.delete(t);
        };
    }, [b, x]);
    const A = v.as ?? "div";
    return /* @__PURE__ */ u.jsx(A, { style: T, className: O, ...v, ...E, children: x.children ?? n });
  })
), X0 = (() => {
  if (typeof self > "u")
    return !1;
  if ("top" in self && self !== top)
    try {
      top.window.document._ = 0;
    } catch {
      return !1;
    }
  return "showOpenFilePicker" in self;
})(), xH = X0 ? Promise.resolve().then(function() {
  return PH;
}) : Promise.resolve().then(function() {
  return MH;
});
async function wH(...e) {
  return (await xH).default(...e);
}
X0 ? Promise.resolve().then(function() {
  return kH;
}) : Promise.resolve().then(function() {
  return RH;
});
const SH = X0 ? Promise.resolve().then(function() {
  return OH;
}) : Promise.resolve().then(function() {
  return $H;
});
async function jH(...e) {
  return (await SH).default(...e);
}
const CH = async (e) => {
  const t = await e.getFile();
  return t.handle = e, t;
};
var EH = async (e = [{}]) => {
  Array.isArray(e) || (e = [e]);
  const t = [];
  e.forEach((o, i) => {
    t[i] = { description: o.description || "Files", accept: {} }, o.mimeTypes ? o.mimeTypes.map((l) => {
      t[i].accept[l] = o.extensions || [];
    }) : t[i].accept["*/*"] = o.extensions || [];
  });
  const n = await window.showOpenFilePicker({ id: e[0].id, startIn: e[0].startIn, types: t, multiple: e[0].multiple || !1, excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1 }), r = await Promise.all(n.map(CH));
  return e[0].multiple ? r : r[0];
}, PH = { __proto__: null, default: EH };
function ep(e) {
  function t(n) {
    if (Object(n) !== n)
      return Promise.reject(new TypeError(n + " is not an object."));
    var r = n.done;
    return Promise.resolve(n.value).then(function(o) {
      return { value: o, done: r };
    });
  }
  return ep = function(n) {
    this.s = n, this.n = n.next;
  }, ep.prototype = { s: null, n: null, next: function() {
    return t(this.n.apply(this.s, arguments));
  }, return: function(n) {
    var r = this.s.return;
    return r === void 0 ? Promise.resolve({ value: n, done: !0 }) : t(r.apply(this.s, arguments));
  }, throw: function(n) {
    var r = this.s.return;
    return r === void 0 ? Promise.reject(n) : t(r.apply(this.s, arguments));
  } }, new ep(e);
}
const X5 = async (e, t, n = e.name, r) => {
  const o = [], i = [];
  var l, c = !1, d = !1;
  try {
    for (var p, g = function(m) {
      var v, b, x, w = 2;
      for (typeof Symbol < "u" && (b = Symbol.asyncIterator, x = Symbol.iterator); w--; ) {
        if (b && (v = m[b]) != null)
          return v.call(m);
        if (x && (v = m[x]) != null)
          return new ep(v.call(m));
        b = "@@asyncIterator", x = "@@iterator";
      }
      throw new TypeError("Object is not async iterable");
    }(e.values()); c = !(p = await g.next()).done; c = !1) {
      const m = p.value, v = `${n}/${m.name}`;
      m.kind === "file" ? i.push(m.getFile().then((b) => (b.directoryHandle = e, b.handle = m, Object.defineProperty(b, "webkitRelativePath", { configurable: !0, enumerable: !0, get: () => v })))) : m.kind !== "directory" || !t || r && r(m) || o.push(X5(m, t, v, r));
    }
  } catch (m) {
    d = !0, l = m;
  } finally {
    try {
      c && g.return != null && await g.return();
    } finally {
      if (d)
        throw l;
    }
  }
  return [...(await Promise.all(o)).flat(), ...await Promise.all(i)];
};
var _H = async (e = {}) => {
  e.recursive = e.recursive || !1, e.mode = e.mode || "read";
  const t = await window.showDirectoryPicker({ id: e.id, startIn: e.startIn, mode: e.mode });
  return (await (await t.values()).next()).done ? [t] : X5(t, e.recursive, void 0, e.skipDirectory);
}, kH = { __proto__: null, default: _H }, TH = async (e, t = [{}], n = null, r = !1, o = null) => {
  Array.isArray(t) || (t = [t]), t[0].fileName = t[0].fileName || "Untitled";
  const i = [];
  let l = null;
  if (e instanceof Blob && e.type ? l = e.type : e.headers && e.headers.get("content-type") && (l = e.headers.get("content-type")), t.forEach((p, g) => {
    i[g] = { description: p.description || "Files", accept: {} }, p.mimeTypes ? (g === 0 && l && p.mimeTypes.push(l), p.mimeTypes.map((m) => {
      i[g].accept[m] = p.extensions || [];
    })) : l ? i[g].accept[l] = p.extensions || [] : i[g].accept["*/*"] = p.extensions || [];
  }), n)
    try {
      await n.getFile();
    } catch (p) {
      if (n = null, r)
        throw p;
    }
  const c = n || await window.showSaveFilePicker({ suggestedName: t[0].fileName, id: t[0].id, startIn: t[0].startIn, types: i, excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1 });
  !n && o && o(c);
  const d = await c.createWritable();
  return "stream" in e ? (await e.stream().pipeTo(d), c) : "body" in e ? (await e.body.pipeTo(d), c) : (await d.write(await e), await d.close(), c);
}, OH = { __proto__: null, default: TH }, LH = async (e = [{}]) => (Array.isArray(e) || (e = [e]), new Promise((t, n) => {
  const r = document.createElement("input");
  r.type = "file";
  const o = [...e.map((d) => d.mimeTypes || []), ...e.map((d) => d.extensions || [])].join();
  r.multiple = e[0].multiple || !1, r.accept = o || "", r.style.display = "none", document.body.append(r);
  const i = (d) => {
    typeof l == "function" && l(), t(d);
  }, l = e[0].legacySetup && e[0].legacySetup(i, () => l(n), r), c = () => {
    window.removeEventListener("focus", c), r.remove();
  };
  r.addEventListener("click", () => {
    window.addEventListener("focus", c);
  }), r.addEventListener("change", () => {
    window.removeEventListener("focus", c), r.remove(), i(r.multiple ? Array.from(r.files) : r.files[0]);
  }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
})), MH = { __proto__: null, default: LH }, AH = async (e = [{}]) => (Array.isArray(e) || (e = [e]), e[0].recursive = e[0].recursive || !1, new Promise((t, n) => {
  const r = document.createElement("input");
  r.type = "file", r.webkitdirectory = !0;
  const o = (l) => {
    typeof i == "function" && i(), t(l);
  }, i = e[0].legacySetup && e[0].legacySetup(o, () => i(n), r);
  r.addEventListener("change", () => {
    let l = Array.from(r.files);
    e[0].recursive ? e[0].recursive && e[0].skipDirectory && (l = l.filter((c) => c.webkitRelativePath.split("/").every((d) => !e[0].skipDirectory({ name: d, kind: "directory" })))) : l = l.filter((c) => c.webkitRelativePath.split("/").length === 2), o(l);
  }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
})), RH = { __proto__: null, default: AH }, NH = async (e, t = {}) => {
  Array.isArray(t) && (t = t[0]);
  const n = document.createElement("a");
  let r = e;
  "body" in e && (r = await async function(l, c) {
    const d = l.getReader(), p = new ReadableStream({ start: (v) => async function b() {
      return d.read().then(({ done: x, value: w }) => {
        if (!x)
          return v.enqueue(w), b();
        v.close();
      });
    }() }), g = new Response(p), m = await g.blob();
    return d.releaseLock(), new Blob([m], { type: c });
  }(e.body, e.headers.get("content-type"))), n.download = t.fileName || "Untitled", n.href = URL.createObjectURL(await r);
  const o = () => {
    typeof i == "function" && i();
  }, i = t.legacySetup && t.legacySetup(o, () => i(), n);
  return n.addEventListener("click", () => {
    setTimeout(() => URL.revokeObjectURL(n.href), 3e4), o();
  }), n.click(), null;
}, $H = { __proto__: null, default: NH };
const DH = { NODE_ENV: "production", NPM_PACKAGE_VERSION: "1.0.0", STUDIO_NPM_PACKAGE_VERSION: "1.0.56" }.REACT_APP_VERSION ?? "1.0.0", IH = xe(function() {
  var n;
  const t = (n = window.grapesjs) == null ? void 0 : n.version;
  return /* @__PURE__ */ u.jsxs(G, { col: !0, space: "m", children: [
    /* @__PURE__ */ u.jsx(G, { justify: "center", children: /* @__PURE__ */ u.jsxs(Y, { className: ge("relative"), children: [
      /* @__PURE__ */ u.jsx(pg, { className: ge("w-24 opacity-50") }),
      t && /* @__PURE__ */ u.jsx(dn, { className: ge(ee.bgA, "absolute gs-utl-right-[-20px] bottom-0"), label: `v${t}`, s: "s", pill: !0 })
    ] }) }),
    /* @__PURE__ */ u.jsxs(Y, { children: [
      /* @__PURE__ */ u.jsxs("p", { children: [
        /* @__PURE__ */ u.jsx("b", { children: "GrapesJS Studio" }),
        " is an innovative experimental editor, initially created to improve and extend the customization capability of the",
        " ",
        /* @__PURE__ */ u.jsx("a", { className: ge(wl.link), href: "https://grapesjs.com", children: "GrapesJS" }),
        " ",
        "library. Beyond pushing the evolution of the core library itself, this application aspires to empower individuals in creating and managing their web projects autonomously, free from subscriptions or dependency on the internet connection."
      ] }),
      /* @__PURE__ */ u.jsx("br", {}),
      /* @__PURE__ */ u.jsxs("p", { children: [
        "If you like the vision of this project and you're eager to play a role in its continued development, consider becoming a backer or sponsor through",
        " ",
        /* @__PURE__ */ u.jsx("a", { className: ge(wl.link), href: "https://opencollective.com/grapesjs", children: "Open Collective" }),
        "."
      ] })
    ] }),
    /* @__PURE__ */ u.jsxs(Y, { className: ge(ee.txtLowEmphasis, "text-right"), children: [
      "GrapesJS Studio: v",
      DH
    ] })
  ] });
}), VH = xe(function() {
  return /* @__PURE__ */ u.jsxs(G, { col: !0, space: "m", children: [
    /* @__PURE__ */ u.jsx(G, { justify: "center", children: /* @__PURE__ */ u.jsx(Y, { className: ce("relative"), children: /* @__PURE__ */ u.jsx(pg, { className: ce("w-24 opacity-50") }) }) }),
    /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsxs("p", { children: [
      "We're excited to introduce the GrapesJS Studio SDK, an embeddable version of the Studio editor.",
      /* @__PURE__ */ u.jsx("br", {}),
      /* @__PURE__ */ u.jsx("br", {}),
      "The Studio SDK offers a powerful and flexible web editing experience that can be seamlessly integrated into your platform as a white-label editor. This enables your users to effortlessly create and manage content with advanced tools.",
      /* @__PURE__ */ u.jsx("br", {}),
      /* @__PURE__ */ u.jsx("br", {}),
      "You can try the initial release of the Studio SDK by creating a license and following the instructions on the",
      " ",
      /* @__PURE__ */ u.jsx("a", { className: ce(wl.link), href: "/dashboard/sdk/licenses", target: "_blank", children: "Studio SDK license page" }),
      /* @__PURE__ */ u.jsx("br", {}),
      /* @__PURE__ */ u.jsx("br", {}),
      "If you have any questions or need assistance with specific use cases, please fill out this",
      " ",
      /* @__PURE__ */ u.jsx("a", { className: ce(wl.link), href: "https://forms.gle/VUycp3rc8iCpbh9k8", target: "_blank", rel: "noreferrer", children: "form" }),
      " ",
      "and we'll get back to you as soon as possible."
    ] }) })
  ] });
});
function Z5({ onCopy: e, getValue: t, value: n, title: r = "Copy", ...o }) {
  const [i, l] = y.useState(!1), c = () => {
    lO((t == null ? void 0 : t()) ?? n), l(!0), e == null || e();
  };
  return y.useEffect(() => {
    if (!i)
      return;
    const d = setTimeout(() => l(!1), 3e3);
    return () => clearTimeout(d);
  }, [i]), /* @__PURE__ */ u.jsx(Qt, { onClick: c, title: r, type: "button", size: "lg", withBg: !0, ...o, children: /* @__PURE__ */ u.jsx(
    ye,
    {
      className: ge(i && ee.tA),
      icon: i ? fe.check : fe.contentCopy,
      size: Ee.s
    }
  ) });
}
function Z0(e) {
  return e = e.trimStart(), e = e.replace(/\s*([\{\}\:\;\,])\s*/g, "$1"), e = e.replace(/;\s*;/g, ";"), e = e.replace(/\,[\s\.\#\d]*{/g, "{"), e = e.replace(/([^\s])\{([^\s])/g, `$1 {
	$2`), e = e.replace(/([^\s])\}([^\n]*)/g, `$1
}
$2`), e = e.replace(/([^\s]);([^\s\}])/g, `$1;
	$2`), e;
}
const J5 = xe(function() {
  const t = Ar(), n = qe(), { Styles: r } = t, { isDarkTheme: o } = gr(), i = r.getSelected(), [l, c] = y.useState(0), d = i ? Z0(i == null ? void 0 : i.toCSS({ allowEmpty: !0 })) : "", [p, g] = y.useState(d);
  y.useEffect(() => {
    const v = () => c((x) => ++x), b = r.events.custom;
    return t.on(b, v), () => {
      t.off(b, v);
    };
  }, [r, t]);
  const m = () => {
    if (p) {
      const v = t.Parser.parseCss(p)[0];
      v && (i == null || i.setStyle(v.style));
    }
  };
  return /* @__PURE__ */ u.jsxs(G, { className: ce("relative"), col: !0, full: !0, children: [
    /* @__PURE__ */ u.jsx(Y, { grow: !0, children: i ? /* @__PURE__ */ u.jsx(
      As,
      {
        padding: 5,
        language: "css",
        defaultValue: d,
        onChange: g,
        isDarkTheme: o,
        clean: !0
      },
      l
    ) : n.t("noCode") }),
    /* @__PURE__ */ u.jsx(ut, { className: ce("absolute right-2 bottom-2 text-sm"), variant: "pr", size: "m2", onClick: m, children: n.t("update") })
  ] });
}), o2 = [
  {
    id: "html",
    label: "HTML"
  },
  {
    id: "mjml",
    label: "MJML"
  }
], HH = xe(function(t) {
  const n = qe(), r = Re(), { isProjectTypeEmail: o } = r, i = r.editor, [l, c] = y.useState(o2[0].id), [d, p] = y.useState(), { isDarkTheme: g } = gr(), [m] = y.useState(() => Z0(i.getCss())), [v, b] = y.useState(), x = (E) => n.t(`actions.showCode.${E}`), w = {
    ...t.options,
    ...o ? { export: !1 } : {}
  }, j = () => {
    i.runCommand("gjs-export-zip", {
      filenamePfx: "gjs-export",
      root: async (E) => {
        const P = await E.runCommand(ke.projectFiles), k = {};
        for (const T in P) {
          const O = P[T], { filename: A, content: $ } = O;
          if (O.path) {
            const N = O.path.split("/").filter(Boolean);
            let R = k;
            for (const z of N)
              R[z] = R[z] || {}, R = R[z];
            R[A] = $;
          } else
            k[A] = $;
        }
        return k;
      }
    });
  };
  y.useEffect(() => {
    (async () => {
      var A, $;
      const P = await i.runCommand(ke.projectFiles, {
        page: i.Pages.getSelected(),
        skipProject: !0,
        styles: "skip"
      }), k = ((A = P.find((N) => N.mimeType === "text/html")) == null ? void 0 : A.content) ?? "", T = (($ = P.find((N) => N.mimeType === "text/mjml")) == null ? void 0 : $.content) ?? "";
      p(l === "mjml" ? T : k);
    })();
  }, [l]), y.useEffect(() => {
    var E;
    v && ((E = v.getModel()) == null || E.setValue(d), KE(v));
  }, [v, d]);
  const C = {
    padding: 5,
    isDarkTheme: g,
    clean: !0
  };
  return /* @__PURE__ */ u.jsxs(G, { col: !0, space: "m", children: [
    /* @__PURE__ */ u.jsxs(G, { className: ce("h-96"), space: "m", children: [
      /* @__PURE__ */ u.jsxs(Y, { className: ce("relative"), grow: !0, children: [
        o && /* @__PURE__ */ u.jsxs(G, { className: ce("absolute top-3 right-3 z-10"), space: "s", nowrap: !0, children: [
          /* @__PURE__ */ u.jsx(
            Ze,
            {
              value: l,
              onChange: c,
              options: o2,
              className: ce("min-w-24")
            }
          ),
          /* @__PURE__ */ u.jsx(Z5, { getValue: () => v.getModel().getValue() })
        ] }),
        d !== void 0 && /* @__PURE__ */ u.jsx(As, { defaultValue: d, language: "html", onMount: b, ...C })
      ] }),
      !o && /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(As, { defaultValue: m, language: "css", ...C }) })
    ] }),
    w.export !== !1 && /* @__PURE__ */ u.jsx(G, { justify: "end", children: /* @__PURE__ */ u.jsx(ut, { size: "m2", variant: "pr", onClick: j, children: x("exportButton") }) })
  ] });
}), FH = () => [
  {
    id: Xe.web,
    label: Wo(Xe.web),
    content: /* @__PURE__ */ u.jsxs(G, { gap: "s", items: "center", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(ye, { icon: fe.web, size: Ee.s }),
      /* @__PURE__ */ u.jsx("span", { children: Wo(Xe.web) })
    ] })
  },
  {
    id: Xe.email,
    label: Wo(Xe.email),
    content: /* @__PURE__ */ u.jsxs(G, { gap: "s", items: "center", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(ye, { icon: fe.emailOutline, size: Ee.s }),
      /* @__PURE__ */ u.jsx("span", { children: Wo(Xe.email) })
    ] })
  }
], mg = 0, Ri = 1, Bl = 2, Q5 = 4;
function zH(e, t) {
  return (n) => e(t(n));
}
function BH(e, t) {
  return t(e);
}
function eP(e, t) {
  return (n) => e(t, n);
}
function s2(e, t) {
  return () => e(t);
}
function J0(e, t) {
  return t(e), e;
}
function Ca(...e) {
  return e;
}
function UH(e) {
  e();
}
function i2(e) {
  return () => e;
}
function WH(...e) {
  return () => {
    e.map(UH);
  };
}
function vg() {
}
function Fn(e, t) {
  return e(Ri, t);
}
function En(e, t) {
  e(mg, t);
}
function Q0(e) {
  e(Bl);
}
function dl(e) {
  return e(Q5);
}
function $t(e, t) {
  return Fn(e, eP(t, mg));
}
function a2(e, t) {
  const n = e(Ri, (r) => {
    n(), t(r);
  });
  return n;
}
function an() {
  const e = [];
  return (t, n) => {
    switch (t) {
      case Bl:
        e.splice(0, e.length);
        return;
      case Ri:
        return e.push(n), () => {
          const r = e.indexOf(n);
          r > -1 && e.splice(r, 1);
        };
      case mg:
        e.slice().forEach((r) => {
          r(n);
        });
        return;
      default:
        throw new Error(`unrecognized action ${t}`);
    }
  };
}
function Be(e) {
  let t = e;
  const n = an();
  return (r, o) => {
    switch (r) {
      case Ri:
        o(t);
        break;
      case mg:
        t = o;
        break;
      case Q5:
        return t;
    }
    return n(r, o);
  };
}
function GH(e) {
  let t, n;
  const r = () => t && t();
  return function(o, i) {
    switch (o) {
      case Ri:
        return i ? n === i ? void 0 : (r(), n = i, t = Fn(e, i), t) : (r(), vg);
      case Bl:
        r(), n = null;
        return;
      default:
        throw new Error(`unrecognized action ${o}`);
    }
  };
}
function Qc(e) {
  return J0(an(), (t) => $t(e, t));
}
function fl(e, t) {
  return J0(Be(t), (n) => $t(e, n));
}
function KH(...e) {
  return (t) => e.reduceRight(BH, t);
}
function Ge(e, ...t) {
  const n = KH(...t);
  return (r, o) => {
    switch (r) {
      case Ri:
        return Fn(e, n(o));
      case Bl:
        Q0(e);
        return;
    }
  };
}
function tP(e, t) {
  return e === t;
}
function lr(e = tP) {
  let t;
  return (n) => (r) => {
    e(t, r) || (t = r, n(r));
  };
}
function Mn(e) {
  return (t) => (n) => {
    e(n) && t(n);
  };
}
function qt(e) {
  return (t) => zH(t, e);
}
function fi(e) {
  return (t) => () => t(e);
}
function Af(e, t) {
  return (n) => (r) => n(t = e(t, r));
}
function hv(e) {
  return (t) => (n) => {
    e > 0 ? e-- : t(n);
  };
}
function Vc(e) {
  let t = null, n;
  return (r) => (o) => {
    t = o, !n && (n = setTimeout(() => {
      n = void 0, r(t);
    }, e));
  };
}
function l2(e) {
  let t, n;
  return (r) => (o) => {
    t = o, n && clearTimeout(n), n = setTimeout(() => {
      r(t);
    }, e);
  };
}
function Fo(...e) {
  const t = new Array(e.length);
  let n = 0, r = null;
  const o = Math.pow(2, e.length) - 1;
  return e.forEach((i, l) => {
    const c = Math.pow(2, l);
    Fn(i, (d) => {
      const p = n;
      n = n | c, t[l] = d, p !== o && n === o && r && (r(), r = null);
    });
  }), (i) => (l) => {
    const c = () => i([l].concat(t));
    n === o ? c() : r = c;
  };
}
function c2(...e) {
  return function(t, n) {
    switch (t) {
      case Ri:
        return WH(...e.map((r) => Fn(r, n)));
      case Bl:
        return;
      default:
        throw new Error(`unrecognized action ${t}`);
    }
  };
}
function ft(e, t = tP) {
  return Ge(e, lr(t));
}
function Ps(...e) {
  const t = an(), n = new Array(e.length);
  let r = 0;
  const o = Math.pow(2, e.length) - 1;
  return e.forEach((i, l) => {
    const c = Math.pow(2, l);
    Fn(i, (d) => {
      n[l] = d, r = r | c, r === o && En(t, n);
    });
  }), function(i, l) {
    switch (i) {
      case Ri:
        return r === o && l(n), Fn(t, l);
      case Bl:
        return Q0(t);
      default:
        throw new Error(`unrecognized action ${i}`);
    }
  };
}
function is(e, t = [], { singleton: n } = { singleton: !0 }) {
  return {
    id: qH(),
    constructor: e,
    dependencies: t,
    singleton: n
  };
}
const qH = () => Symbol();
function YH(e) {
  const t = /* @__PURE__ */ new Map(), n = ({ id: r, constructor: o, dependencies: i, singleton: l }) => {
    if (l && t.has(r))
      return t.get(r);
    const c = o(i.map((d) => n(d)));
    return l && t.set(r, c), c;
  };
  return n(e);
}
function XH(e, t) {
  const n = {}, r = {};
  let o = 0;
  const i = e.length;
  for (; o < i; )
    r[e[o]] = 1, o += 1;
  for (const l in t)
    r.hasOwnProperty(l) || (n[l] = t[l]);
  return n;
}
const Rf = typeof document < "u" ? Q.useLayoutEffect : Q.useEffect;
function ZH(e, t, n) {
  const r = Object.keys(t.required || {}), o = Object.keys(t.optional || {}), i = Object.keys(t.methods || {}), l = Object.keys(t.events || {}), c = Q.createContext({});
  function d(C, E) {
    C.propsReady && En(C.propsReady, !1);
    for (const P of r) {
      const k = C[t.required[P]];
      En(k, E[P]);
    }
    for (const P of o)
      if (P in E) {
        const k = C[t.optional[P]];
        En(k, E[P]);
      }
    C.propsReady && En(C.propsReady, !0);
  }
  function p(C) {
    return i.reduce((E, P) => (E[P] = (k) => {
      const T = C[t.methods[P]];
      En(T, k);
    }, E), {});
  }
  function g(C) {
    return l.reduce((E, P) => (E[P] = GH(C[t.events[P]]), E), {});
  }
  const m = Q.forwardRef((C, E) => {
    const { children: P, ...k } = C, [T] = Q.useState(() => J0(YH(e), ($) => d($, k))), [O] = Q.useState(s2(g, T));
    Rf(() => {
      for (const $ of l)
        $ in k && Fn(O[$], k[$]);
      return () => {
        Object.values(O).map(Q0);
      };
    }, [k, O, T]), Rf(() => {
      d(T, k);
    }), Q.useImperativeHandle(E, i2(p(T)));
    const A = n;
    return /* @__PURE__ */ u.jsx(c.Provider, { value: T, children: n ? /* @__PURE__ */ u.jsx(A, { ...XH([...r, ...o, ...l], k), children: P }) : P });
  }), v = (C) => Q.useCallback(eP(En, Q.useContext(c)[C]), [C]), b = (C) => {
    const P = Q.useContext(c)[C], k = Q.useCallback(
      (T) => Fn(P, T),
      [P]
    );
    return Q.useSyncExternalStore(
      k,
      () => dl(P),
      () => dl(P)
    );
  }, x = (C) => {
    const P = Q.useContext(c)[C], [k, T] = Q.useState(s2(dl, P));
    return Rf(
      () => Fn(P, (O) => {
        O !== k && T(i2(O));
      }),
      [P, k]
    ), k;
  }, w = Q.version.startsWith("18") ? b : x;
  return {
    Component: m,
    usePublisher: v,
    useEmitterValue: w,
    useEmitter: (C, E) => {
      const k = Q.useContext(c)[C];
      Rf(() => Fn(k, E), [E, k]);
    }
  };
}
const nP = typeof document < "u" ? Q.useLayoutEffect : Q.useEffect;
var ey = /* @__PURE__ */ ((e) => (e[e.DEBUG = 0] = "DEBUG", e[e.INFO = 1] = "INFO", e[e.WARN = 2] = "WARN", e[e.ERROR = 3] = "ERROR", e))(ey || {});
const JH = {
  0: "debug",
  1: "log",
  2: "warn",
  3: "error"
}, QH = () => typeof globalThis > "u" ? window : globalThis, rP = is(
  () => {
    const e = Be(
      3
      /* ERROR */
    );
    return {
      log: Be((n, r, o = 1) => {
        var i;
        const l = (i = QH().VIRTUOSO_LOG_LEVEL) != null ? i : dl(e);
        o >= l && console[JH[o]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          n,
          r
        );
      }),
      logLevel: e
    };
  },
  [],
  { singleton: !0 }
);
function oP(e, t, n) {
  const r = Q.useRef(null);
  let o = (i) => {
  };
  if (typeof ResizeObserver < "u") {
    const i = Q.useMemo(() => new ResizeObserver((l) => {
      const c = () => {
        const d = l[0].target;
        d.offsetParent !== null && e(d);
      };
      n ? c() : requestAnimationFrame(c);
    }), [e]);
    o = (l) => {
      l && t ? (i.observe(l), r.current = l) : (r.current && i.unobserve(r.current), r.current = null);
    };
  }
  return { ref: r, callbackRef: o };
}
function yg(e, t, n) {
  return oP(e, t, n).callbackRef;
}
function Sp(e, t) {
  return Math.round(e.getBoundingClientRect()[t]);
}
function sP(e, t) {
  return Math.abs(e - t) < 1.01;
}
function iP(e, t, n, r = vg, o, i) {
  const l = Q.useRef(null), c = Q.useRef(null), d = Q.useRef(null), p = Q.useCallback(
    (v) => {
      const b = v.target, x = b === window || b === document, w = i ? x ? window.pageXOffset || document.documentElement.scrollLeft : b.scrollLeft : x ? window.pageYOffset || document.documentElement.scrollTop : b.scrollTop, j = i ? x ? document.documentElement.scrollWidth : b.scrollWidth : x ? document.documentElement.scrollHeight : b.scrollHeight, C = i ? x ? window.innerWidth : b.offsetWidth : x ? window.innerHeight : b.offsetHeight, E = () => {
        e({
          scrollTop: Math.max(w, 0),
          scrollHeight: j,
          viewportHeight: C
        });
      };
      v.suppressFlushSync ? E() : Cv.flushSync(E), c.current !== null && (w === c.current || w <= 0 || w === j - C) && (c.current = null, t(!0), d.current && (clearTimeout(d.current), d.current = null));
    },
    [e, t]
  );
  Q.useEffect(() => {
    const v = o || l.current;
    return r(o || l.current), p({ target: v, suppressFlushSync: !0 }), v.addEventListener("scroll", p, { passive: !0 }), () => {
      r(null), v.removeEventListener("scroll", p);
    };
  }, [l, p, n, r, o]);
  function g(v) {
    const b = l.current;
    if (!b || (i ? "offsetWidth" in b && b.offsetWidth === 0 : "offsetHeight" in b && b.offsetHeight === 0))
      return;
    const x = v.behavior === "smooth";
    let w, j, C;
    b === window ? (j = Math.max(
      Sp(document.documentElement, i ? "width" : "height"),
      i ? document.documentElement.scrollWidth : document.documentElement.scrollHeight
    ), w = i ? window.innerWidth : window.innerHeight, C = i ? document.documentElement.scrollLeft : document.documentElement.scrollTop) : (j = b[i ? "scrollWidth" : "scrollHeight"], w = Sp(b, i ? "width" : "height"), C = b[i ? "scrollLeft" : "scrollTop"]);
    const E = j - w;
    if (v.top = Math.ceil(Math.max(Math.min(E, v.top), 0)), sP(w, j) || v.top === C) {
      e({ scrollTop: C, scrollHeight: j, viewportHeight: w }), x && t(!0);
      return;
    }
    x ? (c.current = v.top, d.current && clearTimeout(d.current), d.current = setTimeout(() => {
      d.current = null, c.current = null, t(!0);
    }, 1e3)) : c.current = null, i && (v = { left: v.top, behavior: v.behavior }), b.scrollTo(v);
  }
  function m(v) {
    i && (v = { left: v.top, behavior: v.behavior }), l.current.scrollBy(v);
  }
  return { scrollerRef: l, scrollByCallback: m, scrollToCallback: g };
}
const bg = is(
  () => {
    const e = an(), t = an(), n = Be(0), r = an(), o = Be(0), i = an(), l = an(), c = Be(0), d = Be(0), p = Be(0), g = Be(0), m = an(), v = an(), b = Be(!1), x = Be(!1), w = Be(!1);
    return $t(
      Ge(
        e,
        qt(({ scrollTop: j }) => j)
      ),
      t
    ), $t(
      Ge(
        e,
        qt(({ scrollHeight: j }) => j)
      ),
      l
    ), $t(t, o), {
      // input
      scrollContainerState: e,
      scrollTop: t,
      viewportHeight: i,
      headerHeight: c,
      fixedHeaderHeight: d,
      fixedFooterHeight: p,
      footerHeight: g,
      scrollHeight: l,
      smoothScrollTargetReached: r,
      horizontalDirection: x,
      skipAnimationFrameInResizeObserver: w,
      // signals
      scrollTo: m,
      scrollBy: v,
      // state
      statefulScrollTop: o,
      deviation: n,
      scrollingInProgress: b
    };
  },
  [],
  { singleton: !0 }
), eF = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function tF(e) {
  const t = typeof e == "number" ? { index: e } : e;
  return t.align || (t.align = "start"), (!t.behavior || !eF) && (t.behavior = "auto"), t.offset || (t.offset = 0), t;
}
const jp = "up", eu = "down", nF = "none", rF = {
  atBottom: !1,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollTop: 0,
    viewportHeight: 0,
    scrollHeight: 0
  }
}, oF = 0, aP = is(([{ scrollContainerState: e, scrollTop: t, viewportHeight: n, headerHeight: r, footerHeight: o, scrollBy: i }]) => {
  const l = Be(!1), c = Be(!0), d = an(), p = an(), g = Be(4), m = Be(oF), v = fl(
    Ge(
      c2(Ge(ft(t), hv(1), fi(!0)), Ge(ft(t), hv(1), fi(!1), l2(100))),
      lr()
    ),
    !1
  ), b = fl(
    Ge(c2(Ge(i, fi(!0)), Ge(i, fi(!1), l2(200))), lr()),
    !1
  );
  $t(
    Ge(
      Ps(ft(t), ft(m)),
      qt(([E, P]) => E <= P),
      lr()
    ),
    c
  ), $t(Ge(c, Vc(50)), p);
  const x = Qc(
    Ge(
      Ps(e, ft(n), ft(r), ft(o), ft(g)),
      Af((E, [{ scrollTop: P, scrollHeight: k }, T, O, A, $]) => {
        const N = P + T - k > -$, R = {
          viewportHeight: T,
          scrollTop: P,
          scrollHeight: k
        };
        if (N) {
          let D, Z;
          return P > E.state.scrollTop ? (D = "SCROLLED_DOWN", Z = E.state.scrollTop - P) : (D = "SIZE_DECREASED", Z = E.state.scrollTop - P || E.scrollTopDelta), {
            atBottom: !0,
            state: R,
            atBottomBecause: D,
            scrollTopDelta: Z
          };
        }
        let z;
        return R.scrollHeight > E.state.scrollHeight ? z = "SIZE_INCREASED" : T < E.state.viewportHeight ? z = "VIEWPORT_HEIGHT_DECREASING" : P < E.state.scrollTop ? z = "SCROLLING_UPWARDS" : z = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: z,
          state: R
        };
      }, rF),
      lr((E, P) => E && E.atBottom === P.atBottom)
    )
  ), w = fl(
    Ge(
      e,
      Af(
        (E, { scrollTop: P, scrollHeight: k, viewportHeight: T }) => {
          if (sP(E.scrollHeight, k))
            return {
              scrollTop: P,
              scrollHeight: k,
              jump: 0,
              changed: !1
            };
          {
            const O = k - (P + T) < 1;
            return E.scrollTop !== P && O ? {
              scrollHeight: k,
              scrollTop: P,
              jump: E.scrollTop - P,
              changed: !0
            } : {
              scrollHeight: k,
              scrollTop: P,
              jump: 0,
              changed: !0
            };
          }
        },
        { scrollHeight: 0, jump: 0, scrollTop: 0, changed: !1 }
      ),
      Mn((E) => E.changed),
      qt((E) => E.jump)
    ),
    0
  );
  $t(
    Ge(
      x,
      qt((E) => E.atBottom)
    ),
    l
  ), $t(Ge(l, Vc(50)), d);
  const j = Be(eu);
  $t(
    Ge(
      e,
      qt(({ scrollTop: E }) => E),
      lr(),
      Af(
        (E, P) => dl(b) ? { direction: E.direction, prevScrollTop: P } : { direction: P < E.prevScrollTop ? jp : eu, prevScrollTop: P },
        { direction: eu, prevScrollTop: 0 }
      ),
      qt((E) => E.direction)
    ),
    j
  ), $t(Ge(e, Vc(50), fi(nF)), j);
  const C = Be(0);
  return $t(
    Ge(
      v,
      Mn((E) => !E),
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      fi(0)
    ),
    C
  ), $t(
    Ge(
      t,
      Vc(100),
      Fo(v),
      Mn(([E, P]) => !!P),
      Af(([E, P], [k]) => [P, k], [0, 0]),
      qt(([E, P]) => P - E)
    ),
    C
  ), {
    isScrolling: v,
    isAtTop: c,
    isAtBottom: l,
    atBottomState: x,
    atTopStateChange: p,
    atBottomStateChange: d,
    scrollDirection: j,
    atBottomThreshold: g,
    atTopThreshold: m,
    scrollVelocity: C,
    lastJumpDueToItemResize: w
  };
}, Ca(bg)), sF = is(
  ([{ log: e }]) => {
    const t = Be(!1), n = Qc(
      Ge(
        t,
        Mn((r) => r),
        lr()
      )
    );
    return Fn(t, (r) => {
      r && dl(e)("props updated", {}, ey.DEBUG);
    }), { propsReady: t, didMount: n };
  },
  Ca(rP),
  { singleton: !0 }
);
function lP(e, t) {
  e == 0 ? t() : requestAnimationFrame(() => lP(e - 1, t));
}
function iF(e, t) {
  const n = t - 1;
  return typeof e == "number" ? e : e.index === "LAST" ? n : e.index;
}
function mv(e, t) {
  return !!(e && e[0] === t[0] && e[1] === t[1]);
}
function aF(e, t) {
  return !!(e && e.startIndex === t.startIndex && e.endIndex === t.endIndex);
}
const Cp = "top", Ep = "bottom", u2 = "none";
function d2(e, t, n) {
  return typeof e == "number" ? n === jp && t === Cp || n === eu && t === Ep ? e : 0 : n === jp ? t === Cp ? e.main : e.reverse : t === Ep ? e.main : e.reverse;
}
function f2(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const lF = is(
  ([{ scrollTop: e, viewportHeight: t, deviation: n, headerHeight: r, fixedHeaderHeight: o }]) => {
    const i = an(), l = Be(0), c = Be(0), d = Be(0), p = fl(
      Ge(
        Ps(
          ft(e),
          ft(t),
          ft(r),
          ft(i, mv),
          ft(d),
          ft(l),
          ft(o),
          ft(n),
          ft(c)
        ),
        qt(
          ([
            g,
            m,
            v,
            [b, x],
            w,
            j,
            C,
            E,
            P
          ]) => {
            const k = g - E, T = j + C, O = Math.max(v - k, 0);
            let A = u2;
            const $ = f2(P, Cp), N = f2(P, Ep);
            return b -= E, b += v + C, x += v + C, x -= E, b > g + T - $ && (A = jp), x < g - O + m + N && (A = eu), A !== u2 ? [
              Math.max(k - v - d2(w, Cp, A) - $, 0),
              k - O - C + m + d2(w, Ep, A) + N
            ] : null;
          }
        ),
        Mn((g) => g != null),
        lr(mv)
      ),
      [0, 0]
    );
    return {
      // input
      listBoundary: i,
      overscan: d,
      topListHeight: l,
      increaseViewportBy: c,
      // output
      visibleRange: p
    };
  },
  Ca(bg),
  { singleton: !0 }
), cF = is(
  ([{ scrollVelocity: e }]) => {
    const t = Be(!1), n = an(), r = Be(!1);
    return $t(
      Ge(
        e,
        Fo(r, t, n),
        Mn(([o, i]) => !!i),
        qt(([o, i, l, c]) => {
          const { exit: d, enter: p } = i;
          if (l) {
            if (d(o, c))
              return !1;
          } else if (p(o, c))
            return !0;
          return l;
        }),
        lr()
      ),
      t
    ), Fn(
      Ge(Ps(t, e, n), Fo(r)),
      ([[o, i, l], c]) => o && c && c.change && c.change(i, l)
    ), { isSeeking: t, scrollSeekConfiguration: r, scrollVelocity: e, scrollSeekRangeChanged: n };
  },
  Ca(aP),
  { singleton: !0 }
);
function uF(e) {
  let t = !1, n;
  return () => (t || (t = !0, n = e()), n);
}
const dF = is(([{ scrollTo: e, scrollContainerState: t }]) => {
  const n = an(), r = an(), o = an(), i = Be(!1), l = Be(void 0);
  return $t(
    Ge(
      Ps(n, r),
      qt(([{ viewportHeight: c, scrollTop: d, scrollHeight: p }, { offsetTop: g }]) => ({
        scrollTop: Math.max(0, d - g),
        scrollHeight: p,
        viewportHeight: c
      }))
    ),
    t
  ), $t(
    Ge(
      e,
      Fo(r),
      qt(([c, { offsetTop: d }]) => ({
        ...c,
        top: c.top + d
      }))
    ),
    o
  ), {
    // config
    useWindowScroll: i,
    customScrollParent: l,
    // input
    windowScrollContainerState: n,
    windowViewportRect: r,
    // signals
    windowScrollTo: o
  };
}, Ca(bg)), n1 = "-webkit-sticky", p2 = "sticky", cP = uF(() => {
  if (typeof document > "u")
    return p2;
  const e = document.createElement("div");
  return e.style.position = n1, e.style.position === n1 ? n1 : p2;
});
function fF(e, t, n) {
  const r = Q.useRef(null), o = Q.useCallback(
    (d) => {
      if (d === null || !d.offsetParent)
        return;
      const p = d.getBoundingClientRect(), g = p.width;
      let m, v;
      if (t) {
        const b = t.getBoundingClientRect(), x = p.top - b.top;
        m = b.height - Math.max(0, x), v = x + t.scrollTop;
      } else
        m = window.innerHeight - Math.max(0, p.top), v = p.top + window.pageYOffset;
      r.current = {
        offsetTop: v,
        visibleHeight: m,
        visibleWidth: g
      }, e(r.current);
    },
    [e, t]
  ), { callbackRef: i, ref: l } = oP(o, !0, n), c = Q.useCallback(() => {
    o(l.current);
  }, [o, l]);
  return Q.useEffect(() => {
    if (t) {
      t.addEventListener("scroll", c);
      const d = new ResizeObserver(() => {
        requestAnimationFrame(c);
      });
      return d.observe(t), () => {
        t.removeEventListener("scroll", c), d.unobserve(t);
      };
    } else
      return window.addEventListener("scroll", c), window.addEventListener("resize", c), () => {
        window.removeEventListener("scroll", c), window.removeEventListener("resize", c);
      };
  }, [c, t]), i;
}
Q.createContext(void 0);
const uP = Q.createContext(void 0);
function pF(e) {
  return e;
}
cP();
const gF = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
}, hF = {
  outline: "none",
  overflowX: "auto",
  position: "relative"
}, dP = (e) => ({
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  ...e ? { display: "flex", flexDirection: "column" } : {}
});
cP();
function sa(e, t) {
  if (typeof e != "string")
    return { context: t };
}
function mF({ usePublisher: e, useEmitter: t, useEmitterValue: n }) {
  return Q.memo(function({ style: i, children: l, ...c }) {
    const d = e("scrollContainerState"), p = n("ScrollerComponent"), g = e("smoothScrollTargetReached"), m = n("scrollerRef"), v = n("context"), b = n("horizontalDirection") || !1, { scrollerRef: x, scrollByCallback: w, scrollToCallback: j } = iP(
      d,
      g,
      p,
      m,
      void 0,
      b
    );
    t("scrollTo", j), t("scrollBy", w);
    const C = b ? hF : gF;
    return /* @__PURE__ */ u.jsx(
      p,
      {
        ref: x,
        style: { ...C, ...i },
        "data-testid": "virtuoso-scroller",
        "data-virtuoso-scroller": !0,
        tabIndex: 0,
        ...c,
        ...sa(p, v),
        children: l
      }
    );
  });
}
function vF({ usePublisher: e, useEmitter: t, useEmitterValue: n }) {
  return Q.memo(function({ style: i, children: l, ...c }) {
    const d = e("windowScrollContainerState"), p = n("ScrollerComponent"), g = e("smoothScrollTargetReached"), m = n("totalListHeight"), v = n("deviation"), b = n("customScrollParent"), x = n("context"), { scrollerRef: w, scrollByCallback: j, scrollToCallback: C } = iP(
      d,
      g,
      p,
      vg,
      b
    );
    return nP(() => (w.current = b || window, () => {
      w.current = null;
    }), [w, b]), t("windowScrollTo", C), t("scrollBy", j), /* @__PURE__ */ u.jsx(
      p,
      {
        style: { position: "relative", ...i, ...m !== 0 ? { height: m + v } : {} },
        "data-virtuoso-scroller": !0,
        ...c,
        ...sa(p, x),
        children: l
      }
    );
  });
}
const g2 = {
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, yF = {
  items: [{ index: 0 }],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  bottom: 0,
  itemHeight: 0,
  itemWidth: 0
}, { round: h2, ceil: m2, floor: Pp, min: r1, max: tu } = Math;
function bF(e) {
  return {
    ...yF,
    items: e
  };
}
function v2(e, t, n) {
  return Array.from({ length: t - e + 1 }).map((r, o) => {
    const i = n === null ? null : n[o + e];
    return { index: o + e, data: i };
  });
}
function xF(e, t) {
  return e && e.column === t.column && e.row === t.row;
}
function Nf(e, t) {
  return e && e.width === t.width && e.height === t.height;
}
const wF = /* @__PURE__ */ is(
  ([
    { overscan: e, visibleRange: t, listBoundary: n, increaseViewportBy: r },
    { scrollTop: o, viewportHeight: i, scrollBy: l, scrollTo: c, smoothScrollTargetReached: d, scrollContainerState: p, footerHeight: g, headerHeight: m },
    v,
    b,
    { propsReady: x, didMount: w },
    { windowViewportRect: j, useWindowScroll: C, customScrollParent: E, windowScrollContainerState: P, windowScrollTo: k },
    T
  ]) => {
    const O = Be(0), A = Be(0), $ = Be(g2), N = Be({ height: 0, width: 0 }), R = Be({ height: 0, width: 0 }), z = an(), D = an(), Z = Be(0), K = Be(null), H = Be({ row: 0, column: 0 }), q = an(), te = an(), I = Be(!1), F = Be(0), V = Be(!0), L = Be(!1), W = Be(!1);
    Fn(
      Ge(
        w,
        Fo(F),
        Mn(([se, de]) => !!de)
      ),
      () => {
        En(V, !1);
      }
    ), Fn(
      Ge(
        Ps(w, V, R, N, F, L),
        Mn(([se, de, we, je, , He]) => se && !de && we.height !== 0 && je.height !== 0 && !He)
      ),
      ([, , , , se]) => {
        En(L, !0), lP(1, () => {
          En(z, se);
        }), a2(Ge(o), () => {
          En(n, [0, 0]), En(V, !0);
        });
      }
    ), $t(
      Ge(
        te,
        Mn((se) => se != null && se.scrollTop > 0),
        fi(0)
      ),
      A
    ), Fn(
      Ge(
        w,
        Fo(te),
        Mn(([, se]) => se != null)
      ),
      ([, se]) => {
        se && (En(N, se.viewport), En(R, se == null ? void 0 : se.item), En(H, se.gap), se.scrollTop > 0 && (En(I, !0), a2(Ge(o, hv(1)), (de) => {
          En(I, !1);
        }), En(c, { top: se.scrollTop })));
      }
    ), $t(
      Ge(
        N,
        qt(({ height: se }) => se)
      ),
      i
    ), $t(
      Ge(
        Ps(
          ft(N, Nf),
          ft(R, Nf),
          ft(H, (se, de) => se && se.column === de.column && se.row === de.row),
          ft(o)
        ),
        qt(([se, de, we, je]) => ({
          viewport: se,
          item: de,
          gap: we,
          scrollTop: je
        }))
      ),
      q
    ), $t(
      Ge(
        Ps(
          ft(O),
          t,
          ft(H, xF),
          ft(R, Nf),
          ft(N, Nf),
          ft(K),
          ft(A),
          ft(I),
          ft(V),
          ft(F)
        ),
        Mn(([, , , , , , , se]) => !se),
        qt(
          ([
            se,
            [de, we],
            je,
            He,
            Le,
            ot,
            vt,
            ,
            zt,
            Ot
          ]) => {
            const { row: ct, column: vn } = je, { height: St, width: At } = He, { width: en } = Le;
            if (vt === 0 && (se === 0 || en === 0))
              return g2;
            if (At === 0) {
              const oo = iF(Ot, se), as = Math.max(oo + vt - 1, 0);
              return bF(v2(oo, as, ot));
            }
            const Bt = fP(en, At, vn);
            let Et, it;
            zt ? de === 0 && we === 0 && vt > 0 ? (Et = 0, it = vt - 1) : (Et = Bt * Pp((de + ct) / (St + ct)), it = Bt * m2((we + ct) / (St + ct)) - 1, it = r1(se - 1, tu(it, Bt - 1)), Et = r1(it, tu(0, Et))) : (Et = 0, it = -1);
            const Lt = v2(Et, it, ot), { top: Ut, bottom: yn } = y2(Le, je, He, Lt), Bn = m2(se / Bt), Jn = Bn * St + (Bn - 1) * ct - yn;
            return { items: Lt, offsetTop: Ut, offsetBottom: Jn, top: Ut, bottom: yn, itemHeight: St, itemWidth: At };
          }
        )
      ),
      $
    ), $t(
      Ge(
        K,
        Mn((se) => se !== null),
        qt((se) => se.length)
      ),
      O
    ), $t(
      Ge(
        Ps(N, R, $, H),
        Mn(([se, de, { items: we }]) => we.length > 0 && de.height !== 0 && se.height !== 0),
        qt(([se, de, { items: we }, je]) => {
          const { top: He, bottom: Le } = y2(se, je, de, we);
          return [He, Le];
        }),
        lr(mv)
      ),
      n
    );
    const ie = Be(!1);
    $t(
      Ge(
        o,
        Fo(ie),
        qt(([se, de]) => de || se !== 0)
      ),
      ie
    );
    const re = Qc(
      Ge(
        ft($),
        Mn(({ items: se }) => se.length > 0),
        Fo(O, ie),
        Mn(([{ items: se }, de, we]) => we && se[se.length - 1].index === de - 1),
        qt(([, se]) => se - 1),
        lr()
      )
    ), le = Qc(
      Ge(
        ft($),
        Mn(({ items: se }) => se.length > 0 && se[0].index === 0),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        fi(0),
        lr()
      )
    ), me = Qc(
      Ge(
        ft($),
        Fo(I),
        Mn(([{ items: se }, de]) => se.length > 0 && !de),
        qt(([{ items: se }]) => ({
          startIndex: se[0].index,
          endIndex: se[se.length - 1].index
        })),
        lr(aF),
        Vc(0)
      )
    );
    $t(me, b.scrollSeekRangeChanged), $t(
      Ge(
        z,
        Fo(N, R, O, H),
        qt(([se, de, we, je, He]) => {
          const Le = tF(se), { align: ot, behavior: vt, offset: zt } = Le;
          let Ot = Le.index;
          Ot === "LAST" && (Ot = je - 1), Ot = tu(0, Ot, r1(je - 1, Ot));
          let ct = vv(de, He, we, Ot);
          return ot === "end" ? ct = h2(ct - de.height + we.height) : ot === "center" && (ct = h2(ct - de.height / 2 + we.height / 2)), zt && (ct += zt), { top: ct, behavior: vt };
        })
      ),
      c
    );
    const oe = fl(
      Ge(
        $,
        qt((se) => se.offsetBottom + se.bottom)
      ),
      0
    );
    return $t(
      Ge(
        j,
        qt((se) => ({ width: se.visibleWidth, height: se.visibleHeight }))
      ),
      N
    ), {
      // input
      data: K,
      totalCount: O,
      viewportDimensions: N,
      itemDimensions: R,
      scrollTop: o,
      scrollHeight: D,
      overscan: e,
      increaseViewportBy: r,
      scrollBy: l,
      scrollTo: c,
      scrollToIndex: z,
      smoothScrollTargetReached: d,
      windowViewportRect: j,
      windowScrollTo: k,
      useWindowScroll: C,
      customScrollParent: E,
      windowScrollContainerState: P,
      deviation: Z,
      scrollContainerState: p,
      footerHeight: g,
      headerHeight: m,
      initialItemCount: A,
      gap: H,
      restoreStateFrom: te,
      ...b,
      initialTopMostItemIndex: F,
      horizontalDirection: W,
      // output
      gridState: $,
      totalListHeight: oe,
      ...v,
      startReached: le,
      endReached: re,
      rangeChanged: me,
      stateChanged: q,
      propsReady: x,
      stateRestoreInProgress: I,
      ...T
    };
  },
  Ca(lF, bg, aP, cF, sF, dF, rP)
);
function y2(e, t, n, r) {
  const { height: o } = n;
  if (o === void 0 || r.length === 0)
    return { top: 0, bottom: 0 };
  const i = vv(e, t, n, r[0].index), l = vv(e, t, n, r[r.length - 1].index) + o;
  return { top: i, bottom: l };
}
function vv(e, t, n, r) {
  const o = fP(e.width, n.width, t.column), i = Pp(r / o), l = i * n.height + tu(0, i - 1) * t.row;
  return l > 0 ? l + t.row : l;
}
function fP(e, t, n) {
  return tu(1, Pp((e + n) / (Pp(t) + n)));
}
const SF = /* @__PURE__ */ is(() => {
  const e = Be((m) => `Item ${m}`), t = Be({}), n = Be(null), r = Be("virtuoso-grid-item"), o = Be("virtuoso-grid-list"), i = Be(pF), l = Be("div"), c = Be(vg), d = (m, v = null) => fl(
    Ge(
      t,
      qt((b) => b[m]),
      lr()
    ),
    v
  ), p = Be(!1), g = Be(!1);
  return $t(ft(g), p), {
    readyStateChanged: p,
    reportReadyState: g,
    context: n,
    itemContent: e,
    components: t,
    computeItemKey: i,
    itemClassName: r,
    listClassName: o,
    headerFooterTag: l,
    scrollerRef: c,
    FooterComponent: d("Footer"),
    HeaderComponent: d("Header"),
    ListComponent: d("List", "div"),
    ItemComponent: d("Item", "div"),
    ScrollerComponent: d("Scroller", "div"),
    ScrollSeekPlaceholder: d("ScrollSeekPlaceholder", "div")
  };
}), jF = /* @__PURE__ */ is(([e, t]) => ({ ...e, ...t }), Ca(wF, SF)), CF = /* @__PURE__ */ Q.memo(function() {
  const t = Zt("gridState"), n = Zt("listClassName"), r = Zt("itemClassName"), o = Zt("itemContent"), i = Zt("computeItemKey"), l = Zt("isSeeking"), c = Zr("scrollHeight"), d = Zt("ItemComponent"), p = Zt("ListComponent"), g = Zt("ScrollSeekPlaceholder"), m = Zt("context"), v = Zr("itemDimensions"), b = Zr("gap"), x = Zt("log"), w = Zt("stateRestoreInProgress"), j = Zr("reportReadyState"), C = yg(
    Q.useMemo(
      () => (E) => {
        const P = E.parentElement.parentElement.scrollHeight;
        c(P);
        const k = E.firstChild;
        if (k) {
          const { width: T, height: O } = k.getBoundingClientRect();
          v({ width: T, height: O });
        }
        b({
          row: b2("row-gap", getComputedStyle(E).rowGap, x),
          column: b2("column-gap", getComputedStyle(E).columnGap, x)
        });
      },
      [c, v, b, x]
    ),
    !0,
    !1
  );
  return nP(() => {
    t.itemHeight > 0 && t.itemWidth > 0 && j(!0);
  }, [t]), w ? null : /* @__PURE__ */ u.jsx(
    p,
    {
      ref: C,
      className: n,
      ...sa(p, m),
      style: { paddingTop: t.offsetTop, paddingBottom: t.offsetBottom },
      "data-testid": "virtuoso-item-list",
      children: t.items.map((E) => {
        const P = i(E.index, E.data, m);
        return l ? /* @__PURE__ */ u.jsx(
          g,
          {
            ...sa(g, m),
            index: E.index,
            height: t.itemHeight,
            width: t.itemWidth
          },
          P
        ) : /* @__PURE__ */ y.createElement(
          d,
          {
            ...sa(d, m),
            className: r,
            "data-index": E.index,
            key: P
          },
          o(E.index, E.data, m)
        );
      })
    }
  );
}), EF = Q.memo(function() {
  const t = Zt("HeaderComponent"), n = Zr("headerHeight"), r = Zt("headerFooterTag"), o = yg(
    Q.useMemo(() => (l) => n(Sp(l, "height")), [n]),
    !0,
    !1
  ), i = Zt("context");
  return t ? /* @__PURE__ */ u.jsx(r, { ref: o, children: /* @__PURE__ */ u.jsx(t, { ...sa(t, i) }) }) : null;
}), PF = Q.memo(function() {
  const t = Zt("FooterComponent"), n = Zr("footerHeight"), r = Zt("headerFooterTag"), o = yg(
    Q.useMemo(() => (l) => n(Sp(l, "height")), [n]),
    !0,
    !1
  ), i = Zt("context");
  return t ? /* @__PURE__ */ u.jsx(r, { ref: o, children: /* @__PURE__ */ u.jsx(t, { ...sa(t, i) }) }) : null;
}), _F = ({ children: e }) => {
  const t = Q.useContext(uP), n = Zr("itemDimensions"), r = Zr("viewportDimensions"), o = yg(
    Q.useMemo(
      () => (i) => {
        r(i.getBoundingClientRect());
      },
      [r]
    ),
    !0,
    !1
  );
  return Q.useEffect(() => {
    t && (r({ height: t.viewportHeight, width: t.viewportWidth }), n({ height: t.itemHeight, width: t.itemWidth }));
  }, [t, r, n]), /* @__PURE__ */ u.jsx("div", { style: dP(!1), ref: o, children: e });
}, kF = ({ children: e }) => {
  const t = Q.useContext(uP), n = Zr("windowViewportRect"), r = Zr("itemDimensions"), o = Zt("customScrollParent"), i = fF(n, o, !1);
  return Q.useEffect(() => {
    t && (r({ height: t.itemHeight, width: t.itemWidth }), n({ offsetTop: 0, visibleHeight: t.viewportHeight, visibleWidth: t.viewportWidth }));
  }, [t, n, r]), /* @__PURE__ */ u.jsx("div", { ref: i, style: dP(!1), children: e });
}, TF = /* @__PURE__ */ Q.memo(function({ ...t }) {
  const n = Zt("useWindowScroll"), r = Zt("customScrollParent"), o = r || n ? MF : LF, i = r || n ? kF : _F;
  return /* @__PURE__ */ u.jsx(o, { ...t, children: /* @__PURE__ */ u.jsxs(i, { children: [
    /* @__PURE__ */ u.jsx(EF, {}),
    /* @__PURE__ */ u.jsx(CF, {}),
    /* @__PURE__ */ u.jsx(PF, {})
  ] }) });
}), {
  Component: OF,
  usePublisher: Zr,
  useEmitterValue: Zt,
  useEmitter: pP
} = /* @__PURE__ */ ZH(
  jF,
  {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      restoreStateFrom: "restoreStateFrom",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      increaseViewportBy: "increaseViewportBy"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      stateChanged: "stateChanged",
      readyStateChanged: "readyStateChanged"
    }
  },
  TF
), LF = /* @__PURE__ */ mF({ usePublisher: Zr, useEmitterValue: Zt, useEmitter: pP }), MF = /* @__PURE__ */ vF({ usePublisher: Zr, useEmitterValue: Zt, useEmitter: pP });
function b2(e, t, n) {
  return t !== "normal" && !(t != null && t.endsWith("px")) && n(`${e} was not resolved to pixel value correctly`, t, ey.WARN), t === "normal" ? 0 : parseInt(t ?? "0", 10);
}
const Qu = OF, ty = (e) => {
  const t = "gs-utl-grid-cols-4", n = parseInt(`${e || 4}`, 10);
  return n === 1 ? "gs-utl-grid-cols-1" : n === 2 ? "gs-utl-grid-cols-2" : n === 3 ? "gs-utl-grid-cols-3" : n === 4 ? t : n === 5 ? "gs-utl-grid-cols-5" : n === 6 ? "gs-utl-grid-cols-6" : n === 7 ? "gs-utl-grid-cols-7" : n === 8 ? "gs-utl-grid-cols-8" : n === 9 ? "gs-utl-grid-cols-9" : n === 10 ? "gs-utl-grid-cols-10" : n === 11 ? "gs-utl-grid-cols-11" : n === 12 ? "gs-utl-grid-cols-12" : t;
}, AF = (e) => !!(e && !Array.isArray(e) && typeof e == "object");
async function RF(e) {
  const t = e.map(({ id: l, src: c }) => ({ id: l, src: c })), n = e.reduce(
    (l, c) => (l[c.id] = c, l),
    {}
  ), r = [], o = [];
  return (await dO(t)).forEach((l) => {
    l.status === "fulfilled" ? r.push(n[l.value]) : o.push(n[l.reason]);
  }), { loaded: r, failed: o };
}
const NF = async (e) => {
  const t = [...e], n = {};
  if (t.length) {
    const r = {}, o = [];
    if (t.forEach((i, l) => {
      AF(i) && (r[i.id] = { index: l }, o.push(i));
    }), o.length) {
      const { loaded: i } = await RF(o);
      i.forEach(({ id: l, options: c }) => {
        r[l].loaded = !0, n[l] = c || {};
      });
    }
    Object.keys(r).forEach((i) => {
      const l = r[i];
      l.loaded ? t[l.index] = i : t[l.index] = !1;
    });
  }
  return {
    plugins: t.filter(Boolean),
    pluginOptions: n
  };
}, $F = (e, t, n, r = {}) => {
  e.loadData(t);
  let o = `${e.getHtml()}<style>${e.getCss()}</style>`;
  if (n === Xe.email)
    try {
      o = e.runCommand("mjml-code-to-html").html;
    } catch (i) {
      console.error(i);
    }
  return r.removeScripts && (o = o.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "").replace(/<script[^>]*src=["'][^"']*["'][^>]*><\/script>/gi, "").replace(/<script[^>]*src=["'][^"']*["'][^>]*\/?>/gi, "")), r.skipReplace ? o : o.replace("<body", "<div data-body").replace("</body>", "</div>");
}, DF = async (e, t, n) => {
  const r = U5(t, { appStore: n }), o = await NF(r);
  return e == null ? void 0 : e.init({
    headless: !0,
    projectData: {},
    noticeOnUnload: !1,
    storageManager: !1,
    plugins: [
      ...o.plugins,
      (i) => {
        i.Storage.setCurrent("");
      }
    ],
    pluginsOpts: o.pluginOptions,
    protectedCss: `
      * { box-sizing: border-box; }
      [data-body] {
        margin: 0;
        background-color: white;
        width: 100%;
        height: 100%;
        color: initial;
        font-family: initial;
        font-weight: initial;
        line-height: initial;
      }
      [data-body]:before {
        content: "";
        display: block;
        height: 0px;
        overflow: hidden;
      }
    `
  });
};
function ny({
  children: e,
  text: t,
  onConfirm: n,
  onCancel: r,
  className: o = "w-[200px]",
  confirmButtonProps: i = {},
  ...l
}) {
  const c = qe();
  return /* @__PURE__ */ u.jsx(rs, { ...l, overlay: !0, title: !1, buttonAs: "span", handler: e, children: ({ close: d }) => /* @__PURE__ */ u.jsxs(G, { className: ce(o), space: "m", col: !0, children: [
    /* @__PURE__ */ u.jsx(Y, { grow: !0, className: ce("text-center"), children: t || c.t("confirmAction") }),
    /* @__PURE__ */ u.jsxs(G, { justify: "center", items: "center", space: "m", children: [
      /* @__PURE__ */ u.jsx(
        ut,
        {
          variant: "pr",
          size: "m2",
          onClick: () => {
            d(), n == null || n();
          },
          ...i,
          children: i.children || c.t("confirm")
        }
      ),
      /* @__PURE__ */ u.jsx(
        ut,
        {
          size: "m2",
          onClick: () => {
            d(), r == null || r();
          },
          children: c.t("cancel")
        }
      )
    ] })
  ] }) });
}
const x2 = /* @__PURE__ */ new Map(), w2 = /* @__PURE__ */ new Map(), IF = async ({ html: e = "", el: t }) => {
  const n = e, r = {};
  if (document.body.attachShadow) {
    const o = t.shadowRoot || t.attachShadow({ mode: "open" });
    o.innerHTML = n;
  }
  return r;
}, VF = xe(function({
  template: t,
  projectType: n,
  skipProjectNamePopover: r,
  className: o,
  onSelect: i,
  onRemove: l
}) {
  var A;
  const c = qe(), d = Re(), p = d.editor, [g, m] = y.useState(""), v = y.useRef(null), b = c.t("projectManager.projectName"), x = !t.isTemplate && d.currentProjectId === ((A = t.data.custom) == null ? void 0 : A.id), w = n === Xe.web, j = !t.isTemplate || r, C = () => {
    j && (i == null || i({ editor: p, template: t, loadTemplate: E }));
  }, E = d.setProject, P = ($) => {
    $.preventDefault(), i({ editor: p, template: t, loadTemplate: E });
  };
  y.useEffect(() => {
    const N = setTimeout(async () => {
      if (!v.current || !p)
        return;
      const R = `${t.isTemplate ? "t-" : ""}${t.id}`;
      let z = x2.get(R);
      if (!z) {
        let Z = w2.get(n);
        if (!Z) {
          const K = new ug({ appEditorStore: { sdkProps: { options: { licenseKey: "" } } } });
          Z = await DF(p.config.grapesjs, n, K.appEditorStore), w2.set(n, Z);
        }
        z = Z ? $F(Z, t.data, n) : "", x2.set(R, z);
      }
      const D = v.current;
      IF({ el: D, html: z });
    });
    return () => clearTimeout(N);
  }, [v, p, n, t.data]);
  const { media: k, author: T } = t, O = /* @__PURE__ */ u.jsx(ut, { className: ge("text-sm"), size: "m2", variant: "pr", onClick: C, disabled: x, children: c.t("select") });
  return /* @__PURE__ */ u.jsx(pr, { padding: !1, className: ge("overflow-hidden max-w-full group", o), children: /* @__PURE__ */ u.jsxs(G, { col: !0, children: [
    /* @__PURE__ */ u.jsxs(Y, { className: ge("relative group h-36 bg-checker max-w-full"), children: [
      /* @__PURE__ */ u.jsx(
        "div",
        {
          className: ge(
            "gs-utl-relative",
            "gs-utl-h-full",
            "gs-utl-overflow-hidden",
            "gs-utl-flex",
            "gs-utl-justify-center"
          ),
          children: k ? /* @__PURE__ */ u.jsx("img", { src: k, alt: t.name, className: ge("max-w-full") }) : /* @__PURE__ */ u.jsx(
            "div",
            {
              className: ge(
                "gs-utl-w-[1200px]",
                "gs-utl-flex-shrink-0",
                "gs-utl-flex-grow-0",
                "gs-utl-origin-top",
                "gs-utl-bg-white",
                // height needs to be the inverse of scale
                "gs-utl-scale-[0.232]",
                "gs-utl-h-[431.034%]"
              ),
              ref: v
            }
          )
        }
      ),
      x && /* @__PURE__ */ u.jsx(dn, { className: ge("absolute top-2 right-2", ee.bgA2), label: c.t("current"), s: "s", pill: !0 }),
      /* @__PURE__ */ u.jsx(
        G,
        {
          justify: "center",
          items: "center",
          className: ge(nt.coverAbs, ee.bgH75, "group-hover:gs-utl-opacity-100 opacity-0 transition-opacity"),
          children: j ? O : /* @__PURE__ */ u.jsx(rs, { overlay: !0, title: !1, buttonAs: "span", handler: O, children: () => /* @__PURE__ */ u.jsx("form", { onSubmit: P, children: /* @__PURE__ */ u.jsxs(G, { space: "m", col: !0, children: [
            /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
              jt,
              {
                size: "s",
                value: g,
                onChange: m,
                placeholder: b,
                required: !0
              }
            ) }),
            /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ut, { type: "submit", variant: "pr", size: "m2", full: !0, children: c.t("load") }) })
          ] }) }) })
        }
      )
    ] }),
    /* @__PURE__ */ u.jsxs(G, { className: ge("gjs-p-2 max-w-full", ve.bt, ee.br), col: !0, space: "s", children: [
      /* @__PURE__ */ u.jsxs(G, { className: ge("text-sm w-full"), space: "s", nowrap: !0, children: [
        /* @__PURE__ */ u.jsx(Y, { className: ge(nt.txtEllips, "max-w-full"), grow: !0, children: t.name }),
        !!T && /* @__PURE__ */ u.jsxs(Y, { children: [
          "by",
          " ",
          /* @__PURE__ */ u.jsx("a", { className: ge(wl.link), href: T.link, rel: "noreferrer", target: "_blank", children: T.name })
        ] })
      ] }),
      /* @__PURE__ */ u.jsxs(G, { items: "center", children: [
        w && /* @__PURE__ */ u.jsxs(Y, { className: ge("gjs-mr-auto"), children: [
          c.t("projectManager.pages"),
          ": ",
          t.data.pages.length
        ] }),
        !t.isTemplate && l && /* @__PURE__ */ u.jsx(Y, { className: ge("gjs-ml-auto"), children: /* @__PURE__ */ u.jsx(ny, { onConfirm: () => l(t), className: "", children: /* @__PURE__ */ u.jsx(Qt, { title: c.t("delete"), children: /* @__PURE__ */ u.jsx(ye, { icon: fe.delete, size: Ee.sx }) }) }) })
      ] })
    ] })
  ] }) });
}), gP = xe(function({
  templates: e,
  projectType: t,
  content: n,
  skipProjectNamePopover: r,
  onSelect: o,
  onRemove: i
}) {
  const [l] = fg(), d = qe().tScoped("templates"), g = Re().editor, m = ty(n == null ? void 0 : n.itemsPerRow), v = o ?? (({ template: b, loadTemplate: x }) => x(b));
  return /* @__PURE__ */ u.jsx(u.Fragment, { children: g && e ? e.length === 0 ? /* @__PURE__ */ u.jsx(G, { justify: "center", children: d("notFound") }) : /* @__PURE__ */ u.jsx(
    Qu,
    {
      data: e,
      listClassName: ge("grid gap-2 gjs-pr-2", m),
      itemContent: (b, x) => /* @__PURE__ */ u.jsx(
        VF,
        {
          template: x,
          projectType: t,
          onSelect: v,
          onRemove: i,
          skipProjectNamePopover: r
        },
        x.id
      )
    },
    l
  ) : /* @__PURE__ */ u.jsx(Ju, {}) });
}), HF = xe(function() {
  var w;
  const t = Re(), n = TE(), { filteredTemplates: r, projectSourceFilter: o, projectTypeFilter: i } = n, l = qe(), c = os(), { sdkOptions: d } = t, p = l.tScoped("projectManager"), g = async ({ loadTemplate: j, template: C }) => {
    j(C), c.close();
  }, m = async (j) => {
    n.setProjectTypeFilter(j), await n.loadAllTemplates();
  }, v = (j) => {
    n.removeProject(j.id), n.loadProjects();
  }, b = y.useMemo(
    () => [
      {
        id: pu.Existing,
        label: p("existentProjects")
      },
      {
        id: pu.Templates,
        label: p("templates")
      }
    ],
    [l]
  ), x = ((w = d.project) == null ? void 0 : w.types) && Rv();
  return y.useEffect(() => {
    n.loadAllTemplates();
  }, []), /* @__PURE__ */ u.jsxs(G, { col: !0, full: !0, space: "m", children: [
    x && /* @__PURE__ */ u.jsx(G, { items: "center", space: "m", children: /* @__PURE__ */ u.jsx(Y, { className: ge("gjs-ml-auto"), children: /* @__PURE__ */ u.jsx(
      Ze,
      {
        value: i,
        onChange: m,
        options: FH(),
        handlerSelected: (j) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsx("b", { children: p("projectType") }),
          ": ",
          j.label
        ] })
      }
    ) }) }),
    /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(Ds, { tabs: b, value: o, onChange: n.setProjectSourceFilter }) }),
    /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(
      gP,
      {
        templates: r,
        projectType: Xe[i],
        onSelect: g,
        onRemove: v,
        content: { itemsPerRow: 3 }
      }
    ) })
  ] });
}), FF = [
  { id: xo.auto, label: "Auto" },
  { id: xo.dark, label: "Dark" },
  { id: xo.light, label: "Light" }
], zF = { size: "s" }, o1 = ".grapesjs", BF = (e, t) => {
  const n = e == null ? void 0 : e.settingsMenu;
  return n !== !1 && (n == null ? void 0 : n[t]) !== !1;
}, UF = ({
  actions: e,
  editor: t,
  buttons: n,
  sdkOptions: r
}) => {
  const o = r.actions;
  return o === !1 ? [] : Ct(o) ? o({ actions: e, editor: t }) : o || (n ? Ct(n) ? n({ items: e, editor: t }) : n : e);
}, WF = "gs-cmp-topbar-right", GF = xe(function({
  editor: t,
  className: n,
  buttons: r,
  ...o
}) {
  var Z;
  const i = Re(), { theme: l, setTheme: c } = gr(), { Commands: d, UndoManager: p } = t, { installEvent: g, appInstalled: m, isBrowserMode: v, setInstallEvent: b, sdkOptions: x, isProjectTypeEmail: w } = i, j = os(), C = qe(), E = (K) => C.t(`actions.${K}`), P = (Z = x.commands) == null ? void 0 : Z.options, k = t.Storage.events, T = d.events, O = "change:changesCount", A = (K, H) => () => {
    Ct(K) ? K({ editor: t }) : d.isActive(K) ? d.stop(K) : d.run(K, H);
  }, $ = (K) => ({
    [`${T.runCommand}${K}`]: ({ setState: H }) => H({ active: !0 }),
    [`${T.stopCommand}${K}`]: ({ setState: H }) => H({ active: !1 })
  }), N = [
    {
      id: po.componentOutline,
      icon: fe.borderRadius,
      tooltip: E("componentOutline.title"),
      onClick: A("core:component-outline"),
      editorEvents: $("core:component-outline")
    },
    {
      id: po.preview,
      icon: fe.eye,
      tooltip: E("preview.title"),
      onClick: A("core:preview"),
      editorEvents: $("core:preview")
    },
    {
      id: po.fullscreen,
      icon: fe.arrowExpandAll,
      tooltip: E("fullscreen.title"),
      onClick: A("core:fullscreen", { target: "body" }),
      editorEvents: $("core:fullscreen")
    },
    {
      id: po.showCode,
      icon: fe.xml,
      tooltip: E("showCode.title"),
      onClick: () => j.open({
        title: E("showCode.title"),
        content: () => /* @__PURE__ */ u.jsx(HH, { options: P == null ? void 0 : P[po.showCode] })
      })
    },
    {
      id: po.showImportCode,
      icon: fe.trayArrowDown,
      tooltip: E("importCode.title"),
      onClick: () => j.open({
        title: E("importCode.title"),
        content: () => /* @__PURE__ */ u.jsx(qE, {})
      })
    },
    {
      id: po.clearCanvas,
      icon: fe.delete,
      tooltip: E("clearCanvas.title"),
      onClick: () => j.confirm({
        title: E("clearCanvas.title"),
        content: E("clearCanvas.content"),
        confirmButton: { variant: "danger", children: E("clearCanvas.title") },
        onConfirm: () => {
          w ? t.loadProjectData({ pages: [{ component: "<mjml><mj-body></mj-body></mjml>" }] }) : t.Components.clear();
        }
      })
    },
    {
      id: po.store,
      tooltip: E("store.title"),
      onClick: async () => !i.isSaving && t.store(),
      editorEvents: {
        "change:changesCount": ({ setState: K }) => K({}),
        [k.startStore]: ({ setState: K }) => K({ disabled: !0 }),
        [k.endStore]: ({ setState: K }) => K({ disabled: !1 })
      },
      label: () => /* @__PURE__ */ u.jsxs("div", { className: ce("relative"), children: [
        /* @__PURE__ */ u.jsx(ye, { icon: fe.floppy, size: Ee.s }),
        !!t.getDirtyCount() && !i.isSaving && /* @__PURE__ */ u.jsx("div", { className: ce("absolute right-0 gjs-p-0.5 bottom-0 gjs-rounded-full", ee.bg), children: /* @__PURE__ */ u.jsx("div", { className: ce(nt.dot, ee.bgW) }) }),
        i.isSaving && /* @__PURE__ */ u.jsx("div", { className: ce("absolute right-0 bottom-0 gjs-rounded-full", ee.bg), children: /* @__PURE__ */ u.jsx(ye, { icon: fe.refresh, size: "11px", className: ce(nt.spin) }) })
      ] })
    },
    {
      id: po.undo,
      icon: fe.arrowULeftTop,
      disabled: !0,
      onClick: A("core:undo"),
      editorEvents: {
        [O]: ({ setState: K }) => K({ disabled: !p.hasUndo() })
      }
    },
    {
      id: po.redo,
      icon: fe.arrowURightTop,
      disabled: !0,
      onClick: A("core:redo"),
      editorEvents: {
        [O]: ({ setState: K }) => K({ disabled: !p.hasRedo() })
      }
    }
  ], R = UF({ actions: N, sdkOptions: x, editor: t, buttons: r }), z = [
    {
      id: "about",
      label: E("about.title"),
      icon: fe.helpCircle,
      action: () => j.open({
        size: "m",
        title: E("about.title"),
        content: () => /* @__PURE__ */ u.jsx(IH, {})
      })
    },
    {
      id: "embed",
      label: E("embed.title"),
      icon: fe.powerPlug,
      action: () => j.open({
        size: "m",
        title: E("embed.title"),
        content: () => /* @__PURE__ */ u.jsx(VH, {})
      })
    },
    {
      id: "openProject",
      label: E("open.title"),
      icon: fe.folder,
      action: async () => {
        let K = "";
        try {
          K = await (await wH({ extensions: [o1] })).text();
        } catch (H) {
          return console.error(H);
        }
        i.loadProjectData(JSON.parse(K));
      }
    },
    {
      id: "saveProject",
      label: E("save.title"),
      icon: fe.contentSave,
      action: async () => {
        const K = t.getProjectData(), H = new Blob([JSON.stringify(K)]), q = `Untitled-${(/* @__PURE__ */ new Date()).toISOString().replace("T", "-").replace(/:|\./g, "").substring(0, 17)}`;
        try {
          await jH(H, {
            fileName: `${q}${o1}`,
            extensions: [o1]
          });
        } catch (te) {
          return console.error(te);
        }
      }
    },
    // {
    //     id: 'shortcuts',
    //     label: 'Shortcuts',
    //     icon: IconNames.keyboard,
    //     action: () => alert('Open shortcuts'),
    // },
    {
      id: "loadProject",
      label: E("newProject.title"),
      icon: fe.newspaperVariantOutline,
      action: () => j.open({
        fullH: !0,
        title: E("newProject.title"),
        content: () => /* @__PURE__ */ u.jsx(HF, {})
      })
    },
    {
      id: "installApp",
      label: E(m ? "installApp.installed" : "installApp.title"),
      icon: fe.applicationBracketsOutline,
      action: async () => {
        if (m)
          return;
        g == null || g.prompt();
        const K = await (g == null ? void 0 : g.userChoice);
        (K == null ? void 0 : K.outcome) === "accepted" && b();
      }
    },
    ...x.customTheme ? [] : [
      {
        id: "theme",
        label: /* @__PURE__ */ u.jsxs(G, { items: "center", space: "m", children: [
          /* @__PURE__ */ u.jsx(Y, { children: "Theme" }),
          /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
            Ds,
            {
              tabs: FF,
              onChange: (K) => c(K),
              value: l,
              variant: "pills"
            }
          ) })
        ] })
      }
    ]
  ].filter(({ id: K }) => !((!v || !g) && K === "installApp" || !BF(x, K))), D = (K, H) => (q) => {
    Ct(K) && (K(q), H());
  };
  return /* @__PURE__ */ u.jsxs(G, { space: "s", items: "center", justify: "end", className: ce(WF, tt.xS, n), nowrap: !0, ...o, children: [
    R.map(({ id: K, ...H }) => /* @__PURE__ */ u.jsx(Xp, { size: "s", ...H }, K)),
    /* @__PURE__ */ u.jsx(Y, { children: x.settingsMenu !== !1 && z.length > 0 && /* @__PURE__ */ u.jsx(
      rs,
      {
        placement: "bottom-end",
        title: !1,
        padding: !1,
        handler: /* @__PURE__ */ u.jsx(ye, { icon: fe.cog, size: Ee.s }),
        buttonProps: zF,
        overlay: !0,
        children: ({ close: K }) => /* @__PURE__ */ u.jsx(u.Fragment, { children: z.map((H) => /* @__PURE__ */ u.jsx(
          Bu,
          {
            action: D(H.action, K),
            icon: H.icon,
            label: H.label
          },
          H.id
        )) })
      }
    ) })
  ] });
}), KF = ({
  items: e,
  editor: t,
  customItems: n
}) => n === !1 ? [] : Ct(n) ? n({ items: e, editor: t }) : n || e, S2 = (e) => ({
  icon: fe.plus,
  size: Ee.s,
  className: ce("gs-utl-transition-transform", e && "gs-utl-rotate-45")
}), qF = "gs-cmp-topbar-left", YF = xe(function({
  buttons: t,
  className: n,
  style: r
}) {
  const o = Re(), i = qe(), { isOpen: l, toggleOpen: c } = LE(), d = o.editor, g = i.tScoped("blockManager")("blocks"), m = KF({
    items: [
      {
        id: `blocks-${g}`,
        tooltip: g,
        size: fE.s,
        icon: S2(l),
        variant: dE.primary,
        editorEvents: {
          [kr.toggleBlocksPanel]: ({ fromEvent: v, setState: b }) => {
            b({ icon: S2(v.isOpen) });
          }
        },
        onClick: () => c()
      }
    ],
    customItems: t,
    editor: d
  });
  return /* @__PURE__ */ u.jsx(G, { space: "s", items: "center", justify: "start", className: ce(qF, tt.xS, n), style: r, nowrap: !0, children: m.map(({ id: v, ...b }) => /* @__PURE__ */ u.jsx(Xp, { ...b }, v)) });
});
function XF({ devices: e, selected: t, className: n, style: r, select: o }) {
  const i = e.map((l) => ({
    id: l.id,
    label: l.getName(),
    icon: l.attributes.icon
  }));
  return i.length ? /* @__PURE__ */ u.jsx(
    Ze,
    {
      size: "xs",
      className: n,
      style: r,
      value: t,
      options: i,
      onChange: o
    }
  ) : null;
}
const ZF = "gs-devices", hP = y.memo(function({ className: t, style: n }) {
  return /* @__PURE__ */ u.jsx(MD, { children: (r) => /* @__PURE__ */ u.jsx(XF, { className: B(ZF, t), style: n, ...r }) });
}), Rc = "gs-cmp-editor-topbar", JF = xe(function({
  className: t,
  height: n,
  style: r,
  children: o,
  leftContainer: i,
  rightContainer: l,
  devices: c
}) {
  const { topBarSize: d, isInPreview: p, editor: g, isTopSidebarOpen: m } = Re(), v = n ?? d, b = y.useMemo(
    () => ({
      ...r,
      minHeight: v,
      marginTop: p || !m ? `-${v}px` : 0
    }),
    [p, m, r]
  );
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      Y,
      {
        className: B(Rc, "gs-utl-transition-spacing gs-utl-w-full", ve.bb, ee.br, t),
        style: b,
        children: o ?? /* @__PURE__ */ u.jsxs(G, { className: B(`${Rc}__wrp`, "gs-utl-h-full"), items: "center", full: !0, nowrap: !0, children: [
          /* @__PURE__ */ u.jsx(Y, { className: B(`${Rc}__wrp-left`), grow: !0, children: i !== !1 && /* @__PURE__ */ u.jsx(YF, { ...i }) }),
          /* @__PURE__ */ u.jsx(Y, { className: B(`${Rc}__wrp-center`), children: c !== !1 && /* @__PURE__ */ u.jsx(hP, { ...c }) }),
          /* @__PURE__ */ u.jsx(Y, { className: B(`${Rc}__wrp-right`), grow: !0, children: l !== !1 && g && /* @__PURE__ */ u.jsx(GF, { editor: g, ...l }) })
        ] })
      }
    ),
    /* @__PURE__ */ u.jsx(
      Y,
      {
        className: B(
          "gs-utl-transition-transform gs-utl-absolute gs-utl-top-0 gs-utl-left-0 gs-utl-z-10",
          !p && "-gs-utl-translate-y-full"
        ),
        children: /* @__PURE__ */ u.jsx(
          ut,
          {
            className: B("gs-cmp-close-preview gs-utl-m-4", ee.bg),
            size: "s",
            onClick: () => g == null ? void 0 : g.Commands.stop("core:preview"),
            children: /* @__PURE__ */ u.jsx(ye, { icon: fe.eyeOff, size: Ee.s })
          }
        )
      }
    )
  ] });
}), QF = "gs-sidebar-top", mP = y.memo(
  xe(function({ height: t, children: n, ...r }) {
    return /* @__PURE__ */ u.jsx(
      JF,
      {
        height: t,
        ...r,
        style: hg(r),
        className: B(QF, "gs-utl-flex", gg(r)),
        children: n ? Xn(n) : void 0
      }
    );
  })
), ez = "gs-canvas-sidebar-top", tz = y.memo(
  xe(function({ className: t, sidebarTop: n, ...r }) {
    return /* @__PURE__ */ u.jsxs(Rr, { className: B(ez, "gs-utl-flex gs-utl-flex-col", t), grow: !0, ...r, children: [
      /* @__PURE__ */ u.jsx(mP, { ...n }),
      /* @__PURE__ */ u.jsx(Y5, { grow: !0 })
    ] });
  })
), nz = "gs-cmp-column", rz = y.memo(function({ className: t, children: n, full: r, ...o }) {
  return /* @__PURE__ */ u.jsx(
    Rr,
    {
      className: B(nz, ee.bg, "gs-utl-flex gs-utl-flex-col", r && "gs-utl-h-full", t),
      ...o,
      children: Xn(n)
    }
  );
}), oz = "gs-cmp-input-field", sz = y.memo(
  xe(function({
    className: t,
    style: n,
    label: r,
    name: o,
    value: i,
    size: l,
    disabled: c,
    inputType: d,
    readOnly: p,
    required: g,
    placeholder: m,
    onChange: v,
    onInput: b,
    editorEvents: x
  }) {
    const { editor: w } = Re(), [j, C] = y.useState(() => ({
      className: t,
      style: n,
      label: r,
      name: o,
      value: i,
      size: l,
      readOnly: p,
      disabled: c,
      required: g,
      placeholder: m
    })), E = (T) => ({
      value: T,
      editor: w,
      state: j,
      setState: (O) => C((A) => ({ ...A, ...O }))
    }), P = (T) => v == null ? void 0 : v(E(T)), k = (T) => b == null ? void 0 : b(E(T));
    return Ul({
      editor: w,
      editorEvents: x,
      localState: j,
      setLocalState: C
    }), /* @__PURE__ */ u.jsx(
      jt,
      {
        type: d,
        className: B(oz, j.className),
        style: j.style,
        label: j.label,
        name: j.name,
        value: j.value,
        size: j.size,
        required: j.required,
        disabled: j.disabled,
        readOnly: j.readOnly,
        placeholder: j.placeholder,
        onChange: P,
        onInput: k
      }
    );
  })
);
function iz({ children: e, accept: t, onChange: n, multiple: r = !0, ...o }) {
  const i = qe(), l = y.useRef(null), c = () => {
    const { current: d } = l;
    d && (d.value = "", d.click());
  };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(
      "input",
      {
        className: ce("hidden"),
        ref: l,
        type: "file",
        multiple: r,
        accept: t,
        onChange: n
      }
    ),
    /* @__PURE__ */ u.jsx(ut, { variant: "pr", size: "m2", ...o, onClick: c, children: e || i.t("upload") })
  ] });
}
const az = xe(iz), lz = xe(function({
  editor: t,
  assetProps: n,
  itemLayout: r,
  onSelect: o,
  onRemove: i
}) {
  const l = xa();
  return Xn(
    r({
      asset: gi(l.toAsset(n)),
      assetProps: gi(n),
      onSelect: (c) => o(l.toAssetProps(c)),
      onDelete: i && ((c) => i(l.toAssetProps(c))),
      editor: t
    })
  );
}), cz = "gs-cmp-asset-card", uz = xe(function(t) {
  var m;
  const { assetProps: n, onSelect: r, onRemove: o, className: i, itemLayout: l } = t, c = qe(), { editor: d } = Re();
  if (l)
    return d ? /* @__PURE__ */ u.jsx(lz, { ...t, editor: d, itemLayout: l }) : null;
  const { src: p } = n, g = n.name || ((m = p.split("/").pop()) == null ? void 0 : m.split("?").shift());
  return /* @__PURE__ */ u.jsx(pr, { padding: !1, className: ge(cz, "overflow-hidden max-w-full group", i), children: /* @__PURE__ */ u.jsxs(G, { col: !0, children: [
    /* @__PURE__ */ u.jsxs(Y, { className: ge("relative group h-24 cursor-pointer bg-checker"), onClick: () => r(n), children: [
      /* @__PURE__ */ u.jsx(
        "div",
        {
          className: ge("w-full h-full bg-contain bg-no-repeat bg-center"),
          style: { backgroundImage: `url("${p}")` }
        }
      ),
      /* @__PURE__ */ u.jsx(
        G,
        {
          justify: "center",
          items: "center",
          className: ge(nt.coverAbs, ee.bgH75, "group-hover:gs-utl-opacity-100 opacity-0 transition-opacity"),
          children: /* @__PURE__ */ u.jsx(ut, { className: ge("text-sm"), size: "m2", variant: "pr", children: c.t("select") })
        }
      )
    ] }),
    /* @__PURE__ */ u.jsxs(G, { className: ge("gjs-p-1 max-w-full"), space: "s", items: "center", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(Y, { className: ge(nt.txtEllips, "text-sm gjs-mr-auto"), children: g }),
      o && /* @__PURE__ */ u.jsx(
        ny,
        {
          onConfirm: () => o == null ? void 0 : o(n),
          text: /* @__PURE__ */ u.jsxs(G, { col: !0, space: "m", items: "stretch", children: [
            /* @__PURE__ */ u.jsx("p", { className: ge("text-center", ee.txtHighEmphasis), children: c.t("assetManager.deleteConfirmQuestion") }),
            /* @__PURE__ */ u.jsx("p", { className: ge("text-center"), children: c.t("assetManager.deleteConfirmExplanation") })
          ] }),
          confirmButtonProps: { variant: "danger" },
          children: /* @__PURE__ */ u.jsx(Qt, { title: c.t("delete"), children: /* @__PURE__ */ u.jsx(ye, { icon: fe.delete, size: Ee.sx }) })
        }
      )
    ] })
  ] }) });
}), s1 = "gs-asset-manager", dz = {
  search: !0,
  addUrl: !0,
  upload: !0
}, fz = xe(function({
  assetProps: t,
  typeFilterOptions: n,
  providerFilterOptions: r,
  typeFilter: o,
  providerFilter: i,
  searchValue: l,
  isLoading: c,
  optionalType: d,
  optionalProvider: p,
  useLocalSearch: g,
  itemLayout: m,
  content: v,
  onSelect: b,
  onChangeTypeFilter: x,
  onChangeProviderFilter: w,
  onChangeSearchValue: j,
  onChangeUpload: C,
  onAddUrl: E,
  onRemove: P,
  onEndReached: k
}) {
  const T = Re(), { editor: O } = T, A = qe(), [$] = fg(), N = ty(v == null ? void 0 : v.itemsPerRow), [R, z] = y.useState(""), D = (v == null ? void 0 : v.header) === !1 ? !1 : { ...dz, ...Qo(v == null ? void 0 : v.header) ? v.header : {} };
  if (!O)
    return;
  const Z = g ? t.filter((K) => !(l && !ll(K.src, l) && !ll(K.name ?? "", l))) : t;
  return /* @__PURE__ */ u.jsxs(G, { className: ce(s1, "relative gs-utl-h-full", c && nt.disabled), nowrap: !0, col: !0, space: "m", children: [
    D !== !1 && /* @__PURE__ */ u.jsxs(G, { className: ce(`${s1}__header`, "gs-utl-gap-4"), justify: "between", items: "center", children: [
      /* @__PURE__ */ u.jsxs(G, { items: "center", space: "m", children: [
        D.search && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
          jt,
          {
            size: "s",
            type: "search",
            value: l,
            onInput: j,
            placeholder: `${A.t("search")}...`
          }
        ) }),
        n.length > (d ? 0 : 1) && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
          Ze,
          {
            className: ce("items-center"),
            size: "m",
            options: n,
            value: o,
            onChange: x,
            emptyState: A.t("assetManager.assetTypes.all"),
            includeEmpty: d
          }
        ) }),
        r.length > (p ? 0 : 1) && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
          Ze,
          {
            className: ce("items-center"),
            size: "m",
            options: r.map((K) => ({
              ...K,
              label: Ct(K.label) ? K.label({ editor: O }) : K.label
            })),
            value: i,
            onChange: w,
            emptyState: A.t("assetManager.noProvider"),
            includeEmpty: p
          }
        ) })
      ] }),
      /* @__PURE__ */ u.jsxs(G, { items: "center", space: "m", children: [
        D.upload && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(az, { onChange: C }) }),
        D.addUrl && !!E && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
          rs,
          {
            overlay: !0,
            placement: "bottom-end",
            title: !1,
            buttonAs: "span",
            handler: /* @__PURE__ */ u.jsx(ut, { variant: "pr", size: "m2", children: A.t("assetManager.addUrl") }),
            children: ({ close: K }) => /* @__PURE__ */ u.jsxs(G, { space: "m", children: [
              /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
                jt,
                {
                  type: "url",
                  size: "s",
                  value: R,
                  onChange: z,
                  placeholder: A.t("assetManager.inputPlh")
                }
              ) }),
              /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
                ut,
                {
                  variant: "pr",
                  size: "m2",
                  onClick: () => {
                    E(R), K();
                  },
                  children: A.t("add")
                }
              ) })
            ] })
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ u.jsx(G, { className: ce(`${s1}__content`, "gs-utl-h-[75vh] gs-utl-flex-grow"), space: "m", col: !0, nowrap: !0, children: !c && !Z.length ? /* @__PURE__ */ u.jsx(G, { justify: "center", children: A.t("noItems") }) : (
      // Ensure  to render Virtuoso when the transition ends to avoid "holes" in the grid
      !!$ && /* @__PURE__ */ u.jsx(
        Qu,
        {
          data: Z,
          listClassName: ce("gs-utl-grid gs-utl-gap-2", N),
          endReached: k,
          itemContent: (K, H) => /* @__PURE__ */ u.jsx(
            uz,
            {
              assetProps: H,
              onSelect: b,
              onRemove: P,
              itemLayout: m
            },
            H.id
          ),
          components: { Footer: k ? pz : void 0 }
        }
      )
    ) }),
    c && /* @__PURE__ */ u.jsx(Ju, { abs: !0 })
  ] });
}), pz = () => /* @__PURE__ */ u.jsx(
  "div",
  {
    style: {
      padding: "2rem",
      display: "flex",
      justifyContent: "center",
      height: 200
    }
  }
), vP = xe(function({
  panelId: t,
  content: n,
  assets: r,
  types: o,
  providers: i,
  typeId: l,
  providerId: c,
  optionalType: d,
  optionalProvider: p,
  onSelect: g,
  close: m
}) {
  const { appEditorStore: v, i18nStore: b } = Nn(), { editor: x } = v, w = xa(), { customOnLoad: j } = w, C = CE(t);
  y.useEffect(() => {
    const O = ($) => Dt($) ? { id: $, label: b.t(`assetManager.assetTypes.${$}`) || $ } : $;
    C.setCustomTypes(o == null ? void 0 : o.map(O)), C.setCustomProviders(Dt(i) ? [i] : i), l ? C.setTypeFilter(l) : C.initTypeFilter(), c ? C.setProviderFilter(c) : C.initProviderFilter(), d ? C.setOptionalType(d) : C.initOptionalType(), p ? C.setOptionalProvider(p) : C.initOptionalProvider();
    const A = setTimeout(() => C.loadAssets());
    return () => clearTimeout(A);
  }, [o, i, l, c, d, p]);
  const E = (O) => {
    w.addToProjectAssets([{ id: O, src: O, type: C.typeFilter ?? oa.image }]);
  }, P = (O) => {
    x && (g == null || g({ asset: w.toAsset(O), assetProps: O, editor: x }), m == null || m());
  }, k = r == null ? void 0 : r.map(w.toAssetProps), T = C.shouldLoadNextPage ? () => C.loadAssets(!1) : void 0;
  return /* @__PURE__ */ u.jsx(
    fz,
    {
      assetProps: k ?? C.assetProps,
      typeFilter: C.typeFilter,
      typeFilterOptions: C.typeFilterOptions,
      providerFilter: C.providerFilter,
      providerFilterOptions: C.providerFilterOptions,
      searchValue: C.searchValue,
      onChangeTypeFilter: (O) => {
        C.setTypeFilter(O), C.loadAssets();
      },
      onChangeProviderFilter: (O) => {
        C.setProviderFilter(O), C.loadAssets();
      },
      onChangeSearchValue: C.setSearchValue,
      onSelect: P,
      onAddUrl: j ? void 0 : E,
      onChangeUpload: (O) => w.uploadFile(O.nativeEvent),
      onRemove: k ? void 0 : C.handleDelete,
      onEndReached: T,
      isLoading: C.isLoading,
      itemLayout: C.itemLayout,
      content: n,
      optionalType: C.optionalType,
      optionalProvider: C.optionalProvider,
      useLocalSearch: !C.reloadOnInput
    }
  );
});
var gz = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), un = globalThis && globalThis.__assign || function() {
  return un = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, un.apply(this, arguments);
}, j2 = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, C2 = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, $f = {
  width: "20px",
  height: "20px",
  position: "absolute"
}, hz = {
  top: un(un({}, j2), { top: "-5px" }),
  right: un(un({}, C2), { left: void 0, right: "-5px" }),
  bottom: un(un({}, j2), { top: void 0, bottom: "-5px" }),
  left: un(un({}, C2), { left: "-5px" }),
  topRight: un(un({}, $f), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: un(un({}, $f), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: un(un({}, $f), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: un(un({}, $f), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, mz = (
  /** @class */
  function(e) {
    gz(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onMouseDown = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n.onTouchStart = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n;
    }
    return t.prototype.render = function() {
      return y.createElement("div", { className: this.props.className || "", style: un(un({ position: "absolute", userSelect: "none" }, hz[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, t;
  }(y.PureComponent)
), vz = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Io = globalThis && globalThis.__assign || function() {
  return Io = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, Io.apply(this, arguments);
}, yz = {
  width: "auto",
  height: "auto"
}, Df = function(e, t, n) {
  return Math.max(Math.min(e, n), t);
}, E2 = function(e, t, n) {
  var r = Math.round(e / t);
  return r * t + n * (r - 1);
}, Ja = function(e, t) {
  return new RegExp(e, "i").test(t);
}, If = function(e) {
  return !!(e.touches && e.touches.length);
}, bz = function(e) {
  return !!((e.clientX || e.clientX === 0) && (e.clientY || e.clientY === 0));
}, P2 = function(e, t, n) {
  n === void 0 && (n = 0);
  var r = t.reduce(function(i, l, c) {
    return Math.abs(l - e) < Math.abs(t[i] - e) ? c : i;
  }, 0), o = Math.abs(t[r] - e);
  return n === 0 || o < n ? t[r] : e;
}, i1 = function(e) {
  return e = e.toString(), e === "auto" || e.endsWith("px") || e.endsWith("%") || e.endsWith("vh") || e.endsWith("vw") || e.endsWith("vmax") || e.endsWith("vmin") ? e : e + "px";
}, Vf = function(e, t, n, r) {
  if (e && typeof e == "string") {
    if (e.endsWith("px"))
      return Number(e.replace("px", ""));
    if (e.endsWith("%")) {
      var o = Number(e.replace("%", "")) / 100;
      return t * o;
    }
    if (e.endsWith("vw")) {
      var o = Number(e.replace("vw", "")) / 100;
      return n * o;
    }
    if (e.endsWith("vh")) {
      var o = Number(e.replace("vh", "")) / 100;
      return r * o;
    }
  }
  return e;
}, xz = function(e, t, n, r, o, i, l) {
  return r = Vf(r, e.width, t, n), o = Vf(o, e.height, t, n), i = Vf(i, e.width, t, n), l = Vf(l, e.height, t, n), {
    maxWidth: typeof r > "u" ? void 0 : Number(r),
    maxHeight: typeof o > "u" ? void 0 : Number(o),
    minWidth: typeof i > "u" ? void 0 : Number(i),
    minHeight: typeof l > "u" ? void 0 : Number(l)
  };
}, wz = function(e) {
  return Array.isArray(e) ? e : [e, e];
}, Sz = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], _2 = "__resizable_base__", jz = (
  /** @class */
  function(e) {
    vz(t, e);
    function t(n) {
      var r, o, i, l, c = e.call(this, n) || this;
      return c.ratio = 1, c.resizable = null, c.parentLeft = 0, c.parentTop = 0, c.resizableLeft = 0, c.resizableRight = 0, c.resizableTop = 0, c.resizableBottom = 0, c.targetLeft = 0, c.targetTop = 0, c.appendBase = function() {
        if (!c.resizable || !c.window)
          return null;
        var d = c.parentNode;
        if (!d)
          return null;
        var p = c.window.document.createElement("div");
        return p.style.width = "100%", p.style.height = "100%", p.style.position = "absolute", p.style.transform = "scale(0, 0)", p.style.left = "0", p.style.flex = "0 0 100%", p.classList ? p.classList.add(_2) : p.className += _2, d.appendChild(p), p;
      }, c.removeBase = function(d) {
        var p = c.parentNode;
        p && p.removeChild(d);
      }, c.state = {
        isResizing: !1,
        width: (o = (r = c.propsSize) === null || r === void 0 ? void 0 : r.width) !== null && o !== void 0 ? o : "auto",
        height: (l = (i = c.propsSize) === null || i === void 0 ? void 0 : i.height) !== null && l !== void 0 ? l : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, c.onResizeStart = c.onResizeStart.bind(c), c.onMouseMove = c.onMouseMove.bind(c), c.onMouseUp = c.onMouseUp.bind(c), c;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || yz;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
      get: function() {
        var n = 0, r = 0;
        if (this.resizable && this.window) {
          var o = this.resizable.offsetWidth, i = this.resizable.offsetHeight, l = this.resizable.style.position;
          l !== "relative" && (this.resizable.style.position = "relative"), n = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : o, r = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : i, this.resizable.style.position = l;
        }
        return { width: n, height: r };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sizeStyle", {
      get: function() {
        var n = this, r = this.props.size, o = function(c) {
          var d;
          if (typeof n.state[c] > "u" || n.state[c] === "auto")
            return "auto";
          if (n.propsSize && n.propsSize[c] && (!((d = n.propsSize[c]) === null || d === void 0) && d.toString().endsWith("%"))) {
            if (n.state[c].toString().endsWith("%"))
              return n.state[c].toString();
            var p = n.getParentSize(), g = Number(n.state[c].toString().replace("px", "")), m = g / p[c] * 100;
            return m + "%";
          }
          return i1(n.state[c]);
        }, i = r && typeof r.width < "u" && !this.state.isResizing ? i1(r.width) : o("width"), l = r && typeof r.height < "u" && !this.state.isResizing ? i1(r.height) : o("height");
        return { width: i, height: l };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var n = this.appendBase();
      if (!n)
        return { width: 0, height: 0 };
      var r = !1, o = this.parentNode.style.flexWrap;
      o !== "wrap" && (r = !0, this.parentNode.style.flexWrap = "wrap"), n.style.position = "relative", n.style.minWidth = "100%", n.style.minHeight = "100%";
      var i = {
        width: n.offsetWidth,
        height: n.offsetHeight
      };
      return r && (this.parentNode.style.flexWrap = o), this.removeBase(n), i;
    }, t.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, t.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, t.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var n = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: n.flexBasis !== "auto" ? n.flexBasis : void 0
        });
      }
    }, t.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, t.prototype.createSizeForCssProperty = function(n, r) {
      var o = this.propsSize && this.propsSize[r];
      return this.state[r] === "auto" && this.state.original[r] === n && (typeof o > "u" || o === "auto") ? "auto" : n;
    }, t.prototype.calculateNewMaxFromBoundary = function(n, r) {
      var o = this.props.boundsByDirection, i = this.state.direction, l = o && Ja("left", i), c = o && Ja("top", i), d, p;
      if (this.props.bounds === "parent") {
        var g = this.parentNode;
        g && (d = l ? this.resizableRight - this.parentLeft : g.offsetWidth + (this.parentLeft - this.resizableLeft), p = c ? this.resizableBottom - this.parentTop : g.offsetHeight + (this.parentTop - this.resizableTop));
      } else
        this.props.bounds === "window" ? this.window && (d = l ? this.resizableRight : this.window.innerWidth - this.resizableLeft, p = c ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (d = l ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), p = c ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return d && Number.isFinite(d) && (n = n && n < d ? n : d), p && Number.isFinite(p) && (r = r && r < p ? r : p), { maxWidth: n, maxHeight: r };
    }, t.prototype.calculateNewSizeFromDirection = function(n, r) {
      var o = this.props.scale || 1, i = wz(this.props.resizeRatio || 1), l = i[0], c = i[1], d = this.state, p = d.direction, g = d.original, m = this.props, v = m.lockAspectRatio, b = m.lockAspectRatioExtraHeight, x = m.lockAspectRatioExtraWidth, w = g.width, j = g.height, C = b || 0, E = x || 0;
      return Ja("right", p) && (w = g.width + (n - g.x) * l / o, v && (j = (w - E) / this.ratio + C)), Ja("left", p) && (w = g.width - (n - g.x) * l / o, v && (j = (w - E) / this.ratio + C)), Ja("bottom", p) && (j = g.height + (r - g.y) * c / o, v && (w = (j - C) * this.ratio + E)), Ja("top", p) && (j = g.height - (r - g.y) * c / o, v && (w = (j - C) * this.ratio + E)), { newWidth: w, newHeight: j };
    }, t.prototype.calculateNewSizeFromAspectRatio = function(n, r, o, i) {
      var l = this.props, c = l.lockAspectRatio, d = l.lockAspectRatioExtraHeight, p = l.lockAspectRatioExtraWidth, g = typeof i.width > "u" ? 10 : i.width, m = typeof o.width > "u" || o.width < 0 ? n : o.width, v = typeof i.height > "u" ? 10 : i.height, b = typeof o.height > "u" || o.height < 0 ? r : o.height, x = d || 0, w = p || 0;
      if (c) {
        var j = (v - x) * this.ratio + w, C = (b - x) * this.ratio + w, E = (g - w) / this.ratio + x, P = (m - w) / this.ratio + x, k = Math.max(g, j), T = Math.min(m, C), O = Math.max(v, E), A = Math.min(b, P);
        n = Df(n, k, T), r = Df(r, O, A);
      } else
        n = Df(n, g, m), r = Df(r, v, b);
      return { newWidth: n, newHeight: r };
    }, t.prototype.setBoundingClientRect = function() {
      var n = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var r = this.parentNode;
        if (r) {
          var o = r.getBoundingClientRect();
          this.parentLeft = o.left * n, this.parentTop = o.top * n;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var i = this.props.bounds.getBoundingClientRect();
        this.targetLeft = i.left * n, this.targetTop = i.top * n;
      }
      if (this.resizable) {
        var l = this.resizable.getBoundingClientRect(), c = l.left, d = l.top, p = l.right, g = l.bottom;
        this.resizableLeft = c * n, this.resizableRight = p * n, this.resizableTop = d * n, this.resizableBottom = g * n;
      }
    }, t.prototype.onResizeStart = function(n, r) {
      if (!(!this.resizable || !this.window)) {
        var o = 0, i = 0;
        if (n.nativeEvent && bz(n.nativeEvent) ? (o = n.nativeEvent.clientX, i = n.nativeEvent.clientY) : n.nativeEvent && If(n.nativeEvent) && (o = n.nativeEvent.touches[0].clientX, i = n.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var l = this.props.onResizeStart(n, r, this.resizable);
          if (l === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var c, d = this.window.getComputedStyle(this.resizable);
        if (d.flexBasis !== "auto") {
          var p = this.parentNode;
          if (p) {
            var g = this.window.getComputedStyle(p).flexDirection;
            this.flexDir = g.startsWith("row") ? "row" : "column", c = d.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var m = {
          original: {
            x: o,
            y: i,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: Io(Io({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(n.target).cursor || "auto" }),
          direction: r,
          flexBasis: c
        };
        this.setState(m);
      }
    }, t.prototype.onMouseMove = function(n) {
      var r = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && If(n))
          try {
            n.preventDefault(), n.stopPropagation();
          } catch {
          }
        var o = this.props, i = o.maxWidth, l = o.maxHeight, c = o.minWidth, d = o.minHeight, p = If(n) ? n.touches[0].clientX : n.clientX, g = If(n) ? n.touches[0].clientY : n.clientY, m = this.state, v = m.direction, b = m.original, x = m.width, w = m.height, j = this.getParentSize(), C = xz(j, this.window.innerWidth, this.window.innerHeight, i, l, c, d);
        i = C.maxWidth, l = C.maxHeight, c = C.minWidth, d = C.minHeight;
        var E = this.calculateNewSizeFromDirection(p, g), P = E.newHeight, k = E.newWidth, T = this.calculateNewMaxFromBoundary(i, l);
        this.props.snap && this.props.snap.x && (k = P2(k, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (P = P2(P, this.props.snap.y, this.props.snapGap));
        var O = this.calculateNewSizeFromAspectRatio(k, P, { width: T.maxWidth, height: T.maxHeight }, { width: c, height: d });
        if (k = O.newWidth, P = O.newHeight, this.props.grid) {
          var A = E2(k, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), $ = E2(P, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), N = this.props.snapGap || 0, R = N === 0 || Math.abs(A - k) <= N ? A : k, z = N === 0 || Math.abs($ - P) <= N ? $ : P;
          k = R, P = z;
        }
        var D = {
          width: k - b.width,
          height: P - b.height
        };
        if (x && typeof x == "string") {
          if (x.endsWith("%")) {
            var Z = k / j.width * 100;
            k = Z + "%";
          } else if (x.endsWith("vw")) {
            var K = k / this.window.innerWidth * 100;
            k = K + "vw";
          } else if (x.endsWith("vh")) {
            var H = k / this.window.innerHeight * 100;
            k = H + "vh";
          }
        }
        if (w && typeof w == "string") {
          if (w.endsWith("%")) {
            var Z = P / j.height * 100;
            P = Z + "%";
          } else if (w.endsWith("vw")) {
            var K = P / this.window.innerWidth * 100;
            P = K + "vw";
          } else if (w.endsWith("vh")) {
            var H = P / this.window.innerHeight * 100;
            P = H + "vh";
          }
        }
        var q = {
          width: this.createSizeForCssProperty(k, "width"),
          height: this.createSizeForCssProperty(P, "height")
        };
        this.flexDir === "row" ? q.flexBasis = q.width : this.flexDir === "column" && (q.flexBasis = q.height);
        var te = this.state.width !== q.width, I = this.state.height !== q.height, F = this.state.flexBasis !== q.flexBasis, V = te || I || F;
        V && Cr.flushSync(function() {
          r.setState(q);
        }), this.props.onResize && V && this.props.onResize(n, v, this.resizable, D);
      }
    }, t.prototype.onMouseUp = function(n) {
      var r, o, i = this.state, l = i.isResizing, c = i.direction, d = i.original;
      if (!(!l || !this.resizable)) {
        var p = {
          width: this.size.width - d.width,
          height: this.size.height - d.height
        };
        this.props.onResizeStop && this.props.onResizeStop(n, c, this.resizable, p), this.props.size && this.setState({ width: (r = this.props.size.width) !== null && r !== void 0 ? r : "auto", height: (o = this.props.size.height) !== null && o !== void 0 ? o : "auto" }), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: Io(Io({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, t.prototype.updateSize = function(n) {
      var r, o;
      this.setState({ width: (r = n.width) !== null && r !== void 0 ? r : "auto", height: (o = n.height) !== null && o !== void 0 ? o : "auto" });
    }, t.prototype.renderResizer = function(n) {
      var r = this, o = this.props, i = o.enable, l = o.handleStyles, c = o.handleClasses, d = o.handleWrapperStyle, p = o.handleWrapperClass, g = o.handleComponent;
      if (!i)
        return null;
      var m = n.filter(function(v) {
        return i[v] !== !1;
      }).map(function(v) {
        return i[v] !== !1 ? y.createElement(mz, { key: v, direction: v, onResizeStart: r.onResizeStart, replaceStyles: l && l[v], className: c && c[v] }, g && g[v] ? g[v] : null) : null;
      });
      return y.createElement("div", { className: p, style: d }, m);
    }, t.prototype.render = function() {
      var n = this, r = Object.keys(this.props).reduce(function(l, c) {
        return Sz.indexOf(c) !== -1 || (l[c] = n.props[c]), l;
      }, {}), o = Io(Io(Io({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (o.flexBasis = this.state.flexBasis);
      var i = this.props.as || "div";
      return y.createElement(
        i,
        Io({ style: o, className: this.props.className }, r, {
          // `ref` is after `extendsProps` to ensure this one wins over a version
          // passed in
          ref: function(l) {
            l && (n.resizable = l);
          }
        }),
        this.state.isResizing && y.createElement("div", { style: this.state.backgroundStyle }),
        this.renderResizer(["topLeft", "top", "topRight", "left"]),
        this.props.children,
        this.renderResizer(["right", "bottomLeft", "bottom", "bottomRight"])
      );
    }, t.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, t;
  }(y.PureComponent)
);
function xg({
  className: e,
  children: t,
  top: n,
  bottom: r,
  right: o,
  left: i,
  width: l,
  height: c,
  minHeight: d,
  minWidth: p,
  maxHeight: g,
  maxWidth: m,
  style: v,
  onResize: b,
  onResizeStop: x,
  ...w
}) {
  const j = {
    top: n || !1,
    right: o || !1,
    bottom: r || !1,
    left: i || !1,
    topRight: !1,
    bottomRight: !1,
    bottomLeft: !1,
    topLeft: !1
  }, C = {
    width: l || "auto",
    height: c || "auto"
  }, E = ce("z-10", ee.hBgAct), P = {
    bottom: E,
    right: E,
    left: E
  }, k = {
    bottom: { bottom: 0, height: 2 },
    right: { right: -1, width: 2 },
    left: { left: -1, width: 2 }
  };
  return /* @__PURE__ */ u.jsx(
    jz,
    {
      className: e,
      enable: w.enable ?? j,
      defaultSize: C,
      handleStyles: k,
      handleClasses: P,
      onResize: b,
      onResizeStop: x,
      minHeight: d,
      minWidth: p,
      maxHeight: g,
      maxWidth: m,
      style: v,
      children: t
    }
  );
}
const Nc = "gs-studio-panel", yP = (e, t = {}) => ({
  ...t,
  ...e === !0 ? {} : e || void 0
}), Po = y.memo(function({
  children: t,
  header: n,
  resizable: r,
  className: o,
  classNameAccordion: i,
  classNameAccordionContent: l,
  ...c
}) {
  const d = /* @__PURE__ */ u.jsx(Rr, { className: B(Nc, o), ...c, children: t }), p = r ? r === !0 ? {
    top: !0,
    right: !0,
    bottom: !0,
    left: !0
  } : r : void 0, g = p ? /* @__PURE__ */ u.jsx(xg, { className: B([`${Nc}__resizer`]), ...p, children: d }) : d, m = n === !0 ? { collapsible: !0 } : n || void 0;
  return m ? /* @__PURE__ */ u.jsx(
    ja,
    {
      classNameWrap: B(`${Nc}__accordion`, i),
      className: B(`${Nc}__accordion-header`, tt.xy, m.className),
      classNameContent: B(`${Nc}__accordion-content`, l),
      disabled: m.collapsible === !1,
      style: m.style,
      handler: /* @__PURE__ */ u.jsxs(G, { space: "s", items: "center", children: [
        !!m.icon && /* @__PURE__ */ u.jsx(ye, { icon: m.icon, size: Ee.s }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: m.label })
      ] }),
      open: n ? m.collapsed !== !0 : !0,
      children: g
    }
  ) : g;
}), Cz = "gs-panel-assets", Ez = y.memo(
  xe(function({
    className: t,
    onSelect: n,
    content: r,
    assets: o,
    types: i,
    providers: l,
    typeId: c,
    providerId: d,
    optionalType: p,
    optionalProvider: g,
    ...m
  }) {
    const v = Re(), b = xa(), x = v.editor, [w] = y.useState(() => m.id || sC());
    return y.useEffect(() => (b.createAssetManager(w), () => {
      b.removeAssetManager(w);
    }), [w]), CE(w) ? /* @__PURE__ */ u.jsx(
      Po,
      {
        className: B(Cz, "gs-utl-overflow-hidden gs-utl-h-full", t),
        classNameAccordion: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        ...m,
        children: x && /* @__PURE__ */ u.jsx(
          vP,
          {
            panelId: w,
            assets: o,
            types: i,
            providers: l,
            onSelect: n,
            typeId: c,
            providerId: d,
            content: r,
            optionalType: p,
            optionalProvider: g
          }
        )
      }
    ) : null;
  })
), bP = y.forwardRef(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ u.jsx("div", { className: B(ge("gs-block-manager-after"), n), ref: o, ...r, children: t });
}), xP = y.forwardRef(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ u.jsx("div", { className: B(ge("gs-block-manager-before"), n), ref: o, ...r, children: t });
}), Pz = "gs-panel-blocks", _z = y.memo(
  xe(function({
    className: t,
    symbols: n,
    search: r,
    hideCategories: o,
    blocks: i,
    itemLayout: l,
    ...c
  }) {
    const d = Re().sdkProps.children, p = {
      search: r,
      symbols: n,
      hideCategories: o,
      isOpen: !0,
      blocks: i,
      itemLayout: l
    };
    return /* @__PURE__ */ u.jsx(
      Po,
      {
        className: B(Pz, "gs-utl-overflow-hidden", t),
        classNameAccordion: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        ...c,
        children: /* @__PURE__ */ u.jsxs(Sa, { children: [
          cr(d, xP),
          /* @__PURE__ */ u.jsx(qP, { className: B("gs-utl-overflow-hidden gs-utl-flex-nowrap"), ...p }),
          cr(d, bP)
        ] })
      }
    );
  })
), kz = (e, { t, id: n }) => t(`fields.${n}.label`) || Wo(`${e}`.replace(/-/g, " ")), wP = (e, { t, id: n }) => {
  const r = Dt(e) ? { id: e, label: e } : e;
  return {
    ...r,
    label: t(`fields.${n}.options.${r.id}`) || r.label
  };
}, SP = (e) => e.get("defaultValue") || "", ed = (e) => e.get("field"), jP = (e) => {
  const t = ed(e);
  return Dt(t) ? { type: t } : t;
}, CP = (e) => `${e.get("value") || SP(e) || jP(e).defaultValue || ""}`, Tz = (e, t) => e || SP(t) || "", wu = ({
  record: e,
  value: t,
  partial: n
}) => {
  e.set({ value: Tz(t, e) }, { partial: n }), e.em.refreshCanvas({ tools: !0 });
}, Su = (e, t) => {
  const { className: n, defaultValue: r, size: o, ...i } = jP(e), l = r || e.get("defaultValue");
  return {
    ...i,
    hasClear: () => {
      const c = e.get("value");
      return !!c && Rn(l) && c !== l;
    },
    className: B(n, "gs-utl-w-full"),
    size: o || "s",
    value: CP(e),
    label: kz(e.get("label") || e.id || "", t),
    onChange: (c, d) => wu({ record: e, value: c, partial: d })
  };
}, Oz = (e, t) => {
  const n = ed(e), r = Qo(n) ? n : void 0, o = (r == null ? void 0 : r.units) || [], i = pD(CP(e)), l = i.number, c = i.unit || o[0] || "";
  return {
    ...Su(e, t),
    value: l,
    valueUnit: c,
    min: r == null ? void 0 : r.min,
    max: r == null ? void 0 : r.max,
    step: r == null ? void 0 : r.step,
    units: r == null ? void 0 : r.units,
    onChange: (d, p) => {
      wu({ value: d ? `${d}${c}` : "", record: e, partial: p });
    },
    onChangeUnit: (d) => {
      wu({ value: l ? `${l}${d}` : "", record: e });
    }
  };
}, EP = (e, t) => {
  var i;
  const n = ed(e), r = Qo(n) ? n : void 0, o = ((i = r == null ? void 0 : r.options) == null ? void 0 : i.map((l) => wP(l, t))) || [];
  return {
    ...Su(e, t),
    options: o,
    onChange: (l) => wu({ value: l, record: e })
  };
}, Lz = (e, t) => ({
  ...Su(e, t),
  onChange: (n) => wu({ value: n, record: e })
}), Mz = (e, t) => {
  var i;
  const n = ed(e), r = Qo(n) ? n : void 0, o = ((i = r == null ? void 0 : r.options) == null ? void 0 : i.map((l) => wP(l, t))) || [];
  return {
    ...EP(e, t),
    size: "s",
    options: o
  };
};
function Az(e, t) {
  const n = ed(e);
  switch (Dt(n) ? n : n == null ? void 0 : n.type) {
    case "radio":
      return /* @__PURE__ */ u.jsx(Kn, { ...Mz(e, t) });
    case "select":
      return /* @__PURE__ */ u.jsx(Ze, { ...EP(e, t) });
    case "selectFont": {
      const o = Lz(e, t);
      return /* @__PURE__ */ u.jsx(
        og,
        {
          ...o,
          labelAs: "div"
        }
      );
    }
    case "number":
      return /* @__PURE__ */ u.jsx(et, { ...Oz(e, t) });
    case "color":
      return /* @__PURE__ */ u.jsx(Rs, { ...Su(e, t) });
    default:
      return /* @__PURE__ */ u.jsx(jt, { ...Su(e, t) });
  }
}
const k2 = "gs-cmp-global-style-field", Rz = xe(function({ record: t }) {
  const n = Re(), o = qe().tScoped("globalStyleManager"), [, i] = y.useState(0), l = n.editor, c = t.id, d = { t: o, id: c };
  return y.useEffect(() => {
    if (!l)
      return;
    const p = `data:path:${t.getPath("value")}`, g = () => i((m) => ++m);
    return l.on(p, g), () => {
      l.off(p, g);
    };
  }, [l]), /* @__PURE__ */ u.jsx(G, { className: B(k2, `${k2}__${c}`), children: Az(t, d) });
}), nu = "gs-cmp-global-style-manager", T2 = ({ items: e, category: t, className: n }) => {
  const r = B(
    t ? `${nu}__cat-fields--${t.id}` : `${nu}__uncat-fields`,
    "gs-utl-gap-2",
    tt.xy,
    n
  );
  return /* @__PURE__ */ u.jsx(G, { className: r, nowrap: !0, col: !0, children: e.map((o) => /* @__PURE__ */ u.jsx(Rz, { record: o }, o.id)) });
}, Nz = xe(function() {
  const t = P$(), { recordsByCategory: n, openCategories: r } = t, i = qe().tScoped("globalStyleManager");
  return /* @__PURE__ */ u.jsx(G, { col: !0, full: !0, nowrap: !0, className: B(nu, "gs-utl-flex-grow gs-utl-overflow-hidden"), children: /* @__PURE__ */ u.jsx(G, { col: !0, nowrap: !0, className: B(`${nu}__fields`, nt.scrollY, "gs-utl-select-none"), children: n.length ? n.map(
    ({ category: l, items: c }, d) => l ? /* @__PURE__ */ u.jsx(
      ja,
      {
        sticky: !0,
        open: r.get(l.id) ?? l.open,
        handler: i(`categories.${l.id}.label`) || l.label || l.id,
        onChange: ({ open: p }) => t.setCategoryOpen(l.id, p),
        className: (p) => B(
          `${nu}__cat-fields`,
          Vv.itemList({ index: d, open: p, length: n.length }),
          d === 0 && ve.bt
        ),
        children: /* @__PURE__ */ u.jsx(T2, { category: l, items: c })
      },
      l.id
    ) : /* @__PURE__ */ u.jsx(
      T2,
      {
        items: c,
        className: B(n.length !== 1 && [ve.bt, ee.br])
      },
      d
    )
  ) : /* @__PURE__ */ u.jsx(G, { className: B("gs-utl-text-center"), justify: "center", children: i("notFound") }) }) });
}), $z = "gs-panel-global-styles", Dz = y.memo(
  xe(function({ className: t, ...n }) {
    return /* @__PURE__ */ u.jsx(
      Po,
      {
        className: B($z, "gs-utl-overflow-auto", t),
        classNameAccordion: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: B("gs-utl-overflow-auto"),
        ...n,
        children: /* @__PURE__ */ u.jsx(Sa, { children: /* @__PURE__ */ u.jsx(Nz, {}) })
      }
    );
  })
);
function ry({ className: e, value: t, onChange: n }) {
  const [r, o] = y.useState(t), i = y.useRef(null), l = (p) => {
    const { value: g } = p.target;
    o(g);
  }, c = () => {
    n(r || t);
  }, d = (p) => {
    switch (p.key) {
      case "Escape":
        n(t);
        break;
      case "Enter":
        n(r || t);
        break;
    }
  };
  return y.useEffect(() => {
    i.current && i.current.select();
  }, []), /* @__PURE__ */ u.jsx(
    "input",
    {
      autoFocus: !0,
      className: ce([e, "w-full", ee.bgTr]),
      value: r,
      onChange: l,
      onBlur: c,
      onKeyDown: d,
      onPointerDown: yl,
      ref: i
    }
  );
}
const Iz = { maxWidth: `${xO}px` }, Vz = "gs-cmp-layer-item";
function PP({ component: e, draggingCmp: t, dragParent: n, ...r }) {
  const o = Ar(), { Layers: i } = o, l = y.useRef(null), [c, d] = y.useState(!1), [p, g] = y.useState(i.getLayerData(e)), { open: m, selected: v, hovered: b, components: x, visible: w, locked: j, name: C } = p, E = x.map((I) => I.cid), P = t === e, k = E.join("-"), T = r.level + 1, O = b || n === e;
  y.useEffect(() => {
    T === 0 && g(i.getLayerData(e)), l.current && (l.current.__cmp = e);
  }, [e]), y.useEffect(() => {
    const I = l.current;
    if (!I)
      return;
    const { select: F } = o.Components.events, V = (L) => L === e && I.scrollIntoView({ block: "nearest" });
    return o.on(F, V), () => {
      o.off(F, V);
    };
  }, [e, l.current]), y.useEffect(() => {
    const I = (V) => {
      V === e && g(i.getLayerData(V));
    }, F = i.events.component;
    return o.on(F, I), () => {
      o.off(F, I);
    };
  }, [o, i, e]);
  const A = y.useMemo(() => x.map((I) => /* @__PURE__ */ u.jsx(PP, { component: I, level: T, draggingCmp: t, dragParent: n }, I.cid)), [k, t, n]), $ = (I) => {
    i.setLayerData(e, { name: I }), d(!1);
  }, N = (I) => {
    I.stopPropagation(), i.setLayerData(e, { open: !m });
  }, R = (I) => {
    I.stopPropagation(), i.setLayerData(e, { visible: !w });
  }, z = (I) => {
    I.stopPropagation(), i.setLayerData(e, { locked: !j });
  }, D = (I) => {
    I.stopPropagation(), i.setLayerData(e, { selected: !0 }, { event: I });
  }, Z = (I) => {
    I.preventDefault(), o.runCommand(ke.contextMenuComponent, {
      source: x0.layers,
      component: e,
      event: I.nativeEvent,
      x: I.clientX,
      y: I.clientY
    });
  }, K = (I) => {
    (!I || !t) && i.setLayerData(e, { hovered: I });
  }, H = Ml(e), q = ce(
    "layer-item",
    (v || H.isSymbol) && H.bgSoftX,
    (!w || P) && "opacity-50"
  ), te = ce(tt.xyS, ve.b, O ? H.border : ve.bT, v && H.bgSoft);
  return /* @__PURE__ */ u.jsx("div", { className: Vz, children: /* @__PURE__ */ u.jsxs(G, { col: !0, className: q, children: [
    /* @__PURE__ */ u.jsx(
      Y,
      {
        onClick: D,
        onContextMenu: Z,
        onMouseEnter: () => K(!0),
        onMouseLeave: () => K(!1),
        className: ce("group max-w-full"),
        "data-layer-item": !0,
        ref: l,
        children: /* @__PURE__ */ u.jsxs(G, { items: "center", space: "xs", className: te, children: [
          /* @__PURE__ */ u.jsx(
            Y,
            {
              style: { marginLeft: `${T * 10}px` },
              className: ce("cursor-pointer", !x.length && "pointer-events-none opacity-0"),
              onClick: N,
              children: /* @__PURE__ */ u.jsx(ye, { icon: fe.menuDown, size: Ee.sx, rotate: m ? 0 : -90 })
            }
          ),
          /* @__PURE__ */ u.jsx(Y, { children: _0(e) }),
          /* @__PURE__ */ u.jsx(Y, { className: ce("truncate"), onDoubleClick: () => d(!0), style: Iz, grow: !0, children: c ? /* @__PURE__ */ u.jsx(ry, { value: C, onChange: $ }) : /* @__PURE__ */ u.jsx(u.Fragment, { children: C }) }),
          !c && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsx(
              Y,
              {
                className: ce("group-hover:gs-utl-opacity-100 cursor-pointer", j ? "opacity-100" : "opacity-0"),
                onClick: z,
                children: /* @__PURE__ */ u.jsx(ye, { icon: j ? fe.lock : fe.lockOpenVariant, size: Ee.s3x })
              }
            ),
            /* @__PURE__ */ u.jsx(
              Y,
              {
                className: ce("group-hover:gs-utl-opacity-100 cursor-pointer", w ? "opacity-0" : "opacity-100"),
                onClick: R,
                children: /* @__PURE__ */ u.jsx(ye, { icon: w ? fe.eyeOutline : fe.eyeOffOutline, size: Ee.sx })
              }
            )
          ] })
        ] })
      }
    ),
    !!(m && x.length) && /* @__PURE__ */ u.jsx(Y, { className: ce("max-w-full", !m && "hidden"), children: A })
  ] }) });
}
const Hz = {
  touchAction: "none"
}, O2 = 5, Fz = (e) => {
  const t = document.elementFromPoint(e.clientX, e.clientY), n = t == null ? void 0 : t.closest("[data-layer-item]");
  return {
    el: n,
    cmp: n == null ? void 0 : n.__cmp
  };
}, _P = xe(function({ root: t, header: n }) {
  const { editor: r } = Re(), [o, i] = y.useState(!1), [l, c] = y.useState({}), [d, p] = y.useState(), [g, m] = y.useState(), [v, b] = y.useState(), [x, w] = y.useState(), j = y.useRef(null);
  if (y.useEffect(() => {
    const N = window.document, R = (z) => {
      z.key === "Escape" && (c({ ...l, result: !1 }), k());
    };
    return N.addEventListener("keydown", R), () => {
      N.removeEventListener("keydown", R);
    };
  }, []), !r)
    return null;
  const { Components: C } = r, E = (N) => {
    N.button === 0 && i(!0);
  }, P = (N) => {
    if (!o)
      return;
    const { cmp: R, el: z } = Fz(N);
    if (!z || !R)
      return;
    const D = z.getBoundingClientRect(), Z = z.offsetHeight, K = z.offsetTop, H = N.clientY, q = H < D.y + Z / 2, te = g || R, I = R.parent(), F = R.index() + (q ? 0 : 1);
    !g && m(R), p(R);
    const V = C.canMove(I, te, F), L = C.canMove(R, te), W = {
      ...V,
      canMoveInside: L,
      index: F
    };
    let ie = !1;
    L.result && H > D.y + O2 && H < D.y + Z - O2 && (ie = !0, W.target = R, delete W.index), b(ie ? R : void 0), c(W), w({
      pointerInside: ie,
      y: K + (q ? 0 : Z),
      h: Z
    });
  }, k = () => {
    var N;
    l != null && l.result && ((N = l.source) == null || N.move(l.target, { at: l.index })), c({}), i(!1), m(void 0), p(void 0), b(void 0), w(void 0);
  }, T = (d ? d.parents() : []).length, O = !!(g && x && (l != null && l.result) && !x.pointerInside), A = O ? { top: x.y, left: 0, marginLeft: T * 10 + 20 } : {}, $ = n && (n == null ? void 0 : n.label) || "Layers";
  return /* @__PURE__ */ u.jsxs(G, { col: !0, full: !0, nowrap: !0, className: ce("gs-layer-manager flex-grow overflow-hidden"), children: [
    n !== !1 && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsxs(G, { space: "s", items: "center", className: ce([tt.xy, ve.bb, ee.br]), children: [
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ye, { icon: fe.layers, size: Ee.s }) }),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: $ })
    ] }) }),
    /* @__PURE__ */ u.jsxs(
      Y,
      {
        className: ce("overflow-y-auto overflow-x-hidden text-sm select-none relative"),
        style: Hz,
        onPointerDown: E,
        onPointerMove: P,
        onPointerUp: k,
        grow: !0,
        children: [
          !!t && /* @__PURE__ */ u.jsx(PP, { component: t, level: -1, draggingCmp: g, dragParent: v }),
          O && /* @__PURE__ */ u.jsx("div", { ref: j, className: ce("absolute w-full gs-utl-h-0.5", ee.cmp), style: A })
        ]
      }
    )
  ] });
}), kP = y.forwardRef(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ u.jsx("div", { className: B(ge("gs-layer-manager-after"), n), ref: o, ...r, children: t });
}), TP = y.forwardRef(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ u.jsx("div", { className: B(ge("gs-layer-manager-before"), n), ref: o, ...r, children: t });
}), zz = "gs-panel-layers", OP = y.memo(
  xe(function({ className: t, ...n }) {
    const r = Re().sdkProps.children;
    return /* @__PURE__ */ u.jsx(
      Po,
      {
        className: B(zz, "gs-utl-overflow-auto", t),
        classNameAccordion: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: B("gs-utl-overflow-auto"),
        ...n,
        children: /* @__PURE__ */ u.jsx(f5, { children: (o) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          cr(r, TP),
          /* @__PURE__ */ u.jsx(_P, { ...o, header: !1 }),
          cr(r, kP)
        ] }) })
      }
    );
  })
), Bz = xe(function() {
  const t = qe(), { editor: n } = Re(), r = xa(), o = Ku(), i = o.sortedFonts;
  return n ? /* @__PURE__ */ u.jsx(
    Ho,
    {
      items: i,
      selected: null,
      renderItem: (l) => {
        const c = P0(l);
        return /* @__PURE__ */ u.jsxs(G, { col: !0, children: [
          /* @__PURE__ */ u.jsx(Y, { className: "gs-utl-text-lg", style: { fontFamily: c }, children: l.familyLabel }),
          /* @__PURE__ */ u.jsx(Y, { children: l.familyLabel })
        ] });
      },
      remove: (l) => o.removeFont(l.family),
      add: o.sdkAddFonts && r.hasType("font") ? () => A0(n) : void 0,
      titleAdd: t.t("fontManager.addFontToProject"),
      label: t.t("fontManager.projectFonts"),
      getItemId: (l) => l.family,
      emptyState: t.t("fontManager.emptyProjectFonts")
    }
  ) : null;
}), LP = Q.forwardRef(function({ size: t = "m", className: n, classNameContent: r, border: o = !0, children: i, ...l }, c) {
  const d = ge(
    ee.bg,
    ee.br,
    o && `${ve.b} ${ve.rnd}`,
    t === "m" && tt.xy,
    t === "s" && "gjs-px-3 gjs-py-1",
    n
  );
  return /* @__PURE__ */ u.jsx(G, { className: d, items: "center", space: "x2s", ...l, ref: c, children: /* @__PURE__ */ u.jsx(Y, { grow: !0, className: r, children: i }) });
}), Uz = ({ autoResize: e, style: t = {}, ...n }) => {
  const r = y.useRef(null);
  return y.useEffect(() => {
    !r.current || !e || (r.current.style.height = "auto", r.current.style.height = r.current.scrollHeight + "px");
  }, [n.value]), /* @__PURE__ */ u.jsx("textarea", { ref: r, style: { ...t, ...e ? { resize: "none" } : {} }, ...n });
}, Wz = "gs-field-textarea";
function L2(e) {
  const {
    className: t,
    value: n,
    label: r,
    size: o,
    description: i,
    placeholder: l,
    readOnly: c,
    disabled: d,
    required: p,
    onChange: g,
    onKeyDown: m,
    afterInput: v,
    minHeight: b,
    maxHeight: x,
    autoResize: w,
    classNameField: j,
    classNameFieldContent: C,
    classNameInput: E
  } = e, P = Uu(e);
  return /* @__PURE__ */ u.jsxs("div", { className: ce(Wz, t), children: [
    !!r && /* @__PURE__ */ u.jsx(wi, { size: o, children: r }),
    !!i && /* @__PURE__ */ u.jsx(wi, { size: o, as: "span", className: ce(ee.txtLowEmphasis), capitalize: !1, children: i }),
    /* @__PURE__ */ u.jsxs(LP, { size: o, className: j, classNameContent: C, children: [
      /* @__PURE__ */ u.jsx(
        Uz,
        {
          className: ce(P, E),
          autoResize: w,
          value: n,
          placeholder: l,
          readOnly: c,
          disabled: d,
          required: p,
          onChange: (k) => g == null ? void 0 : g(k.target.value),
          onKeyDown: m,
          style: { minHeight: b, maxHeight: x }
        }
      ),
      v
    ] })
  ] });
}
const wg = "gs-page-settings", Gz = `${wg}-header`, Kz = `${wg}-content`, qz = `${wg}-footer`, M2 = "", MP = xe(function({
  className: t,
  classNameHeader: n,
  classNameContent: r,
  classNameFooter: o,
  page: i,
  size: l = Zp.m
}) {
  const c = Re(), { isDarkTheme: d } = gr(), p = Ku(), g = qe(), [m, v] = y.useState(i), [b, x] = y.useState(() => Qw(m, c)), [w, j] = y.useState(() => g.t("update")), C = g.tScoped("pageManager.settings"), E = g.tScoped("pageManager.settings.fields"), P = c.editor, k = {
    containerClassName: ge("min-h-80"),
    size: l,
    padding: 5,
    isDarkTheme: d,
    clean: !0
  }, T = (D) => x((Z) => ({ ...Z, ...D })), O = (D) => {
    D.preventDefault();
    const { name: Z, ...K } = b;
    K.customCodeHead = gO(K.customCodeHead), K.customCodeBody = pO(K.customCodeBody), m ? (e$(m, K), m.setName(Z)) : c.setProjectDataCustom({
      globalPageSettings: K
    }), j(g.t("updated")), setTimeout(() => j(g.t("update")), 2e3), xE(P), P.trigger(kr.pageSettingsUpdate, { page: m, data: { name: Z, ...K } });
  }, A = { tooltip: g.t("clear") }, $ = (m == null ? void 0 : m.getId()) ?? M2, N = (D) => {
    const Z = P.Pages.get(D);
    v(Z), x(Qw(Z, c));
  }, R = Q8(m), z = [
    {
      id: M2,
      label: C("global")
    },
    ...P.Pages.getAll().map((D) => ({
      id: D.getId(),
      label: D.getName()
    }))
  ];
  return /* @__PURE__ */ u.jsx("form", { onSubmit: O, className: ge(wg, "h-full", t), children: /* @__PURE__ */ u.jsxs(G, { col: !0, full: !0, className: ge("gap-1 gs-utl-overflow-hidden"), nowrap: !0, children: [
    /* @__PURE__ */ u.jsx(Y, { className: ge(Gz, n, ee.br, ve.bb), children: /* @__PURE__ */ u.jsx(
      Ze,
      {
        value: $,
        onChange: N,
        options: z,
        handlerSelected: (D) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          /* @__PURE__ */ u.jsx("b", { children: g.t("pageManager.page") }),
          ": ",
          D.label
        ] })
      }
    ) }),
    /* @__PURE__ */ u.jsxs(G, { col: !0, className: ge(Kz, "gap-5 overflow-y-auto", r), nowrap: !0, children: [
      !!$ && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        /* @__PURE__ */ u.jsx(
          jt,
          {
            size: l,
            value: b.name,
            onChange: (D) => T({ name: D }),
            label: E("name.label"),
            description: E("name.description"),
            required: !0
          }
        ),
        !R && /* @__PURE__ */ u.jsx(
          jt,
          {
            size: l,
            value: b.slug,
            onChange: (D) => T({ slug: Nv(D) }),
            label: E("slug.label"),
            description: E("slug.description"),
            required: !0
          }
        )
      ] }),
      /* @__PURE__ */ u.jsx(
        jt,
        {
          size: l,
          value: b.title,
          onChange: (D) => T({ title: D }),
          label: E("title.label"),
          description: E("title.description")
        }
      ),
      /* @__PURE__ */ u.jsx(
        L2,
        {
          size: l,
          value: b.description,
          onChange: (D) => T({ description: D }),
          label: E("description.label"),
          description: E("description.description")
        }
      ),
      /* @__PURE__ */ u.jsx(
        vu,
        {
          size: l,
          clear: A,
          value: b.favicon,
          onChange: (D) => T({ favicon: D }),
          onOpen: () => {
            P.Assets.open({
              select(D) {
                T({ favicon: D.getSrc() }), P.Assets.close();
              }
            });
          },
          label: E("favicon.label"),
          description: E("favicon.description")
        }
      ),
      /* @__PURE__ */ u.jsx(
        jt,
        {
          size: l,
          value: b.keywords,
          onChange: (D) => T({ keywords: D }),
          label: E("keywords.label"),
          description: E("keywords.description")
        }
      ),
      /* @__PURE__ */ u.jsx(
        jt,
        {
          size: l,
          value: b.socialTitle,
          onChange: (D) => T({ socialTitle: D }),
          label: E("socialTitle.label"),
          description: E("socialTitle.description")
        }
      ),
      /* @__PURE__ */ u.jsx(
        vu,
        {
          size: l,
          clear: A,
          value: b.socialImage,
          onChange: (D) => T({ socialImage: D }),
          onOpen: () => {
            P.Assets.open({
              select(D) {
                T({ socialImage: D.getSrc() }), P.Assets.close();
              }
            });
          },
          label: E("socialImage.label"),
          description: E("socialImage.description")
        }
      ),
      /* @__PURE__ */ u.jsx(
        L2,
        {
          size: l,
          value: b.socialDescription,
          onChange: (D) => T({ socialDescription: D }),
          label: E("socialDescription.label"),
          description: E("socialDescription.description")
        }
      ),
      /* @__PURE__ */ u.jsx(
        As,
        {
          language: "html",
          defaultValue: b.customCodeHead,
          onChange: (D) => T({ customCodeHead: D }),
          label: E("customCodeHead.label"),
          description: E("customCodeHead.description"),
          ...k
        },
        `head-${$}`
      ),
      /* @__PURE__ */ u.jsx(
        As,
        {
          language: "html",
          defaultValue: b.customCodeBody,
          onChange: (D) => T({ customCodeBody: D }),
          label: E("customCodeBody.label"),
          description: E("customCodeBody.description"),
          ...k
        },
        `body-${$}`
      ),
      p.sdkShowProjectFonts && !$ && /* @__PURE__ */ u.jsx(Bz, {})
    ] }),
    /* @__PURE__ */ u.jsx(G, { className: ge(qz, "mt-auto", o, ee.br, ve.bt), children: /* @__PURE__ */ u.jsx(ut, { type: "submit", variant: "pr", size: "m2", full: !0, children: w }) })
  ] }) });
}), Yz = "gs-panel-page-settings", Xz = y.memo(
  xe(function({ className: t, page: n, ...r }) {
    return /* @__PURE__ */ u.jsx(
      Po,
      {
        className: B(Yz, "gs-utl-overflow-hidden", t),
        classNameAccordion: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        ...r,
        children: /* @__PURE__ */ u.jsx(Sa, { children: /* @__PURE__ */ u.jsx(
          MP,
          {
            className: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
            page: n,
            size: Zp.s,
            classNameHeader: tt.s,
            classNameContent: tt.s,
            classNameFooter: tt.s
          }
        ) })
      }
    );
  })
), a1 = "gs-page-item", A2 = xe(function({ page: t, rename: n, setRename: r, commandItems: o }) {
  const i = Re(), l = qe(), c = i.editor, { Pages: d } = c, { sdkPagesConfig: p } = i, g = p == null ? void 0 : p.settings, m = (P) => l.t(`pageManager.${P}`), v = (P) => d.select(P), b = (P) => d.getSelected() === P, x = (P) => P === n, w = (P) => P.getName() || P.getId(), j = (P) => {
    n == null || n.set({ name: P }), r(void 0);
  }, C = ge("group-hover:gs-utl-opacity-100 opacity-0 cursor-pointer transition-opacity"), E = () => c.runCommand(ke.setPageSettings, { page: t, isOpen: !0 });
  return /* @__PURE__ */ u.jsxs(
    G,
    {
      space: "s",
      items: "center",
      onClick: () => v(t),
      className: ge([
        a1,
        "group cursor-default",
        tt.xy,
        b(t) && ee.bgH,
        !b(t) && ee.hBgH2
      ]),
      children: [
        /* @__PURE__ */ u.jsx(Y, { className: ge(`${a1}__name truncate`), grow: !0, children: x(t) ? /* @__PURE__ */ u.jsx(ry, { value: w(t), onChange: j }) : /* @__PURE__ */ u.jsx(u.Fragment, { children: w(t) }) }),
        /* @__PURE__ */ u.jsxs(G, { className: `${a1}__actions`, space: "xs", onClick: yl, items: "center", children: [
          !n && g !== !1 && /* @__PURE__ */ u.jsx(
            Qt,
            {
              className: C,
              size: "xs",
              border: !1,
              title: m("settings.label"),
              onClick: E,
              block: !0,
              children: /* @__PURE__ */ u.jsx(ye, { icon: fe.cog, size: Ee.s3x })
            }
          ),
          b(t) && !!o.length && /* @__PURE__ */ u.jsx(
            rs,
            {
              placement: "right-start",
              handler: /* @__PURE__ */ u.jsx(ye, { icon: fe.dotsVertical, size: Ee.s }),
              title: !1,
              padding: !1,
              fixed: !0,
              overlay: !0,
              children: ({ close: P }) => o.map((k) => /* @__PURE__ */ u.jsx(
                Bu,
                {
                  label: Ct(k.label) ? k.label({ editor: c }) : k.label,
                  action: () => {
                    var T;
                    P(), (T = k.cmd) == null || T.call(k, { page: t, editor: c });
                  }
                },
                k.id
              ))
            }
          )
        ] })
      ]
    },
    t.getId()
  );
});
function Zz({ dragging: e, dragRect: t }) {
  const n = !!(e && t), r = n ? { top: t.y, left: 0, marginLeft: 0 } : {};
  return {
    showIndicator: n,
    indicatorStyle: r
  };
}
var AP = /* @__PURE__ */ ((e) => (e.horizontal = "horizontal", e.vertical = "vertical", e))(AP || {});
const l1 = "gs-cmp-sortable", Jz = ({ items: e, direction: t, onDrop: n, renderItem: r }) => {
  const [o, i] = y.useState(null), [l, c] = y.useState(-1), [d, p] = y.useState(), g = y.useRef(null), { showIndicator: m, indicatorStyle: v } = Zz({ dragging: !!o, dragRect: d }), b = y.useMemo(() => [], [e]);
  y.useEffect(() => {
    const T = window.document, O = (A) => A.key === "Escape" && j(A);
    return T.addEventListener("keydown", O), () => T.removeEventListener("keydown", O);
  }, []);
  const x = (T) => (O) => {
    O.button === 0 && (g.current = { x: O.clientX, y: O.clientY }, i(T), O.target.setPointerCapture(O.pointerId));
  }, w = (T) => {
    if (!o || !g.current)
      return;
    const O = T.clientY;
    let A = -1;
    b.forEach((R, z) => {
      const D = R.getBoundingClientRect();
      O > D.top + D.height / 2 && (A = z);
    });
    const $ = e.findIndex((R) => R.id === o.id);
    A < $ && (A += 1), A = Math.min(A, e.length - 1), c(A);
    const N = b[A];
    if (N) {
      const { height: R, top: z } = N.getBoundingClientRect(), D = O < z + R / 2;
      p({
        y: N.offsetTop + (D ? 0 : R),
        h: R
      });
    }
  }, j = (T) => {
    i(null), g.current = null, p(void 0);
    const O = T.target, { pointerId: A } = T;
    A && (O == null || O.releasePointerCapture(A));
  }, C = (T) => {
    !o || !g.current || (d && l !== -1 && (n == null || n(o, l)), j(T));
  }, E = B(l1, "gs-utl-relative"), P = B(`${l1}__indicator`, ee.cmp, "gs-utl-absolute gs-utl-w-full gs-utl-h-0.5"), k = (T) => B(`${l1}__item`, m && (o == null ? void 0 : o.id) === T.id && "gs-utl-opacity-50 gs-utl-select-none");
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsx(G, { col: t === "vertical", className: E, children: e.map((T, O) => /* @__PURE__ */ u.jsx(
      Y,
      {
        ref: (A) => {
          A && (b[O] = A);
        },
        className: k(T),
        onPointerDown: x(T),
        onPointerMove: w,
        onPointerUp: C,
        children: r(T)
      },
      T.id
    )) }),
    m && /* @__PURE__ */ u.jsx("div", { className: P, style: v })
  ] });
}, Qz = ({ pages: e, commandItems: t, rename: n, setRename: r, editor: o }) => {
  if (!o.Pages.move)
    return e.map((d) => /* @__PURE__ */ u.jsx(A2, { page: d, commandItems: t, rename: n, setRename: r }, d.getId()));
  const i = (d, p) => {
    o.Pages.move(d.entity, { at: p });
  }, l = (d) => /* @__PURE__ */ u.jsx(A2, { page: d.entity, commandItems: t, rename: n, setRename: r }, d.id), c = e.map((d) => ({
    id: d.getId(),
    entity: d
  }));
  return /* @__PURE__ */ u.jsx(Jz, { items: c, direction: AP.vertical, onDrop: i, renderItem: l });
}, eB = ({
  items: e,
  editor: t,
  sdkPageConfig: n
}) => {
  const r = n == null ? void 0 : n.commandItems;
  return r === !1 ? [] : Ct(r) ? r({ items: e, editor: t }) : r || e;
}, c1 = "gs-panel-page-manager", RP = xe(function({
  pages: t,
  select: n,
  add: r,
  remove: o,
  header: i,
  resizable: l = { bottom: !0 },
  height: c = 200
}) {
  const d = Re(), p = os(), g = qe(), { sdkPagesConfig: m } = d, v = d.editor, [b, x] = y.useState(), w = (D) => g.t(`pageManager.${D}`), j = m == null ? void 0 : m.add, C = m == null ? void 0 : m.duplicate, E = m == null ? void 0 : m.remove, P = (D) => {
    yl(D);
    const Z = (H) => {
      const q = t.length + 1;
      return r(
        {
          name: `${w("page")} ${q}`,
          component: `<div>${w("newPage")} ${q}</div>`,
          ...H
        },
        { select: !0 }
      );
    };
    if (j)
      return j({ event: D, editor: v, rename: x, addPage: Z });
    const K = Z();
    K && x(K);
  }, k = ({ page: D }) => {
    if (E)
      return E({ editor: v, page: D });
    p.confirm({
      title: w("deletePage"),
      content: w("confirmDelete"),
      confirmButton: { variant: "danger", children: w("deletePage") },
      onConfirm: () => {
        const Z = t.indexOf(D), K = t[Z + 1] || t[0];
        n(K), o(D);
      }
    });
  }, T = ({ page: D }) => {
    if (C)
      return C({ editor: v, page: D, rename: x });
    const Z = D.getMainComponent(), K = r(
      {
        name: `${D.getName()} (${w("copy")})`,
        component: Z.clone()
      },
      { select: !0 }
    );
    K && x(K);
  }, O = [
    { id: "rename", label: w("rename"), cmd: ({ page: D }) => x(D) },
    C !== !1 && { id: "duplicate", label: w("duplicate"), cmd: T },
    t.length > 1 && E !== !1 && { id: "remove", label: w("delete"), cmd: k }
  ].filter(Boolean), A = eB({ items: O, editor: v, sdkPageConfig: m }), $ = yP(i, {
    collapsible: !0,
    label: w("pages"),
    icon: fe.textBoxMultiple
  }), N = l ? l === !0 ? {
    top: !0,
    right: !0,
    bottom: !0,
    left: !0
  } : l : void 0, R = /* @__PURE__ */ u.jsx(Qz, { pages: t, commandItems: A, rename: b, setRename: x, editor: v }), z = N ? /* @__PURE__ */ u.jsx(
    xg,
    {
      className: ce([`${c1}__content`, "text-sm overflow-auto", ve.bt, ee.br]),
      height: c,
      ...N,
      children: R
    }
  ) : R;
  return /* @__PURE__ */ u.jsx(
    ja,
    {
      classNameWrap: c1,
      className: ce(`${c1}__header`, tt.xy, i === !1 && "gs-utl-hidden"),
      disabled: $ && $.collapsible === !1,
      handler: /* @__PURE__ */ u.jsxs(G, { space: "s", items: "center", children: [
        !!$.icon && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ye, { icon: $.icon, size: Ee.s }) }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: $.label }),
        j !== !1 && /* @__PURE__ */ u.jsx(_n, { title: w("add"), children: /* @__PURE__ */ u.jsx(G, { onClick: P, className: ce("cursor-pointer"), children: /* @__PURE__ */ u.jsx(ye, { icon: fe.plus, size: Ee.s }) }) })
      ] }),
      open: $ ? $.collapsed !== !0 : !0,
      children: z
    }
  );
}), NP = y.forwardRef(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ u.jsx("div", { className: B(ge("gs-page-manager-after"), n), ref: o, ...r, children: t });
}), $P = y.forwardRef(function({ children: t, className: n, ...r }, o) {
  return /* @__PURE__ */ u.jsx("div", { className: B(ge("gs-page-manager-before"), n), ref: o, ...r, children: t });
}), tB = "gs-panel-pages", DP = y.memo(
  xe(function({ className: t, header: n, height: r, resizable: o, ...i }) {
    const l = Re().sdkProps.children;
    return /* @__PURE__ */ u.jsx(Rr, { className: B(tB, t), ...i, children: /* @__PURE__ */ u.jsx(p5, { children: (c) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      cr(l, $P),
      /* @__PURE__ */ u.jsx(RP, { header: n, height: r, resizable: o, ...c }),
      cr(l, NP)
    ] }) }) });
  })
), nB = "gs-panel-pages-layers", rB = y.memo(
  xe(function({
    className: t,
    panelPagesProps: n,
    panelLayersProps: r,
    ...o
  }) {
    const { showPages: i } = Re(), l = qe(), { className: c, ...d } = n || {}, p = yP(r == null ? void 0 : r.header, {
      icon: fe.layers,
      collapsible: !1,
      label: l.t("layerManager.layers"),
      className: B(ve.bb, ee.br)
    });
    return /* @__PURE__ */ u.jsxs(Po, { className: B(nB, "gs-utl-flex gs-utl-flex-col gs-utl-h-full", t), ...o, children: [
      i && /* @__PURE__ */ u.jsx(DP, { className: B(c, ve.bb, ee.br), ...d }),
      /* @__PURE__ */ u.jsx(OP, { ...r, header: p })
    ] });
  })
), oB = "gs-trait-custom", sB = xe(function(t) {
  const { trait: n, editor: r, value: o, disabled: i, labelAs: l, className: c } = t, [, d] = y.useState(0), p = y.useRef(null), g = n.get("component"), m = n.get("render"), v = n.target, b = p.current;
  if (y.useEffect(() => {
    if (v) {
      let j = () => {
      }, C = () => {
      };
      const E = () => {
        C(), d((P) => ++P);
      };
      if (v.on("change", E), !g && m && b) {
        const P = (O) => b.appendChild(O), k = (O) => b.removeChild(O), T = m({
          editor: r,
          component: v,
          trait: n,
          addEl: P,
          removeEl: k,
          onUpdate: (O) => {
            C = O;
          }
        });
        T instanceof HTMLElement ? (P(T), j = () => k(T)) : Ct(T) && (j = () => T());
      }
      return () => {
        v.off("change", E), j();
      };
    }
  }, [v, b, o]), !v)
    return null;
  const x = Li({ ...t, className: B(oB, c) }), w = { trait: n, component: v, editor: r, value: o, disabled: i };
  return /* @__PURE__ */ u.jsxs("div", { ...x, children: [
    /* @__PURE__ */ u.jsx(Eo, { ...t, as: l }),
    /* @__PURE__ */ u.jsx("div", { className: B(i && "gs-utl-pointer-events-none opacity-50"), children: g ? /* @__PURE__ */ u.jsx(g, { ...w }) : m ? /* @__PURE__ */ u.jsx("div", { ref: p }) : null })
  ] });
});
function IP({
  className: e,
  options: t,
  value: n,
  name: r,
  label: o,
  border: i,
  hideCaret: l,
  size: c = "s",
  autoFocus: d,
  open: p,
  allowNew: g,
  onChange: m,
  onBlur: v,
  placeholder: b
}) {
  const [x, w] = y.useState(null), [j, C] = y.useState(null), { styles: E, attributes: P } = $l(x, j, j0), [k, T] = y.useState(""), O = Uu(), A = k === "" ? t : t.filter((K) => K.label.toLowerCase().includes(k.toLowerCase())), $ = (K) => T(K.target.value), N = (K) => K == null ? void 0 : K.label, R = g && k.length > 0 && !A.some((K) => K.label === k), z = Ct(g) ? g(k) : g, D = {
    minWidth: `${x == null ? void 0 : x.offsetWidth}px`,
    maxHeight: 200
  }, Z = () => v == null ? void 0 : v();
  return /* @__PURE__ */ u.jsxs("div", { className: ce("w-full", e), children: [
    !!o && /* @__PURE__ */ u.jsx(wi, { size: c, children: o }),
    /* @__PURE__ */ u.jsxs(Ya, { value: n, onChange: m, name: r, nullable: !0, children: [
      /* @__PURE__ */ u.jsx(LP, { size: c, ref: w, border: i, children: /* @__PURE__ */ u.jsxs(G, { nowrap: !0, children: [
        /* @__PURE__ */ u.jsx(
          Ya.Input,
          {
            autoFocus: d,
            className: O,
            displayValue: N,
            onChange: $,
            onBlur: Z,
            placeholder: b
          }
        ),
        !l && /* @__PURE__ */ u.jsx(Ya.Button, { children: /* @__PURE__ */ u.jsx(ye, { icon: fe.chevronDown, size: Ee.sx }) })
      ] }) }),
      /* @__PURE__ */ u.jsx(
        Ya.Options,
        {
          static: p,
          className: hE,
          ref: C,
          style: E.popper,
          ...P.popper,
          children: /* @__PURE__ */ u.jsxs(pr, { className: ce("h-full"), padding: !1, style: D, children: [
            R && /* @__PURE__ */ u.jsx(Ya.Option, { value: { id: null, label: k }, children: ({ active: K }) => /* @__PURE__ */ u.jsx(zw, { option: { id: null, label: z }, active: K, selected: n }) }),
            !R && A.length === 0 && /* @__PURE__ */ u.jsx("div", { className: ce(tt.xy), children: "No items found" }),
            A.map((K) => /* @__PURE__ */ u.jsx(Ya.Option, { value: K, children: ({ active: H }) => /* @__PURE__ */ u.jsx(zw, { option: K, active: H, selected: n }) }, K.id))
          ] })
        }
      )
    ] })
  ] });
}
const iB = "page://", VP = "#", tp = "mailto:", u1 = "subject=", yv = "tel:", HP = "hrefType", R2 = "showIdList", N2 = (e, t) => {
  const n = t == null ? void 0 : t.get(HP);
  return n || (e.startsWith(yv) ? "phone" : e.startsWith(tp) ? "email" : e.startsWith(iB) ? "pages" : e.startsWith(VP) ? "elements" : "url");
}, $2 = (e) => `${e.getName()} - #${e.getId()}`, aB = "gs-trait-href", lB = xe(function(t) {
  const { trait: n, value: r, disabled: o, labelAs: i, className: l } = t, c = n.component, d = Re(), { isSelectingTarget: p } = d, [, g] = y.useState(0), [m, v] = y.useState(""), [b, x] = y.useState(""), [w, j] = y.useState(""), [C, E] = y.useState([]), P = Ar(), k = qe(), T = P.Pages.getAll(), O = k.tScoped("traitManager.traits.labels"), A = () => g((L) => ++L), $ = c.get(R2) ?? !1, N = N2(r, c), R = (L) => {
    n.setValue(L);
  }, z = (L) => {
    c.set({ [R2]: L }), A();
  }, D = (L) => {
    v(""), x(""), j(""), R(""), c.set({ [HP]: L }), A();
  }, Z = (L) => {
    R(L), A();
  }, K = (L) => {
    L && (R(L.id), A());
  }, H = (L) => {
    R(`${yv}${L}`), j(L);
  }, q = (L) => {
    R(`${tp}${L}${b ? `?${u1}${b}` : ""}`), v(L);
  }, te = (L) => {
    R(`${tp}${m}${L ? `?${u1}${L}` : ""}`), x(L);
  }, I = () => {
    d.setSelectingTarget(!p);
  }, F = (L) => {
    const W = L.replace(VP, ""), ie = P.Components.componentsById[W];
    return {
      id: L,
      label: ie ? $2(ie) : L
    };
  };
  y.useEffect(() => {
    var W;
    const L = [];
    if ($) {
      const ie = ["path", "br", "b", "u", "i", "strike"], re = (W = P.Pages.getSelected()) == null ? void 0 : W.getMainComponent();
      re == null || re.forEachChild((le) => {
        !le.is("comment") && !le.is("textnode") && !ie.includes(le.get("tagName")) && L.push({ id: `#${le.getId()}`, label: $2(le) });
      });
    }
    E(L);
  }, [$]), y.useEffect(() => {
    let L = () => {
    };
    const W = () => {
      L(), P.stopCommand(vp);
    };
    return p && (L = cO(W), P.runCommand(vp, {
      onSelect: (ie) => R(`#${ie.getId()}`)
    })), W;
  }, [p]), y.useEffect(() => {
    if (!r)
      return;
    switch (N2(r, c)) {
      case "phone":
        j(r.replace(yv, ""));
        break;
      case "email": {
        const [W, ie = ""] = r.replace(tp, "").split("?");
        v(W), x(ie.replace(u1, ""));
        break;
      }
    }
  }, [r]);
  const V = Li({ className: B(aB, l) });
  return /* @__PURE__ */ u.jsxs("div", { ...V, children: [
    /* @__PURE__ */ u.jsx(Eo, { ...t, as: i }),
    /* @__PURE__ */ u.jsx("div", { className: B(o && "gs-utl-pointer-events-none opacity-50"), children: /* @__PURE__ */ u.jsx(
      Ds,
      {
        onChange: D,
        classNamePanel: "gs-utl-p-1",
        value: N,
        tabs: [
          {
            id: "url",
            label: /* @__PURE__ */ u.jsx(ye, { icon: fe.link, size: Ee.s }),
            content: /* @__PURE__ */ u.jsx(
              jt,
              {
                placeholder: "eg. https://google.com",
                value: r,
                label: "URL",
                onChange: R,
                size: "s",
                type: "url"
              }
            )
          },
          {
            id: "pages",
            label: /* @__PURE__ */ u.jsx(ye, { icon: fe.textBoxMultiple, size: Ee.s }),
            content: /* @__PURE__ */ u.jsx(
              Ze,
              {
                size: "s",
                options: T.map((L) => ({ id: `page://${L.getId()}`, label: L.getName() })),
                value: r,
                onChange: Z,
                label: "Page"
              }
            )
          },
          {
            id: "elements",
            label: /* @__PURE__ */ u.jsx(ye, { icon: fe.viewDayOutline, size: Ee.s }),
            content: /* @__PURE__ */ u.jsxs(G, { gap: "s", col: !0, children: [
              /* @__PURE__ */ u.jsx(wi, { size: "s", children: "Element ID" }),
              /* @__PURE__ */ u.jsxs(G, { gap: "xs", nowrap: !0, children: [
                $ ? /* @__PURE__ */ u.jsx(
                  IP,
                  {
                    options: C,
                    onChange: K,
                    value: F(r),
                    placeholder: k.t("selectList")
                  }
                ) : /* @__PURE__ */ u.jsx(
                  jt,
                  {
                    size: "s",
                    placeholder: "eg. #my-element-in-page",
                    value: r,
                    onChange: R,
                    className: "gs-utl-flex-1"
                  }
                ),
                /* @__PURE__ */ u.jsx(
                  Qt,
                  {
                    title: k.t("selectTarget"),
                    size: "m2",
                    active: p,
                    onClick: I,
                    className: "gs-utl-h-[30px]",
                    children: /* @__PURE__ */ u.jsx(ye, { icon: fe.target, size: Ee.sx })
                  }
                )
              ] }),
              /* @__PURE__ */ u.jsx(mu, { value: $, onChange: z, label: O("showList") })
            ] })
          },
          {
            id: "email",
            label: /* @__PURE__ */ u.jsx(ye, { icon: fe.email, size: Ee.s }),
            content: /* @__PURE__ */ u.jsxs(G, { gap: "s", col: !0, children: [
              /* @__PURE__ */ u.jsx(
                jt,
                {
                  placeholder: "eg. mail@gmail.com",
                  value: m,
                  onChange: q,
                  size: "s",
                  label: "Email",
                  type: "email"
                }
              ),
              /* @__PURE__ */ u.jsx(
                jt,
                {
                  placeholder: "eg. My subject",
                  value: b,
                  onChange: te,
                  label: "Subject",
                  size: "s"
                }
              )
            ] })
          },
          {
            id: "phone",
            label: /* @__PURE__ */ u.jsx(ye, { icon: fe.phone, size: Ee.s }),
            content: /* @__PURE__ */ u.jsx(
              jt,
              {
                size: "s",
                type: "tel",
                label: "Phone",
                placeholder: "eg. +55123456789",
                value: w,
                onChange: H
              }
            )
          }
        ]
      }
    ) })
  ] });
});
function cB({ trait: e, value: t, disabled: n, label: r, labelAs: o }) {
  const [i, l] = y.useState(), c = e.get("properties"), d = e.get("addItem"), p = e.get("labelItem"), g = t || [], m = g.findIndex((v) => v.id === (i == null ? void 0 : i.id));
  return /* @__PURE__ */ u.jsx(
    Ho,
    {
      items: g,
      selected: m > -1 ? i : null,
      select: l,
      disabled: n,
      label: r,
      labelAs: o,
      add: () => {
        const v = g.length + 1, b = d ? d(v) : { id: `opt${v}`, label: `New option ${v}` };
        e.setValue([...g, b]);
      },
      move: (v, b) => {
        const x = e.getValue().filter((w) => w.id !== v.id);
        x.splice(b, 0, v), e.setValue(x);
      },
      remove: (v) => {
        const b = e.getValue().filter((x) => x.id !== v.id);
        e.setValue(b, { removed: v });
      },
      renderItem: (v) => p ? p(v) : v.label,
      children: /* @__PURE__ */ u.jsx(G, { space: "m", col: !0, children: !!i && c.map((v) => {
        const { name: b, getValue: x } = v, w = v.setValue, j = v.label || b, C = g[m];
        if (!C)
          return null;
        const E = C[b], P = x ? x(E) : E, k = (O) => {
          const A = { ...C };
          C[b] = w ? w(O, P) : O, e.setValue([...g], { item: C, previous: A }), b === "id" && l(C);
        };
        let T = /* @__PURE__ */ u.jsx(jt, { label: j, value: P, onChange: k });
        switch (v.type) {
          case "select":
            T = /* @__PURE__ */ u.jsx(Ze, { label: j, options: v.options, value: P, onChange: k });
        }
        return /* @__PURE__ */ u.jsx(y.Fragment, { children: T }, b);
      }) })
    }
  );
}
const uB = "gs-trait-custom-type", dB = xe(function({ trait: t, editor: n }) {
  const r = y.useRef(null), o = t.getType(), i = t.target, { Traits: l } = n, c = l.getType(o), d = !!(i && c), p = r.current;
  return y.useEffect(() => {
    if (c && p && i) {
      const g = new c({
        model: t,
        config: l.getConfig(),
        attributes: t.get("attributes")
      }), m = g.render().el;
      return p.appendChild(m), g.listenTo(i, "change", () => g.postUpdate()), () => {
        p.removeChild(m), g.removeView();
      };
    }
  }, [p]), d && /* @__PURE__ */ u.jsx("div", { className: uB, ref: r });
});
function fB(e, t) {
  const n = e.em.getEditor(), r = e.target;
  let o = !1;
  t === !0 ? o = !0 : Qo(t) && Ct(t.enable) && (o = t.enable({
    trait: e,
    component: r,
    editor: n
  }));
  const i = e.getValue({ skipResolve: !0 }), l = r.collectionsStateMap, c = ji(i);
  return {
    hasDataResolverValue: c,
    dataResolverValue: c ? e.getValue() : void 0,
    enableDataValue: o,
    initialDataValue: i,
    handleDataValueChange: (d) => e.setValue(d),
    handleValueClear: () => {
      const d = e.getValue();
      e.setValue(""), e.setValue(d);
    },
    editor: n,
    additionalSources: l
  };
}
const pB = ({ label: e, buttons: t }) => /* @__PURE__ */ u.jsxs(G, { items: "center", nowrap: !0, full: !0, children: [
  /* @__PURE__ */ u.jsx(Y, { grow: !0, children: e }),
  /* @__PURE__ */ u.jsx(G, { nowrap: !0, items: "center", justify: "end", gap: "x2s", children: t.map((n, r) => /* @__PURE__ */ u.jsx(Qt, { ...n }, r)) })
] }), FP = (e) => Wo((e || "").replace(/-/g, " ")), gB = (e, t) => ({
  size: "s",
  tip: e.get("tip"),
  type: e.getType(),
  value: e.getValue(),
  label: e.get("label") !== !1 && FP(e.getLabel({ locale: !0 })),
  placeholder: (t == null ? void 0 : t.t(`traitManager.traits.attributes.${e.getId()}.placeholder`)) || e.get("placeholder") || "",
  onChange: (n, r) => e.setValue(n, { partial: r })
}), _o = (e, t, n) => {
  const r = fB(e, n.traitManagerDataConfig), o = m5(r), { hasDataResolverValue: i, dataResolverValue: l } = r, c = gB(e, t);
  return {
    ...c,
    value: l ?? c.value,
    disabled: i,
    labelAs: o.length ? "span" : void 0,
    label: /* @__PURE__ */ u.jsx(pB, { label: c.label, buttons: o })
  };
}, D2 = (e, t, n) => _o(e, t, n), hB = (e, t, n) => _o(e, t, n), mB = (e, t, n) => {
  const r = ji(e.getValue({ skipResolve: !0 })), o = _o(e, t, n), i = {
    min: e.get("min"),
    max: e.get("max"),
    step: e.get("step"),
    pan: !r,
    units: r ? [] : e.get("units"),
    onChange: (l, c) => {
      const d = c || isNaN(parseFloat(l)) ? l : parseFloat(l);
      e.setValue(d, { partial: c });
    }
  };
  return { ...o, ...i };
}, zP = (e, t, n) => {
  const r = e.get("labelToTitle"), o = ji(e.getValue({ skipResolve: !0 })), i = _o(e, t, n), l = {
    options: e.getOptions().map((c) => {
      const d = c.labelReact || c.name || c.label || c.value;
      return Dt(c) ? { id: c, label: c } : {
        id: c.id || c.value,
        title: r ? d : c.title,
        icon: c.icon,
        label: r ? "" : d
      };
    }),
    onChange: (c) => e.setValue(c),
    emptyState: o && e.getValue() || void 0,
    hideCaret: o
  };
  return { ...i, ...l };
}, vB = (e, t, n) => {
  const { options: r, onChange: o } = zP(e, t, n), i = { options: r, onChange: o };
  return { ..._o(e, t, n), ...i };
}, yB = (e, t, n) => {
  const r = e.get("typeProps") || {}, o = ji(e.getValue({ skipResolve: !0 }));
  return {
    ..._o(e, t, n),
    isContain: !0,
    hideButton: o,
    btnLabel: e.get("text"),
    onOpen() {
      if (o)
        return;
      const l = t == null ? void 0 : t.Assets;
      l == null || l.open({
        select(c) {
          e.setValue(c.getSrc()), l.close();
        }
      });
    },
    ...r
  };
}, bB = (e) => ({
  children: FP(e.getLabel() || e.get("text") || e.get("labelButton")),
  onClick: () => {
    const t = e.em.Editor, n = e.get("command");
    Dt(n) ? t.runCommand(n) : n == null || n(t, e);
  },
  full: !0
}), xB = (e, t, n) => {
  const r = _o(e, t, n), i = {
    value: !!(r.disabled ? r.value : e.getValue({ useType: !0 })),
    onChange: (l) => e.setValue(l)
  };
  return {
    ...r,
    ...i
  };
}, wB = (e, t, n) => {
  const r = _o(e, t, n), o = e.get("typeProps") || {}, i = ji(e.getValue({ skipResolve: !0 }));
  return {
    language: "css",
    ...o,
    ...r,
    formatOnMount: !i,
    onChange: (l) => e.setValue(l)
  };
}, SB = (e, t, n) => ({
  ..._o(e, t, n),
  trait: e
}), jB = (e, t, n) => ({
  ..._o(e, t, n),
  trait: e
}), CB = (e, t, n) => ({
  ..._o(e, t, n),
  trait: e,
  editor: t
});
function EB(e, t, n = {}) {
  var l;
  const r = e.get("visible"), o = e.getType(), i = { traitManagerDataConfig: n.traitManagerDataConfig };
  if (Ct(r) && r({ component: e.target, trait: e }) === !1)
    return null;
  switch (o) {
    case "text":
      return /* @__PURE__ */ u.jsx(jt, { ...D2(e, t, i) });
    case "select":
      return /* @__PURE__ */ u.jsx(Ze, { ...zP(e, t, i) });
    case "number":
      return /* @__PURE__ */ u.jsx(et, { ...mB(e, t, i) });
    case "color":
      return /* @__PURE__ */ u.jsx(Rs, { ...hB(e, t, i) });
    case "checkbox":
      return /* @__PURE__ */ u.jsx(mu, { ...xB(e, t, i) });
    case "button":
      return /* @__PURE__ */ u.jsx(ut, { ...bB(e) });
    case "radio":
      return /* @__PURE__ */ u.jsx(Kn, { ...vB(e, t, i) });
    case "code":
      return /* @__PURE__ */ u.jsx(As, { ...wB(e, t, i), ...n }, ((l = t == null ? void 0 : t.getSelected()) == null ? void 0 : l.getId()) || "");
    case "image":
    case "file":
      return /* @__PURE__ */ u.jsx(vu, { ...yB(e, t, i) });
    case "stack":
      return /* @__PURE__ */ u.jsx(cB, { ...SB(e, t, i) });
    case "href":
      return /* @__PURE__ */ u.jsx(lB, { ...jB(e, t, i) });
    case "custom":
      return /* @__PURE__ */ u.jsx(sB, { ...CB(e, t, i) });
    default:
      return !!t.Traits.getType(o) ? /* @__PURE__ */ u.jsx(dB, { editor: t, trait: e }) : /* @__PURE__ */ u.jsx(jt, { ...D2(e, t, i) });
  }
}
const bv = "gs-trait-manager", I2 = ({
  trait: e,
  isDarkTheme: t,
  traitManagerDataConfig: n
}) => /* @__PURE__ */ u.jsx(Y, { className: ce(`${bv}-field gs-utl-mb-2 gs-utl-w-full`), children: EB(e, e.em.getEditor(), { isDarkTheme: t, traitManagerDataConfig: n }) });
function PB({ traits: e, className: t }) {
  var g, m;
  const n = Ar(), { isDarkTheme: r } = gr(), i = (g = Re().sdkOptions.dataSources) == null ? void 0 : g.traitManager, l = n.Traits.getTraitsByCategory(e), c = (m = l.find((v) => !v.category)) == null ? void 0 : m.items, d = l.filter((v) => v.category), p = ce("gs-utl-text-center");
  return /* @__PURE__ */ u.jsx(G, { className: ce(bv, t), col: !0, children: n.getSelected() ? e.length ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    c == null ? void 0 : c.map((v) => /* @__PURE__ */ u.jsx(
      I2,
      {
        trait: v,
        isDarkTheme: r,
        traitManagerDataConfig: i
      },
      v.id
    )),
    d.map(({ category: v, items: b }, x) => /* @__PURE__ */ u.jsx(
      ja,
      {
        open: !!(v != null && v.get("open")),
        onChange: ({ open: w }) => v == null ? void 0 : v.set({ open: w }),
        handler: v == null ? void 0 : v.getLabel(),
        handlerIcon: v == null ? void 0 : v.get("icon"),
        classNameContent: "gs-utl-p-2",
        classNameWrap: `${bv}-category -gs-utl-mx-2`,
        className: (w) => ce(
          Vv.itemList({
            index: x + (c ? 1 : 0),
            open: w,
            length: d.length
          })
        ),
        children: b.map((w) => /* @__PURE__ */ u.jsx(
          I2,
          {
            trait: w,
            isDarkTheme: r,
            traitManagerDataConfig: i
          },
          w.id
        ))
      },
      v == null ? void 0 : v.id
    ))
  ] }) : /* @__PURE__ */ u.jsx(Y, { className: p, children: "No properties available" }) : /* @__PURE__ */ u.jsx(Y, { className: p, children: n.t("traitManager.empty") }) });
}
const xv = xe(PB), _B = "gs-panel-properties", kB = y.memo(
  xe(function({ className: t, ...n }) {
    return /* @__PURE__ */ u.jsx(
      Po,
      {
        className: B(_B, "gs-utl-overflow-auto gs-utl-h-full", t),
        classNameAccordion: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: B("gs-utl-overflow-auto"),
        ...n,
        children: /* @__PURE__ */ u.jsx(iv, { children: (r) => /* @__PURE__ */ u.jsx(xv, { ...r }) })
      }
    );
  })
), TB = async ({ html: e = "", css: t = "", el: n }) => {
  const r = `<span style="color: initial; display: inline-block;"><style> body { margin: 0; } ${t}</style>${e}</span>`, o = {};
  if (document.body.attachShadow) {
    const i = n.shadowRoot || n.attachShadow({ mode: "open" });
    i.innerHTML = r;
  }
  return o;
}, OB = xe(function({ rule: t, onSelect: n, onRemove: r, className: o }) {
  const i = y.useRef(null), c = Re().editor, d = qe(), p = t.getDevice(), g = t.getState(), { isDarkTheme: m } = gr(), [v, b] = y.useState(t.toCSS({ allowEmpty: !0 })), [x, w] = y.useState(v), j = t.selectorsToString(), C = () => {
    c.select(), setTimeout(() => c.Selectors.select(t)), n == null || n();
  }, E = () => {
    c.Css.remove(t), r == null || r();
  }, P = () => {
    if (x) {
      const k = c.Parser.parseCss(x)[0];
      k && (t.setStyle(k.style), b(x));
    }
  };
  return y.useEffect(() => {
    if (i.current) {
      const k = i.current;
      TB({
        el: k,
        html: '<div class="prv-rule">Preview</div>',
        css: `
        .prv-rule {
          background-color: #fff;
          padding: 5px;
        }
        .prv-rule, ${v}
        `
      });
    }
  }, [i, v]), /* @__PURE__ */ u.jsx(pr, { padding: !1, className: ge("overflow-hidden max-w-full group", o), children: /* @__PURE__ */ u.jsxs(G, { col: !0, space: "xs", children: [
    /* @__PURE__ */ u.jsx(G, { className: ge("bg-checker gjs-p-3 overflow-auto overflow-x-hidden h-20"), justify: "center", items: "center", children: /* @__PURE__ */ u.jsx("div", { ref: i, className: ge("relative flex items-center justify-center") }) }),
    /* @__PURE__ */ u.jsxs(G, { className: ge("gjs-p-1 w-full"), col: !0, space: "s", children: [
      /* @__PURE__ */ u.jsxs(G, { nowrap: !0, items: "center", space: "xs", full: !0, children: [
        /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx("pre", { className: ge("text-xs bg-white/10", ee.txt, ve.rnd, tt.xyS), children: j }) }),
        !!p && p.getWidthMedia() && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
          _n,
          {
            title: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
              d.t("deviceManager.device"),
              ": ",
              /* @__PURE__ */ u.jsx("b", { children: p.getName() })
            ] }),
            children: /* @__PURE__ */ u.jsx(ye, { icon: fe.cellphoneLink, size: Ee.sx })
          }
        ) }),
        !!g && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
          _n,
          {
            title: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
              d.t("selectorManager.state"),
              ": ",
              /* @__PURE__ */ u.jsx("b", { children: g.getLabel() })
            ] }),
            children: /* @__PURE__ */ u.jsx(ye, { icon: fe.flare, size: Ee.sx })
          }
        ) })
      ] }),
      /* @__PURE__ */ u.jsxs(G, { nowrap: !0, className: ge(nt.txtEllips), space: "s", children: [
        /* @__PURE__ */ u.jsx(Y, { className: ge("group-hover:gs-utl-opacity-100 opacity-0 transition-opacity"), grow: !0, children: /* @__PURE__ */ u.jsx(ut, { onClick: C, className: ge("text-sm gjs-mr-auto"), size: "m2", full: !0, children: d.t("select") }) }),
        /* @__PURE__ */ u.jsx(
          rs,
          {
            overlay: !0,
            title: !1,
            padding: !1,
            buttonAs: "span",
            handler: /* @__PURE__ */ u.jsx(Qt, { title: d.t("selectorManager.showCSS"), children: /* @__PURE__ */ u.jsx(ye, { icon: fe.codeBraces, size: Ee.sx }) }),
            children: ({ close: k }) => /* @__PURE__ */ u.jsxs(G, { className: ge("relative w-80 h-48"), col: !0, children: [
              /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(
                As,
                {
                  defaultValue: Z0(v),
                  onChange: w,
                  language: "css",
                  padding: 5,
                  isDarkTheme: m,
                  clean: !0
                }
              ) }),
              /* @__PURE__ */ u.jsx(
                ut,
                {
                  className: ge("absolute right-2 bottom-2 text-sm"),
                  variant: "pr",
                  size: "m2",
                  onClick: () => {
                    P(), k();
                  },
                  children: d.t("update")
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ u.jsx(ny, { onConfirm: E, className: ge("w-48"), children: /* @__PURE__ */ u.jsx(Qt, { title: d.t("selectorManager.deleteStyle"), children: /* @__PURE__ */ u.jsx(ye, { icon: fe.delete, size: Ee.sx }) }) })
      ] })
    ] })
  ] }, t.cid) });
}), LB = xe(function() {
  const [t] = fg(), n = os(), r = qe(), [o, i] = y.useState(""), [l, c] = y.useState(""), p = Re().editor, [g, m] = y.useState(p.Css.getRules("")), v = p.Devices.getDevices().map((w) => ({
    id: w.id,
    label: w.getName()
  })), b = g.filter((w) => {
    var j;
    return !(o && !ll(w.selectorsToString(), o) || l && ((j = w.getDevice()) == null ? void 0 : j.id) !== l);
  }), x = () => m(p.Css.getRules(""));
  return /* @__PURE__ */ u.jsxs(G, { col: !0, space: "m", children: [
    /* @__PURE__ */ u.jsxs(G, { items: "center", space: "m", children: [
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
        jt,
        {
          size: "s",
          type: "search",
          value: o,
          onInput: i,
          placeholder: `${r.t("selectorManager.searchStyle")}...`
        }
      ) }),
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
        Ze,
        {
          includeEmpty: !0,
          size: "s",
          value: l,
          options: v,
          onChange: c,
          emptyState: r.t("deviceManager.allDevices"),
          handlerSelected: (w) => /* @__PURE__ */ u.jsxs(G, { space: "s", items: "center", children: [
            /* @__PURE__ */ u.jsx(ye, { icon: fe.cellphoneLink, size: Ee.sx }),
            /* @__PURE__ */ u.jsx("span", { children: w.label })
          ] })
        }
      ) })
    ] }),
    /* @__PURE__ */ u.jsx(Y, { className: ge("gs-utl-h-[75vh] w-full overflow-auto"), children: b.length ? /* @__PURE__ */ u.jsx(
      Qu,
      {
        data: b,
        listClassName: ge("grid grid-cols-4 gap-2 gjs-pr-2"),
        itemContent: (w, j) => /* @__PURE__ */ u.jsx(OB, { rule: j, onRemove: x, onSelect: n.close }, j.cid)
      },
      t
    ) : /* @__PURE__ */ u.jsx(G, { justify: "center", children: r.t("modals.styleCatalog.noStyles") }) })
  ] });
});
function BP({
  className: e,
  value: t,
  active: n,
  unstyled: r,
  activable: o,
  onChange: i,
  onActive: l,
  ...c
}) {
  const [d, p] = y.useState(n);
  y.useEffect(() => {
    p(n);
  }, [n]);
  const g = (v) => {
    l == null || l(v), p(v);
  }, m = (v) => {
    i(v), g(!1);
  };
  return /* @__PURE__ */ u.jsx("div", { className: ce("truncate", e), ...c, onDoubleClick: () => o && g(!0), children: d ? /* @__PURE__ */ u.jsx(ry, { className: ce(r && nt.noFocusOut), value: t, onChange: m }) : /* @__PURE__ */ u.jsx(u.Fragment, { children: t }) });
}
const MB = xe(function({ selector: t, className: n, removable: r, toggleable: o }) {
  const i = qe(), l = Re(), [c, d] = y.useState(), [p, g] = y.useState(t.getActive()), m = l.editor, { Selectors: v } = m, b = t.getLabel(), x = /* @__PURE__ */ u.jsx(ye, { icon: fe.dotsVertical, size: Ee.sx }), w = () => {
    v.removeSelected(t);
  }, j = (O) => {
    c && v.rename(c, O), d(void 0);
  }, C = () => {
    v.duplicateSelected(t);
  }, E = () => {
    const O = !t.getActive();
    g(O), t.setActive(O);
  }, k = [
    { id: "rename", label: i.t("rename"), action: () => d(t) },
    { id: "duplicate", label: i.t("duplicate"), action: C },
    r && { id: "delete", label: i.t("delete"), action: w },
    o && { id: "active", label: i.t(p ? "disable" : "enable"), action: E }
  ].filter(Boolean), T = (O, A) => ($) => {
    O(), Ct(A) && A($);
  };
  return /* @__PURE__ */ u.jsx(dn, { className: ge(["gjs-ml-1 gjs-my-1 group overflow-hidden cursor-default relative", ee.sel, n]), s: "s", children: /* @__PURE__ */ u.jsxs(G, { items: "center", children: [
    /* @__PURE__ */ u.jsx(Y, { className: ge("gjs-mr-4", !c && !p && "opacity-50 line-through"), children: /* @__PURE__ */ u.jsx(BP, { value: b, onChange: j, active: !!c, unstyled: !0 }) }),
    /* @__PURE__ */ u.jsx(G, { className: ge("absolute h-full right-0 transition-opacity", ee.sel, ee.selBr, ve.bl), children: /* @__PURE__ */ u.jsx(rs, { handler: x, title: !1, padding: !1, fixed: !0, overlay: !0, children: ({ close: O }) => k.map((A) => /* @__PURE__ */ u.jsx(
      Bu,
      {
        className: ge(ee.txt),
        label: A.label,
        action: T(O, A.action)
      },
      A.id
    )) }) })
  ] }) });
}), AB = (e) => (e == null ? void 0 : e.get("groups")) || [], RB = /^\.[a-zA-Z_][\w-]*$/;
function NB(e, t = {}) {
  const n = e.Css.getAll().filter(
    (r) => AB(r).some((o) => o.startsWith(wa.globalStyles))
  );
  return t.withSingleClass ? n.filter((r) => RB.test(r.getSelectorsString())) : n;
}
const $B = (e) => {
  const { Selectors: t } = e, n = t.getAll({ array: !0 });
  return t.getSelectedAll().reduce((i, l) => {
    const c = i.indexOf(l);
    return c >= 0 && i.splice(c, 1), i;
  }, n).filter((i) => i.isClass());
}, DB = (e, t) => {
  const { sdkGlobalStylesConfig: n } = t, { i18nStore: r } = t.store, i = (n != null && n.showInClassSelectors ? NB(e, { withSingleClass: !0 }) : []).map((c) => {
    const d = c.getSelectorsString().replace(".", "");
    return {
      id: d,
      label: `${r.t("globalStyleManager.globalStyles")}: ${d}`
    };
  });
  return [...$B(e).map((c) => ({
    id: c,
    label: c.getLabel()
  })), ...i];
}, IB = (e) => {
  var r, o;
  let t = (r = e == null ? void 0 : e.selectorsToString) == null ? void 0 : r.call(e);
  const n = (o = e == null ? void 0 : e.getAtRule) == null ? void 0 : o.call(e);
  return t && n && (t = `${n} {
	${t}
}`), t;
}, Br = "gs-cmp-selector-manager", d1 = {}, UP = xe(function(t) {
  var we, je, He;
  const { selectedState: n, states: r, setState: o, styleCatalog: i, stateSelector: l } = t, c = Re(), [d, p] = y.useState(!1), [g, m] = y.useState([]), [v, b] = y.useState(d1), { toggleCssPanel: x, isCssPanelActive: w, editor: j, store: C } = Re(), { i18nStore: E, modalStore: P } = C, k = j == null ? void 0 : j.getSelected(), T = j == null ? void 0 : j.Styles.getSelected();
  if (y.useEffect(() => {
    if (j && T && c) {
      const Le = setTimeout(() => {
        let ot = d1;
        const vt = k == null ? void 0 : k.get("selectorManager");
        k && Ct(vt) && (ot = vt({ editor: j, component: k })), b(ot || d1), m(DB(j, c));
      });
      return () => clearTimeout(Le);
    }
  }, [k, j, T, c]), !j)
    return null;
  const { Selectors: O } = j, A = v.disableClasses, $ = v.disableComponent, N = A && $, R = O.getComponentFirst() && !$, z = O.getSelectedAll(), D = j.getSelectedAll(), Z = r.map((Le) => ({ id: Le.getName(), label: Le.getLabel() })), K = j.getModel(), H = (we = T == null ? void 0 : T.getDevice) == null ? void 0 : we.call(T), q = (je = T == null ? void 0 : T.getState) == null ? void 0 : je.call(T), te = B("gs-utl-overflow-hidden", ve.b, ve.rnd, ee.br), I = B(ee.bA), F = B("gs-utl-flex gs-utl-h-full gs-utl-cursor-pointer gs-utl-p-2", ve.br, ee.br), V = `${ee.bgA}`, L = IB(T), W = z.length > 0, ie = D.length > 0, re = W || ie, le = R && ie || !R && !W, me = le ? "Components" : "Selectors", oe = (Le) => E.t(`selectorManager.${Le}`), se = E.t("modals.styleCatalog.title"), de = () => P.open({ title: se, content: /* @__PURE__ */ u.jsx(LB, {}) });
  return /* @__PURE__ */ u.jsxs(G, { className: Br, gap: "s", col: !0, full: !0, children: [
    /* @__PURE__ */ u.jsxs(G, { className: B(`${Br}__head`), items: "center", justify: "between", gap: "m", children: [
      /* @__PURE__ */ u.jsxs(G, { className: B(`${Br}__head-start`), items: "center", gap: "s", children: [
        /* @__PURE__ */ u.jsx(Y, { className: B(`${Br}__head-title`), children: oe("selection") }),
        i !== !1 && /* @__PURE__ */ u.jsx(Y, { className: B(`${Br}__style-catalog`), children: /* @__PURE__ */ u.jsx(_n, { className: "gs-utl-cursor-pointer", onClick: de, title: se, children: /* @__PURE__ */ u.jsx(ye, { icon: fe.paletteSwatch, size: Ee.s }) }) })
      ] }),
      !!T && l !== !1 && !N && /* @__PURE__ */ u.jsx(Y, { className: `${Br}__head-end`, children: /* @__PURE__ */ u.jsx(
        Ze,
        {
          size: "s",
          value: n,
          options: Z,
          includeEmpty: !0,
          onChange: o,
          emptyState: `- ${oe("state")} -`,
          className: B(n && ee.bA)
        }
      ) })
    ] }),
    re && !N ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      !A && /* @__PURE__ */ u.jsxs(
        G,
        {
          className: B(`${Br}__field-selectors`, te, !le && I),
          items: "stretch",
          gap: "xs",
          children: [
            /* @__PURE__ */ u.jsx(
              _n,
              {
                title: oe(W ? "applyOnSelector" : "noSelectors"),
                className: B(F, !le && V),
                onClick: () => W && O.setComponentFirst(!1),
                children: /* @__PURE__ */ u.jsx(G, { className: "gs-utl-h-full", items: "center", children: /* @__PURE__ */ u.jsx(ye, { icon: fe.tag, size: Ee.sx }) })
              }
            ),
            /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(G, { className: "gs-utl-h-full gs-utl-pr-1", items: "center", children: d ? /* @__PURE__ */ u.jsx(
              IP,
              {
                autoFocus: !0,
                open: !0,
                hideCaret: !0,
                border: !1,
                options: g,
                allowNew: oe("addNewSelector"),
                onBlur: () => setTimeout(() => p(!1), 100),
                onChange: (Le) => {
                  Le && (O.addSelected(Le.id || Le.label), p(!1));
                }
              }
            ) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
              ie && /* @__PURE__ */ u.jsx(
                Qt,
                {
                  title: oe("addNewSelector"),
                  variant: "out",
                  size: "xs",
                  className: "gs-utl-p-0.5",
                  onClick: () => p(!0),
                  block: !0,
                  children: /* @__PURE__ */ u.jsx(ye, { icon: fe.plus, size: Ee.sx })
                }
              ),
              z.map((Le) => /* @__PURE__ */ u.jsx(
                MB,
                {
                  selector: Le,
                  removable: ie,
                  toggleable: ie && z.filter((ot) => ot.getActive() || ot === Le).length > 1
                },
                Le.toString()
              ))
            ] }) }) })
          ]
        }
      ),
      !$ && /* @__PURE__ */ u.jsxs(
        G,
        {
          className: B(`${Br}__field-components`, te, le && I),
          items: "stretch",
          gap: "xs",
          children: [
            /* @__PURE__ */ u.jsx(
              _n,
              {
                title: oe(ie ? "applyOnComponents" : "noComponents"),
                onClick: () => ie && O.setComponentFirst(!0),
                className: B(F, le && V),
                children: /* @__PURE__ */ u.jsx(G, { className: "gs-utl-h-full", items: "center", children: /* @__PURE__ */ u.jsx(ye, { icon: fe.targetVariant, size: Ee.sx }) })
              }
            ),
            /* @__PURE__ */ u.jsx(Y, { grow: !0, className: "gs-utl-py-0.5", children: /* @__PURE__ */ u.jsx(G, { className: "gs-utl-h-full gs-utl-pr-1", items: "center", children: D.map((Le) => /* @__PURE__ */ u.jsx(
              dn,
              {
                s: "s",
                className: B("gs-utl-ml-1 gs-utl-my-0.5 gs-utl-cursor-default", ee.cmp),
                onPointerEnter: () => K.setHovered(Le),
                onPointerOut: () => K.setHovered(),
                label: Le.getName()
              },
              Le.getId()
            )) }) })
          ]
        }
      ),
      /* @__PURE__ */ u.jsxs(G, { className: `${Br}__actions`, gap: "s", items: "center", justify: "between", children: [
        /* @__PURE__ */ u.jsx(
          _n,
          {
            title: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
              /* @__PURE__ */ u.jsx("div", { children: oe("selected") }),
              /* @__PURE__ */ u.jsx(
                "pre",
                {
                  className: B(
                    "gs-utl-text-xs gs-utl-mt-1 gs-utl-bg-white/10 gs-utl-text-gray-400",
                    ve.rnd,
                    tt.xyS
                  ),
                  children: L
                }
              ),
              /* @__PURE__ */ u.jsx("div", { className: "gs-utl-text-xs gs-utl-mt-1.5", children: oe("currentSelection") })
            ] }),
            children: /* @__PURE__ */ u.jsx(dn, { className: B(ve.b, ve.rnd, ee.br), s: "xs", nopad: !0, block: !0, children: /* @__PURE__ */ u.jsx(ye, { icon: fe.target, size: Ee.sx }) })
          }
        ),
        /* @__PURE__ */ u.jsx(Y, { className: "gs-utl-text-sm", children: /* @__PURE__ */ u.jsx(dn, { className: B(ve.b, ve.rnd, ee.br), s: "xs", nopad: !0, children: /* @__PURE__ */ u.jsxs(G, { space: "xs", items: "center", nowrap: !0, children: [
          !!H && H.getWidthMedia() && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsx(
              _n,
              {
                title: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
                  oe("device"),
                  ": ",
                  /* @__PURE__ */ u.jsx("b", { children: H.getName() })
                ] }),
                children: /* @__PURE__ */ u.jsx(ye, { icon: fe.cellphoneLink, size: Ee.sx })
              }
            ),
            /* @__PURE__ */ u.jsx(Y, { className: "gs-utl-opacity-30", children: "|" })
          ] }),
          /* @__PURE__ */ u.jsx(
            _n,
            {
              title: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
                oe("target"),
                ": ",
                /* @__PURE__ */ u.jsx("b", { children: me }),
                /* @__PURE__ */ u.jsxs("span", { className: "gs-utl-text-xs gs-utl-opacity-75", children: [
                  " ",
                  (He = T == null ? void 0 : T.selectorsToString) == null ? void 0 : He.call(T, { skipState: 1 })
                ] })
              ] }),
              children: /* @__PURE__ */ u.jsx(ye, { icon: le ? fe.targetVariant : fe.tag, size: Ee.sx })
            }
          ),
          !!q && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
            /* @__PURE__ */ u.jsx(Y, { className: "gs-utl-opacity-30", children: "|" }),
            /* @__PURE__ */ u.jsx(
              _n,
              {
                title: /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
                  oe("state"),
                  ": ",
                  /* @__PURE__ */ u.jsx("b", { children: q.getLabel() })
                ] }),
                children: /* @__PURE__ */ u.jsx(ye, { icon: fe.flare, size: Ee.sx })
              }
            )
          ] })
        ] }) }) }),
        /* @__PURE__ */ u.jsx(
          Qt,
          {
            title: E.t("toggleCss"),
            onClick: x,
            active: w,
            size: "s",
            children: /* @__PURE__ */ u.jsx(ye, { icon: fe.codeBraces, size: Ee.sx })
          }
        )
      ] })
    ] }) : /* @__PURE__ */ u.jsxs(G, { className: B(`${Br}__empty-state`, "gs-utl-text-sm gs-utl-leading-6 gs-utl-my-4"), col: !0, children: [
      /* @__PURE__ */ u.jsx(Y, { className: `${Br}__empty-state-title`, children: oe("noSelecton") }),
      /* @__PURE__ */ u.jsxs("ul", { className: B(`${Br}__empty-state-list`, "gs-utl-list-disc gs-utl-pl-5 gs-utl-mt-2"), children: [
        /* @__PURE__ */ u.jsx("li", { children: oe("selectFromCanvas") }),
        /* @__PURE__ */ u.jsx("li", { children: oe("selectFromList") })
      ] })
    ] })
  ] });
}), VB = "gs-panel-selectors", HB = y.memo(
  xe(function({
    className: t,
    styleCatalog: n,
    stateSelector: r,
    ...o
  }) {
    return /* @__PURE__ */ u.jsx(Po, { className: B(VB, t), ...o, children: /* @__PURE__ */ u.jsx(g5, { children: (i) => /* @__PURE__ */ u.jsx(UP, { ...i, styleCatalog: n, stateSelector: r }) }) });
  })
), FB = y.forwardRef(function({ children: t, className: n, content: r, ...o }, i) {
  return /* @__PURE__ */ u.jsx("div", { className: B(ge("gs-design-manager-tab"), n), ref: i, ...o, children: t });
}), V2 = "gs-cmp-sidebar-right", H2 = "gs-cmp-traits-provider", f1 = B("gs-utl-overflow-y-auto gs-utl-overflow-x-hidden gs-utl-max-w-full");
function zB() {
  var E, P, k;
  const {
    isCssPanelActive: e,
    selectedDesignerTab: t,
    showSelectors: n,
    setSelectedDesignerTab: r,
    sdkProps: o,
    sdkOptions: i,
    isProjectTypeEmail: l
  } = Re(), c = qe(), d = B(e && "gs-utl-hidden"), g = (((E = cr(o.children, FB)) == null ? void 0 : E.filter(Boolean)) || []).map(({ props: T }, O) => ({
    id: T.id,
    label: T.label,
    content: /* @__PURE__ */ u.jsx(Sa, { children: T.children }),
    order: T.order ?? 2 + O + 1
  })), m = (P = i.designPanel) == null ? void 0 : P.propsInStyles, v = (k = i.designPanel) == null ? void 0 : k.hideTabs, b = m === !0 || l && m !== !1, x = v === !0 || l && v !== !1, w = c.t("traitManager.panelLabel"), C = [
    {
      id: "style",
      label: c.t("styleManager.panelLabel"),
      order: 1,
      content: /* @__PURE__ */ u.jsxs(G, { col: !0, full: !0, children: [
        !!n && /* @__PURE__ */ u.jsx(Y, { className: B("gs-cmp-selectors-provider", tt.s, ve.bb, ee.br), children: /* @__PURE__ */ u.jsx(g5, { children: (T) => /* @__PURE__ */ u.jsx(UP, { ...T }) }) }),
        b && /* @__PURE__ */ u.jsx(Y, { className: B(H2, f1), children: /* @__PURE__ */ u.jsx(ja, { handler: w, className: I5(!1), sticky: !0, open: !0, children: /* @__PURE__ */ u.jsx(iv, { children: (T) => /* @__PURE__ */ u.jsx(xv, { ...T, className: B("gs-utl-p-2", ee.br, ve.bb) }) }) }) }),
        /* @__PURE__ */ u.jsx(Y, { className: B("gs-cmp-styles-provider", f1), grow: !0, children: /* @__PURE__ */ u.jsx(h5, { children: (T) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          e && /* @__PURE__ */ u.jsx(J5, {}),
          /* @__PURE__ */ u.jsx(F5, { className: d, ...T })
        ] }) }) })
      ] })
    },
    !b && {
      id: "props",
      label: w,
      order: 2,
      content: /* @__PURE__ */ u.jsx(G, { className: H2, col: !0, full: !0, children: /* @__PURE__ */ u.jsx(Y, { className: B(tt.s, f1), children: /* @__PURE__ */ u.jsx(iv, { children: (T) => /* @__PURE__ */ u.jsx(xv, { ...T }) }) }) })
    },
    ...g
  ].filter(Boolean).sort((T, O) => T.order - O.order);
  return /* @__PURE__ */ u.jsx(G, { className: V2, col: !0, full: !0, nowrap: !0, children: /* @__PURE__ */ u.jsx(
    Ds,
    {
      value: t,
      onChange: r,
      tabs: C,
      className: B(`${V2}__tabs`, x && "gs-utl-hidden")
    }
  ) });
}
const WP = xe(zB), BB = "gs-panel-sidebar-tabs", UB = y.memo(
  xe(function({ className: t, ...n }) {
    return /* @__PURE__ */ u.jsx(Po, { className: B(BB, "gs-utl-h-full", t), ...n, children: /* @__PURE__ */ u.jsx(WP, {}) });
  })
), WB = "gs-panel-styles", GB = y.memo(
  xe(function({ className: t, ...n }) {
    const { isCssPanelActive: r } = Re(), o = B(r && " gs-utl-hidden");
    return /* @__PURE__ */ u.jsx(
      Po,
      {
        className: B(WB, "gs-utl-overflow-auto gs-utl-h-full", t),
        classNameAccordion: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: B("gs-utl-overflow-auto"),
        ...n,
        children: /* @__PURE__ */ u.jsx(h5, { children: (i) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          r && /* @__PURE__ */ u.jsx(J5, {}),
          /* @__PURE__ */ u.jsx(F5, { className: o, ...i })
        ] }) })
      }
    );
  })
), KB = "gs-panel-templates", qB = y.memo(
  xe(function({
    className: t,
    templates: n,
    content: r,
    onSelect: o,
    ...i
  }) {
    const l = TE(), { projectTypeFilter: c } = l;
    let d = n ?? l.templates;
    return d = d == null ? void 0 : d.map((p) => ({ ...p, isTemplate: !0 })), y.useEffect(() => {
      n || l.loadTemplates();
    }, [n]), /* @__PURE__ */ u.jsx(
      Po,
      {
        className: B(KB, "gs-utl-overflow-hidden gs-utl-h-full", t),
        classNameAccordion: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        classNameAccordionContent: B("gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"),
        ...i,
        children: /* @__PURE__ */ u.jsx(G, { className: ge("relative gs-utl-h-full"), nowrap: !0, col: !0, space: "m", children: /* @__PURE__ */ u.jsx(G, { className: ge("gs-utl-h-[75vh] gs-utl-flex-grow"), nowrap: !0, col: !0, space: "m", children: /* @__PURE__ */ u.jsx(
          gP,
          {
            templates: d,
            projectType: Xe[c],
            content: r,
            onSelect: o,
            skipProjectNamePopover: !0
          }
        ) }) })
      }
    );
  })
), YB = "gs-cmp-row", XB = y.memo(function({ className: t, children: n, full: r, ...o }) {
  return /* @__PURE__ */ u.jsx(Rr, { className: B(YB, ee.bg, "gs-utl-flex", r && "gs-utl-w-full", t), ...o, children: Xn(n) });
}), ZB = "gs-cmp-select-field", JB = y.memo(
  xe(function({
    className: t,
    style: n,
    label: r,
    name: o,
    value: i,
    options: l,
    size: c,
    onChange: d,
    required: p,
    disabled: g,
    emptyState: m,
    editorEvents: v
  }) {
    const { editor: b } = Re(), [x, w] = y.useState(() => ({
      required: p,
      disabled: g,
      style: n,
      className: t,
      label: r,
      name: o,
      value: i,
      options: l,
      size: c,
      emptyState: m
    })), j = (C) => {
      d({
        value: C,
        editor: b,
        state: x,
        setState: (E) => w((P) => ({ ...P, ...E }))
      });
    };
    return Ul({
      editor: b,
      editorEvents: v,
      localState: x,
      setLocalState: w
    }), /* @__PURE__ */ u.jsx(
      Ze,
      {
        classNameContainer: B(ZB, x.className),
        style: x.style,
        label: x.label,
        name: x.name,
        value: x.value ?? "",
        options: x.options ?? [],
        size: x.size,
        required: x.required,
        disabled: x.disabled,
        emptyState: x.emptyState,
        onChange: j
      }
    );
  })
), QB = "gs-cmp-select-field", eU = y.memo(
  xe(function({
    className: t,
    style: n,
    label: r,
    name: o,
    value: i,
    size: l,
    onChange: c,
    required: d,
    disabled: p,
    emptyState: g,
    editorEvents: m
  }) {
    const { editor: v } = Re(), [b, x] = y.useState(() => ({
      required: d,
      disabled: p,
      style: n,
      className: t,
      label: r,
      name: o,
      value: i,
      size: l,
      emptyState: g
    })), w = (j) => {
      c({
        value: j,
        editor: v,
        state: b,
        setState: (C) => x((E) => ({ ...E, ...C }))
      });
    };
    return Ul({
      editor: v,
      editorEvents: m,
      localState: b,
      setLocalState: x
    }), /* @__PURE__ */ u.jsx(
      og,
      {
        classNameContainer: B(QB, b.className),
        style: b.style,
        label: b.label,
        name: b.name,
        value: b.value ?? "",
        size: b.size,
        required: b.required,
        disabled: b.disabled,
        emptyState: b.emptyState,
        onChange: w
      }
    );
  })
), tU = "gs-sidebar-bottom", nU = y.memo(
  xe(function({ children: t, className: n, style: r, height: o, ...i }) {
    const { isInPreview: l, isBottomSidebarOpen: c } = Re(), d = o ?? 35, p = y.useMemo(
      () => ({
        height: d,
        marginBottom: l || !c ? `-${d}px` : 0,
        ...r
      }),
      [l, c, r]
    );
    return /* @__PURE__ */ u.jsx(
      Rr,
      {
        className: B(tU, "gs-utl-flex gs-utl-transition-spacing", ve.bt, ee.br, n),
        style: p,
        ...i,
        children: t ? Xn(t) : void 0
      }
    );
  })
), rU = xe(function(t) {
  var P;
  const { leftSidebarSize: n, setLeftSidebarSize: r, editor: o, isInPreview: i, isLeftSidebarOpen: l, sdkProps: c, showPages: d } = Re(), p = c.children, g = ((P = t.style) == null ? void 0 : P.width) ?? t.width, m = g ?? n, v = t.resizable === !1, b = B(t.className, "gs-utl-h-full gs-utl-transition-spacing", ve.br, ee.br), x = B("gs-utl-w-full", ve.bb, ee.br), w = B("gs-utl-w-full gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"), j = y.useMemo(
    () => ({
      marginLeft: i || !l ? `-${m}px` : 0,
      ...t.style
    }),
    [m, i, l, t.style]
  ), C = () => o == null ? void 0 : o.refresh(), E = (k, T, O) => {
    r(O.getBoundingClientRect().width);
  };
  return /* @__PURE__ */ u.jsx(
    xg,
    {
      className: b,
      enable: v ? !1 : void 0,
      right: !v,
      style: j,
      height: "100%",
      width: m,
      minWidth: g ?? 200,
      maxWidth: g ?? 400,
      onResize: C,
      onResizeStop: E,
      children: t.children ?? /* @__PURE__ */ u.jsxs(G, { full: !0, col: !0, children: [
        d && /* @__PURE__ */ u.jsx(Y, { className: x, children: /* @__PURE__ */ u.jsx(p5, { children: (k) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          cr(p, $P),
          /* @__PURE__ */ u.jsx(RP, { ...k }),
          cr(p, NP)
        ] }) }) }),
        /* @__PURE__ */ u.jsx(Y, { className: w, grow: !0, children: /* @__PURE__ */ u.jsx(f5, { children: (k) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
          cr(p, TP),
          /* @__PURE__ */ u.jsx(_P, { ...k }),
          cr(p, kP)
        ] }) }) })
      ] })
    }
  );
}), oU = "gs-sidebar-left", sU = y.memo(
  xe(function({ children: t, width: n, resizable: r, ...o }) {
    return /* @__PURE__ */ u.jsx(
      rU,
      {
        className: B(oU, "gs-utl-flex gs-utl-flex-col gs-utl-flex-nowrap", gg(o)),
        width: n,
        resizable: r,
        style: hg(o),
        children: t ? Xn(t) : void 0
      }
    );
  })
), iU = xe(function(t) {
  var x;
  const { rightSidebarSize: n, setRightSidebarSize: r, editor: o, isInPreview: i, isRightSidebarOpen: l } = Re(), c = ((x = t.style) == null ? void 0 : x.width) ?? t.width, d = c ?? n, p = t.resizable === !1, g = B(t.className, "gs-utl-h-full gs-utl-transition-spacing", ve.bl, ee.br), m = y.useMemo(
    () => ({
      marginRight: i || !l ? `-${d}px` : 0,
      ...t.style
    }),
    [d, i, l, t.style]
  ), v = () => o == null ? void 0 : o.refresh(), b = (w, j, C) => {
    r(C.getBoundingClientRect().width);
  };
  return /* @__PURE__ */ u.jsx(
    xg,
    {
      className: g,
      enable: p ? !1 : void 0,
      left: !p,
      style: m,
      height: "100%",
      width: d,
      minWidth: c ?? 200,
      maxWidth: c ?? 400,
      onResize: v,
      onResizeStop: b,
      children: t.children ?? /* @__PURE__ */ u.jsx(WP, {})
    }
  );
}), aU = "gs-sidebar-right", lU = y.memo(
  xe(function({ children: t, resizable: n, ...r }) {
    return /* @__PURE__ */ u.jsx(
      iU,
      {
        className: B(aU, "gs-utl-flex gs-utl-flex-col gs-utl-flex-nowrap", gg(r)),
        resizable: n,
        style: hg(r),
        children: t ? Xn(t) : void 0
      }
    );
  })
), cU = xe(function({
  className: t,
  variant: n,
  value: r,
  tabs: o,
  style: i,
  editorEvents: l,
  onChange: c
}) {
  const { editor: d } = Re(), [p, g] = y.useState(() => ({
    tabs: o,
    style: i,
    value: r,
    variant: n,
    className: t
  })), m = y.useMemo(
    () => {
      var b;
      return ((b = p.tabs) == null ? void 0 : b.map((x) => ({
        ...x,
        content: Xn(x.children)
      }))) || [];
    },
    [p.tabs]
  ), v = (b) => {
    c && d ? c({
      value: b,
      editor: d,
      state: p,
      setState: (x) => g((w) => ({ ...w, ...x }))
    }) : g((x) => ({ ...x, value: b }));
  };
  return Ul({
    editor: d,
    editorEvents: l,
    localState: p,
    setLocalState: g
  }), /* @__PURE__ */ u.jsx(
    Ds,
    {
      tabs: m,
      className: B(p.className),
      variant: p.variant,
      value: p.value,
      style: p.style,
      onChange: v
    }
  );
}), uU = "gs-cmp-text", dU = y.memo(function({ className: t, content: n, children: r, ...o }) {
  return /* @__PURE__ */ u.jsx(Rr, { className: B(uU, t), ...o, children: r || n });
}), fU = "gs-cmp-virtual-list", pU = xe(function({
  id: t,
  items: n,
  itemLayout: r,
  itemsPerRow: o = 12,
  className: i,
  style: l,
  htmlAttrs: c
}) {
  const [d, p] = y.useState(0), { editor: g, transitionTime: m } = Re(), v = ty(o);
  return y.useEffect(() => {
    const b = setTimeout(() => p((x) => ++x), m);
    return () => clearTimeout(b);
  }, [m]), !!d && /* @__PURE__ */ u.jsx(
    Qu,
    {
      ...c,
      data: n,
      className: B(fU, "gs-utl-h-full", i),
      listClassName: `gs-utl-grid gs-utl-gap-2 gs-utl-pr-2 ${v}`,
      style: l,
      itemContent: (b, x) => /* @__PURE__ */ u.jsx(Q.Fragment, { children: r ? Xn(r({ item: x, editor: g })) : /* @__PURE__ */ u.jsx("pre", { children: JSON.stringify(x, void 0, 2) }) }, x.id ?? b)
    },
    t
  );
});
var wv = /* @__PURE__ */ ((e) => (e.text = "text", e.row = "row", e.column = "column", e.button = "button", e.buttonGroupField = "buttonGroupField", e.menuList = "menuList", e.inputField = "inputField", e.codeField = "codeField", e.selectField = "selectField", e.selectFontField = "selectFontField", e.tabs = "tabs", e.devices = "devices", e.custom = "custom", e.panelLayers = "panelLayers", e.panelPages = "panelPages", e.panelSelectors = "panelSelectors", e.panelStyles = "panelStyles", e.panelProperties = "panelProperties", e.panelSidebarTabs = "panelSidebarTabs", e.panelPagesLayers = "panelPagesLayers", e.panelBlocks = "panelBlocks", e.panelPageSettings = "panelPageSettings", e.panelGlobalStyles = "panelGlobalStyles", e.panelAssets = "panelAssets", e.panelTemplates = "panelTemplates", e.sidebarLeft = "sidebarLeft", e.sidebarRight = "sidebarRight", e.sidebarTop = "sidebarTop", e.sidebarBottom = "sidebarBottom", e.canvas = "canvas", e.canvasSidebarTop = "canvasSidebarTop", e.virtualList = "virtualList", e.dataPathField = "dataPathField", e.panelDataVariablePicker = "panelDataVariablePicker", e.panelDataConditionPicker = "panelDataConditionPicker", e.panelDataCollectionPicker = "panelDataCollectionPicker", e.panelDataValuePicker = "panelDataValuePicker", e))(wv || {});
const gU = {
  array: fe.codeBrackets,
  object: fe.codeBraces,
  string: fe.codeString,
  number: fe.number,
  boolean: fe.toggleSwitchOffOutline,
  default: fe.null
}, hU = (e) => Array.isArray(e) ? "array" : e === null ? "default" : typeof e, mU = xe(({ name: e, value: t, isActive: n, onClick: r, className: o }) => {
  const i = qe().tScoped("dataSources"), l = hU(t), c = typeof t == "object" && t !== null, d = B(
    o,
    "gs-utl-text-left",
    ee.hBgH,
    ve.b,
    ve.rnd,
    tt.xy,
    n ? [ve.bA, ee.tA] : [ee.br, ee.txtHighEmphasisH]
  ), p = (g) => typeof g == "object" ? Array.isArray(g) ? i("items", { params: { length: g.length } }) : g ? i("properties", { params: { length: Object.keys(g).length } }) : "null" : String(g);
  return /* @__PURE__ */ u.jsx(ut, { onClick: r, border: !1, className: d, full: !0, children: /* @__PURE__ */ u.jsxs(G, { items: "center", justify: "between", gap: "s", nowrap: !0, children: [
    /* @__PURE__ */ u.jsxs(G, { className: "gs-utl-flex-grow gs-utl-overflow-hidden", gap: "s", col: !0, children: [
      /* @__PURE__ */ u.jsxs(G, { className: "gs-utl-overflow-hidden", items: "center", gap: "s", full: !0, nowrap: !0, children: [
        /* @__PURE__ */ u.jsx(ye, { icon: gU[l], size: Ee.s }),
        /* @__PURE__ */ u.jsx(Y, { className: B(nt.txtEllips), children: e })
      ] }),
      /* @__PURE__ */ u.jsx(Y, { className: B("gs-utl-w-full", nt.txtEllips, nt.disabled), children: p(t) })
    ] }),
    c && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
      ye,
      {
        size: Ee.sx,
        icon: fe.arrowRight,
        className: B(n && "gs-utl-rotate-180", "gs-utl-transition-transform gs-utl-duration-200")
      }
    ) })
  ] }) });
}), vU = "gs-cmp-data-path-explorer", F2 = xe(function({
  additionalSources: t,
  onChange: n,
  path: r = ""
}) {
  const { editor: o } = Re(), i = y.useRef({}), [l, c] = y.useState(() => r.split(".")), [d, p] = y.useState([]), g = y.useMemo(() => ({ ...o ? y7(o) : {}, ...t }), [o, t]), m = (w, j) => {
    let C = i.current;
    for (let E = 0; E < j && E < w.length; E++) {
      const P = w[E];
      if (C && typeof C == "object" && P in C)
        C = C[P];
      else {
        C = void 0;
        break;
      }
    }
    return !C || typeof C != "object" ? [] : Object.entries(C).map(([E, P]) => {
      const k = w.slice(0, j).concat(E), T = l[j] === E, O = () => {
        const A = T ? k.slice(0, -1) : k;
        n == null || n(A.join("."), { paths: A }), c(A);
      };
      return /* @__PURE__ */ u.jsx(mU, { name: E, value: P, isActive: T, onClick: O }, E);
    });
  };
  y.useEffect(() => {
    i.current = g;
    const w = [];
    for (let j = 0; j <= l.length; j++) {
      const C = m(l, j);
      C.length > 0 && w.push(C);
    }
    p(w);
  }, [g, l]);
  const v = B(vU, ee.bg, ee.br, ve.b, ve.rnd, nt.scrollX, "gs-utl-h-full"), b = B("gs-utl-min-w-[220px]", ee.br), x = B("gs-utl-h-full gs-utl-max-h-[60vh]", nt.scrollY, tt.xyS);
  return /* @__PURE__ */ u.jsx(G, { className: v, full: !0, nowrap: !0, children: d.map((w, j) => /* @__PURE__ */ u.jsx(Y, { className: B(b, j !== d.length - 1 && ve.br), children: /* @__PURE__ */ u.jsx(G, { col: !0, nowrap: !0, gap: "m", className: x, children: w }) }, j)) });
}), yU = "gs-cmp-data-path-field", td = xe((e) => {
  const {
    size: t = "m",
    value: n = "",
    label: r,
    open: o,
    defaultValue: i,
    additionalSources: l,
    readOnly: c,
    disabled: d,
    pickerInPopover: p,
    onChange: g,
    onPickerToggle: m
  } = e, { editor: v } = Re(), b = qe().tScoped("dataSources"), [x, w] = y.useState(!!o), [j, C] = y.useState(!1), E = !!c || x || j, P = () => C(!j), k = (q) => {
    const te = q ?? !x;
    w(te), m == null || m(te);
  }, T = () => k(!1), O = (...q) => {
    g == null || g(...q);
  }, A = (q) => {
    E || g == null || g(q, { paths: q.split(".") });
  }, $ = j && v ? `"${v.DataSources.getValue(n, i)}"` : n, N = t === "m", R = N ? "lg" : t, z = N ? Ee.l : Ee.s, D = b(x ? "closePathExplorer" : "openPathExplorer"), Z = { icon: x ? fe.close : fe.databaseOutline, size: Ee.l }, K = {
    icon: j ? fe.eyeOff : fe.eye,
    size: N ? Ee.m : z
  }, H = /* @__PURE__ */ u.jsx(
    Qt,
    {
      block: !0,
      variant: "pr",
      size: R,
      title: D,
      onClick: () => k(),
      icon: Z
    }
  );
  return /* @__PURE__ */ u.jsxs(G, { className: yU, gap: t, col: !0, children: [
    /* @__PURE__ */ u.jsxs(G, { gap: t, items: "end", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(
        jt,
        {
          readOnly: E,
          label: r,
          value: n ? $ : "",
          size: t,
          disabled: d,
          onChange: A,
          placeholder: b("selectVariablePath"),
          className: B("gs-utl-flex-grow", ee.txt, nt.txtEllips),
          afterInput: !!n && /* @__PURE__ */ u.jsx(
            Qt,
            {
              block: !0,
              variant: "out-clear",
              size: "xs",
              border: !1,
              title: b("toggleResolvedPath"),
              onClick: P,
              className: nt.hover,
              icon: K
            }
          )
        }
      ),
      p ? /* @__PURE__ */ u.jsx(
        rs,
        {
          placement: "bottom-end",
          classNameBody: "gs-utl-w-[400px] gs-utl-h-[300px]",
          title: !1,
          padding: !1,
          border: !1,
          buttonAs: "span",
          handler: H,
          onClose: T,
          overlay: !0,
          children: /* @__PURE__ */ u.jsx(F2, { path: n ?? "", onChange: O, additionalSources: l })
        }
      ) : H
    ] }),
    !!x && !p && /* @__PURE__ */ u.jsx(F2, { path: n ?? "", onChange: O, additionalSources: l })
  ] });
}), bU = "gs-data-path-field", xU = xe(
  ({ className: e, value: t = "", onChange: n, ...r }) => /* @__PURE__ */ u.jsx(Rr, { className: B(bU, e), ...r, children: /* @__PURE__ */ u.jsx(td, { onChange: (o) => n({ value: o }), value: t }) })
);
function GP(e) {
  const { collectionId: t, variableType: n, path: r = "" } = e;
  return t ? [t, n, r].filter(Boolean).join(".") : r;
}
function oy(e, t) {
  const [n = "", r = "", ...o] = e.split(".");
  return n && t[n] ? {
    collectionId: n,
    variableType: r,
    path: o.join(".")
  } : { path: e, collectionId: void 0, variableType: void 0 };
}
function sy(e) {
  var l;
  const [t, n] = y.useState(((l = e.getDataResolver) == null ? void 0 : l.call(e)) ?? {}), r = y.useRef(t), o = (c) => {
    const d = { ...r.current, ...c };
    r.current = d, n(d);
  }, i = () => {
    e.setDataResolver(r.current);
  };
  return y.useEffect(() => {
    const c = "change:dataResolver", d = () => {
      const p = e.getDataResolver();
      n(p);
    };
    return e.on(c, d), () => {
      e.off(c, d);
    };
  }, [e]), {
    localData: t,
    updateLocalData: o,
    syncToComponent: i
  };
}
const wU = "gs-cmp-data-variable-picker", SU = xe(({ component: e, onConfirm: t }) => {
  const { localData: n, updateLocalData: r, syncToComponent: o } = sy(e), i = qe().tScoped("dataSources"), { path: l = "", defaultValue: c = "" } = n, d = e.collectionsStateMap, p = (v) => {
    r(oy(v, d));
  }, g = () => {
    o(), t == null || t({ value: n });
  }, m = (v) => r({ defaultValue: v });
  return /* @__PURE__ */ u.jsxs(G, { className: wU, gap: "s", col: !0, nowrap: !0, children: [
    /* @__PURE__ */ u.jsx(
      td,
      {
        value: l,
        label: i("variablePath"),
        additionalSources: d,
        defaultValue: c,
        onChange: p
      }
    ),
    /* @__PURE__ */ u.jsx(jt, { label: i("defaultValue"), value: c, onChange: m }),
    /* @__PURE__ */ u.jsx(G, { full: !0, justify: "end", className: tt.y, children: /* @__PURE__ */ u.jsx(ut, { onClick: g, variant: "pr", size: "m", children: i("confirm") }) })
  ] });
}), jU = "gs-data-variable-picker", CU = xe(function({
  className: t,
  component: n,
  onConfirm: r,
  ...o
}) {
  return /* @__PURE__ */ u.jsx(Rr, { className: B(jU, t), ...o, children: /* @__PURE__ */ u.jsx(SU, { component: n, onConfirm: r }) });
});
var Pr = /* @__PURE__ */ ((e) => (e.STRING = "string", e.NUMBER = "number", e.DATA_SOURCE = "dataSource", e))(Pr || {}), xr = /* @__PURE__ */ ((e) => (e.equals = "equals", e.isTruthy = "isTruthy", e.isFalsy = "isFalsy", e.isDefined = "isDefined", e.isNull = "isNull", e.isUndefined = "isUndefined", e.isArray = "isArray", e.isObject = "isObject", e.isString = "isString", e.isNumber = "isNumber", e.isBoolean = "isBoolean", e.isDefaultValue = "isDefaultValue", e))(xr || {}), iy = /* @__PURE__ */ ((e) => (e.greaterThan = ">", e.lessThan = "<", e.greaterThanOrEqual = ">=", e.lessThanOrEqual = "<=", e.equals = "=", e.notEquals = "!=", e))(iy || {}), ay = /* @__PURE__ */ ((e) => (e.contains = "contains", e.startsWith = "startsWith", e.endsWith = "endsWith", e.equalsIgnoreCase = "equalsIgnoreCase", e.trimEquals = "trimEquals", e))(ay || {});
const EU = [
  ...Object.values(ay),
  ...Object.values(iy),
  ...Object.values(xr)
], Sv = {
  string: Object.values(ay),
  number: Object.values(iy),
  dataSource: EU
}, PU = y.memo(function(t) {
  const { additionalSources: n, side: r, type: o, value: i, onChange: l } = t;
  switch (o) {
    case Pr.DATA_SOURCE:
      return /* @__PURE__ */ u.jsx(
        td,
        {
          size: "s",
          pickerInPopover: !0,
          value: GP(i),
          onChange: (c) => l(r, c, o),
          additionalSources: n
        }
      );
    case Pr.NUMBER:
      return /* @__PURE__ */ u.jsx(et, { size: "s", value: i, onChange: (c) => l(r, c, o) });
    default:
      return /* @__PURE__ */ u.jsx(jt, { size: "s", value: i, onChange: (c) => l(r, c, o) });
  }
}), _U = "gs-cmp-statement-side", z2 = y.memo(function({
  side: t,
  type: n,
  value: r,
  label: o,
  onChange: i,
  onTypeChange: l,
  additionalSources: c,
  typeOptions: d
}) {
  return /* @__PURE__ */ u.jsxs(G, { className: B(_U, "gs-utl-flex-grow"), col: !0, children: [
    /* @__PURE__ */ u.jsx(wi, { size: "s", children: o }),
    /* @__PURE__ */ u.jsxs(G, { items: "center", gap: "xs", children: [
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(Ze, { size: "s", value: n, options: d, onChange: (p) => l(t, p) }) }),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(
        PU,
        {
          additionalSources: c,
          side: t,
          type: n,
          value: r,
          onChange: i
        }
      ) })
    ] })
  ] });
}), Hf = (e) => typeof e == "object" && (e == null ? void 0 : e.type) === "data-variable" ? Pr.DATA_SOURCE : typeof e == "string" ? Pr.STRING : typeof e == "number" ? Pr.NUMBER : Pr.STRING, kU = (e, t, n) => {
  switch (t) {
    case Pr.STRING:
      return e || "";
    case Pr.NUMBER:
      return e ? Number(e) : 0;
    case Pr.DATA_SOURCE: {
      const r = n || {};
      return {
        type: "data-variable",
        ...(Dt(e) ? oy(e, r) : e) ?? { path: "", defaultValue: "" }
      };
    }
    default:
      return e;
  }
}, TU = (e) => Sv[e][0], OU = (e) => ![
  xr.isTruthy,
  xr.isFalsy,
  xr.isDefined,
  xr.isNull,
  xr.isUndefined,
  xr.isArray,
  xr.isObject,
  xr.isString,
  xr.isNumber,
  xr.isBoolean,
  xr.isDefaultValue
].includes(e), LU = "gs-cmp-statement", MU = xe((e) => {
  const { statement: t, onChange: n, className: r, additionalSources: o } = e, i = qe().tScoped("dataSources"), [l, c] = y.useState(() => Hf(t.left)), [d, p] = y.useState(() => Hf(t.right)), g = Sv[l] || Sv[Pr.STRING], m = y.useMemo(() => Object.values(Pr).map((k) => ({ id: k, label: Wo(k) })), []), v = y.useMemo(
    () => g.map((k) => ({ id: k, label: i(`operators.${k}`) })),
    [g, i]
  );
  y.useEffect(() => {
    c(Hf(t.left)), p(Hf(t.right));
  }, [t.left, t.right]);
  const b = (k) => {
    n({
      ...t,
      ...k
    });
  }, x = (k, T, O) => {
    const A = kU(T, O, o), $ = k === "left", N = $ && O !== Pr.DATA_SOURCE;
    $ ? c(O) : p(O), b({
      [k]: A,
      ...N && { operator: TU(O) }
    });
  }, w = (k, T) => x(k, null, T), j = (k) => b({ operator: k }), C = B(LU, r, ee.br, ve.b, ve.rnd, tt.xy), E = OU(t.operator), P = {
    additionalSources: o,
    onChange: x,
    onTypeChange: w,
    typeOptions: m
  };
  return /* @__PURE__ */ u.jsx(G, { className: B(C, "gs-utl-w-full"), items: "stretch", gap: "m", col: !0, full: !0, nowrap: !0, children: /* @__PURE__ */ u.jsxs(G, { gap: "m", items: "center", full: !0, nowrap: !0, children: [
    /* @__PURE__ */ u.jsx(
      z2,
      {
        side: "left",
        type: l,
        value: t.left,
        label: i("leftValue"),
        ...P
      }
    ),
    /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
      Ze,
      {
        size: "s",
        label: i("operator"),
        value: t.operator,
        options: v,
        onChange: j
      }
    ) }),
    E && /* @__PURE__ */ u.jsx(
      z2,
      {
        side: "right",
        type: d,
        value: t.right,
        label: i("rightValue"),
        ...P
      }
    )
  ] }) });
}), p1 = "gs-cmp-statements-group", AU = (e) => e === "and" || e === "or", _p = (e) => ({
  ...e,
  statements: [
    ...e.statements ?? [],
    {
      left: "",
      operator: "equals",
      right: ""
    }
  ]
}), KP = xe((e) => {
  const { className: t, condition: n, onUpdate: r, additionalSources: o, skipAddCondition: i } = e, l = qe().tScoped("dataSources"), c = n.statements ?? [], d = n.logicalOperator || "and", p = (x) => {
    AU(x) && r({ ...n, logicalOperator: x });
  }, g = () => {
    _p(n), r(_p(n));
  }, m = (x) => {
    const w = c.filter((j, C) => C !== x);
    r({ ...n, statements: w });
  }, v = (x, w) => {
    if (x >= 0 && x < c.length) {
      const j = [...c];
      j[x] = w, r({ ...n, statements: j });
    }
  }, b = [
    { id: "and", label: l("conditionAnd") },
    { id: "or", label: l("conditionOr") }
  ];
  return /* @__PURE__ */ u.jsxs(G, { className: B(p1, t, "gs-utl-w-full"), full: !0, gap: "m", col: !0, nowrap: !0, children: [
    c.length > 1 && /* @__PURE__ */ u.jsx(Ds, { value: d, onChange: p, tabs: b }),
    /* @__PURE__ */ u.jsx(G, { className: `${p1}__items`, gap: "s", col: !0, full: !0, nowrap: !0, children: c.map((x, w) => /* @__PURE__ */ u.jsxs(G, { className: B(`${p1}__item`), gap: "s", col: !0, children: [
      /* @__PURE__ */ u.jsx(
        MU,
        {
          additionalSources: o,
          statement: x,
          onChange: (j) => v(w, j)
        }
      ),
      w < c.length - 1 && /* @__PURE__ */ u.jsxs(G, { justify: "center", items: "center", gap: "m", children: [
        /* @__PURE__ */ u.jsx("span", { className: B(ee.txtHighEmphasis, "gs-utl-text-sm gs-utl-font-bold"), children: d.toUpperCase() }),
        /* @__PURE__ */ u.jsx(
          Qt,
          {
            block: !0,
            variant: "out-clear",
            title: l("deleteCondition"),
            onClick: () => m(w + 1),
            icon: { icon: fe.delete, size: Ee.s }
          }
        )
      ] })
    ] }, `stmt-${w}`)) }),
    !i && /* @__PURE__ */ u.jsx(G, { justify: "end", children: /* @__PURE__ */ u.jsx(ut, { variant: "pr", onClick: g, icon: { icon: fe.plus, size: Ee.s }, children: l("addCondition") }) })
  ] });
}), RU = "gs-cmp-data-condition-picker", NU = xe(({ component: e, onConfirm: t }) => {
  const { localData: n, updateLocalData: r, syncToComponent: o } = sy(e), i = qe().tScoped("dataSources"), l = n.condition, c = (g) => r({ condition: g }), d = () => {
    o(), t == null || t({ value: n });
  }, p = () => {
    r({ condition: _p(l) });
  };
  return /* @__PURE__ */ u.jsxs(G, { className: RU, items: "stretch", gap: "m", full: !0, col: !0, children: [
    /* @__PURE__ */ u.jsx(
      KP,
      {
        additionalSources: e.collectionsStateMap ?? {},
        condition: l,
        onUpdate: c,
        skipAddCondition: !0
      }
    ),
    /* @__PURE__ */ u.jsxs(G, { gap: "m", justify: "end", full: !0, children: [
      /* @__PURE__ */ u.jsx(ut, { variant: "out", onClick: p, icon: { icon: fe.plus, size: Ee.s }, children: i("addCondition") }),
      /* @__PURE__ */ u.jsx(ut, { onClick: d, variant: "pr", size: "m", children: i("confirm") })
    ] })
  ] });
}), $U = "gs-data-condition-picker", DU = xe(function({
  className: t,
  component: n,
  onConfirm: r,
  ...o
}) {
  return /* @__PURE__ */ u.jsx(Rr, { className: B($U, t), ...o, children: /* @__PURE__ */ u.jsx(NU, { component: n, onConfirm: r }) });
}), IU = "gs-cmp-data-collection-picker", VU = xe(({ component: e, onConfirm: t }) => {
  const { localData: n, updateLocalData: r, syncToComponent: o } = sy(e), { collectionId: i = "", dataSource: l = {}, startIndex: c = 0, endIndex: d = 10 } = n, p = GP(l), g = d === Number.MAX_VALUE, m = qe().tScoped("dataSources"), v = g ? "" : d, b = () => {
    o(), t == null || t({ value: n });
  }, x = (E) => r({ dataSource: { ...l, path: E } }), w = (E) => r({ startIndex: E }), j = (E) => r({ endIndex: E }), C = (E) => r({ endIndex: E ? Number.MAX_VALUE : 4 });
  return /* @__PURE__ */ u.jsxs(G, { className: IU, gap: "s", col: !0, nowrap: !0, children: [
    /* @__PURE__ */ u.jsxs(G, { items: "end", gap: "s", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(
        jt,
        {
          className: "gs-utl-flex-grow",
          size: "s",
          label: m("collectionId"),
          value: i,
          readOnly: !0,
          disabled: !0
        }
      ),
      /* @__PURE__ */ u.jsx(Z5, { size: "s", value: i, block: !0 })
    ] }),
    /* @__PURE__ */ u.jsx(td, { label: m("variablePath"), value: p, onChange: x }),
    /* @__PURE__ */ u.jsxs(G, { items: "end", gap: "s", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(
        et,
        {
          size: "s",
          className: "gs-utl-flex-grow",
          label: m("collectionStartIndex"),
          value: c == null ? void 0 : c.toString(),
          onChange: w
        }
      ),
      /* @__PURE__ */ u.jsx(
        et,
        {
          size: "s",
          label: m("collectionEndIndex"),
          placeholder: g ? "-" : "",
          value: v == null ? void 0 : v.toString(),
          onChange: j,
          className: B("gs-utl-flex-grow", g && "gs-utl-opacity-50 gs-utl-pointer-events-none")
        }
      ),
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(mu, { label: m("collectionUpToEndIndex"), value: g, onChange: C }) })
    ] }),
    /* @__PURE__ */ u.jsx(G, { full: !0, justify: "end", children: /* @__PURE__ */ u.jsx(ut, { onClick: b, variant: "pr", size: "m", children: m("confirm") }) })
  ] });
}), HU = "gs-data-collection-picker", FU = xe(function({
  className: t,
  component: n,
  onConfirm: r,
  ...o
}) {
  return /* @__PURE__ */ u.jsx(Rr, { className: B(HU, t), ...o, children: /* @__PURE__ */ u.jsx(VU, { component: n, onConfirm: r }) });
}), zU = "gs-code-field", BU = xe(function(e) {
  const { editor: t } = Re(), { isDarkTheme: n } = gr(), { editorEvents: r, onChange: o } = e, [i, l] = y.useState(() => e), c = (p) => ({
    value: p,
    editor: t,
    state: i,
    setState: (g) => l((m) => ({ ...m, ...g }))
  }), d = (p) => o == null ? void 0 : o(c(p || ""));
  return Ul({
    editor: t,
    editorEvents: r,
    localState: i,
    setLocalState: l
  }), /* @__PURE__ */ u.jsx(
    As,
    {
      className: B(zU, i.className),
      language: i.language,
      style: i.style,
      label: i.label,
      name: i.name,
      defaultValue: i.value,
      size: i.size,
      required: i.required,
      disabled: i.disabled,
      readOnly: i.readOnly,
      minHeight: i.minHeight,
      row: i.row,
      isDarkTheme: n,
      monacoOptions: e.monacoOptions,
      onChange: d
    }
  );
}), UU = "gs-menu-list", WU = xe(function({ className: e, items: t, onItemClick: n, ...r }) {
  const { editor: o } = Re(), [i, l] = y.useState(), c = (d) => {
    const { onClick: p } = d;
    if (p && o)
      return (g) => {
        const m = {
          item: d,
          editor: o,
          ...g
        };
        p(m), n == null || n(m);
      };
  };
  return /* @__PURE__ */ u.jsx(Rr, { className: B(UU, ee.bg, "gs-utl-flex gs-utl-flex-col", e), ...r, children: (t || []).map((d, p) => /* @__PURE__ */ y.createElement(
    Bu,
    {
      ...d,
      label: d.layout ? Xn(d.layout) : d.label,
      key: d.id ?? p,
      className: d.className,
      action: c(d),
      onActive: () => l(d),
      active: i === d,
      items: d.items
    }
  )) });
}), Ff = { type: "data-variable", path: "", defaultValue: "" }, B2 = {
  type: "data-condition",
  condition: {
    logicalOperator: "and",
    statements: [
      {
        left: "",
        operator: "",
        right: ""
      }
    ]
  },
  ifTrue: "",
  ifFalse: ""
}, U2 = "gs-cmp-dynamic-value-picker", GU = xe(
  ({ value: e, onChange: t, onConfirm: n, additionalSources: r }) => {
    const [o, i] = y.useState(() => ji(e) ? e : Ff), [l, c] = y.useState(o.type), d = qe().tScoped("dataSources");
    y.useEffect(() => {
      const P = ji(e) ? e : Ff;
      (P.type !== o.type || JSON.stringify(P) !== JSON.stringify(o)) && (i(P), c(P.type));
    }, [e]);
    const p = (P) => {
      i(P), t == null || t({ value: P });
    }, g = (P) => {
      const k = P;
      c(k);
      const T = o.type === k ? o : k === "data-variable" ? Ff : B2;
      p(T);
    }, m = (P) => {
      p({
        type: "data-variable",
        defaultValue: o.defaultValue,
        ...oy(P, r)
      });
    }, v = (P) => {
      i((k) => {
        const T = {
          ...k,
          defaultValue: P
        };
        return t == null || t({ value: T }), T;
      });
    }, b = (P) => {
      p({
        ...o,
        condition: P
      });
    }, x = (P, k) => {
      p({
        ...o,
        [P]: k
      });
    }, w = () => {
      const P = o.condition;
      b(_p(P));
    }, j = [
      { id: "data-variable", label: d("variable") },
      { id: "data-condition", label: d("condition") }
    ], C = (o == null ? void 0 : o.type) === "data-variable" ? o : Ff, E = (o == null ? void 0 : o.type) === "data-condition" ? o : B2;
    return /* @__PURE__ */ u.jsxs(G, { className: U2, gap: "s", col: !0, nowrap: !0, children: [
      /* @__PURE__ */ u.jsxs(G, { className: U2, gap: "m", col: !0, nowrap: !0, full: !0, children: [
        /* @__PURE__ */ u.jsx(Ds, { value: l, onChange: g, tabs: j }),
        /* @__PURE__ */ u.jsx(Y, { grow: !0, className: tt.y, style: { overflowY: "auto", overflowX: "hidden" }, children: l === "data-variable" ? /* @__PURE__ */ u.jsxs(G, { gap: "s", col: !0, nowrap: !0, children: [
          /* @__PURE__ */ u.jsx(
            td,
            {
              value: C.path,
              label: d("variablePath"),
              additionalSources: r,
              defaultValue: C.defaultValue,
              onChange: m
            }
          ),
          /* @__PURE__ */ u.jsx(
            jt,
            {
              label: d("defaultValue"),
              value: C.defaultValue || "",
              onChange: v
            }
          )
        ] }) : /* @__PURE__ */ u.jsxs(G, { gap: "m", col: !0, children: [
          /* @__PURE__ */ u.jsx(
            KP,
            {
              additionalSources: r,
              condition: E.condition,
              onUpdate: b,
              skipAddCondition: !0
            }
          ),
          /* @__PURE__ */ u.jsxs(G, { gap: "s", col: !0, nowrap: !0, children: [
            /* @__PURE__ */ u.jsx(
              jt,
              {
                label: d("ifTrue"),
                value: E.ifTrue,
                onChange: (P) => x("ifTrue", P)
              }
            ),
            /* @__PURE__ */ u.jsx(
              jt,
              {
                label: d("ifFalse"),
                value: E.ifFalse,
                onChange: (P) => x("ifFalse", P)
              }
            )
          ] })
        ] }) }),
        l === "data-condition" && /* @__PURE__ */ u.jsx(G, { full: !0, justify: "end", className: tt.x, children: /* @__PURE__ */ u.jsx(ut, { variant: "out", onClick: w, icon: { icon: fe.plus, size: Ee.s }, children: d("addCondition") }) })
      ] }),
      /* @__PURE__ */ u.jsx(G, { full: !0, justify: "end", className: tt.y, children: /* @__PURE__ */ u.jsx(
        ut,
        {
          onClick: () => {
            n == null || n({ value: o });
          },
          variant: "pr",
          size: "m",
          children: d("confirm")
        }
      ) })
    ] });
  }
), KU = "gs-data-value-picker", qU = xe(
  ({ className: e, value: t = {}, onChange: n, onConfirm: r, additionalSources: o = {}, ...i }) => /* @__PURE__ */ u.jsx(Rr, { className: B(KU, e), ...i, children: /* @__PURE__ */ u.jsx(
    GU,
    {
      value: t,
      onConfirm: (l) => r == null ? void 0 : r(l),
      onChange: (l) => n == null ? void 0 : n(l),
      additionalSources: o
    }
  ) })
), YU = {
  row: XB,
  column: rz,
  text: dU,
  tabs: cU,
  button: Xp,
  buttonGroupField: gH,
  menuList: WU,
  inputField: sz,
  codeField: BU,
  selectField: JB,
  selectFontField: eU,
  devices: hP,
  panelPages: DP,
  panelPageSettings: Xz,
  panelLayers: OP,
  panelPagesLayers: rB,
  panelBlocks: _z,
  panelGlobalStyles: Dz,
  panelSelectors: HB,
  panelStyles: GB,
  panelProperties: kB,
  panelSidebarTabs: UB,
  panelAssets: Ez,
  panelTemplates: qB,
  sidebarRight: lU,
  sidebarLeft: sU,
  sidebarTop: mP,
  sidebarBottom: nU,
  canvas: Y5,
  canvasSidebarTop: tz,
  virtualList: pU,
  dataPathField: xU,
  panelDataVariablePicker: CU,
  panelDataConditionPicker: DU,
  panelDataCollectionPicker: FU,
  panelDataValuePicker: qU
}, Xn = (e) => {
  const t = Array.isArray(e) ? e : e ? [e] : [], n = c$();
  return t.filter(Boolean).map((r, o) => {
    const { id: i = "", type: l, ...c } = Dt(r) ? { type: wv.text, content: r } : r || {}, d = YU[l], p = n.layoutChildren.get(i), g = i || o;
    return p ? /* @__PURE__ */ u.jsx(X1, { id: i, ...p }, g) : l === wv.custom ? /* @__PURE__ */ u.jsx(X1, { id: i, ...c }, g) : d ? /* @__PURE__ */ u.jsx(d, { id: i, ...c }, g) : null;
  });
}, Ul = (e) => {
  const { editorEvents: t, editor: n, localState: r, setLocalState: o } = e;
  y.useEffect(() => {
    if (!t || !n)
      return;
    const i = Object.keys(t).reduce(
      (c, d) => (c[d] = (p = {}) => {
        const g = t[d];
        g({
          fromEvent: p,
          editor: n,
          state: r,
          setState: (m) => o((v) => ({ ...v, ...m }))
        });
      }, c),
      {}
    ), l = Object.keys(i);
    return l.forEach((c) => n.on(c, i[c])), () => {
      l.forEach((c) => n.off(c, i[c]));
    };
  }, [n, r]);
}, W2 = "gs-block-item", XU = B("gs-utl-text-center gs-utl-w-full", nt.txtEllips), ZU = ({ block: e, className: t, itemLayout: n }) => {
  const { editor: r } = Re(), o = qe(), [, i] = y.useState(0), l = o.tScoped("blockManager.labels"), c = e.getId(), d = !!e.get("full"), p = e.get("onClick"), g = e.get("disable"), m = e.get("mediaReact"), v = e.getMedia(), b = e.get("attributes") || {}, x = l(c) || e.getLabel(), w = B(
    W2,
    `${W2}--${c}`,
    t,
    "gs-utl-py-2 gs-utl-px-2 gs-utl-transition-colors",
    ve.b,
    ve.rnd,
    ee.br,
    d && "gs-utl-col-span-full",
    g ? nt.disabledM : B("gs-utl-cursor-pointer", ee.hTAo, ee.hBgH)
  ), j = Rn(b.class) ? b.class : B("gs-utl-block-media gs-utl-max-h-10 gs-utl-max-w-10 gs-utl-w-full");
  if (y.useEffect(() => {
    if (!r)
      return;
    const { Blocks: O } = r, A = O.events.update, $ = (N) => N === e && i((R) => ++R);
    return r.on(A, $), () => {
      r.off(A, $);
    };
  }, [e, r]), !r)
    return null;
  const { Blocks: C } = r, k = {
    className: w,
    ...!g && {
      onDragStart: () => C.startDrag(e),
      onDragEnd: () => C.endDrag(!1),
      draggable: !0
    },
    ...!!p && {
      onClick: () => p(e, r)
    }
  }, T = n == null ? void 0 : n({ editor: r, block: e, attributes: k });
  return T && Xn(T) || /* @__PURE__ */ u.jsxs(G, { items: "center", col: !0, ...k, children: [
    m || /* @__PURE__ */ u.jsx("div", { className: j, dangerouslySetInnerHTML: { __html: v } }),
    /* @__PURE__ */ u.jsx("div", { className: XU, title: x, children: x })
  ] });
}, G2 = xe(ZU), K2 = ge("text-sm w-full", nt.txtEllips), JU = ({ symbol: e, className: t }) => {
  const n = Ar(), { Components: r } = n, o = qe(), i = os(), l = o.tScoped("blockManager.symbols"), c = () => {
    const { draggable: C, droppable: E, attributes: P, type: k, tagName: T } = e.attributes;
    n.Canvas.startDrag({
      // @ts-expect-error Allow to return Components
      content: () => r.addSymbol(e),
      model: e,
      dragDef: {
        type: k,
        tagName: T,
        draggable: C,
        droppable: E,
        attributes: P
      }
    });
  }, d = () => {
    n.Canvas.endDrag();
  }, p = e.getIcon(), g = e.getName(), m = r.getSymbolInfo(e).instances.length, v = ge("h-10 w-10 block-media", ee.grouphTAo), b = ge("gjs-pt-1 gjs-mt-2", ve.bt, ee.br), x = ge("cursor-pointer gjs-p-2 transition-colors group", ve.b, ve.rnd, ee.br, ee.hBgH, t), w = () => {
    i.confirm({
      title: l("delete"),
      content: l("deleteConfirm"),
      onConfirm: () => e.remove()
    });
  }, j = (C) => {
    e.set("custom-name", C);
  };
  return /* @__PURE__ */ u.jsxs(G, { className: x, onDragStart: c, onDragEnd: d, items: "center", draggable: !0, col: !0, children: [
    /* @__PURE__ */ u.jsx("div", { className: v, dangerouslySetInnerHTML: { __html: p } }),
    /* @__PURE__ */ u.jsxs(G, { items: "center", justify: "between", className: b, space: "m", full: !0, children: [
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(G, { className: ge(K2, "gjs-mr-auto"), children: /* @__PURE__ */ u.jsx(_n, { title: `${m} ${l("instancesProject")}`, children: /* @__PURE__ */ u.jsx(dn, { label: `${m}`, className: ge(ee.bgH75) }) }) }) }),
      /* @__PURE__ */ u.jsx(Y, { className: ge("truncate"), grow: !0, title: g, children: /* @__PURE__ */ u.jsx(BP, { activable: !0, value: g, className: K2, onChange: j }) }),
      /* @__PURE__ */ u.jsx(Y, { className: ge(nt.hoverGroup), children: /* @__PURE__ */ u.jsx(G, { justify: "end", full: !0, children: /* @__PURE__ */ u.jsx(Qt, { onClick: w, title: l("delete"), border: !1, size: "", block: !0, children: /* @__PURE__ */ u.jsx(ye, { icon: fe.delete, size: Ee.s }) }) }) })
    ] })
  ] });
}, QU = xe(JU), ii = "gs-block-manager", q2 = (e, t) => {
  const n = t == null ? void 0 : t.getId();
  return n && e.I18n.t(`blockManager.categories.${n}`) || (t == null ? void 0 : t.getLabel()) || "";
}, qP = xe(function({
  isOpen: t,
  className: n,
  hideCategories: r,
  itemLayout: o,
  ...i
}) {
  var le, me;
  const { editor: l } = Re(), c = qe(), [d, p] = y.useState(0), [g, m] = y.useState(Ic.REGULAR), [v, b] = y.useState(""), [x, w] = y.useState(() => (l == null ? void 0 : l.Components.getSymbols()) || []), j = g === Ic.SYMBOLS, C = y.useRef(null), E = c.tScoped("blockManager");
  if (y.useEffect(() => {
    if (!l)
      return;
    const { Blocks: oe, Components: se } = l, de = oe.events.custom, we = se.events.symbol, je = () => {
      w(se.getSymbols()), p((He) => ++He);
    };
    return l.on(we, je), l.on(de, je), () => {
      l.off(we, je), l.off(de, je);
    };
  }, [l]), y.useEffect(() => {
    if (C.current && t) {
      const oe = C.current.querySelector("input");
      setTimeout(() => oe == null ? void 0 : oe.focus(), pC);
    }
  }, [C.current, t]), !l)
    return null;
  const { Blocks: P } = l, k = (oe) => E(`labels.${oe.getId()}`) || oe.getLabel(), T = x.filter((oe) => ll(oe.getName(), v)), O = P.getAll().map((oe) => oe), $ = (((le = i.blocks) == null ? void 0 : le.call(i, { blocks: O })) || O).filter((oe) => {
    const se = q2(l, oe.category);
    return !(v && !ll(se, v) && !ll(k(oe), v));
  }), N = P.getBlocksByCategory($), R = r ? $ : (me = N.find((oe) => !oe.category)) == null ? void 0 : me.items, z = r ? [] : N.filter((oe) => oe.category), D = i.symbols !== !1, Z = i.search !== !1, K = !D && !Z, H = E("search") || c.t("search"), q = B(ii, n, "gap-2"), te = B(`${ii}__header`, "gs-utl-pt-2", tt.xS, K && "gs-utl-hidden"), I = B(`${ii}__content`, nt.scrollY, ee.br, ve.bt), F = B(`${ii}__symbols`, "gs-utl-grid gs-utl-grid-cols-1 gs-utl-gap-2 gs-utl-p-2"), V = B(`${ii}__not-found`, "gs-utl-text-center gs-utl-p-4"), L = B(`${ii}__blocks`, "gs-utl-grid gs-utl-grid-cols-2 gs-utl-gap-2 gs-utl-p-2 gs-utl-text-sm"), W = B(`${ii}__no-category`, L, ee.br, z.length && ve.bb), ie = `${ii}__category`, re = [
    { id: Ic.REGULAR, label: E("types.regular") },
    { id: Ic.SYMBOLS, label: E("types.symbols") }
  ];
  return /* @__PURE__ */ u.jsxs(G, { className: q, col: !0, full: !0, children: [
    /* @__PURE__ */ u.jsxs(G, { className: te, space: "s", col: !0, children: [
      D && /* @__PURE__ */ u.jsx(Ds, { tabs: re, onChange: m, value: g, variant: "pills" }),
      Z && /* @__PURE__ */ u.jsx(
        jt,
        {
          ref: C,
          size: "s",
          value: v,
          onInput: b,
          placeholder: H,
          type: "search"
        }
      )
    ] }),
    /* @__PURE__ */ u.jsxs(Y, { className: I, grow: !0, children: [
      j && (T.length ? /* @__PURE__ */ u.jsx(G, { className: F, children: T.map((oe) => /* @__PURE__ */ u.jsx(QU, { symbol: oe }, `${d}_${oe.getId()}`)) }) : /* @__PURE__ */ u.jsx(G, { className: V, justify: "center", children: E("symbols.notFound") })),
      !j && ($.length ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        !!(R != null && R.length) && /* @__PURE__ */ u.jsx(G, { className: W, children: R == null ? void 0 : R.map((oe) => /* @__PURE__ */ u.jsx(G2, { block: oe, itemLayout: o }, oe.id)) }),
        z.map(({ category: oe, items: se }, de) => /* @__PURE__ */ u.jsx(
          ja,
          {
            sticky: !0,
            className: (we) => Vv.itemList({ index: de, open: we, length: z.length }),
            open: !!(oe != null && oe.get("open")),
            onChange: ({ open: we }) => oe == null ? void 0 : oe.set({ open: we }),
            handler: q2(l, oe),
            handlerIcon: oe == null ? void 0 : oe.get("icon"),
            classNameWrap: B(ie, `${ie}--${oe == null ? void 0 : oe.id}`),
            children: /* @__PURE__ */ u.jsx(G, { className: L, children: se.map((we) => /* @__PURE__ */ u.jsx(G2, { block: we, itemLayout: o }, we.id)) })
          },
          oe == null ? void 0 : oe.id
        ))
      ] }) : /* @__PURE__ */ u.jsx(G, { className: V, justify: "center", children: E("notFound") }))
    ] })
  ] });
}), eW = {
  add: fe.plus
}, Y2 = (e, t) => t || eW[e];
function ly({ className: e, icon: t, title: n, onClose: r, actions: o = [], children: i }) {
  const { t: l } = qe();
  return /* @__PURE__ */ u.jsxs(G, { className: ce("gjs-card-title", e), items: "center", children: [
    /* @__PURE__ */ u.jsx(Y, { className: ce("truncate"), grow: !0, children: n }),
    i,
    /* @__PURE__ */ u.jsxs(G, { space: "s", children: [
      !!o.length && /* @__PURE__ */ u.jsx(G, { space: "xs", className: ce("gjs-px-1"), children: o.map(({ id: c, icon: d, className: p, ...g }) => /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
        Qt,
        {
          block: !0,
          border: !1,
          size: "xs",
          icon: Y2(c, d) ? { icon: Y2(c, d), size: Ee.s } : void 0,
          className: ce(nt.click, p),
          ...g
        }
      ) }, c)) }),
      (r || t) && /* @__PURE__ */ u.jsx(
        Qt,
        {
          title: l("close"),
          onClick: r,
          border: !1,
          className: ce(nt.click),
          icon: { icon: fe.close, size: Ee.s },
          size: "xs",
          block: !0
        }
      )
    ] })
  ] });
}
const YP = "0.22.12", tW = "1.0.27", pi = "https://cdn.jsdelivr.net/npm/", nW = `${pi}grapesjs@${YP}/dist/grapes.min.js`, rW = `${pi}grapesjs@${YP}/dist/css/grapes.min.css`, oW = !1, ws = tW, ai = `${pi}@grapesjs/studio-sdk-plugins@${ws}`, Ur = { category: "Extra", select: !0 }, XP = [
  {
    id: "grapesjs-component-countdown",
    name: "Countdown",
    description: "Live countdown timer to highlight upcoming events, launches, or deadlines.",
    category: ir.components,
    src: `${pi}grapesjs-component-countdown@1.0.1/dist/index.js`,
    image: "https://cdn.grapesjs.com/workspaces/clywyth4s0001a5x8dfysepz7/assets/b2b347be-144d-4860-8f1a-2d8678ab07c7__plugin-counter.png",
    version: "1.0.1",
    projectType: [Xe.web],
    options: {
      props: {
        emptyState: !0
      }
    }
  },
  {
    id: "grapesjs-tabs",
    name: "Tabs",
    description: "Organize content into easy-to-navigate sections using tabs.",
    category: ir.components,
    src: `${pi}grapesjs-tabs@1.0.18/dist/index.js`,
    image: "https://cdn.grapesjs.com/workspaces/clywyth4s0001a5x8dfysepz7/assets/e322063c-a8b4-46d4-a21e-20f885ab53df__plugin-tabs.png",
    version: "1.0.18",
    projectType: [Xe.web],
    options: { tabsBlock: Ur }
  },
  {
    id: "grapesjs-custom-code",
    name: "Custom code",
    description: "Insert your own custom code directly into the page. Perfect for adding third-party widgets, advanced styling, or custom functionality.",
    category: ir.components,
    src: `${pi}grapesjs-custom-code@1.0.2/dist/index.js`,
    image: "https://user-images.githubusercontent.com/11614725/43289377-15322c5e-912b-11e8-9a29-cc2dc45af48a.gif",
    version: "1.0.2",
    projectType: [Xe.web]
  },
  {
    id: "grapesjs-tooltip",
    name: "Tooltip",
    description: "A simple, CSS-only, tooltip component. Great for adding helpful hints or extra info on hover.",
    src: `${pi}grapesjs-tooltip@0.1.8/dist/index.js`,
    category: ir.components,
    image: "https://cdn.grapesjs.com/workspaces/clywyth4s0001a5x8dfysepz7/assets/53239882-2c3f-4480-84cb-16fb9dd3d713__plugin-tooltip.webp",
    version: "0.1.8",
    projectType: [Xe.web],
    options: {
      propsTooltip: {
        emptyState: { styleOut: "width: 80px;" }
      }
    }
  },
  {
    id: "grapesjs-typed",
    name: "Typed",
    description: "A typewriter-style animation component powered by Typed.js. Ideal for dynamic hero headings and attention-grabbing text effects.",
    category: ir.components,
    src: `${pi}grapesjs-typed@2.0.1/dist/index.js`,
    image: "https://user-images.githubusercontent.com/11614725/67621063-3f31c380-f80d-11e9-8d62-7f1da9f27111.png",
    version: "2.0.1",
    projectType: [Xe.web],
    options: { block: Ur }
  },
  {
    id: "StudioSdkPlugins_tableComponent",
    name: "Table",
    description: "Add table component with additional functionalities.",
    category: ir.components,
    src: `${ai}/dist/tableComponent/index.umd.js`,
    image: "https://app.grapesjs.com/docs-sdk/assets/images/table-plugin-f8c7596df01f9e12fb5d94a9de4ee502.png",
    version: ws,
    projectType: [Xe.web],
    options: { block: Ur }
  },
  {
    id: "StudioSdkPlugins_listPagesComponent",
    name: "List Pages",
    description: "Add a list component that dynamically generates navigation links based on the pages in your project.",
    category: ir.components,
    src: `${ai}/dist/listPagesComponent/index.umd.js`,
    image: "https://app.grapesjs.com/docs-sdk/assets/images/list-pages-plugin-a315be106d0897f4167a6c93c71e7878.png",
    version: ws,
    projectType: [Xe.web],
    options: { block: Ur }
  },
  {
    id: "StudioSdkPlugins_fsLightboxComponent",
    name: "FsLightbox",
    description: "Image viewer plugin based on FsLightbox.",
    category: ir.components,
    src: `${ai}/dist/fsLightboxComponent/index.umd.js`,
    image: "https://app.grapesjs.com/docs-sdk/assets/images/fslightbox-plugin-5d9d81980202b475e60ccaa248036915.png",
    version: ws,
    projectType: [Xe.web],
    options: { block: Ur }
  },
  {
    id: "StudioSdkPlugins_lightGalleryComponent",
    name: "LightGallery",
    description: "Gallery component based on lightGallery.",
    category: ir.components,
    src: `${ai}/dist/lightGalleryComponent/index.umd.js`,
    image: "https://app.grapesjs.com/docs-sdk/assets/images/lightgallery-plugin-0ef8d47f0aaa2bbdd0c83cffb9087fa4.png",
    version: ws,
    projectType: [Xe.web],
    options: { block: Ur }
  },
  {
    id: "StudioSdkPlugins_swiperComponent",
    name: "Swiper (Slider)",
    description: "Slider component plugin based on Swiper.",
    category: ir.components,
    src: `${ai}/dist/swiperComponent/index.umd.js`,
    image: "https://app.grapesjs.com/docs-sdk/assets/images/swiper-plugin-ded7740b473376f249829eced9003fee.png",
    version: ws,
    projectType: [Xe.web],
    options: { block: Ur }
  },
  {
    id: "StudioSdkPlugins_iconifyComponent",
    name: "Iconify",
    description: "Add an icon component with the icon picker by levering the Iconify collections.",
    category: ir.components,
    src: `${ai}/dist/iconifyComponent/index.umd.js`,
    image: "https://app.grapesjs.com/docs-sdk/assets/images/iconify-plugin-265b0e0e9218b0d33744366e5a069bef.png",
    version: ws,
    projectType: [Xe.web],
    options: { block: Ur }
  },
  {
    id: "StudioSdkPlugins_accordionComponent",
    name: "Accordion",
    description: "Accordion component, allowing users to create collapsible content sections with smooth animations and keyboard navigation support.",
    category: ir.components,
    src: `${ai}/dist/accordionComponent/index.umd.js`,
    image: "https://app.grapesjs.com/docs-sdk/assets/images/accordion-plugin-09ee15747de2cbc119e7e9ca654abec6.webp",
    version: ws,
    projectType: [Xe.web],
    options: { block: Ur, blockGroup: Ur }
  },
  {
    id: "StudioSdkPlugins_animationComponent",
    name: "Animations",
    description: "Add scroll-triggered animation components with support for staggered grouping effects.",
    category: ir.components,
    src: `${ai}/dist/animationComponent/index.umd.js`,
    image: "https://app.grapesjs.com/docs-sdk/assets/images/animation-plugin-f099c7cb5c88ffd5ca7794cbfcd0d7af.webp",
    version: ws,
    projectType: [Xe.web],
    options: { block: Ur, blockGroup: Ur }
  }
], sW = XP.reduce(
  (e, t) => (e[t.id] = t, e),
  {}
), iW = () => new Promise((e) => {
  setTimeout(() => e(XP), 100);
}), X2 = xe(function({
  plugin: t,
  className: n,
  installed: r,
  onInstall: o,
  onSelect: i
}) {
  const l = qe(), c = (x) => l.t(`pluginManager.${x}`), d = r[t.id], p = () => i == null ? void 0 : i(t), g = () => o(t), m = B(
    "gs-cmp-plugin-item gs-utl-overflow-hidden gs-utl-max-w-full gs-utl-group gs-utl-px-4 gs-utl-py-3",
    n
  ), v = B("gs-utl-cursor-pointer gs-utl-font-bold", nt.txtEllips), b = B("gs-utl-max-w-full gs-utl-h-48 gs-utl-w-72 gs-utl-object-cover", ee.br, ve.b, ve.rnd);
  return /* @__PURE__ */ u.jsxs(pr, { className: m, padding: !1, classNameBody: "gs-utl-flex gs-utl-flex-col gs-utl-gap-2", children: [
    /* @__PURE__ */ u.jsxs(G, { items: "center", gap: "s", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(Y, { className: v, onClick: p, children: t.name }),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: /* @__PURE__ */ u.jsx(dn, { className: "gs-utl-opacity-90", label: `v${t.version}`, s: "s", pill: !0, border: !0 }) }),
      /* @__PURE__ */ u.jsx(ut, { className: "gs-utl-text-sm", size: "m2", variant: "pr", onClick: g, children: c(d ? "uninstall" : "install") })
    ] }),
    /* @__PURE__ */ u.jsxs(G, { gap: "s", nowrap: !0, children: [
      /* @__PURE__ */ u.jsx(Y, { grow: !0, className: "gs-utl-text-sm", children: t.description }),
      t.image && /* @__PURE__ */ u.jsx("img", { className: b, src: t.image, alt: t.name })
    ] })
  ] });
}), ZP = xe(function(t) {
  const { selectedId: n, loadPlugins: r, loadPluginsInstalled: o } = t, i = qe(), [l] = fg(), c = Y0(), d = Re(), [p, g] = y.useState(), [m, v] = y.useState(), [b, x] = y.useState(), [w, j] = y.useState(
    "all"
    /* All */
  ), C = w === "all" ? b : m, E = i.tScoped("pluginManager"), { editor: P } = d, k = { editor: P }, T = async () => (o ? await o(k) : await cg()).map((D) => ({
    ...sW[D.id],
    ...D
  }));
  y.useEffect(() => {
    const D = setTimeout(async () => {
      if (m || v(await T()), !b) {
        const Z = r ? await r(k) : await iW();
        x(Z);
      }
    });
    return () => clearTimeout(D);
  }, [m, b, P]), y.useEffect(() => {
    if (n && b && !c.selectedShown) {
      const z = b.find((D) => D.id === n);
      z && g(z), c.setSelectedShown(!0);
    }
  }, [b]);
  const O = y.useMemo(
    () => [
      {
        id: "all",
        label: E("all")
      },
      {
        id: "installed",
        label: E("installed") + (m != null && m.length ? ` (${m.length})` : "")
      }
    ],
    [i, m == null ? void 0 : m.length]
  ), A = y.useCallback(
    async (z) => {
      const { onInstall: D, onUninstall: Z } = t;
      m != null && m.find((K) => K.id === z.id) ? (await (Z == null ? void 0 : Z(z, k)), await qV(z, {
        skipUpdateLocal: !!Z,
        installed: Z ? m : void 0
      })) : (await (D == null ? void 0 : D(z, k)), await KV(z, {
        skipUpdateLocal: !!D,
        installed: D ? m : void 0
      })), v(await T());
    },
    [m, P]
  ), $ = y.useMemo(
    () => (m == null ? void 0 : m.reduce((z, D) => (z[D.id] = D.version, z), {})) || {},
    [m]
  ), N = !!(p || c.hasPending), R = async () => {
    if (o) {
      const z = await T();
      c.setProjectPlugins(z, { clearPending: !0 }), d.refreshStudio(), d.store.modalStore.close();
    } else
      d.updateStudio();
  };
  return /* @__PURE__ */ u.jsxs(G, { gap: "m", col: !0, full: !0, children: [
    N && /* @__PURE__ */ u.jsxs(G, { children: [
      !!p && /* @__PURE__ */ u.jsx(ut, { onClick: () => g(void 0), className: ee.tAo, border: !1, children: /* @__PURE__ */ u.jsxs(G, { gap: "xs", items: "center", children: [
        /* @__PURE__ */ u.jsx(ye, { icon: fe.chevronLeft, size: Ee.s }),
        /* @__PURE__ */ u.jsx("div", { children: E("allPlugins") })
      ] }) }),
      c.hasPending && /* @__PURE__ */ u.jsx(ut, { className: "gs-utl-text-sm gs-utl-ml-auto", size: "m2", variant: "out", onClick: R, children: E("updateStudio") })
    ] }),
    p ? /* @__PURE__ */ u.jsx(Y, { grow: !0, className: "gs-utl-w-full", children: /* @__PURE__ */ u.jsx(X2, { plugin: p, installed: $, onInstall: A, selected: !0 }) }) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(Ds, { tabs: O, onChange: j, value: w }) }),
      /* @__PURE__ */ u.jsx(Y, { grow: !0, children: C ? C.length ? /* @__PURE__ */ u.jsx(
        Qu,
        {
          data: C,
          listClassName: "gs-utl-grid gs-utl-grid-cols-1 gs-utl-gap-2 gs-utl-pr-2",
          itemContent: (z, D) => /* @__PURE__ */ u.jsx(
            X2,
            {
              plugin: D,
              installed: $,
              onInstall: A,
              onSelect: g
            },
            D.id
          )
        },
        l
      ) : /* @__PURE__ */ u.jsx(G, { justify: "center", children: i.t("notItemsFound") }) : /* @__PURE__ */ u.jsx(Ju, {}) })
    ] })
  ] });
}), aW = xe(function() {
  const { isOpen: t, toggleOpen: n } = LE(), { editor: r, sdkProps: o, sdkOptions: i, isProjectTypeEmail: l } = Re(), c = os(), d = qe(), p = o.children, g = d.tScoped("blockManager"), m = ce(
    "absolute left-0 top-0 h-full transition-transform z-10",
    !t && "-translate-x-full",
    ve.br,
    ee.br,
    ee.bg
  ), v = () => {
    c.open({
      fullH: !0,
      title: d.t("pluginManager.plugins"),
      content: () => /* @__PURE__ */ u.jsx(ZP, {})
    });
  }, b = y.useMemo(
    () => [
      !!i.pluginManager && !l && {
        id: "add",
        title: g("add"),
        className: ee.tAo,
        onClick: v,
        icon: fe.viewGridPlus
      }
    ].filter(Boolean),
    [r]
  );
  return /* @__PURE__ */ u.jsxs(G, { className: m, style: { width: 240 }, col: !0, nowrap: !0, children: [
    /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ly, { title: g("blocks"), onClose: n, className: ce(tt.s), actions: b }) }),
    /* @__PURE__ */ u.jsxs(Sa, { children: [
      cr(p, xP),
      /* @__PURE__ */ u.jsx(Y, { className: ce("overflow-hidden"), grow: !0, children: /* @__PURE__ */ u.jsx(qP, { isOpen: t }) }),
      cr(p, bP)
    ] })
  ] });
}), g1 = "gs-canvas-spot-drag";
function lW({ spot: e, className: t }) {
  const n = Ar(), r = Ml(e.component), o = B(ve.b, r.border), { originComponent: i, matchedComponents: l, originMatchedDistances: c } = e.attributes;
  return /* @__PURE__ */ u.jsxs("div", { className: t, children: [
    /* @__PURE__ */ u.jsx(Z2, { editor: n, componentEl: i, className: B(g1, o) }),
    l.map((d) => /* @__PURE__ */ u.jsx(
      Z2,
      {
        editor: n,
        componentEl: d,
        className: B(`${g1}__matched`, o)
      },
      d.id
    )),
    c.map((d, p) => /* @__PURE__ */ u.jsx(
      cW,
      {
        editor: n,
        originMatchedDistance: d,
        className: B(`${g1}__distance`),
        componentColorClasses: r
      },
      p
    ))
  ] });
}
function Z2(e) {
  const { editor: t, componentEl: n, className: r } = e, o = t.Canvas.getCanvasView(), { x: i, y: l, width: c, height: d } = o.getElBoxRect(n), p = B(r, "gs-utl-absolute gs-utl-top-0 gs-utl-left-0"), g = {
    translate: `${i}px ${l}px`,
    width: `${c}px`,
    height: `${d}px`
  };
  return /* @__PURE__ */ u.jsx("div", { className: p, style: g });
}
function cW(e) {
  const { originMatchedDistance: t, editor: n, className: r, componentColorClasses: o } = e, l = n.Canvas.getCanvasView().clsUnscale || "", { axis: c, x: d, y: p, width: g, height: m } = t, v = c === "y", b = v ? g : m, x = {
    translate: `${d}px ${p}px`,
    width: `${g}px`,
    height: `${m}px`
  }, w = `${r}__guides`, j = `${r}__guide-info ${r}__guide-info__${c} gs-utl-absolute`, C = B(
    `${r}__guide-info__line`,
    o.bg,
    v ? "gs-utl-w-full gs-utl-h-[1px]" : "gs-utl-h-full gs-utl-w-[1px]"
  ), E = B(
    `${r}__guide-info__content gs-utl-w-full gs-utl-h-full gs-utl-flex gs-utl-justify-center gs-utl-items-center`
  ), P = B(
    `${r}__guide-info__badge gs-utl-shadow-md`,
    l,
    o.bg
  );
  return /* @__PURE__ */ u.jsx("div", { className: w, children: /* @__PURE__ */ u.jsx("div", { className: j, style: x, children: /* @__PURE__ */ u.jsx("div", { className: C, children: /* @__PURE__ */ u.jsx("div", { className: E, children: /* @__PURE__ */ u.jsxs(dn, { className: P, s: "s", children: [
    Math.round(b),
    "px"
  ] }) }) }) }) });
}
const uW = {
  pointerEvents: "all"
};
function pl({ spot: e, children: t, style: n, spotStyles: r, ...o }) {
  const i = {
    ...r || e.getStyle(),
    ...n
  };
  return /* @__PURE__ */ u.jsx("div", { ...o, style: i, children: /* @__PURE__ */ u.jsx("div", { style: uW, children: t }) });
}
const go = y.forwardRef(function({ children: t, className: n, position: r, out: o, ...i }, l) {
  var v;
  const { Canvas: c } = Ar(), d = ((v = c.getCanvasView()) == null ? void 0 : v.clsUnscale) || "", p = [], g = {};
  switch (r) {
    case "top-left":
      p.push("top-0", "left-0"), g.transformOrigin = "top left", o && (g.translate = "0 -100%", g.transformOrigin = "bottom left");
      break;
    case "top-center":
      p.push("top-0"), g.left = "50%", g.translate = "-50% 0", g.transformOrigin = "top center", o && (g.translate = "-50% -100%", g.transformOrigin = "bottom center");
      break;
    case "top-right":
      p.push("top-0", "right-0"), g.transformOrigin = "top right", o && (g.translate = "0 -100%", g.transformOrigin = "bottom right");
      break;
    case "center-left":
      p.push("left-0"), g.top = "50%", g.translate = "0 -50%", g.transformOrigin = "center left", o && (g.translate = "-100% -50%", g.transformOrigin = "center right");
      break;
    case "center-center":
      g.top = "50%", g.left = "50%", g.translate = "-50% -50%", g.transformOrigin = "center";
      break;
    case "center-right":
      p.push("right-0"), g.top = "50%", g.translate = "0 -50%", g.transformOrigin = "center right", o && (g.translate = "100% -50%", g.transformOrigin = "center left");
      break;
    case "bottom-left":
      p.push("left-0", "bottom-0"), g.transformOrigin = "bottom left", o && (g.translate = "0 100%", g.transformOrigin = "top left");
      break;
    case "bottom-center":
      p.push("bottom-0"), g.left = "50%", g.translate = "-50% 0", g.transformOrigin = "bottom center", o && (g.translate = "-50% 100%", g.transformOrigin = "top center");
      break;
    case "bottom-right":
      p.push("right-0", "bottom-0"), g.transformOrigin = "bottom right", o && (g.translate = "0 100%", g.transformOrigin = "top right");
      break;
  }
  const m = {
    ...g,
    ...i.style
  };
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      ...i,
      className: B(d, ge("gs-utl-flex gs-utl-absolute", n, p.join(" "))),
      style: m,
      ref: l,
      children: t
    }
  );
});
function JP({ spot: e, className: t, badgeConfig: n }) {
  const r = Ar(), { Canvas: o } = r, i = (n == null ? void 0 : n.position) || "top-left", [l, c] = y.useState(i), d = e.component, p = e.getBoxRect(), g = o.getWorldRectToScreen(p), m = y.useRef(null), v = o.getElement().clientHeight;
  return cE(m, {
    zoomMultiplier: o.getZoomMultiplier(),
    boxRectScreen: g,
    vwHeight: v,
    setPos: c,
    initialPos: i
  }), !d || d.get("badgable") === !1 ? null : /* @__PURE__ */ u.jsx(go, { className: "gs-utl-pointer-events-none", ref: m, style: t3, position: l, out: !0, children: /* @__PURE__ */ u.jsx(
    dn,
    {
      className: B(n == null ? void 0 : n.className, "gs-utl-shadow-md", t || Ml(d).bg),
      style: n == null ? void 0 : n.style,
      s: "s",
      children: /* @__PURE__ */ u.jsxs(G, { gap: "xs", items: "center", nowrap: !0, children: [
        (n == null ? void 0 : n.icon) !== !1 && _0(d),
        /* @__PURE__ */ u.jsx("div", { className: "gs-utl-whitespace-nowrap gs-utl-max-w-36 gs-utl-truncate", children: d.getName() })
      ] })
    }
  ) });
}
function dW({ spot: e, className: t, spotConfig: n }) {
  const r = QP(n), o = B(n == null ? void 0 : n.className, ve.b, Ml(e.component).border, t);
  return /* @__PURE__ */ u.jsx(pl, { spot: e, className: o, style: n == null ? void 0 : n.style, children: r && /* @__PURE__ */ u.jsx(JP, { spot: e, badgeConfig: r }) });
}
function QP(e) {
  const t = e == null ? void 0 : e.badge;
  return t === !1 ? !1 : t === !0 ? {} : t || {};
}
function fW({ spot: e, className: t, spotConfig: n }) {
  var K;
  const r = Ar(), o = Re(), i = y.useRef(null), [l] = y.useState(t3), [c, d] = y.useState([]), [p, g] = y.useState([]), [m, v] = y.useState("top-right"), b = e.component, x = e.getBoxRect(), { Canvas: w } = r, j = w.getWorldRectToScreen(x), C = e.getStyle({ boxRect: x }), E = r.getSelected() === b, P = w.getElement().clientHeight, k = w0();
  y.useEffect(() => {
    const H = async () => g(await gW(b, o)), q = async () => d(await k.getItemsForComponent(b)), I = setTimeout(() => {
      H(), q();
    }, 10);
    return () => clearTimeout(I);
  }, [b]), cE(i, {
    zoomMultiplier: w.getZoomMultiplier(),
    boxRectScreen: j,
    vwHeight: P,
    setPos: v
  });
  const T = (H = {}) => {
    var L, W, ie;
    const q = (ie = (W = (L = r.getSelected()) == null ? void 0 : L.view) == null ? void 0 : W.el) == null ? void 0 : ie.getBoundingClientRect(), te = q ? q.left + q.width / 2 : 0, I = q ? q.top + q.height / 2 : 0, F = { ...H.event, clientX: te, clientY: I };
    return { ...H, event: F };
  }, O = (H, q) => {
    H === "tlb-move" && (q = T(q)), Dt(H) ? r.runCommand(H, q) : H == null || H(r, "", q);
  }, A = (H) => {
    const q = H.currentTarget.getBoundingClientRect();
    k.show({
      items: c,
      x: q.x + q.width,
      y: q.y
    });
  }, $ = Ml(b), N = e3(n), R = B(n == null ? void 0 : n.className, "gs-utl-border-2", $.border, t), z = B(
    N && N.className,
    $.bg,
    "gs-utl-overflow-hidden gs-utl-shadow-md"
  ), D = pW(n), Z = N !== !1;
  return /* @__PURE__ */ u.jsxs(pl, { spot: e, spotStyles: C, style: n == null ? void 0 : n.style, className: R, children: [
    E && Z && /* @__PURE__ */ u.jsx(go, { ref: i, style: l, position: m, out: !0, children: /* @__PURE__ */ u.jsx(dn, { className: z, style: N == null ? void 0 : N.style, s: "s", nopad: !0, block: !0, children: /* @__PURE__ */ u.jsxs(G, { gap: "x2s", items: "center", nowrap: !0, children: [
      D && /* @__PURE__ */ u.jsxs(
        G,
        {
          className: B(D.className, "gs-utl-py-1 gs-utl-px-2"),
          style: D.style,
          gap: "xs",
          items: "center",
          nowrap: !0,
          children: [
            D.icon !== !1 && _0(b),
            /* @__PURE__ */ u.jsx("div", { className: B(nt.txtEllips, "gs-utl-max-w-36"), children: b.getName() })
          ]
        }
      ),
      p.map(({ label: H, command: q = "" }) => /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
        ut,
        {
          border: !1,
          rounded: !1,
          size: "s",
          className: ge("block gs-utl-py-1.5 gs-utl-px-1.5", ee.hBgDark),
          onMouseDown: (te) => O(q, { event: te }),
          children: H != null && H.startsWith("<svg") ? /* @__PURE__ */ u.jsx($v, { className: ge("w-4 fill-current"), svg: H }) : H
        }
      ) }, H)),
      !!c.length && /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(
        ut,
        {
          border: !1,
          rounded: !1,
          size: "s",
          className: ge("block", ee.hBgDark),
          onClick: A,
          children: /* @__PURE__ */ u.jsx(ye, { icon: fe.dotsVertical, size: Ee.s })
        }
      ) })
    ] }) }) }),
    (K = n == null ? void 0 : n.items) == null ? void 0 : K.map(({ id: H, layout: q, position: te, className: I, style: F }, V) => /* @__PURE__ */ u.jsx(go, { position: te, className: I, style: F, out: !0, children: Xn(q) }, H || V))
  ] });
}
function e3(e) {
  return e && e.toolbar;
}
function pW(e) {
  const t = e3(e), n = t && t.badge;
  return n === !0 ? {} : n || !1;
}
async function gW(e, t) {
  var g;
  if (!(e != null && e.em))
    return [];
  const n = e.em.getEditor(), r = e.toolbar.filter(Boolean), o = e.get("toolbarItems"), i = await h1(o, { items: r, component: e, editor: n }), l = {
    items: i,
    component: e,
    editor: n
  }, c = await h1(i, l), d = (g = t.sdkComponentsConfig) == null ? void 0 : g.toolbar;
  return await h1(d, { ...l, items: c });
}
const h1 = async (e, t) => Ct(e) ? (await e(t)).filter(Boolean) : t.items;
var ho = /* @__PURE__ */ ((e) => (e.PaddingTop = "padding-top", e.PaddingRight = "padding-right", e.PaddingBottom = "padding-bottom", e.PaddingLeft = "padding-left", e.MarginTop = "margin-top", e.MarginRight = "margin-right", e.MarginBottom = "margin-bottom", e.MarginLeft = "margin-left", e))(ho || {});
const { PaddingTop: zf, PaddingRight: m1, PaddingBottom: Bf, PaddingLeft: v1, MarginTop: Uf, MarginRight: y1, MarginBottom: Wf, MarginLeft: b1 } = ho, hW = (e, t) => {
  const n = t != null && t.startsWith("p") ? "padding" : "margin";
  return r$(e, n, t);
}, li = (e, t, n = {}) => {
  const r = Ar(), o = EE(), [i, l] = y.useState(), c = (g) => {
    const v = r.Canvas.getFramesEl().classList, b = g ? "add" : "remove";
    v[b]("gs-utl-pointer-events-none"), v[b]("gs-utl-select-none");
  }, d = (g) => {
    var m, v;
    (m = n.setAltKey) == null || m.call(n, g.altKey), (v = n.setShiftKey) == null || v.call(n, g.shiftKey);
  };
  return y.useEffect(() => {
    var z;
    const g = [zf, Bf, Uf, Wf].includes(t), m = document.body.classList, v = e.component.getEl(), b = r.Styles.getSelected(), x = window.getComputedStyle(v), w = g ? "!cursor-ns-resize" : "!cursor-ew-resize", j = r.Canvas.getZoomMultiplier(), C = {};
    let E = parseFloat(x[t]) ?? 0, P, k = "", T = {};
    for (const D of Object.values(ho)) {
      const Z = D;
      C[Z] = x[Z];
    }
    const O = (D, Z) => {
      const K = t == null ? void 0 : t.startsWith("p"), { altKey: H, shiftKey: q } = Z, te = C, I = {
        [zf]: q || t === Bf && H ? D : te[zf],
        [m1]: q || t === v1 && H ? D : te[m1],
        [Bf]: q || t === zf && H ? D : te[Bf],
        [v1]: q || t === m1 && H ? D : te[v1]
      }, F = {
        [Uf]: q || t === Wf && H ? D : te[Uf],
        [y1]: q || t === b1 && H ? D : te[y1],
        [Wf]: q || t === Uf && H ? D : te[Wf],
        [b1]: q || t === y1 && H ? D : te[b1]
      };
      return I[t] = D, F[t] = D, K ? I : F;
    }, A = (D) => {
      k && (P ? P.upValue(k, D) : b == null || b.addStyle(T, D));
    }, $ = (D) => {
      if (!i || !b)
        return;
      const Z = g ? D.clientY - i.y : D.clientX - i.x, K = Math.max(0, parseInt(`${E + Z * j}`));
      k = `${K}px`, T = O(k, D), A({ partial: !0 }), o.show(K);
    }, N = () => {
      !i || !b || (l(void 0), c(!1), o.hide(), A());
    }, R = (D) => {
      d(D), T = O(k, D), A({ partial: !0 });
    };
    return i && (document.addEventListener("pointermove", $), document.addEventListener("pointerup", N), document.addEventListener("keydown", R), document.addEventListener("keyup", R), m.add(w), (z = n.onActive) == null || z.call(n, t), n.useStyleProperty && (P = hW(r, t), E = (P == null ? void 0 : P.getValue()) ?? E)), () => {
      var D;
      document.removeEventListener("pointermove", $), document.removeEventListener("pointerup", N), document.removeEventListener("keydown", R), document.removeEventListener("keyup", R), m.remove(w), (D = n.onActive) == null || D.call(n, void 0);
    };
  }, [i]), [y.useCallback((g) => {
    if (g.button !== 0)
      return;
    const { clientX: m, clientY: v } = g;
    l({ x: m, y: v }), c(!0), d(g.nativeEvent);
  }, []), !!i];
}, Gf = "gs-utl-border-2 gs-utl-border-white !gs-utl-box-content", J2 = "gs-utl-bg-[#7fc65e]", Q2 = "gs-utl-bg-[#ebae70]", ej = "gs-utl-h-5 gs-utl-w-1 gs-utl-mx-2 gs-utl-cursor-ew-resize", tj = "gs-utl-h-1 gs-utl-w-5 gs-utl-my-2 gs-utl-cursor-ns-resize", mW = y.memo(function({
  spot: t,
  disabledHandler: n,
  useStyleProperty: r,
  onActive: o
}) {
  const [i, l] = y.useState(!1), [c, d] = y.useState(!1), p = { onActive: o, setAltKey: l, setShiftKey: d, useStyleProperty: r }, [g, m] = li(t, "padding-top", p), [v, b] = li(t, "padding-right", p), [x, w] = li(t, "padding-bottom", p), [j, C] = li(t, "padding-left", p), [E, P] = li(t, "margin-top", p), [k, T] = li(t, "margin-right", p), [O, A] = li(t, "margin-bottom", p), [$, N] = li(t, "margin-left", p), R = ge(Gf, J2, ej), z = ge(Gf, J2, tj), D = ge(Gf, Q2, ej), Z = ge(Gf, Q2, tj), K = m || b || w || C, H = P || T || A || N, q = K || H, te = (se, de) => {
    let we = !1;
    const je = K && c, He = H && c;
    switch (de) {
      case "padding-top":
        we = w && i || je;
        break;
      case "padding-right":
        we = C && i || je;
        break;
      case "padding-bottom":
        we = m && i || je;
        break;
      case "padding-left":
        we = b && i || je;
        break;
      case "margin-top":
        we = A && i || He;
        break;
      case "margin-right":
        we = N && i || He;
        break;
      case "margin-bottom":
        we = P && i || He;
        break;
      case "margin-left":
        we = T && i || He;
        break;
    }
    return !q || se || we;
  }, I = !!(n != null && n.padding), F = !!(n != null && n.margin), V = !I && te(
    m,
    "padding-top"
    /* PaddingTop */
  ), L = !I && te(
    b,
    "padding-right"
    /* PaddingRight */
  ), W = !I && te(
    w,
    "padding-bottom"
    /* PaddingBottom */
  ), ie = !I && te(
    C,
    "padding-left"
    /* PaddingLeft */
  ), re = !F && te(
    P,
    "margin-top"
    /* MarginTop */
  ), le = !F && te(
    T,
    "margin-right"
    /* MarginRight */
  ), me = !F && te(
    A,
    "margin-bottom"
    /* MarginBottom */
  ), oe = !F && te(
    N,
    "margin-left"
    /* MarginLeft */
  );
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    V && /* @__PURE__ */ u.jsx(go, { position: "top-center", onPointerDown: g, children: /* @__PURE__ */ u.jsx(dn, { className: z, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    L && /* @__PURE__ */ u.jsx(go, { position: "center-right", onPointerDown: v, children: /* @__PURE__ */ u.jsx(dn, { className: R, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    W && /* @__PURE__ */ u.jsx(go, { position: "bottom-center", onPointerDown: x, children: /* @__PURE__ */ u.jsx(dn, { className: z, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    ie && /* @__PURE__ */ u.jsx(go, { position: "center-left", onPointerDown: j, children: /* @__PURE__ */ u.jsx(dn, { className: R, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    re && /* @__PURE__ */ u.jsx(go, { position: "top-center", onPointerDown: E, out: !0, children: /* @__PURE__ */ u.jsx(dn, { className: Z, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    le && /* @__PURE__ */ u.jsx(go, { position: "center-right", onPointerDown: k, out: !0, children: /* @__PURE__ */ u.jsx(dn, { className: D, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    me && /* @__PURE__ */ u.jsx(go, { position: "bottom-center", onPointerDown: O, out: !0, children: /* @__PURE__ */ u.jsx(dn, { className: Z, s: "s", pill: !0, block: !0, nopad: !0 }) }),
    oe && /* @__PURE__ */ u.jsx(go, { position: "center-left", onPointerDown: $, out: !0, children: /* @__PURE__ */ u.jsx(dn, { className: D, s: "s", pill: !0, block: !0, nopad: !0 }) })
  ] });
}), nj = (e, t) => {
  var n;
  return !!((n = jE(e, t)) != null && n.isVisible());
}, vW = (e = {}) => {
  const [t, n, r, o] = cS(e.padding || ""), [i, l, c, d] = cS(e.margin || "");
  return {
    paddingTop: e[ho.PaddingTop] || t,
    paddingRight: e[ho.PaddingRight] || n,
    paddingBottom: e[ho.PaddingBottom] || r,
    paddingLeft: e[ho.PaddingLeft] || o,
    marginTop: e[ho.MarginTop] || i,
    marginRight: e[ho.MarginTop] || l,
    marginBottom: e[ho.MarginTop] || c,
    marginLeft: e[ho.MarginTop] || d
  };
};
function yW({ spot: e, className: t }) {
  const n = Ar(), { isProjectTypeEmail: r } = Re(), [o, i] = y.useState(), [l, c] = y.useState({
    padding: !1,
    margin: !1
  }), { el: d, component: p } = e, g = e.getBoxRect(), m = n.Canvas.getZoomDecimal(), v = g.height * m, b = g.width * m, x = e.getStyle({ boxRect: g }), w = n.getSelectedAll().includes(p), j = n.getSelected() === p, C = (o == null ? void 0 : o.startsWith("p")) ?? !1, E = (o == null ? void 0 : o.startsWith("m")) ?? !1, P = vW(r ? p == null ? void 0 : p.getStyle() : {});
  if (y.useEffect(() => {
    w && c({
      padding: !nj(n, "padding"),
      margin: !nj(n, "margin")
    });
  }, [w]), e.type === "spacing" && w)
    return null;
  const k = {
    borderColor: "rgba(196, 222, 184, 0.5)",
    // '#c4deb8',
    borderStyle: "solid"
  }, T = {
    borderColor: "rgba(249, 204, 158, 0.5)",
    // '#f9cc9e',
    borderStyle: "solid",
    boxSizing: "content-box"
  }, O = window.getComputedStyle(d);
  k.borderTopWidth = P.paddingTop || O.paddingTop, k.borderRightWidth = P.paddingRight || O.paddingRight, k.borderBottomWidth = P.paddingBottom || O.paddingBottom, k.borderLeftWidth = P.paddingLeft || O.paddingLeft, T.borderTopWidth = P.marginTop || O.marginTop, T.borderRightWidth = P.marginTop || O.marginRight, T.borderBottomWidth = P.marginTop || O.marginBottom, T.borderLeftWidth = P.marginTop || O.marginLeft;
  const A = {
    ...x,
    ...k
  }, $ = {
    ...x,
    ...T,
    translate: `${g.x - parseFloat(O.marginLeft)}px ${g.y - parseFloat(O.marginTop)}px`
  };
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    (!w || C) && /* @__PURE__ */ u.jsx(pl, { spot: e, spotStyles: A, className: ge(t) }),
    (!w || E) && /* @__PURE__ */ u.jsx(pl, { spot: e, spotStyles: $, className: ge(t) }),
    j && (v > 60 && b > 60 || o) && /* @__PURE__ */ u.jsx(pl, { spot: e, spotStyles: x, className: ge(t), children: /* @__PURE__ */ u.jsx(
      mW,
      {
        spot: e,
        onActive: i,
        disabledHandler: l,
        useStyleProperty: r
      }
    ) })
  ] });
}
function bW({ spot: e, className: t, spotConfig: n }) {
  const r = QP(n), o = B(n == null ? void 0 : n.className, "gs-utl-border-2", ee.cmpTargetBr, ee.cmpTargetBgOpac, t);
  return /* @__PURE__ */ u.jsx(pl, { spot: e, className: o, style: n == null ? void 0 : n.style, children: r && /* @__PURE__ */ u.jsx(JP, { spot: e, className: ee.cmpTargetBg, badgeConfig: r }) });
}
async function xW(e, t) {
  var m;
  const n = e.component, r = n == null ? void 0 : n.em.getEditor();
  if (!n || !r)
    return {};
  const o = {}, i = Ml(n), l = { editor: r, component: n, spot: e, componentTheme: i, result: o }, c = n.get("canvasSpots"), d = await (c == null ? void 0 : c(l)) || o, p = (m = t.sdkComponentsConfig) == null ? void 0 : m.canvasSpots;
  return await (p == null ? void 0 : p({ ...l, result: d })) || d;
}
const wW = 9, t3 = {
  padding: `${wW}px 0`
}, rj = "dragAbsolute";
function SW({ spot: e }) {
  const t = Ar(), [n, r] = y.useState(), { Canvas: o } = t, i = Re(), l = t.getEditing(), { type: c, component: d } = e, p = c === "select", g = c === "spacing", m = c === "hover", v = c === "target", b = c === rj, x = [rj];
  return y.useEffect(() => {
    const w = `${t.Components.events.update}:status`, j = async () => r(await xW(e, i)), C = setTimeout(j);
    return t.on(w, j), () => {
      clearTimeout(C), t.off(w, j);
    };
  }, [d]), !n || !e.el || i.isInPreview || !o.hasCustomSpot(c) && !x.includes(c) || // When selecting a target, skip any other spot besides the 'target'
  i.isSelectingTarget && !v || // Avoid hover/spacing spots on inner components during editing
  (m || g) && l && (d != null && d.isChildOf(l)) ? null : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    (g || p) && n.spacing !== !1 && /* @__PURE__ */ u.jsx(yW, { spot: e, className: "gs-utl-z-0" }),
    v && n.target !== !1 && /* @__PURE__ */ u.jsx(bW, { spot: e, spotConfig: n.target, className: "gs-utl-z-10" }),
    p && n.select !== !1 && /* @__PURE__ */ u.jsx(fW, { spot: e, spotConfig: n.select, className: "gs-utl-z-20" }),
    m && n.hover !== !1 && /* @__PURE__ */ u.jsx(dW, { spot: e, spotConfig: n.hover, className: "gs-utl-z-30" }),
    b && /* @__PURE__ */ u.jsx(lW, { spot: e, className: "gs-utl-z-40" })
  ] });
}
const oj = /* @__PURE__ */ new WeakMap();
function n3(e) {
  if (!e)
    return () => null;
  const t = oj.get(e);
  if (t)
    return t;
  const n = function({ children: o }) {
    return Cv.createPortal(o, e);
  };
  return oj.set(e, n), n;
}
const jW = y.memo(function({ children: t }) {
  const n = D0(), [r, o] = y.useState([]), [i, l] = y.useState({});
  y.useEffect(() => {
    if (!n)
      return;
    n.onReady(() => {
      const g = n.Canvas.getSpotsEl(), m = n3(g);
      l({ Container: m });
    });
    const d = "canvas:spot", p = () => {
      const g = n.Canvas.getSpots();
      o(g);
    };
    return n.on(d, p), () => {
      n.off(d, p);
    };
  }, [n]);
  const { Container: c } = i;
  return n && c ? /* @__PURE__ */ u.jsx(c, { children: t({ spots: r }) }) : null;
}), CW = xe(function() {
  const { isCanvasPanning: t } = Re();
  return /* @__PURE__ */ u.jsx(jW, { children: ({ spots: n }) => /* @__PURE__ */ u.jsx(Xo, { show: !t, ...gC, children: n.map((r) => /* @__PURE__ */ u.jsx(SW, { spot: r }, r.id)) }) });
}), Qa = "gs-layout-panel", EW = y.memo(
  xe(function({ className: t, layout: n, children: r }) {
    const o = k0(), i = os(), [l, c] = y.useState(!1), [d, p] = y.useState(null), { id: g, header: m, layout: v, props: b, full: x = !0, style: w, toRemove: j, disablePropagation: C } = n, E = () => {
      c(!1), setTimeout(() => o.remove(g, { force: !0 }), 150);
    }, P = n.placer || { type: nl.absolute, position: tl.left }, k = P.type === nl.absolute ? P : null, T = P.type === nl.popover ? P : null, O = P.type === nl.static ? P : null, A = P.type === nl.dialog ? P : null, $ = (k == null ? void 0 : k.position) === tl.left, N = (k == null ? void 0 : k.position) === tl.right, R = (k == null ? void 0 : k.position) === tl.top, z = (k == null ? void 0 : k.position) === tl.bottom, D = O || A, Z = Dt(v) ? { type: v } : v, K = !!k, { x: H, y: q } = T || {}, te = (T == null ? void 0 : T.w) || (T == null ? void 0 : T.width), I = (T == null ? void 0 : T.h) || (T == null ? void 0 : T.height), F = T == null ? void 0 : T.target, V = y.useMemo(
      () => F && l ? F : {
        getBoundingClientRect: () => F ? F.getBoundingClientRect() : new DOMRect(H, q, te, I)
      },
      [H, q, te, I, F, l]
    ), L = $l(V, d, {
      ...mE,
      placement: "auto",
      ...T == null ? void 0 : T.options
    }), W = B(
      Qa,
      ee.br,
      ee.bg,
      ee.txt,
      "gs-utl-z-10",
      K && "gs-utl-absolute gs-utl-transition",
      ($ || R) && "gs-utl-top-0 gs-utl-left-0",
      N && "gs-utl-top-0 gs-utl-right-0",
      z && "gs-utl-bottom-0 gs-utl-left-0",
      K && x && ($ || N ? "gs-utl-h-full" : "gs-utl-w-full"),
      !l && K ? "gs-utl-opacity-0" : "gs-utl-opacity-100",
      !l && $ && "-gs-utl-translate-x-full",
      !l && N && "gs-utl-translate-x-full",
      !l && R && "-gs-utl-translate-y-full",
      !l && z && "gs-utl-translate-y-full",
      T && ve.rnd,
      T && ve.b,
      n.className,
      t
    );
    y.useEffect(() => {
      const me = setTimeout(() => c(!0));
      return () => clearTimeout(me);
    }, []), y.useEffect(() => {
      j && E();
    }, [j]);
    const ie = {
      ...w,
      width: (w == null ? void 0 : w.width) || ($ || N ? 240 : void 0)
    };
    lE(
      { current: d },
      {
        onTrigger: E,
        enabled: (T == null ? void 0 : T.closeOnClickAway) && l
      }
    );
    const re = (me) => {
      C && me.nativeEvent.stopImmediatePropagation();
    }, le = /* @__PURE__ */ u.jsxs(G, { className: W, style: ie, col: !0, nowrap: !0, onPointerDown: re, onMouseDown: re, children: [
      m !== !1 && /* @__PURE__ */ u.jsx(Y, { className: B(`${Qa}__header`, m == null ? void 0 : m.className), style: m == null ? void 0 : m.style, children: /* @__PURE__ */ u.jsx(
        ly,
        {
          onClose: (m == null ? void 0 : m.close) !== !1 ? E : void 0,
          className: ge(tt.s),
          title: /* @__PURE__ */ u.jsxs(G, { className: `${Qa}__title`, space: "s", items: "center", children: [
            !!(m != null && m.icon) && /* @__PURE__ */ u.jsx(ye, { icon: m.icon, size: Ee.s }),
            !!(m != null && m.label) && /* @__PURE__ */ u.jsx(Y, { grow: !0, children: m.label })
          ] })
        }
      ) }),
      /* @__PURE__ */ u.jsx(Y, { className: B(`${Qa}__content`, "gs-utl-overflow-hidden gs-utl-flex gs-utl-flex-col"), grow: !0, children: v || g ? Xn({ ...b, id: g, ...Z }) : r })
    ] });
    return y.useEffect(() => {
      if (l) {
        if (O) {
          const me = o.layoutsById.get(O.layoutId);
          if (me)
            return me.setState({ children: le }), () => {
              !n.placer.skipCleanup && me.setState({ children: null });
            };
        } else if (A)
          return i.open({
            // use function to avoid mobx errors
            content: () => le,
            disablePropagation: C,
            title: A.title,
            size: A.size,
            onClose: E
          }), () => {
            i.close();
          };
      }
    }, [l]), D ? null : T ? /* @__PURE__ */ u.jsx(
      "div",
      {
        className: ge(Qa, `${Qa}-popover`, "gs-utl-z-20"),
        ref: p,
        style: L.styles.popper,
        ...L.attributes.popper,
        children: /* @__PURE__ */ u.jsx(Xo, { show: l, ...Au, unmount: !1, children: le })
      }
    ) : le;
  })
), PW = xe(function({
  className: t,
  ...n
}) {
  const { layouts: r } = k0();
  return /* @__PURE__ */ u.jsx("div", { className: B("gs-layout-panel-container", t), ...n, children: r.map((o) => /* @__PURE__ */ u.jsx(EW, { layout: o }, o.id)) });
}), xs = "gs-cmp-modal";
function r3({
  open: e = !1,
  title: t,
  disablePropagation: n,
  isDarkTheme: r,
  description: o,
  children: i,
  onClose: l,
  preventOverflow: c,
  closable: d = !0,
  fullH: p,
  buttons: g = [],
  size: m
}) {
  const v = () => d && l(), b = B(
    nC,
    `${xs} gs-utl-fixed gs-utl-z-20 gs-utl-inset-0 gs-utl-overflow-y-auto`,
    r && Z1
  ), x = B(
    `${xs}-wrapper gs-utl-relative gs-utl-flex gs-utl-justify-center gs-utl-min-h-screen`,
    p ? "gs-utl-items-stretch" : "gs-utl-items-center",
    c && "gs-utl-h-dvh"
  ), w = B(
    `${xs}-container`,
    "gs-utl-relative gs-utl-w-full gs-utl-p-5 gs-utl-my-8 gs-utl-overflow-hidden gs-utl-shadow-xl gs-utl-rounded-xl gs-utl-flex gs-utl-flex-col",
    ve.b,
    ee.br,
    ee.bg,
    ee.txt,
    m === "lg" ? "gs-utl-max-w-lg" : m === "l" ? "gs-utl-max-w-5xl" : m === "s" ? "gs-utl-max-w-sm" : "gs-utl-max-w-md"
  ), j = B(
    `${xs}-overlay gs-utl-absolute gs-utl-inset-0 gs-utl-bg-black/50 gs-utl-transition-opacity`
  ), C = B(`${xs}-close gs-utl-absolute gs-utl-top-0 gs-utl-right-0 gs-utl-m-3`), E = B(`${xs}-title gs-utl-text-lg gs-utl-font-medium gs-utl-leading-6 gs-utl-m-0`), P = B(`${xs}-desc gs-utl-m-0`), k = B(`${xs}-content gs-utl-mt-4 gs-utl-h-full`, c && "gs-utl-overflow-hidden"), T = B(`${xs}-buttons gs-utl-mt-4`), O = (A) => {
    n && A.nativeEvent.stopImmediatePropagation();
  };
  return /* @__PURE__ */ u.jsx(Xo, { show: e, as: y.Fragment, children: /* @__PURE__ */ u.jsx(kc, { onClose: v, className: b, onPointerDown: O, onMouseDown: O, children: /* @__PURE__ */ u.jsxs("div", { className: x, children: [
    /* @__PURE__ */ u.jsx(Xo.Child, { as: y.Fragment, ...Au, children: /* @__PURE__ */ u.jsx(kc.Overlay, { className: j }) }),
    /* @__PURE__ */ u.jsx(Xo.Child, { as: y.Fragment, ...Dv, children: /* @__PURE__ */ u.jsxs("div", { className: w, children: [
      d && /* @__PURE__ */ u.jsx("div", { className: C, children: /* @__PURE__ */ u.jsx(Qt, { block: !0, border: !1, onClick: v, children: /* @__PURE__ */ u.jsx(ye, { icon: fe.close, size: 1 }) }) }),
      /* @__PURE__ */ u.jsx(kc.Title, { as: "h3", className: E, children: t }),
      /* @__PURE__ */ u.jsx(kc.Description, { className: P, children: o }),
      /* @__PURE__ */ u.jsx("div", { className: k, children: i }),
      g.length > 0 && /* @__PURE__ */ u.jsx(G, { className: T, space: "m", items: "center", justify: "end", children: g.map((A, $) => /* @__PURE__ */ u.jsx(ut, { ...A }, $)) })
    ] }) }),
    /* @__PURE__ */ u.jsx(kc, { onClose: () => {
    }, open: !1 })
  ] }) }) });
}
const _W = xe(function() {
  const { isOpen: t, close: n, content: r, modalProps: o } = os(), { isDarkTheme: i } = gr();
  return /* @__PURE__ */ u.jsx(r3, { open: t, onClose: n, isDarkTheme: i, ...o, children: Ct(r) ? r() : r });
}), kW = "gs-panel-page-settings-cnt", TW = xe(function() {
  const t = qe(), n = Re(), { panelPageSettings: r } = n, o = t.tScoped("pageManager.settings"), { isOpen: i, page: l, width: c } = r, d = ce(
    kW,
    "absolute left-0 top-0 h-full transition-transform z-10",
    !i && "-translate-x-full",
    ve.br,
    ee.br,
    ee.bg
  ), p = ce(tt.s), g = () => n.setPanelPageSettings({ isOpen: !1 });
  return /* @__PURE__ */ u.jsxs(G, { className: d, style: { width: c }, col: !0, nowrap: !0, children: [
    /* @__PURE__ */ u.jsx(Y, { children: /* @__PURE__ */ u.jsx(ly, { title: o("title"), onClose: g, className: p }) }),
    /* @__PURE__ */ u.jsx(Sa, { children: /* @__PURE__ */ u.jsx(Y, { className: ce("overflow-hidden"), grow: !0, children: r.isOpen && /* @__PURE__ */ u.jsx(
      MP,
      {
        page: l,
        size: Zp.s,
        classNameHeader: p,
        classNameContent: p,
        classNameFooter: p
      }
    ) }) })
  ] });
}), sj = "gs-cmp-custom-rte", OW = xe(function({ items: t }) {
  const n = (r) => r.nativeEvent.stopImmediatePropagation();
  return /* @__PURE__ */ u.jsx(
    pr,
    {
      className: B(sj, "gs-utl-m-2"),
      size: "s",
      onPointerDown: n,
      onMouseDown: n,
      classNameBody: B(`${sj}__body`, "gs-utl-flex gs-utl-gap-1 gs-utl-items-center"),
      children: Xn(t)
    }
  );
});
function LW({ children: e }) {
  const t = D0(), [n, r] = y.useState({
    enabled: !1,
    actions: [],
    Container: () => null
  });
  y.useEffect(() => {
    if (!t)
      return;
    const d = t.RichTextEditor, p = d.events.custom, g = (m) => {
      let v;
      const b = d.customRte, x = b == null ? void 0 : b.toolbar, w = d.model.attributes.currentView;
      x && (w != null && w.model) && (v = x({
        editor: t,
        view: w,
        component: w.model,
        el: w.getChildrenContainer()
      }));
      const j = d.getAll().map((C) => ({
        id: C.name,
        icon: C.icon,
        run: () => d.run(C),
        state: C.currentState
      }));
      r({
        customRte: b,
        customToolbar: v,
        enabled: m.enabled,
        Container: n3(m.container),
        actions: j
      });
    };
    return t.on(p, g), () => {
      t.off(p, g);
    };
  }, [t]);
  const { Container: o, customToolbar: i, customRte: l } = n, c = i ? /* @__PURE__ */ u.jsx(OW, { items: i }) : null;
  return t && o ? /* @__PURE__ */ u.jsx(o, { children: l ? c : e(n) }) : null;
}
function MW() {
  return /* @__PURE__ */ u.jsx(LW, { children: ({ actions: e }) => /* @__PURE__ */ u.jsx(G, { className: ce(ee.bg, ve.b, ve.rnd, ee.br, "gjs-m-2"), nowrap: !0, children: e.map((t, n) => /* @__PURE__ */ u.jsx(
    ut,
    {
      border: !1,
      rounded: !1,
      active: t.state === 1,
      disabled: t.state === -1,
      className: ce("w-6", ee.br, n !== 0 && ve.bl),
      dangerouslySetInnerHTML: { __html: t.icon },
      onClick: t.run
    },
    t.id
  )) }) });
}
const AW = xe((e) => {
  const { select: t, close: n, Container: r, open: o } = e, i = xa(), { editor: l } = Re();
  if (!l || !o)
    return /* @__PURE__ */ u.jsx(r, { children: null });
  const { providers: c, onSelect: d, typeId: p, providerId: g, types: m, optionalType: v, optionalProvider: b, content: x } = l.Assets.__customData().options;
  return /* @__PURE__ */ u.jsx(r, { children: /* @__PURE__ */ u.jsx(
    vP,
    {
      panelId: i.mainPanelId,
      onSelect: d ?? (({ asset: w }) => t(w)),
      close: n,
      types: m,
      providers: c,
      typeId: p,
      providerId: g,
      optionalType: v,
      optionalProvider: b,
      content: x
    }
  ) });
}), RW = xe(function() {
  var C, E;
  const t = Re(), n = xa(), { projectType: r, editorKey: o, setEditor: i, sdkProps: l, sdkOptions: c, currentLayout: d } = t, { isDarkTheme: p } = gr(), g = !!((E = (C = c.gjsOptions) == null ? void 0 : C.assetManager) != null && E.custom), m = Y0(), [v, b] = y.useMemo(
    () => [W5(r, c), m.getPluginsToLoad(r, t)],
    [r, o]
  ), x = (P) => {
    var k, T;
    i(P), n.onEditor(), (k = l.onEditor) == null || k.call(l, P), (T = c.onEditor) == null || T.call(c, P), P.on("destroy", () => {
      var O;
      i(), (O = c.onDestroy) == null || O.call(c, P), t.setIsReady(!1);
    });
  }, w = (P) => {
    var k, T;
    (k = l.onReady) == null || k.call(l, P), (T = c.onReady) == null || T.call(c, P), t.setIsReady(!0);
  }, j = (P, k) => {
    var T, O;
    (T = l.onUpdate) == null || T.call(l, P, k), (O = c.onUpdate) == null || O.call(c, P, k);
  };
  return /* @__PURE__ */ u.jsxs(
    ID,
    {
      className: ce("gs-editor-gjs h-full w-full", ve.b, ee.br),
      grapesjs: c.gjsScript,
      grapesjsCss: c.gjsStyle,
      options: v,
      plugins: b,
      onEditor: x,
      onReady: w,
      onUpdate: j,
      children: [
        Xn(d),
        /* @__PURE__ */ u.jsx(PW, {}),
        /* @__PURE__ */ u.jsx(aW, {}),
        /* @__PURE__ */ u.jsx(TW, {}),
        !g && /* @__PURE__ */ u.jsx(OD, { children: (P) => /* @__PURE__ */ u.jsx(AW, { ...P }) }),
        /* @__PURE__ */ u.jsx(VD, { children: ({ open: P, title: k, close: T, content: O }) => /* @__PURE__ */ u.jsx(r3, { open: P, onClose: T, title: /* @__PURE__ */ u.jsx(u.Fragment, { children: k }), isDarkTheme: p, size: "l", children: /* @__PURE__ */ u.jsx(u.Fragment, { children: O }) }) }),
        /* @__PURE__ */ u.jsx(CW, {}),
        /* @__PURE__ */ u.jsx(MW, {}),
        /* @__PURE__ */ u.jsx(_W, {})
      ]
    },
    o
  );
}), NW = xe(function() {
  const t = Re(), { updateAppShell: n } = gr(), { editor: r, editorKey: o, sdkLicenseError: i, sdkMisconfigurationError: l, isReady: c, licenseCheckStarted: d, rootElWidth: p } = t, g = os(), m = qe(), v = Y0();
  OE();
  const b = !!o && !!p;
  return y.useEffect(() => {
    n && document.querySelector("body").classList.add(...ge(ee.bg, "overflow-hidden").split(" "));
  }, []), y.useEffect(() => {
    if (c && !d && !Rv()) {
      const x = setTimeout(() => t.loadLicense(), 100);
      return () => clearTimeout(x);
    }
  }, [c, d]), y.useEffect(() => {
    l && console.error(l);
  }, [l]), y.useEffect(() => {
    if (!r)
      return;
    "launchQueue" in window && "LaunchParams" in window && window.launchQueue.setConsumer(async (j) => {
      if (!j.files.length)
        return;
      const P = await (await j.files[0].getFile()).text();
      t.loadProjectData(JSON.parse(P));
    });
    const { plg: x } = t.queryParams;
    x && !v.selectedShown && g.open({
      fullH: !0,
      title: m.t("pluginManager.plugins"),
      content: () => /* @__PURE__ */ u.jsx(ZP, { selectedId: x })
    });
    const w = Es(() => t.refreshEditorCanvas(), 100);
    return window.addEventListener("scroll", w, !0), () => window.removeEventListener("scroll", w, !0);
  }, [r]), y.useEffect(() => {
  }, []), /* @__PURE__ */ u.jsxs(G, { className: ge("relative transition-colors h-full", ee.bg, ee.txt), justify: "center", items: "center", col: !0, children: [
    b && (i ? /* @__PURE__ */ u.jsxs(G, { col: !0, justify: "center", items: "center", children: [
      /* @__PURE__ */ u.jsx("div", { children: "SDK License Error" }),
      /* @__PURE__ */ u.jsx("span", { className: ge("text-sm"), children: i })
    ] }) : l ? /* @__PURE__ */ u.jsx(G, { col: !0, justify: "center", items: "center", children: /* @__PURE__ */ u.jsx("div", { children: "SDK Misconfiguration Error" }) }) : /* @__PURE__ */ u.jsx(RW, {})),
    /* @__PURE__ */ u.jsx(Xo, { show: !b, as: y.Fragment, ...Au, children: /* @__PURE__ */ u.jsx(Ju, { className: ge("z-10", ee.bg), abs: !0 }) })
  ] });
});
function $W({
  projectType: e,
  project: t
}) {
  const n = DW({ projectType: e }), r = { type: e, default: { pages: [n] } };
  return t ? (t.type = t.type ?? r.type, t.default = t.default ?? r.default, t) : r;
}
function DW({ projectType: e }) {
  const t = { name: "Web", component: IW }, n = { name: "Email", component: VW };
  switch (e) {
    case Xe.web:
      return t;
    case Xe.email:
      return n;
    default:
      return t;
  }
}
const kp = "https://app.grapesjs.com/docs-sdk/configuration/projects#self-hosted-storage", Tp = "https://app.grapesjs.com/docs-sdk/configuration/projects#setup", o3 = "https://app.grapesjs.com/docs-sdk/img/grapesjs-logo-black.svg", IW = `<body>
    <header class="head">
      <img class="logo" src="${o3}" alt="GrapesJS Logo">
    </header>
    <div class="card">
        <h1 class="title">Welcome to GrapesJS Studio SDK!</h1>
        <p class="subtitle">You're currently viewing the default fallback project for web.</p>

        <p class="paragraph">
          This appears because no storage has been configured yet. To set up your own storage, follow the guide here:
          <br/>
          👉 <a class="link" href="${kp}" target="_blank">${kp}</a>
        </p>

        <p class="paragraph">
          Want to customize the fallback project? You can do so by setting options.project.default. Learn more here:
          <br/>
          👉 <a class="link" href="${Tp}" target="_blank">${Tp}</a>
        </p>

        <footer class="footer">Happy building! 🚀</footer>
    </div>
    <style>
      body {
        background-color: #e7e7e7;
        font-family: Arial, sans-serif;
      }
      .head {
        padding: 50px 50px 35px;
      }
      .logo {
        max-width: 250px;
        display: block;
        margin: 0 auto;
      }
      .card {
        max-width: 600px;
        padding: 40px 45px;
        background-color: white;
        border-radius: 15px;
        margin: 0 auto;
        color: #333333;
        font-size: 16px;
      }
      .title {
        color: #af4e8a;
        font-size: 24px;
        font-weight: bold;
        margin: 0;
        text-align: center;
      }
      .subtitle {
        text-align: center;
        margin: 0;
        padding: 25px 0;
      }
      .paragraph {
        line-height: 1.5;
        margin-bottom: 40px;
      }
      .link {
        color:#af4e8a;
        text-decoration:none;
        font-size:13px;
      }
      .footer {
        margin-top: 30px;
        text-align: center;
      }
  </style>
</body>`, VW = `<mjml>
  <mj-body background-color="#E7E7E7">
    <mj-section full-width="full-width" padding="50px 50px 35px 50px">
      <mj-column width="100%">
        <mj-image src="${o3}" width="250px" padding="0px" />
      </mj-column>
    </mj-section>
    <mj-section padding="0px">
      <mj-column background-color="white" border-radius="15px" padding="40px 20px">
        <mj-text color="#af4e8a" font-size="24px" font-weight="bold" align="center">
          Welcome to GrapesJS Studio SDK!
        </mj-text>
        <mj-text font-size="16px" color="#333333" line-height="1.5" align="center" padding="10px 25px 25px 25px">
          You're currently viewing the default fallback project for emails.
        </mj-text>
        <mj-text font-size="16px" color="#333333" line-height="1.5" padding="10px 25px 30px 25px">
          This appears because no storage has been configured yet. To set up your own storage, follow the guide here:
          <br/>
          👉 <a href="${kp}" style="color:#af4e8a;text-decoration:none;font-size:13px;">
            ${kp}
          </a>
        </mj-text>
        <mj-text font-size="16px" color="#333333" line-height="1.5">
          Want to customize the fallback project? You can do so by setting options.project.default. Learn more here:
          <br/>
          👉 <a id="iu9rf-2" href="${Tp}" style="color:#af4e8a;text-decoration:none;font-size:13px;">
            ${Tp}
          </a>
        </mj-text>
        <mj-text font-size="16px" color="#333333" align="center" padding="30px 25px 10px 25px">Happy building! 🚀
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`, jv = {
  licenseKey: "",
  settingsMenu: {
    // These were made mainly for the standalone editor, probably not suitable for the embedded one.
    // Need to revesit the interface to allow custom setting menu items.
    about: !1,
    embed: !1,
    openProject: !1,
    saveProject: !1,
    loadProject: !1,
    installApp: !1
  }
}, s3 = y.forwardRef(function(t, n) {
  var g;
  const { options: r = jv } = t, o = { theme: r.theme }, i = r.localStorage, l = i ? $E(i, o) : o, c = (l == null ? void 0 : l.lastProjectType) || ((g = r.project) == null ? void 0 : g.type) || Xe.web, d = $W({ projectType: c, project: r.project }), p = {
    localSettingsStore: {
      ...l,
      key: i,
      updateAppShell: r.updateAppShell,
      rootEl: r.root
    },
    appEditorStore: {
      isDev: oW,
      isStage: !!r.stg,
      licenseKey: r.licenseKey,
      projectType: c,
      sdkProps: {
        ...t,
        options: {
          ...jv,
          gjsScript: nW,
          gjsStyle: rW,
          ...r,
          project: d
        }
      }
    }
  };
  return /* @__PURE__ */ u.jsx(XV, { initialState: p, children: /* @__PURE__ */ u.jsx(fH, { ref: n, children: /* @__PURE__ */ u.jsx(NW, {}) }) });
}), zW = (e) => {
  const t = new ug({});
  return t.pluginStore.getPluginsToLoad(e, t.appEditorStore);
}, HW = async (e) => {
  var v;
  const t = [], { gjsScript: n, project: r } = e, {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    plugins: o,
    ...i
  } = e;
  if (!n || !n.init)
    throw new Error("The 'gjsScript' option is missing or invalid. Make sure to provide a valid GrapesJS constructor.");
  const l = (r == null ? void 0 : r.type) || Xe.web, c = e.projectData || ((v = e.storage) == null ? void 0 : v.project) || (r == null ? void 0 : r.default) || {}, d = new ug({}), p = W5(l, i), m = d.pluginStore.getPluginsToLoad(l, d.appEditorStore).filter((b) => {
    if (Ct(b))
      return !0;
    t.push(b);
  });
  if (t.length)
    throw new Error(
      `Headless editor plugins must be functions. Invalid plugins detected: ${JSON.stringify(t)}`
    );
  return n.init({
    headless: !0,
    noticeOnUnload: !1,
    storageManager: !1,
    ...p,
    projectData: c,
    plugins: m
  });
};
const BW = s3, UW = (e) => HW(e), WW = async (e) => {
  const { root: t } = e, n = Dt(t), r = n ? document.querySelector(t) : t;
  if (!r)
    return console.error(
      `The 'root' element not found! ${t ? n ? `Looks like you used a selector that doesn't exist: "${t}"` : "" : "Ensure to provide 'root' as an option."}`
    );
  e.root = r, Cv.render(
    /* @__PURE__ */ u.jsx(Q.StrictMode, { children: /* @__PURE__ */ u.jsx(s3, { options: e }) }),
    r
  );
};
export {
  U1 as AssetStorageType,
  oa as AssetType,
  po as BuiltInActionButtons,
  ci as ComponentContextMenuItem,
  x0 as ComponentContextMenuSource,
  kn as DataComponentTypes,
  D8 as GlobalStyleFieldType,
  fe as IconNames,
  nl as LayoutPlacers,
  tl as LayoutPosition,
  W1 as ProjectStorageType,
  Xe as ProjectType,
  _8 as StudioCanvasSpotType,
  ke as StudioCommands,
  BW as StudioEditor,
  kr as StudioEvents,
  xo as ThemeValue,
  Gn as ToastVariant,
  WW as createStudioEditor,
  UW as createStudioHeadlessEditor,
  WW as default,
  zW as getStudioPlugins
};
